import { b as ya, E as Xc, r as cs, a as lr, p as wo, U as J0, h as Re, c as Ni, H as X0, d as bp, e as sc, s as Ci, f as Wn, g as pn, i as vp, j as T, k as ko, I as rl, l as yp, q as xp, m as us, n as Yc, o as bd, t as Zc, u as nr, v as vd, w as wp, x as Y0, y as Z0, z as Q0, A as eb, B as Qc, C as kp, D as tb, F as eu, G as tu, J as nb, K as ib, L as oc, M as rb, N as sb, O as ob, P as ab, Q as yd, R as xa, S as br, T as nu, V as wa, W as lb, X as cb, Y as ub, Z as db, _ as hb, $ as fb, a0 as pb, a1 as mb, a2 as gb, a3 as Lt, a4 as _b, a5 as bb, a6 as vb, a7 as yb, a8 as xb, a9 as wb, aa as kb, ab as Sb, ac as Eb, ad as Cb, ae as Tb, af as Mr, ag as xd, ah as wd, ai as Ab, aj as Mb, ak as iu, al as Ob, am as Gr, an as Nb, ao as Ae, ap as kd, aq as Lb, ar as Rb, as as Sp, at as Ib, au as Pb, av as _e, aw as be, ax as Q, ay as X, az as We, aA as gn, aB as V, aC as ve, aD as ce, aE as U, aF as ee, aG as L, aH as F, aI as O, aJ as mi, aK as Me, aL as Db, aM as $b, aN as Ft, aO as Ep, aP as Cp, aQ as ne, aR as Tp, aS as B, aT as vn, aU as Ap, aV as vr, aW as Rt, aX as st, aY as zb, aZ as Fs, a_ as De, a$ as yn, b0 as So, b1 as Hb, b2 as Bb, b3 as cr, b4 as Fb, b5 as Vb, b6 as jb, b7 as Wb } from "./component-DaN8cu97.js";
const Ub = "0.0.1", pe = (n) => typeof n == "string", Or = () => {
  let n, e;
  const t = new Promise((i, r) => {
    n = i, e = r;
  });
  return t.resolve = n, t.reject = e, t;
}, Sd = (n) => n == null ? "" : "" + n, Kb = (n, e, t) => {
  n.forEach((i) => {
    e[i] && (t[i] = e[i]);
  });
}, qb = /###/g, Ed = (n) => n && n.indexOf("###") > -1 ? n.replace(qb, ".") : n, Cd = (n) => !n || pe(n), Jr = (n, e, t) => {
  const i = pe(e) ? e.split(".") : e;
  let r = 0;
  for (; r < i.length - 1; ) {
    if (Cd(n)) return {};
    const s = Ed(i[r]);
    !n[s] && t && (n[s] = new t()), Object.prototype.hasOwnProperty.call(n, s) ? n = n[s] : n = {}, ++r;
  }
  return Cd(n) ? {} : {
    obj: n,
    k: Ed(i[r])
  };
}, Td = (n, e, t) => {
  const {
    obj: i,
    k: r
  } = Jr(n, e, Object);
  if (i !== void 0 || e.length === 1) {
    i[r] = t;
    return;
  }
  let s = e[e.length - 1], o = e.slice(0, e.length - 1), a = Jr(n, o, Object);
  for (; a.obj === void 0 && o.length; )
    s = `${o[o.length - 1]}.${s}`, o = o.slice(0, o.length - 1), a = Jr(n, o, Object), a?.obj && typeof a.obj[`${a.k}.${s}`] < "u" && (a.obj = void 0);
  a.obj[`${a.k}.${s}`] = t;
}, Gb = (n, e, t, i) => {
  const {
    obj: r,
    k: s
  } = Jr(n, e, Object);
  r[s] = r[s] || [], r[s].push(t);
}, Eo = (n, e) => {
  const {
    obj: t,
    k: i
  } = Jr(n, e);
  if (t && Object.prototype.hasOwnProperty.call(t, i))
    return t[i];
}, Jb = (n, e, t) => {
  const i = Eo(n, t);
  return i !== void 0 ? i : Eo(e, t);
}, Mp = (n, e, t) => {
  for (const i in e)
    i !== "__proto__" && i !== "constructor" && (i in n ? pe(n[i]) || n[i] instanceof String || pe(e[i]) || e[i] instanceof String ? t && (n[i] = e[i]) : Mp(n[i], e[i], t) : n[i] = e[i]);
  return n;
}, ji = (n) => n.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var Xb = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const Yb = (n) => pe(n) ? n.replace(/[&<>"'\/]/g, (e) => Xb[e]) : n;
class Zb {
  constructor(e) {
    this.capacity = e, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e) {
    const t = this.regExpMap.get(e);
    if (t !== void 0)
      return t;
    const i = new RegExp(e);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e, i), this.regExpQueue.push(e), i;
  }
}
const Qb = [" ", ",", "?", "!", ";"], e1 = new Zb(20), t1 = (n, e, t) => {
  e = e || "", t = t || "";
  const i = Qb.filter((o) => e.indexOf(o) < 0 && t.indexOf(o) < 0);
  if (i.length === 0) return !0;
  const r = e1.getRegExp(`(${i.map((o) => o === "?" ? "\\?" : o).join("|")})`);
  let s = !r.test(n);
  if (!s) {
    const o = n.indexOf(t);
    o > 0 && !r.test(n.substring(0, o)) && (s = !0);
  }
  return s;
}, ac = function(n, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!n) return;
  if (n[e])
    return Object.prototype.hasOwnProperty.call(n, e) ? n[e] : void 0;
  const i = e.split(t);
  let r = n;
  for (let s = 0; s < i.length; ) {
    if (!r || typeof r != "object")
      return;
    let o, a = "";
    for (let l = s; l < i.length; ++l)
      if (l !== s && (a += t), a += i[l], o = r[a], o !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof o) > -1 && l < i.length - 1)
          continue;
        s += l - s + 1;
        break;
      }
    r = o;
  }
  return r;
}, Co = (n) => n?.replace("_", "-"), n1 = {
  type: "logger",
  log(n) {
    this.output("log", n);
  },
  warn(n) {
    this.output("warn", n);
  },
  error(n) {
    this.output("error", n);
  },
  output(n, e) {
    console?.[n]?.apply?.(console, e);
  }
};
class To {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(e, t);
  }
  init(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = t.prefix || "i18next:", this.logger = e || n1, this.options = t, this.debug = t.debug;
  }
  log() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
      t[i] = arguments[i];
    return this.forward(t, "log", "", !0);
  }
  warn() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
      t[i] = arguments[i];
    return this.forward(t, "warn", "", !0);
  }
  error() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
      t[i] = arguments[i];
    return this.forward(t, "error", "");
  }
  deprecate() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
      t[i] = arguments[i];
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, t, i, r) {
    return r && !this.debug ? null : (pe(e[0]) && (e[0] = `${i}${this.prefix} ${e[0]}`), this.logger[t](e));
  }
  create(e) {
    return new To(this.logger, {
      prefix: `${this.prefix}:${e}:`,
      ...this.options
    });
  }
  clone(e) {
    return e = e || this.options, e.prefix = e.prefix || this.prefix, new To(this.logger, e);
  }
}
var An = new To();
let ka = class {
  constructor() {
    this.observers = {};
  }
  on(e, t) {
    return e.split(" ").forEach((i) => {
      this.observers[i] || (this.observers[i] = /* @__PURE__ */ new Map());
      const r = this.observers[i].get(t) || 0;
      this.observers[i].set(t, r + 1);
    }), this;
  }
  off(e, t) {
    if (this.observers[e]) {
      if (!t) {
        delete this.observers[e];
        return;
      }
      this.observers[e].delete(t);
    }
  }
  emit(e) {
    for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
      i[r - 1] = arguments[r];
    this.observers[e] && Array.from(this.observers[e].entries()).forEach((o) => {
      let [a, l] = o;
      for (let c = 0; c < l; c++)
        a(...i);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((o) => {
      let [a, l] = o;
      for (let c = 0; c < l; c++)
        a.apply(a, [e, ...i]);
    });
  }
};
class Ad extends ka {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = e || {}, this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const t = this.options.ns.indexOf(e);
    t > -1 && this.options.ns.splice(t, 1);
  }
  getResource(e, t, i) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const s = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator, o = r.ignoreJSONStructure !== void 0 ? r.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let a;
    e.indexOf(".") > -1 ? a = e.split(".") : (a = [e, t], i && (Array.isArray(i) ? a.push(...i) : pe(i) && s ? a.push(...i.split(s)) : a.push(i)));
    const l = Eo(this.data, a);
    return !l && !t && !i && e.indexOf(".") > -1 && (e = a[0], t = a[1], i = a.slice(2).join(".")), l || !o || !pe(i) ? l : ac(this.data?.[e]?.[t], i, s);
  }
  addResource(e, t, i, r) {
    let s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const o = s.keySeparator !== void 0 ? s.keySeparator : this.options.keySeparator;
    let a = [e, t];
    i && (a = a.concat(o ? i.split(o) : i)), e.indexOf(".") > -1 && (a = e.split("."), r = t, t = a[1]), this.addNamespaces(t), Td(this.data, a, r), s.silent || this.emit("added", e, t, i, r);
  }
  addResources(e, t, i) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const s in i)
      (pe(i[s]) || Array.isArray(i[s])) && this.addResource(e, t, s, i[s], {
        silent: !0
      });
    r.silent || this.emit("added", e, t, i);
  }
  addResourceBundle(e, t, i, r, s) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, a = [e, t];
    e.indexOf(".") > -1 && (a = e.split("."), r = i, i = t, t = a[1]), this.addNamespaces(t);
    let l = Eo(this.data, a) || {};
    o.skipCopy || (i = JSON.parse(JSON.stringify(i))), r ? Mp(l, i, s) : l = {
      ...l,
      ...i
    }, Td(this.data, a, l), o.silent || this.emit("added", e, t, i);
  }
  removeResourceBundle(e, t) {
    this.hasResourceBundle(e, t) && delete this.data[e][t], this.removeNamespaces(t), this.emit("removed", e, t);
  }
  hasResourceBundle(e, t) {
    return this.getResource(e, t) !== void 0;
  }
  getResourceBundle(e, t) {
    return t || (t = this.options.defaultNS), this.getResource(e, t);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const t = this.getDataByLanguage(e);
    return !!(t && Object.keys(t) || []).find((r) => t[r] && Object.keys(t[r]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Op = {
  processors: {},
  addPostProcessor(n) {
    this.processors[n.name] = n;
  },
  handle(n, e, t, i, r) {
    return n.forEach((s) => {
      e = this.processors[s]?.process(e, t, i, r) ?? e;
    }), e;
  }
};
const Md = {}, Od = (n) => !pe(n) && typeof n != "boolean" && typeof n != "number";
class Ao extends ka {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), Kb(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this), this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = An.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    return e == null ? !1 : this.resolve(e, t)?.res !== void 0;
  }
  extractFromKey(e, t) {
    let i = t.nsSeparator !== void 0 ? t.nsSeparator : this.options.nsSeparator;
    i === void 0 && (i = ":");
    const r = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator;
    let s = t.ns || this.options.defaultNS || [];
    const o = i && e.indexOf(i) > -1, a = !this.options.userDefinedKeySeparator && !t.keySeparator && !this.options.userDefinedNsSeparator && !t.nsSeparator && !t1(e, i, r);
    if (o && !a) {
      const l = e.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: e,
          namespaces: pe(s) ? [s] : s
        };
      const c = e.split(i);
      (i !== r || i === r && this.options.ns.indexOf(c[0]) > -1) && (s = c.shift()), e = c.join(r);
    }
    return {
      key: e,
      namespaces: pe(s) ? [s] : s
    };
  }
  translate(e, t, i) {
    if (typeof t != "object" && this.options.overloadTranslationOptionHandler && (t = this.options.overloadTranslationOptionHandler(arguments)), typeof t == "object" && (t = {
      ...t
    }), t || (t = {}), e == null) return "";
    Array.isArray(e) || (e = [String(e)]);
    const r = t.returnDetails !== void 0 ? t.returnDetails : this.options.returnDetails, s = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator, {
      key: o,
      namespaces: a
    } = this.extractFromKey(e[e.length - 1], t), l = a[a.length - 1], c = t.lng || this.language, u = t.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (c?.toLowerCase() === "cimode") {
      if (u) {
        const C = t.nsSeparator || this.options.nsSeparator;
        return r ? {
          res: `${l}${C}${o}`,
          usedKey: o,
          exactUsedKey: o,
          usedLng: c,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(t)
        } : `${l}${C}${o}`;
      }
      return r ? {
        res: o,
        usedKey: o,
        exactUsedKey: o,
        usedLng: c,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(t)
      } : o;
    }
    const d = this.resolve(e, t);
    let h = d?.res;
    const f = d?.usedKey || o, p = d?.exactUsedKey || o, _ = ["[object Number]", "[object Function]", "[object RegExp]"], m = t.joinArrays !== void 0 ? t.joinArrays : this.options.joinArrays, g = !this.i18nFormat || this.i18nFormat.handleAsObject, y = t.count !== void 0 && !pe(t.count), x = Ao.hasDefaultValue(t), k = y ? this.pluralResolver.getSuffix(c, t.count, t) : "", E = t.ordinal && y ? this.pluralResolver.getSuffix(c, t.count, {
      ordinal: !1
    }) : "", S = y && !t.ordinal && t.count === 0, w = S && t[`defaultValue${this.options.pluralSeparator}zero`] || t[`defaultValue${k}`] || t[`defaultValue${E}`] || t.defaultValue;
    let v = h;
    g && !h && x && (v = w);
    const A = Od(v), b = Object.prototype.toString.apply(v);
    if (g && v && A && _.indexOf(b) < 0 && !(pe(m) && Array.isArray(v))) {
      if (!t.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const C = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(f, v, {
          ...t,
          ns: a
        }) : `key '${o} (${this.language})' returned an object instead of string.`;
        return r ? (d.res = C, d.usedParams = this.getUsedParamsDetails(t), d) : C;
      }
      if (s) {
        const C = Array.isArray(v), M = C ? [] : {}, z = C ? p : f;
        for (const D in v)
          if (Object.prototype.hasOwnProperty.call(v, D)) {
            const H = `${z}${s}${D}`;
            x && !h ? M[D] = this.translate(H, {
              ...t,
              defaultValue: Od(w) ? w[D] : void 0,
              joinArrays: !1,
              ns: a
            }) : M[D] = this.translate(H, {
              ...t,
              joinArrays: !1,
              ns: a
            }), M[D] === H && (M[D] = v[D]);
          }
        h = M;
      }
    } else if (g && pe(m) && Array.isArray(h))
      h = h.join(m), h && (h = this.extendTranslation(h, e, t, i));
    else {
      let C = !1, M = !1;
      !this.isValidLookup(h) && x && (C = !0, h = w), this.isValidLookup(h) || (M = !0, h = o);
      const D = (t.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && M ? void 0 : h, H = x && w !== h && this.options.updateMissing;
      if (M || C || H) {
        if (this.logger.log(H ? "updateKey" : "missingKey", c, l, o, H ? w : h), s) {
          const Y = this.resolve(o, {
            ...t,
            keySeparator: !1
          });
          Y && Y.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let q = [];
        const G = this.languageUtils.getFallbackCodes(this.options.fallbackLng, t.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && G && G[0])
          for (let Y = 0; Y < G.length; Y++)
            q.push(G[Y]);
        else this.options.saveMissingTo === "all" ? q = this.languageUtils.toResolveHierarchy(t.lng || this.language) : q.push(t.lng || this.language);
        const ae = (Y, le, de) => {
          const ot = x && de !== h ? de : D;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(Y, l, le, ot, H, t) : this.backendConnector?.saveMissing && this.backendConnector.saveMissing(Y, l, le, ot, H, t), this.emit("missingKey", Y, l, le, h);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && y ? q.forEach((Y) => {
          const le = this.pluralResolver.getSuffixes(Y, t);
          S && t[`defaultValue${this.options.pluralSeparator}zero`] && le.indexOf(`${this.options.pluralSeparator}zero`) < 0 && le.push(`${this.options.pluralSeparator}zero`), le.forEach((de) => {
            ae([Y], o + de, t[`defaultValue${de}`] || w);
          });
        }) : ae(q, o, w));
      }
      h = this.extendTranslation(h, e, t, d, i), M && h === o && this.options.appendNamespaceToMissingKey && (h = `${l}:${o}`), (M || C) && this.options.parseMissingKeyHandler && (h = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${o}` : o, C ? h : void 0));
    }
    return r ? (d.res = h, d.usedParams = this.getUsedParamsDetails(t), d) : h;
  }
  extendTranslation(e, t, i, r, s) {
    var o = this;
    if (this.i18nFormat?.parse)
      e = this.i18nFormat.parse(e, {
        ...this.options.interpolation.defaultVariables,
        ...i
      }, i.lng || this.language || r.usedLng, r.usedNS, r.usedKey, {
        resolved: r
      });
    else if (!i.skipInterpolation) {
      i.interpolation && this.interpolator.init({
        ...i,
        interpolation: {
          ...this.options.interpolation,
          ...i.interpolation
        }
      });
      const c = pe(e) && (i?.interpolation?.skipOnVariables !== void 0 ? i.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let u;
      if (c) {
        const h = e.match(this.interpolator.nestingRegexp);
        u = h && h.length;
      }
      let d = i.replace && !pe(i.replace) ? i.replace : i;
      if (this.options.interpolation.defaultVariables && (d = {
        ...this.options.interpolation.defaultVariables,
        ...d
      }), e = this.interpolator.interpolate(e, d, i.lng || this.language || r.usedLng, i), c) {
        const h = e.match(this.interpolator.nestingRegexp), f = h && h.length;
        u < f && (i.nest = !1);
      }
      !i.lng && r && r.res && (i.lng = this.language || r.usedLng), i.nest !== !1 && (e = this.interpolator.nest(e, function() {
        for (var h = arguments.length, f = new Array(h), p = 0; p < h; p++)
          f[p] = arguments[p];
        return s?.[0] === f[0] && !i.context ? (o.logger.warn(`It seems you are nesting recursively key: ${f[0]} in key: ${t[0]}`), null) : o.translate(...f, t);
      }, i)), i.interpolation && this.interpolator.reset();
    }
    const a = i.postProcess || this.options.postProcess, l = pe(a) ? [a] : a;
    return e != null && l?.length && i.applyPostProcessor !== !1 && (e = Op.handle(l, e, t, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...r,
        usedParams: this.getUsedParamsDetails(i)
      },
      ...i
    } : i, this)), e;
  }
  resolve(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i, r, s, o, a;
    return pe(e) && (e = [e]), e.forEach((l) => {
      if (this.isValidLookup(i)) return;
      const c = this.extractFromKey(l, t), u = c.key;
      r = u;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const h = t.count !== void 0 && !pe(t.count), f = h && !t.ordinal && t.count === 0, p = t.context !== void 0 && (pe(t.context) || typeof t.context == "number") && t.context !== "", _ = t.lngs ? t.lngs : this.languageUtils.toResolveHierarchy(t.lng || this.language, t.fallbackLng);
      d.forEach((m) => {
        this.isValidLookup(i) || (a = m, !Md[`${_[0]}-${m}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(a) && (Md[`${_[0]}-${m}`] = !0, this.logger.warn(`key "${r}" for languages "${_.join(", ")}" won't get resolved as namespace "${a}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), _.forEach((g) => {
          if (this.isValidLookup(i)) return;
          o = g;
          const y = [u];
          if (this.i18nFormat?.addLookupKeys)
            this.i18nFormat.addLookupKeys(y, u, g, m, t);
          else {
            let k;
            h && (k = this.pluralResolver.getSuffix(g, t.count, t));
            const E = `${this.options.pluralSeparator}zero`, S = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (h && (y.push(u + k), t.ordinal && k.indexOf(S) === 0 && y.push(u + k.replace(S, this.options.pluralSeparator)), f && y.push(u + E)), p) {
              const w = `${u}${this.options.contextSeparator}${t.context}`;
              y.push(w), h && (y.push(w + k), t.ordinal && k.indexOf(S) === 0 && y.push(w + k.replace(S, this.options.pluralSeparator)), f && y.push(w + E));
            }
          }
          let x;
          for (; x = y.pop(); )
            this.isValidLookup(i) || (s = x, i = this.getResource(g, m, x, t));
        }));
      });
    }), {
      res: i,
      usedKey: r,
      exactUsedKey: s,
      usedLng: o,
      usedNS: a
    };
  }
  isValidLookup(e) {
    return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "");
  }
  getResource(e, t, i) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat?.getResource ? this.i18nFormat.getResource(e, t, i, r) : this.resourceStore.getResource(e, t, i, r);
  }
  getUsedParamsDetails() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const t = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], i = e.replace && !pe(e.replace);
    let r = i ? e.replace : e;
    if (i && typeof e.count < "u" && (r.count = e.count), this.options.interpolation.defaultVariables && (r = {
      ...this.options.interpolation.defaultVariables,
      ...r
    }), !i) {
      r = {
        ...r
      };
      for (const s of t)
        delete r[s];
    }
    return r;
  }
  static hasDefaultValue(e) {
    const t = "defaultValue";
    for (const i in e)
      if (Object.prototype.hasOwnProperty.call(e, i) && t === i.substring(0, t.length) && e[i] !== void 0)
        return !0;
    return !1;
  }
}
class Nd {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = An.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (e = Co(e), !e || e.indexOf("-") < 0) return null;
    const t = e.split("-");
    return t.length === 2 || (t.pop(), t[t.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(t.join("-"));
  }
  getLanguagePartFromCode(e) {
    if (e = Co(e), !e || e.indexOf("-") < 0) return e;
    const t = e.split("-");
    return this.formatLanguageCode(t[0]);
  }
  formatLanguageCode(e) {
    if (pe(e) && e.indexOf("-") > -1) {
      let t;
      try {
        t = Intl.getCanonicalLocales(e)[0];
      } catch {
      }
      return t && this.options.lowerCaseLng && (t = t.toLowerCase()), t || (this.options.lowerCaseLng ? e.toLowerCase() : e);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e) return null;
    let t;
    return e.forEach((i) => {
      if (t) return;
      const r = this.formatLanguageCode(i);
      (!this.options.supportedLngs || this.isSupportedCode(r)) && (t = r);
    }), !t && this.options.supportedLngs && e.forEach((i) => {
      if (t) return;
      const r = this.getLanguagePartFromCode(i);
      if (this.isSupportedCode(r)) return t = r;
      t = this.options.supportedLngs.find((s) => {
        if (s === r) return s;
        if (!(s.indexOf("-") < 0 && r.indexOf("-") < 0) && (s.indexOf("-") > 0 && r.indexOf("-") < 0 && s.substring(0, s.indexOf("-")) === r || s.indexOf(r) === 0 && r.length > 1))
          return s;
      });
    }), t || (t = this.getFallbackCodes(this.options.fallbackLng)[0]), t;
  }
  getFallbackCodes(e, t) {
    if (!e) return [];
    if (typeof e == "function" && (e = e(t)), pe(e) && (e = [e]), Array.isArray(e)) return e;
    if (!t) return e.default || [];
    let i = e[t];
    return i || (i = e[this.getScriptPartFromCode(t)]), i || (i = e[this.formatLanguageCode(t)]), i || (i = e[this.getLanguagePartFromCode(t)]), i || (i = e.default), i || [];
  }
  toResolveHierarchy(e, t) {
    const i = this.getFallbackCodes(t || this.options.fallbackLng || [], e), r = [], s = (o) => {
      o && (this.isSupportedCode(o) ? r.push(o) : this.logger.warn(`rejecting language code not found in supportedLngs: ${o}`));
    };
    return pe(e) && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && s(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && s(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && s(this.getLanguagePartFromCode(e))) : pe(e) && s(this.formatLanguageCode(e)), i.forEach((o) => {
      r.indexOf(o) < 0 && s(this.formatLanguageCode(o));
    }), r;
  }
}
const Ld = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, Rd = {
  select: (n) => n === 1 ? "one" : "other",
  resolvedOptions: () => ({
    pluralCategories: ["one", "other"]
  })
};
class i1 {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = e, this.options = t, this.logger = An.create("pluralResolver"), this.pluralRulesCache = {};
  }
  addRule(e, t) {
    this.rules[e] = t;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const i = Co(e === "dev" ? "en" : e), r = t.ordinal ? "ordinal" : "cardinal", s = JSON.stringify({
      cleanedCode: i,
      type: r
    });
    if (s in this.pluralRulesCache)
      return this.pluralRulesCache[s];
    let o;
    try {
      o = new Intl.PluralRules(i, {
        type: r
      });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), Rd;
      if (!e.match(/-|_/)) return Rd;
      const l = this.languageUtils.getLanguagePartFromCode(e);
      o = this.getRule(l, t);
    }
    return this.pluralRulesCache[s] = o, o;
  }
  needsPlural(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = this.getRule(e, t);
    return i || (i = this.getRule("dev", t)), i?.resolvedOptions().pluralCategories.length > 1;
  }
  getPluralFormsOfKey(e, t) {
    let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(e, i).map((r) => `${t}${r}`);
  }
  getSuffixes(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = this.getRule(e, t);
    return i || (i = this.getRule("dev", t)), i ? i.resolvedOptions().pluralCategories.sort((r, s) => Ld[r] - Ld[s]).map((r) => `${this.options.prepend}${t.ordinal ? `ordinal${this.options.prepend}` : ""}${r}`) : [];
  }
  getSuffix(e, t) {
    let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const r = this.getRule(e, i);
    return r ? `${this.options.prepend}${i.ordinal ? `ordinal${this.options.prepend}` : ""}${r.select(t)}` : (this.logger.warn(`no plural rule found for: ${e}`), this.getSuffix("dev", t, i));
  }
}
const Id = function(n, e, t) {
  let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", r = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, s = Jb(n, e, t);
  return !s && r && pe(t) && (s = ac(n, t, i), s === void 0 && (s = ac(e, t, i))), s;
}, sl = (n) => n.replace(/\$/g, "$$$$");
class r1 {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = An.create("interpolator"), this.options = e, this.format = e?.interpolation?.format || ((t) => t), this.init(e);
  }
  init() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    e.interpolation || (e.interpolation = {
      escapeValue: !0
    });
    const {
      escape: t,
      escapeValue: i,
      useRawValueToEscape: r,
      prefix: s,
      prefixEscaped: o,
      suffix: a,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: h,
      nestingPrefixEscaped: f,
      nestingSuffix: p,
      nestingSuffixEscaped: _,
      nestingOptionsSeparator: m,
      maxReplaces: g,
      alwaysFormat: y
    } = e.interpolation;
    this.escape = t !== void 0 ? t : Yb, this.escapeValue = i !== void 0 ? i : !0, this.useRawValueToEscape = r !== void 0 ? r : !1, this.prefix = s ? ji(s) : o || "{{", this.suffix = a ? ji(a) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = h ? ji(h) : f || ji("$t("), this.nestingSuffix = p ? ji(p) : _ || ji(")"), this.nestingOptionsSeparator = m || ",", this.maxReplaces = g || 1e3, this.alwaysFormat = y !== void 0 ? y : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (t, i) => t?.source === i ? (t.lastIndex = 0, t) : new RegExp(i, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(e, t, i, r) {
    let s, o, a;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (f) => {
      if (f.indexOf(this.formatSeparator) < 0) {
        const g = Id(t, l, f, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(g, void 0, i, {
          ...r,
          ...t,
          interpolationkey: f
        }) : g;
      }
      const p = f.split(this.formatSeparator), _ = p.shift().trim(), m = p.join(this.formatSeparator).trim();
      return this.format(Id(t, l, _, this.options.keySeparator, this.options.ignoreJSONStructure), m, i, {
        ...r,
        ...t,
        interpolationkey: _
      });
    };
    this.resetRegExp();
    const u = r?.missingInterpolationHandler || this.options.missingInterpolationHandler, d = r?.interpolation?.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (f) => sl(f)
    }, {
      regex: this.regexp,
      safeValue: (f) => this.escapeValue ? sl(this.escape(f)) : sl(f)
    }].forEach((f) => {
      for (a = 0; s = f.regex.exec(e); ) {
        const p = s[1].trim();
        if (o = c(p), o === void 0)
          if (typeof u == "function") {
            const m = u(e, s, r);
            o = pe(m) ? m : "";
          } else if (r && Object.prototype.hasOwnProperty.call(r, p))
            o = "";
          else if (d) {
            o = s[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${p} for interpolating ${e}`), o = "";
        else !pe(o) && !this.useRawValueToEscape && (o = Sd(o));
        const _ = f.safeValue(o);
        if (e = e.replace(s[0], _), d ? (f.regex.lastIndex += o.length, f.regex.lastIndex -= s[0].length) : f.regex.lastIndex = 0, a++, a >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, t) {
    let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r, s, o;
    const a = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0) return l;
      const d = l.split(new RegExp(`${u}[ ]*{`));
      let h = `{${d[1]}`;
      l = d[0], h = this.interpolate(h, o);
      const f = h.match(/'/g), p = h.match(/"/g);
      ((f?.length ?? 0) % 2 === 0 && !p || p.length % 2 !== 0) && (h = h.replace(/'/g, '"'));
      try {
        o = JSON.parse(h), c && (o = {
          ...c,
          ...o
        });
      } catch (_) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, _), `${l}${u}${h}`;
      }
      return o.defaultValue && o.defaultValue.indexOf(this.prefix) > -1 && delete o.defaultValue, l;
    };
    for (; r = this.nestingRegexp.exec(e); ) {
      let l = [];
      o = {
        ...i
      }, o = o.replace && !pe(o.replace) ? o.replace : o, o.applyPostProcessor = !1, delete o.defaultValue;
      let c = !1;
      if (r[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(r[1])) {
        const u = r[1].split(this.formatSeparator).map((d) => d.trim());
        r[1] = u.shift(), l = u, c = !0;
      }
      if (s = t(a.call(this, r[1].trim(), o), o), s && r[0] === e && !pe(s)) return s;
      pe(s) || (s = Sd(s)), s || (this.logger.warn(`missed to resolve ${r[1]} for nesting ${e}`), s = ""), c && (s = l.reduce((u, d) => this.format(u, d, i.lng, {
        ...i,
        interpolationkey: r[1].trim()
      }), s.trim())), e = e.replace(r[0], s), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
const s1 = (n) => {
  let e = n.toLowerCase().trim();
  const t = {};
  if (n.indexOf("(") > -1) {
    const i = n.split("(");
    e = i[0].toLowerCase().trim();
    const r = i[1].substring(0, i[1].length - 1);
    e === "currency" && r.indexOf(":") < 0 ? t.currency || (t.currency = r.trim()) : e === "relativetime" && r.indexOf(":") < 0 ? t.range || (t.range = r.trim()) : r.split(";").forEach((o) => {
      if (o) {
        const [a, ...l] = o.split(":"), c = l.join(":").trim().replace(/^'+|'+$/g, ""), u = a.trim();
        t[u] || (t[u] = c), c === "false" && (t[u] = !1), c === "true" && (t[u] = !0), isNaN(c) || (t[u] = parseInt(c, 10));
      }
    });
  }
  return {
    formatName: e,
    formatOptions: t
  };
}, Wi = (n) => {
  const e = {};
  return (t, i, r) => {
    let s = r;
    r && r.interpolationkey && r.formatParams && r.formatParams[r.interpolationkey] && r[r.interpolationkey] && (s = {
      ...s,
      [r.interpolationkey]: void 0
    });
    const o = i + JSON.stringify(s);
    let a = e[o];
    return a || (a = n(Co(i), r), e[o] = a), a(t);
  };
};
class o1 {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = An.create("formatter"), this.options = e, this.formats = {
      number: Wi((t, i) => {
        const r = new Intl.NumberFormat(t, {
          ...i
        });
        return (s) => r.format(s);
      }),
      currency: Wi((t, i) => {
        const r = new Intl.NumberFormat(t, {
          ...i,
          style: "currency"
        });
        return (s) => r.format(s);
      }),
      datetime: Wi((t, i) => {
        const r = new Intl.DateTimeFormat(t, {
          ...i
        });
        return (s) => r.format(s);
      }),
      relativetime: Wi((t, i) => {
        const r = new Intl.RelativeTimeFormat(t, {
          ...i
        });
        return (s) => r.format(s, i.range || "day");
      }),
      list: Wi((t, i) => {
        const r = new Intl.ListFormat(t, {
          ...i
        });
        return (s) => r.format(s);
      })
    }, this.init(e);
  }
  init(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = t.interpolation.formatSeparator || ",";
  }
  add(e, t) {
    this.formats[e.toLowerCase().trim()] = t;
  }
  addCached(e, t) {
    this.formats[e.toLowerCase().trim()] = Wi(t);
  }
  format(e, t, i) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const s = t.split(this.formatSeparator);
    if (s.length > 1 && s[0].indexOf("(") > 1 && s[0].indexOf(")") < 0 && s.find((a) => a.indexOf(")") > -1)) {
      const a = s.findIndex((l) => l.indexOf(")") > -1);
      s[0] = [s[0], ...s.splice(1, a)].join(this.formatSeparator);
    }
    return s.reduce((a, l) => {
      const {
        formatName: c,
        formatOptions: u
      } = s1(l);
      if (this.formats[c]) {
        let d = a;
        try {
          const h = r?.formatParams?.[r.interpolationkey] || {}, f = h.locale || h.lng || r.locale || r.lng || i;
          d = this.formats[c](a, f, {
            ...u,
            ...r,
            ...h
          });
        } catch (h) {
          this.logger.warn(h);
        }
        return d;
      } else
        this.logger.warn(`there was no format function for ${c}`);
      return a;
    }, e);
  }
}
const a1 = (n, e) => {
  n.pending[e] !== void 0 && (delete n.pending[e], n.pendingCount--);
};
class l1 extends ka {
  constructor(e, t, i) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = e, this.store = t, this.services = i, this.languageUtils = i.languageUtils, this.options = r, this.logger = An.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = r.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = r.maxRetries >= 0 ? r.maxRetries : 5, this.retryTimeout = r.retryTimeout >= 1 ? r.retryTimeout : 350, this.state = {}, this.queue = [], this.backend?.init?.(i, r.backend, r);
  }
  queueLoad(e, t, i, r) {
    const s = {}, o = {}, a = {}, l = {};
    return e.forEach((c) => {
      let u = !0;
      t.forEach((d) => {
        const h = `${c}|${d}`;
        !i.reload && this.store.hasResourceBundle(c, d) ? this.state[h] = 2 : this.state[h] < 0 || (this.state[h] === 1 ? o[h] === void 0 && (o[h] = !0) : (this.state[h] = 1, u = !1, o[h] === void 0 && (o[h] = !0), s[h] === void 0 && (s[h] = !0), l[d] === void 0 && (l[d] = !0)));
      }), u || (a[c] = !0);
    }), (Object.keys(s).length || Object.keys(o).length) && this.queue.push({
      pending: o,
      pendingCount: Object.keys(o).length,
      loaded: {},
      errors: [],
      callback: r
    }), {
      toLoad: Object.keys(s),
      pending: Object.keys(o),
      toLoadLanguages: Object.keys(a),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(e, t, i) {
    const r = e.split("|"), s = r[0], o = r[1];
    t && this.emit("failedLoading", s, o, t), !t && i && this.store.addResourceBundle(s, o, i, void 0, void 0, {
      skipCopy: !0
    }), this.state[e] = t ? -1 : 2, t && i && (this.state[e] = 0);
    const a = {};
    this.queue.forEach((l) => {
      Gb(l.loaded, [s], o), a1(l, e), t && l.errors.push(t), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        a[c] || (a[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((d) => {
          a[c][d] === void 0 && (a[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", a), this.queue = this.queue.filter((l) => !l.done);
  }
  read(e, t, i) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, o = arguments.length > 5 ? arguments[5] : void 0;
    if (!e.length) return o(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: e,
        ns: t,
        fcName: i,
        tried: r,
        wait: s,
        callback: o
      });
      return;
    }
    this.readingCalls++;
    const a = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && u && r < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, e, t, i, r + 1, s * 2, o);
        }, s);
        return;
      }
      o(c, u);
    }, l = this.backend[i].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(e, t);
        c && typeof c.then == "function" ? c.then((u) => a(null, u)).catch(a) : a(null, c);
      } catch (c) {
        a(c);
      }
      return;
    }
    return l(e, t, a);
  }
  prepareLoading(e, t) {
    let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), r && r();
    pe(e) && (e = this.languageUtils.toResolveHierarchy(e)), pe(t) && (t = [t]);
    const s = this.queueLoad(e, t, i, r);
    if (!s.toLoad.length)
      return s.pending.length || r(), null;
    s.toLoad.forEach((o) => {
      this.loadOne(o);
    });
  }
  load(e, t, i) {
    this.prepareLoading(e, t, {}, i);
  }
  reload(e, t, i) {
    this.prepareLoading(e, t, {
      reload: !0
    }, i);
  }
  loadOne(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const i = e.split("|"), r = i[0], s = i[1];
    this.read(r, s, "read", void 0, void 0, (o, a) => {
      o && this.logger.warn(`${t}loading namespace ${s} for language ${r} failed`, o), !o && a && this.logger.log(`${t}loaded namespace ${s} for language ${r}`, a), this.loaded(e, o, a);
    });
  }
  saveMissing(e, t, i, r, s) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, a = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(t)) {
      this.logger.warn(`did not save key "${i}" as the namespace "${t}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(i == null || i === "")) {
      if (this.backend?.create) {
        const l = {
          ...o,
          isUpdate: s
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(e, t, i, r, l) : u = c(e, t, i, r), u && typeof u.then == "function" ? u.then((d) => a(null, d)).catch(a) : a(null, u);
          } catch (u) {
            a(u);
          }
        else
          c(e, t, i, r, a, l);
      }
      !e || !e[0] || this.store.addResource(e[0], t, i, r);
    }
  }
}
const Pd = () => ({
  debug: !1,
  initAsync: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (n) => {
    let e = {};
    if (typeof n[1] == "object" && (e = n[1]), pe(n[1]) && (e.defaultValue = n[1]), pe(n[2]) && (e.tDescription = n[2]), typeof n[2] == "object" || typeof n[3] == "object") {
      const t = n[3] || n[2];
      Object.keys(t).forEach((i) => {
        e[i] = t[i];
      });
    }
    return e;
  },
  interpolation: {
    escapeValue: !0,
    format: (n) => n,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), Dd = (n) => (pe(n.ns) && (n.ns = [n.ns]), pe(n.fallbackLng) && (n.fallbackLng = [n.fallbackLng]), pe(n.fallbackNS) && (n.fallbackNS = [n.fallbackNS]), n.supportedLngs?.indexOf?.("cimode") < 0 && (n.supportedLngs = n.supportedLngs.concat(["cimode"])), typeof n.initImmediate == "boolean" && (n.initAsync = n.initImmediate), n), Vs = () => {
}, c1 = (n) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(n)).forEach((t) => {
    typeof n[t] == "function" && (n[t] = n[t].bind(n));
  });
};
class ds extends ka {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = Dd(e), this.services = {}, this.logger = An, this.modules = {
      external: []
    }, c1(this), t && !this.isInitialized && !e.isClone) {
      if (!this.options.initAsync)
        return this.init(e, t), this;
      setTimeout(() => {
        this.init(e, t);
      }, 0);
    }
  }
  init() {
    var e = this;
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof t == "function" && (i = t, t = {}), t.defaultNS == null && t.ns && (pe(t.ns) ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const r = Pd();
    this.options = {
      ...r,
      ...this.options,
      ...Dd(t)
    }, this.options.interpolation = {
      ...r.interpolation,
      ...this.options.interpolation
    }, t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    const s = (u) => u ? typeof u == "function" ? new u() : u : null;
    if (!this.options.isClone) {
      this.modules.logger ? An.init(s(this.modules.logger), this.options) : An.init(null, this.options);
      let u;
      this.modules.formatter ? u = this.modules.formatter : u = o1;
      const d = new Nd(this.options);
      this.store = new Ad(this.options.resources, this.options);
      const h = this.services;
      h.logger = An, h.resourceStore = this.store, h.languageUtils = d, h.pluralResolver = new i1(d, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), u && (!this.options.interpolation.format || this.options.interpolation.format === r.interpolation.format) && (h.formatter = s(u), h.formatter.init(h, this.options), this.options.interpolation.format = h.formatter.format.bind(h.formatter)), h.interpolator = new r1(this.options), h.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, h.backendConnector = new l1(s(this.modules.backend), h.resourceStore, h, this.options), h.backendConnector.on("*", function(f) {
        for (var p = arguments.length, _ = new Array(p > 1 ? p - 1 : 0), m = 1; m < p; m++)
          _[m - 1] = arguments[m];
        e.emit(f, ..._);
      }), this.modules.languageDetector && (h.languageDetector = s(this.modules.languageDetector), h.languageDetector.init && h.languageDetector.init(h, this.options.detection, this.options)), this.modules.i18nFormat && (h.i18nFormat = s(this.modules.i18nFormat), h.i18nFormat.init && h.i18nFormat.init(this)), this.translator = new Ao(this.services, this.options), this.translator.on("*", function(f) {
        for (var p = arguments.length, _ = new Array(p > 1 ? p - 1 : 0), m = 1; m < p; m++)
          _[m - 1] = arguments[m];
        e.emit(f, ..._);
      }), this.modules.external.forEach((f) => {
        f.init && f.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, i || (i = Vs), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const u = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      u.length > 0 && u[0] !== "dev" && (this.options.lng = u[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((u) => {
      this[u] = function() {
        return e.store[u](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((u) => {
      this[u] = function() {
        return e.store[u](...arguments), e;
      };
    });
    const l = Or(), c = () => {
      const u = (d, h) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(h), i(d, h);
      };
      if (this.languages && !this.isInitialized) return u(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, u);
    };
    return this.options.resources || !this.options.initAsync ? c() : setTimeout(c, 0), l;
  }
  loadResources(e) {
    let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Vs;
    const r = pe(e) ? e : this.language;
    if (typeof e == "function" && (i = e), !this.options.resources || this.options.partialBundledLanguages) {
      if (r?.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return i();
      const s = [], o = (a) => {
        if (!a || a === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(a).forEach((c) => {
          c !== "cimode" && s.indexOf(c) < 0 && s.push(c);
        });
      };
      r ? o(r) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => o(l)), this.options.preload?.forEach?.((a) => o(a)), this.services.backendConnector.load(s, this.options.ns, (a) => {
        !a && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), i(a);
      });
    } else
      i(null);
  }
  reloadResources(e, t, i) {
    const r = Or();
    return typeof e == "function" && (i = e, e = void 0), typeof t == "function" && (i = t, t = void 0), e || (e = this.languages), t || (t = this.options.ns), i || (i = Vs), this.services.backendConnector.reload(e, t, (s) => {
      r.resolve(), i(s);
    }), r;
  }
  use(e) {
    if (!e) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && Op.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1))
      for (let t = 0; t < this.languages.length; t++) {
        const i = this.languages[t];
        if (!(["cimode", "dev"].indexOf(i) > -1) && this.store.hasLanguageSomeTranslations(i)) {
          this.resolvedLanguage = i;
          break;
        }
      }
  }
  changeLanguage(e, t) {
    var i = this;
    this.isLanguageChangingTo = e;
    const r = Or();
    this.emit("languageChanging", e);
    const s = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, o = (l, c) => {
      c ? (s(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, r.resolve(function() {
        return i.t(...arguments);
      }), t && t(l, function() {
        return i.t(...arguments);
      });
    }, a = (l) => {
      !e && !l && this.services.languageDetector && (l = []);
      const c = pe(l) ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      c && (this.language || s(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector?.cacheUserLanguage?.(c)), this.loadResources(c, (u) => {
        o(u, c);
      });
    };
    return !e && this.services.languageDetector && !this.services.languageDetector.async ? a(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(a) : this.services.languageDetector.detect(a) : a(e), r;
  }
  getFixedT(e, t, i) {
    var r = this;
    const s = function(o, a) {
      let l;
      if (typeof a != "object") {
        for (var c = arguments.length, u = new Array(c > 2 ? c - 2 : 0), d = 2; d < c; d++)
          u[d - 2] = arguments[d];
        l = r.options.overloadTranslationOptionHandler([o, a].concat(u));
      } else
        l = {
          ...a
        };
      l.lng = l.lng || s.lng, l.lngs = l.lngs || s.lngs, l.ns = l.ns || s.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || i || s.keyPrefix);
      const h = r.options.keySeparator || ".";
      let f;
      return l.keyPrefix && Array.isArray(o) ? f = o.map((p) => `${l.keyPrefix}${h}${p}`) : f = l.keyPrefix ? `${l.keyPrefix}${h}${o}` : o, r.t(f, l);
    };
    return pe(e) ? s.lng = e : s.lngs = e, s.ns = t, s.keyPrefix = i, s;
  }
  t() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
      t[i] = arguments[i];
    return this.translator?.translate(...t);
  }
  exists() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
      t[i] = arguments[i];
    return this.translator?.exists(...t);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const i = t.lng || this.resolvedLanguage || this.languages[0], r = this.options ? this.options.fallbackLng : !1, s = this.languages[this.languages.length - 1];
    if (i.toLowerCase() === "cimode") return !0;
    const o = (a, l) => {
      const c = this.services.backendConnector.state[`${a}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (t.precheck) {
      const a = t.precheck(this, o);
      if (a !== void 0) return a;
    }
    return !!(this.hasResourceBundle(i, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || o(i, e) && (!r || o(s, e)));
  }
  loadNamespaces(e, t) {
    const i = Or();
    return this.options.ns ? (pe(e) && (e = [e]), e.forEach((r) => {
      this.options.ns.indexOf(r) < 0 && this.options.ns.push(r);
    }), this.loadResources((r) => {
      i.resolve(), t && t(r);
    }), i) : (t && t(), Promise.resolve());
  }
  loadLanguages(e, t) {
    const i = Or();
    pe(e) && (e = [e]);
    const r = this.options.preload || [], s = e.filter((o) => r.indexOf(o) < 0 && this.services.languageUtils.isSupportedCode(o));
    return s.length ? (this.options.preload = r.concat(s), this.loadResources((o) => {
      i.resolve(), t && t(o);
    }), i) : (t && t(), Promise.resolve());
  }
  dir(e) {
    if (e || (e = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language)), !e) return "rtl";
    const t = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], i = this.services?.languageUtils || new Nd(Pd());
    return t.indexOf(i.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    return new ds(e, t);
  }
  cloneInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Vs;
    const i = e.forkResourceStore;
    i && delete e.forkResourceStore;
    const r = {
      ...this.options,
      ...e,
      isClone: !0
    }, s = new ds(r);
    if ((e.debug !== void 0 || e.prefix !== void 0) && (s.logger = s.logger.clone(e)), ["store", "services", "language"].forEach((a) => {
      s[a] = this[a];
    }), s.services = {
      ...this.services
    }, s.services.utils = {
      hasLoadedNamespace: s.hasLoadedNamespace.bind(s)
    }, i) {
      const a = Object.keys(this.store.data).reduce((l, c) => (l[c] = {
        ...this.store.data[c]
      }, Object.keys(l[c]).reduce((u, d) => (u[d] = {
        ...l[c][d]
      }, u), {})), {});
      s.store = new Ad(a, r), s.services.resourceStore = s.store;
    }
    return s.translator = new Ao(s.services, r), s.translator.on("*", function(a) {
      for (var l = arguments.length, c = new Array(l > 1 ? l - 1 : 0), u = 1; u < l; u++)
        c[u - 1] = arguments[u];
      s.emit(a, ...c);
    }), s.init(r, t), s.translator.options = r, s.translator.backendConnector.services.utils = {
      hasLoadedNamespace: s.hasLoadedNamespace.bind(s)
    }, s;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const Je = ds.createInstance();
Je.createInstance = ds.createInstance;
Je.createInstance;
Je.dir;
Je.init;
Je.loadResources;
Je.reloadResources;
Je.use;
Je.changeLanguage;
Je.getFixedT;
Je.t;
Je.exists;
Je.setDefaultNamespace;
Je.hasLoadedNamespace;
Je.loadNamespaces;
Je.loadLanguages;
const u1 = "キャンセル", d1 = "中央揃え", h1 = "同じウィンドウ", f1 = "セル", p1 = "行", m1 = "下線", g1 = "URL", _1 = "高さ", b1 = "表", v1 = "やり直す", y1 = "段落", x1 = "テキスト", w1 = "スコープ", k1 = "太字", S1 = "ツールバー", E1 = "左揃え", C1 = "元に戻す", T1 = "取り消し線", A1 = "引用", M1 = "上揃え", O1 = "保存", N1 = "インデントを増やす", L1 = "中央揃え", R1 = "画像", I1 = "定型文", P1 = "インデントを減らす", D1 = "リッチテキストエディタ", $1 = "リンク", z1 = "新規ウィンドウ", H1 = "斜体", B1 = "列", F1 = "挿入", V1 = "なし", j1 = "右揃え", W1 = "下揃え", U1 = "書式設定済み", K1 = "リンクを解除", q1 = "両端揃え", G1 = "タイトル", J1 = "ファイル", X1 = "幅", Y1 = {
  "Insert (s)": "挿入 (s)",
  "Full Screen": "フルスクリーン",
  "Parameters for oEmbed API": "oEmbed API呼び出しで指定するパラメータ",
  Cancel: u1,
  HORIZONTAL_ALIGN_CENTER: d1,
  "Merge cells": "セルを結合",
  "Delete Image": "画像を削除",
  "Can not get data from [_1]: [_2]": "[_1]からデータを取得できませんでした: [_2]",
  "Heading 5": "見出し 5",
  "Toggle to HTML structure editing mode": "HTML構造編集モードへの切り替え",
  LINK_TARGET_SELF: h1,
  Cell: f1,
  Row: p1,
  "Horizontal Rule": "水平罫線",
  Underline: m1,
  URL: g1,
  "Color Palette": "カラーパレット",
  "Select the data attributes you want to keep in the pasted HTML. Unselected attributes will be removed.": "保持したいデータ属性を選択してください。選択しない属性は削除されます。",
  "Save (s)": "保存 (s)",
  "Insert Link": "リンク挿入",
  "Paste as HTML": "HTMLとして貼り付け",
  Height: _1,
  "Paste as text": "テキストとして貼り付け",
  Table: b1,
  "Failed to get embed object: [_1]": "埋め込みオブジェクトの取得に失敗しました: [_1]",
  "Split cell": "セルを分割",
  "Convert from Markdown": "Markdownから変換",
  "Insert Boilerplate": "定型文の挿入",
  "Table Properties": "表のプロパティ",
  Redo: v1,
  "Insert row after": "後に行を挿入",
  "Cell Spacing": "セルの間隔",
  Paragraph: y1,
  "Row properties": "行のプロパティ",
  Text: x1,
  Scope: w1,
  "Bullet List": "箇条書き",
  "Link Target": "リンクの開き方...",
  "Cancel (x)": "キャンセル (x)",
  "Embed object": "埋め込みオブジェクト",
  "Cell Properties": "セルのプロパティ",
  Bold: k1,
  Toolbar: S1,
  "Failed to parse HTML: [_1]": "HTMLの解析に失敗しました: [_1]",
  HORIZONTAL_ALIGN_LEFT: E1,
  "Delete table": "表の削除",
  "Heading 2": "見出し 2",
  Undo: C1,
  Strike: T1,
  "Specify the default value of a parameter when using the oEmbed API to obtain the embed code for content from an external service. <br>Since the handling of the specified parameters depends on the specifications of each service, it may not always be embedded at the specified size.": "外部サービスのコンテンツの埋め込みコードをoEmbed APIを利用して取得する際の、パラメータの初期値を指定します。<br>指定したパラメータの扱いはサービス毎の仕様によるため、必ずしも指定した通りのサイズで埋め込まれるとは限りません。",
  "Cell type": "セルの種類",
  "Delete column": "列の削除",
  "Available Paragraph Styles": "追加可能な段落スタイル",
  "Select the properties you want to keep in the pasted HTML. Unselected properties will be removed.": "style属性のプロパティを選択してください。選択しないプロパティは削除されます。",
  Blockquote: A1,
  "Row group": "行グループ",
  "Link URL": "リンクURL",
  "Row Properties": "行のプロパティ",
  "Insert column after": "後に列を挿入",
  "Available Items": "追加可能なアイテム",
  "Insert HTML": "HTMLの挿入",
  VERTICAL_ALIGN_TOP: M1,
  "Insert File": "アセットの挿入",
  Save: O1,
  "Select All": "すべて選択",
  "Source Code": "ソースコード",
  Indent: N1,
  "Highlight Color": "ハイライトの色",
  "Heading 1": "見出し 1",
  "Add color to the palette": "カラーパレットに色を追加",
  "Toggle to HTML editing mode": "HTML編集モードへの切り替え",
  "Properties for style attributes": "style属性のプロパティ",
  "Border Width": "枠線幅",
  "Delete row": "行の削除",
  VERTICAL_ALIGN_MIDDLE: L1,
  "Insert Image": "画像の挿入",
  Image: R1,
  "Header cell": "ヘッダーセル",
  "Remove Format": "書式をクリア",
  "Cell properties": "セルのプロパティ",
  Boilerplate: I1,
  "Horizontal align": "横配置",
  "Vertical align": "縦配置",
  "Insert row before": "前に行を挿入",
  "Retrieval of data when embedding web pages": "ウェブページの埋め込み時のデータ取得",
  "Edit Image": "画像を編集",
  "Ordered List": "番号付き箇条書き",
  Outdent: P1,
  "Select items to use in the toolbar.": "ツールバーで利用するアイテムを選択します。",
  "Do not allow data to be retrieved": "データ取得を許可しない",
  MTRichTextEditor: D1,
  "Cell Padding": "セル内のスペース",
  Link: $1,
  "Insert column before": "前に列を挿入",
  "Edit attributes": "属性値の編集",
  LINK_TARGET_BLANK: z1,
  "MTRichTextEditor Settings": "リッチテキストエディタ設定",
  Italic: H1,
  "Heading 6": "見出し 6",
  "Paste as link": "リンクとして貼り付け",
  Column: B1,
  Insert: F1,
  None: V1,
  "Select the style to be used in the paragraph style.": "段落スタイルで利用するスタイルを選択します。",
  HORIZONTAL_ALIGN_RIGHT: j1,
  VERTICAL_ALIGN_BOTTOM: W1,
  "Heading 3": "見出し 3",
  'Specify the color to be used for "Text color" and "highlight color".': "「テキストの色」や「ハイライトの色」で利用する色を指定します。",
  Preformatted: U1,
  Unlink: K1,
  HORIZONTAL_ALIGN_JUSTIFY: q1,
  "Embed inline": "インライン埋め込み",
  "Align Left": "左揃え",
  "Link Text": "リンク元テキスト",
  Title: G1,
  "Allow data to be retrieved from any URL": "任意のURLに対してデータ取得を許可する",
  "Embed webpage as inline link": "ウェブページの埋め込み (インラインリンク)",
  "Insert table": "表の挿入",
  "Align Center": "中央揃え",
  "Embed webpage as card": "ウェブページの埋め込み (カード)",
  "Table properties": "表のプロパティ",
  "Text Color": "テキストの色",
  "Paragraph Styles": "段落スタイル",
  "Align Right": "右揃え",
  "Edit Link": "リンクを編集",
  "Select the rules that allow the retrieval of web page metadata. This selection affects the ability to embed web page content.": "ウェブページのメタデータの取得を許可するルールを選択します。この選択はウェブページの内容を埋め込む機能に影響します。",
  "Heading 4": "見出し 4",
  "Data attributes": "データ属性",
  "Column group": "列グループ",
  File: J1,
  Width: X1,
  "Allow data to be retrieved from URLs of sites in the system": "システム内のサイトのURLに対してデータ取得を許可する"
}, Z1 = "Justify", Q1 = "Left", ev = "Top", tv = "Right", nv = "Current window", iv = "New window", rv = "Center", sv = "Middle", ov = "Bottom", av = {
  HORIZONTAL_ALIGN_JUSTIFY: Z1,
  HORIZONTAL_ALIGN_LEFT: Q1,
  VERTICAL_ALIGN_TOP: ev,
  HORIZONTAL_ALIGN_RIGHT: tv,
  LINK_TARGET_SELF: nv,
  LINK_TARGET_BLANK: iv,
  HORIZONTAL_ALIGN_CENTER: rv,
  "Vertical align": "Vertical align",
  VERTICAL_ALIGN_MIDDLE: sv,
  VERTICAL_ALIGN_BOTTOM: ov
};
Je.init({
  fallbackLng: "en",
  resources: {
    ja: {
      translation: Y1
    },
    en: {
      translation: av
    }
  }
});
const I = (...n) => {
  if (typeof n[0] == "string")
    return Je.t(...n);
  {
    let e = "";
    const [t, ...i] = n;
    for (let r = 0; r < t.length; r++)
      e += t[r] + Je.t(i[r]);
    return e;
  }
};
function xt(n) {
  this.content = n;
}
xt.prototype = {
  constructor: xt,
  find: function(n) {
    for (var e = 0; e < this.content.length; e += 2)
      if (this.content[e] === n) return e;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(n) {
    var e = this.find(n);
    return e == -1 ? void 0 : this.content[e + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(n, e, t) {
    var i = t && t != n ? this.remove(t) : this, r = i.find(n), s = i.content.slice();
    return r == -1 ? s.push(t || n, e) : (s[r + 1] = e, t && (s[r] = t)), new xt(s);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(n) {
    var e = this.find(n);
    if (e == -1) return this;
    var t = this.content.slice();
    return t.splice(e, 2), new xt(t);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(n, e) {
    return new xt([n, e].concat(this.remove(n).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(n, e) {
    var t = this.remove(n).content.slice();
    return t.push(n, e), new xt(t);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(n, e, t) {
    var i = this.remove(e), r = i.content.slice(), s = i.find(n);
    return r.splice(s == -1 ? r.length : s, 0, e, t), new xt(r);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(n) {
    for (var e = 0; e < this.content.length; e += 2)
      n(this.content[e], this.content[e + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(n) {
    return n = xt.from(n), n.size ? new xt(n.content.concat(this.subtract(n).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(n) {
    return n = xt.from(n), n.size ? new xt(this.subtract(n).content.concat(n.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(n) {
    var e = this;
    n = xt.from(n);
    for (var t = 0; t < n.content.length; t += 2)
      e = e.remove(n.content[t]);
    return e;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var n = {};
    return this.forEach(function(e, t) {
      n[e] = t;
    }), n;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
xt.from = function(n) {
  if (n instanceof xt) return n;
  var e = [];
  if (n) for (var t in n) e.push(t, n[t]);
  return new xt(e);
};
function Np(n, e, t) {
  for (let i = 0; ; i++) {
    if (i == n.childCount || i == e.childCount)
      return n.childCount == e.childCount ? null : t;
    let r = n.child(i), s = e.child(i);
    if (r == s) {
      t += r.nodeSize;
      continue;
    }
    if (!r.sameMarkup(s))
      return t;
    if (r.isText && r.text != s.text) {
      for (let o = 0; r.text[o] == s.text[o]; o++)
        t++;
      return t;
    }
    if (r.content.size || s.content.size) {
      let o = Np(r.content, s.content, t + 1);
      if (o != null)
        return o;
    }
    t += r.nodeSize;
  }
}
function Lp(n, e, t, i) {
  for (let r = n.childCount, s = e.childCount; ; ) {
    if (r == 0 || s == 0)
      return r == s ? null : { a: t, b: i };
    let o = n.child(--r), a = e.child(--s), l = o.nodeSize;
    if (o == a) {
      t -= l, i -= l;
      continue;
    }
    if (!o.sameMarkup(a))
      return { a: t, b: i };
    if (o.isText && o.text != a.text) {
      let c = 0, u = Math.min(o.text.length, a.text.length);
      for (; c < u && o.text[o.text.length - c - 1] == a.text[a.text.length - c - 1]; )
        c++, t--, i--;
      return { a: t, b: i };
    }
    if (o.content.size || a.content.size) {
      let c = Lp(o.content, a.content, t - 1, i - 1);
      if (c)
        return c;
    }
    t -= l, i -= l;
  }
}
class $ {
  /**
  @internal
  */
  constructor(e, t) {
    if (this.content = e, this.size = t || 0, t == null)
      for (let i = 0; i < e.length; i++)
        this.size += e[i].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(e, t, i, r = 0, s) {
    for (let o = 0, a = 0; a < t; o++) {
      let l = this.content[o], c = a + l.nodeSize;
      if (c > e && i(l, r + a, s || null, o) !== !1 && l.content.size) {
        let u = a + 1;
        l.nodesBetween(Math.max(0, e - u), Math.min(l.content.size, t - u), i, r + u);
      }
      a = c;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(e, t, i, r) {
    let s = "", o = !0;
    return this.nodesBetween(e, t, (a, l) => {
      let c = a.isText ? a.text.slice(Math.max(e, l) - l, t - l) : a.isLeaf ? r ? typeof r == "function" ? r(a) : r : a.type.spec.leafText ? a.type.spec.leafText(a) : "" : "";
      a.isBlock && (a.isLeaf && c || a.isTextblock) && i && (o ? o = !1 : s += i), s += c;
    }, 0), s;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let t = this.lastChild, i = e.firstChild, r = this.content.slice(), s = 0;
    for (t.isText && t.sameMarkup(i) && (r[r.length - 1] = t.withText(t.text + i.text), s = 1); s < e.content.length; s++)
      r.push(e.content[s]);
    return new $(r, this.size + e.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(e, t = this.size) {
    if (e == 0 && t == this.size)
      return this;
    let i = [], r = 0;
    if (t > e)
      for (let s = 0, o = 0; o < t; s++) {
        let a = this.content[s], l = o + a.nodeSize;
        l > e && ((o < e || l > t) && (a.isText ? a = a.cut(Math.max(0, e - o), Math.min(a.text.length, t - o)) : a = a.cut(Math.max(0, e - o - 1), Math.min(a.content.size, t - o - 1))), i.push(a), r += a.nodeSize), o = l;
      }
    return new $(i, r);
  }
  /**
  @internal
  */
  cutByIndex(e, t) {
    return e == t ? $.empty : e == 0 && t == this.content.length ? this : new $(this.content.slice(e, t));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(e, t) {
    let i = this.content[e];
    if (i == t)
      return this;
    let r = this.content.slice(), s = this.size + t.nodeSize - i.nodeSize;
    return r[e] = t, new $(r, s);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(e) {
    return new $([e].concat(this.content), this.size + e.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(e) {
    return new $(this.content.concat(e), this.size + e.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let t = 0; t < this.content.length; t++)
      if (!this.content[t].eq(e.content[t]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(e) {
    let t = this.content[e];
    if (!t)
      throw new RangeError("Index " + e + " out of range for " + this);
    return t;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content[e] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    for (let t = 0, i = 0; t < this.content.length; t++) {
      let r = this.content[t];
      e(r, i, t), i += r.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(e, t = 0) {
    return Np(this, e, t);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(e, t = this.size, i = e.size) {
    return Lp(this, e, t, i);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(e, t = -1) {
    if (e == 0)
      return js(0, e);
    if (e == this.size)
      return js(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let i = 0, r = 0; ; i++) {
      let s = this.child(i), o = r + s.nodeSize;
      if (o >= e)
        return o == e || t > 0 ? js(i + 1, o) : js(i, r);
      r = o;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      return $.empty;
    if (!Array.isArray(t))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new $(t.map(e.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(e) {
    if (!e.length)
      return $.empty;
    let t, i = 0;
    for (let r = 0; r < e.length; r++) {
      let s = e[r];
      i += s.nodeSize, r && s.isText && e[r - 1].sameMarkup(s) ? (t || (t = e.slice(0, r)), t[t.length - 1] = s.withText(t[t.length - 1].text + s.text)) : t && t.push(s);
    }
    return new $(t || e, i);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(e) {
    if (!e)
      return $.empty;
    if (e instanceof $)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new $([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
$.empty = new $([], 0);
const ol = { index: 0, offset: 0 };
function js(n, e) {
  return ol.index = n, ol.offset = e, ol;
}
function Mo(n, e) {
  if (n === e)
    return !0;
  if (!(n && typeof n == "object") || !(e && typeof e == "object"))
    return !1;
  let t = Array.isArray(n);
  if (Array.isArray(e) != t)
    return !1;
  if (t) {
    if (n.length != e.length)
      return !1;
    for (let i = 0; i < n.length; i++)
      if (!Mo(n[i], e[i]))
        return !1;
  } else {
    for (let i in n)
      if (!(i in e) || !Mo(n[i], e[i]))
        return !1;
    for (let i in e)
      if (!(i in n))
        return !1;
  }
  return !0;
}
let $e = class lc {
  /**
  @internal
  */
  constructor(e, t) {
    this.type = e, this.attrs = t;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(e) {
    let t, i = !1;
    for (let r = 0; r < e.length; r++) {
      let s = e[r];
      if (this.eq(s))
        return e;
      if (this.type.excludes(s.type))
        t || (t = e.slice(0, r));
      else {
        if (s.type.excludes(this.type))
          return e;
        !i && s.type.rank > this.type.rank && (t || (t = e.slice(0, r)), t.push(this), i = !0), t && t.push(s);
      }
    }
    return t || (t = e.slice()), i || t.push(this), t;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return e.slice(0, t).concat(e.slice(t + 1));
    return e;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(e) {
    return this == e || this.type == e.type && Mo(this.attrs, e.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let i = e.marks[t.type];
    if (!i)
      throw new RangeError(`There is no mark type ${t.type} in this schema`);
    let r = i.create(t.attrs);
    return i.checkAttrs(r.attrs), r;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(e, t) {
    if (e == t)
      return !0;
    if (e.length != t.length)
      return !1;
    for (let i = 0; i < e.length; i++)
      if (!e[i].eq(t[i]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(e) {
    if (!e || Array.isArray(e) && e.length == 0)
      return lc.none;
    if (e instanceof lc)
      return [e];
    let t = e.slice();
    return t.sort((i, r) => i.type.rank - r.type.rank), t;
  }
};
$e.none = [];
class Oo extends Error {
}
class J {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(e, t, i) {
    this.content = e, this.openStart = t, this.openEnd = i;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(e, t) {
    let i = Ip(this.content, e + this.openStart, t);
    return i && new J(i, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(e, t) {
    return new J(Rp(this.content, e + this.openStart, t + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      return J.empty;
    let i = t.openStart || 0, r = t.openEnd || 0;
    if (typeof i != "number" || typeof r != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new J($.fromJSON(e, t.content), i, r);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(e, t = !0) {
    let i = 0, r = 0;
    for (let s = e.firstChild; s && !s.isLeaf && (t || !s.type.spec.isolating); s = s.firstChild)
      i++;
    for (let s = e.lastChild; s && !s.isLeaf && (t || !s.type.spec.isolating); s = s.lastChild)
      r++;
    return new J(e, i, r);
  }
}
J.empty = new J($.empty, 0, 0);
function Rp(n, e, t) {
  let { index: i, offset: r } = n.findIndex(e), s = n.maybeChild(i), { index: o, offset: a } = n.findIndex(t);
  if (r == e || s.isText) {
    if (a != t && !n.child(o).isText)
      throw new RangeError("Removing non-flat range");
    return n.cut(0, e).append(n.cut(t));
  }
  if (i != o)
    throw new RangeError("Removing non-flat range");
  return n.replaceChild(i, s.copy(Rp(s.content, e - r - 1, t - r - 1)));
}
function Ip(n, e, t, i) {
  let { index: r, offset: s } = n.findIndex(e), o = n.maybeChild(r);
  if (s == e || o.isText)
    return n.cut(0, e).append(t).append(n.cut(e));
  let a = Ip(o.content, e - s - 1, t);
  return a && n.replaceChild(r, o.copy(a));
}
function lv(n, e, t) {
  if (t.openStart > n.depth)
    throw new Oo("Inserted content deeper than insertion position");
  if (n.depth - t.openStart != e.depth - t.openEnd)
    throw new Oo("Inconsistent open depths");
  return Pp(n, e, t, 0);
}
function Pp(n, e, t, i) {
  let r = n.index(i), s = n.node(i);
  if (r == e.index(i) && i < n.depth - t.openStart) {
    let o = Pp(n, e, t, i + 1);
    return s.copy(s.content.replaceChild(r, o));
  } else if (t.content.size)
    if (!t.openStart && !t.openEnd && n.depth == i && e.depth == i) {
      let o = n.parent, a = o.content;
      return Ai(o, a.cut(0, n.parentOffset).append(t.content).append(a.cut(e.parentOffset)));
    } else {
      let { start: o, end: a } = cv(t, n);
      return Ai(s, $p(n, o, a, e, i));
    }
  else return Ai(s, No(n, e, i));
}
function Dp(n, e) {
  if (!e.type.compatibleContent(n.type))
    throw new Oo("Cannot join " + e.type.name + " onto " + n.type.name);
}
function cc(n, e, t) {
  let i = n.node(t);
  return Dp(i, e.node(t)), i;
}
function Ti(n, e) {
  let t = e.length - 1;
  t >= 0 && n.isText && n.sameMarkup(e[t]) ? e[t] = n.withText(e[t].text + n.text) : e.push(n);
}
function Xr(n, e, t, i) {
  let r = (e || n).node(t), s = 0, o = e ? e.index(t) : r.childCount;
  n && (s = n.index(t), n.depth > t ? s++ : n.textOffset && (Ti(n.nodeAfter, i), s++));
  for (let a = s; a < o; a++)
    Ti(r.child(a), i);
  e && e.depth == t && e.textOffset && Ti(e.nodeBefore, i);
}
function Ai(n, e) {
  return n.type.checkContent(e), n.copy(e);
}
function $p(n, e, t, i, r) {
  let s = n.depth > r && cc(n, e, r + 1), o = i.depth > r && cc(t, i, r + 1), a = [];
  return Xr(null, n, r, a), s && o && e.index(r) == t.index(r) ? (Dp(s, o), Ti(Ai(s, $p(n, e, t, i, r + 1)), a)) : (s && Ti(Ai(s, No(n, e, r + 1)), a), Xr(e, t, r, a), o && Ti(Ai(o, No(t, i, r + 1)), a)), Xr(i, null, r, a), new $(a);
}
function No(n, e, t) {
  let i = [];
  if (Xr(null, n, t, i), n.depth > t) {
    let r = cc(n, e, t + 1);
    Ti(Ai(r, No(n, e, t + 1)), i);
  }
  return Xr(e, null, t, i), new $(i);
}
function cv(n, e) {
  let t = e.depth - n.openStart, r = e.node(t).copy(n.content);
  for (let s = t - 1; s >= 0; s--)
    r = e.node(s).copy($.from(r));
  return {
    start: r.resolveNoCache(n.openStart + t),
    end: r.resolveNoCache(r.content.size - n.openEnd - t)
  };
}
class hs {
  /**
  @internal
  */
  constructor(e, t, i) {
    this.pos = e, this.path = t, this.parentOffset = i, this.depth = t.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(e) {
    return e == null ? this.depth : e < 0 ? this.depth + e : e;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(e) {
    return this.path[this.resolveDepth(e) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(e) {
    return this.path[this.resolveDepth(e) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(e) {
    return e = this.resolveDepth(e), this.index(e) + (e == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(e) {
    return e = this.resolveDepth(e), e == 0 ? 0 : this.path[e * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(e) {
    return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position before the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position after the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1] + this.path[e * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let e = this.parent, t = this.index(this.depth);
    if (t == e.childCount)
      return null;
    let i = this.pos - this.path[this.path.length - 1], r = e.child(t);
    return i ? e.child(t).cut(i) : r;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let e = this.index(this.depth), t = this.pos - this.path[this.path.length - 1];
    return t ? this.parent.child(e).cut(0, t) : e == 0 ? null : this.parent.child(e - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(e, t) {
    t = this.resolveDepth(t);
    let i = this.path[t * 3], r = t == 0 ? 0 : this.path[t * 3 - 1] + 1;
    for (let s = 0; s < e; s++)
      r += i.child(s).nodeSize;
    return r;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let e = this.parent, t = this.index();
    if (e.content.size == 0)
      return $e.none;
    if (this.textOffset)
      return e.child(t).marks;
    let i = e.maybeChild(t - 1), r = e.maybeChild(t);
    if (!i) {
      let a = i;
      i = r, r = a;
    }
    let s = i.marks;
    for (var o = 0; o < s.length; o++)
      s[o].type.spec.inclusive === !1 && (!r || !s[o].isInSet(r.marks)) && (s = s[o--].removeFromSet(s));
    return s;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(e) {
    let t = this.parent.maybeChild(this.index());
    if (!t || !t.isInline)
      return null;
    let i = t.marks, r = e.parent.maybeChild(e.index());
    for (var s = 0; s < i.length; s++)
      i[s].type.spec.inclusive === !1 && (!r || !i[s].isInSet(r.marks)) && (i = i[s--].removeFromSet(i));
    return i;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(e) {
    for (let t = this.depth; t > 0; t--)
      if (this.start(t) <= e && this.end(t) >= e)
        return t;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(e = this, t) {
    if (e.pos < this.pos)
      return e.blockRange(this);
    for (let i = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); i >= 0; i--)
      if (e.pos <= this.end(i) && (!t || t(this.node(i))))
        return new Lo(this, e, i);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(e) {
    return this.pos - this.parentOffset == e.pos - e.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(e) {
    return e.pos > this.pos ? e : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(e) {
    return e.pos < this.pos ? e : this;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let t = 1; t <= this.depth; t++)
      e += (e ? "/" : "") + this.node(t).type.name + "_" + this.index(t - 1);
    return e + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(e, t) {
    if (!(t >= 0 && t <= e.content.size))
      throw new RangeError("Position " + t + " out of range");
    let i = [], r = 0, s = t;
    for (let o = e; ; ) {
      let { index: a, offset: l } = o.content.findIndex(s), c = s - l;
      if (i.push(o, a, r + l), !c || (o = o.child(a), o.isText))
        break;
      s = c - 1, r += l + 1;
    }
    return new hs(t, i, s);
  }
  /**
  @internal
  */
  static resolveCached(e, t) {
    let i = $d.get(e);
    if (i)
      for (let s = 0; s < i.elts.length; s++) {
        let o = i.elts[s];
        if (o.pos == t)
          return o;
      }
    else
      $d.set(e, i = new uv());
    let r = i.elts[i.i] = hs.resolve(e, t);
    return i.i = (i.i + 1) % dv, r;
  }
}
class uv {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const dv = 12, $d = /* @__PURE__ */ new WeakMap();
class Lo {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(e, t, i) {
    this.$from = e, this.$to = t, this.depth = i;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const hv = /* @__PURE__ */ Object.create(null);
let On = class uc {
  /**
  @internal
  */
  constructor(e, t, i, r = $e.none) {
    this.type = e, this.attrs = t, this.marks = r, this.content = i || $.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(e) {
    return this.content.child(e);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content.maybeChild(e);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    this.content.forEach(e);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(e, t, i, r = 0) {
    this.content.nodesBetween(e, t, i, r, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(e) {
    this.nodesBetween(0, this.content.size, e);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
  */
  textBetween(e, t, i, r) {
    return this.content.textBetween(e, t, i, r);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(e) {
    return this == e || this.sameMarkup(e) && this.content.eq(e.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(e) {
    return this.hasMarkup(e.type, e.attrs, e.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(e, t, i) {
    return this.type == e && Mo(this.attrs, t || e.defaultAttrs || hv) && $e.sameSet(this.marks, i || $e.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(e = null) {
    return e == this.content ? this : new uc(this.type, this.attrs, e, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(e) {
    return e == this.marks ? this : new uc(this.type, this.attrs, this.content, e);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(e, t = this.content.size) {
    return e == 0 && t == this.content.size ? this : this.copy(this.content.cut(e, t));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(e, t = this.content.size, i = !1) {
    if (e == t)
      return J.empty;
    let r = this.resolve(e), s = this.resolve(t), o = i ? 0 : r.sharedDepth(t), a = r.start(o), c = r.node(o).content.cut(r.pos - a, s.pos - a);
    return new J(c, r.depth - o, s.depth - o);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(e, t, i) {
    return lv(this.resolve(e), this.resolve(t), i);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(e) {
    for (let t = this; ; ) {
      let { index: i, offset: r } = t.content.findIndex(e);
      if (t = t.maybeChild(i), !t)
        return null;
      if (r == e || t.isText)
        return t;
      e -= r + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(e) {
    let { index: t, offset: i } = this.content.findIndex(e);
    return { node: this.content.maybeChild(t), index: t, offset: i };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(e) {
    if (e == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: t, offset: i } = this.content.findIndex(e);
    if (i < e)
      return { node: this.content.child(t), index: t, offset: i };
    let r = this.content.child(t - 1);
    return { node: r, index: t - 1, offset: i - r.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(e) {
    return hs.resolveCached(this, e);
  }
  /**
  @internal
  */
  resolveNoCache(e) {
    return hs.resolve(this, e);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(e, t, i) {
    let r = !1;
    return t > e && this.nodesBetween(e, t, (s) => (i.isInSet(s.marks) && (r = !0), !r)), r;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let e = this.type.name;
    return this.content.size && (e += "(" + this.content.toStringInner() + ")"), zp(this.marks, e);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(e) {
    let t = this.type.contentMatch.matchFragment(this.content, 0, e);
    if (!t)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return t;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(e, t, i = $.empty, r = 0, s = i.childCount) {
    let o = this.contentMatchAt(e).matchFragment(i, r, s), a = o && o.matchFragment(this.content, t);
    if (!a || !a.validEnd)
      return !1;
    for (let l = r; l < s; l++)
      if (!this.type.allowsMarks(i.child(l).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(e, t, i, r) {
    if (r && !this.type.allowsMarks(r))
      return !1;
    let s = this.contentMatchAt(e).matchType(i), o = s && s.matchFragment(this.content, t);
    return o ? o.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(e) {
    return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let e = $e.none;
    for (let t = 0; t < this.marks.length; t++) {
      let i = this.marks[t];
      i.type.checkAttrs(i.attrs), e = i.addToSet(e);
    }
    if (!$e.sameSet(e, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((t) => t.type.name)}`);
    this.content.forEach((t) => t.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map((t) => t.toJSON())), e;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Node.fromJSON");
    let i;
    if (t.marks) {
      if (!Array.isArray(t.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      i = t.marks.map(e.markFromJSON);
    }
    if (t.type == "text") {
      if (typeof t.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return e.text(t.text, i);
    }
    let r = $.fromJSON(e, t.content), s = e.nodeType(t.type).create(t.attrs, r, i);
    return s.type.checkAttrs(s.attrs), s;
  }
};
On.prototype.text = void 0;
class Ro extends On {
  /**
  @internal
  */
  constructor(e, t, i, r) {
    if (super(e, t, null, r), !i)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = i;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : zp(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(e, t) {
    return this.text.slice(e, t);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(e) {
    return e == this.marks ? this : new Ro(this.type, this.attrs, this.text, e);
  }
  withText(e) {
    return e == this.text ? this : new Ro(this.type, this.attrs, e, this.marks);
  }
  cut(e = 0, t = this.text.length) {
    return e == 0 && t == this.text.length ? this : this.withText(this.text.slice(e, t));
  }
  eq(e) {
    return this.sameMarkup(e) && this.text == e.text;
  }
  toJSON() {
    let e = super.toJSON();
    return e.text = this.text, e;
  }
}
function zp(n, e) {
  for (let t = n.length - 1; t >= 0; t--)
    e = n[t].type.name + "(" + e + ")";
  return e;
}
class Li {
  /**
  @internal
  */
  constructor(e) {
    this.validEnd = e, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(e, t) {
    let i = new fv(e, t);
    if (i.next == null)
      return Li.empty;
    let r = Hp(i);
    i.next && i.err("Unexpected trailing text");
    let s = yv(vv(r));
    return xv(s, i), s;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(e) {
    for (let t = 0; t < this.next.length; t++)
      if (this.next[t].type == e)
        return this.next[t].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(e, t = 0, i = e.childCount) {
    let r = this;
    for (let s = t; r && s < i; s++)
      r = r.matchType(e.child(s).type);
    return r;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let e = 0; e < this.next.length; e++) {
      let { type: t } = this.next[e];
      if (!(t.isText || t.hasRequiredAttrs()))
        return t;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(e) {
    for (let t = 0; t < this.next.length; t++)
      for (let i = 0; i < e.next.length; i++)
        if (this.next[t].type == e.next[i].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(e, t = !1, i = 0) {
    let r = [this];
    function s(o, a) {
      let l = o.matchFragment(e, i);
      if (l && (!t || l.validEnd))
        return $.from(a.map((c) => c.createAndFill()));
      for (let c = 0; c < o.next.length; c++) {
        let { type: u, next: d } = o.next[c];
        if (!(u.isText || u.hasRequiredAttrs()) && r.indexOf(d) == -1) {
          r.push(d);
          let h = s(d, a.concat(u));
          if (h)
            return h;
        }
      }
      return null;
    }
    return s(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(e) {
    for (let i = 0; i < this.wrapCache.length; i += 2)
      if (this.wrapCache[i] == e)
        return this.wrapCache[i + 1];
    let t = this.computeWrapping(e);
    return this.wrapCache.push(e, t), t;
  }
  /**
  @internal
  */
  computeWrapping(e) {
    let t = /* @__PURE__ */ Object.create(null), i = [{ match: this, type: null, via: null }];
    for (; i.length; ) {
      let r = i.shift(), s = r.match;
      if (s.matchType(e)) {
        let o = [];
        for (let a = r; a.type; a = a.via)
          o.push(a.type);
        return o.reverse();
      }
      for (let o = 0; o < s.next.length; o++) {
        let { type: a, next: l } = s.next[o];
        !a.isLeaf && !a.hasRequiredAttrs() && !(a.name in t) && (!r.type || l.validEnd) && (i.push({ match: a.contentMatch, type: a, via: r }), t[a.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(e) {
    if (e >= this.next.length)
      throw new RangeError(`There's no ${e}th edge in this content match`);
    return this.next[e];
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    function t(i) {
      e.push(i);
      for (let r = 0; r < i.next.length; r++)
        e.indexOf(i.next[r].next) == -1 && t(i.next[r].next);
    }
    return t(this), e.map((i, r) => {
      let s = r + (i.validEnd ? "*" : " ") + " ";
      for (let o = 0; o < i.next.length; o++)
        s += (o ? ", " : "") + i.next[o].type.name + "->" + e.indexOf(i.next[o].next);
      return s;
    }).join(`
`);
  }
}
Li.empty = new Li(!0);
class fv {
  constructor(e, t) {
    this.string = e, this.nodeTypes = t, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(e) {
    return this.next == e && (this.pos++ || !0);
  }
  err(e) {
    throw new SyntaxError(e + " (in content expression '" + this.string + "')");
  }
}
function Hp(n) {
  let e = [];
  do
    e.push(pv(n));
  while (n.eat("|"));
  return e.length == 1 ? e[0] : { type: "choice", exprs: e };
}
function pv(n) {
  let e = [];
  do
    e.push(mv(n));
  while (n.next && n.next != ")" && n.next != "|");
  return e.length == 1 ? e[0] : { type: "seq", exprs: e };
}
function mv(n) {
  let e = bv(n);
  for (; ; )
    if (n.eat("+"))
      e = { type: "plus", expr: e };
    else if (n.eat("*"))
      e = { type: "star", expr: e };
    else if (n.eat("?"))
      e = { type: "opt", expr: e };
    else if (n.eat("{"))
      e = gv(n, e);
    else
      break;
  return e;
}
function zd(n) {
  /\D/.test(n.next) && n.err("Expected number, got '" + n.next + "'");
  let e = Number(n.next);
  return n.pos++, e;
}
function gv(n, e) {
  let t = zd(n), i = t;
  return n.eat(",") && (n.next != "}" ? i = zd(n) : i = -1), n.eat("}") || n.err("Unclosed braced range"), { type: "range", min: t, max: i, expr: e };
}
function _v(n, e) {
  let t = n.nodeTypes, i = t[e];
  if (i)
    return [i];
  let r = [];
  for (let s in t) {
    let o = t[s];
    o.isInGroup(e) && r.push(o);
  }
  return r.length == 0 && n.err("No node type or group '" + e + "' found"), r;
}
function bv(n) {
  if (n.eat("(")) {
    let e = Hp(n);
    return n.eat(")") || n.err("Missing closing paren"), e;
  } else if (/\W/.test(n.next))
    n.err("Unexpected token '" + n.next + "'");
  else {
    let e = _v(n, n.next).map((t) => (n.inline == null ? n.inline = t.isInline : n.inline != t.isInline && n.err("Mixing inline and block content"), { type: "name", value: t }));
    return n.pos++, e.length == 1 ? e[0] : { type: "choice", exprs: e };
  }
}
function vv(n) {
  let e = [[]];
  return r(s(n, 0), t()), e;
  function t() {
    return e.push([]) - 1;
  }
  function i(o, a, l) {
    let c = { term: l, to: a };
    return e[o].push(c), c;
  }
  function r(o, a) {
    o.forEach((l) => l.to = a);
  }
  function s(o, a) {
    if (o.type == "choice")
      return o.exprs.reduce((l, c) => l.concat(s(c, a)), []);
    if (o.type == "seq")
      for (let l = 0; ; l++) {
        let c = s(o.exprs[l], a);
        if (l == o.exprs.length - 1)
          return c;
        r(c, a = t());
      }
    else if (o.type == "star") {
      let l = t();
      return i(a, l), r(s(o.expr, l), l), [i(l)];
    } else if (o.type == "plus") {
      let l = t();
      return r(s(o.expr, a), l), r(s(o.expr, l), l), [i(l)];
    } else {
      if (o.type == "opt")
        return [i(a)].concat(s(o.expr, a));
      if (o.type == "range") {
        let l = a;
        for (let c = 0; c < o.min; c++) {
          let u = t();
          r(s(o.expr, l), u), l = u;
        }
        if (o.max == -1)
          r(s(o.expr, l), l);
        else
          for (let c = o.min; c < o.max; c++) {
            let u = t();
            i(l, u), r(s(o.expr, l), u), l = u;
          }
        return [i(l)];
      } else {
        if (o.type == "name")
          return [i(a, void 0, o.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function Bp(n, e) {
  return e - n;
}
function Hd(n, e) {
  let t = [];
  return i(e), t.sort(Bp);
  function i(r) {
    let s = n[r];
    if (s.length == 1 && !s[0].term)
      return i(s[0].to);
    t.push(r);
    for (let o = 0; o < s.length; o++) {
      let { term: a, to: l } = s[o];
      !a && t.indexOf(l) == -1 && i(l);
    }
  }
}
function yv(n) {
  let e = /* @__PURE__ */ Object.create(null);
  return t(Hd(n, 0));
  function t(i) {
    let r = [];
    i.forEach((o) => {
      n[o].forEach(({ term: a, to: l }) => {
        if (!a)
          return;
        let c;
        for (let u = 0; u < r.length; u++)
          r[u][0] == a && (c = r[u][1]);
        Hd(n, l).forEach((u) => {
          c || r.push([a, c = []]), c.indexOf(u) == -1 && c.push(u);
        });
      });
    });
    let s = e[i.join(",")] = new Li(i.indexOf(n.length - 1) > -1);
    for (let o = 0; o < r.length; o++) {
      let a = r[o][1].sort(Bp);
      s.next.push({ type: r[o][0], next: e[a.join(",")] || t(a) });
    }
    return s;
  }
}
function xv(n, e) {
  for (let t = 0, i = [n]; t < i.length; t++) {
    let r = i[t], s = !r.validEnd, o = [];
    for (let a = 0; a < r.next.length; a++) {
      let { type: l, next: c } = r.next[a];
      o.push(l.name), s && !(l.isText || l.hasRequiredAttrs()) && (s = !1), i.indexOf(c) == -1 && i.push(c);
    }
    s && e.err("Only non-generatable nodes (" + o.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function Fp(n) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in n) {
    let i = n[t];
    if (!i.hasDefault)
      return null;
    e[t] = i.default;
  }
  return e;
}
function Vp(n, e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let i in n) {
    let r = e && e[i];
    if (r === void 0) {
      let s = n[i];
      if (s.hasDefault)
        r = s.default;
      else
        throw new RangeError("No value supplied for attribute " + i);
    }
    t[i] = r;
  }
  return t;
}
function jp(n, e, t, i) {
  for (let r in e)
    if (!(r in n))
      throw new RangeError(`Unsupported attribute ${r} for ${t} of type ${r}`);
  for (let r in n) {
    let s = n[r];
    s.validate && s.validate(e[r]);
  }
}
function Wp(n, e) {
  let t = /* @__PURE__ */ Object.create(null);
  if (e)
    for (let i in e)
      t[i] = new kv(n, i, e[i]);
  return t;
}
let Bd = class Up {
  /**
  @internal
  */
  constructor(e, t, i) {
    this.name = e, this.schema = t, this.spec = i, this.markSet = null, this.groups = i.group ? i.group.split(" ") : [], this.attrs = Wp(e, i.attrs), this.defaultAttrs = Fp(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(i.inline || e == "text"), this.isText = e == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == Li.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(e) {
    return this.groups.indexOf(e) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let e in this.attrs)
      if (this.attrs[e].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(e) {
    return this == e || this.contentMatch.compatible(e.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(e) {
    return !e && this.defaultAttrs ? this.defaultAttrs : Vp(this.attrs, e);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(e = null, t, i) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new On(this, this.computeAttrs(e), $.from(t), $e.setFrom(i));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(e = null, t, i) {
    return t = $.from(t), this.checkContent(t), new On(this, this.computeAttrs(e), t, $e.setFrom(i));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(e = null, t, i) {
    if (e = this.computeAttrs(e), t = $.from(t), t.size) {
      let o = this.contentMatch.fillBefore(t);
      if (!o)
        return null;
      t = o.append(t);
    }
    let r = this.contentMatch.matchFragment(t), s = r && r.fillBefore($.empty, !0);
    return s ? new On(this, e, t.append(s), $e.setFrom(i)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(e) {
    let t = this.contentMatch.matchFragment(e);
    if (!t || !t.validEnd)
      return !1;
    for (let i = 0; i < e.childCount; i++)
      if (!this.allowsMarks(e.child(i).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(e) {
    if (!this.validContent(e))
      throw new RangeError(`Invalid content for node ${this.name}: ${e.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(e) {
    jp(this.attrs, e, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(e) {
    return this.markSet == null || this.markSet.indexOf(e) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(e) {
    if (this.markSet == null)
      return !0;
    for (let t = 0; t < e.length; t++)
      if (!this.allowsMarkType(e[t].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(e) {
    if (this.markSet == null)
      return e;
    let t;
    for (let i = 0; i < e.length; i++)
      this.allowsMarkType(e[i].type) ? t && t.push(e[i]) : t || (t = e.slice(0, i));
    return t ? t.length ? t : $e.none : e;
  }
  /**
  @internal
  */
  static compile(e, t) {
    let i = /* @__PURE__ */ Object.create(null);
    e.forEach((s, o) => i[s] = new Up(s, t, o));
    let r = t.spec.topNode || "doc";
    if (!i[r])
      throw new RangeError("Schema is missing its top node type ('" + r + "')");
    if (!i.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let s in i.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return i;
  }
};
function wv(n, e, t) {
  let i = t.split("|");
  return (r) => {
    let s = r === null ? "null" : typeof r;
    if (i.indexOf(s) < 0)
      throw new RangeError(`Expected value of type ${i} for attribute ${e} on type ${n}, got ${s}`);
  };
}
class kv {
  constructor(e, t, i) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(i, "default"), this.default = i.default, this.validate = typeof i.validate == "string" ? wv(e, t, i.validate) : i.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class Sa {
  /**
  @internal
  */
  constructor(e, t, i, r) {
    this.name = e, this.rank = t, this.schema = i, this.spec = r, this.attrs = Wp(e, r.attrs), this.excluded = null;
    let s = Fp(this.attrs);
    this.instance = s ? new $e(this, s) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(e = null) {
    return !e && this.instance ? this.instance : new $e(this, Vp(this.attrs, e));
  }
  /**
  @internal
  */
  static compile(e, t) {
    let i = /* @__PURE__ */ Object.create(null), r = 0;
    return e.forEach((s, o) => i[s] = new Sa(s, r++, t, o)), i;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(e) {
    for (var t = 0; t < e.length; t++)
      e[t].type == this && (e = e.slice(0, t).concat(e.slice(t + 1)), t--);
    return e;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (e[t].type == this)
        return e[t];
  }
  /**
  @internal
  */
  checkAttrs(e) {
    jp(this.attrs, e, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(e) {
    return this.excluded.indexOf(e) > -1;
  }
}
class Kp {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(e) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let t = this.spec = {};
    for (let r in e)
      t[r] = e[r];
    t.nodes = xt.from(e.nodes), t.marks = xt.from(e.marks || {}), this.nodes = Bd.compile(this.spec.nodes, this), this.marks = Sa.compile(this.spec.marks, this);
    let i = /* @__PURE__ */ Object.create(null);
    for (let r in this.nodes) {
      if (r in this.marks)
        throw new RangeError(r + " can not be both a node and a mark");
      let s = this.nodes[r], o = s.spec.content || "", a = s.spec.marks;
      if (s.contentMatch = i[o] || (i[o] = Li.parse(o, this.nodes)), s.inlineContent = s.contentMatch.inlineContent, s.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!s.isInline || !s.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = s;
      }
      s.markSet = a == "_" ? null : a ? Fd(this, a.split(" ")) : a == "" || !s.inlineContent ? [] : null;
    }
    for (let r in this.marks) {
      let s = this.marks[r], o = s.spec.excludes;
      s.excluded = o == null ? [s] : o == "" ? [] : Fd(this, o.split(" "));
    }
    this.nodeFromJSON = this.nodeFromJSON.bind(this), this.markFromJSON = this.markFromJSON.bind(this), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(e, t = null, i, r) {
    if (typeof e == "string")
      e = this.nodeType(e);
    else if (e instanceof Bd) {
      if (e.schema != this)
        throw new RangeError("Node type from different schema used (" + e.name + ")");
    } else throw new RangeError("Invalid node type: " + e);
    return e.createChecked(t, i, r);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(e, t) {
    let i = this.nodes.text;
    return new Ro(i, i.defaultAttrs, e, $e.setFrom(t));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(e, t) {
    return typeof e == "string" && (e = this.marks[e]), e.create(t);
  }
  /**
  Deserialize a node from its JSON representation. This method is
  bound.
  */
  nodeFromJSON(e) {
    return On.fromJSON(this, e);
  }
  /**
  Deserialize a mark from its JSON representation. This method is
  bound.
  */
  markFromJSON(e) {
    return $e.fromJSON(this, e);
  }
  /**
  @internal
  */
  nodeType(e) {
    let t = this.nodes[e];
    if (!t)
      throw new RangeError("Unknown node type: " + e);
    return t;
  }
}
function Fd(n, e) {
  let t = [];
  for (let i = 0; i < e.length; i++) {
    let r = e[i], s = n.marks[r], o = s;
    if (s)
      t.push(s);
    else
      for (let a in n.marks) {
        let l = n.marks[a];
        (r == "_" || l.spec.group && l.spec.group.split(" ").indexOf(r) > -1) && t.push(o = l);
      }
    if (!o)
      throw new SyntaxError("Unknown mark type: '" + e[i] + "'");
  }
  return t;
}
function Sv(n) {
  return n.tag != null;
}
function Ev(n) {
  return n.style != null;
}
let ir = class dc {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(e, t) {
    this.schema = e, this.rules = t, this.tags = [], this.styles = [];
    let i = this.matchedStyles = [];
    t.forEach((r) => {
      if (Sv(r))
        this.tags.push(r);
      else if (Ev(r)) {
        let s = /[^=]*/.exec(r.style)[0];
        i.indexOf(s) < 0 && i.push(s), this.styles.push(r);
      }
    }), this.normalizeLists = !this.tags.some((r) => {
      if (!/^(ul|ol)\b/.test(r.tag) || !r.node)
        return !1;
      let s = e.nodes[r.node];
      return s.contentMatch.matchType(s);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(e, t = {}) {
    let i = new jd(this, t, !1);
    return i.addAll(e, $e.none, t.from, t.to), i.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(e, t = {}) {
    let i = new jd(this, t, !0);
    return i.addAll(e, $e.none, t.from, t.to), J.maxOpen(i.finish());
  }
  /**
  @internal
  */
  matchTag(e, t, i) {
    for (let r = i ? this.tags.indexOf(i) + 1 : 0; r < this.tags.length; r++) {
      let s = this.tags[r];
      if (Av(e, s.tag) && (s.namespace === void 0 || e.namespaceURI == s.namespace) && (!s.context || t.matchesContext(s.context))) {
        if (s.getAttrs) {
          let o = s.getAttrs(e);
          if (o === !1)
            continue;
          s.attrs = o || void 0;
        }
        return s;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(e, t, i, r) {
    for (let s = r ? this.styles.indexOf(r) + 1 : 0; s < this.styles.length; s++) {
      let o = this.styles[s], a = o.style;
      if (!(a.indexOf(e) != 0 || o.context && !i.matchesContext(o.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      a.length > e.length && (a.charCodeAt(e.length) != 61 || a.slice(e.length + 1) != t))) {
        if (o.getAttrs) {
          let l = o.getAttrs(t);
          if (l === !1)
            continue;
          o.attrs = l || void 0;
        }
        return o;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(e) {
    let t = [];
    function i(r) {
      let s = r.priority == null ? 50 : r.priority, o = 0;
      for (; o < t.length; o++) {
        let a = t[o];
        if ((a.priority == null ? 50 : a.priority) < s)
          break;
      }
      t.splice(o, 0, r);
    }
    for (let r in e.marks) {
      let s = e.marks[r].spec.parseDOM;
      s && s.forEach((o) => {
        i(o = Wd(o)), o.mark || o.ignore || o.clearMark || (o.mark = r);
      });
    }
    for (let r in e.nodes) {
      let s = e.nodes[r].spec.parseDOM;
      s && s.forEach((o) => {
        i(o = Wd(o)), o.node || o.ignore || o.mark || (o.node = r);
      });
    }
    return t;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
  */
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new dc(e, dc.schemaRules(e)));
  }
};
const qp = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, Cv = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, Gp = { ol: !0, ul: !0 }, fs = 1, hc = 2, Yr = 4;
function Vd(n, e, t) {
  return e != null ? (e ? fs : 0) | (e === "full" ? hc : 0) : n && n.whitespace == "pre" ? fs | hc : t & ~Yr;
}
class Ws {
  constructor(e, t, i, r, s, o) {
    this.type = e, this.attrs = t, this.marks = i, this.solid = r, this.options = o, this.content = [], this.activeMarks = $e.none, this.match = s || (o & Yr ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type)
        return [];
      let t = this.type.contentMatch.fillBefore($.from(e));
      if (t)
        this.match = this.type.contentMatch.matchFragment(t);
      else {
        let i = this.type.contentMatch, r;
        return (r = i.findWrapping(e.type)) ? (this.match = i, r) : null;
      }
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(this.options & fs)) {
      let i = this.content[this.content.length - 1], r;
      if (i && i.isText && (r = /[ \t\r\n\u000c]+$/.exec(i.text))) {
        let s = i;
        i.text.length == r[0].length ? this.content.pop() : this.content[this.content.length - 1] = s.withText(s.text.slice(0, s.text.length - r[0].length));
      }
    }
    let t = $.from(this.content);
    return !e && this.match && (t = t.append(this.match.fillBefore($.empty, !0))), this.type ? this.type.create(this.attrs, t, this.marks) : t;
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !qp.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
class jd {
  constructor(e, t, i) {
    this.parser = e, this.options = t, this.isOpen = i, this.open = 0, this.localPreserveWS = !1;
    let r = t.topNode, s, o = Vd(null, t.preserveWhitespace, 0) | (i ? Yr : 0);
    r ? s = new Ws(r.type, r.attrs, $e.none, !0, t.topMatch || r.type.contentMatch, o) : i ? s = new Ws(null, null, $e.none, !0, null, o) : s = new Ws(e.schema.topNodeType, null, $e.none, !0, null, o), this.nodes = [s], this.find = t.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(e, t) {
    e.nodeType == 3 ? this.addTextNode(e, t) : e.nodeType == 1 && this.addElement(e, t);
  }
  addTextNode(e, t) {
    let i = e.nodeValue, r = this.top, s = r.options & hc ? "full" : this.localPreserveWS || (r.options & fs) > 0;
    if (s === "full" || r.inlineContext(e) || /[^ \t\r\n\u000c]/.test(i)) {
      if (s)
        s !== "full" ? i = i.replace(/\r?\n|\r/g, " ") : i = i.replace(/\r\n?/g, `
`);
      else if (i = i.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(i) && this.open == this.nodes.length - 1) {
        let o = r.content[r.content.length - 1], a = e.previousSibling;
        (!o || a && a.nodeName == "BR" || o.isText && /[ \t\r\n\u000c]$/.test(o.text)) && (i = i.slice(1));
      }
      i && this.insertNode(this.parser.schema.text(i), t), this.findInText(e);
    } else
      this.findInside(e);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(e, t, i) {
    let r = this.localPreserveWS, s = this.top;
    (e.tagName == "PRE" || /pre/.test(e.style && e.style.whiteSpace)) && (this.localPreserveWS = !0);
    let o = e.nodeName.toLowerCase(), a;
    Gp.hasOwnProperty(o) && this.parser.normalizeLists && Tv(e);
    let l = this.options.ruleFromNode && this.options.ruleFromNode(e) || (a = this.parser.matchTag(e, this, i));
    e: if (l ? l.ignore : Cv.hasOwnProperty(o))
      this.findInside(e), this.ignoreFallback(e, t);
    else if (!l || l.skip || l.closeParent) {
      l && l.closeParent ? this.open = Math.max(0, this.open - 1) : l && l.skip.nodeType && (e = l.skip);
      let c, u = this.needsBlock;
      if (qp.hasOwnProperty(o))
        s.content.length && s.content[0].isInline && this.open && (this.open--, s = this.top), c = !0, s.type || (this.needsBlock = !0);
      else if (!e.firstChild) {
        this.leafFallback(e, t);
        break e;
      }
      let d = l && l.skip ? t : this.readStyles(e, t);
      d && this.addAll(e, d), c && this.sync(s), this.needsBlock = u;
    } else {
      let c = this.readStyles(e, t);
      c && this.addElementByRule(e, l, c, l.consuming === !1 ? a : void 0);
    }
    this.localPreserveWS = r;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(e, t) {
    e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`), t);
  }
  // Called for ignored nodes
  ignoreFallback(e, t) {
    e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), t);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(e, t) {
    let i = e.style;
    if (i && i.length)
      for (let r = 0; r < this.parser.matchedStyles.length; r++) {
        let s = this.parser.matchedStyles[r], o = i.getPropertyValue(s);
        if (o)
          for (let a = void 0; ; ) {
            let l = this.parser.matchStyle(s, o, this, a);
            if (!l)
              break;
            if (l.ignore)
              return null;
            if (l.clearMark ? t = t.filter((c) => !l.clearMark(c)) : t = t.concat(this.parser.schema.marks[l.mark].create(l.attrs)), l.consuming === !1)
              a = l;
            else
              break;
          }
      }
    return t;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(e, t, i, r) {
    let s, o;
    if (t.node)
      if (o = this.parser.schema.nodes[t.node], o.isLeaf)
        this.insertNode(o.create(t.attrs), i) || this.leafFallback(e, i);
      else {
        let l = this.enter(o, t.attrs || null, i, t.preserveWhitespace);
        l && (s = !0, i = l);
      }
    else {
      let l = this.parser.schema.marks[t.mark];
      i = i.concat(l.create(t.attrs));
    }
    let a = this.top;
    if (o && o.isLeaf)
      this.findInside(e);
    else if (r)
      this.addElement(e, i, r);
    else if (t.getContent)
      this.findInside(e), t.getContent(e, this.parser.schema).forEach((l) => this.insertNode(l, i));
    else {
      let l = e;
      typeof t.contentElement == "string" ? l = e.querySelector(t.contentElement) : typeof t.contentElement == "function" ? l = t.contentElement(e) : t.contentElement && (l = t.contentElement), this.findAround(e, l, !0), this.addAll(l, i), this.findAround(e, l, !1);
    }
    s && this.sync(a) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(e, t, i, r) {
    let s = i || 0;
    for (let o = i ? e.childNodes[i] : e.firstChild, a = r == null ? null : e.childNodes[r]; o != a; o = o.nextSibling, ++s)
      this.findAtPoint(e, s), this.addDOM(o, t);
    this.findAtPoint(e, s);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(e, t) {
    let i, r;
    for (let s = this.open; s >= 0; s--) {
      let o = this.nodes[s], a = o.findWrapping(e);
      if (a && (!i || i.length > a.length) && (i = a, r = o, !a.length) || o.solid)
        break;
    }
    if (!i)
      return null;
    this.sync(r);
    for (let s = 0; s < i.length; s++)
      t = this.enterInner(i[s], null, t, !1);
    return t;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(e, t) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let r = this.textblockFromContext();
      r && (t = this.enterInner(r, null, t));
    }
    let i = this.findPlace(e, t);
    if (i) {
      this.closeExtra();
      let r = this.top;
      r.match && (r.match = r.match.matchType(e.type));
      let s = $e.none;
      for (let o of i.concat(e.marks))
        (r.type ? r.type.allowsMarkType(o.type) : Ud(o.type, e.type)) && (s = o.addToSet(s));
      return r.content.push(e.mark(s)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(e, t, i, r) {
    let s = this.findPlace(e.create(t), i);
    return s && (s = this.enterInner(e, t, i, !0, r)), s;
  }
  // Open a node of the given type
  enterInner(e, t, i, r = !1, s) {
    this.closeExtra();
    let o = this.top;
    o.match = o.match && o.match.matchType(e);
    let a = Vd(e, s, o.options);
    o.options & Yr && o.content.length == 0 && (a |= Yr);
    let l = $e.none;
    return i = i.filter((c) => (o.type ? o.type.allowsMarkType(c.type) : Ud(c.type, e)) ? (l = c.addToSet(l), !1) : !0), this.nodes.push(new Ws(e, t, l, r, null, a)), this.open++, i;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(e = !1) {
    let t = this.nodes.length - 1;
    if (t > this.open) {
      for (; t > this.open; t--)
        this.nodes[t - 1].content.push(this.nodes[t].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(e) {
    for (let t = this.open; t >= 0; t--) {
      if (this.nodes[t] == e)
        return this.open = t, !0;
      this.localPreserveWS && (this.nodes[t].options |= fs);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let t = this.open; t >= 0; t--) {
      let i = this.nodes[t].content;
      for (let r = i.length - 1; r >= 0; r--)
        e += i[r].nodeSize;
      t && e++;
    }
    return e;
  }
  findAtPoint(e, t) {
    if (this.find)
      for (let i = 0; i < this.find.length; i++)
        this.find[i].node == e && this.find[i].offset == t && (this.find[i].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].pos == null && e.nodeType == 1 && e.contains(this.find[t].node) && (this.find[t].pos = this.currentPos);
  }
  findAround(e, t, i) {
    if (e != t && this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].pos == null && e.nodeType == 1 && e.contains(this.find[r].node) && t.compareDocumentPosition(this.find[r].node) & (i ? 2 : 4) && (this.find[r].pos = this.currentPos);
  }
  findInText(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].node == e && (this.find[t].pos = this.currentPos - (e.nodeValue.length - this.find[t].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(e) {
    if (e.indexOf("|") > -1)
      return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let t = e.split("/"), i = this.options.context, r = !this.isOpen && (!i || i.parent.type == this.nodes[0].type), s = -(i ? i.depth + 1 : 0) + (r ? 0 : 1), o = (a, l) => {
      for (; a >= 0; a--) {
        let c = t[a];
        if (c == "") {
          if (a == t.length - 1 || a == 0)
            continue;
          for (; l >= s; l--)
            if (o(a - 1, l))
              return !0;
          return !1;
        } else {
          let u = l > 0 || l == 0 && r ? this.nodes[l].type : i && l >= s ? i.node(l - s).type : null;
          if (!u || u.name != c && !u.isInGroup(c))
            return !1;
          l--;
        }
      }
      return !0;
    };
    return o(t.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e)
      for (let t = e.depth; t >= 0; t--) {
        let i = e.node(t).contentMatchAt(e.indexAfter(t)).defaultType;
        if (i && i.isTextblock && i.defaultAttrs)
          return i;
      }
    for (let t in this.parser.schema.nodes) {
      let i = this.parser.schema.nodes[t];
      if (i.isTextblock && i.defaultAttrs)
        return i;
    }
  }
}
function Tv(n) {
  for (let e = n.firstChild, t = null; e; e = e.nextSibling) {
    let i = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    i && Gp.hasOwnProperty(i) && t ? (t.appendChild(e), e = t) : i == "li" ? t = e : i && (t = null);
  }
}
function Av(n, e) {
  return (n.matches || n.msMatchesSelector || n.webkitMatchesSelector || n.mozMatchesSelector).call(n, e);
}
function Wd(n) {
  let e = {};
  for (let t in n)
    e[t] = n[t];
  return e;
}
function Ud(n, e) {
  let t = e.schema.nodes;
  for (let i in t) {
    let r = t[i];
    if (!r.allowsMarkType(n))
      continue;
    let s = [], o = (a) => {
      s.push(a);
      for (let l = 0; l < a.edgeCount; l++) {
        let { type: c, next: u } = a.edge(l);
        if (c == e || s.indexOf(u) < 0 && o(u))
          return !0;
      }
    };
    if (o(r.contentMatch))
      return !0;
  }
}
class zi {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(e, t) {
    this.nodes = e, this.marks = t;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(e, t = {}, i) {
    i || (i = al(t).createDocumentFragment());
    let r = i, s = [];
    return e.forEach((o) => {
      if (s.length || o.marks.length) {
        let a = 0, l = 0;
        for (; a < s.length && l < o.marks.length; ) {
          let c = o.marks[l];
          if (!this.marks[c.type.name]) {
            l++;
            continue;
          }
          if (!c.eq(s[a][0]) || c.type.spec.spanning === !1)
            break;
          a++, l++;
        }
        for (; a < s.length; )
          r = s.pop()[1];
        for (; l < o.marks.length; ) {
          let c = o.marks[l++], u = this.serializeMark(c, o.isInline, t);
          u && (s.push([c, r]), r.appendChild(u.dom), r = u.contentDOM || u.dom);
        }
      }
      r.appendChild(this.serializeNodeInner(o, t));
    }), i;
  }
  /**
  @internal
  */
  serializeNodeInner(e, t) {
    let { dom: i, contentDOM: r } = po(al(t), this.nodes[e.type.name](e), null, e.attrs);
    if (r) {
      if (e.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(e.content, t, r);
    }
    return i;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(e, t = {}) {
    let i = this.serializeNodeInner(e, t);
    for (let r = e.marks.length - 1; r >= 0; r--) {
      let s = this.serializeMark(e.marks[r], e.isInline, t);
      s && ((s.contentDOM || s.dom).appendChild(i), i = s.dom);
    }
    return i;
  }
  /**
  @internal
  */
  serializeMark(e, t, i = {}) {
    let r = this.marks[e.type.name];
    return r && po(al(i), r(e, t), null, e.attrs);
  }
  static renderSpec(e, t, i = null, r) {
    return po(e, t, i, r);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(e) {
    return e.cached.domSerializer || (e.cached.domSerializer = new zi(this.nodesFromSchema(e), this.marksFromSchema(e)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(e) {
    let t = Kd(e.nodes);
    return t.text || (t.text = (i) => i.text), t;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(e) {
    return Kd(e.marks);
  }
}
function Kd(n) {
  let e = {};
  for (let t in n) {
    let i = n[t].spec.toDOM;
    i && (e[t] = i);
  }
  return e;
}
function al(n) {
  return n.document || window.document;
}
const qd = /* @__PURE__ */ new WeakMap();
function Mv(n) {
  let e = qd.get(n);
  return e === void 0 && qd.set(n, e = Ov(n)), e;
}
function Ov(n) {
  let e = null;
  function t(i) {
    if (i && typeof i == "object")
      if (Array.isArray(i))
        if (typeof i[0] == "string")
          e || (e = []), e.push(i);
        else
          for (let r = 0; r < i.length; r++)
            t(i[r]);
      else
        for (let r in i)
          t(i[r]);
  }
  return t(n), e;
}
function po(n, e, t, i) {
  if (typeof e == "string")
    return { dom: n.createTextNode(e) };
  if (e.nodeType != null)
    return { dom: e };
  if (e.dom && e.dom.nodeType != null)
    return e;
  let r = e[0], s;
  if (typeof r != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (i && (s = Mv(i)) && s.indexOf(e) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let o = r.indexOf(" ");
  o > 0 && (t = r.slice(0, o), r = r.slice(o + 1));
  let a, l = t ? n.createElementNS(t, r) : n.createElement(r), c = e[1], u = 1;
  if (c && typeof c == "object" && c.nodeType == null && !Array.isArray(c)) {
    u = 2;
    for (let d in c)
      if (c[d] != null) {
        let h = d.indexOf(" ");
        h > 0 ? l.setAttributeNS(d.slice(0, h), d.slice(h + 1), c[d]) : l.setAttribute(d, c[d]);
      }
  }
  for (let d = u; d < e.length; d++) {
    let h = e[d];
    if (h === 0) {
      if (d < e.length - 1 || d > u)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: l, contentDOM: l };
    } else {
      let { dom: f, contentDOM: p } = po(n, h, t, i);
      if (l.appendChild(f), p) {
        if (a)
          throw new RangeError("Multiple content holes");
        a = p;
      }
    }
  }
  return { dom: l, contentDOM: a };
}
const Jp = 65535, Xp = Math.pow(2, 16);
function Nv(n, e) {
  return n + e * Xp;
}
function Gd(n) {
  return n & Jp;
}
function Lv(n) {
  return (n - (n & Jp)) / Xp;
}
const Yp = 1, Zp = 2, mo = 4, Qp = 8;
class fc {
  /**
  @internal
  */
  constructor(e, t, i) {
    this.pos = e, this.delInfo = t, this.recover = i;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & Qp) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (Yp | mo)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (Zp | mo)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & mo) > 0;
  }
}
class qt {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(e, t = !1) {
    if (this.ranges = e, this.inverted = t, !e.length && qt.empty)
      return qt.empty;
  }
  /**
  @internal
  */
  recover(e) {
    let t = 0, i = Gd(e);
    if (!this.inverted)
      for (let r = 0; r < i; r++)
        t += this.ranges[r * 3 + 2] - this.ranges[r * 3 + 1];
    return this.ranges[i * 3] + t + Lv(e);
  }
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  map(e, t = 1) {
    return this._map(e, t, !0);
  }
  /**
  @internal
  */
  _map(e, t, i) {
    let r = 0, s = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let a = 0; a < this.ranges.length; a += 3) {
      let l = this.ranges[a] - (this.inverted ? r : 0);
      if (l > e)
        break;
      let c = this.ranges[a + s], u = this.ranges[a + o], d = l + c;
      if (e <= d) {
        let h = c ? e == l ? -1 : e == d ? 1 : t : t, f = l + r + (h < 0 ? 0 : u);
        if (i)
          return f;
        let p = e == (t < 0 ? l : d) ? null : Nv(a / 3, e - l), _ = e == l ? Zp : e == d ? Yp : mo;
        return (t < 0 ? e != l : e != d) && (_ |= Qp), new fc(f, _, p);
      }
      r += u - c;
    }
    return i ? e + r : new fc(e + r, 0, null);
  }
  /**
  @internal
  */
  touches(e, t) {
    let i = 0, r = Gd(t), s = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let a = 0; a < this.ranges.length; a += 3) {
      let l = this.ranges[a] - (this.inverted ? i : 0);
      if (l > e)
        break;
      let c = this.ranges[a + s], u = l + c;
      if (e <= u && a == r * 3)
        return !0;
      i += this.ranges[a + o] - c;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(e) {
    let t = this.inverted ? 2 : 1, i = this.inverted ? 1 : 2;
    for (let r = 0, s = 0; r < this.ranges.length; r += 3) {
      let o = this.ranges[r], a = o - (this.inverted ? s : 0), l = o + (this.inverted ? 0 : s), c = this.ranges[r + t], u = this.ranges[r + i];
      e(a, a + c, l, l + u), s += u - c;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new qt(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(e) {
    return e == 0 ? qt.empty : new qt(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
qt.empty = new qt([]);
class rr {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(e = [], t, i = 0, r = e.length) {
    this.maps = e, this.mirror = t, this.from = i, this.to = r;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(e = 0, t = this.maps.length) {
    return new rr(this.maps, this.mirror, e, t);
  }
  /**
  @internal
  */
  copy() {
    return new rr(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(e, t) {
    this.to = this.maps.push(e), t != null && this.setMirror(this.maps.length - 1, t);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(e) {
    for (let t = 0, i = this.maps.length; t < e.maps.length; t++) {
      let r = e.getMirror(t);
      this.appendMap(e.maps[t], r != null && r < t ? i + r : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(e) {
    if (this.mirror) {
      for (let t = 0; t < this.mirror.length; t++)
        if (this.mirror[t] == e)
          return this.mirror[t + (t % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(e, t) {
    this.mirror || (this.mirror = []), this.mirror.push(e, t);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(e) {
    for (let t = e.maps.length - 1, i = this.maps.length + e.maps.length; t >= 0; t--) {
      let r = e.getMirror(t);
      this.appendMap(e.maps[t].invert(), r != null && r > t ? i - r - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let e = new rr();
    return e.appendMappingInverted(this), e;
  }
  /**
  Map a position through this mapping.
  */
  map(e, t = 1) {
    if (this.mirror)
      return this._map(e, t, !0);
    for (let i = this.from; i < this.to; i++)
      e = this.maps[i].map(e, t);
    return e;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  /**
  @internal
  */
  _map(e, t, i) {
    let r = 0;
    for (let s = this.from; s < this.to; s++) {
      let o = this.maps[s], a = o.mapResult(e, t);
      if (a.recover != null) {
        let l = this.getMirror(s);
        if (l != null && l > s && l < this.to) {
          s = l, e = this.maps[l].recover(a.recover);
          continue;
        }
      }
      r |= a.delInfo, e = a.pos;
    }
    return i ? e : new fc(e, r, null);
  }
}
const ll = /* @__PURE__ */ Object.create(null);
class It {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return qt.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(e) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(e, t) {
    if (!t || !t.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let i = ll[t.stepType];
    if (!i)
      throw new RangeError(`No step type ${t.stepType} defined`);
    return i.fromJSON(e, t);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(e, t) {
    if (e in ll)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return ll[e] = t, t.prototype.jsonID = e, t;
  }
}
class rt {
  /**
  @internal
  */
  constructor(e, t) {
    this.doc = e, this.failed = t;
  }
  /**
  Create a successful step result.
  */
  static ok(e) {
    return new rt(e, null);
  }
  /**
  Create a failed step result.
  */
  static fail(e) {
    return new rt(null, e);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(e, t, i, r) {
    try {
      return rt.ok(e.replace(t, i, r));
    } catch (s) {
      if (s instanceof Oo)
        return rt.fail(s.message);
      throw s;
    }
  }
}
function ru(n, e, t) {
  let i = [];
  for (let r = 0; r < n.childCount; r++) {
    let s = n.child(r);
    s.content.size && (s = s.copy(ru(s.content, e, s))), s.isInline && (s = e(s, t, r)), i.push(s);
  }
  return $.fromArray(i);
}
class ci extends It {
  /**
  Create a mark step.
  */
  constructor(e, t, i) {
    super(), this.from = e, this.to = t, this.mark = i;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), i = e.resolve(this.from), r = i.node(i.sharedDepth(this.to)), s = new J(ru(t.content, (o, a) => !o.isAtom || !a.type.allowsMarkType(this.mark.type) ? o : o.mark(this.mark.addToSet(o.marks)), r), t.openStart, t.openEnd);
    return rt.fromReplace(e, this.from, this.to, s);
  }
  invert() {
    return new _n(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), i = e.mapResult(this.to, -1);
    return t.deleted && i.deleted || t.pos >= i.pos ? null : new ci(t.pos, i.pos, this.mark);
  }
  merge(e) {
    return e instanceof ci && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new ci(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new ci(t.from, t.to, e.markFromJSON(t.mark));
  }
}
It.jsonID("addMark", ci);
class _n extends It {
  /**
  Create a mark-removing step.
  */
  constructor(e, t, i) {
    super(), this.from = e, this.to = t, this.mark = i;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), i = new J(ru(t.content, (r) => r.mark(this.mark.removeFromSet(r.marks)), e), t.openStart, t.openEnd);
    return rt.fromReplace(e, this.from, this.to, i);
  }
  invert() {
    return new ci(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), i = e.mapResult(this.to, -1);
    return t.deleted && i.deleted || t.pos >= i.pos ? null : new _n(t.pos, i.pos, this.mark);
  }
  merge(e) {
    return e instanceof _n && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new _n(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new _n(t.from, t.to, e.markFromJSON(t.mark));
  }
}
It.jsonID("removeMark", _n);
class ui extends It {
  /**
  Create a node mark step.
  */
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return rt.fail("No node at mark step's position");
    let i = t.type.create(t.attrs, null, this.mark.addToSet(t.marks));
    return rt.fromReplace(e, this.pos, this.pos + 1, new J($.from(i), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    if (t) {
      let i = this.mark.addToSet(t.marks);
      if (i.length == t.marks.length) {
        for (let r = 0; r < t.marks.length; r++)
          if (!t.marks[r].isInSet(i))
            return new ui(this.pos, t.marks[r]);
        return new ui(this.pos, this.mark);
      }
    }
    return new ur(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new ui(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new ui(t.pos, e.markFromJSON(t.mark));
  }
}
It.jsonID("addNodeMark", ui);
class ur extends It {
  /**
  Create a mark-removing step.
  */
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return rt.fail("No node at mark step's position");
    let i = t.type.create(t.attrs, null, this.mark.removeFromSet(t.marks));
    return rt.fromReplace(e, this.pos, this.pos + 1, new J($.from(i), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    return !t || !this.mark.isInSet(t.marks) ? this : new ui(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new ur(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new ur(t.pos, e.markFromJSON(t.mark));
  }
}
It.jsonID("removeNodeMark", ur);
class pt extends It {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(e, t, i, r = !1) {
    super(), this.from = e, this.to = t, this.slice = i, this.structure = r;
  }
  apply(e) {
    return this.structure && pc(e, this.from, this.to) ? rt.fail("Structure replace would overwrite content") : rt.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new qt([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new pt(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let t = e.mapResult(this.from, 1), i = e.mapResult(this.to, -1);
    return t.deletedAcross && i.deletedAcross ? null : new pt(t.pos, Math.max(t.pos, i.pos), this.slice);
  }
  merge(e) {
    if (!(e instanceof pt) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let t = this.slice.size + e.slice.size == 0 ? J.empty : new J(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new pt(this.from, this.to + (e.to - e.from), t, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let t = this.slice.size + e.slice.size == 0 ? J.empty : new J(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new pt(e.from, this.to, t, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new pt(t.from, t.to, J.fromJSON(e, t.slice), !!t.structure);
  }
}
It.jsonID("replace", pt);
class _t extends It {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(e, t, i, r, s, o, a = !1) {
    super(), this.from = e, this.to = t, this.gapFrom = i, this.gapTo = r, this.slice = s, this.insert = o, this.structure = a;
  }
  apply(e) {
    if (this.structure && (pc(e, this.from, this.gapFrom) || pc(e, this.gapTo, this.to)))
      return rt.fail("Structure gap-replace would overwrite content");
    let t = e.slice(this.gapFrom, this.gapTo);
    if (t.openStart || t.openEnd)
      return rt.fail("Gap is not a flat range");
    let i = this.slice.insertAt(this.insert, t.content);
    return i ? rt.fromReplace(e, this.from, this.to, i) : rt.fail("Content does not fit in gap");
  }
  getMap() {
    return new qt([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let t = this.gapTo - this.gapFrom;
    return new _t(this.from, this.from + this.slice.size + t, this.from + this.insert, this.from + this.insert + t, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), i = e.mapResult(this.to, -1), r = this.from == this.gapFrom ? t.pos : e.map(this.gapFrom, -1), s = this.to == this.gapTo ? i.pos : e.map(this.gapTo, 1);
    return t.deletedAcross && i.deletedAcross || r < t.pos || s > i.pos ? null : new _t(t.pos, i.pos, r, s, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number" || typeof t.gapFrom != "number" || typeof t.gapTo != "number" || typeof t.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new _t(t.from, t.to, t.gapFrom, t.gapTo, J.fromJSON(e, t.slice), t.insert, !!t.structure);
  }
}
It.jsonID("replaceAround", _t);
function pc(n, e, t) {
  let i = n.resolve(e), r = t - e, s = i.depth;
  for (; r > 0 && s > 0 && i.indexAfter(s) == i.node(s).childCount; )
    s--, r--;
  if (r > 0) {
    let o = i.node(s).maybeChild(i.indexAfter(s));
    for (; r > 0; ) {
      if (!o || o.isLeaf)
        return !0;
      o = o.firstChild, r--;
    }
  }
  return !1;
}
function Rv(n, e, t, i) {
  let r = [], s = [], o, a;
  n.doc.nodesBetween(e, t, (l, c, u) => {
    if (!l.isInline)
      return;
    let d = l.marks;
    if (!i.isInSet(d) && u.type.allowsMarkType(i.type)) {
      let h = Math.max(c, e), f = Math.min(c + l.nodeSize, t), p = i.addToSet(d);
      for (let _ = 0; _ < d.length; _++)
        d[_].isInSet(p) || (o && o.to == h && o.mark.eq(d[_]) ? o.to = f : r.push(o = new _n(h, f, d[_])));
      a && a.to == h ? a.to = f : s.push(a = new ci(h, f, i));
    }
  }), r.forEach((l) => n.step(l)), s.forEach((l) => n.step(l));
}
function Iv(n, e, t, i) {
  let r = [], s = 0;
  n.doc.nodesBetween(e, t, (o, a) => {
    if (!o.isInline)
      return;
    s++;
    let l = null;
    if (i instanceof Sa) {
      let c = o.marks, u;
      for (; u = i.isInSet(c); )
        (l || (l = [])).push(u), c = u.removeFromSet(c);
    } else i ? i.isInSet(o.marks) && (l = [i]) : l = o.marks;
    if (l && l.length) {
      let c = Math.min(a + o.nodeSize, t);
      for (let u = 0; u < l.length; u++) {
        let d = l[u], h;
        for (let f = 0; f < r.length; f++) {
          let p = r[f];
          p.step == s - 1 && d.eq(r[f].style) && (h = p);
        }
        h ? (h.to = c, h.step = s) : r.push({ style: d, from: Math.max(a, e), to: c, step: s });
      }
    }
  }), r.forEach((o) => n.step(new _n(o.from, o.to, o.style)));
}
function su(n, e, t, i = t.contentMatch, r = !0) {
  let s = n.doc.nodeAt(e), o = [], a = e + 1;
  for (let l = 0; l < s.childCount; l++) {
    let c = s.child(l), u = a + c.nodeSize, d = i.matchType(c.type);
    if (!d)
      o.push(new pt(a, u, J.empty));
    else {
      i = d;
      for (let h = 0; h < c.marks.length; h++)
        t.allowsMarkType(c.marks[h].type) || n.step(new _n(a, u, c.marks[h]));
      if (r && c.isText && t.whitespace != "pre") {
        let h, f = /\r?\n|\r/g, p;
        for (; h = f.exec(c.text); )
          p || (p = new J($.from(t.schema.text(" ", t.allowedMarks(c.marks))), 0, 0)), o.push(new pt(a + h.index, a + h.index + h[0].length, p));
      }
    }
    a = u;
  }
  if (!i.validEnd) {
    let l = i.fillBefore($.empty, !0);
    n.replace(a, a, new J(l, 0, 0));
  }
  for (let l = o.length - 1; l >= 0; l--)
    n.step(o[l]);
}
function Pv(n, e, t) {
  return (e == 0 || n.canReplace(e, n.childCount)) && (t == n.childCount || n.canReplace(0, t));
}
function yr(n) {
  let t = n.parent.content.cutByIndex(n.startIndex, n.endIndex);
  for (let i = n.depth; ; --i) {
    let r = n.$from.node(i), s = n.$from.index(i), o = n.$to.indexAfter(i);
    if (i < n.depth && r.canReplace(s, o, t))
      return i;
    if (i == 0 || r.type.spec.isolating || !Pv(r, s, o))
      break;
  }
  return null;
}
function Dv(n, e, t) {
  let { $from: i, $to: r, depth: s } = e, o = i.before(s + 1), a = r.after(s + 1), l = o, c = a, u = $.empty, d = 0;
  for (let p = s, _ = !1; p > t; p--)
    _ || i.index(p) > 0 ? (_ = !0, u = $.from(i.node(p).copy(u)), d++) : l--;
  let h = $.empty, f = 0;
  for (let p = s, _ = !1; p > t; p--)
    _ || r.after(p + 1) < r.end(p) ? (_ = !0, h = $.from(r.node(p).copy(h)), f++) : c++;
  n.step(new _t(l, c, o, a, new J(u.append(h), d, f), u.size - d, !0));
}
function ou(n, e, t = null, i = n) {
  let r = $v(n, e), s = r && zv(i, e);
  return s ? r.map(Jd).concat({ type: e, attrs: t }).concat(s.map(Jd)) : null;
}
function Jd(n) {
  return { type: n, attrs: null };
}
function $v(n, e) {
  let { parent: t, startIndex: i, endIndex: r } = n, s = t.contentMatchAt(i).findWrapping(e);
  if (!s)
    return null;
  let o = s.length ? s[0] : e;
  return t.canReplaceWith(i, r, o) ? s : null;
}
function zv(n, e) {
  let { parent: t, startIndex: i, endIndex: r } = n, s = t.child(i), o = e.contentMatch.findWrapping(s.type);
  if (!o)
    return null;
  let l = (o.length ? o[o.length - 1] : e).contentMatch;
  for (let c = i; l && c < r; c++)
    l = l.matchType(t.child(c).type);
  return !l || !l.validEnd ? null : o;
}
function Hv(n, e, t) {
  let i = $.empty;
  for (let o = t.length - 1; o >= 0; o--) {
    if (i.size) {
      let a = t[o].type.contentMatch.matchFragment(i);
      if (!a || !a.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    i = $.from(t[o].type.create(t[o].attrs, i));
  }
  let r = e.start, s = e.end;
  n.step(new _t(r, s, r, s, new J(i, 0, 0), t.length, !0));
}
function Bv(n, e, t, i, r) {
  if (!i.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let s = n.steps.length;
  n.doc.nodesBetween(e, t, (o, a) => {
    let l = typeof r == "function" ? r(o) : r;
    if (o.isTextblock && !o.hasMarkup(i, l) && Fv(n.doc, n.mapping.slice(s).map(a), i)) {
      let c = null;
      if (i.schema.linebreakReplacement) {
        let f = i.whitespace == "pre", p = !!i.contentMatch.matchType(i.schema.linebreakReplacement);
        f && !p ? c = !1 : !f && p && (c = !0);
      }
      c === !1 && tm(n, o, a, s), su(n, n.mapping.slice(s).map(a, 1), i, void 0, c === null);
      let u = n.mapping.slice(s), d = u.map(a, 1), h = u.map(a + o.nodeSize, 1);
      return n.step(new _t(d, h, d + 1, h - 1, new J($.from(i.create(l, null, o.marks)), 0, 0), 1, !0)), c === !0 && em(n, o, a, s), !1;
    }
  });
}
function em(n, e, t, i) {
  e.forEach((r, s) => {
    if (r.isText) {
      let o, a = /\r?\n|\r/g;
      for (; o = a.exec(r.text); ) {
        let l = n.mapping.slice(i).map(t + 1 + s + o.index);
        n.replaceWith(l, l + 1, e.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function tm(n, e, t, i) {
  e.forEach((r, s) => {
    if (r.type == r.type.schema.linebreakReplacement) {
      let o = n.mapping.slice(i).map(t + 1 + s);
      n.replaceWith(o, o + 1, e.type.schema.text(`
`));
    }
  });
}
function Fv(n, e, t) {
  let i = n.resolve(e), r = i.index();
  return i.parent.canReplaceWith(r, r + 1, t);
}
function Vv(n, e, t, i, r) {
  let s = n.doc.nodeAt(e);
  if (!s)
    throw new RangeError("No node at given position");
  t || (t = s.type);
  let o = t.create(i, null, r || s.marks);
  if (s.isLeaf)
    return n.replaceWith(e, e + s.nodeSize, o);
  if (!t.validContent(s.content))
    throw new RangeError("Invalid content for node type " + t.name);
  n.step(new _t(e, e + s.nodeSize, e + 1, e + s.nodeSize - 1, new J($.from(o), 0, 0), 1, !0));
}
function Un(n, e, t = 1, i) {
  let r = n.resolve(e), s = r.depth - t, o = i && i[i.length - 1] || r.parent;
  if (s < 0 || r.parent.type.spec.isolating || !r.parent.canReplace(r.index(), r.parent.childCount) || !o.type.validContent(r.parent.content.cutByIndex(r.index(), r.parent.childCount)))
    return !1;
  for (let c = r.depth - 1, u = t - 2; c > s; c--, u--) {
    let d = r.node(c), h = r.index(c);
    if (d.type.spec.isolating)
      return !1;
    let f = d.content.cutByIndex(h, d.childCount), p = i && i[u + 1];
    p && (f = f.replaceChild(0, p.type.create(p.attrs)));
    let _ = i && i[u] || d;
    if (!d.canReplace(h + 1, d.childCount) || !_.type.validContent(f))
      return !1;
  }
  let a = r.indexAfter(s), l = i && i[0];
  return r.node(s).canReplaceWith(a, a, l ? l.type : r.node(s + 1).type);
}
function jv(n, e, t = 1, i) {
  let r = n.doc.resolve(e), s = $.empty, o = $.empty;
  for (let a = r.depth, l = r.depth - t, c = t - 1; a > l; a--, c--) {
    s = $.from(r.node(a).copy(s));
    let u = i && i[c];
    o = $.from(u ? u.type.create(u.attrs, o) : r.node(a).copy(o));
  }
  n.step(new pt(e, e, new J(s.append(o), t, t), !0));
}
function _i(n, e) {
  let t = n.resolve(e), i = t.index();
  return nm(t.nodeBefore, t.nodeAfter) && t.parent.canReplace(i, i + 1);
}
function Wv(n, e) {
  e.content.size || n.type.compatibleContent(e.type);
  let t = n.contentMatchAt(n.childCount), { linebreakReplacement: i } = n.type.schema;
  for (let r = 0; r < e.childCount; r++) {
    let s = e.child(r), o = s.type == i ? n.type.schema.nodes.text : s.type;
    if (t = t.matchType(o), !t || !n.type.allowsMarks(s.marks))
      return !1;
  }
  return t.validEnd;
}
function nm(n, e) {
  return !!(n && e && !n.isLeaf && Wv(n, e));
}
function Ea(n, e, t = -1) {
  let i = n.resolve(e);
  for (let r = i.depth; ; r--) {
    let s, o, a = i.index(r);
    if (r == i.depth ? (s = i.nodeBefore, o = i.nodeAfter) : t > 0 ? (s = i.node(r + 1), a++, o = i.node(r).maybeChild(a)) : (s = i.node(r).maybeChild(a - 1), o = i.node(r + 1)), s && !s.isTextblock && nm(s, o) && i.node(r).canReplace(a, a + 1))
      return e;
    if (r == 0)
      break;
    e = t < 0 ? i.before(r) : i.after(r);
  }
}
function Uv(n, e, t) {
  let i = null, { linebreakReplacement: r } = n.doc.type.schema, s = n.doc.resolve(e - t), o = s.node().type;
  if (r && o.inlineContent) {
    let u = o.whitespace == "pre", d = !!o.contentMatch.matchType(r);
    u && !d ? i = !1 : !u && d && (i = !0);
  }
  let a = n.steps.length;
  if (i === !1) {
    let u = n.doc.resolve(e + t);
    tm(n, u.node(), u.before(), a);
  }
  o.inlineContent && su(n, e + t - 1, o, s.node().contentMatchAt(s.index()), i == null);
  let l = n.mapping.slice(a), c = l.map(e - t);
  if (n.step(new pt(c, l.map(e + t, -1), J.empty, !0)), i === !0) {
    let u = n.doc.resolve(c);
    em(n, u.node(), u.before(), n.steps.length);
  }
  return n;
}
function Kv(n, e, t) {
  let i = n.resolve(e);
  if (i.parent.canReplaceWith(i.index(), i.index(), t))
    return e;
  if (i.parentOffset == 0)
    for (let r = i.depth - 1; r >= 0; r--) {
      let s = i.index(r);
      if (i.node(r).canReplaceWith(s, s, t))
        return i.before(r + 1);
      if (s > 0)
        return null;
    }
  if (i.parentOffset == i.parent.content.size)
    for (let r = i.depth - 1; r >= 0; r--) {
      let s = i.indexAfter(r);
      if (i.node(r).canReplaceWith(s, s, t))
        return i.after(r + 1);
      if (s < i.node(r).childCount)
        return null;
    }
  return null;
}
function im(n, e, t) {
  let i = n.resolve(e);
  if (!t.content.size)
    return e;
  let r = t.content;
  for (let s = 0; s < t.openStart; s++)
    r = r.firstChild.content;
  for (let s = 1; s <= (t.openStart == 0 && t.size ? 2 : 1); s++)
    for (let o = i.depth; o >= 0; o--) {
      let a = o == i.depth ? 0 : i.pos <= (i.start(o + 1) + i.end(o + 1)) / 2 ? -1 : 1, l = i.index(o) + (a > 0 ? 1 : 0), c = i.node(o), u = !1;
      if (s == 1)
        u = c.canReplace(l, l, r);
      else {
        let d = c.contentMatchAt(l).findWrapping(r.firstChild.type);
        u = d && c.canReplaceWith(l, l, d[0]);
      }
      if (u)
        return a == 0 ? i.pos : a < 0 ? i.before(o + 1) : i.after(o + 1);
    }
  return null;
}
function Ca(n, e, t = e, i = J.empty) {
  if (e == t && !i.size)
    return null;
  let r = n.resolve(e), s = n.resolve(t);
  return rm(r, s, i) ? new pt(e, t, i) : new qv(r, s, i).fit();
}
function rm(n, e, t) {
  return !t.openStart && !t.openEnd && n.start() == e.start() && n.parent.canReplace(n.index(), e.index(), t.content);
}
class qv {
  constructor(e, t, i) {
    this.$from = e, this.$to = t, this.unplaced = i, this.frontier = [], this.placed = $.empty;
    for (let r = 0; r <= e.depth; r++) {
      let s = e.node(r);
      this.frontier.push({
        type: s.type,
        match: s.contentMatchAt(e.indexAfter(r))
      });
    }
    for (let r = e.depth; r > 0; r--)
      this.placed = $.from(e.node(r).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let c = this.findFittable();
      c ? this.placeNodes(c) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), t = this.placed.size - this.depth - this.$from.depth, i = this.$from, r = this.close(e < 0 ? this.$to : i.doc.resolve(e));
    if (!r)
      return null;
    let s = this.placed, o = i.depth, a = r.depth;
    for (; o && a && s.childCount == 1; )
      s = s.firstChild.content, o--, a--;
    let l = new J(s, o, a);
    return e > -1 ? new _t(i.pos, e, this.$to.pos, this.$to.end(), l, t) : l.size || i.pos != this.$to.pos ? new pt(i.pos, r.pos, l) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let e = this.unplaced.openStart;
    for (let t = this.unplaced.content, i = 0, r = this.unplaced.openEnd; i < e; i++) {
      let s = t.firstChild;
      if (t.childCount > 1 && (r = 0), s.type.spec.isolating && r <= i) {
        e = i;
        break;
      }
      t = s.content;
    }
    for (let t = 1; t <= 2; t++)
      for (let i = t == 1 ? e : this.unplaced.openStart; i >= 0; i--) {
        let r, s = null;
        i ? (s = cl(this.unplaced.content, i - 1).firstChild, r = s.content) : r = this.unplaced.content;
        let o = r.firstChild;
        for (let a = this.depth; a >= 0; a--) {
          let { type: l, match: c } = this.frontier[a], u, d = null;
          if (t == 1 && (o ? c.matchType(o.type) || (d = c.fillBefore($.from(o), !1)) : s && l.compatibleContent(s.type)))
            return { sliceDepth: i, frontierDepth: a, parent: s, inject: d };
          if (t == 2 && o && (u = c.findWrapping(o.type)))
            return { sliceDepth: i, frontierDepth: a, parent: s, wrap: u };
          if (s && c.matchType(s.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: t, openEnd: i } = this.unplaced, r = cl(e, t);
    return !r.childCount || r.firstChild.isLeaf ? !1 : (this.unplaced = new J(e, t + 1, Math.max(i, r.size + t >= e.size - i ? t + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: t, openEnd: i } = this.unplaced, r = cl(e, t);
    if (r.childCount <= 1 && t > 0) {
      let s = e.size - t <= t + r.size;
      this.unplaced = new J(Vr(e, t - 1, 1), t - 1, s ? t - 1 : i);
    } else
      this.unplaced = new J(Vr(e, t, 1), t, i);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: e, frontierDepth: t, parent: i, inject: r, wrap: s }) {
    for (; this.depth > t; )
      this.closeFrontierNode();
    if (s)
      for (let _ = 0; _ < s.length; _++)
        this.openFrontierNode(s[_]);
    let o = this.unplaced, a = i ? i.content : o.content, l = o.openStart - e, c = 0, u = [], { match: d, type: h } = this.frontier[t];
    if (r) {
      for (let _ = 0; _ < r.childCount; _++)
        u.push(r.child(_));
      d = d.matchFragment(r);
    }
    let f = a.size + e - (o.content.size - o.openEnd);
    for (; c < a.childCount; ) {
      let _ = a.child(c), m = d.matchType(_.type);
      if (!m)
        break;
      c++, (c > 1 || l == 0 || _.content.size) && (d = m, u.push(sm(_.mark(h.allowedMarks(_.marks)), c == 1 ? l : 0, c == a.childCount ? f : -1)));
    }
    let p = c == a.childCount;
    p || (f = -1), this.placed = jr(this.placed, t, $.from(u)), this.frontier[t].match = d, p && f < 0 && i && i.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let _ = 0, m = a; _ < f; _++) {
      let g = m.lastChild;
      this.frontier.push({ type: g.type, match: g.contentMatchAt(g.childCount) }), m = g.content;
    }
    this.unplaced = p ? e == 0 ? J.empty : new J(Vr(o.content, e - 1, 1), e - 1, f < 0 ? o.openEnd : e - 1) : new J(Vr(o.content, e, c), o.openStart, o.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], t;
    if (!e.type.isTextblock || !ul(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (t = this.findCloseLevel(this.$to)) && t.depth == this.depth)
      return -1;
    let { depth: i } = this.$to, r = this.$to.after(i);
    for (; i > 1 && r == this.$to.end(--i); )
      ++r;
    return r;
  }
  findCloseLevel(e) {
    e: for (let t = Math.min(this.depth, e.depth); t >= 0; t--) {
      let { match: i, type: r } = this.frontier[t], s = t < e.depth && e.end(t + 1) == e.pos + (e.depth - (t + 1)), o = ul(e, t, r, i, s);
      if (o) {
        for (let a = t - 1; a >= 0; a--) {
          let { match: l, type: c } = this.frontier[a], u = ul(e, a, c, l, !0);
          if (!u || u.childCount)
            continue e;
        }
        return { depth: t, fit: o, move: s ? e.doc.resolve(e.after(t + 1)) : e };
      }
    }
  }
  close(e) {
    let t = this.findCloseLevel(e);
    if (!t)
      return null;
    for (; this.depth > t.depth; )
      this.closeFrontierNode();
    t.fit.childCount && (this.placed = jr(this.placed, t.depth, t.fit)), e = t.move;
    for (let i = t.depth + 1; i <= e.depth; i++) {
      let r = e.node(i), s = r.type.contentMatch.fillBefore(r.content, !0, e.index(i));
      this.openFrontierNode(r.type, r.attrs, s);
    }
    return e;
  }
  openFrontierNode(e, t = null, i) {
    let r = this.frontier[this.depth];
    r.match = r.match.matchType(e), this.placed = jr(this.placed, this.depth, $.from(e.create(t, i))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let t = this.frontier.pop().match.fillBefore($.empty, !0);
    t.childCount && (this.placed = jr(this.placed, this.frontier.length, t));
  }
}
function Vr(n, e, t) {
  return e == 0 ? n.cutByIndex(t, n.childCount) : n.replaceChild(0, n.firstChild.copy(Vr(n.firstChild.content, e - 1, t)));
}
function jr(n, e, t) {
  return e == 0 ? n.append(t) : n.replaceChild(n.childCount - 1, n.lastChild.copy(jr(n.lastChild.content, e - 1, t)));
}
function cl(n, e) {
  for (let t = 0; t < e; t++)
    n = n.firstChild.content;
  return n;
}
function sm(n, e, t) {
  if (e <= 0)
    return n;
  let i = n.content;
  return e > 1 && (i = i.replaceChild(0, sm(i.firstChild, e - 1, i.childCount == 1 ? t - 1 : 0))), e > 0 && (i = n.type.contentMatch.fillBefore(i).append(i), t <= 0 && (i = i.append(n.type.contentMatch.matchFragment(i).fillBefore($.empty, !0)))), n.copy(i);
}
function ul(n, e, t, i, r) {
  let s = n.node(e), o = r ? n.indexAfter(e) : n.index(e);
  if (o == s.childCount && !t.compatibleContent(s.type))
    return null;
  let a = i.fillBefore(s.content, !0, o);
  return a && !Gv(t, s.content, o) ? a : null;
}
function Gv(n, e, t) {
  for (let i = t; i < e.childCount; i++)
    if (!n.allowsMarks(e.child(i).marks))
      return !0;
  return !1;
}
function Jv(n) {
  return n.spec.defining || n.spec.definingForContent;
}
function Xv(n, e, t, i) {
  if (!i.size)
    return n.deleteRange(e, t);
  let r = n.doc.resolve(e), s = n.doc.resolve(t);
  if (rm(r, s, i))
    return n.step(new pt(e, t, i));
  let o = am(r, n.doc.resolve(t));
  o[o.length - 1] == 0 && o.pop();
  let a = -(r.depth + 1);
  o.unshift(a);
  for (let h = r.depth, f = r.pos - 1; h > 0; h--, f--) {
    let p = r.node(h).type.spec;
    if (p.defining || p.definingAsContext || p.isolating)
      break;
    o.indexOf(h) > -1 ? a = h : r.before(h) == f && o.splice(1, 0, -h);
  }
  let l = o.indexOf(a), c = [], u = i.openStart;
  for (let h = i.content, f = 0; ; f++) {
    let p = h.firstChild;
    if (c.push(p), f == i.openStart)
      break;
    h = p.content;
  }
  for (let h = u - 1; h >= 0; h--) {
    let f = c[h], p = Jv(f.type);
    if (p && !f.sameMarkup(r.node(Math.abs(a) - 1)))
      u = h;
    else if (p || !f.type.isTextblock)
      break;
  }
  for (let h = i.openStart; h >= 0; h--) {
    let f = (h + u + 1) % (i.openStart + 1), p = c[f];
    if (p)
      for (let _ = 0; _ < o.length; _++) {
        let m = o[(_ + l) % o.length], g = !0;
        m < 0 && (g = !1, m = -m);
        let y = r.node(m - 1), x = r.index(m - 1);
        if (y.canReplaceWith(x, x, p.type, p.marks))
          return n.replace(r.before(m), g ? s.after(m) : t, new J(om(i.content, 0, i.openStart, f), f, i.openEnd));
      }
  }
  let d = n.steps.length;
  for (let h = o.length - 1; h >= 0 && (n.replace(e, t, i), !(n.steps.length > d)); h--) {
    let f = o[h];
    f < 0 || (e = r.before(f), t = s.after(f));
  }
}
function om(n, e, t, i, r) {
  if (e < t) {
    let s = n.firstChild;
    n = n.replaceChild(0, s.copy(om(s.content, e + 1, t, i, s)));
  }
  if (e > i) {
    let s = r.contentMatchAt(0), o = s.fillBefore(n).append(n);
    n = o.append(s.matchFragment(o).fillBefore($.empty, !0));
  }
  return n;
}
function Yv(n, e, t, i) {
  if (!i.isInline && e == t && n.doc.resolve(e).parent.content.size) {
    let r = Kv(n.doc, e, i.type);
    r != null && (e = t = r);
  }
  n.replaceRange(e, t, new J($.from(i), 0, 0));
}
function Zv(n, e, t) {
  let i = n.doc.resolve(e), r = n.doc.resolve(t), s = am(i, r);
  for (let o = 0; o < s.length; o++) {
    let a = s[o], l = o == s.length - 1;
    if (l && a == 0 || i.node(a).type.contentMatch.validEnd)
      return n.delete(i.start(a), r.end(a));
    if (a > 0 && (l || i.node(a - 1).canReplace(i.index(a - 1), r.indexAfter(a - 1))))
      return n.delete(i.before(a), r.after(a));
  }
  for (let o = 1; o <= i.depth && o <= r.depth; o++)
    if (e - i.start(o) == i.depth - o && t > i.end(o) && r.end(o) - t != r.depth - o && i.start(o - 1) == r.start(o - 1) && i.node(o - 1).canReplace(i.index(o - 1), r.index(o - 1)))
      return n.delete(i.before(o), t);
  n.delete(e, t);
}
function am(n, e) {
  let t = [], i = Math.min(n.depth, e.depth);
  for (let r = i; r >= 0; r--) {
    let s = n.start(r);
    if (s < n.pos - (n.depth - r) || e.end(r) > e.pos + (e.depth - r) || n.node(r).type.spec.isolating || e.node(r).type.spec.isolating)
      break;
    (s == e.start(r) || r == n.depth && r == e.depth && n.parent.inlineContent && e.parent.inlineContent && r && e.start(r - 1) == s - 1) && t.push(r);
  }
  return t;
}
class sr extends It {
  /**
  Construct an attribute step.
  */
  constructor(e, t, i) {
    super(), this.pos = e, this.attr = t, this.value = i;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return rt.fail("No node at attribute step's position");
    let i = /* @__PURE__ */ Object.create(null);
    for (let s in t.attrs)
      i[s] = t.attrs[s];
    i[this.attr] = this.value;
    let r = t.type.create(i, null, t.marks);
    return rt.fromReplace(e, this.pos, this.pos + 1, new J($.from(r), 0, t.isLeaf ? 0 : 1));
  }
  getMap() {
    return qt.empty;
  }
  invert(e) {
    return new sr(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new sr(t.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.pos != "number" || typeof t.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new sr(t.pos, t.attr, t.value);
  }
}
It.jsonID("attr", sr);
class ps extends It {
  /**
  Construct an attribute step.
  */
  constructor(e, t) {
    super(), this.attr = e, this.value = t;
  }
  apply(e) {
    let t = /* @__PURE__ */ Object.create(null);
    for (let r in e.attrs)
      t[r] = e.attrs[r];
    t[this.attr] = this.value;
    let i = e.type.create(t, e.content, e.marks);
    return rt.ok(i);
  }
  getMap() {
    return qt.empty;
  }
  invert(e) {
    return new ps(this.attr, e.attrs[this.attr]);
  }
  map(e) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new ps(t.attr, t.value);
  }
}
It.jsonID("docAttr", ps);
let dr = class extends Error {
};
dr = function n(e) {
  let t = Error.call(this, e);
  return t.__proto__ = n.prototype, t;
};
dr.prototype = Object.create(Error.prototype);
dr.prototype.constructor = dr;
dr.prototype.name = "TransformError";
class au {
  /**
  Create a transform that starts with the given document.
  */
  constructor(e) {
    this.doc = e, this.steps = [], this.docs = [], this.mapping = new rr();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(e) {
    let t = this.maybeStep(e);
    if (t.failed)
      throw new dr(t.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(e) {
    let t = e.apply(this.doc);
    return t.failed || this.addStep(e, t.doc), t;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(e, t) {
    this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = t;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(e, t = e, i = J.empty) {
    let r = Ca(this.doc, e, t, i);
    return r && this.step(r), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(e, t, i) {
    return this.replace(e, t, new J($.from(i), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(e, t) {
    return this.replace(e, t, J.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(e, t) {
    return this.replaceWith(e, e, t);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(e, t, i) {
    return Xv(this, e, t, i), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(e, t, i) {
    return Yv(this, e, t, i), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(e, t) {
    return Zv(this, e, t), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(e, t) {
    return Dv(this, e, t), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(e, t = 1) {
    return Uv(this, e, t), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(e, t) {
    return Hv(this, e, t), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(e, t = e, i, r = null) {
    return Bv(this, e, t, i, r), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(e, t, i = null, r) {
    return Vv(this, e, t, i, r), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(e, t, i) {
    return this.step(new sr(e, t, i)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(e, t) {
    return this.step(new ps(e, t)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(e, t) {
    return this.step(new ui(e, t)), this;
  }
  /**
  Remove a mark (or a mark of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(e, t) {
    if (!(t instanceof $e)) {
      let i = this.doc.nodeAt(e);
      if (!i)
        throw new RangeError("No node at position " + e);
      if (t = t.isInSet(i.marks), !t)
        return this;
    }
    return this.step(new ur(e, t)), this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split.
  */
  split(e, t = 1, i) {
    return jv(this, e, t, i), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(e, t, i) {
    return Rv(this, e, t, i), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(e, t, i) {
    return Iv(this, e, t, i), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(e, t, i) {
    return su(this, e, t, i), this;
  }
}
const dl = /* @__PURE__ */ Object.create(null);
class fe {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(e, t, i) {
    this.$anchor = e, this.$head = t, this.ranges = i || [new lm(e.min(t), e.max(t))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let e = this.ranges;
    for (let t = 0; t < e.length; t++)
      if (e[t].$from.pos != e[t].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(e, t = J.empty) {
    let i = t.content.lastChild, r = null;
    for (let a = 0; a < t.openEnd; a++)
      r = i, i = i.lastChild;
    let s = e.steps.length, o = this.ranges;
    for (let a = 0; a < o.length; a++) {
      let { $from: l, $to: c } = o[a], u = e.mapping.slice(s);
      e.replaceRange(u.map(l.pos), u.map(c.pos), a ? J.empty : t), a == 0 && Zd(e, s, (i ? i.isInline : r && r.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(e, t) {
    let i = e.steps.length, r = this.ranges;
    for (let s = 0; s < r.length; s++) {
      let { $from: o, $to: a } = r[s], l = e.mapping.slice(i), c = l.map(o.pos), u = l.map(a.pos);
      s ? e.deleteRange(c, u) : (e.replaceRangeWith(c, u, t), Zd(e, i, t.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(e, t, i = !1) {
    let r = e.parent.inlineContent ? new ue(e) : Gi(e.node(0), e.parent, e.pos, e.index(), t, i);
    if (r)
      return r;
    for (let s = e.depth - 1; s >= 0; s--) {
      let o = t < 0 ? Gi(e.node(0), e.node(s), e.before(s + 1), e.index(s), t, i) : Gi(e.node(0), e.node(s), e.after(s + 1), e.index(s) + 1, t, i);
      if (o)
        return o;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(e, t = 1) {
    return this.findFrom(e, t) || this.findFrom(e, -t) || new Wt(e.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(e) {
    return Gi(e, e, 0, 0, 1) || new Wt(e);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(e) {
    return Gi(e, e, e.content.size, e.childCount, -1) || new Wt(e);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(e, t) {
    if (!t || !t.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let i = dl[t.type];
    if (!i)
      throw new RangeError(`No selection type ${t.type} defined`);
    return i.fromJSON(e, t);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(e, t) {
    if (e in dl)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return dl[e] = t, t.prototype.jsonID = e, t;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return ue.between(this.$anchor, this.$head).getBookmark();
  }
}
fe.prototype.visible = !0;
class lm {
  /**
  Create a range.
  */
  constructor(e, t) {
    this.$from = e, this.$to = t;
  }
}
let Xd = !1;
function Yd(n) {
  !Xd && !n.parent.inlineContent && (Xd = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + n.parent.type.name + ")"));
}
class ue extends fe {
  /**
  Construct a text selection between the given points.
  */
  constructor(e, t = e) {
    Yd(e), Yd(t), super(e, t);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, t) {
    let i = e.resolve(t.map(this.head));
    if (!i.parent.inlineContent)
      return fe.near(i);
    let r = e.resolve(t.map(this.anchor));
    return new ue(r.parent.inlineContent ? r : i, i);
  }
  replace(e, t = J.empty) {
    if (super.replace(e, t), t == J.empty) {
      let i = this.$from.marksAcross(this.$to);
      i && e.ensureMarks(i);
    }
  }
  eq(e) {
    return e instanceof ue && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new Ta(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.anchor != "number" || typeof t.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new ue(e.resolve(t.anchor), e.resolve(t.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(e, t, i = t) {
    let r = e.resolve(t);
    return new this(r, i == t ? r : e.resolve(i));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(e, t, i) {
    let r = e.pos - t.pos;
    if ((!i || r) && (i = r >= 0 ? 1 : -1), !t.parent.inlineContent) {
      let s = fe.findFrom(t, i, !0) || fe.findFrom(t, -i, !0);
      if (s)
        t = s.$head;
      else
        return fe.near(t, i);
    }
    return e.parent.inlineContent || (r == 0 ? e = t : (e = (fe.findFrom(e, -i, !0) || fe.findFrom(e, i, !0)).$anchor, e.pos < t.pos != r < 0 && (e = t))), new ue(e, t);
  }
}
fe.jsonID("text", ue);
class Ta {
  constructor(e, t) {
    this.anchor = e, this.head = t;
  }
  map(e) {
    return new Ta(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return ue.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class re extends fe {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(e) {
    let t = e.nodeAfter, i = e.node(0).resolve(e.pos + t.nodeSize);
    super(e, i), this.node = t;
  }
  map(e, t) {
    let { deleted: i, pos: r } = t.mapResult(this.anchor), s = e.resolve(r);
    return i ? fe.near(s) : new re(s);
  }
  content() {
    return new J($.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof re && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new lu(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new re(e.resolve(t.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(e, t) {
    return new re(e.resolve(t));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
re.prototype.visible = !1;
fe.jsonID("node", re);
class lu {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: t, pos: i } = e.mapResult(this.anchor);
    return t ? new Ta(i, i) : new lu(i);
  }
  resolve(e) {
    let t = e.resolve(this.anchor), i = t.nodeAfter;
    return i && re.isSelectable(i) ? new re(t) : fe.near(t);
  }
}
class Wt extends fe {
  /**
  Create an all-selection over the given document.
  */
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, t = J.empty) {
    if (t == J.empty) {
      e.delete(0, e.doc.content.size);
      let i = fe.atStart(e.doc);
      i.eq(e.selection) || e.setSelection(i);
    } else
      super.replace(e, t);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(e) {
    return new Wt(e);
  }
  map(e) {
    return new Wt(e);
  }
  eq(e) {
    return e instanceof Wt;
  }
  getBookmark() {
    return Qv;
  }
}
fe.jsonID("all", Wt);
const Qv = {
  map() {
    return this;
  },
  resolve(n) {
    return new Wt(n);
  }
};
function Gi(n, e, t, i, r, s = !1) {
  if (e.inlineContent)
    return ue.create(n, t);
  for (let o = i - (r > 0 ? 0 : 1); r > 0 ? o < e.childCount : o >= 0; o += r) {
    let a = e.child(o);
    if (a.isAtom) {
      if (!s && re.isSelectable(a))
        return re.create(n, t - (r < 0 ? a.nodeSize : 0));
    } else {
      let l = Gi(n, a, t + r, r < 0 ? a.childCount : 0, r, s);
      if (l)
        return l;
    }
    t += a.nodeSize * r;
  }
  return null;
}
function Zd(n, e, t) {
  let i = n.steps.length - 1;
  if (i < e)
    return;
  let r = n.steps[i];
  if (!(r instanceof pt || r instanceof _t))
    return;
  let s = n.mapping.maps[i], o;
  s.forEach((a, l, c, u) => {
    o == null && (o = u);
  }), n.setSelection(fe.near(n.doc.resolve(o), t));
}
const Qd = 1, Us = 2, eh = 4;
class ey extends au {
  /**
  @internal
  */
  constructor(e) {
    super(e.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = e.selection, this.storedMarks = e.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(e) {
    if (e.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = e, this.curSelectionFor = this.steps.length, this.updated = (this.updated | Qd) & ~Us, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & Qd) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(e) {
    return this.storedMarks = e, this.updated |= Us, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(e) {
    return $e.sameSet(this.storedMarks || this.selection.$from.marks(), e) || this.setStoredMarks(e), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(e) {
    return this.ensureMarks(e.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(e) {
    return this.ensureMarks(e.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & Us) > 0;
  }
  /**
  @internal
  */
  addStep(e, t) {
    super.addStep(e, t), this.updated = this.updated & ~Us, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(e) {
    return this.time = e, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(e) {
    return this.selection.replace(this, e), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(e, t = !0) {
    let i = this.selection;
    return t && (e = e.mark(this.storedMarks || (i.empty ? i.$from.marks() : i.$from.marksAcross(i.$to) || $e.none))), i.replaceWith(this, e), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(e, t, i) {
    let r = this.doc.type.schema;
    if (t == null)
      return e ? this.replaceSelectionWith(r.text(e), !0) : this.deleteSelection();
    {
      if (i == null && (i = t), i = i ?? t, !e)
        return this.deleteRange(t, i);
      let s = this.storedMarks;
      if (!s) {
        let o = this.doc.resolve(t);
        s = i == t ? o.marks() : o.marksAcross(this.doc.resolve(i));
      }
      return this.replaceRangeWith(t, i, r.text(e, s)), this.selection.empty || this.setSelection(fe.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(e, t) {
    return this.meta[typeof e == "string" ? e : e.key] = t, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(e) {
    return this.meta[typeof e == "string" ? e : e.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let e in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= eh, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & eh) > 0;
  }
}
function th(n, e) {
  return !e || !n ? n : n.bind(e);
}
class Wr {
  constructor(e, t, i) {
    this.name = e, this.init = th(t.init, i), this.apply = th(t.apply, i);
  }
}
const ty = [
  new Wr("doc", {
    init(n) {
      return n.doc || n.schema.topNodeType.createAndFill();
    },
    apply(n) {
      return n.doc;
    }
  }),
  new Wr("selection", {
    init(n, e) {
      return n.selection || fe.atStart(e.doc);
    },
    apply(n) {
      return n.selection;
    }
  }),
  new Wr("storedMarks", {
    init(n) {
      return n.storedMarks || null;
    },
    apply(n, e, t, i) {
      return i.selection.$cursor ? n.storedMarks : null;
    }
  }),
  new Wr("scrollToSelection", {
    init() {
      return 0;
    },
    apply(n, e) {
      return n.scrolledIntoView ? e + 1 : e;
    }
  })
];
class hl {
  constructor(e, t) {
    this.schema = e, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = ty.slice(), t && t.forEach((i) => {
      if (this.pluginsByKey[i.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + i.key + ")");
      this.plugins.push(i), this.pluginsByKey[i.key] = i, i.spec.state && this.fields.push(new Wr(i.key, i.spec.state, i));
    });
  }
}
class Zi {
  /**
  @internal
  */
  constructor(e) {
    this.config = e;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(e) {
    return this.applyTransaction(e).state;
  }
  /**
  @internal
  */
  filterTransaction(e, t = -1) {
    for (let i = 0; i < this.config.plugins.length; i++)
      if (i != t) {
        let r = this.config.plugins[i];
        if (r.spec.filterTransaction && !r.spec.filterTransaction.call(r, e, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(e) {
    if (!this.filterTransaction(e))
      return { state: this, transactions: [] };
    let t = [e], i = this.applyInner(e), r = null;
    for (; ; ) {
      let s = !1;
      for (let o = 0; o < this.config.plugins.length; o++) {
        let a = this.config.plugins[o];
        if (a.spec.appendTransaction) {
          let l = r ? r[o].n : 0, c = r ? r[o].state : this, u = l < t.length && a.spec.appendTransaction.call(a, l ? t.slice(l) : t, c, i);
          if (u && i.filterTransaction(u, o)) {
            if (u.setMeta("appendedTransaction", e), !r) {
              r = [];
              for (let d = 0; d < this.config.plugins.length; d++)
                r.push(d < o ? { state: i, n: t.length } : { state: this, n: 0 });
            }
            t.push(u), i = i.applyInner(u), s = !0;
          }
          r && (r[o] = { state: i, n: t.length });
        }
      }
      if (!s)
        return { state: i, transactions: t };
    }
  }
  /**
  @internal
  */
  applyInner(e) {
    if (!e.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let t = new Zi(this.config), i = this.config.fields;
    for (let r = 0; r < i.length; r++) {
      let s = i[r];
      t[s.name] = s.apply(e, this[s.name], this, t);
    }
    return t;
  }
  /**
  Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new ey(this);
  }
  /**
  Create a new state.
  */
  static create(e) {
    let t = new hl(e.doc ? e.doc.type.schema : e.schema, e.plugins), i = new Zi(t);
    for (let r = 0; r < t.fields.length; r++)
      i[t.fields[r].name] = t.fields[r].init(e, i);
    return i;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(e) {
    let t = new hl(this.schema, e.plugins), i = t.fields, r = new Zi(t);
    for (let s = 0; s < i.length; s++) {
      let o = i[s].name;
      r[o] = this.hasOwnProperty(o) ? this[o] : i[s].init(e, r);
    }
    return r;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(e) {
    let t = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (t.storedMarks = this.storedMarks.map((i) => i.toJSON())), e && typeof e == "object")
      for (let i in e) {
        if (i == "doc" || i == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let r = e[i], s = r.spec.state;
        s && s.toJSON && (t[i] = s.toJSON.call(r, this[r.key]));
      }
    return t;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(e, t, i) {
    if (!t)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!e.schema)
      throw new RangeError("Required config field 'schema' missing");
    let r = new hl(e.schema, e.plugins), s = new Zi(r);
    return r.fields.forEach((o) => {
      if (o.name == "doc")
        s.doc = On.fromJSON(e.schema, t.doc);
      else if (o.name == "selection")
        s.selection = fe.fromJSON(s.doc, t.selection);
      else if (o.name == "storedMarks")
        t.storedMarks && (s.storedMarks = t.storedMarks.map(e.schema.markFromJSON));
      else {
        if (i)
          for (let a in i) {
            let l = i[a], c = l.spec.state;
            if (l.key == o.name && c && c.fromJSON && Object.prototype.hasOwnProperty.call(t, a)) {
              s[o.name] = c.fromJSON.call(l, e, t[a], s);
              return;
            }
          }
        s[o.name] = o.init(e, s);
      }
    }), s;
  }
}
function cm(n, e, t) {
  for (let i in n) {
    let r = n[i];
    r instanceof Function ? r = r.bind(e) : i == "handleDOMEvents" && (r = cm(r, e, {})), t[i] = r;
  }
  return t;
}
class je {
  /**
  Create a plugin.
  */
  constructor(e) {
    this.spec = e, this.props = {}, e.props && cm(e.props, this, this.props), this.key = e.key ? e.key.key : um("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const fl = /* @__PURE__ */ Object.create(null);
function um(n) {
  return n in fl ? n + "$" + ++fl[n] : (fl[n] = 0, n + "$");
}
class Xe {
  /**
  Create a plugin key.
  */
  constructor(e = "key") {
    this.key = um(e);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const cu = (n, e) => n.selection.empty ? !1 : (e && e(n.tr.deleteSelection().scrollIntoView()), !0);
function dm(n, e) {
  let { $cursor: t } = n.selection;
  return !t || (e ? !e.endOfTextblock("backward", n) : t.parentOffset > 0) ? null : t;
}
const hm = (n, e, t) => {
  let i = dm(n, t);
  if (!i)
    return !1;
  let r = uu(i);
  if (!r) {
    let o = i.blockRange(), a = o && yr(o);
    return a == null ? !1 : (e && e(n.tr.lift(o, a).scrollIntoView()), !0);
  }
  let s = r.nodeBefore;
  if (xm(n, r, e, -1))
    return !0;
  if (i.parent.content.size == 0 && (hr(s, "end") || re.isSelectable(s)))
    for (let o = i.depth; ; o--) {
      let a = Ca(n.doc, i.before(o), i.after(o), J.empty);
      if (a && a.slice.size < a.to - a.from) {
        if (e) {
          let l = n.tr.step(a);
          l.setSelection(hr(s, "end") ? fe.findFrom(l.doc.resolve(l.mapping.map(r.pos, -1)), -1) : re.create(l.doc, r.pos - s.nodeSize)), e(l.scrollIntoView());
        }
        return !0;
      }
      if (o == 1 || i.node(o - 1).childCount > 1)
        break;
    }
  return s.isAtom && r.depth == i.depth - 1 ? (e && e(n.tr.delete(r.pos - s.nodeSize, r.pos).scrollIntoView()), !0) : !1;
}, ny = (n, e, t) => {
  let i = dm(n, t);
  if (!i)
    return !1;
  let r = uu(i);
  return r ? fm(n, r, e) : !1;
}, iy = (n, e, t) => {
  let i = mm(n, t);
  if (!i)
    return !1;
  let r = du(i);
  return r ? fm(n, r, e) : !1;
};
function fm(n, e, t) {
  let i = e.nodeBefore, r = i, s = e.pos - 1;
  for (; !r.isTextblock; s--) {
    if (r.type.spec.isolating)
      return !1;
    let u = r.lastChild;
    if (!u)
      return !1;
    r = u;
  }
  let o = e.nodeAfter, a = o, l = e.pos + 1;
  for (; !a.isTextblock; l++) {
    if (a.type.spec.isolating)
      return !1;
    let u = a.firstChild;
    if (!u)
      return !1;
    a = u;
  }
  let c = Ca(n.doc, s, l, J.empty);
  if (!c || c.from != s || c instanceof pt && c.slice.size >= l - s)
    return !1;
  if (t) {
    let u = n.tr.step(c);
    u.setSelection(ue.create(u.doc, s)), t(u.scrollIntoView());
  }
  return !0;
}
function hr(n, e, t = !1) {
  for (let i = n; i; i = e == "start" ? i.firstChild : i.lastChild) {
    if (i.isTextblock)
      return !0;
    if (t && i.childCount != 1)
      return !1;
  }
  return !1;
}
const pm = (n, e, t) => {
  let { $head: i, empty: r } = n.selection, s = i;
  if (!r)
    return !1;
  if (i.parent.isTextblock) {
    if (t ? !t.endOfTextblock("backward", n) : i.parentOffset > 0)
      return !1;
    s = uu(i);
  }
  let o = s && s.nodeBefore;
  return !o || !re.isSelectable(o) ? !1 : (e && e(n.tr.setSelection(re.create(n.doc, s.pos - o.nodeSize)).scrollIntoView()), !0);
};
function uu(n) {
  if (!n.parent.type.spec.isolating)
    for (let e = n.depth - 1; e >= 0; e--) {
      if (n.index(e) > 0)
        return n.doc.resolve(n.before(e + 1));
      if (n.node(e).type.spec.isolating)
        break;
    }
  return null;
}
function mm(n, e) {
  let { $cursor: t } = n.selection;
  return !t || (e ? !e.endOfTextblock("forward", n) : t.parentOffset < t.parent.content.size) ? null : t;
}
const gm = (n, e, t) => {
  let i = mm(n, t);
  if (!i)
    return !1;
  let r = du(i);
  if (!r)
    return !1;
  let s = r.nodeAfter;
  if (xm(n, r, e, 1))
    return !0;
  if (i.parent.content.size == 0 && (hr(s, "start") || re.isSelectable(s))) {
    let o = Ca(n.doc, i.before(), i.after(), J.empty);
    if (o && o.slice.size < o.to - o.from) {
      if (e) {
        let a = n.tr.step(o);
        a.setSelection(hr(s, "start") ? fe.findFrom(a.doc.resolve(a.mapping.map(r.pos)), 1) : re.create(a.doc, a.mapping.map(r.pos))), e(a.scrollIntoView());
      }
      return !0;
    }
  }
  return s.isAtom && r.depth == i.depth - 1 ? (e && e(n.tr.delete(r.pos, r.pos + s.nodeSize).scrollIntoView()), !0) : !1;
}, _m = (n, e, t) => {
  let { $head: i, empty: r } = n.selection, s = i;
  if (!r)
    return !1;
  if (i.parent.isTextblock) {
    if (t ? !t.endOfTextblock("forward", n) : i.parentOffset < i.parent.content.size)
      return !1;
    s = du(i);
  }
  let o = s && s.nodeAfter;
  return !o || !re.isSelectable(o) ? !1 : (e && e(n.tr.setSelection(re.create(n.doc, s.pos)).scrollIntoView()), !0);
};
function du(n) {
  if (!n.parent.type.spec.isolating)
    for (let e = n.depth - 1; e >= 0; e--) {
      let t = n.node(e);
      if (n.index(e) + 1 < t.childCount)
        return n.doc.resolve(n.after(e + 1));
      if (t.type.spec.isolating)
        break;
    }
  return null;
}
const ry = (n, e) => {
  let t = n.selection, i = t instanceof re, r;
  if (i) {
    if (t.node.isTextblock || !_i(n.doc, t.from))
      return !1;
    r = t.from;
  } else if (r = Ea(n.doc, t.from, -1), r == null)
    return !1;
  if (e) {
    let s = n.tr.join(r);
    i && s.setSelection(re.create(s.doc, r - n.doc.resolve(r).nodeBefore.nodeSize)), e(s.scrollIntoView());
  }
  return !0;
}, sy = (n, e) => {
  let t = n.selection, i;
  if (t instanceof re) {
    if (t.node.isTextblock || !_i(n.doc, t.to))
      return !1;
    i = t.to;
  } else if (i = Ea(n.doc, t.to, 1), i == null)
    return !1;
  return e && e(n.tr.join(i).scrollIntoView()), !0;
}, oy = (n, e) => {
  let { $from: t, $to: i } = n.selection, r = t.blockRange(i), s = r && yr(r);
  return s == null ? !1 : (e && e(n.tr.lift(r, s).scrollIntoView()), !0);
}, bm = (n, e) => {
  let { $head: t, $anchor: i } = n.selection;
  return !t.parent.type.spec.code || !t.sameParent(i) ? !1 : (e && e(n.tr.insertText(`
`).scrollIntoView()), !0);
};
function hu(n) {
  for (let e = 0; e < n.edgeCount; e++) {
    let { type: t } = n.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
const ay = (n, e) => {
  let { $head: t, $anchor: i } = n.selection;
  if (!t.parent.type.spec.code || !t.sameParent(i))
    return !1;
  let r = t.node(-1), s = t.indexAfter(-1), o = hu(r.contentMatchAt(s));
  if (!o || !r.canReplaceWith(s, s, o))
    return !1;
  if (e) {
    let a = t.after(), l = n.tr.replaceWith(a, a, o.createAndFill());
    l.setSelection(fe.near(l.doc.resolve(a), 1)), e(l.scrollIntoView());
  }
  return !0;
}, vm = (n, e) => {
  let t = n.selection, { $from: i, $to: r } = t;
  if (t instanceof Wt || i.parent.inlineContent || r.parent.inlineContent)
    return !1;
  let s = hu(r.parent.contentMatchAt(r.indexAfter()));
  if (!s || !s.isTextblock)
    return !1;
  if (e) {
    let o = (!i.parentOffset && r.index() < r.parent.childCount ? i : r).pos, a = n.tr.insert(o, s.createAndFill());
    a.setSelection(ue.create(a.doc, o + 1)), e(a.scrollIntoView());
  }
  return !0;
}, ym = (n, e) => {
  let { $cursor: t } = n.selection;
  if (!t || t.parent.content.size)
    return !1;
  if (t.depth > 1 && t.after() != t.end(-1)) {
    let s = t.before();
    if (Un(n.doc, s))
      return e && e(n.tr.split(s).scrollIntoView()), !0;
  }
  let i = t.blockRange(), r = i && yr(i);
  return r == null ? !1 : (e && e(n.tr.lift(i, r).scrollIntoView()), !0);
};
function ly(n) {
  return (e, t) => {
    let { $from: i, $to: r } = e.selection;
    if (e.selection instanceof re && e.selection.node.isBlock)
      return !i.parentOffset || !Un(e.doc, i.pos) ? !1 : (t && t(e.tr.split(i.pos).scrollIntoView()), !0);
    if (!i.depth)
      return !1;
    let s = [], o, a, l = !1, c = !1;
    for (let f = i.depth; ; f--)
      if (i.node(f).isBlock) {
        l = i.end(f) == i.pos + (i.depth - f), c = i.start(f) == i.pos - (i.depth - f), a = hu(i.node(f - 1).contentMatchAt(i.indexAfter(f - 1))), s.unshift(l && a ? { type: a } : null), o = f;
        break;
      } else {
        if (f == 1)
          return !1;
        s.unshift(null);
      }
    let u = e.tr;
    (e.selection instanceof ue || e.selection instanceof Wt) && u.deleteSelection();
    let d = u.mapping.map(i.pos), h = Un(u.doc, d, s.length, s);
    if (h || (s[0] = a ? { type: a } : null, h = Un(u.doc, d, s.length, s)), u.split(d, s.length, s), !l && c && i.node(o).type != a) {
      let f = u.mapping.map(i.before(o)), p = u.doc.resolve(f);
      a && i.node(o - 1).canReplaceWith(p.index(), p.index() + 1, a) && u.setNodeMarkup(u.mapping.map(i.before(o)), a);
    }
    return t && t(u.scrollIntoView()), !0;
  };
}
const cy = ly(), uy = (n, e) => {
  let { $from: t, to: i } = n.selection, r, s = t.sharedDepth(i);
  return s == 0 ? !1 : (r = t.before(s), e && e(n.tr.setSelection(re.create(n.doc, r))), !0);
};
function dy(n, e, t) {
  let i = e.nodeBefore, r = e.nodeAfter, s = e.index();
  return !i || !r || !i.type.compatibleContent(r.type) ? !1 : !i.content.size && e.parent.canReplace(s - 1, s) ? (t && t(n.tr.delete(e.pos - i.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(s, s + 1) || !(r.isTextblock || _i(n.doc, e.pos)) ? !1 : (t && t(n.tr.join(e.pos).scrollIntoView()), !0);
}
function xm(n, e, t, i) {
  let r = e.nodeBefore, s = e.nodeAfter, o, a, l = r.type.spec.isolating || s.type.spec.isolating;
  if (!l && dy(n, e, t))
    return !0;
  let c = !l && e.parent.canReplace(e.index(), e.index() + 1);
  if (c && (o = (a = r.contentMatchAt(r.childCount)).findWrapping(s.type)) && a.matchType(o[0] || s.type).validEnd) {
    if (t) {
      let f = e.pos + s.nodeSize, p = $.empty;
      for (let g = o.length - 1; g >= 0; g--)
        p = $.from(o[g].create(null, p));
      p = $.from(r.copy(p));
      let _ = n.tr.step(new _t(e.pos - 1, f, e.pos, f, new J(p, 1, 0), o.length, !0)), m = _.doc.resolve(f + 2 * o.length);
      m.nodeAfter && m.nodeAfter.type == r.type && _i(_.doc, m.pos) && _.join(m.pos), t(_.scrollIntoView());
    }
    return !0;
  }
  let u = s.type.spec.isolating || i > 0 && l ? null : fe.findFrom(e, 1), d = u && u.$from.blockRange(u.$to), h = d && yr(d);
  if (h != null && h >= e.depth)
    return t && t(n.tr.lift(d, h).scrollIntoView()), !0;
  if (c && hr(s, "start", !0) && hr(r, "end")) {
    let f = r, p = [];
    for (; p.push(f), !f.isTextblock; )
      f = f.lastChild;
    let _ = s, m = 1;
    for (; !_.isTextblock; _ = _.firstChild)
      m++;
    if (f.canReplace(f.childCount, f.childCount, _.content)) {
      if (t) {
        let g = $.empty;
        for (let x = p.length - 1; x >= 0; x--)
          g = $.from(p[x].copy(g));
        let y = n.tr.step(new _t(e.pos - p.length, e.pos + s.nodeSize, e.pos + m, e.pos + s.nodeSize - m, new J(g, p.length, 0), 0, !0));
        t(y.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function wm(n) {
  return function(e, t) {
    let i = e.selection, r = n < 0 ? i.$from : i.$to, s = r.depth;
    for (; r.node(s).isInline; ) {
      if (!s)
        return !1;
      s--;
    }
    return r.node(s).isTextblock ? (t && t(e.tr.setSelection(ue.create(e.doc, n < 0 ? r.start(s) : r.end(s)))), !0) : !1;
  };
}
const hy = wm(-1), fy = wm(1);
function py(n, e = null) {
  return function(t, i) {
    let { $from: r, $to: s } = t.selection, o = r.blockRange(s), a = o && ou(o, n, e);
    return a ? (i && i(t.tr.wrap(o, a).scrollIntoView()), !0) : !1;
  };
}
function nh(n, e = null) {
  return function(t, i) {
    let r = !1;
    for (let s = 0; s < t.selection.ranges.length && !r; s++) {
      let { $from: { pos: o }, $to: { pos: a } } = t.selection.ranges[s];
      t.doc.nodesBetween(o, a, (l, c) => {
        if (r)
          return !1;
        if (!(!l.isTextblock || l.hasMarkup(n, e)))
          if (l.type == n)
            r = !0;
          else {
            let u = t.doc.resolve(c), d = u.index();
            r = u.parent.canReplaceWith(d, d + 1, n);
          }
      });
    }
    if (!r)
      return !1;
    if (i) {
      let s = t.tr;
      for (let o = 0; o < t.selection.ranges.length; o++) {
        let { $from: { pos: a }, $to: { pos: l } } = t.selection.ranges[o];
        s.setBlockType(a, l, n, e);
      }
      i(s.scrollIntoView());
    }
    return !0;
  };
}
function fu(...n) {
  return function(e, t, i) {
    for (let r = 0; r < n.length; r++)
      if (n[r](e, t, i))
        return !0;
    return !1;
  };
}
fu(cu, hm, pm);
fu(cu, gm, _m);
fu(bm, vm, ym, cy);
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function my(n, e = null) {
  return function(t, i) {
    let { $from: r, $to: s } = t.selection, o = r.blockRange(s);
    if (!o)
      return !1;
    let a = i ? t.tr : null;
    return gy(a, o, n, e) ? (i && i(a.scrollIntoView()), !0) : !1;
  };
}
function gy(n, e, t, i = null) {
  let r = !1, s = e, o = e.$from.doc;
  if (e.depth >= 2 && e.$from.node(e.depth - 1).type.compatibleContent(t) && e.startIndex == 0) {
    if (e.$from.index(e.depth - 1) == 0)
      return !1;
    let l = o.resolve(e.start - 2);
    s = new Lo(l, l, e.depth), e.endIndex < e.parent.childCount && (e = new Lo(e.$from, o.resolve(e.$to.end(e.depth)), e.depth)), r = !0;
  }
  let a = ou(s, t, i, e);
  return a ? (n && _y(n, e, a, r, t), !0) : !1;
}
function _y(n, e, t, i, r) {
  let s = $.empty;
  for (let u = t.length - 1; u >= 0; u--)
    s = $.from(t[u].type.create(t[u].attrs, s));
  n.step(new _t(e.start - (i ? 2 : 0), e.end, e.start, e.end, new J(s, 0, 0), t.length, !0));
  let o = 0;
  for (let u = 0; u < t.length; u++)
    t[u].type == r && (o = u + 1);
  let a = t.length - o, l = e.start + t.length - (i ? 2 : 0), c = e.parent;
  for (let u = e.startIndex, d = e.endIndex, h = !0; u < d; u++, h = !1)
    !h && Un(n.doc, l, a) && (n.split(l, a), l += 2 * a), l += c.child(u).nodeSize;
  return n;
}
function by(n) {
  return function(e, t) {
    let { $from: i, $to: r } = e.selection, s = i.blockRange(r, (o) => o.childCount > 0 && o.firstChild.type == n);
    return s ? t ? i.node(s.depth - 1).type == n ? vy(e, t, n, s) : yy(e, t, s) : !0 : !1;
  };
}
function vy(n, e, t, i) {
  let r = n.tr, s = i.end, o = i.$to.end(i.depth);
  s < o && (r.step(new _t(s - 1, o, s, o, new J($.from(t.create(null, i.parent.copy())), 1, 0), 1, !0)), i = new Lo(r.doc.resolve(i.$from.pos), r.doc.resolve(o), i.depth));
  const a = yr(i);
  if (a == null)
    return !1;
  r.lift(i, a);
  let l = r.mapping.map(s, -1) - 1;
  return _i(r.doc, l) && r.join(l), e(r.scrollIntoView()), !0;
}
function yy(n, e, t) {
  let i = n.tr, r = t.parent;
  for (let f = t.end, p = t.endIndex - 1, _ = t.startIndex; p > _; p--)
    f -= r.child(p).nodeSize, i.delete(f - 1, f + 1);
  let s = i.doc.resolve(t.start), o = s.nodeAfter;
  if (i.mapping.map(t.end) != t.start + s.nodeAfter.nodeSize)
    return !1;
  let a = t.startIndex == 0, l = t.endIndex == r.childCount, c = s.node(-1), u = s.index(-1);
  if (!c.canReplace(u + (a ? 0 : 1), u + 1, o.content.append(l ? $.empty : $.from(r))))
    return !1;
  let d = s.pos, h = d + o.nodeSize;
  return i.step(new _t(d - (a ? 1 : 0), h + (l ? 1 : 0), d + 1, h - 1, new J((a ? $.empty : $.from(r.copy($.empty))).append(l ? $.empty : $.from(r.copy($.empty))), a ? 0 : 1, l ? 0 : 1), a ? 0 : 1)), e(i.scrollIntoView()), !0;
}
function xy(n) {
  return function(e, t) {
    let { $from: i, $to: r } = e.selection, s = i.blockRange(r, (c) => c.childCount > 0 && c.firstChild.type == n);
    if (!s)
      return !1;
    let o = s.startIndex;
    if (o == 0)
      return !1;
    let a = s.parent, l = a.child(o - 1);
    if (l.type != n)
      return !1;
    if (t) {
      let c = l.lastChild && l.lastChild.type == a.type, u = $.from(c ? n.create() : null), d = new J($.from(n.create(null, $.from(a.type.create(null, u)))), c ? 3 : 1, 0), h = s.start, f = s.end;
      t(e.tr.step(new _t(h - (c ? 3 : 1), f, h, f, d, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
const wt = function(n) {
  for (var e = 0; ; e++)
    if (n = n.previousSibling, !n)
      return e;
}, fr = function(n) {
  let e = n.assignedSlot || n.parentNode;
  return e && e.nodeType == 11 ? e.host : e;
};
let mc = null;
const Fn = function(n, e, t) {
  let i = mc || (mc = document.createRange());
  return i.setEnd(n, t ?? n.nodeValue.length), i.setStart(n, e || 0), i;
}, wy = function() {
  mc = null;
}, Ri = function(n, e, t, i) {
  return t && (ih(n, e, t, i, -1) || ih(n, e, t, i, 1));
}, ky = /^(img|br|input|textarea|hr)$/i;
function ih(n, e, t, i, r) {
  for (var s; ; ) {
    if (n == t && e == i)
      return !0;
    if (e == (r < 0 ? 0 : sn(n))) {
      let o = n.parentNode;
      if (!o || o.nodeType != 1 || Ss(n) || ky.test(n.nodeName) || n.contentEditable == "false")
        return !1;
      e = wt(n) + (r < 0 ? 0 : 1), n = o;
    } else if (n.nodeType == 1) {
      let o = n.childNodes[e + (r < 0 ? -1 : 0)];
      if (o.nodeType == 1 && o.contentEditable == "false")
        if (!((s = o.pmViewDesc) === null || s === void 0) && s.ignoreForSelection)
          e += r;
        else
          return !1;
      else
        n = o, e = r < 0 ? sn(n) : 0;
    } else
      return !1;
  }
}
function sn(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function Sy(n, e) {
  for (; ; ) {
    if (n.nodeType == 3 && e)
      return n;
    if (n.nodeType == 1 && e > 0) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[e - 1], e = sn(n);
    } else if (n.parentNode && !Ss(n))
      e = wt(n), n = n.parentNode;
    else
      return null;
  }
}
function Ey(n, e) {
  for (; ; ) {
    if (n.nodeType == 3 && e < n.nodeValue.length)
      return n;
    if (n.nodeType == 1 && e < n.childNodes.length) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[e], e = 0;
    } else if (n.parentNode && !Ss(n))
      e = wt(n) + 1, n = n.parentNode;
    else
      return null;
  }
}
function Cy(n, e, t) {
  for (let i = e == 0, r = e == sn(n); i || r; ) {
    if (n == t)
      return !0;
    let s = wt(n);
    if (n = n.parentNode, !n)
      return !1;
    i = i && s == 0, r = r && s == sn(n);
  }
}
function Ss(n) {
  let e;
  for (let t = n; t && !(e = t.pmViewDesc); t = t.parentNode)
    ;
  return e && e.node && e.node.isBlock && (e.dom == n || e.contentDOM == n);
}
const Aa = function(n) {
  return n.focusNode && Ri(n.focusNode, n.focusOffset, n.anchorNode, n.anchorOffset);
};
function wi(n, e) {
  let t = document.createEvent("Event");
  return t.initEvent("keydown", !0, !0), t.keyCode = n, t.key = t.code = e, t;
}
function Ty(n) {
  let e = n.activeElement;
  for (; e && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function Ay(n, e, t) {
  if (n.caretPositionFromPoint)
    try {
      let i = n.caretPositionFromPoint(e, t);
      if (i)
        return { node: i.offsetNode, offset: Math.min(sn(i.offsetNode), i.offset) };
    } catch {
    }
  if (n.caretRangeFromPoint) {
    let i = n.caretRangeFromPoint(e, t);
    if (i)
      return { node: i.startContainer, offset: Math.min(sn(i.startContainer), i.startOffset) };
  }
}
const Nn = typeof navigator < "u" ? navigator : null, rh = typeof document < "u" ? document : null, bi = Nn && Nn.userAgent || "", gc = /Edge\/(\d+)/.exec(bi), km = /MSIE \d/.exec(bi), _c = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(bi), Ut = !!(km || _c || gc), hi = km ? document.documentMode : _c ? +_c[1] : gc ? +gc[1] : 0, on = !Ut && /gecko\/(\d+)/i.test(bi);
on && +(/Firefox\/(\d+)/.exec(bi) || [0, 0])[1];
const bc = !Ut && /Chrome\/(\d+)/.exec(bi), mt = !!bc, Sm = bc ? +bc[1] : 0, Ot = !Ut && !!Nn && /Apple Computer/.test(Nn.vendor), pr = Ot && (/Mobile\/\w+/.test(bi) || !!Nn && Nn.maxTouchPoints > 2), rn = pr || (Nn ? /Mac/.test(Nn.platform) : !1), Em = Nn ? /Win/.test(Nn.platform) : !1, jn = /Android \d/.test(bi), Es = !!rh && "webkitFontSmoothing" in rh.documentElement.style, My = Es ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function Oy(n) {
  let e = n.defaultView && n.defaultView.visualViewport;
  return e ? {
    left: 0,
    right: e.width,
    top: 0,
    bottom: e.height
  } : {
    left: 0,
    right: n.documentElement.clientWidth,
    top: 0,
    bottom: n.documentElement.clientHeight
  };
}
function Pn(n, e) {
  return typeof n == "number" ? n : n[e];
}
function Ny(n) {
  let e = n.getBoundingClientRect(), t = e.width / n.offsetWidth || 1, i = e.height / n.offsetHeight || 1;
  return {
    left: e.left,
    right: e.left + n.clientWidth * t,
    top: e.top,
    bottom: e.top + n.clientHeight * i
  };
}
function sh(n, e, t) {
  let i = n.someProp("scrollThreshold") || 0, r = n.someProp("scrollMargin") || 5, s = n.dom.ownerDocument;
  for (let o = t || n.dom; o; ) {
    if (o.nodeType != 1) {
      o = fr(o);
      continue;
    }
    let a = o, l = a == s.body, c = l ? Oy(s) : Ny(a), u = 0, d = 0;
    if (e.top < c.top + Pn(i, "top") ? d = -(c.top - e.top + Pn(r, "top")) : e.bottom > c.bottom - Pn(i, "bottom") && (d = e.bottom - e.top > c.bottom - c.top ? e.top + Pn(r, "top") - c.top : e.bottom - c.bottom + Pn(r, "bottom")), e.left < c.left + Pn(i, "left") ? u = -(c.left - e.left + Pn(r, "left")) : e.right > c.right - Pn(i, "right") && (u = e.right - c.right + Pn(r, "right")), u || d)
      if (l)
        s.defaultView.scrollBy(u, d);
      else {
        let f = a.scrollLeft, p = a.scrollTop;
        d && (a.scrollTop += d), u && (a.scrollLeft += u);
        let _ = a.scrollLeft - f, m = a.scrollTop - p;
        e = { left: e.left - _, top: e.top - m, right: e.right - _, bottom: e.bottom - m };
      }
    let h = l ? "fixed" : getComputedStyle(o).position;
    if (/^(fixed|sticky)$/.test(h))
      break;
    o = h == "absolute" ? o.offsetParent : fr(o);
  }
}
function Ly(n) {
  let e = n.dom.getBoundingClientRect(), t = Math.max(0, e.top), i, r;
  for (let s = (e.left + e.right) / 2, o = t + 1; o < Math.min(innerHeight, e.bottom); o += 5) {
    let a = n.root.elementFromPoint(s, o);
    if (!a || a == n.dom || !n.dom.contains(a))
      continue;
    let l = a.getBoundingClientRect();
    if (l.top >= t - 20) {
      i = a, r = l.top;
      break;
    }
  }
  return { refDOM: i, refTop: r, stack: Cm(n.dom) };
}
function Cm(n) {
  let e = [], t = n.ownerDocument;
  for (let i = n; i && (e.push({ dom: i, top: i.scrollTop, left: i.scrollLeft }), n != t); i = fr(i))
    ;
  return e;
}
function Ry({ refDOM: n, refTop: e, stack: t }) {
  let i = n ? n.getBoundingClientRect().top : 0;
  Tm(t, i == 0 ? 0 : i - e);
}
function Tm(n, e) {
  for (let t = 0; t < n.length; t++) {
    let { dom: i, top: r, left: s } = n[t];
    i.scrollTop != r + e && (i.scrollTop = r + e), i.scrollLeft != s && (i.scrollLeft = s);
  }
}
let Ui = null;
function Iy(n) {
  if (n.setActive)
    return n.setActive();
  if (Ui)
    return n.focus(Ui);
  let e = Cm(n);
  n.focus(Ui == null ? {
    get preventScroll() {
      return Ui = { preventScroll: !0 }, !0;
    }
  } : void 0), Ui || (Ui = !1, Tm(e, 0));
}
function Am(n, e) {
  let t, i = 2e8, r, s = 0, o = e.top, a = e.top, l, c;
  for (let u = n.firstChild, d = 0; u; u = u.nextSibling, d++) {
    let h;
    if (u.nodeType == 1)
      h = u.getClientRects();
    else if (u.nodeType == 3)
      h = Fn(u).getClientRects();
    else
      continue;
    for (let f = 0; f < h.length; f++) {
      let p = h[f];
      if (p.top <= o && p.bottom >= a) {
        o = Math.max(p.bottom, o), a = Math.min(p.top, a);
        let _ = p.left > e.left ? p.left - e.left : p.right < e.left ? e.left - p.right : 0;
        if (_ < i) {
          t = u, i = _, r = _ && t.nodeType == 3 ? {
            left: p.right < e.left ? p.right : p.left,
            top: e.top
          } : e, u.nodeType == 1 && _ && (s = d + (e.left >= (p.left + p.right) / 2 ? 1 : 0));
          continue;
        }
      } else p.top > e.top && !l && p.left <= e.left && p.right >= e.left && (l = u, c = { left: Math.max(p.left, Math.min(p.right, e.left)), top: p.top });
      !t && (e.left >= p.right && e.top >= p.top || e.left >= p.left && e.top >= p.bottom) && (s = d + 1);
    }
  }
  return !t && l && (t = l, r = c, i = 0), t && t.nodeType == 3 ? Py(t, r) : !t || i && t.nodeType == 1 ? { node: n, offset: s } : Am(t, r);
}
function Py(n, e) {
  let t = n.nodeValue.length, i = document.createRange(), r;
  for (let s = 0; s < t; s++) {
    i.setEnd(n, s + 1), i.setStart(n, s);
    let o = ei(i, 1);
    if (o.top != o.bottom && pu(e, o)) {
      r = { node: n, offset: s + (e.left >= (o.left + o.right) / 2 ? 1 : 0) };
      break;
    }
  }
  return i.detach(), r || { node: n, offset: 0 };
}
function pu(n, e) {
  return n.left >= e.left - 1 && n.left <= e.right + 1 && n.top >= e.top - 1 && n.top <= e.bottom + 1;
}
function Dy(n, e) {
  let t = n.parentNode;
  return t && /^li$/i.test(t.nodeName) && e.left < n.getBoundingClientRect().left ? t : n;
}
function $y(n, e, t) {
  let { node: i, offset: r } = Am(e, t), s = -1;
  if (i.nodeType == 1 && !i.firstChild) {
    let o = i.getBoundingClientRect();
    s = o.left != o.right && t.left > (o.left + o.right) / 2 ? 1 : -1;
  }
  return n.docView.posFromDOM(i, r, s);
}
function zy(n, e, t, i) {
  let r = -1;
  for (let s = e, o = !1; s != n.dom; ) {
    let a = n.docView.nearestDesc(s, !0), l;
    if (!a)
      return null;
    if (a.dom.nodeType == 1 && (a.node.isBlock && a.parent || !a.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((l = a.dom.getBoundingClientRect()).width || l.height) && (a.node.isBlock && a.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(a.dom.nodeName) && (!o && l.left > i.left || l.top > i.top ? r = a.posBefore : (!o && l.right < i.left || l.bottom < i.top) && (r = a.posAfter), o = !0), !a.contentDOM && r < 0 && !a.node.isText))
      return (a.node.isBlock ? i.top < (l.top + l.bottom) / 2 : i.left < (l.left + l.right) / 2) ? a.posBefore : a.posAfter;
    s = a.dom.parentNode;
  }
  return r > -1 ? r : n.docView.posFromDOM(e, t, -1);
}
function Mm(n, e, t) {
  let i = n.childNodes.length;
  if (i && t.top < t.bottom)
    for (let r = Math.max(0, Math.min(i - 1, Math.floor(i * (e.top - t.top) / (t.bottom - t.top)) - 2)), s = r; ; ) {
      let o = n.childNodes[s];
      if (o.nodeType == 1) {
        let a = o.getClientRects();
        for (let l = 0; l < a.length; l++) {
          let c = a[l];
          if (pu(e, c))
            return Mm(o, e, c);
        }
      }
      if ((s = (s + 1) % i) == r)
        break;
    }
  return n;
}
function Hy(n, e) {
  let t = n.dom.ownerDocument, i, r = 0, s = Ay(t, e.left, e.top);
  s && ({ node: i, offset: r } = s);
  let o = (n.root.elementFromPoint ? n.root : t).elementFromPoint(e.left, e.top), a;
  if (!o || !n.dom.contains(o.nodeType != 1 ? o.parentNode : o)) {
    let c = n.dom.getBoundingClientRect();
    if (!pu(e, c) || (o = Mm(n.dom, e, c), !o))
      return null;
  }
  if (Ot)
    for (let c = o; i && c; c = fr(c))
      c.draggable && (i = void 0);
  if (o = Dy(o, e), i) {
    if (on && i.nodeType == 1 && (r = Math.min(r, i.childNodes.length), r < i.childNodes.length)) {
      let u = i.childNodes[r], d;
      u.nodeName == "IMG" && (d = u.getBoundingClientRect()).right <= e.left && d.bottom > e.top && r++;
    }
    let c;
    Es && r && i.nodeType == 1 && (c = i.childNodes[r - 1]).nodeType == 1 && c.contentEditable == "false" && c.getBoundingClientRect().top >= e.top && r--, i == n.dom && r == i.childNodes.length - 1 && i.lastChild.nodeType == 1 && e.top > i.lastChild.getBoundingClientRect().bottom ? a = n.state.doc.content.size : (r == 0 || i.nodeType != 1 || i.childNodes[r - 1].nodeName != "BR") && (a = zy(n, i, r, e));
  }
  a == null && (a = $y(n, o, e));
  let l = n.docView.nearestDesc(o, !0);
  return { pos: a, inside: l ? l.posAtStart - l.border : -1 };
}
function oh(n) {
  return n.top < n.bottom || n.left < n.right;
}
function ei(n, e) {
  let t = n.getClientRects();
  if (t.length) {
    let i = t[e < 0 ? 0 : t.length - 1];
    if (oh(i))
      return i;
  }
  return Array.prototype.find.call(t, oh) || n.getBoundingClientRect();
}
const By = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function Om(n, e, t) {
  let { node: i, offset: r, atom: s } = n.docView.domFromPos(e, t < 0 ? -1 : 1), o = Es || on;
  if (i.nodeType == 3)
    if (o && (By.test(i.nodeValue) || (t < 0 ? !r : r == i.nodeValue.length))) {
      let l = ei(Fn(i, r, r), t);
      if (on && r && /\s/.test(i.nodeValue[r - 1]) && r < i.nodeValue.length) {
        let c = ei(Fn(i, r - 1, r - 1), -1);
        if (c.top == l.top) {
          let u = ei(Fn(i, r, r + 1), -1);
          if (u.top != l.top)
            return Nr(u, u.left < c.left);
        }
      }
      return l;
    } else {
      let l = r, c = r, u = t < 0 ? 1 : -1;
      return t < 0 && !r ? (c++, u = -1) : t >= 0 && r == i.nodeValue.length ? (l--, u = 1) : t < 0 ? l-- : c++, Nr(ei(Fn(i, l, c), u), u < 0);
    }
  if (!n.state.doc.resolve(e - (s || 0)).parent.inlineContent) {
    if (s == null && r && (t < 0 || r == sn(i))) {
      let l = i.childNodes[r - 1];
      if (l.nodeType == 1)
        return pl(l.getBoundingClientRect(), !1);
    }
    if (s == null && r < sn(i)) {
      let l = i.childNodes[r];
      if (l.nodeType == 1)
        return pl(l.getBoundingClientRect(), !0);
    }
    return pl(i.getBoundingClientRect(), t >= 0);
  }
  if (s == null && r && (t < 0 || r == sn(i))) {
    let l = i.childNodes[r - 1], c = l.nodeType == 3 ? Fn(l, sn(l) - (o ? 0 : 1)) : l.nodeType == 1 && (l.nodeName != "BR" || !l.nextSibling) ? l : null;
    if (c)
      return Nr(ei(c, 1), !1);
  }
  if (s == null && r < sn(i)) {
    let l = i.childNodes[r];
    for (; l.pmViewDesc && l.pmViewDesc.ignoreForCoords; )
      l = l.nextSibling;
    let c = l ? l.nodeType == 3 ? Fn(l, 0, o ? 0 : 1) : l.nodeType == 1 ? l : null : null;
    if (c)
      return Nr(ei(c, -1), !0);
  }
  return Nr(ei(i.nodeType == 3 ? Fn(i) : i, -t), t >= 0);
}
function Nr(n, e) {
  if (n.width == 0)
    return n;
  let t = e ? n.left : n.right;
  return { top: n.top, bottom: n.bottom, left: t, right: t };
}
function pl(n, e) {
  if (n.height == 0)
    return n;
  let t = e ? n.top : n.bottom;
  return { top: t, bottom: t, left: n.left, right: n.right };
}
function Nm(n, e, t) {
  let i = n.state, r = n.root.activeElement;
  i != e && n.updateState(e), r != n.dom && n.focus();
  try {
    return t();
  } finally {
    i != e && n.updateState(i), r != n.dom && r && r.focus();
  }
}
function Fy(n, e, t) {
  let i = e.selection, r = t == "up" ? i.$from : i.$to;
  return Nm(n, e, () => {
    let { node: s } = n.docView.domFromPos(r.pos, t == "up" ? -1 : 1);
    for (; ; ) {
      let a = n.docView.nearestDesc(s, !0);
      if (!a)
        break;
      if (a.node.isBlock) {
        s = a.contentDOM || a.dom;
        break;
      }
      s = a.dom.parentNode;
    }
    let o = Om(n, r.pos, 1);
    for (let a = s.firstChild; a; a = a.nextSibling) {
      let l;
      if (a.nodeType == 1)
        l = a.getClientRects();
      else if (a.nodeType == 3)
        l = Fn(a, 0, a.nodeValue.length).getClientRects();
      else
        continue;
      for (let c = 0; c < l.length; c++) {
        let u = l[c];
        if (u.bottom > u.top + 1 && (t == "up" ? o.top - u.top > (u.bottom - o.top) * 2 : u.bottom - o.bottom > (o.bottom - u.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const Vy = /[\u0590-\u08ac]/;
function jy(n, e, t) {
  let { $head: i } = e.selection;
  if (!i.parent.isTextblock)
    return !1;
  let r = i.parentOffset, s = !r, o = r == i.parent.content.size, a = n.domSelection();
  return a ? !Vy.test(i.parent.textContent) || !a.modify ? t == "left" || t == "backward" ? s : o : Nm(n, e, () => {
    let { focusNode: l, focusOffset: c, anchorNode: u, anchorOffset: d } = n.domSelectionRange(), h = a.caretBidiLevel;
    a.modify("move", t, "character");
    let f = i.depth ? n.docView.domAfterPos(i.before()) : n.dom, { focusNode: p, focusOffset: _ } = n.domSelectionRange(), m = p && !f.contains(p.nodeType == 1 ? p : p.parentNode) || l == p && c == _;
    try {
      a.collapse(u, d), l && (l != u || c != d) && a.extend && a.extend(l, c);
    } catch {
    }
    return h != null && (a.caretBidiLevel = h), m;
  }) : i.pos == i.start() || i.pos == i.end();
}
let ah = null, lh = null, ch = !1;
function Wy(n, e, t) {
  return ah == e && lh == t ? ch : (ah = e, lh = t, ch = t == "up" || t == "down" ? Fy(n, e, t) : jy(n, e, t));
}
const an = 0, uh = 1, ki = 2, Ln = 3;
class Cs {
  constructor(e, t, i, r) {
    this.parent = e, this.children = t, this.dom = i, this.contentDOM = r, this.dirty = an, i.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(e) {
    return !1;
  }
  matchesMark(e) {
    return !1;
  }
  matchesNode(e, t, i) {
    return !1;
  }
  matchesHack(e) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(e) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let e = 0;
    for (let t = 0; t < this.children.length; t++)
      e += this.children[t].size;
    return e;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let e = 0; e < this.children.length; e++)
      this.children[e].destroy();
  }
  posBeforeChild(e) {
    for (let t = 0, i = this.posAtStart; ; t++) {
      let r = this.children[t];
      if (r == e)
        return i;
      i += r.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(e, t, i) {
    if (this.contentDOM && this.contentDOM.contains(e.nodeType == 1 ? e : e.parentNode))
      if (i < 0) {
        let s, o;
        if (e == this.contentDOM)
          s = e.childNodes[t - 1];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          s = e.previousSibling;
        }
        for (; s && !((o = s.pmViewDesc) && o.parent == this); )
          s = s.previousSibling;
        return s ? this.posBeforeChild(o) + o.size : this.posAtStart;
      } else {
        let s, o;
        if (e == this.contentDOM)
          s = e.childNodes[t];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          s = e.nextSibling;
        }
        for (; s && !((o = s.pmViewDesc) && o.parent == this); )
          s = s.nextSibling;
        return s ? this.posBeforeChild(o) : this.posAtEnd;
      }
    let r;
    if (e == this.dom && this.contentDOM)
      r = t > wt(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      r = e.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (t == 0)
        for (let s = e; ; s = s.parentNode) {
          if (s == this.dom) {
            r = !1;
            break;
          }
          if (s.previousSibling)
            break;
        }
      if (r == null && t == e.childNodes.length)
        for (let s = e; ; s = s.parentNode) {
          if (s == this.dom) {
            r = !0;
            break;
          }
          if (s.nextSibling)
            break;
        }
    }
    return r ?? i > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(e, t = !1) {
    for (let i = !0, r = e; r; r = r.parentNode) {
      let s = this.getDesc(r), o;
      if (s && (!t || s.node))
        if (i && (o = s.nodeDOM) && !(o.nodeType == 1 ? o.contains(e.nodeType == 1 ? e : e.parentNode) : o == e))
          i = !1;
        else
          return s;
    }
  }
  getDesc(e) {
    let t = e.pmViewDesc;
    for (let i = t; i; i = i.parent)
      if (i == this)
        return t;
  }
  posFromDOM(e, t, i) {
    for (let r = e; r; r = r.parentNode) {
      let s = this.getDesc(r);
      if (s)
        return s.localPosFromDOM(e, t, i);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(e) {
    for (let t = 0, i = 0; t < this.children.length; t++) {
      let r = this.children[t], s = i + r.size;
      if (i == e && s != i) {
        for (; !r.border && r.children.length; )
          for (let o = 0; o < r.children.length; o++) {
            let a = r.children[o];
            if (a.size) {
              r = a;
              break;
            }
          }
        return r;
      }
      if (e < s)
        return r.descAt(e - i - r.border);
      i = s;
    }
  }
  domFromPos(e, t) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: e + 1 };
    let i = 0, r = 0;
    for (let s = 0; i < this.children.length; i++) {
      let o = this.children[i], a = s + o.size;
      if (a > e || o instanceof Rm) {
        r = e - s;
        break;
      }
      s = a;
    }
    if (r)
      return this.children[i].domFromPos(r - this.children[i].border, t);
    for (let s; i && !(s = this.children[i - 1]).size && s instanceof Lm && s.side >= 0; i--)
      ;
    if (t <= 0) {
      let s, o = !0;
      for (; s = i ? this.children[i - 1] : null, !(!s || s.dom.parentNode == this.contentDOM); i--, o = !1)
        ;
      return s && t && o && !s.border && !s.domAtom ? s.domFromPos(s.size, t) : { node: this.contentDOM, offset: s ? wt(s.dom) + 1 : 0 };
    } else {
      let s, o = !0;
      for (; s = i < this.children.length ? this.children[i] : null, !(!s || s.dom.parentNode == this.contentDOM); i++, o = !1)
        ;
      return s && o && !s.border && !s.domAtom ? s.domFromPos(0, t) : { node: this.contentDOM, offset: s ? wt(s.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(e, t, i = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: e, to: t, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let r = -1, s = -1;
    for (let o = i, a = 0; ; a++) {
      let l = this.children[a], c = o + l.size;
      if (r == -1 && e <= c) {
        let u = o + l.border;
        if (e >= u && t <= c - l.border && l.node && l.contentDOM && this.contentDOM.contains(l.contentDOM))
          return l.parseRange(e, t, u);
        e = o;
        for (let d = a; d > 0; d--) {
          let h = this.children[d - 1];
          if (h.size && h.dom.parentNode == this.contentDOM && !h.emptyChildAt(1)) {
            r = wt(h.dom) + 1;
            break;
          }
          e -= h.size;
        }
        r == -1 && (r = 0);
      }
      if (r > -1 && (c > t || a == this.children.length - 1)) {
        t = c;
        for (let u = a + 1; u < this.children.length; u++) {
          let d = this.children[u];
          if (d.size && d.dom.parentNode == this.contentDOM && !d.emptyChildAt(-1)) {
            s = wt(d.dom);
            break;
          }
          t += d.size;
        }
        s == -1 && (s = this.contentDOM.childNodes.length);
        break;
      }
      o = c;
    }
    return { node: this.contentDOM, from: e, to: t, fromOffset: r, toOffset: s };
  }
  emptyChildAt(e) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let t = this.children[e < 0 ? 0 : this.children.length - 1];
    return t.size == 0 || t.emptyChildAt(e);
  }
  domAfterPos(e) {
    let { node: t, offset: i } = this.domFromPos(e, 0);
    if (t.nodeType != 1 || i == t.childNodes.length)
      throw new RangeError("No node after pos " + e);
    return t.childNodes[i];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(e, t, i, r = !1) {
    let s = Math.min(e, t), o = Math.max(e, t);
    for (let f = 0, p = 0; f < this.children.length; f++) {
      let _ = this.children[f], m = p + _.size;
      if (s > p && o < m)
        return _.setSelection(e - p - _.border, t - p - _.border, i, r);
      p = m;
    }
    let a = this.domFromPos(e, e ? -1 : 1), l = t == e ? a : this.domFromPos(t, t ? -1 : 1), c = i.root.getSelection(), u = i.domSelectionRange(), d = !1;
    if ((on || Ot) && e == t) {
      let { node: f, offset: p } = a;
      if (f.nodeType == 3) {
        if (d = !!(p && f.nodeValue[p - 1] == `
`), d && p == f.nodeValue.length)
          for (let _ = f, m; _; _ = _.parentNode) {
            if (m = _.nextSibling) {
              m.nodeName == "BR" && (a = l = { node: m.parentNode, offset: wt(m) + 1 });
              break;
            }
            let g = _.pmViewDesc;
            if (g && g.node && g.node.isBlock)
              break;
          }
      } else {
        let _ = f.childNodes[p - 1];
        d = _ && (_.nodeName == "BR" || _.contentEditable == "false");
      }
    }
    if (on && u.focusNode && u.focusNode != l.node && u.focusNode.nodeType == 1) {
      let f = u.focusNode.childNodes[u.focusOffset];
      f && f.contentEditable == "false" && (r = !0);
    }
    if (!(r || d && Ot) && Ri(a.node, a.offset, u.anchorNode, u.anchorOffset) && Ri(l.node, l.offset, u.focusNode, u.focusOffset))
      return;
    let h = !1;
    if ((c.extend || e == t) && !(d && on)) {
      c.collapse(a.node, a.offset);
      try {
        e != t && c.extend(l.node, l.offset), h = !0;
      } catch {
      }
    }
    if (!h) {
      if (e > t) {
        let p = a;
        a = l, l = p;
      }
      let f = document.createRange();
      f.setEnd(l.node, l.offset), f.setStart(a.node, a.offset), c.removeAllRanges(), c.addRange(f);
    }
  }
  ignoreMutation(e) {
    return !this.contentDOM && e.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(e, t) {
    for (let i = 0, r = 0; r < this.children.length; r++) {
      let s = this.children[r], o = i + s.size;
      if (i == o ? e <= o && t >= i : e < o && t > i) {
        let a = i + s.border, l = o - s.border;
        if (e >= a && t <= l) {
          this.dirty = e == i || t == o ? ki : uh, e == a && t == l && (s.contentLost || s.dom.parentNode != this.contentDOM) ? s.dirty = Ln : s.markDirty(e - a, t - a);
          return;
        } else
          s.dirty = s.dom == s.contentDOM && s.dom.parentNode == this.contentDOM && !s.children.length ? ki : Ln;
      }
      i = o;
    }
    this.dirty = ki;
  }
  markParentsDirty() {
    let e = 1;
    for (let t = this.parent; t; t = t.parent, e++) {
      let i = e == 1 ? ki : uh;
      t.dirty < i && (t.dirty = i);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  get ignoreForSelection() {
    return !1;
  }
  isText(e) {
    return !1;
  }
}
class Lm extends Cs {
  constructor(e, t, i, r) {
    let s, o = t.type.toDOM;
    if (typeof o == "function" && (o = o(i, () => {
      if (!s)
        return r;
      if (s.parent)
        return s.parent.posBeforeChild(s);
    })), !t.type.spec.raw) {
      if (o.nodeType != 1) {
        let a = document.createElement("span");
        a.appendChild(o), o = a;
      }
      o.contentEditable = "false", o.classList.add("ProseMirror-widget");
    }
    super(e, [], o, null), this.widget = t, this.widget = t, s = this;
  }
  matchesWidget(e) {
    return this.dirty == an && e.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(e) {
    let t = this.widget.spec.stopEvent;
    return t ? t(e) : !1;
  }
  ignoreMutation(e) {
    return e.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get ignoreForSelection() {
    return !!this.widget.type.spec.relaxedSide;
  }
  get side() {
    return this.widget.type.side;
  }
}
class Uy extends Cs {
  constructor(e, t, i, r) {
    super(e, [], t, null), this.textDOM = i, this.text = r;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(e, t) {
    return e != this.textDOM ? this.posAtStart + (t ? this.size : 0) : this.posAtStart + t;
  }
  domFromPos(e) {
    return { node: this.textDOM, offset: e };
  }
  ignoreMutation(e) {
    return e.type === "characterData" && e.target.nodeValue == e.oldValue;
  }
}
class Ii extends Cs {
  constructor(e, t, i, r, s) {
    super(e, [], i, r), this.mark = t, this.spec = s;
  }
  static create(e, t, i, r) {
    let s = r.nodeViews[t.type.name], o = s && s(t, r, i);
    return (!o || !o.dom) && (o = zi.renderSpec(document, t.type.spec.toDOM(t, i), null, t.attrs)), new Ii(e, t, o.dom, o.contentDOM || o.dom, o);
  }
  parseRule() {
    return this.dirty & Ln || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(e) {
    return this.dirty != Ln && this.mark.eq(e);
  }
  markDirty(e, t) {
    if (super.markDirty(e, t), this.dirty != an) {
      let i = this.parent;
      for (; !i.node; )
        i = i.parent;
      i.dirty < this.dirty && (i.dirty = this.dirty), this.dirty = an;
    }
  }
  slice(e, t, i) {
    let r = Ii.create(this.parent, this.mark, !0, i), s = this.children, o = this.size;
    t < o && (s = yc(s, t, o, i)), e > 0 && (s = yc(s, 0, e, i));
    for (let a = 0; a < s.length; a++)
      s[a].parent = r;
    return r.children = s, r;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class fi extends Cs {
  constructor(e, t, i, r, s, o, a, l, c) {
    super(e, [], s, o), this.node = t, this.outerDeco = i, this.innerDeco = r, this.nodeDOM = a;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(e, t, i, r, s, o) {
    let a = s.nodeViews[t.type.name], l, c = a && a(t, s, () => {
      if (!l)
        return o;
      if (l.parent)
        return l.parent.posBeforeChild(l);
    }, i, r), u = c && c.dom, d = c && c.contentDOM;
    if (t.isText) {
      if (!u)
        u = document.createTextNode(t.text);
      else if (u.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else u || ({ dom: u, contentDOM: d } = zi.renderSpec(document, t.type.spec.toDOM(t), null, t.attrs));
    !d && !t.isText && u.nodeName != "BR" && (u.hasAttribute("contenteditable") || (u.contentEditable = "false"), t.type.spec.draggable && (u.draggable = !0));
    let h = u;
    return u = Dm(u, i, t), c ? l = new Ky(e, t, i, r, u, d || null, h, c, s, o + 1) : t.isText ? new Ma(e, t, i, r, u, h, s) : new fi(e, t, i, r, u, d || null, h, s, o + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let e = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (e.preserveWhitespace = "full"), !this.contentDOM)
      e.getContent = () => this.node.content;
    else if (!this.contentLost)
      e.contentElement = this.contentDOM;
    else {
      for (let t = this.children.length - 1; t >= 0; t--) {
        let i = this.children[t];
        if (this.dom.contains(i.dom.parentNode)) {
          e.contentElement = i.dom.parentNode;
          break;
        }
      }
      e.contentElement || (e.getContent = () => $.empty);
    }
    return e;
  }
  matchesNode(e, t, i) {
    return this.dirty == an && e.eq(this.node) && Io(t, this.outerDeco) && i.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(e, t) {
    let i = this.node.inlineContent, r = t, s = e.composing ? this.localCompositionInfo(e, t) : null, o = s && s.pos > -1 ? s : null, a = s && s.pos < 0, l = new Gy(this, o && o.node, e);
    Yy(this.node, this.innerDeco, (c, u, d) => {
      c.spec.marks ? l.syncToMarks(c.spec.marks, i, e) : c.type.side >= 0 && !d && l.syncToMarks(u == this.node.childCount ? $e.none : this.node.child(u).marks, i, e), l.placeWidget(c, e, r);
    }, (c, u, d, h) => {
      l.syncToMarks(c.marks, i, e);
      let f;
      l.findNodeMatch(c, u, d, h) || a && e.state.selection.from > r && e.state.selection.to < r + c.nodeSize && (f = l.findIndexWithChild(s.node)) > -1 && l.updateNodeAt(c, u, d, f, e) || l.updateNextNode(c, u, d, e, h, r) || l.addNode(c, u, d, e, r), r += c.nodeSize;
    }), l.syncToMarks([], i, e), this.node.isTextblock && l.addTextblockHacks(), l.destroyRest(), (l.changed || this.dirty == ki) && (o && this.protectLocalComposition(e, o), Im(this.contentDOM, this.children, e), pr && Zy(this.dom));
  }
  localCompositionInfo(e, t) {
    let { from: i, to: r } = e.state.selection;
    if (!(e.state.selection instanceof ue) || i < t || r > t + this.node.content.size)
      return null;
    let s = e.input.compositionNode;
    if (!s || !this.dom.contains(s.parentNode))
      return null;
    if (this.node.inlineContent) {
      let o = s.nodeValue, a = Qy(this.node.content, o, i - t, r - t);
      return a < 0 ? null : { node: s, pos: a, text: o };
    } else
      return { node: s, pos: -1, text: "" };
  }
  protectLocalComposition(e, { node: t, pos: i, text: r }) {
    if (this.getDesc(t))
      return;
    let s = t;
    for (; s.parentNode != this.contentDOM; s = s.parentNode) {
      for (; s.previousSibling; )
        s.parentNode.removeChild(s.previousSibling);
      for (; s.nextSibling; )
        s.parentNode.removeChild(s.nextSibling);
      s.pmViewDesc && (s.pmViewDesc = void 0);
    }
    let o = new Uy(this, s, t, r);
    e.input.compositionNodes.push(o), this.children = yc(this.children, i, i + r.length, e, o);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(e, t, i, r) {
    return this.dirty == Ln || !e.sameMarkup(this.node) ? !1 : (this.updateInner(e, t, i, r), !0);
  }
  updateInner(e, t, i, r) {
    this.updateOuterDeco(t), this.node = e, this.innerDeco = i, this.contentDOM && this.updateChildren(r, this.posAtStart), this.dirty = an;
  }
  updateOuterDeco(e) {
    if (Io(e, this.outerDeco))
      return;
    let t = this.nodeDOM.nodeType != 1, i = this.dom;
    this.dom = Pm(this.dom, this.nodeDOM, vc(this.outerDeco, this.node, t), vc(e, this.node, t)), this.dom != i && (i.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = e;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.nodeDOM.draggable = !0));
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.nodeDOM.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function dh(n, e, t, i, r) {
  Dm(i, e, n);
  let s = new fi(void 0, n, e, t, i, i, i, r, 0);
  return s.contentDOM && s.updateChildren(r, 0), s;
}
class Ma extends fi {
  constructor(e, t, i, r, s, o, a) {
    super(e, t, i, r, s, null, o, a, 0);
  }
  parseRule() {
    let e = this.nodeDOM.parentNode;
    for (; e && e != this.dom && !e.pmIsDeco; )
      e = e.parentNode;
    return { skip: e || !0 };
  }
  update(e, t, i, r) {
    return this.dirty == Ln || this.dirty != an && !this.inParent() || !e.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(t), (this.dirty != an || e.text != this.node.text) && e.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = e.text, r.trackWrites == this.nodeDOM && (r.trackWrites = null)), this.node = e, this.dirty = an, !0);
  }
  inParent() {
    let e = this.parent.contentDOM;
    for (let t = this.nodeDOM; t; t = t.parentNode)
      if (t == e)
        return !0;
    return !1;
  }
  domFromPos(e) {
    return { node: this.nodeDOM, offset: e };
  }
  localPosFromDOM(e, t, i) {
    return e == this.nodeDOM ? this.posAtStart + Math.min(t, this.node.text.length) : super.localPosFromDOM(e, t, i);
  }
  ignoreMutation(e) {
    return e.type != "characterData" && e.type != "selection";
  }
  slice(e, t, i) {
    let r = this.node.cut(e, t), s = document.createTextNode(r.text);
    return new Ma(this.parent, r, this.outerDeco, this.innerDeco, s, s, i);
  }
  markDirty(e, t) {
    super.markDirty(e, t), this.dom != this.nodeDOM && (e == 0 || t == this.nodeDOM.nodeValue.length) && (this.dirty = Ln);
  }
  get domAtom() {
    return !1;
  }
  isText(e) {
    return this.node.text == e;
  }
}
class Rm extends Cs {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(e) {
    return this.dirty == an && this.dom.nodeName == e;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class Ky extends fi {
  constructor(e, t, i, r, s, o, a, l, c, u) {
    super(e, t, i, r, s, o, a, c, u), this.spec = l;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(e, t, i, r) {
    if (this.dirty == Ln)
      return !1;
    if (this.spec.update && (this.node.type == e.type || this.spec.multiType)) {
      let s = this.spec.update(e, t, i);
      return s && this.updateInner(e, t, i, r), s;
    } else return !this.contentDOM && !e.isLeaf ? !1 : super.update(e, t, i, r);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(e, t, i, r) {
    this.spec.setSelection ? this.spec.setSelection(e, t, i.root) : super.setSelection(e, t, i, r);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(e) {
    return this.spec.stopEvent ? this.spec.stopEvent(e) : !1;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
}
function Im(n, e, t) {
  let i = n.firstChild, r = !1;
  for (let s = 0; s < e.length; s++) {
    let o = e[s], a = o.dom;
    if (a.parentNode == n) {
      for (; a != i; )
        i = hh(i), r = !0;
      i = i.nextSibling;
    } else
      r = !0, n.insertBefore(a, i);
    if (o instanceof Ii) {
      let l = i ? i.previousSibling : n.lastChild;
      Im(o.contentDOM, o.children, t), i = l ? l.nextSibling : n.firstChild;
    }
  }
  for (; i; )
    i = hh(i), r = !0;
  r && t.trackWrites == n && (t.trackWrites = null);
}
const Zr = function(n) {
  n && (this.nodeName = n);
};
Zr.prototype = /* @__PURE__ */ Object.create(null);
const Si = [new Zr()];
function vc(n, e, t) {
  if (n.length == 0)
    return Si;
  let i = t ? Si[0] : new Zr(), r = [i];
  for (let s = 0; s < n.length; s++) {
    let o = n[s].type.attrs;
    if (o) {
      o.nodeName && r.push(i = new Zr(o.nodeName));
      for (let a in o) {
        let l = o[a];
        l != null && (t && r.length == 1 && r.push(i = new Zr(e.isInline ? "span" : "div")), a == "class" ? i.class = (i.class ? i.class + " " : "") + l : a == "style" ? i.style = (i.style ? i.style + ";" : "") + l : a != "nodeName" && (i[a] = l));
      }
    }
  }
  return r;
}
function Pm(n, e, t, i) {
  if (t == Si && i == Si)
    return e;
  let r = e;
  for (let s = 0; s < i.length; s++) {
    let o = i[s], a = t[s];
    if (s) {
      let l;
      a && a.nodeName == o.nodeName && r != n && (l = r.parentNode) && l.nodeName.toLowerCase() == o.nodeName || (l = document.createElement(o.nodeName), l.pmIsDeco = !0, l.appendChild(r), a = Si[0]), r = l;
    }
    qy(r, a || Si[0], o);
  }
  return r;
}
function qy(n, e, t) {
  for (let i in e)
    i != "class" && i != "style" && i != "nodeName" && !(i in t) && n.removeAttribute(i);
  for (let i in t)
    i != "class" && i != "style" && i != "nodeName" && t[i] != e[i] && n.setAttribute(i, t[i]);
  if (e.class != t.class) {
    let i = e.class ? e.class.split(" ").filter(Boolean) : [], r = t.class ? t.class.split(" ").filter(Boolean) : [];
    for (let s = 0; s < i.length; s++)
      r.indexOf(i[s]) == -1 && n.classList.remove(i[s]);
    for (let s = 0; s < r.length; s++)
      i.indexOf(r[s]) == -1 && n.classList.add(r[s]);
    n.classList.length == 0 && n.removeAttribute("class");
  }
  if (e.style != t.style) {
    if (e.style) {
      let i = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, r;
      for (; r = i.exec(e.style); )
        n.style.removeProperty(r[1]);
    }
    t.style && (n.style.cssText += t.style);
  }
}
function Dm(n, e, t) {
  return Pm(n, n, Si, vc(e, t, n.nodeType != 1));
}
function Io(n, e) {
  if (n.length != e.length)
    return !1;
  for (let t = 0; t < n.length; t++)
    if (!n[t].type.eq(e[t].type))
      return !1;
  return !0;
}
function hh(n) {
  let e = n.nextSibling;
  return n.parentNode.removeChild(n), e;
}
class Gy {
  constructor(e, t, i) {
    this.lock = t, this.view = i, this.index = 0, this.stack = [], this.changed = !1, this.top = e, this.preMatch = Jy(e.node.content, e);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(e, t) {
    if (e != t) {
      for (let i = e; i < t; i++)
        this.top.children[i].destroy();
      this.top.children.splice(e, t - e), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(e, t, i) {
    let r = 0, s = this.stack.length >> 1, o = Math.min(s, e.length);
    for (; r < o && (r == s - 1 ? this.top : this.stack[r + 1 << 1]).matchesMark(e[r]) && e[r].type.spec.spanning !== !1; )
      r++;
    for (; r < s; )
      this.destroyRest(), this.top.dirty = an, this.index = this.stack.pop(), this.top = this.stack.pop(), s--;
    for (; s < e.length; ) {
      this.stack.push(this.top, this.index + 1);
      let a = -1;
      for (let l = this.index; l < Math.min(this.index + 3, this.top.children.length); l++) {
        let c = this.top.children[l];
        if (c.matchesMark(e[s]) && !this.isLocked(c.dom)) {
          a = l;
          break;
        }
      }
      if (a > -1)
        a > this.index && (this.changed = !0, this.destroyBetween(this.index, a)), this.top = this.top.children[this.index];
      else {
        let l = Ii.create(this.top, e[s], t, i);
        this.top.children.splice(this.index, 0, l), this.top = l, this.changed = !0;
      }
      this.index = 0, s++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(e, t, i, r) {
    let s = -1, o;
    if (r >= this.preMatch.index && (o = this.preMatch.matches[r - this.preMatch.index]).parent == this.top && o.matchesNode(e, t, i))
      s = this.top.children.indexOf(o, this.index);
    else
      for (let a = this.index, l = Math.min(this.top.children.length, a + 5); a < l; a++) {
        let c = this.top.children[a];
        if (c.matchesNode(e, t, i) && !this.preMatch.matched.has(c)) {
          s = a;
          break;
        }
      }
    return s < 0 ? !1 : (this.destroyBetween(this.index, s), this.index++, !0);
  }
  updateNodeAt(e, t, i, r, s) {
    let o = this.top.children[r];
    return o.dirty == Ln && o.dom == o.contentDOM && (o.dirty = ki), o.update(e, t, i, s) ? (this.destroyBetween(this.index, r), this.index++, !0) : !1;
  }
  findIndexWithChild(e) {
    for (; ; ) {
      let t = e.parentNode;
      if (!t)
        return -1;
      if (t == this.top.contentDOM) {
        let i = e.pmViewDesc;
        if (i) {
          for (let r = this.index; r < this.top.children.length; r++)
            if (this.top.children[r] == i)
              return r;
        }
        return -1;
      }
      e = t;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(e, t, i, r, s, o) {
    for (let a = this.index; a < this.top.children.length; a++) {
      let l = this.top.children[a];
      if (l instanceof fi) {
        let c = this.preMatch.matched.get(l);
        if (c != null && c != s)
          return !1;
        let u = l.dom, d, h = this.isLocked(u) && !(e.isText && l.node && l.node.isText && l.nodeDOM.nodeValue == e.text && l.dirty != Ln && Io(t, l.outerDeco));
        if (!h && l.update(e, t, i, r))
          return this.destroyBetween(this.index, a), l.dom != u && (this.changed = !0), this.index++, !0;
        if (!h && (d = this.recreateWrapper(l, e, t, i, r, o)))
          return this.destroyBetween(this.index, a), this.top.children[this.index] = d, d.contentDOM && (d.dirty = ki, d.updateChildren(r, o + 1), d.dirty = an), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(e, t, i, r, s, o) {
    if (e.dirty || t.isAtom || !e.children.length || !e.node.content.eq(t.content) || !Io(i, e.outerDeco) || !r.eq(e.innerDeco))
      return null;
    let a = fi.create(this.top, t, i, r, s, o);
    if (a.contentDOM) {
      a.children = e.children, e.children = [];
      for (let l of a.children)
        l.parent = a;
    }
    return e.destroy(), a;
  }
  // Insert the node as a newly created node desc.
  addNode(e, t, i, r, s) {
    let o = fi.create(this.top, e, t, i, r, s);
    o.contentDOM && o.updateChildren(r, s + 1), this.top.children.splice(this.index++, 0, o), this.changed = !0;
  }
  placeWidget(e, t, i) {
    let r = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (r && r.matchesWidget(e) && (e == r.widget || !r.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let s = new Lm(this.top, e, t, i);
      this.top.children.splice(this.index++, 0, s), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let e = this.top.children[this.index - 1], t = this.top;
    for (; e instanceof Ii; )
      t = e, e = t.children[t.children.length - 1];
    (!e || // Empty textblock
    !(e instanceof Ma) || /\n$/.test(e.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(e.node.text)) && ((Ot || mt) && e && e.dom.contentEditable == "false" && this.addHackNode("IMG", t), this.addHackNode("BR", this.top));
  }
  addHackNode(e, t) {
    if (t == this.top && this.index < t.children.length && t.children[this.index].matchesHack(e))
      this.index++;
    else {
      let i = document.createElement(e);
      e == "IMG" && (i.className = "ProseMirror-separator", i.alt = ""), e == "BR" && (i.className = "ProseMirror-trailingBreak");
      let r = new Rm(this.top, [], i, null);
      t != this.top ? t.children.push(r) : t.children.splice(this.index++, 0, r), this.changed = !0;
    }
  }
  isLocked(e) {
    return this.lock && (e == this.lock || e.nodeType == 1 && e.contains(this.lock.parentNode));
  }
}
function Jy(n, e) {
  let t = e, i = t.children.length, r = n.childCount, s = /* @__PURE__ */ new Map(), o = [];
  e: for (; r > 0; ) {
    let a;
    for (; ; )
      if (i) {
        let c = t.children[i - 1];
        if (c instanceof Ii)
          t = c, i = c.children.length;
        else {
          a = c, i--;
          break;
        }
      } else {
        if (t == e)
          break e;
        i = t.parent.children.indexOf(t), t = t.parent;
      }
    let l = a.node;
    if (l) {
      if (l != n.child(r - 1))
        break;
      --r, s.set(a, r), o.push(a);
    }
  }
  return { index: r, matched: s, matches: o.reverse() };
}
function Xy(n, e) {
  return n.type.side - e.type.side;
}
function Yy(n, e, t, i) {
  let r = e.locals(n), s = 0;
  if (r.length == 0) {
    for (let c = 0; c < n.childCount; c++) {
      let u = n.child(c);
      i(u, r, e.forChild(s, u), c), s += u.nodeSize;
    }
    return;
  }
  let o = 0, a = [], l = null;
  for (let c = 0; ; ) {
    let u, d;
    for (; o < r.length && r[o].to == s; ) {
      let m = r[o++];
      m.widget && (u ? (d || (d = [u])).push(m) : u = m);
    }
    if (u)
      if (d) {
        d.sort(Xy);
        for (let m = 0; m < d.length; m++)
          t(d[m], c, !!l);
      } else
        t(u, c, !!l);
    let h, f;
    if (l)
      f = -1, h = l, l = null;
    else if (c < n.childCount)
      f = c, h = n.child(c++);
    else
      break;
    for (let m = 0; m < a.length; m++)
      a[m].to <= s && a.splice(m--, 1);
    for (; o < r.length && r[o].from <= s && r[o].to > s; )
      a.push(r[o++]);
    let p = s + h.nodeSize;
    if (h.isText) {
      let m = p;
      o < r.length && r[o].from < m && (m = r[o].from);
      for (let g = 0; g < a.length; g++)
        a[g].to < m && (m = a[g].to);
      m < p && (l = h.cut(m - s), h = h.cut(0, m - s), p = m, f = -1);
    } else
      for (; o < r.length && r[o].to < p; )
        o++;
    let _ = h.isInline && !h.isLeaf ? a.filter((m) => !m.inline) : a.slice();
    i(h, _, e.forChild(s, h), f), s = p;
  }
}
function Zy(n) {
  if (n.nodeName == "UL" || n.nodeName == "OL") {
    let e = n.style.cssText;
    n.style.cssText = e + "; list-style: square !important", window.getComputedStyle(n).listStyle, n.style.cssText = e;
  }
}
function Qy(n, e, t, i) {
  for (let r = 0, s = 0; r < n.childCount && s <= i; ) {
    let o = n.child(r++), a = s;
    if (s += o.nodeSize, !o.isText)
      continue;
    let l = o.text;
    for (; r < n.childCount; ) {
      let c = n.child(r++);
      if (s += c.nodeSize, !c.isText)
        break;
      l += c.text;
    }
    if (s >= t) {
      if (s >= i && l.slice(i - e.length - a, i - a) == e)
        return i - e.length;
      let c = a < i ? l.lastIndexOf(e, i - a - 1) : -1;
      if (c >= 0 && c + e.length + a >= t)
        return a + c;
      if (t == i && l.length >= i + e.length - a && l.slice(i - a, i - a + e.length) == e)
        return i;
    }
  }
  return -1;
}
function yc(n, e, t, i, r) {
  let s = [];
  for (let o = 0, a = 0; o < n.length; o++) {
    let l = n[o], c = a, u = a += l.size;
    c >= t || u <= e ? s.push(l) : (c < e && s.push(l.slice(0, e - c, i)), r && (s.push(r), r = void 0), u > t && s.push(l.slice(t - c, l.size, i)));
  }
  return s;
}
function mu(n, e = null) {
  let t = n.domSelectionRange(), i = n.state.doc;
  if (!t.focusNode)
    return null;
  let r = n.docView.nearestDesc(t.focusNode), s = r && r.size == 0, o = n.docView.posFromDOM(t.focusNode, t.focusOffset, 1);
  if (o < 0)
    return null;
  let a = i.resolve(o), l, c;
  if (Aa(t)) {
    for (l = o; r && !r.node; )
      r = r.parent;
    let d = r.node;
    if (r && d.isAtom && re.isSelectable(d) && r.parent && !(d.isInline && Cy(t.focusNode, t.focusOffset, r.dom))) {
      let h = r.posBefore;
      c = new re(o == h ? a : i.resolve(h));
    }
  } else {
    if (t instanceof n.dom.ownerDocument.defaultView.Selection && t.rangeCount > 1) {
      let d = o, h = o;
      for (let f = 0; f < t.rangeCount; f++) {
        let p = t.getRangeAt(f);
        d = Math.min(d, n.docView.posFromDOM(p.startContainer, p.startOffset, 1)), h = Math.max(h, n.docView.posFromDOM(p.endContainer, p.endOffset, -1));
      }
      if (d < 0)
        return null;
      [l, o] = h == n.state.selection.anchor ? [h, d] : [d, h], a = i.resolve(o);
    } else
      l = n.docView.posFromDOM(t.anchorNode, t.anchorOffset, 1);
    if (l < 0)
      return null;
  }
  let u = i.resolve(l);
  if (!c) {
    let d = e == "pointer" || n.state.selection.head < a.pos && !s ? 1 : -1;
    c = gu(n, u, a, d);
  }
  return c;
}
function $m(n) {
  return n.editable ? n.hasFocus() : Hm(n) && document.activeElement && document.activeElement.contains(n.dom);
}
function Kn(n, e = !1) {
  let t = n.state.selection;
  if (zm(n, t), !!$m(n)) {
    if (!e && n.input.mouseDown && n.input.mouseDown.allowDefault && mt) {
      let i = n.domSelectionRange(), r = n.domObserver.currentSelection;
      if (i.anchorNode && r.anchorNode && Ri(i.anchorNode, i.anchorOffset, r.anchorNode, r.anchorOffset)) {
        n.input.mouseDown.delayedSelectionSync = !0, n.domObserver.setCurSelection();
        return;
      }
    }
    if (n.domObserver.disconnectSelection(), n.cursorWrapper)
      tx(n);
    else {
      let { anchor: i, head: r } = t, s, o;
      fh && !(t instanceof ue) && (t.$from.parent.inlineContent || (s = ph(n, t.from)), !t.empty && !t.$from.parent.inlineContent && (o = ph(n, t.to))), n.docView.setSelection(i, r, n, e), fh && (s && mh(s), o && mh(o)), t.visible ? n.dom.classList.remove("ProseMirror-hideselection") : (n.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && ex(n));
    }
    n.domObserver.setCurSelection(), n.domObserver.connectSelection();
  }
}
const fh = Ot || mt && Sm < 63;
function ph(n, e) {
  let { node: t, offset: i } = n.docView.domFromPos(e, 0), r = i < t.childNodes.length ? t.childNodes[i] : null, s = i ? t.childNodes[i - 1] : null;
  if (Ot && r && r.contentEditable == "false")
    return ml(r);
  if ((!r || r.contentEditable == "false") && (!s || s.contentEditable == "false")) {
    if (r)
      return ml(r);
    if (s)
      return ml(s);
  }
}
function ml(n) {
  return n.contentEditable = "true", Ot && n.draggable && (n.draggable = !1, n.wasDraggable = !0), n;
}
function mh(n) {
  n.contentEditable = "false", n.wasDraggable && (n.draggable = !0, n.wasDraggable = null);
}
function ex(n) {
  let e = n.dom.ownerDocument;
  e.removeEventListener("selectionchange", n.input.hideSelectionGuard);
  let t = n.domSelectionRange(), i = t.anchorNode, r = t.anchorOffset;
  e.addEventListener("selectionchange", n.input.hideSelectionGuard = () => {
    (t.anchorNode != i || t.anchorOffset != r) && (e.removeEventListener("selectionchange", n.input.hideSelectionGuard), setTimeout(() => {
      (!$m(n) || n.state.selection.visible) && n.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function tx(n) {
  let e = n.domSelection();
  if (!e)
    return;
  let t = n.cursorWrapper.dom, i = t.nodeName == "IMG";
  i ? e.collapse(t.parentNode, wt(t) + 1) : e.collapse(t, 0), !i && !n.state.selection.visible && Ut && hi <= 11 && (t.disabled = !0, t.disabled = !1);
}
function zm(n, e) {
  if (e instanceof re) {
    let t = n.docView.descAt(e.from);
    t != n.lastSelectedViewDesc && (gh(n), t && t.selectNode(), n.lastSelectedViewDesc = t);
  } else
    gh(n);
}
function gh(n) {
  n.lastSelectedViewDesc && (n.lastSelectedViewDesc.parent && n.lastSelectedViewDesc.deselectNode(), n.lastSelectedViewDesc = void 0);
}
function gu(n, e, t, i) {
  return n.someProp("createSelectionBetween", (r) => r(n, e, t)) || ue.between(e, t, i);
}
function _h(n) {
  return n.editable && !n.hasFocus() ? !1 : Hm(n);
}
function Hm(n) {
  let e = n.domSelectionRange();
  if (!e.anchorNode)
    return !1;
  try {
    return n.dom.contains(e.anchorNode.nodeType == 3 ? e.anchorNode.parentNode : e.anchorNode) && (n.editable || n.dom.contains(e.focusNode.nodeType == 3 ? e.focusNode.parentNode : e.focusNode));
  } catch {
    return !1;
  }
}
function nx(n) {
  let e = n.docView.domFromPos(n.state.selection.anchor, 0), t = n.domSelectionRange();
  return Ri(e.node, e.offset, t.anchorNode, t.anchorOffset);
}
function xc(n, e) {
  let { $anchor: t, $head: i } = n.selection, r = e > 0 ? t.max(i) : t.min(i), s = r.parent.inlineContent ? r.depth ? n.doc.resolve(e > 0 ? r.after() : r.before()) : null : r;
  return s && fe.findFrom(s, e);
}
function ni(n, e) {
  return n.dispatch(n.state.tr.setSelection(e).scrollIntoView()), !0;
}
function bh(n, e, t) {
  let i = n.state.selection;
  if (i instanceof ue)
    if (t.indexOf("s") > -1) {
      let { $head: r } = i, s = r.textOffset ? null : e < 0 ? r.nodeBefore : r.nodeAfter;
      if (!s || s.isText || !s.isLeaf)
        return !1;
      let o = n.state.doc.resolve(r.pos + s.nodeSize * (e < 0 ? -1 : 1));
      return ni(n, new ue(i.$anchor, o));
    } else if (i.empty) {
      if (n.endOfTextblock(e > 0 ? "forward" : "backward")) {
        let r = xc(n.state, e);
        return r && r instanceof re ? ni(n, r) : !1;
      } else if (!(rn && t.indexOf("m") > -1)) {
        let r = i.$head, s = r.textOffset ? null : e < 0 ? r.nodeBefore : r.nodeAfter, o;
        if (!s || s.isText)
          return !1;
        let a = e < 0 ? r.pos - s.nodeSize : r.pos;
        return s.isAtom || (o = n.docView.descAt(a)) && !o.contentDOM ? re.isSelectable(s) ? ni(n, new re(e < 0 ? n.state.doc.resolve(r.pos - s.nodeSize) : r)) : Es ? ni(n, new ue(n.state.doc.resolve(e < 0 ? a : a + s.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (i instanceof re && i.node.isInline)
      return ni(n, new ue(e > 0 ? i.$to : i.$from));
    {
      let r = xc(n.state, e);
      return r ? ni(n, r) : !1;
    }
  }
}
function Po(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function Qr(n, e) {
  let t = n.pmViewDesc;
  return t && t.size == 0 && (e < 0 || n.nextSibling || n.nodeName != "BR");
}
function Ki(n, e) {
  return e < 0 ? ix(n) : rx(n);
}
function ix(n) {
  let e = n.domSelectionRange(), t = e.focusNode, i = e.focusOffset;
  if (!t)
    return;
  let r, s, o = !1;
  for (on && t.nodeType == 1 && i < Po(t) && Qr(t.childNodes[i], -1) && (o = !0); ; )
    if (i > 0) {
      if (t.nodeType != 1)
        break;
      {
        let a = t.childNodes[i - 1];
        if (Qr(a, -1))
          r = t, s = --i;
        else if (a.nodeType == 3)
          t = a, i = t.nodeValue.length;
        else
          break;
      }
    } else {
      if (Bm(t))
        break;
      {
        let a = t.previousSibling;
        for (; a && Qr(a, -1); )
          r = t.parentNode, s = wt(a), a = a.previousSibling;
        if (a)
          t = a, i = Po(t);
        else {
          if (t = t.parentNode, t == n.dom)
            break;
          i = 0;
        }
      }
    }
  o ? wc(n, t, i) : r && wc(n, r, s);
}
function rx(n) {
  let e = n.domSelectionRange(), t = e.focusNode, i = e.focusOffset;
  if (!t)
    return;
  let r = Po(t), s, o;
  for (; ; )
    if (i < r) {
      if (t.nodeType != 1)
        break;
      let a = t.childNodes[i];
      if (Qr(a, 1))
        s = t, o = ++i;
      else
        break;
    } else {
      if (Bm(t))
        break;
      {
        let a = t.nextSibling;
        for (; a && Qr(a, 1); )
          s = a.parentNode, o = wt(a) + 1, a = a.nextSibling;
        if (a)
          t = a, i = 0, r = Po(t);
        else {
          if (t = t.parentNode, t == n.dom)
            break;
          i = r = 0;
        }
      }
    }
  s && wc(n, s, o);
}
function Bm(n) {
  let e = n.pmViewDesc;
  return e && e.node && e.node.isBlock;
}
function sx(n, e) {
  for (; n && e == n.childNodes.length && !Ss(n); )
    e = wt(n) + 1, n = n.parentNode;
  for (; n && e < n.childNodes.length; ) {
    let t = n.childNodes[e];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    n = t, e = 0;
  }
}
function ox(n, e) {
  for (; n && !e && !Ss(n); )
    e = wt(n), n = n.parentNode;
  for (; n && e; ) {
    let t = n.childNodes[e - 1];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    n = t, e = n.childNodes.length;
  }
}
function wc(n, e, t) {
  if (e.nodeType != 3) {
    let s, o;
    (o = sx(e, t)) ? (e = o, t = 0) : (s = ox(e, t)) && (e = s, t = s.nodeValue.length);
  }
  let i = n.domSelection();
  if (!i)
    return;
  if (Aa(i)) {
    let s = document.createRange();
    s.setEnd(e, t), s.setStart(e, t), i.removeAllRanges(), i.addRange(s);
  } else i.extend && i.extend(e, t);
  n.domObserver.setCurSelection();
  let { state: r } = n;
  setTimeout(() => {
    n.state == r && Kn(n);
  }, 50);
}
function vh(n, e) {
  let t = n.state.doc.resolve(e);
  if (!(mt || Em) && t.parent.inlineContent) {
    let r = n.coordsAtPos(e);
    if (e > t.start()) {
      let s = n.coordsAtPos(e - 1), o = (s.top + s.bottom) / 2;
      if (o > r.top && o < r.bottom && Math.abs(s.left - r.left) > 1)
        return s.left < r.left ? "ltr" : "rtl";
    }
    if (e < t.end()) {
      let s = n.coordsAtPos(e + 1), o = (s.top + s.bottom) / 2;
      if (o > r.top && o < r.bottom && Math.abs(s.left - r.left) > 1)
        return s.left > r.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(n.dom).direction == "rtl" ? "rtl" : "ltr";
}
function yh(n, e, t) {
  let i = n.state.selection;
  if (i instanceof ue && !i.empty || t.indexOf("s") > -1 || rn && t.indexOf("m") > -1)
    return !1;
  let { $from: r, $to: s } = i;
  if (!r.parent.inlineContent || n.endOfTextblock(e < 0 ? "up" : "down")) {
    let o = xc(n.state, e);
    if (o && o instanceof re)
      return ni(n, o);
  }
  if (!r.parent.inlineContent) {
    let o = e < 0 ? r : s, a = i instanceof Wt ? fe.near(o, e) : fe.findFrom(o, e);
    return a ? ni(n, a) : !1;
  }
  return !1;
}
function xh(n, e) {
  if (!(n.state.selection instanceof ue))
    return !0;
  let { $head: t, $anchor: i, empty: r } = n.state.selection;
  if (!t.sameParent(i))
    return !0;
  if (!r)
    return !1;
  if (n.endOfTextblock(e > 0 ? "forward" : "backward"))
    return !0;
  let s = !t.textOffset && (e < 0 ? t.nodeBefore : t.nodeAfter);
  if (s && !s.isText) {
    let o = n.state.tr;
    return e < 0 ? o.delete(t.pos - s.nodeSize, t.pos) : o.delete(t.pos, t.pos + s.nodeSize), n.dispatch(o), !0;
  }
  return !1;
}
function wh(n, e, t) {
  n.domObserver.stop(), e.contentEditable = t, n.domObserver.start();
}
function ax(n) {
  if (!Ot || n.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: e, focusOffset: t } = n.domSelectionRange();
  if (e && e.nodeType == 1 && t == 0 && e.firstChild && e.firstChild.contentEditable == "false") {
    let i = e.firstChild;
    wh(n, i, "true"), setTimeout(() => wh(n, i, "false"), 20);
  }
  return !1;
}
function lx(n) {
  let e = "";
  return n.ctrlKey && (e += "c"), n.metaKey && (e += "m"), n.altKey && (e += "a"), n.shiftKey && (e += "s"), e;
}
function cx(n, e) {
  let t = e.keyCode, i = lx(e);
  if (t == 8 || rn && t == 72 && i == "c")
    return xh(n, -1) || Ki(n, -1);
  if (t == 46 && !e.shiftKey || rn && t == 68 && i == "c")
    return xh(n, 1) || Ki(n, 1);
  if (t == 13 || t == 27)
    return !0;
  if (t == 37 || rn && t == 66 && i == "c") {
    let r = t == 37 ? vh(n, n.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return bh(n, r, i) || Ki(n, r);
  } else if (t == 39 || rn && t == 70 && i == "c") {
    let r = t == 39 ? vh(n, n.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return bh(n, r, i) || Ki(n, r);
  } else {
    if (t == 38 || rn && t == 80 && i == "c")
      return yh(n, -1, i) || Ki(n, -1);
    if (t == 40 || rn && t == 78 && i == "c")
      return ax(n) || yh(n, 1, i) || Ki(n, 1);
    if (i == (rn ? "m" : "c") && (t == 66 || t == 73 || t == 89 || t == 90))
      return !0;
  }
  return !1;
}
function _u(n, e) {
  n.someProp("transformCopied", (f) => {
    e = f(e, n);
  });
  let t = [], { content: i, openStart: r, openEnd: s } = e;
  for (; r > 1 && s > 1 && i.childCount == 1 && i.firstChild.childCount == 1; ) {
    r--, s--;
    let f = i.firstChild;
    t.push(f.type.name, f.attrs != f.type.defaultAttrs ? f.attrs : null), i = f.content;
  }
  let o = n.someProp("clipboardSerializer") || zi.fromSchema(n.state.schema), a = Km(), l = a.createElement("div");
  l.appendChild(o.serializeFragment(i, { document: a }));
  let c = l.firstChild, u, d = 0;
  for (; c && c.nodeType == 1 && (u = Um[c.nodeName.toLowerCase()]); ) {
    for (let f = u.length - 1; f >= 0; f--) {
      let p = a.createElement(u[f]);
      for (; l.firstChild; )
        p.appendChild(l.firstChild);
      l.appendChild(p), d++;
    }
    c = l.firstChild;
  }
  c && c.nodeType == 1 && c.setAttribute("data-pm-slice", `${r} ${s}${d ? ` -${d}` : ""} ${JSON.stringify(t)}`);
  let h = n.someProp("clipboardTextSerializer", (f) => f(e, n)) || e.content.textBetween(0, e.content.size, `

`);
  return { dom: l, text: h, slice: e };
}
function Fm(n, e, t, i, r) {
  let s = r.parent.type.spec.code, o, a;
  if (!t && !e)
    return null;
  let l = !!e && (i || s || !t);
  if (l) {
    if (n.someProp("transformPastedText", (h) => {
      e = h(e, s || i, n);
    }), s)
      return a = new J($.from(n.state.schema.text(e.replace(/\r\n?/g, `
`))), 0, 0), n.someProp("transformPasted", (h) => {
        a = h(a, n, !0);
      }), a;
    let d = n.someProp("clipboardTextParser", (h) => h(e, r, i, n));
    if (d)
      a = d;
    else {
      let h = r.marks(), { schema: f } = n.state, p = zi.fromSchema(f);
      o = document.createElement("div"), e.split(/(?:\r\n?|\n)+/).forEach((_) => {
        let m = o.appendChild(document.createElement("p"));
        _ && m.appendChild(p.serializeNode(f.text(_, h)));
      });
    }
  } else
    n.someProp("transformPastedHTML", (d) => {
      t = d(t, n);
    }), o = fx(t), Es && px(o);
  let c = o && o.querySelector("[data-pm-slice]"), u = c && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(c.getAttribute("data-pm-slice") || "");
  if (u && u[3])
    for (let d = +u[3]; d > 0; d--) {
      let h = o.firstChild;
      for (; h && h.nodeType != 1; )
        h = h.nextSibling;
      if (!h)
        break;
      o = h;
    }
  if (a || (a = (n.someProp("clipboardParser") || n.someProp("domParser") || ir.fromSchema(n.state.schema)).parseSlice(o, {
    preserveWhitespace: !!(l || u),
    context: r,
    ruleFromNode(h) {
      return h.nodeName == "BR" && !h.nextSibling && h.parentNode && !ux.test(h.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), u)
    a = mx(kh(a, +u[1], +u[2]), u[4]);
  else if (a = J.maxOpen(dx(a.content, r), !0), a.openStart || a.openEnd) {
    let d = 0, h = 0;
    for (let f = a.content.firstChild; d < a.openStart && !f.type.spec.isolating; d++, f = f.firstChild)
      ;
    for (let f = a.content.lastChild; h < a.openEnd && !f.type.spec.isolating; h++, f = f.lastChild)
      ;
    a = kh(a, d, h);
  }
  return n.someProp("transformPasted", (d) => {
    a = d(a, n, l);
  }), a;
}
const ux = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function dx(n, e) {
  if (n.childCount < 2)
    return n;
  for (let t = e.depth; t >= 0; t--) {
    let r = e.node(t).contentMatchAt(e.index(t)), s, o = [];
    if (n.forEach((a) => {
      if (!o)
        return;
      let l = r.findWrapping(a.type), c;
      if (!l)
        return o = null;
      if (c = o.length && s.length && jm(l, s, a, o[o.length - 1], 0))
        o[o.length - 1] = c;
      else {
        o.length && (o[o.length - 1] = Wm(o[o.length - 1], s.length));
        let u = Vm(a, l);
        o.push(u), r = r.matchType(u.type), s = l;
      }
    }), o)
      return $.from(o);
  }
  return n;
}
function Vm(n, e, t = 0) {
  for (let i = e.length - 1; i >= t; i--)
    n = e[i].create(null, $.from(n));
  return n;
}
function jm(n, e, t, i, r) {
  if (r < n.length && r < e.length && n[r] == e[r]) {
    let s = jm(n, e, t, i.lastChild, r + 1);
    if (s)
      return i.copy(i.content.replaceChild(i.childCount - 1, s));
    if (i.contentMatchAt(i.childCount).matchType(r == n.length - 1 ? t.type : n[r + 1]))
      return i.copy(i.content.append($.from(Vm(t, n, r + 1))));
  }
}
function Wm(n, e) {
  if (e == 0)
    return n;
  let t = n.content.replaceChild(n.childCount - 1, Wm(n.lastChild, e - 1)), i = n.contentMatchAt(n.childCount).fillBefore($.empty, !0);
  return n.copy(t.append(i));
}
function kc(n, e, t, i, r, s) {
  let o = e < 0 ? n.firstChild : n.lastChild, a = o.content;
  return n.childCount > 1 && (s = 0), r < i - 1 && (a = kc(a, e, t, i, r + 1, s)), r >= t && (a = e < 0 ? o.contentMatchAt(0).fillBefore(a, s <= r).append(a) : a.append(o.contentMatchAt(o.childCount).fillBefore($.empty, !0))), n.replaceChild(e < 0 ? 0 : n.childCount - 1, o.copy(a));
}
function kh(n, e, t) {
  return e < n.openStart && (n = new J(kc(n.content, -1, e, n.openStart, 0, n.openEnd), e, n.openEnd)), t < n.openEnd && (n = new J(kc(n.content, 1, t, n.openEnd, 0, 0), n.openStart, t)), n;
}
const Um = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let Sh = null;
function Km() {
  return Sh || (Sh = document.implementation.createHTMLDocument("title"));
}
let gl = null;
function hx(n) {
  let e = window.trustedTypes;
  return e ? (gl || (gl = e.defaultPolicy || e.createPolicy("ProseMirrorClipboard", { createHTML: (t) => t })), gl.createHTML(n)) : n;
}
function fx(n) {
  let e = /^(\s*<meta [^>]*>)*/.exec(n);
  e && (n = n.slice(e[0].length));
  let t = Km().createElement("div"), i = /<([a-z][^>\s]+)/i.exec(n), r;
  if ((r = i && Um[i[1].toLowerCase()]) && (n = r.map((s) => "<" + s + ">").join("") + n + r.map((s) => "</" + s + ">").reverse().join("")), t.innerHTML = hx(n), r)
    for (let s = 0; s < r.length; s++)
      t = t.querySelector(r[s]) || t;
  return t;
}
function px(n) {
  let e = n.querySelectorAll(mt ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let t = 0; t < e.length; t++) {
    let i = e[t];
    i.childNodes.length == 1 && i.textContent == " " && i.parentNode && i.parentNode.replaceChild(n.ownerDocument.createTextNode(" "), i);
  }
}
function mx(n, e) {
  if (!n.size)
    return n;
  let t = n.content.firstChild.type.schema, i;
  try {
    i = JSON.parse(e);
  } catch {
    return n;
  }
  let { content: r, openStart: s, openEnd: o } = n;
  for (let a = i.length - 2; a >= 0; a -= 2) {
    let l = t.nodes[i[a]];
    if (!l || l.hasRequiredAttrs())
      break;
    r = $.from(l.create(i[a + 1], r)), s++, o++;
  }
  return new J(r, s, o);
}
const $t = {}, zt = {}, gx = { touchstart: !0, touchmove: !0 };
class _x {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "", button: 0 }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastChromeDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function bx(n) {
  for (let e in $t) {
    let t = $t[e];
    n.dom.addEventListener(e, n.input.eventHandlers[e] = (i) => {
      yx(n, i) && !bu(n, i) && (n.editable || !(i.type in zt)) && t(n, i);
    }, gx[e] ? { passive: !0 } : void 0);
  }
  Ot && n.dom.addEventListener("input", () => null), Sc(n);
}
function di(n, e) {
  n.input.lastSelectionOrigin = e, n.input.lastSelectionTime = Date.now();
}
function vx(n) {
  n.domObserver.stop();
  for (let e in n.input.eventHandlers)
    n.dom.removeEventListener(e, n.input.eventHandlers[e]);
  clearTimeout(n.input.composingTimeout), clearTimeout(n.input.lastIOSEnterFallbackTimeout);
}
function Sc(n) {
  n.someProp("handleDOMEvents", (e) => {
    for (let t in e)
      n.input.eventHandlers[t] || n.dom.addEventListener(t, n.input.eventHandlers[t] = (i) => bu(n, i));
  });
}
function bu(n, e) {
  return n.someProp("handleDOMEvents", (t) => {
    let i = t[e.type];
    return i ? i(n, e) || e.defaultPrevented : !1;
  });
}
function yx(n, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let t = e.target; t != n.dom; t = t.parentNode)
    if (!t || t.nodeType == 11 || t.pmViewDesc && t.pmViewDesc.stopEvent(e))
      return !1;
  return !0;
}
function xx(n, e) {
  !bu(n, e) && $t[e.type] && (n.editable || !(e.type in zt)) && $t[e.type](n, e);
}
zt.keydown = (n, e) => {
  let t = e;
  if (n.input.shiftKey = t.keyCode == 16 || t.shiftKey, !Gm(n, t) && (n.input.lastKeyCode = t.keyCode, n.input.lastKeyCodeTime = Date.now(), !(jn && mt && t.keyCode == 13)))
    if (t.keyCode != 229 && n.domObserver.forceFlush(), pr && t.keyCode == 13 && !t.ctrlKey && !t.altKey && !t.metaKey) {
      let i = Date.now();
      n.input.lastIOSEnter = i, n.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        n.input.lastIOSEnter == i && (n.someProp("handleKeyDown", (r) => r(n, wi(13, "Enter"))), n.input.lastIOSEnter = 0);
      }, 200);
    } else n.someProp("handleKeyDown", (i) => i(n, t)) || cx(n, t) ? t.preventDefault() : di(n, "key");
};
zt.keyup = (n, e) => {
  e.keyCode == 16 && (n.input.shiftKey = !1);
};
zt.keypress = (n, e) => {
  let t = e;
  if (Gm(n, t) || !t.charCode || t.ctrlKey && !t.altKey || rn && t.metaKey)
    return;
  if (n.someProp("handleKeyPress", (r) => r(n, t))) {
    t.preventDefault();
    return;
  }
  let i = n.state.selection;
  if (!(i instanceof ue) || !i.$from.sameParent(i.$to)) {
    let r = String.fromCharCode(t.charCode), s = () => n.state.tr.insertText(r).scrollIntoView();
    !/[\r\n]/.test(r) && !n.someProp("handleTextInput", (o) => o(n, i.$from.pos, i.$to.pos, r, s)) && n.dispatch(s()), t.preventDefault();
  }
};
function Oa(n) {
  return { left: n.clientX, top: n.clientY };
}
function wx(n, e) {
  let t = e.x - n.clientX, i = e.y - n.clientY;
  return t * t + i * i < 100;
}
function vu(n, e, t, i, r) {
  if (i == -1)
    return !1;
  let s = n.state.doc.resolve(i);
  for (let o = s.depth + 1; o > 0; o--)
    if (n.someProp(e, (a) => o > s.depth ? a(n, t, s.nodeAfter, s.before(o), r, !0) : a(n, t, s.node(o), s.before(o), r, !1)))
      return !0;
  return !1;
}
function or(n, e, t) {
  if (n.focused || n.focus(), n.state.selection.eq(e))
    return;
  let i = n.state.tr.setSelection(e);
  i.setMeta("pointer", !0), n.dispatch(i);
}
function kx(n, e) {
  if (e == -1)
    return !1;
  let t = n.state.doc.resolve(e), i = t.nodeAfter;
  return i && i.isAtom && re.isSelectable(i) ? (or(n, new re(t)), !0) : !1;
}
function Sx(n, e) {
  if (e == -1)
    return !1;
  let t = n.state.selection, i, r;
  t instanceof re && (i = t.node);
  let s = n.state.doc.resolve(e);
  for (let o = s.depth + 1; o > 0; o--) {
    let a = o > s.depth ? s.nodeAfter : s.node(o);
    if (re.isSelectable(a)) {
      i && t.$from.depth > 0 && o >= t.$from.depth && s.before(t.$from.depth + 1) == t.$from.pos ? r = s.before(t.$from.depth) : r = s.before(o);
      break;
    }
  }
  return r != null ? (or(n, re.create(n.state.doc, r)), !0) : !1;
}
function Ex(n, e, t, i, r) {
  return vu(n, "handleClickOn", e, t, i) || n.someProp("handleClick", (s) => s(n, e, i)) || (r ? Sx(n, t) : kx(n, t));
}
function Cx(n, e, t, i) {
  return vu(n, "handleDoubleClickOn", e, t, i) || n.someProp("handleDoubleClick", (r) => r(n, e, i));
}
function Tx(n, e, t, i) {
  return vu(n, "handleTripleClickOn", e, t, i) || n.someProp("handleTripleClick", (r) => r(n, e, i)) || Ax(n, t, i);
}
function Ax(n, e, t) {
  if (t.button != 0)
    return !1;
  let i = n.state.doc;
  if (e == -1)
    return i.inlineContent ? (or(n, ue.create(i, 0, i.content.size)), !0) : !1;
  let r = i.resolve(e);
  for (let s = r.depth + 1; s > 0; s--) {
    let o = s > r.depth ? r.nodeAfter : r.node(s), a = r.before(s);
    if (o.inlineContent)
      or(n, ue.create(i, a + 1, a + 1 + o.content.size));
    else if (re.isSelectable(o))
      or(n, re.create(i, a));
    else
      continue;
    return !0;
  }
}
function yu(n) {
  return Do(n);
}
const qm = rn ? "metaKey" : "ctrlKey";
$t.mousedown = (n, e) => {
  let t = e;
  n.input.shiftKey = t.shiftKey;
  let i = yu(n), r = Date.now(), s = "singleClick";
  r - n.input.lastClick.time < 500 && wx(t, n.input.lastClick) && !t[qm] && n.input.lastClick.button == t.button && (n.input.lastClick.type == "singleClick" ? s = "doubleClick" : n.input.lastClick.type == "doubleClick" && (s = "tripleClick")), n.input.lastClick = { time: r, x: t.clientX, y: t.clientY, type: s, button: t.button };
  let o = n.posAtCoords(Oa(t));
  o && (s == "singleClick" ? (n.input.mouseDown && n.input.mouseDown.done(), n.input.mouseDown = new Mx(n, o, t, !!i)) : (s == "doubleClick" ? Cx : Tx)(n, o.pos, o.inside, t) ? t.preventDefault() : di(n, "pointer"));
};
class Mx {
  constructor(e, t, i, r) {
    this.view = e, this.pos = t, this.event = i, this.flushed = r, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = e.state.doc, this.selectNode = !!i[qm], this.allowDefault = i.shiftKey;
    let s, o;
    if (t.inside > -1)
      s = e.state.doc.nodeAt(t.inside), o = t.inside;
    else {
      let u = e.state.doc.resolve(t.pos);
      s = u.parent, o = u.depth ? u.before() : 0;
    }
    const a = r ? null : i.target, l = a ? e.docView.nearestDesc(a, !0) : null;
    this.target = l && l.nodeDOM.nodeType == 1 ? l.nodeDOM : null;
    let { selection: c } = e.state;
    (i.button == 0 && s.type.spec.draggable && s.type.spec.selectable !== !1 || c instanceof re && c.from <= o && c.to > o) && (this.mightDrag = {
      node: s,
      pos: o,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && on && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this)), di(e, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => Kn(this.view)), this.view.input.mouseDown = null;
  }
  up(e) {
    if (this.done(), !this.view.dom.contains(e.target))
      return;
    let t = this.pos;
    this.view.state.doc != this.startDoc && (t = this.view.posAtCoords(Oa(e))), this.updateAllowDefault(e), this.allowDefault || !t ? di(this.view, "pointer") : Ex(this.view, t.pos, t.inside, e, this.selectNode) ? e.preventDefault() : e.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    Ot && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    mt && !this.view.state.selection.visible && Math.min(Math.abs(t.pos - this.view.state.selection.from), Math.abs(t.pos - this.view.state.selection.to)) <= 2) ? (or(this.view, fe.near(this.view.state.doc.resolve(t.pos))), e.preventDefault()) : di(this.view, "pointer");
  }
  move(e) {
    this.updateAllowDefault(e), di(this.view, "pointer"), e.buttons == 0 && this.done();
  }
  updateAllowDefault(e) {
    !this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0);
  }
}
$t.touchstart = (n) => {
  n.input.lastTouch = Date.now(), yu(n), di(n, "pointer");
};
$t.touchmove = (n) => {
  n.input.lastTouch = Date.now(), di(n, "pointer");
};
$t.contextmenu = (n) => yu(n);
function Gm(n, e) {
  return n.composing ? !0 : Ot && Math.abs(e.timeStamp - n.input.compositionEndedAt) < 500 ? (n.input.compositionEndedAt = -2e8, !0) : !1;
}
const Ox = jn ? 5e3 : -1;
zt.compositionstart = zt.compositionupdate = (n) => {
  if (!n.composing) {
    n.domObserver.flush();
    let { state: e } = n, t = e.selection.$to;
    if (e.selection instanceof ue && (e.storedMarks || !t.textOffset && t.parentOffset && t.nodeBefore.marks.some((i) => i.type.spec.inclusive === !1) || mt && Em && Nx(n)))
      n.markCursor = n.state.storedMarks || t.marks(), Do(n, !0), n.markCursor = null;
    else if (Do(n, !e.selection.empty), on && e.selection.empty && t.parentOffset && !t.textOffset && t.nodeBefore.marks.length) {
      let i = n.domSelectionRange();
      for (let r = i.focusNode, s = i.focusOffset; r && r.nodeType == 1 && s != 0; ) {
        let o = s < 0 ? r.lastChild : r.childNodes[s - 1];
        if (!o)
          break;
        if (o.nodeType == 3) {
          let a = n.domSelection();
          a && a.collapse(o, o.nodeValue.length);
          break;
        } else
          r = o, s = -1;
      }
    }
    n.input.composing = !0;
  }
  Jm(n, Ox);
};
function Nx(n) {
  let { focusNode: e, focusOffset: t } = n.domSelectionRange();
  if (!e || e.nodeType != 1 || t >= e.childNodes.length)
    return !1;
  let i = e.childNodes[t];
  return i.nodeType == 1 && i.contentEditable == "false";
}
zt.compositionend = (n, e) => {
  n.composing && (n.input.composing = !1, n.input.compositionEndedAt = e.timeStamp, n.input.compositionPendingChanges = n.domObserver.pendingRecords().length ? n.input.compositionID : 0, n.input.compositionNode = null, n.input.compositionPendingChanges && Promise.resolve().then(() => n.domObserver.flush()), n.input.compositionID++, Jm(n, 20));
};
function Jm(n, e) {
  clearTimeout(n.input.composingTimeout), e > -1 && (n.input.composingTimeout = setTimeout(() => Do(n), e));
}
function Xm(n) {
  for (n.composing && (n.input.composing = !1, n.input.compositionEndedAt = Rx()); n.input.compositionNodes.length > 0; )
    n.input.compositionNodes.pop().markParentsDirty();
}
function Lx(n) {
  let e = n.domSelectionRange();
  if (!e.focusNode)
    return null;
  let t = Sy(e.focusNode, e.focusOffset), i = Ey(e.focusNode, e.focusOffset);
  if (t && i && t != i) {
    let r = i.pmViewDesc, s = n.domObserver.lastChangedTextNode;
    if (t == s || i == s)
      return s;
    if (!r || !r.isText(i.nodeValue))
      return i;
    if (n.input.compositionNode == i) {
      let o = t.pmViewDesc;
      if (!(!o || !o.isText(t.nodeValue)))
        return i;
    }
  }
  return t || i;
}
function Rx() {
  let n = document.createEvent("Event");
  return n.initEvent("event", !0, !0), n.timeStamp;
}
function Do(n, e = !1) {
  if (!(jn && n.domObserver.flushingSoon >= 0)) {
    if (n.domObserver.forceFlush(), Xm(n), e || n.docView && n.docView.dirty) {
      let t = mu(n), i = n.state.selection;
      return t && !t.eq(i) ? n.dispatch(n.state.tr.setSelection(t)) : (n.markCursor || e) && !i.$from.node(i.$from.sharedDepth(i.to)).inlineContent ? n.dispatch(n.state.tr.deleteSelection()) : n.updateState(n.state), !0;
    }
    return !1;
  }
}
function Ix(n, e) {
  if (!n.dom.parentNode)
    return;
  let t = n.dom.parentNode.appendChild(document.createElement("div"));
  t.appendChild(e), t.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let i = getSelection(), r = document.createRange();
  r.selectNodeContents(e), n.dom.blur(), i.removeAllRanges(), i.addRange(r), setTimeout(() => {
    t.parentNode && t.parentNode.removeChild(t), n.focus();
  }, 50);
}
const ms = Ut && hi < 15 || pr && My < 604;
$t.copy = zt.cut = (n, e) => {
  let t = e, i = n.state.selection, r = t.type == "cut";
  if (i.empty)
    return;
  let s = ms ? null : t.clipboardData, o = i.content(), { dom: a, text: l } = _u(n, o);
  s ? (t.preventDefault(), s.clearData(), s.setData("text/html", a.innerHTML), s.setData("text/plain", l)) : Ix(n, a), r && n.dispatch(n.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function Px(n) {
  return n.openStart == 0 && n.openEnd == 0 && n.content.childCount == 1 ? n.content.firstChild : null;
}
function Dx(n, e) {
  if (!n.dom.parentNode)
    return;
  let t = n.input.shiftKey || n.state.selection.$from.parent.type.spec.code, i = n.dom.parentNode.appendChild(document.createElement(t ? "textarea" : "div"));
  t || (i.contentEditable = "true"), i.style.cssText = "position: fixed; left: -10000px; top: 10px", i.focus();
  let r = n.input.shiftKey && n.input.lastKeyCode != 45;
  setTimeout(() => {
    n.focus(), i.parentNode && i.parentNode.removeChild(i), t ? gs(n, i.value, null, r, e) : gs(n, i.textContent, i.innerHTML, r, e);
  }, 50);
}
function gs(n, e, t, i, r) {
  let s = Fm(n, e, t, i, n.state.selection.$from);
  if (n.someProp("handlePaste", (l) => l(n, r, s || J.empty)))
    return !0;
  if (!s)
    return !1;
  let o = Px(s), a = o ? n.state.tr.replaceSelectionWith(o, i) : n.state.tr.replaceSelection(s);
  return n.dispatch(a.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function Ym(n) {
  let e = n.getData("text/plain") || n.getData("Text");
  if (e)
    return e;
  let t = n.getData("text/uri-list");
  return t ? t.replace(/\r?\n/g, " ") : "";
}
zt.paste = (n, e) => {
  let t = e;
  if (n.composing && !jn)
    return;
  let i = ms ? null : t.clipboardData, r = n.input.shiftKey && n.input.lastKeyCode != 45;
  i && gs(n, Ym(i), i.getData("text/html"), r, t) ? t.preventDefault() : Dx(n, t);
};
class Zm {
  constructor(e, t, i) {
    this.slice = e, this.move = t, this.node = i;
  }
}
const $x = rn ? "altKey" : "ctrlKey";
function Qm(n, e) {
  let t = n.someProp("dragCopies", (i) => !i(e));
  return t ?? !e[$x];
}
$t.dragstart = (n, e) => {
  let t = e, i = n.input.mouseDown;
  if (i && i.done(), !t.dataTransfer)
    return;
  let r = n.state.selection, s = r.empty ? null : n.posAtCoords(Oa(t)), o;
  if (!(s && s.pos >= r.from && s.pos <= (r instanceof re ? r.to - 1 : r.to))) {
    if (i && i.mightDrag)
      o = re.create(n.state.doc, i.mightDrag.pos);
    else if (t.target && t.target.nodeType == 1) {
      let d = n.docView.nearestDesc(t.target, !0);
      d && d.node.type.spec.draggable && d != n.docView && (o = re.create(n.state.doc, d.posBefore));
    }
  }
  let a = (o || n.state.selection).content(), { dom: l, text: c, slice: u } = _u(n, a);
  (!t.dataTransfer.files.length || !mt || Sm > 120) && t.dataTransfer.clearData(), t.dataTransfer.setData(ms ? "Text" : "text/html", l.innerHTML), t.dataTransfer.effectAllowed = "copyMove", ms || t.dataTransfer.setData("text/plain", c), n.dragging = new Zm(u, Qm(n, t), o);
};
$t.dragend = (n) => {
  let e = n.dragging;
  window.setTimeout(() => {
    n.dragging == e && (n.dragging = null);
  }, 50);
};
zt.dragover = zt.dragenter = (n, e) => e.preventDefault();
zt.drop = (n, e) => {
  try {
    zx(n, e, n.dragging);
  } finally {
    n.dragging = null;
  }
};
function zx(n, e, t) {
  if (!e.dataTransfer)
    return;
  let i = n.posAtCoords(Oa(e));
  if (!i)
    return;
  let r = n.state.doc.resolve(i.pos), s = t && t.slice;
  s ? n.someProp("transformPasted", (f) => {
    s = f(s, n, !1);
  }) : s = Fm(n, Ym(e.dataTransfer), ms ? null : e.dataTransfer.getData("text/html"), !1, r);
  let o = !!(t && Qm(n, e));
  if (n.someProp("handleDrop", (f) => f(n, e, s || J.empty, o))) {
    e.preventDefault();
    return;
  }
  if (!s)
    return;
  e.preventDefault();
  let a = s ? im(n.state.doc, r.pos, s) : r.pos;
  a == null && (a = r.pos);
  let l = n.state.tr;
  if (o) {
    let { node: f } = t;
    f ? f.replace(l) : l.deleteSelection();
  }
  let c = l.mapping.map(a), u = s.openStart == 0 && s.openEnd == 0 && s.content.childCount == 1, d = l.doc;
  if (u ? l.replaceRangeWith(c, c, s.content.firstChild) : l.replaceRange(c, c, s), l.doc.eq(d))
    return;
  let h = l.doc.resolve(c);
  if (u && re.isSelectable(s.content.firstChild) && h.nodeAfter && h.nodeAfter.sameMarkup(s.content.firstChild))
    l.setSelection(new re(h));
  else {
    let f = l.mapping.map(a);
    l.mapping.maps[l.mapping.maps.length - 1].forEach((p, _, m, g) => f = g), l.setSelection(gu(n, h, l.doc.resolve(f)));
  }
  n.focus(), n.dispatch(l.setMeta("uiEvent", "drop"));
}
$t.focus = (n) => {
  n.input.lastFocus = Date.now(), n.focused || (n.domObserver.stop(), n.dom.classList.add("ProseMirror-focused"), n.domObserver.start(), n.focused = !0, setTimeout(() => {
    n.docView && n.hasFocus() && !n.domObserver.currentSelection.eq(n.domSelectionRange()) && Kn(n);
  }, 20));
};
$t.blur = (n, e) => {
  let t = e;
  n.focused && (n.domObserver.stop(), n.dom.classList.remove("ProseMirror-focused"), n.domObserver.start(), t.relatedTarget && n.dom.contains(t.relatedTarget) && n.domObserver.currentSelection.clear(), n.focused = !1);
};
$t.beforeinput = (n, e) => {
  if (mt && jn && e.inputType == "deleteContentBackward") {
    n.domObserver.flushSoon();
    let { domChangeCount: i } = n.input;
    setTimeout(() => {
      if (n.input.domChangeCount != i || (n.dom.blur(), n.focus(), n.someProp("handleKeyDown", (s) => s(n, wi(8, "Backspace")))))
        return;
      let { $cursor: r } = n.state.selection;
      r && r.pos > 0 && n.dispatch(n.state.tr.delete(r.pos - 1, r.pos).scrollIntoView());
    }, 50);
  }
};
for (let n in zt)
  $t[n] = zt[n];
function _s(n, e) {
  if (n == e)
    return !0;
  for (let t in n)
    if (n[t] !== e[t])
      return !1;
  for (let t in e)
    if (!(t in n))
      return !1;
  return !0;
}
class $o {
  constructor(e, t) {
    this.toDOM = e, this.spec = t || Mi, this.side = this.spec.side || 0;
  }
  map(e, t, i, r) {
    let { pos: s, deleted: o } = e.mapResult(t.from + r, this.side < 0 ? -1 : 1);
    return o ? null : new gt(s - i, s - i, this);
  }
  valid() {
    return !0;
  }
  eq(e) {
    return this == e || e instanceof $o && (this.spec.key && this.spec.key == e.spec.key || this.toDOM == e.toDOM && _s(this.spec, e.spec));
  }
  destroy(e) {
    this.spec.destroy && this.spec.destroy(e);
  }
}
class pi {
  constructor(e, t) {
    this.attrs = e, this.spec = t || Mi;
  }
  map(e, t, i, r) {
    let s = e.map(t.from + r, this.spec.inclusiveStart ? -1 : 1) - i, o = e.map(t.to + r, this.spec.inclusiveEnd ? 1 : -1) - i;
    return s >= o ? null : new gt(s, o, this);
  }
  valid(e, t) {
    return t.from < t.to;
  }
  eq(e) {
    return this == e || e instanceof pi && _s(this.attrs, e.attrs) && _s(this.spec, e.spec);
  }
  static is(e) {
    return e.type instanceof pi;
  }
  destroy() {
  }
}
class xu {
  constructor(e, t) {
    this.attrs = e, this.spec = t || Mi;
  }
  map(e, t, i, r) {
    let s = e.mapResult(t.from + r, 1);
    if (s.deleted)
      return null;
    let o = e.mapResult(t.to + r, -1);
    return o.deleted || o.pos <= s.pos ? null : new gt(s.pos - i, o.pos - i, this);
  }
  valid(e, t) {
    let { index: i, offset: r } = e.content.findIndex(t.from), s;
    return r == t.from && !(s = e.child(i)).isText && r + s.nodeSize == t.to;
  }
  eq(e) {
    return this == e || e instanceof xu && _s(this.attrs, e.attrs) && _s(this.spec, e.spec);
  }
  destroy() {
  }
}
class gt {
  /**
  @internal
  */
  constructor(e, t, i) {
    this.from = e, this.to = t, this.type = i;
  }
  /**
  @internal
  */
  copy(e, t) {
    return new gt(e, t, this.type);
  }
  /**
  @internal
  */
  eq(e, t = 0) {
    return this.type.eq(e.type) && this.from + t == e.from && this.to + t == e.to;
  }
  /**
  @internal
  */
  map(e, t, i) {
    return this.type.map(e, this, t, i);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(e, t, i) {
    return new gt(e, e, new $o(t, i));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(e, t, i, r) {
    return new gt(e, t, new pi(i, r));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(e, t, i, r) {
    return new gt(e, t, new xu(i, r));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof pi;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof $o;
  }
}
const Ji = [], Mi = {};
class ze {
  /**
  @internal
  */
  constructor(e, t) {
    this.local = e.length ? e : Ji, this.children = t.length ? t : Ji;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(e, t) {
    return t.length ? zo(t, e, 0, Mi) : Mt;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(e, t, i) {
    let r = [];
    return this.findInner(e ?? 0, t ?? 1e9, r, 0, i), r;
  }
  findInner(e, t, i, r, s) {
    for (let o = 0; o < this.local.length; o++) {
      let a = this.local[o];
      a.from <= t && a.to >= e && (!s || s(a.spec)) && i.push(a.copy(a.from + r, a.to + r));
    }
    for (let o = 0; o < this.children.length; o += 3)
      if (this.children[o] < t && this.children[o + 1] > e) {
        let a = this.children[o] + 1;
        this.children[o + 2].findInner(e - a, t - a, i, r + a, s);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(e, t, i) {
    return this == Mt || e.maps.length == 0 ? this : this.mapInner(e, t, 0, 0, i || Mi);
  }
  /**
  @internal
  */
  mapInner(e, t, i, r, s) {
    let o;
    for (let a = 0; a < this.local.length; a++) {
      let l = this.local[a].map(e, i, r);
      l && l.type.valid(t, l) ? (o || (o = [])).push(l) : s.onRemove && s.onRemove(this.local[a].spec);
    }
    return this.children.length ? Hx(this.children, o || [], e, t, i, r, s) : o ? new ze(o.sort(Oi), Ji) : Mt;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(e, t) {
    return t.length ? this == Mt ? ze.create(e, t) : this.addInner(e, t, 0) : this;
  }
  addInner(e, t, i) {
    let r, s = 0;
    e.forEach((a, l) => {
      let c = l + i, u;
      if (u = tg(t, a, c)) {
        for (r || (r = this.children.slice()); s < r.length && r[s] < l; )
          s += 3;
        r[s] == l ? r[s + 2] = r[s + 2].addInner(a, u, c + 1) : r.splice(s, 0, l, l + a.nodeSize, zo(u, a, c + 1, Mi)), s += 3;
      }
    });
    let o = eg(s ? ng(t) : t, -i);
    for (let a = 0; a < o.length; a++)
      o[a].type.valid(e, o[a]) || o.splice(a--, 1);
    return new ze(o.length ? this.local.concat(o).sort(Oi) : this.local, r || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(e) {
    return e.length == 0 || this == Mt ? this : this.removeInner(e, 0);
  }
  removeInner(e, t) {
    let i = this.children, r = this.local;
    for (let s = 0; s < i.length; s += 3) {
      let o, a = i[s] + t, l = i[s + 1] + t;
      for (let u = 0, d; u < e.length; u++)
        (d = e[u]) && d.from > a && d.to < l && (e[u] = null, (o || (o = [])).push(d));
      if (!o)
        continue;
      i == this.children && (i = this.children.slice());
      let c = i[s + 2].removeInner(o, a + 1);
      c != Mt ? i[s + 2] = c : (i.splice(s, 3), s -= 3);
    }
    if (r.length) {
      for (let s = 0, o; s < e.length; s++)
        if (o = e[s])
          for (let a = 0; a < r.length; a++)
            r[a].eq(o, t) && (r == this.local && (r = this.local.slice()), r.splice(a--, 1));
    }
    return i == this.children && r == this.local ? this : r.length || i.length ? new ze(r, i) : Mt;
  }
  forChild(e, t) {
    if (this == Mt)
      return this;
    if (t.isLeaf)
      return ze.empty;
    let i, r;
    for (let a = 0; a < this.children.length; a += 3)
      if (this.children[a] >= e) {
        this.children[a] == e && (i = this.children[a + 2]);
        break;
      }
    let s = e + 1, o = s + t.content.size;
    for (let a = 0; a < this.local.length; a++) {
      let l = this.local[a];
      if (l.from < o && l.to > s && l.type instanceof pi) {
        let c = Math.max(s, l.from) - s, u = Math.min(o, l.to) - s;
        c < u && (r || (r = [])).push(l.copy(c, u));
      }
    }
    if (r) {
      let a = new ze(r.sort(Oi), Ji);
      return i ? new oi([a, i]) : a;
    }
    return i || Mt;
  }
  /**
  @internal
  */
  eq(e) {
    if (this == e)
      return !0;
    if (!(e instanceof ze) || this.local.length != e.local.length || this.children.length != e.children.length)
      return !1;
    for (let t = 0; t < this.local.length; t++)
      if (!this.local[t].eq(e.local[t]))
        return !1;
    for (let t = 0; t < this.children.length; t += 3)
      if (this.children[t] != e.children[t] || this.children[t + 1] != e.children[t + 1] || !this.children[t + 2].eq(e.children[t + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(e) {
    return wu(this.localsInner(e));
  }
  /**
  @internal
  */
  localsInner(e) {
    if (this == Mt)
      return Ji;
    if (e.inlineContent || !this.local.some(pi.is))
      return this.local;
    let t = [];
    for (let i = 0; i < this.local.length; i++)
      this.local[i].type instanceof pi || t.push(this.local[i]);
    return t;
  }
  forEachSet(e) {
    e(this);
  }
}
ze.empty = new ze([], []);
ze.removeOverlap = wu;
const Mt = ze.empty;
class oi {
  constructor(e) {
    this.members = e;
  }
  map(e, t) {
    const i = this.members.map((r) => r.map(e, t, Mi));
    return oi.from(i);
  }
  forChild(e, t) {
    if (t.isLeaf)
      return ze.empty;
    let i = [];
    for (let r = 0; r < this.members.length; r++) {
      let s = this.members[r].forChild(e, t);
      s != Mt && (s instanceof oi ? i = i.concat(s.members) : i.push(s));
    }
    return oi.from(i);
  }
  eq(e) {
    if (!(e instanceof oi) || e.members.length != this.members.length)
      return !1;
    for (let t = 0; t < this.members.length; t++)
      if (!this.members[t].eq(e.members[t]))
        return !1;
    return !0;
  }
  locals(e) {
    let t, i = !0;
    for (let r = 0; r < this.members.length; r++) {
      let s = this.members[r].localsInner(e);
      if (s.length)
        if (!t)
          t = s;
        else {
          i && (t = t.slice(), i = !1);
          for (let o = 0; o < s.length; o++)
            t.push(s[o]);
        }
    }
    return t ? wu(i ? t : t.sort(Oi)) : Ji;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(e) {
    switch (e.length) {
      case 0:
        return Mt;
      case 1:
        return e[0];
      default:
        return new oi(e.every((t) => t instanceof ze) ? e : e.reduce((t, i) => t.concat(i instanceof ze ? i : i.members), []));
    }
  }
  forEachSet(e) {
    for (let t = 0; t < this.members.length; t++)
      this.members[t].forEachSet(e);
  }
}
function Hx(n, e, t, i, r, s, o) {
  let a = n.slice();
  for (let c = 0, u = s; c < t.maps.length; c++) {
    let d = 0;
    t.maps[c].forEach((h, f, p, _) => {
      let m = _ - p - (f - h);
      for (let g = 0; g < a.length; g += 3) {
        let y = a[g + 1];
        if (y < 0 || h > y + u - d)
          continue;
        let x = a[g] + u - d;
        f >= x ? a[g + 1] = h <= x ? -2 : -1 : h >= u && m && (a[g] += m, a[g + 1] += m);
      }
      d += m;
    }), u = t.maps[c].map(u, -1);
  }
  let l = !1;
  for (let c = 0; c < a.length; c += 3)
    if (a[c + 1] < 0) {
      if (a[c + 1] == -2) {
        l = !0, a[c + 1] = -1;
        continue;
      }
      let u = t.map(n[c] + s), d = u - r;
      if (d < 0 || d >= i.content.size) {
        l = !0;
        continue;
      }
      let h = t.map(n[c + 1] + s, -1), f = h - r, { index: p, offset: _ } = i.content.findIndex(d), m = i.maybeChild(p);
      if (m && _ == d && _ + m.nodeSize == f) {
        let g = a[c + 2].mapInner(t, m, u + 1, n[c] + s + 1, o);
        g != Mt ? (a[c] = d, a[c + 1] = f, a[c + 2] = g) : (a[c + 1] = -2, l = !0);
      } else
        l = !0;
    }
  if (l) {
    let c = Bx(a, n, e, t, r, s, o), u = zo(c, i, 0, o);
    e = u.local;
    for (let d = 0; d < a.length; d += 3)
      a[d + 1] < 0 && (a.splice(d, 3), d -= 3);
    for (let d = 0, h = 0; d < u.children.length; d += 3) {
      let f = u.children[d];
      for (; h < a.length && a[h] < f; )
        h += 3;
      a.splice(h, 0, u.children[d], u.children[d + 1], u.children[d + 2]);
    }
  }
  return new ze(e.sort(Oi), a);
}
function eg(n, e) {
  if (!e || !n.length)
    return n;
  let t = [];
  for (let i = 0; i < n.length; i++) {
    let r = n[i];
    t.push(new gt(r.from + e, r.to + e, r.type));
  }
  return t;
}
function Bx(n, e, t, i, r, s, o) {
  function a(l, c) {
    for (let u = 0; u < l.local.length; u++) {
      let d = l.local[u].map(i, r, c);
      d ? t.push(d) : o.onRemove && o.onRemove(l.local[u].spec);
    }
    for (let u = 0; u < l.children.length; u += 3)
      a(l.children[u + 2], l.children[u] + c + 1);
  }
  for (let l = 0; l < n.length; l += 3)
    n[l + 1] == -1 && a(n[l + 2], e[l] + s + 1);
  return t;
}
function tg(n, e, t) {
  if (e.isLeaf)
    return null;
  let i = t + e.nodeSize, r = null;
  for (let s = 0, o; s < n.length; s++)
    (o = n[s]) && o.from > t && o.to < i && ((r || (r = [])).push(o), n[s] = null);
  return r;
}
function ng(n) {
  let e = [];
  for (let t = 0; t < n.length; t++)
    n[t] != null && e.push(n[t]);
  return e;
}
function zo(n, e, t, i) {
  let r = [], s = !1;
  e.forEach((a, l) => {
    let c = tg(n, a, l + t);
    if (c) {
      s = !0;
      let u = zo(c, a, t + l + 1, i);
      u != Mt && r.push(l, l + a.nodeSize, u);
    }
  });
  let o = eg(s ? ng(n) : n, -t).sort(Oi);
  for (let a = 0; a < o.length; a++)
    o[a].type.valid(e, o[a]) || (i.onRemove && i.onRemove(o[a].spec), o.splice(a--, 1));
  return o.length || r.length ? new ze(o, r) : Mt;
}
function Oi(n, e) {
  return n.from - e.from || n.to - e.to;
}
function wu(n) {
  let e = n;
  for (let t = 0; t < e.length - 1; t++) {
    let i = e[t];
    if (i.from != i.to)
      for (let r = t + 1; r < e.length; r++) {
        let s = e[r];
        if (s.from == i.from) {
          s.to != i.to && (e == n && (e = n.slice()), e[r] = s.copy(s.from, i.to), Eh(e, r + 1, s.copy(i.to, s.to)));
          continue;
        } else {
          s.from < i.to && (e == n && (e = n.slice()), e[t] = i.copy(i.from, s.from), Eh(e, r, i.copy(s.from, i.to)));
          break;
        }
      }
  }
  return e;
}
function Eh(n, e, t) {
  for (; e < n.length && Oi(t, n[e]) > 0; )
    e++;
  n.splice(e, 0, t);
}
function _l(n) {
  let e = [];
  return n.someProp("decorations", (t) => {
    let i = t(n.state);
    i && i != Mt && e.push(i);
  }), n.cursorWrapper && e.push(ze.create(n.state.doc, [n.cursorWrapper.deco])), oi.from(e);
}
const Fx = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, Vx = Ut && hi <= 11;
class jx {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(e) {
    this.anchorNode = e.anchorNode, this.anchorOffset = e.anchorOffset, this.focusNode = e.focusNode, this.focusOffset = e.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(e) {
    return e.anchorNode == this.anchorNode && e.anchorOffset == this.anchorOffset && e.focusNode == this.focusNode && e.focusOffset == this.focusOffset;
  }
}
class Wx {
  constructor(e, t) {
    this.view = e, this.handleDOMChange = t, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new jx(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((i) => {
      for (let r = 0; r < i.length; r++)
        this.queue.push(i[r]);
      Ut && hi <= 11 && i.some((r) => r.type == "childList" && r.removedNodes.length || r.type == "characterData" && r.oldValue.length > r.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), Vx && (this.onCharData = (i) => {
      this.queue.push({ target: i.target, type: "characterData", oldValue: i.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, Fx)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let e = this.observer.takeRecords();
      if (e.length) {
        for (let t = 0; t < e.length; t++)
          this.queue.push(e[t]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (_h(this.view)) {
      if (this.suppressingSelectionUpdates)
        return Kn(this.view);
      if (Ut && hi <= 11 && !this.view.state.selection.empty) {
        let e = this.view.domSelectionRange();
        if (e.focusNode && Ri(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(e) {
    if (!e.focusNode)
      return !0;
    let t = /* @__PURE__ */ new Set(), i;
    for (let s = e.focusNode; s; s = fr(s))
      t.add(s);
    for (let s = e.anchorNode; s; s = fr(s))
      if (t.has(s)) {
        i = s;
        break;
      }
    let r = i && this.view.docView.nearestDesc(i);
    if (r && r.ignoreMutation({
      type: "selection",
      target: i.nodeType == 3 ? i.parentNode : i
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let e of this.observer.takeRecords())
        this.queue.push(e);
    return this.queue;
  }
  flush() {
    let { view: e } = this;
    if (!e.docView || this.flushingSoon > -1)
      return;
    let t = this.pendingRecords();
    t.length && (this.queue = []);
    let i = e.domSelectionRange(), r = !this.suppressingSelectionUpdates && !this.currentSelection.eq(i) && _h(e) && !this.ignoreSelectionChange(i), s = -1, o = -1, a = !1, l = [];
    if (e.editable)
      for (let u = 0; u < t.length; u++) {
        let d = this.registerMutation(t[u], l);
        d && (s = s < 0 ? d.from : Math.min(d.from, s), o = o < 0 ? d.to : Math.max(d.to, o), d.typeOver && (a = !0));
      }
    if (on && l.length) {
      let u = l.filter((d) => d.nodeName == "BR");
      if (u.length == 2) {
        let [d, h] = u;
        d.parentNode && d.parentNode.parentNode == h.parentNode ? h.remove() : d.remove();
      } else {
        let { focusNode: d } = this.currentSelection;
        for (let h of u) {
          let f = h.parentNode;
          f && f.nodeName == "LI" && (!d || qx(e, d) != f) && h.remove();
        }
      }
    } else if ((mt || Ot) && l.some((u) => u.nodeName == "BR") && (e.input.lastKeyCode == 8 || e.input.lastKeyCode == 46)) {
      for (let u of l)
        if (u.nodeName == "BR" && u.parentNode) {
          let d = u.nextSibling;
          d && d.nodeType == 1 && d.contentEditable == "false" && u.parentNode.removeChild(u);
        }
    }
    let c = null;
    s < 0 && r && e.input.lastFocus > Date.now() - 200 && Math.max(e.input.lastTouch, e.input.lastClick.time) < Date.now() - 300 && Aa(i) && (c = mu(e)) && c.eq(fe.near(e.state.doc.resolve(0), 1)) ? (e.input.lastFocus = 0, Kn(e), this.currentSelection.set(i), e.scrollToSelection()) : (s > -1 || r) && (s > -1 && (e.docView.markDirty(s, o), Ux(e)), this.handleDOMChange(s, o, a, l), e.docView && e.docView.dirty ? e.updateState(e.state) : this.currentSelection.eq(i) || Kn(e), this.currentSelection.set(i));
  }
  registerMutation(e, t) {
    if (t.indexOf(e.target) > -1)
      return null;
    let i = this.view.docView.nearestDesc(e.target);
    if (e.type == "attributes" && (i == this.view.docView || e.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    e.attributeName == "style" && !e.oldValue && !e.target.getAttribute("style")) || !i || i.ignoreMutation(e))
      return null;
    if (e.type == "childList") {
      for (let u = 0; u < e.addedNodes.length; u++) {
        let d = e.addedNodes[u];
        t.push(d), d.nodeType == 3 && (this.lastChangedTextNode = d);
      }
      if (i.contentDOM && i.contentDOM != i.dom && !i.contentDOM.contains(e.target))
        return { from: i.posBefore, to: i.posAfter };
      let r = e.previousSibling, s = e.nextSibling;
      if (Ut && hi <= 11 && e.addedNodes.length)
        for (let u = 0; u < e.addedNodes.length; u++) {
          let { previousSibling: d, nextSibling: h } = e.addedNodes[u];
          (!d || Array.prototype.indexOf.call(e.addedNodes, d) < 0) && (r = d), (!h || Array.prototype.indexOf.call(e.addedNodes, h) < 0) && (s = h);
        }
      let o = r && r.parentNode == e.target ? wt(r) + 1 : 0, a = i.localPosFromDOM(e.target, o, -1), l = s && s.parentNode == e.target ? wt(s) : e.target.childNodes.length, c = i.localPosFromDOM(e.target, l, 1);
      return { from: a, to: c };
    } else return e.type == "attributes" ? { from: i.posAtStart - i.border, to: i.posAtEnd + i.border } : (this.lastChangedTextNode = e.target, {
      from: i.posAtStart,
      to: i.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: e.target.nodeValue == e.oldValue
    });
  }
}
let Ch = /* @__PURE__ */ new WeakMap(), Th = !1;
function Ux(n) {
  if (!Ch.has(n) && (Ch.set(n, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(n.dom).whiteSpace) !== -1)) {
    if (n.requiresGeckoHackNode = on, Th)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), Th = !0;
  }
}
function Ah(n, e) {
  let t = e.startContainer, i = e.startOffset, r = e.endContainer, s = e.endOffset, o = n.domAtPos(n.state.selection.anchor);
  return Ri(o.node, o.offset, r, s) && ([t, i, r, s] = [r, s, t, i]), { anchorNode: t, anchorOffset: i, focusNode: r, focusOffset: s };
}
function Kx(n, e) {
  if (e.getComposedRanges) {
    let r = e.getComposedRanges(n.root)[0];
    if (r)
      return Ah(n, r);
  }
  let t;
  function i(r) {
    r.preventDefault(), r.stopImmediatePropagation(), t = r.getTargetRanges()[0];
  }
  return n.dom.addEventListener("beforeinput", i, !0), document.execCommand("indent"), n.dom.removeEventListener("beforeinput", i, !0), t ? Ah(n, t) : null;
}
function qx(n, e) {
  for (let t = e.parentNode; t && t != n.dom; t = t.parentNode) {
    let i = n.docView.nearestDesc(t, !0);
    if (i && i.node.isBlock)
      return t;
  }
  return null;
}
function Gx(n, e, t) {
  let { node: i, fromOffset: r, toOffset: s, from: o, to: a } = n.docView.parseRange(e, t), l = n.domSelectionRange(), c, u = l.anchorNode;
  if (u && n.dom.contains(u.nodeType == 1 ? u : u.parentNode) && (c = [{ node: u, offset: l.anchorOffset }], Aa(l) || c.push({ node: l.focusNode, offset: l.focusOffset })), mt && n.input.lastKeyCode === 8)
    for (let m = s; m > r; m--) {
      let g = i.childNodes[m - 1], y = g.pmViewDesc;
      if (g.nodeName == "BR" && !y) {
        s = m;
        break;
      }
      if (!y || y.size)
        break;
    }
  let d = n.state.doc, h = n.someProp("domParser") || ir.fromSchema(n.state.schema), f = d.resolve(o), p = null, _ = h.parse(i, {
    topNode: f.parent,
    topMatch: f.parent.contentMatchAt(f.index()),
    topOpen: !0,
    from: r,
    to: s,
    preserveWhitespace: f.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: c,
    ruleFromNode: Jx,
    context: f
  });
  if (c && c[0].pos != null) {
    let m = c[0].pos, g = c[1] && c[1].pos;
    g == null && (g = m), p = { anchor: m + o, head: g + o };
  }
  return { doc: _, sel: p, from: o, to: a };
}
function Jx(n) {
  let e = n.pmViewDesc;
  if (e)
    return e.parseRule();
  if (n.nodeName == "BR" && n.parentNode) {
    if (Ot && /^(ul|ol)$/i.test(n.parentNode.nodeName)) {
      let t = document.createElement("div");
      return t.appendChild(document.createElement("li")), { skip: t };
    } else if (n.parentNode.lastChild == n || Ot && /^(tr|table)$/i.test(n.parentNode.nodeName))
      return { ignore: !0 };
  } else if (n.nodeName == "IMG" && n.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const Xx = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function Yx(n, e, t, i, r) {
  let s = n.input.compositionPendingChanges || (n.composing ? n.input.compositionID : 0);
  if (n.input.compositionPendingChanges = 0, e < 0) {
    let w = n.input.lastSelectionTime > Date.now() - 50 ? n.input.lastSelectionOrigin : null, v = mu(n, w);
    if (v && !n.state.selection.eq(v)) {
      if (mt && jn && n.input.lastKeyCode === 13 && Date.now() - 100 < n.input.lastKeyCodeTime && n.someProp("handleKeyDown", (b) => b(n, wi(13, "Enter"))))
        return;
      let A = n.state.tr.setSelection(v);
      w == "pointer" ? A.setMeta("pointer", !0) : w == "key" && A.scrollIntoView(), s && A.setMeta("composition", s), n.dispatch(A);
    }
    return;
  }
  let o = n.state.doc.resolve(e), a = o.sharedDepth(t);
  e = o.before(a + 1), t = n.state.doc.resolve(t).after(a + 1);
  let l = n.state.selection, c = Gx(n, e, t), u = n.state.doc, d = u.slice(c.from, c.to), h, f;
  n.input.lastKeyCode === 8 && Date.now() - 100 < n.input.lastKeyCodeTime ? (h = n.state.selection.to, f = "end") : (h = n.state.selection.from, f = "start"), n.input.lastKeyCode = null;
  let p = ew(d.content, c.doc.content, c.from, h, f);
  if (p && n.input.domChangeCount++, (pr && n.input.lastIOSEnter > Date.now() - 225 || jn) && r.some((w) => w.nodeType == 1 && !Xx.test(w.nodeName)) && (!p || p.endA >= p.endB) && n.someProp("handleKeyDown", (w) => w(n, wi(13, "Enter")))) {
    n.input.lastIOSEnter = 0;
    return;
  }
  if (!p)
    if (i && l instanceof ue && !l.empty && l.$head.sameParent(l.$anchor) && !n.composing && !(c.sel && c.sel.anchor != c.sel.head))
      p = { start: l.from, endA: l.to, endB: l.to };
    else {
      if (c.sel) {
        let w = Mh(n, n.state.doc, c.sel);
        if (w && !w.eq(n.state.selection)) {
          let v = n.state.tr.setSelection(w);
          s && v.setMeta("composition", s), n.dispatch(v);
        }
      }
      return;
    }
  n.state.selection.from < n.state.selection.to && p.start == p.endB && n.state.selection instanceof ue && (p.start > n.state.selection.from && p.start <= n.state.selection.from + 2 && n.state.selection.from >= c.from ? p.start = n.state.selection.from : p.endA < n.state.selection.to && p.endA >= n.state.selection.to - 2 && n.state.selection.to <= c.to && (p.endB += n.state.selection.to - p.endA, p.endA = n.state.selection.to)), Ut && hi <= 11 && p.endB == p.start + 1 && p.endA == p.start && p.start > c.from && c.doc.textBetween(p.start - c.from - 1, p.start - c.from + 1) == "  " && (p.start--, p.endA--, p.endB--);
  let _ = c.doc.resolveNoCache(p.start - c.from), m = c.doc.resolveNoCache(p.endB - c.from), g = u.resolve(p.start), y = _.sameParent(m) && _.parent.inlineContent && g.end() >= p.endA;
  if ((pr && n.input.lastIOSEnter > Date.now() - 225 && (!y || r.some((w) => w.nodeName == "DIV" || w.nodeName == "P")) || !y && _.pos < c.doc.content.size && (!_.sameParent(m) || !_.parent.inlineContent) && _.pos < m.pos && !/\S/.test(c.doc.textBetween(_.pos, m.pos, "", ""))) && n.someProp("handleKeyDown", (w) => w(n, wi(13, "Enter")))) {
    n.input.lastIOSEnter = 0;
    return;
  }
  if (n.state.selection.anchor > p.start && Qx(u, p.start, p.endA, _, m) && n.someProp("handleKeyDown", (w) => w(n, wi(8, "Backspace")))) {
    jn && mt && n.domObserver.suppressSelectionUpdates();
    return;
  }
  mt && p.endB == p.start && (n.input.lastChromeDelete = Date.now()), jn && !y && _.start() != m.start() && m.parentOffset == 0 && _.depth == m.depth && c.sel && c.sel.anchor == c.sel.head && c.sel.head == p.endA && (p.endB -= 2, m = c.doc.resolveNoCache(p.endB - c.from), setTimeout(() => {
    n.someProp("handleKeyDown", function(w) {
      return w(n, wi(13, "Enter"));
    });
  }, 20));
  let x = p.start, k = p.endA, E = (w) => {
    let v = w || n.state.tr.replace(x, k, c.doc.slice(p.start - c.from, p.endB - c.from));
    if (c.sel) {
      let A = Mh(n, v.doc, c.sel);
      A && !(mt && n.composing && A.empty && (p.start != p.endB || n.input.lastChromeDelete < Date.now() - 100) && (A.head == x || A.head == v.mapping.map(k) - 1) || Ut && A.empty && A.head == x) && v.setSelection(A);
    }
    return s && v.setMeta("composition", s), v.scrollIntoView();
  }, S;
  if (y)
    if (_.pos == m.pos) {
      Ut && hi <= 11 && _.parentOffset == 0 && (n.domObserver.suppressSelectionUpdates(), setTimeout(() => Kn(n), 20));
      let w = E(n.state.tr.delete(x, k)), v = u.resolve(p.start).marksAcross(u.resolve(p.endA));
      v && w.ensureMarks(v), n.dispatch(w);
    } else if (
      // Adding or removing a mark
      p.endA == p.endB && (S = Zx(_.parent.content.cut(_.parentOffset, m.parentOffset), g.parent.content.cut(g.parentOffset, p.endA - g.start())))
    ) {
      let w = E(n.state.tr);
      S.type == "add" ? w.addMark(x, k, S.mark) : w.removeMark(x, k, S.mark), n.dispatch(w);
    } else if (_.parent.child(_.index()).isText && _.index() == m.index() - (m.textOffset ? 0 : 1)) {
      let w = _.parent.textBetween(_.parentOffset, m.parentOffset), v = () => E(n.state.tr.insertText(w, x, k));
      n.someProp("handleTextInput", (A) => A(n, x, k, w, v)) || n.dispatch(v());
    } else
      n.dispatch(E());
  else
    n.dispatch(E());
}
function Mh(n, e, t) {
  return Math.max(t.anchor, t.head) > e.content.size ? null : gu(n, e.resolve(t.anchor), e.resolve(t.head));
}
function Zx(n, e) {
  let t = n.firstChild.marks, i = e.firstChild.marks, r = t, s = i, o, a, l;
  for (let u = 0; u < i.length; u++)
    r = i[u].removeFromSet(r);
  for (let u = 0; u < t.length; u++)
    s = t[u].removeFromSet(s);
  if (r.length == 1 && s.length == 0)
    a = r[0], o = "add", l = (u) => u.mark(a.addToSet(u.marks));
  else if (r.length == 0 && s.length == 1)
    a = s[0], o = "remove", l = (u) => u.mark(a.removeFromSet(u.marks));
  else
    return null;
  let c = [];
  for (let u = 0; u < e.childCount; u++)
    c.push(l(e.child(u)));
  if ($.from(c).eq(n))
    return { mark: a, type: o };
}
function Qx(n, e, t, i, r) {
  if (
    // The content must have shrunk
    t - e <= r.pos - i.pos || // newEnd must point directly at or after the end of the block that newStart points into
    bl(i, !0, !1) < r.pos
  )
    return !1;
  let s = n.resolve(e);
  if (!i.parent.isTextblock) {
    let a = s.nodeAfter;
    return a != null && t == e + a.nodeSize;
  }
  if (s.parentOffset < s.parent.content.size || !s.parent.isTextblock)
    return !1;
  let o = n.resolve(bl(s, !0, !0));
  return !o.parent.isTextblock || o.pos > t || bl(o, !0, !1) < t ? !1 : i.parent.content.cut(i.parentOffset).eq(o.parent.content);
}
function bl(n, e, t) {
  let i = n.depth, r = e ? n.end() : n.pos;
  for (; i > 0 && (e || n.indexAfter(i) == n.node(i).childCount); )
    i--, r++, e = !1;
  if (t) {
    let s = n.node(i).maybeChild(n.indexAfter(i));
    for (; s && !s.isLeaf; )
      s = s.firstChild, r++;
  }
  return r;
}
function ew(n, e, t, i, r) {
  let s = n.findDiffStart(e, t);
  if (s == null)
    return null;
  let { a: o, b: a } = n.findDiffEnd(e, t + n.size, t + e.size);
  if (r == "end") {
    let l = Math.max(0, s - Math.min(o, a));
    i -= o + l - s;
  }
  if (o < s && n.size < e.size) {
    let l = i <= s && i >= o ? s - i : 0;
    s -= l, s && s < e.size && Oh(e.textBetween(s - 1, s + 1)) && (s += l ? 1 : -1), a = s + (a - o), o = s;
  } else if (a < s) {
    let l = i <= s && i >= a ? s - i : 0;
    s -= l, s && s < n.size && Oh(n.textBetween(s - 1, s + 1)) && (s += l ? 1 : -1), o = s + (o - a), a = s;
  }
  return { start: s, endA: o, endB: a };
}
function Oh(n) {
  if (n.length != 2)
    return !1;
  let e = n.charCodeAt(0), t = n.charCodeAt(1);
  return e >= 56320 && e <= 57343 && t >= 55296 && t <= 56319;
}
class ig {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(e, t) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new _x(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = t, this.state = t.state, this.directPlugins = t.plugins || [], this.directPlugins.forEach(Ph), this.dispatch = this.dispatch.bind(this), this.dom = e && e.mount || document.createElement("div"), e && (e.appendChild ? e.appendChild(this.dom) : typeof e == "function" ? e(this.dom) : e.mount && (this.mounted = !0)), this.editable = Rh(this), Lh(this), this.nodeViews = Ih(this), this.docView = dh(this.state.doc, Nh(this), _l(this), this.dom, this), this.domObserver = new Wx(this, (i, r, s, o) => Yx(this, i, r, s, o)), this.domObserver.start(), bx(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let e = this._props;
      this._props = {};
      for (let t in e)
        this._props[t] = e[t];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(e) {
    e.handleDOMEvents != this._props.handleDOMEvents && Sc(this);
    let t = this._props;
    this._props = e, e.plugins && (e.plugins.forEach(Ph), this.directPlugins = e.plugins), this.updateStateInner(e.state, t);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(e) {
    let t = {};
    for (let i in this._props)
      t[i] = this._props[i];
    t.state = this.state;
    for (let i in e)
      t[i] = e[i];
    this.update(t);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(e) {
    this.updateStateInner(e, this._props);
  }
  updateStateInner(e, t) {
    var i;
    let r = this.state, s = !1, o = !1;
    e.storedMarks && this.composing && (Xm(this), o = !0), this.state = e;
    let a = r.plugins != e.plugins || this._props.plugins != t.plugins;
    if (a || this._props.plugins != t.plugins || this._props.nodeViews != t.nodeViews) {
      let f = Ih(this);
      nw(f, this.nodeViews) && (this.nodeViews = f, s = !0);
    }
    (a || t.handleDOMEvents != this._props.handleDOMEvents) && Sc(this), this.editable = Rh(this), Lh(this);
    let l = _l(this), c = Nh(this), u = r.plugins != e.plugins && !r.doc.eq(e.doc) ? "reset" : e.scrollToSelection > r.scrollToSelection ? "to selection" : "preserve", d = s || !this.docView.matchesNode(e.doc, c, l);
    (d || !e.selection.eq(r.selection)) && (o = !0);
    let h = u == "preserve" && o && this.dom.style.overflowAnchor == null && Ly(this);
    if (o) {
      this.domObserver.stop();
      let f = d && (Ut || mt) && !this.composing && !r.selection.empty && !e.selection.empty && tw(r.selection, e.selection);
      if (d) {
        let p = mt ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = Lx(this)), (s || !this.docView.update(e.doc, c, l, this)) && (this.docView.updateOuterDeco(c), this.docView.destroy(), this.docView = dh(e.doc, c, l, this.dom, this)), p && (!this.trackWrites || !this.dom.contains(this.trackWrites)) && (f = !0);
      }
      f || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && nx(this)) ? Kn(this, f) : (zm(this, e.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(r), !((i = this.dragging) === null || i === void 0) && i.node && !r.doc.eq(e.doc) && this.updateDraggedNode(this.dragging, r), u == "reset" ? this.dom.scrollTop = 0 : u == "to selection" ? this.scrollToSelection() : h && Ry(h);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let e = this.domSelectionRange().focusNode;
    if (!(!e || !this.dom.contains(e.nodeType == 1 ? e : e.parentNode))) {
      if (!this.someProp("handleScrollToSelection", (t) => t(this))) if (this.state.selection instanceof re) {
        let t = this.docView.domAfterPos(this.state.selection.from);
        t.nodeType == 1 && sh(this, t.getBoundingClientRect(), e);
      } else
        sh(this, this.coordsAtPos(this.state.selection.head, 1), e);
    }
  }
  destroyPluginViews() {
    let e;
    for (; e = this.pluginViews.pop(); )
      e.destroy && e.destroy();
  }
  updatePluginViews(e) {
    if (!e || e.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let t = 0; t < this.directPlugins.length; t++) {
        let i = this.directPlugins[t];
        i.spec.view && this.pluginViews.push(i.spec.view(this));
      }
      for (let t = 0; t < this.state.plugins.length; t++) {
        let i = this.state.plugins[t];
        i.spec.view && this.pluginViews.push(i.spec.view(this));
      }
    } else
      for (let t = 0; t < this.pluginViews.length; t++) {
        let i = this.pluginViews[t];
        i.update && i.update(this, e);
      }
  }
  updateDraggedNode(e, t) {
    let i = e.node, r = -1;
    if (this.state.doc.nodeAt(i.from) == i.node)
      r = i.from;
    else {
      let s = i.from + (this.state.doc.content.size - t.doc.content.size);
      (s > 0 && this.state.doc.nodeAt(s)) == i.node && (r = s);
    }
    this.dragging = new Zm(e.slice, e.move, r < 0 ? void 0 : re.create(this.state.doc, r));
  }
  someProp(e, t) {
    let i = this._props && this._props[e], r;
    if (i != null && (r = t ? t(i) : i))
      return r;
    for (let o = 0; o < this.directPlugins.length; o++) {
      let a = this.directPlugins[o].props[e];
      if (a != null && (r = t ? t(a) : a))
        return r;
    }
    let s = this.state.plugins;
    if (s)
      for (let o = 0; o < s.length; o++) {
        let a = s[o].props[e];
        if (a != null && (r = t ? t(a) : a))
          return r;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (Ut) {
      let e = this.root.activeElement;
      if (e == this.dom)
        return !0;
      if (!e || !this.dom.contains(e))
        return !1;
      for (; e && this.dom != e && this.dom.contains(e); ) {
        if (e.contentEditable == "false")
          return !1;
        e = e.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && Iy(this.dom), Kn(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let e = this._root;
    if (e == null) {
      for (let t = this.dom.parentNode; t; t = t.parentNode)
        if (t.nodeType == 9 || t.nodeType == 11 && t.host)
          return t.getSelection || (Object.getPrototypeOf(t).getSelection = () => t.ownerDocument.getSelection()), this._root = t;
    }
    return e || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(e) {
    return Hy(this, e);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(e, t = 1) {
    return Om(this, e, t);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(e, t = 0) {
    return this.docView.domFromPos(e, t);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(e) {
    let t = this.docView.descAt(e);
    return t ? t.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(e, t, i = -1) {
    let r = this.docView.posFromDOM(e, t, i);
    if (r == null)
      throw new RangeError("DOM position not inside the editor");
    return r;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(e, t) {
    return Wy(this, t || this.state, e);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(e, t) {
    return gs(this, "", e, !1, t || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(e, t) {
    return gs(this, e, null, !0, t || new ClipboardEvent("paste"));
  }
  /**
  Serialize the given slice as it would be if it was copied from
  this editor. Returns a DOM element that contains a
  representation of the slice as its children, a textual
  representation, and the transformed slice (which can be
  different from the given input due to hooks like
  [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
  */
  serializeForClipboard(e) {
    return _u(this, e);
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (vx(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], _l(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, wy());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(e) {
    return xx(this, e);
  }
  /**
  @internal
  */
  domSelectionRange() {
    let e = this.domSelection();
    return e ? Ot && this.root.nodeType === 11 && Ty(this.dom.ownerDocument) == this.dom && Kx(this, e) || e : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
ig.prototype.dispatch = function(n) {
  let e = this._props.dispatchTransaction;
  e ? e.call(this, n) : this.updateState(this.state.apply(n));
};
function Nh(n) {
  let e = /* @__PURE__ */ Object.create(null);
  return e.class = "ProseMirror", e.contenteditable = String(n.editable), n.someProp("attributes", (t) => {
    if (typeof t == "function" && (t = t(n.state)), t)
      for (let i in t)
        i == "class" ? e.class += " " + t[i] : i == "style" ? e.style = (e.style ? e.style + ";" : "") + t[i] : !e[i] && i != "contenteditable" && i != "nodeName" && (e[i] = String(t[i]));
  }), e.translate || (e.translate = "no"), [gt.node(0, n.state.doc.content.size, e)];
}
function Lh(n) {
  if (n.markCursor) {
    let e = document.createElement("img");
    e.className = "ProseMirror-separator", e.setAttribute("mark-placeholder", "true"), e.setAttribute("alt", ""), n.cursorWrapper = { dom: e, deco: gt.widget(n.state.selection.from, e, { raw: !0, marks: n.markCursor }) };
  } else
    n.cursorWrapper = null;
}
function Rh(n) {
  return !n.someProp("editable", (e) => e(n.state) === !1);
}
function tw(n, e) {
  let t = Math.min(n.$anchor.sharedDepth(n.head), e.$anchor.sharedDepth(e.head));
  return n.$anchor.start(t) != e.$anchor.start(t);
}
function Ih(n) {
  let e = /* @__PURE__ */ Object.create(null);
  function t(i) {
    for (let r in i)
      Object.prototype.hasOwnProperty.call(e, r) || (e[r] = i[r]);
  }
  return n.someProp("nodeViews", t), n.someProp("markViews", t), e;
}
function nw(n, e) {
  let t = 0, i = 0;
  for (let r in n) {
    if (n[r] != e[r])
      return !0;
    t++;
  }
  for (let r in e)
    i++;
  return t != i;
}
function Ph(n) {
  if (n.spec.state || n.spec.filterTransaction || n.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var gi = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, Ho = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, iw = typeof navigator < "u" && /Mac/.test(navigator.platform), rw = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var kt = 0; kt < 10; kt++) gi[48 + kt] = gi[96 + kt] = String(kt);
for (var kt = 1; kt <= 24; kt++) gi[kt + 111] = "F" + kt;
for (var kt = 65; kt <= 90; kt++)
  gi[kt] = String.fromCharCode(kt + 32), Ho[kt] = String.fromCharCode(kt);
for (var vl in gi) Ho.hasOwnProperty(vl) || (Ho[vl] = gi[vl]);
function sw(n) {
  var e = iw && n.metaKey && n.shiftKey && !n.ctrlKey && !n.altKey || rw && n.shiftKey && n.key && n.key.length == 1 || n.key == "Unidentified", t = !e && n.key || (n.shiftKey ? Ho : gi)[n.keyCode] || n.key || "Unidentified";
  return t == "Esc" && (t = "Escape"), t == "Del" && (t = "Delete"), t == "Left" && (t = "ArrowLeft"), t == "Up" && (t = "ArrowUp"), t == "Right" && (t = "ArrowRight"), t == "Down" && (t = "ArrowDown"), t;
}
const ow = typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : !1;
function aw(n) {
  let e = n.split(/-(?!$)/), t = e[e.length - 1];
  t == "Space" && (t = " ");
  let i, r, s, o;
  for (let a = 0; a < e.length - 1; a++) {
    let l = e[a];
    if (/^(cmd|meta|m)$/i.test(l))
      o = !0;
    else if (/^a(lt)?$/i.test(l))
      i = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      r = !0;
    else if (/^s(hift)?$/i.test(l))
      s = !0;
    else if (/^mod$/i.test(l))
      ow ? o = !0 : r = !0;
    else
      throw new Error("Unrecognized modifier name: " + l);
  }
  return i && (t = "Alt-" + t), r && (t = "Ctrl-" + t), o && (t = "Meta-" + t), s && (t = "Shift-" + t), t;
}
function lw(n) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in n)
    e[aw(t)] = n[t];
  return e;
}
function yl(n, e, t = !0) {
  return e.altKey && (n = "Alt-" + n), e.ctrlKey && (n = "Ctrl-" + n), e.metaKey && (n = "Meta-" + n), t && e.shiftKey && (n = "Shift-" + n), n;
}
function cw(n) {
  return new je({ props: { handleKeyDown: ku(n) } });
}
function ku(n) {
  let e = lw(n);
  return function(t, i) {
    let r = sw(i), s, o = e[yl(r, i)];
    if (o && o(t.state, t.dispatch, t))
      return !0;
    if (r.length == 1 && r != " ") {
      if (i.shiftKey) {
        let a = e[yl(r, i, !1)];
        if (a && a(t.state, t.dispatch, t))
          return !0;
      }
      if ((i.shiftKey || i.altKey || i.metaKey || r.charCodeAt(0) > 127) && (s = gi[i.keyCode]) && s != r) {
        let a = e[yl(s, i)];
        if (a && a(t.state, t.dispatch, t))
          return !0;
      }
    }
    return !1;
  };
}
var uw = Object.defineProperty, Su = (n, e) => {
  for (var t in e)
    uw(n, t, { get: e[t], enumerable: !0 });
};
function Ts(n) {
  const { state: e, transaction: t } = n;
  let { selection: i } = t, { doc: r } = t, { storedMarks: s } = t;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return s;
    },
    get selection() {
      return i;
    },
    get doc() {
      return r;
    },
    get tr() {
      return i = t.selection, r = t.doc, s = t.storedMarks, t;
    }
  };
}
var As = class {
  constructor(n) {
    this.editor = n.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = n.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: n, editor: e, state: t } = this, { view: i } = e, { tr: r } = t, s = this.buildProps(r);
    return Object.fromEntries(
      Object.entries(n).map(([o, a]) => [o, (...c) => {
        const u = a(...c)(s);
        return !r.getMeta("preventDispatch") && !this.hasCustomState && i.dispatch(r), u;
      }])
    );
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(n, e = !0) {
    const { rawCommands: t, editor: i, state: r } = this, { view: s } = i, o = [], a = !!n, l = n || r.tr, c = () => (!a && e && !l.getMeta("preventDispatch") && !this.hasCustomState && s.dispatch(l), o.every((d) => d === !0)), u = {
      ...Object.fromEntries(
        Object.entries(t).map(([d, h]) => [d, (...p) => {
          const _ = this.buildProps(l, e), m = h(...p)(_);
          return o.push(m), u;
        }])
      ),
      run: c
    };
    return u;
  }
  createCan(n) {
    const { rawCommands: e, state: t } = this, i = !1, r = n || t.tr, s = this.buildProps(r, i);
    return {
      ...Object.fromEntries(
        Object.entries(e).map(([a, l]) => [a, (...c) => l(...c)({ ...s, dispatch: void 0 })])
      ),
      chain: () => this.createChain(r, i)
    };
  }
  buildProps(n, e = !0) {
    const { rawCommands: t, editor: i, state: r } = this, { view: s } = i, o = {
      tr: n,
      editor: i,
      view: s,
      state: Ts({
        state: r,
        transaction: n
      }),
      dispatch: e ? () => {
      } : void 0,
      chain: () => this.createChain(n, e),
      can: () => this.createCan(n),
      get commands() {
        return Object.fromEntries(
          Object.entries(t).map(([a, l]) => [a, (...c) => l(...c)(o)])
        );
      }
    };
    return o;
  }
}, Eu = {};
Su(Eu, {
  blur: () => dw,
  clearContent: () => hw,
  clearNodes: () => fw,
  command: () => pw,
  createParagraphNear: () => mw,
  cut: () => gw,
  deleteCurrentNode: () => _w,
  deleteNode: () => bw,
  deleteRange: () => vw,
  deleteSelection: () => yw,
  enter: () => xw,
  exitCode: () => ww,
  extendMarkRange: () => kw,
  first: () => Sw,
  focus: () => Ew,
  forEach: () => Cw,
  insertContent: () => Tw,
  insertContentAt: () => Mw,
  joinBackward: () => Lw,
  joinDown: () => Nw,
  joinForward: () => Rw,
  joinItemBackward: () => Iw,
  joinItemForward: () => Pw,
  joinTextblockBackward: () => Dw,
  joinTextblockForward: () => $w,
  joinUp: () => Ow,
  keyboardShortcut: () => Hw,
  lift: () => Bw,
  liftEmptyBlock: () => Fw,
  liftListItem: () => Vw,
  newlineInCode: () => jw,
  resetAttributes: () => Ww,
  scrollIntoView: () => Uw,
  selectAll: () => Kw,
  selectNodeBackward: () => qw,
  selectNodeForward: () => Gw,
  selectParentNode: () => Jw,
  selectTextblockEnd: () => Xw,
  selectTextblockStart: () => Yw,
  setContent: () => Zw,
  setMark: () => ok,
  setMeta: () => ak,
  setNode: () => lk,
  setNodeSelection: () => ck,
  setTextSelection: () => uk,
  sinkListItem: () => dk,
  splitBlock: () => hk,
  splitListItem: () => fk,
  toggleList: () => pk,
  toggleMark: () => mk,
  toggleNode: () => gk,
  toggleWrap: () => _k,
  undoInputRule: () => bk,
  unsetAllMarks: () => vk,
  unsetMark: () => yk,
  updateAttributes: () => xk,
  wrapIn: () => wk,
  wrapInList: () => kk
});
var dw = () => ({ editor: n, view: e }) => (requestAnimationFrame(() => {
  var t;
  n.isDestroyed || (e.dom.blur(), (t = window?.getSelection()) == null || t.removeAllRanges());
}), !0), hw = (n = !0) => ({ commands: e }) => e.setContent("", { emitUpdate: n }), fw = () => ({ state: n, tr: e, dispatch: t }) => {
  const { selection: i } = e, { ranges: r } = i;
  return t && r.forEach(({ $from: s, $to: o }) => {
    n.doc.nodesBetween(s.pos, o.pos, (a, l) => {
      if (a.type.isText)
        return;
      const { doc: c, mapping: u } = e, d = c.resolve(u.map(l)), h = c.resolve(u.map(l + a.nodeSize)), f = d.blockRange(h);
      if (!f)
        return;
      const p = yr(f);
      if (a.type.isTextblock) {
        const { defaultType: _ } = d.parent.contentMatchAt(d.index());
        e.setNodeMarkup(f.start, _);
      }
      (p || p === 0) && e.lift(f, p);
    });
  }), !0;
}, pw = (n) => (e) => n(e), mw = () => ({ state: n, dispatch: e }) => vm(n, e), gw = (n, e) => ({ editor: t, tr: i }) => {
  const { state: r } = t, s = r.doc.slice(n.from, n.to);
  i.deleteRange(n.from, n.to);
  const o = i.mapping.map(e);
  return i.insert(o, s.content), i.setSelection(new ue(i.doc.resolve(Math.max(o - 1, 0)))), !0;
}, _w = () => ({ tr: n, dispatch: e }) => {
  const { selection: t } = n, i = t.$anchor.node();
  if (i.content.size > 0)
    return !1;
  const r = n.selection.$anchor;
  for (let s = r.depth; s > 0; s -= 1)
    if (r.node(s).type === i.type) {
      if (e) {
        const a = r.before(s), l = r.after(s);
        n.delete(a, l).scrollIntoView();
      }
      return !0;
    }
  return !1;
};
function Ze(n, e) {
  if (typeof n == "string") {
    if (!e.nodes[n])
      throw Error(`There is no node type named '${n}'. Maybe you forgot to add the extension?`);
    return e.nodes[n];
  }
  return n;
}
var bw = (n) => ({ tr: e, state: t, dispatch: i }) => {
  const r = Ze(n, t.schema), s = e.selection.$anchor;
  for (let o = s.depth; o > 0; o -= 1)
    if (s.node(o).type === r) {
      if (i) {
        const l = s.before(o), c = s.after(o);
        e.delete(l, c).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, vw = (n) => ({ tr: e, dispatch: t }) => {
  const { from: i, to: r } = n;
  return t && e.delete(i, r), !0;
}, yw = () => ({ state: n, dispatch: e }) => cu(n, e), xw = () => ({ commands: n }) => n.keyboardShortcut("Enter"), ww = () => ({ state: n, dispatch: e }) => ay(n, e);
function Na(n) {
  return Object.prototype.toString.call(n) === "[object RegExp]";
}
function bs(n, e, t = { strict: !0 }) {
  const i = Object.keys(e);
  return i.length ? i.every((r) => t.strict ? e[r] === n[r] : Na(e[r]) ? e[r].test(n[r]) : e[r] === n[r]) : !0;
}
function rg(n, e, t = {}) {
  return n.find((i) => i.type === e && bs(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(t).map((r) => [r, i.attrs[r]])),
    t
  ));
}
function Dh(n, e, t = {}) {
  return !!rg(n, e, t);
}
function La(n, e, t) {
  var i;
  if (!n || !e)
    return;
  let r = n.parent.childAfter(n.parentOffset);
  if ((!r.node || !r.node.marks.some((u) => u.type === e)) && (r = n.parent.childBefore(n.parentOffset)), !r.node || !r.node.marks.some((u) => u.type === e) || (t = t || ((i = r.node.marks[0]) == null ? void 0 : i.attrs), !rg([...r.node.marks], e, t)))
    return;
  let o = r.index, a = n.start() + r.offset, l = o + 1, c = a + r.node.nodeSize;
  for (; o > 0 && Dh([...n.parent.child(o - 1).marks], e, t); )
    o -= 1, a -= n.parent.child(o).nodeSize;
  for (; l < n.parent.childCount && Dh([...n.parent.child(l).marks], e, t); )
    c += n.parent.child(l).nodeSize, l += 1;
  return {
    from: a,
    to: c
  };
}
function Rn(n, e) {
  if (typeof n == "string") {
    if (!e.marks[n])
      throw Error(`There is no mark type named '${n}'. Maybe you forgot to add the extension?`);
    return e.marks[n];
  }
  return n;
}
var kw = (n, e = {}) => ({ tr: t, state: i, dispatch: r }) => {
  const s = Rn(n, i.schema), { doc: o, selection: a } = t, { $from: l, from: c, to: u } = a;
  if (r) {
    const d = La(l, s, e);
    if (d && d.from <= c && d.to >= u) {
      const h = ue.create(o, d.from, d.to);
      t.setSelection(h);
    }
  }
  return !0;
}, Sw = (n) => (e) => {
  const t = typeof n == "function" ? n(e) : n;
  for (let i = 0; i < t.length; i += 1)
    if (t[i](e))
      return !0;
  return !1;
};
function Cu(n) {
  return n instanceof ue;
}
function Mn(n = 0, e = 0, t = 0) {
  return Math.min(Math.max(n, e), t);
}
function Tu(n, e = null) {
  if (!e)
    return null;
  const t = fe.atStart(n), i = fe.atEnd(n);
  if (e === "start" || e === !0)
    return t;
  if (e === "end")
    return i;
  const r = t.from, s = i.to;
  return e === "all" ? ue.create(n, Mn(0, r, s), Mn(n.content.size, r, s)) : ue.create(n, Mn(e, r, s), Mn(e, r, s));
}
function Ra() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function xr() {
  return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || // iPad on iOS 13 detection
  navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
var Ew = (n = null, e = {}) => ({ editor: t, view: i, tr: r, dispatch: s }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const o = () => {
    (xr() || Ra()) && i.dom.focus(), requestAnimationFrame(() => {
      t.isDestroyed || (i.focus(), e?.scrollIntoView && t.commands.scrollIntoView());
    });
  };
  if (i.hasFocus() && n === null || n === !1)
    return !0;
  if (s && n === null && !Cu(t.state.selection))
    return o(), !0;
  const a = Tu(r.doc, n) || t.state.selection, l = t.state.selection.eq(a);
  return s && (l || r.setSelection(a), l && r.storedMarks && r.setStoredMarks(r.storedMarks), o()), !0;
}, Cw = (n, e) => (t) => n.every((i, r) => e(i, { ...t, index: r })), Tw = (n, e) => ({ tr: t, commands: i }) => i.insertContentAt({ from: t.selection.from, to: t.selection.to }, n, e), sg = (n) => {
  const e = n.childNodes;
  for (let t = e.length - 1; t >= 0; t -= 1) {
    const i = e[t];
    i.nodeType === 3 && i.nodeValue && /^(\n\s\s|\n)$/.test(i.nodeValue) ? n.removeChild(i) : i.nodeType === 1 && sg(i);
  }
  return n;
};
function Qi(n) {
  if (typeof window > "u")
    throw new Error("[tiptap error]: there is no window object available, so this function cannot be used");
  const e = `<body>${n}</body>`, t = new window.DOMParser().parseFromString(e, "text/html").body;
  return sg(t);
}
function mr(n, e, t) {
  if (n instanceof On || n instanceof $)
    return n;
  t = {
    slice: !0,
    parseOptions: {},
    ...t
  };
  const i = typeof n == "object" && n !== null, r = typeof n == "string";
  if (i)
    try {
      if (Array.isArray(n) && n.length > 0)
        return $.fromArray(n.map((a) => e.nodeFromJSON(a)));
      const o = e.nodeFromJSON(n);
      return t.errorOnInvalidContent && o.check(), o;
    } catch (s) {
      if (t.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: s });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", n, "Error:", s), mr("", e, t);
    }
  if (r) {
    if (t.errorOnInvalidContent) {
      let o = !1, a = "";
      const l = new Kp({
        topNode: e.spec.topNode,
        marks: e.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: e.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (c) => (o = !0, a = typeof c == "string" ? c : c.outerHTML, null)
              }
            ]
          }
        })
      });
      if (t.slice ? ir.fromSchema(l).parseSlice(Qi(n), t.parseOptions) : ir.fromSchema(l).parse(Qi(n), t.parseOptions), t.errorOnInvalidContent && o)
        throw new Error("[tiptap error]: Invalid HTML content", {
          cause: new Error(`Invalid element found: ${a}`)
        });
    }
    const s = ir.fromSchema(e);
    return t.slice ? s.parseSlice(Qi(n), t.parseOptions).content : s.parse(Qi(n), t.parseOptions);
  }
  return mr("", e, t);
}
function og(n, e, t) {
  const i = n.steps.length - 1;
  if (i < e)
    return;
  const r = n.steps[i];
  if (!(r instanceof pt || r instanceof _t))
    return;
  const s = n.mapping.maps[i];
  let o = 0;
  s.forEach((a, l, c, u) => {
    o === 0 && (o = u);
  }), n.setSelection(fe.near(n.doc.resolve(o), t));
}
var Aw = (n) => !("type" in n), Mw = (n, e, t) => ({ tr: i, dispatch: r, editor: s }) => {
  var o;
  if (r) {
    t = {
      parseOptions: s.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...t
    };
    let a;
    const l = (m) => {
      s.emit("contentError", {
        editor: s,
        error: m,
        disableCollaboration: () => {
          "collaboration" in s.storage && typeof s.storage.collaboration == "object" && s.storage.collaboration && (s.storage.collaboration.isDisabled = !0);
        }
      });
    }, c = {
      preserveWhitespace: "full",
      ...t.parseOptions
    };
    if (!t.errorOnInvalidContent && !s.options.enableContentCheck && s.options.emitContentError)
      try {
        mr(e, s.schema, {
          parseOptions: c,
          errorOnInvalidContent: !0
        });
      } catch (m) {
        l(m);
      }
    try {
      a = mr(e, s.schema, {
        parseOptions: c,
        errorOnInvalidContent: (o = t.errorOnInvalidContent) != null ? o : s.options.enableContentCheck
      });
    } catch (m) {
      return l(m), !1;
    }
    let { from: u, to: d } = typeof n == "number" ? { from: n, to: n } : { from: n.from, to: n.to }, h = !0, f = !0;
    if ((Aw(a) ? a : [a]).forEach((m) => {
      m.check(), h = h ? m.isText && m.marks.length === 0 : !1, f = f ? m.isBlock : !1;
    }), u === d && f) {
      const { parent: m } = i.doc.resolve(u);
      m.isTextblock && !m.type.spec.code && !m.childCount && (u -= 1, d += 1);
    }
    let _;
    if (h) {
      if (Array.isArray(e))
        _ = e.map((m) => m.text || "").join("");
      else if (e instanceof $) {
        let m = "";
        e.forEach((g) => {
          g.text && (m += g.text);
        }), _ = m;
      } else typeof e == "object" && e && e.text ? _ = e.text : _ = e;
      i.insertText(_, u, d);
    } else {
      _ = a;
      const m = i.doc.resolve(u), g = m.node(), y = m.parentOffset === 0, x = g.isText || g.isTextblock, k = g.content.size > 0;
      y && x && k && (u = Math.max(0, u - 1)), i.replaceWith(u, d, _);
    }
    t.updateSelection && og(i, i.steps.length - 1, -1), t.applyInputRules && i.setMeta("applyInputRules", { from: u, text: _ }), t.applyPasteRules && i.setMeta("applyPasteRules", { from: u, text: _ });
  }
  return !0;
}, Ow = () => ({ state: n, dispatch: e }) => ry(n, e), Nw = () => ({ state: n, dispatch: e }) => sy(n, e), Lw = () => ({ state: n, dispatch: e }) => hm(n, e), Rw = () => ({ state: n, dispatch: e }) => gm(n, e), Iw = () => ({ state: n, dispatch: e, tr: t }) => {
  try {
    const i = Ea(n.doc, n.selection.$from.pos, -1);
    return i == null ? !1 : (t.join(i, 2), e && e(t), !0);
  } catch {
    return !1;
  }
}, Pw = () => ({ state: n, dispatch: e, tr: t }) => {
  try {
    const i = Ea(n.doc, n.selection.$from.pos, 1);
    return i == null ? !1 : (t.join(i, 2), e && e(t), !0);
  } catch {
    return !1;
  }
}, Dw = () => ({ state: n, dispatch: e }) => ny(n, e), $w = () => ({ state: n, dispatch: e }) => iy(n, e);
function Au() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function zw(n) {
  const e = n.split(/-(?!$)/);
  let t = e[e.length - 1];
  t === "Space" && (t = " ");
  let i, r, s, o;
  for (let a = 0; a < e.length - 1; a += 1) {
    const l = e[a];
    if (/^(cmd|meta|m)$/i.test(l))
      o = !0;
    else if (/^a(lt)?$/i.test(l))
      i = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      r = !0;
    else if (/^s(hift)?$/i.test(l))
      s = !0;
    else if (/^mod$/i.test(l))
      xr() || Au() ? o = !0 : r = !0;
    else
      throw new Error(`Unrecognized modifier name: ${l}`);
  }
  return i && (t = `Alt-${t}`), r && (t = `Ctrl-${t}`), o && (t = `Meta-${t}`), s && (t = `Shift-${t}`), t;
}
var Hw = (n) => ({ editor: e, view: t, tr: i, dispatch: r }) => {
  const s = zw(n).split(/-(?!$)/), o = s.find((c) => !["Alt", "Ctrl", "Meta", "Shift"].includes(c)), a = new KeyboardEvent("keydown", {
    key: o === "Space" ? " " : o,
    altKey: s.includes("Alt"),
    ctrlKey: s.includes("Ctrl"),
    metaKey: s.includes("Meta"),
    shiftKey: s.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), l = e.captureTransaction(() => {
    t.someProp("handleKeyDown", (c) => c(t, a));
  });
  return l?.steps.forEach((c) => {
    const u = c.map(i.mapping);
    u && r && i.maybeStep(u);
  }), !0;
};
function Gn(n, e, t = {}) {
  const { from: i, to: r, empty: s } = n.selection, o = e ? Ze(e, n.schema) : null, a = [];
  n.doc.nodesBetween(i, r, (d, h) => {
    if (d.isText)
      return;
    const f = Math.max(i, h), p = Math.min(r, h + d.nodeSize);
    a.push({
      node: d,
      from: f,
      to: p
    });
  });
  const l = r - i, c = a.filter((d) => o ? o.name === d.node.type.name : !0).filter((d) => bs(d.node.attrs, t, { strict: !1 }));
  return s ? !!c.length : c.reduce((d, h) => d + h.to - h.from, 0) >= l;
}
var Bw = (n, e = {}) => ({ state: t, dispatch: i }) => {
  const r = Ze(n, t.schema);
  return Gn(t, r, e) ? oy(t, i) : !1;
}, Fw = () => ({ state: n, dispatch: e }) => ym(n, e), Vw = (n) => ({ state: e, dispatch: t }) => {
  const i = Ze(n, e.schema);
  return by(i)(e, t);
}, jw = () => ({ state: n, dispatch: e }) => bm(n, e);
function Ms(n, e) {
  return e.nodes[n] ? "node" : e.marks[n] ? "mark" : null;
}
function Ec(n, e) {
  const t = typeof e == "string" ? [e] : e;
  return Object.keys(n).reduce((i, r) => (t.includes(r) || (i[r] = n[r]), i), {});
}
var Ww = (n, e) => ({ tr: t, state: i, dispatch: r }) => {
  let s = null, o = null;
  const a = Ms(
    typeof n == "string" ? n : n.name,
    i.schema
  );
  return a ? (a === "node" && (s = Ze(n, i.schema)), a === "mark" && (o = Rn(n, i.schema)), r && t.selection.ranges.forEach((l) => {
    i.doc.nodesBetween(l.$from.pos, l.$to.pos, (c, u) => {
      s && s === c.type && t.setNodeMarkup(u, void 0, Ec(c.attrs, e)), o && c.marks.length && c.marks.forEach((d) => {
        o === d.type && t.addMark(u, u + c.nodeSize, o.create(Ec(d.attrs, e)));
      });
    });
  }), !0) : !1;
}, Uw = () => ({ tr: n, dispatch: e }) => (e && n.scrollIntoView(), !0), Kw = () => ({ tr: n, dispatch: e }) => {
  if (e) {
    const t = new Wt(n.doc);
    n.setSelection(t);
  }
  return !0;
}, qw = () => ({ state: n, dispatch: e }) => pm(n, e), Gw = () => ({ state: n, dispatch: e }) => _m(n, e), Jw = () => ({ state: n, dispatch: e }) => uy(n, e), Xw = () => ({ state: n, dispatch: e }) => fy(n, e), Yw = () => ({ state: n, dispatch: e }) => hy(n, e);
function Bo(n, e, t = {}, i = {}) {
  return mr(n, e, {
    slice: !1,
    parseOptions: t,
    errorOnInvalidContent: i.errorOnInvalidContent
  });
}
var Zw = (n, { errorOnInvalidContent: e, emitUpdate: t = !0, parseOptions: i = {} } = {}) => ({ editor: r, tr: s, dispatch: o, commands: a }) => {
  const { doc: l } = s;
  if (i.preserveWhitespace !== "full") {
    const c = Bo(n, r.schema, i, {
      errorOnInvalidContent: e ?? r.options.enableContentCheck
    });
    return o && s.replaceWith(0, l.content.size, c).setMeta("preventUpdate", !t), !0;
  }
  return o && s.setMeta("preventUpdate", !t), a.insertContentAt({ from: 0, to: l.content.size }, n, {
    parseOptions: i,
    errorOnInvalidContent: e ?? r.options.enableContentCheck
  });
};
function Mu(n, e) {
  const t = Rn(e, n.schema), { from: i, to: r, empty: s } = n.selection, o = [];
  s ? (n.storedMarks && o.push(...n.storedMarks), o.push(...n.selection.$head.marks())) : n.doc.nodesBetween(i, r, (l) => {
    o.push(...l.marks);
  });
  const a = o.find((l) => l.type.name === t.name);
  return a ? { ...a.attrs } : {};
}
function Ou(n, e) {
  const t = new au(n);
  return e.forEach((i) => {
    i.steps.forEach((r) => {
      t.step(r);
    });
  }), t;
}
function ag(n) {
  for (let e = 0; e < n.edgeCount; e += 1) {
    const { type: t } = n.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
function Qw(n, e) {
  const t = [];
  return n.descendants((i, r) => {
    e(i) && t.push({
      node: i,
      pos: r
    });
  }), t;
}
function lg(n, e, t) {
  const i = [];
  return n.nodesBetween(e.from, e.to, (r, s) => {
    t(r) && i.push({
      node: r,
      pos: s
    });
  }), i;
}
function Nu(n, e) {
  for (let t = n.depth; t > 0; t -= 1) {
    const i = n.node(t);
    if (e(i))
      return {
        pos: t > 0 ? n.before(t) : 0,
        start: n.start(t),
        depth: t,
        node: i
      };
  }
}
function Hi(n) {
  return (e) => Nu(e.$from, n);
}
function se(n, e, t) {
  return n.config[e] === void 0 && n.parent ? se(n.parent, e, t) : typeof n.config[e] == "function" ? n.config[e].bind({
    ...t,
    parent: n.parent ? se(n.parent, e, t) : null
  }) : n.config[e];
}
function Ia(n) {
  return n.map((e) => {
    const t = {
      name: e.name,
      options: e.options,
      storage: e.storage
    }, i = se(e, "addExtensions", t);
    return i ? [e, ...Ia(i())] : e;
  }).flat(10);
}
function Os(n, e) {
  const t = zi.fromSchema(e).serializeFragment(n), r = document.implementation.createHTMLDocument().createElement("div");
  return r.appendChild(t), r.innerHTML;
}
function Lu(n) {
  return typeof n == "function";
}
function Te(n, e = void 0, ...t) {
  return Lu(n) ? e ? n.bind(e)(...t) : n(...t) : n;
}
function cg(n = {}) {
  return Object.keys(n).length === 0 && n.constructor === Object;
}
function gr(n) {
  const e = n.filter((r) => r.type === "extension"), t = n.filter((r) => r.type === "node"), i = n.filter((r) => r.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: t,
    markExtensions: i
  };
}
function Ru(n) {
  const e = [], { nodeExtensions: t, markExtensions: i } = gr(n), r = [...t, ...i], s = {
    default: null,
    validate: void 0,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  };
  return n.forEach((o) => {
    const a = {
      name: o.name,
      options: o.options,
      storage: o.storage,
      extensions: r
    }, l = se(
      o,
      "addGlobalAttributes",
      a
    );
    if (!l)
      return;
    l().forEach((u) => {
      u.types.forEach((d) => {
        Object.entries(u.attributes).forEach(([h, f]) => {
          e.push({
            type: d,
            name: h,
            attribute: {
              ...s,
              ...f
            }
          });
        });
      });
    });
  }), r.forEach((o) => {
    const a = {
      name: o.name,
      options: o.options,
      storage: o.storage
    }, l = se(
      o,
      "addAttributes",
      a
    );
    if (!l)
      return;
    const c = l();
    Object.entries(c).forEach(([u, d]) => {
      const h = {
        ...s,
        ...d
      };
      typeof h?.default == "function" && (h.default = h.default()), h?.isRequired && h?.default === void 0 && delete h.default, e.push({
        type: o.name,
        name: u,
        attribute: h
      });
    });
  }), e;
}
function Ee(...n) {
  return n.filter((e) => !!e).reduce((e, t) => {
    const i = { ...e };
    return Object.entries(t).forEach(([r, s]) => {
      if (!i[r]) {
        i[r] = s;
        return;
      }
      if (r === "class") {
        const a = s ? String(s).split(" ") : [], l = i[r] ? i[r].split(" ") : [], c = a.filter((u) => !l.includes(u));
        i[r] = [...l, ...c].join(" ");
      } else if (r === "style") {
        const a = s ? s.split(";").map((u) => u.trim()).filter(Boolean) : [], l = i[r] ? i[r].split(";").map((u) => u.trim()).filter(Boolean) : [], c = /* @__PURE__ */ new Map();
        l.forEach((u) => {
          const [d, h] = u.split(":").map((f) => f.trim());
          c.set(d, h);
        }), a.forEach((u) => {
          const [d, h] = u.split(":").map((f) => f.trim());
          c.set(d, h);
        }), i[r] = Array.from(c.entries()).map(([u, d]) => `${u}: ${d}`).join("; ");
      } else
        i[r] = s;
    }), i;
  }, {});
}
function vs(n, e) {
  return e.filter((t) => t.type === n.type.name).filter((t) => t.attribute.rendered).map((t) => t.attribute.renderHTML ? t.attribute.renderHTML(n.attrs) || {} : {
    [t.name]: n.attrs[t.name]
  }).reduce((t, i) => Ee(t, i), {});
}
function ug(n) {
  return typeof n != "string" ? n : n.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(n) : n === "true" ? !0 : n === "false" ? !1 : n;
}
function Cc(n, e) {
  return "style" in n ? n : {
    ...n,
    getAttrs: (t) => {
      const i = n.getAttrs ? n.getAttrs(t) : n.attrs;
      if (i === !1)
        return !1;
      const r = e.reduce((s, o) => {
        const a = o.attribute.parseHTML ? o.attribute.parseHTML(t) : ug(t.getAttribute(o.name));
        return a == null ? s : {
          ...s,
          [o.name]: a
        };
      }, {});
      return { ...i, ...r };
    }
  };
}
function $h(n) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(n).filter(([e, t]) => e === "attrs" && cg(t) ? !1 : t != null)
  );
}
function zh(n) {
  var e, t, i;
  const r = {};
  return !((e = n?.attribute) != null && e.isRequired) && ((t = n?.attribute) == null ? void 0 : t.default) !== void 0 && (r.default = n.attribute.default), ((i = n?.attribute) == null ? void 0 : i.validate) !== void 0 && (r.validate = n.attribute.validate), [n.name, r];
}
function Iu(n, e) {
  var t;
  const i = Ru(n), { nodeExtensions: r, markExtensions: s } = gr(n), o = (t = r.find((c) => se(c, "topNode"))) == null ? void 0 : t.name, a = Object.fromEntries(
    r.map((c) => {
      const u = i.filter((g) => g.type === c.name), d = {
        name: c.name,
        options: c.options,
        storage: c.storage,
        editor: e
      }, h = n.reduce((g, y) => {
        const x = se(y, "extendNodeSchema", d);
        return {
          ...g,
          ...x ? x(c) : {}
        };
      }, {}), f = $h({
        ...h,
        content: Te(se(c, "content", d)),
        marks: Te(se(c, "marks", d)),
        group: Te(se(c, "group", d)),
        inline: Te(se(c, "inline", d)),
        atom: Te(se(c, "atom", d)),
        selectable: Te(se(c, "selectable", d)),
        draggable: Te(se(c, "draggable", d)),
        code: Te(se(c, "code", d)),
        whitespace: Te(se(c, "whitespace", d)),
        linebreakReplacement: Te(
          se(c, "linebreakReplacement", d)
        ),
        defining: Te(se(c, "defining", d)),
        isolating: Te(se(c, "isolating", d)),
        attrs: Object.fromEntries(u.map(zh))
      }), p = Te(se(c, "parseHTML", d));
      p && (f.parseDOM = p.map(
        (g) => Cc(g, u)
      ));
      const _ = se(c, "renderHTML", d);
      _ && (f.toDOM = (g) => _({
        node: g,
        HTMLAttributes: vs(g, u)
      }));
      const m = se(c, "renderText", d);
      return m && (f.toText = m), [c.name, f];
    })
  ), l = Object.fromEntries(
    s.map((c) => {
      const u = i.filter((m) => m.type === c.name), d = {
        name: c.name,
        options: c.options,
        storage: c.storage,
        editor: e
      }, h = n.reduce((m, g) => {
        const y = se(g, "extendMarkSchema", d);
        return {
          ...m,
          ...y ? y(c) : {}
        };
      }, {}), f = $h({
        ...h,
        inclusive: Te(se(c, "inclusive", d)),
        excludes: Te(se(c, "excludes", d)),
        group: Te(se(c, "group", d)),
        spanning: Te(se(c, "spanning", d)),
        code: Te(se(c, "code", d)),
        attrs: Object.fromEntries(u.map(zh))
      }), p = Te(se(c, "parseHTML", d));
      p && (f.parseDOM = p.map(
        (m) => Cc(m, u)
      ));
      const _ = se(c, "renderHTML", d);
      return _ && (f.toDOM = (m) => _({
        mark: m,
        HTMLAttributes: vs(m, u)
      })), [c.name, f];
    })
  );
  return new Kp({
    topNode: o,
    nodes: a,
    marks: l
  });
}
function dg(n) {
  const e = n.filter((t, i) => n.indexOf(t) !== i);
  return Array.from(new Set(e));
}
function Pa(n) {
  return n.sort((t, i) => {
    const r = se(t, "priority") || 100, s = se(i, "priority") || 100;
    return r > s ? -1 : r < s ? 1 : 0;
  });
}
function Da(n) {
  const e = Pa(Ia(n)), t = dg(e.map((i) => i.name));
  return t.length && console.warn(
    `[tiptap warn]: Duplicate extension names found: [${t.map((i) => `'${i}'`).join(", ")}]. This can lead to issues.`
  ), e;
}
function $a(n, e) {
  const t = Da(n);
  return Iu(t, e);
}
function ek(n, e) {
  const t = $a(e), i = On.fromJSON(t, n);
  return Os(i.content, t);
}
function hg(n, e) {
  const t = $a(e), i = Qi(n);
  return ir.fromSchema(t).parse(i).toJSON();
}
function Pu(n, e, t) {
  const { from: i, to: r } = e, { blockSeparator: s = `

`, textSerializers: o = {} } = t || {};
  let a = "";
  return n.nodesBetween(i, r, (l, c, u, d) => {
    var h;
    l.isBlock && c > i && (a += s);
    const f = o?.[l.type.name];
    if (f)
      return u && (a += f({
        node: l,
        pos: c,
        parent: u,
        index: d,
        range: e
      })), !1;
    l.isText && (a += (h = l?.text) == null ? void 0 : h.slice(Math.max(i, c) - c, r - c));
  }), a;
}
function Du(n, e) {
  const t = {
    from: 0,
    to: n.content.size
  };
  return Pu(n, t, e);
}
function za(n) {
  return Object.fromEntries(
    Object.entries(n.nodes).filter(([, e]) => e.spec.toText).map(([e, t]) => [e, t.spec.toText])
  );
}
function tk(n, e, t) {
  const { blockSeparator: i = `

`, textSerializers: r = {} } = t || {}, s = $a(e), o = On.fromJSON(s, n);
  return Du(o, {
    blockSeparator: i,
    textSerializers: {
      ...za(s),
      ...r
    }
  });
}
function fg(n, e) {
  const t = Ze(e, n.schema), { from: i, to: r } = n.selection, s = [];
  n.doc.nodesBetween(i, r, (a) => {
    s.push(a);
  });
  const o = s.reverse().find((a) => a.type.name === t.name);
  return o ? { ...o.attrs } : {};
}
function $u(n, e) {
  const t = Ms(
    typeof e == "string" ? e : e.name,
    n.schema
  );
  return t === "node" ? fg(n, e) : t === "mark" ? Mu(n, e) : {};
}
function pg(n, e = JSON.stringify) {
  const t = {};
  return n.filter((i) => {
    const r = e(i);
    return Object.prototype.hasOwnProperty.call(t, r) ? !1 : t[r] = !0;
  });
}
function nk(n) {
  const e = pg(n);
  return e.length === 1 ? e : e.filter((t, i) => !e.filter((s, o) => o !== i).some((s) => t.oldRange.from >= s.oldRange.from && t.oldRange.to <= s.oldRange.to && t.newRange.from >= s.newRange.from && t.newRange.to <= s.newRange.to));
}
function zu(n) {
  const { mapping: e, steps: t } = n, i = [];
  return e.maps.forEach((r, s) => {
    const o = [];
    if (r.ranges.length)
      r.forEach((a, l) => {
        o.push({ from: a, to: l });
      });
    else {
      const { from: a, to: l } = t[s];
      if (a === void 0 || l === void 0)
        return;
      o.push({ from: a, to: l });
    }
    o.forEach(({ from: a, to: l }) => {
      const c = e.slice(s).map(a, -1), u = e.slice(s).map(l), d = e.invert().map(c, -1), h = e.invert().map(u);
      i.push({
        oldRange: {
          from: d,
          to: h
        },
        newRange: {
          from: c,
          to: u
        }
      });
    });
  }), nk(i);
}
function mg(n, e = 0) {
  const i = n.type === n.type.schema.topNodeType ? 0 : 1, r = e, s = r + n.nodeSize, o = n.marks.map((c) => {
    const u = {
      type: c.type.name
    };
    return Object.keys(c.attrs).length && (u.attrs = { ...c.attrs }), u;
  }), a = { ...n.attrs }, l = {
    type: n.type.name,
    from: r,
    to: s
  };
  return Object.keys(a).length && (l.attrs = a), o.length && (l.marks = o), n.content.childCount && (l.content = [], n.forEach((c, u) => {
    var d;
    (d = l.content) == null || d.push(mg(c, e + u + i));
  })), n.text && (l.text = n.text), l;
}
function Ha(n, e, t) {
  const i = [];
  return n === e ? t.resolve(n).marks().forEach((r) => {
    const s = t.resolve(n), o = La(s, r.type);
    o && i.push({
      mark: r,
      ...o
    });
  }) : t.nodesBetween(n, e, (r, s) => {
    !r || r?.nodeSize === void 0 || i.push(
      ...r.marks.map((o) => ({
        from: s,
        to: s + r.nodeSize,
        mark: o
      }))
    );
  }), i;
}
var gg = (n, e, t, i = 20) => {
  const r = n.doc.resolve(t);
  let s = i, o = null;
  for (; s > 0 && o === null; ) {
    const a = r.node(s);
    a?.type.name === e ? o = a : s -= 1;
  }
  return [o, s];
};
function go(n, e) {
  return e.nodes[n] || e.marks[n] || null;
}
function es(n, e, t) {
  return Object.fromEntries(
    Object.entries(t).filter(([i]) => {
      const r = n.find((s) => s.type === e && s.name === i);
      return r ? r.attribute.keepOnSplit : !1;
    })
  );
}
var _g = (n, e = 500) => {
  let t = "";
  const i = n.parentOffset;
  return n.parent.nodesBetween(Math.max(0, i - e), i, (r, s, o, a) => {
    var l, c;
    const u = ((c = (l = r.type.spec).toText) == null ? void 0 : c.call(l, {
      node: r,
      pos: s,
      parent: o,
      index: a
    })) || r.textContent || "%leaf%";
    t += r.isAtom && !r.isText ? u : u.slice(0, Math.max(0, i - s));
  }), t;
};
function Fo(n, e, t = {}) {
  const { empty: i, ranges: r } = n.selection, s = e ? Rn(e, n.schema) : null;
  if (i)
    return !!(n.storedMarks || n.selection.$from.marks()).filter((d) => s ? s.name === d.type.name : !0).find((d) => bs(d.attrs, t, { strict: !1 }));
  let o = 0;
  const a = [];
  if (r.forEach(({ $from: d, $to: h }) => {
    const f = d.pos, p = h.pos;
    n.doc.nodesBetween(f, p, (_, m) => {
      if (!_.isText && !_.marks.length)
        return;
      const g = Math.max(f, m), y = Math.min(p, m + _.nodeSize), x = y - g;
      o += x, a.push(
        ..._.marks.map((k) => ({
          mark: k,
          from: g,
          to: y
        }))
      );
    });
  }), o === 0)
    return !1;
  const l = a.filter((d) => s ? s.name === d.mark.type.name : !0).filter((d) => bs(d.mark.attrs, t, { strict: !1 })).reduce((d, h) => d + h.to - h.from, 0), c = a.filter((d) => s ? d.mark.type !== s && d.mark.type.excludes(s) : !0).reduce((d, h) => d + h.to - h.from, 0);
  return (l > 0 ? l + c : l) >= o;
}
function bg(n, e, t = {}) {
  if (!e)
    return Gn(n, null, t) || Fo(n, null, t);
  const i = Ms(e, n.schema);
  return i === "node" ? Gn(n, e, t) : i === "mark" ? Fo(n, e, t) : !1;
}
var vg = (n, e) => {
  const { $from: t, $to: i, $anchor: r } = n.selection;
  if (e) {
    const s = Hi((a) => a.type.name === e)(n.selection);
    if (!s)
      return !1;
    const o = n.doc.resolve(s.pos + 1);
    return r.pos + 1 === o.end();
  }
  return !(i.parentOffset < i.parent.nodeSize - 2 || t.pos !== i.pos);
}, yg = (n) => {
  const { $from: e, $to: t } = n.selection;
  return !(e.parentOffset > 0 || e.pos !== t.pos);
};
function Tc(n, e) {
  return Array.isArray(e) ? e.some((t) => (typeof t == "string" ? t : t.name) === n.name) : e;
}
function Ac(n, e) {
  const { nodeExtensions: t } = gr(e), i = t.find((o) => o.name === n);
  if (!i)
    return !1;
  const r = {
    name: i.name,
    options: i.options,
    storage: i.storage
  }, s = Te(se(i, "group", r));
  return typeof s != "string" ? !1 : s.split(" ").includes("list");
}
function Ns(n, {
  checkChildren: e = !0,
  ignoreWhitespace: t = !1
} = {}) {
  var i;
  if (t) {
    if (n.type.name === "hardBreak")
      return !0;
    if (n.isText)
      return /^\s*$/m.test((i = n.text) != null ? i : "");
  }
  if (n.isText)
    return !n.text;
  if (n.isAtom || n.isLeaf)
    return !1;
  if (n.content.childCount === 0)
    return !0;
  if (e) {
    let r = !0;
    return n.content.forEach((s) => {
      r !== !1 && (Ns(s, { ignoreWhitespace: t, checkChildren: e }) || (r = !1));
    }), r;
  }
  return !1;
}
function Hu(n) {
  return n instanceof re;
}
function ik(n, e, t) {
  const r = n.state.doc.content.size, s = Mn(e, 0, r), o = Mn(t, 0, r), a = n.coordsAtPos(s), l = n.coordsAtPos(o, -1), c = Math.min(a.top, l.top), u = Math.max(a.bottom, l.bottom), d = Math.min(a.left, l.left), h = Math.max(a.right, l.right), f = h - d, p = u - c, g = {
    top: c,
    bottom: u,
    left: d,
    right: h,
    width: f,
    height: p,
    x: d,
    y: c
  };
  return {
    ...g,
    toJSON: () => g
  };
}
function xg({
  json: n,
  validMarks: e,
  validNodes: t,
  options: i,
  rewrittenContent: r = []
}) {
  return n.marks && Array.isArray(n.marks) && (n.marks = n.marks.filter((s) => {
    const o = typeof s == "string" ? s : s.type;
    return e.has(o) ? !0 : (r.push({
      original: JSON.parse(JSON.stringify(s)),
      unsupported: o
    }), !1);
  })), n.content && Array.isArray(n.content) && (n.content = n.content.map(
    (s) => xg({
      json: s,
      validMarks: e,
      validNodes: t,
      options: i,
      rewrittenContent: r
    }).json
  ).filter((s) => s != null)), n.type && !t.has(n.type) ? (r.push({
    original: JSON.parse(JSON.stringify(n)),
    unsupported: n.type
  }), n.content && Array.isArray(n.content) && i?.fallbackToParagraph !== !1 ? (n.type = "paragraph", {
    json: n,
    rewrittenContent: r
  }) : {
    json: null,
    rewrittenContent: r
  }) : { json: n, rewrittenContent: r };
}
function rk(n, e, t) {
  return xg({
    json: n,
    validNodes: new Set(Object.keys(e.nodes)),
    validMarks: new Set(Object.keys(e.marks)),
    options: t
  });
}
function sk(n, e, t) {
  var i;
  const { selection: r } = e;
  let s = null;
  if (Cu(r) && (s = r.$cursor), s) {
    const a = (i = n.storedMarks) != null ? i : s.marks();
    return s.parent.type.allowsMarkType(t) && (!!t.isInSet(a) || !a.some((c) => c.type.excludes(t)));
  }
  const { ranges: o } = r;
  return o.some(({ $from: a, $to: l }) => {
    let c = a.depth === 0 ? n.doc.inlineContent && n.doc.type.allowsMarkType(t) : !1;
    return n.doc.nodesBetween(a.pos, l.pos, (u, d, h) => {
      if (c)
        return !1;
      if (u.isInline) {
        const f = !h || h.type.allowsMarkType(t), p = !!t.isInSet(u.marks) || !u.marks.some((_) => _.type.excludes(t));
        c = f && p;
      }
      return !c;
    }), c;
  });
}
var ok = (n, e = {}) => ({ tr: t, state: i, dispatch: r }) => {
  const { selection: s } = t, { empty: o, ranges: a } = s, l = Rn(n, i.schema);
  if (r)
    if (o) {
      const c = Mu(i, l);
      t.addStoredMark(
        l.create({
          ...c,
          ...e
        })
      );
    } else
      a.forEach((c) => {
        const u = c.$from.pos, d = c.$to.pos;
        i.doc.nodesBetween(u, d, (h, f) => {
          const p = Math.max(f, u), _ = Math.min(f + h.nodeSize, d);
          h.marks.find((g) => g.type === l) ? h.marks.forEach((g) => {
            l === g.type && t.addMark(
              p,
              _,
              l.create({
                ...g.attrs,
                ...e
              })
            );
          }) : t.addMark(p, _, l.create(e));
        });
      });
  return sk(i, t, l);
}, ak = (n, e) => ({ tr: t }) => (t.setMeta(n, e), !0), lk = (n, e = {}) => ({ state: t, dispatch: i, chain: r }) => {
  const s = Ze(n, t.schema);
  let o;
  return t.selection.$anchor.sameParent(t.selection.$head) && (o = t.selection.$anchor.parent.attrs), s.isTextblock ? r().command(({ commands: a }) => nh(s, { ...o, ...e })(t) ? !0 : a.clearNodes()).command(({ state: a }) => nh(s, { ...o, ...e })(a, i)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, ck = (n) => ({ tr: e, dispatch: t }) => {
  if (t) {
    const { doc: i } = e, r = Mn(n, 0, i.content.size), s = re.create(i, r);
    e.setSelection(s);
  }
  return !0;
}, uk = (n) => ({ tr: e, dispatch: t }) => {
  if (t) {
    const { doc: i } = e, { from: r, to: s } = typeof n == "number" ? { from: n, to: n } : n, o = ue.atStart(i).from, a = ue.atEnd(i).to, l = Mn(r, o, a), c = Mn(s, o, a), u = ue.create(i, l, c);
    e.setSelection(u);
  }
  return !0;
}, dk = (n) => ({ state: e, dispatch: t }) => {
  const i = Ze(n, e.schema);
  return xy(i)(e, t);
};
function Hh(n, e) {
  const t = n.storedMarks || n.selection.$to.parentOffset && n.selection.$from.marks();
  if (t) {
    const i = t.filter((r) => e?.includes(r.type.name));
    n.tr.ensureMarks(i);
  }
}
var hk = ({ keepMarks: n = !0 } = {}) => ({ tr: e, state: t, dispatch: i, editor: r }) => {
  const { selection: s, doc: o } = e, { $from: a, $to: l } = s, c = r.extensionManager.attributes, u = es(c, a.node().type.name, a.node().attrs);
  if (s instanceof re && s.node.isBlock)
    return !a.parentOffset || !Un(o, a.pos) ? !1 : (i && (n && Hh(t, r.extensionManager.splittableMarks), e.split(a.pos).scrollIntoView()), !0);
  if (!a.parent.isBlock)
    return !1;
  const d = l.parentOffset === l.parent.content.size, h = a.depth === 0 ? void 0 : ag(a.node(-1).contentMatchAt(a.indexAfter(-1)));
  let f = d && h ? [
    {
      type: h,
      attrs: u
    }
  ] : void 0, p = Un(e.doc, e.mapping.map(a.pos), 1, f);
  if (!f && !p && Un(e.doc, e.mapping.map(a.pos), 1, h ? [{ type: h }] : void 0) && (p = !0, f = h ? [
    {
      type: h,
      attrs: u
    }
  ] : void 0), i) {
    if (p && (s instanceof ue && e.deleteSelection(), e.split(e.mapping.map(a.pos), 1, f), h && !d && !a.parentOffset && a.parent.type !== h)) {
      const _ = e.mapping.map(a.before()), m = e.doc.resolve(_);
      a.node(-1).canReplaceWith(m.index(), m.index() + 1, h) && e.setNodeMarkup(e.mapping.map(a.before()), h);
    }
    n && Hh(t, r.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return p;
}, fk = (n, e = {}) => ({ tr: t, state: i, dispatch: r, editor: s }) => {
  var o;
  const a = Ze(n, i.schema), { $from: l, $to: c } = i.selection, u = i.selection.node;
  if (u && u.isBlock || l.depth < 2 || !l.sameParent(c))
    return !1;
  const d = l.node(-1);
  if (d.type !== a)
    return !1;
  const h = s.extensionManager.attributes;
  if (l.parent.content.size === 0 && l.node(-1).childCount === l.indexAfter(-1)) {
    if (l.depth === 2 || l.node(-3).type !== a || l.index(-2) !== l.node(-2).childCount - 1)
      return !1;
    if (r) {
      let g = $.empty;
      const y = l.index(-1) ? 1 : l.index(-2) ? 2 : 3;
      for (let v = l.depth - y; v >= l.depth - 3; v -= 1)
        g = $.from(l.node(v).copy(g));
      const x = (
        // eslint-disable-next-line no-nested-ternary
        l.indexAfter(-1) < l.node(-2).childCount ? 1 : l.indexAfter(-2) < l.node(-3).childCount ? 2 : 3
      ), k = {
        ...es(h, l.node().type.name, l.node().attrs),
        ...e
      }, E = ((o = a.contentMatch.defaultType) == null ? void 0 : o.createAndFill(k)) || void 0;
      g = g.append($.from(a.createAndFill(null, E) || void 0));
      const S = l.before(l.depth - (y - 1));
      t.replace(S, l.after(-x), new J(g, 4 - y, 0));
      let w = -1;
      t.doc.nodesBetween(S, t.doc.content.size, (v, A) => {
        if (w > -1)
          return !1;
        v.isTextblock && v.content.size === 0 && (w = A + 1);
      }), w > -1 && t.setSelection(ue.near(t.doc.resolve(w))), t.scrollIntoView();
    }
    return !0;
  }
  const f = c.pos === l.end() ? d.contentMatchAt(0).defaultType : null, p = {
    ...es(h, d.type.name, d.attrs),
    ...e
  }, _ = {
    ...es(h, l.node().type.name, l.node().attrs),
    ...e
  };
  t.delete(l.pos, c.pos);
  const m = f ? [
    { type: a, attrs: p },
    { type: f, attrs: _ }
  ] : [{ type: a, attrs: p }];
  if (!Un(t.doc, l.pos, 2))
    return !1;
  if (r) {
    const { selection: g, storedMarks: y } = i, { splittableMarks: x } = s.extensionManager, k = y || g.$to.parentOffset && g.$from.marks();
    if (t.split(l.pos, 2, m).scrollIntoView(), !k || !r)
      return !0;
    const E = k.filter((S) => x.includes(S.type.name));
    t.ensureMarks(E);
  }
  return !0;
}, xl = (n, e) => {
  const t = Hi((o) => o.type === e)(n.selection);
  if (!t)
    return !0;
  const i = n.doc.resolve(Math.max(0, t.pos - 1)).before(t.depth);
  if (i === void 0)
    return !0;
  const r = n.doc.nodeAt(i);
  return t.node.type === r?.type && _i(n.doc, t.pos) && n.join(t.pos), !0;
}, wl = (n, e) => {
  const t = Hi((o) => o.type === e)(n.selection);
  if (!t)
    return !0;
  const i = n.doc.resolve(t.start).after(t.depth);
  if (i === void 0)
    return !0;
  const r = n.doc.nodeAt(i);
  return t.node.type === r?.type && _i(n.doc, i) && n.join(i), !0;
}, pk = (n, e, t, i = {}) => ({ editor: r, tr: s, state: o, dispatch: a, chain: l, commands: c, can: u }) => {
  const { extensions: d, splittableMarks: h } = r.extensionManager, f = Ze(n, o.schema), p = Ze(e, o.schema), { selection: _, storedMarks: m } = o, { $from: g, $to: y } = _, x = g.blockRange(y), k = m || _.$to.parentOffset && _.$from.marks();
  if (!x)
    return !1;
  const E = Hi((S) => Ac(S.type.name, d))(_);
  if (x.depth >= 1 && E && x.depth - E.depth <= 1) {
    if (E.node.type === f)
      return c.liftListItem(p);
    if (Ac(E.node.type.name, d) && f.validContent(E.node.content) && a)
      return l().command(() => (s.setNodeMarkup(E.pos, f), !0)).command(() => xl(s, f)).command(() => wl(s, f)).run();
  }
  return !t || !k || !a ? l().command(() => u().wrapInList(f, i) ? !0 : c.clearNodes()).wrapInList(f, i).command(() => xl(s, f)).command(() => wl(s, f)).run() : l().command(() => {
    const S = u().wrapInList(f, i), w = k.filter((v) => h.includes(v.type.name));
    return s.ensureMarks(w), S ? !0 : c.clearNodes();
  }).wrapInList(f, i).command(() => xl(s, f)).command(() => wl(s, f)).run();
}, mk = (n, e = {}, t = {}) => ({ state: i, commands: r }) => {
  const { extendEmptyMarkRange: s = !1 } = t, o = Rn(n, i.schema);
  return Fo(i, o, e) ? r.unsetMark(o, { extendEmptyMarkRange: s }) : r.setMark(o, e);
}, gk = (n, e, t = {}) => ({ state: i, commands: r }) => {
  const s = Ze(n, i.schema), o = Ze(e, i.schema), a = Gn(i, s, t);
  let l;
  return i.selection.$anchor.sameParent(i.selection.$head) && (l = i.selection.$anchor.parent.attrs), a ? r.setNode(o, l) : r.setNode(s, { ...l, ...t });
}, _k = (n, e = {}) => ({ state: t, commands: i }) => {
  const r = Ze(n, t.schema);
  return Gn(t, r, e) ? i.lift(r) : i.wrapIn(r, e);
}, bk = () => ({ state: n, dispatch: e }) => {
  const t = n.plugins;
  for (let i = 0; i < t.length; i += 1) {
    const r = t[i];
    let s;
    if (r.spec.isInputRules && (s = r.getState(n))) {
      if (e) {
        const o = n.tr, a = s.transform;
        for (let l = a.steps.length - 1; l >= 0; l -= 1)
          o.step(a.steps[l].invert(a.docs[l]));
        if (s.text) {
          const l = o.doc.resolve(s.from).marks();
          o.replaceWith(s.from, s.to, n.schema.text(s.text, l));
        } else
          o.delete(s.from, s.to);
      }
      return !0;
    }
  }
  return !1;
}, vk = () => ({ tr: n, dispatch: e }) => {
  const { selection: t } = n, { empty: i, ranges: r } = t;
  return i || e && r.forEach((s) => {
    n.removeMark(s.$from.pos, s.$to.pos);
  }), !0;
}, yk = (n, e = {}) => ({ tr: t, state: i, dispatch: r }) => {
  var s;
  const { extendEmptyMarkRange: o = !1 } = e, { selection: a } = t, l = Rn(n, i.schema), { $from: c, empty: u, ranges: d } = a;
  if (!r)
    return !0;
  if (u && o) {
    let { from: h, to: f } = a;
    const p = (s = c.marks().find((m) => m.type === l)) == null ? void 0 : s.attrs, _ = La(c, l, p);
    _ && (h = _.from, f = _.to), t.removeMark(h, f, l);
  } else
    d.forEach((h) => {
      t.removeMark(h.$from.pos, h.$to.pos, l);
    });
  return t.removeStoredMark(l), !0;
}, xk = (n, e = {}) => ({ tr: t, state: i, dispatch: r }) => {
  let s = null, o = null;
  const a = Ms(
    typeof n == "string" ? n : n.name,
    i.schema
  );
  return a ? (a === "node" && (s = Ze(n, i.schema)), a === "mark" && (o = Rn(n, i.schema)), r && t.selection.ranges.forEach((l) => {
    const c = l.$from.pos, u = l.$to.pos;
    let d, h, f, p;
    t.selection.empty ? i.doc.nodesBetween(c, u, (_, m) => {
      s && s === _.type && (f = Math.max(m, c), p = Math.min(m + _.nodeSize, u), d = m, h = _);
    }) : i.doc.nodesBetween(c, u, (_, m) => {
      m < c && s && s === _.type && (f = Math.max(m, c), p = Math.min(m + _.nodeSize, u), d = m, h = _), m >= c && m <= u && (s && s === _.type && t.setNodeMarkup(m, void 0, {
        ..._.attrs,
        ...e
      }), o && _.marks.length && _.marks.forEach((g) => {
        if (o === g.type) {
          const y = Math.max(m, c), x = Math.min(m + _.nodeSize, u);
          t.addMark(
            y,
            x,
            o.create({
              ...g.attrs,
              ...e
            })
          );
        }
      }));
    }), h && (d !== void 0 && t.setNodeMarkup(d, void 0, {
      ...h.attrs,
      ...e
    }), o && h.marks.length && h.marks.forEach((_) => {
      o === _.type && t.addMark(
        f,
        p,
        o.create({
          ..._.attrs,
          ...e
        })
      );
    }));
  }), !0) : !1;
}, wk = (n, e = {}) => ({ state: t, dispatch: i }) => {
  const r = Ze(n, t.schema);
  return py(r, e)(t, i);
}, kk = (n, e = {}) => ({ state: t, dispatch: i }) => {
  const r = Ze(n, t.schema);
  return my(r, e)(t, i);
}, Sk = class {
  constructor() {
    this.callbacks = {};
  }
  on(n, e) {
    return this.callbacks[n] || (this.callbacks[n] = []), this.callbacks[n].push(e), this;
  }
  emit(n, ...e) {
    const t = this.callbacks[n];
    return t && t.forEach((i) => i.apply(this, e)), this;
  }
  off(n, e) {
    const t = this.callbacks[n];
    return t && (e ? this.callbacks[n] = t.filter((i) => i !== e) : delete this.callbacks[n]), this;
  }
  once(n, e) {
    const t = (...i) => {
      this.off(n, t), e.apply(this, i);
    };
    return this.on(n, t);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}, Bi = class {
  constructor(n) {
    var e;
    this.find = n.find, this.handler = n.handler, this.undoable = (e = n.undoable) != null ? e : !0;
  }
}, Ek = (n, e) => {
  if (Na(e))
    return e.exec(n);
  const t = e(n);
  if (!t)
    return null;
  const i = [t.text];
  return i.index = t.index, i.input = n, i.data = t.data, t.replaceWith && (t.text.includes(t.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), i.push(t.replaceWith)), i;
};
function Ks(n) {
  var e;
  const { editor: t, from: i, to: r, text: s, rules: o, plugin: a } = n, { view: l } = t;
  if (l.composing)
    return !1;
  const c = l.state.doc.resolve(i);
  if (
    // check for code node
    c.parent.type.spec.code || (e = c.nodeBefore || c.nodeAfter) != null && e.marks.find((h) => h.type.spec.code)
  )
    return !1;
  let u = !1;
  const d = _g(c) + s;
  return o.forEach((h) => {
    if (u)
      return;
    const f = Ek(d, h.find);
    if (!f)
      return;
    const p = l.state.tr, _ = Ts({
      state: l.state,
      transaction: p
    }), m = {
      from: i - (f[0].length - s.length),
      to: r
    }, { commands: g, chain: y, can: x } = new As({
      editor: t,
      state: _
    });
    h.handler({
      state: _,
      range: m,
      match: f,
      commands: g,
      chain: y,
      can: x
    }) === null || !p.steps.length || (h.undoable && p.setMeta(a, {
      transform: p,
      from: i,
      to: r,
      text: s
    }), l.dispatch(p), u = !0);
  }), u;
}
function wg(n) {
  const { editor: e, rules: t } = n, i = new je({
    state: {
      init() {
        return null;
      },
      apply(r, s, o) {
        const a = r.getMeta(i);
        if (a)
          return a;
        const l = r.getMeta("applyInputRules");
        return !!l && setTimeout(() => {
          let { text: u } = l;
          typeof u == "string" ? u = u : u = Os($.from(u), o.schema);
          const { from: d } = l, h = d + u.length;
          Ks({
            editor: e,
            from: d,
            to: h,
            text: u,
            rules: t,
            plugin: i
          });
        }), r.selectionSet || r.docChanged ? null : s;
      }
    },
    props: {
      handleTextInput(r, s, o, a) {
        return Ks({
          editor: e,
          from: s,
          to: o,
          text: a,
          rules: t,
          plugin: i
        });
      },
      handleDOMEvents: {
        compositionend: (r) => (setTimeout(() => {
          const { $cursor: s } = r.state.selection;
          s && Ks({
            editor: e,
            from: s.pos,
            to: s.pos,
            text: "",
            rules: t,
            plugin: i
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(r, s) {
        if (s.key !== "Enter")
          return !1;
        const { $cursor: o } = r.state.selection;
        return o ? Ks({
          editor: e,
          from: o.pos,
          to: o.pos,
          text: `
`,
          rules: t,
          plugin: i
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return i;
}
function Ck(n) {
  return Object.prototype.toString.call(n).slice(8, -1);
}
function Ur(n) {
  return Ck(n) !== "Object" ? !1 : n.constructor === Object && Object.getPrototypeOf(n) === Object.prototype;
}
function Bu(n, e) {
  const t = { ...n };
  return Ur(n) && Ur(e) && Object.keys(e).forEach((i) => {
    Ur(e[i]) && Ur(n[i]) ? t[i] = Bu(n[i], e[i]) : t[i] = e[i];
  }), t;
}
var Ba = class {
  constructor(n = {}) {
    this.type = "extendable", this.parent = null, this.child = null, this.name = "", this.config = {
      name: this.name
    }, this.config = {
      ...this.config,
      ...n
    }, this.name = this.config.name;
  }
  get options() {
    return {
      ...Te(
        se(this, "addOptions", {
          name: this.name
        })
      ) || {}
    };
  }
  get storage() {
    return {
      ...Te(
        se(this, "addStorage", {
          name: this.name,
          options: this.options
        })
      ) || {}
    };
  }
  configure(n = {}) {
    const e = this.extend({
      ...this.config,
      addOptions: () => Bu(this.options, n)
    });
    return e.name = this.name, e.parent = this.parent, e;
  }
  extend(n = {}) {
    const e = new this.constructor({ ...this.config, ...n });
    return e.parent = this, this.child = e, e.name = "name" in n ? n.name : e.parent.name, e;
  }
}, Jt = class kg extends Ba {
  constructor() {
    super(...arguments), this.type = "mark";
  }
  /**
   * Create a new Mark instance
   * @param config - Mark configuration object or a function that returns a configuration object
   */
  static create(e = {}) {
    const t = typeof e == "function" ? e() : e;
    return new kg(t);
  }
  static handleExit({ editor: e, mark: t }) {
    const { tr: i } = e.state, r = e.state.selection.$from;
    if (r.pos === r.end()) {
      const o = r.marks();
      if (!!!o.find((c) => c?.type.name === t.name))
        return !1;
      const l = o.find((c) => c?.type.name === t.name);
      return l && i.removeStoredMark(l), i.insertText(" ", r.pos), e.view.dispatch(i), !0;
    }
    return !1;
  }
  configure(e) {
    return super.configure(e);
  }
  extend(e) {
    const t = typeof e == "function" ? e() : e;
    return super.extend(t);
  }
};
function Sg(n) {
  return typeof n == "number";
}
var Fa = class {
  constructor(n) {
    this.find = n.find, this.handler = n.handler;
  }
}, Tk = (n, e, t) => {
  if (Na(e))
    return [...n.matchAll(e)];
  const i = e(n, t);
  return i ? i.map((r) => {
    const s = [r.text];
    return s.index = r.index, s.input = n, s.data = r.data, r.replaceWith && (r.text.includes(r.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), s.push(r.replaceWith)), s;
  }) : [];
};
function Ak(n) {
  const { editor: e, state: t, from: i, to: r, rule: s, pasteEvent: o, dropEvent: a } = n, { commands: l, chain: c, can: u } = new As({
    editor: e,
    state: t
  }), d = [];
  return t.doc.nodesBetween(i, r, (f, p) => {
    var _, m, g, y, x;
    if ((m = (_ = f.type) == null ? void 0 : _.spec) != null && m.code || !(f.isText || f.isTextblock || f.isInline))
      return;
    const k = (x = (y = (g = f.content) == null ? void 0 : g.size) != null ? y : f.nodeSize) != null ? x : 0, E = Math.max(i, p), S = Math.min(r, p + k);
    if (E >= S)
      return;
    const w = f.isText ? f.text || "" : f.textBetween(E - p, S - p, void 0, "￼");
    Tk(w, s.find, o).forEach((A) => {
      if (A.index === void 0)
        return;
      const b = E + A.index + 1, C = b + A[0].length, M = {
        from: t.tr.mapping.map(b),
        to: t.tr.mapping.map(C)
      }, z = s.handler({
        state: t,
        range: M,
        match: A,
        commands: l,
        chain: c,
        can: u,
        pasteEvent: o,
        dropEvent: a
      });
      d.push(z);
    });
  }), d.every((f) => f !== null);
}
var qs = null, Mk = (n) => {
  var e;
  const t = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (e = t.clipboardData) == null || e.setData("text/html", n), t;
};
function Eg(n) {
  const { editor: e, rules: t } = n;
  let i = null, r = !1, s = !1, o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, a;
  try {
    a = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  } catch {
    a = null;
  }
  const l = ({
    state: u,
    from: d,
    to: h,
    rule: f,
    pasteEvt: p
  }) => {
    const _ = u.tr, m = Ts({
      state: u,
      transaction: _
    });
    if (!(!Ak({
      editor: e,
      state: m,
      from: Math.max(d - 1, 0),
      to: h.b - 1,
      rule: f,
      pasteEvent: p,
      dropEvent: a
    }) || !_.steps.length)) {
      try {
        a = typeof DragEvent < "u" ? new DragEvent("drop") : null;
      } catch {
        a = null;
      }
      return o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, _;
    }
  };
  return t.map((u) => new je({
    // we register a global drag handler to track the current drag source element
    view(d) {
      const h = (p) => {
        var _;
        i = (_ = d.dom.parentElement) != null && _.contains(p.target) ? d.dom.parentElement : null, i && (qs = e);
      }, f = () => {
        qs && (qs = null);
      };
      return window.addEventListener("dragstart", h), window.addEventListener("dragend", f), {
        destroy() {
          window.removeEventListener("dragstart", h), window.removeEventListener("dragend", f);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (d, h) => {
          if (s = i === d.dom.parentElement, a = h, !s) {
            const f = qs;
            f?.isEditable && setTimeout(() => {
              const p = f.state.selection;
              p && f.commands.deleteRange({ from: p.from, to: p.to });
            }, 10);
          }
          return !1;
        },
        paste: (d, h) => {
          var f;
          const p = (f = h.clipboardData) == null ? void 0 : f.getData("text/html");
          return o = h, r = !!p?.includes("data-pm-slice"), !1;
        }
      }
    },
    appendTransaction: (d, h, f) => {
      const p = d[0], _ = p.getMeta("uiEvent") === "paste" && !r, m = p.getMeta("uiEvent") === "drop" && !s, g = p.getMeta("applyPasteRules"), y = !!g;
      if (!_ && !m && !y)
        return;
      if (y) {
        let { text: E } = g;
        typeof E == "string" ? E = E : E = Os($.from(E), f.schema);
        const { from: S } = g, w = S + E.length, v = Mk(E);
        return l({
          rule: u,
          state: f,
          from: S,
          to: { b: w },
          pasteEvt: v
        });
      }
      const x = h.doc.content.findDiffStart(f.doc.content), k = h.doc.content.findDiffEnd(f.doc.content);
      if (!(!Sg(x) || !k || x === k.b))
        return l({
          rule: u,
          state: f,
          from: x,
          to: k,
          pasteEvt: o
        });
    }
  }));
}
var Va = class {
  constructor(n, e) {
    this.splittableMarks = [], this.editor = e, this.baseExtensions = n, this.extensions = Da(n), this.schema = Iu(this.extensions, e), this.setupExtensions();
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((n, e) => {
      const t = {
        name: e.name,
        options: e.options,
        storage: this.editor.extensionStorage[e.name],
        editor: this.editor,
        type: go(e.name, this.schema)
      }, i = se(e, "addCommands", t);
      return i ? {
        ...n,
        ...i()
      } : n;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: n } = this;
    return Pa([...this.extensions].reverse()).flatMap((i) => {
      const r = {
        name: i.name,
        options: i.options,
        storage: this.editor.extensionStorage[i.name],
        editor: n,
        type: go(i.name, this.schema)
      }, s = [], o = se(
        i,
        "addKeyboardShortcuts",
        r
      );
      let a = {};
      if (i.type === "mark" && se(i, "exitable", r) && (a.ArrowRight = () => Jt.handleExit({ editor: n, mark: i })), o) {
        const h = Object.fromEntries(
          Object.entries(o()).map(([f, p]) => [f, () => p({ editor: n })])
        );
        a = { ...a, ...h };
      }
      const l = cw(a);
      s.push(l);
      const c = se(i, "addInputRules", r);
      if (Tc(i, n.options.enableInputRules) && c) {
        const h = c();
        if (h && h.length) {
          const f = wg({
            editor: n,
            rules: h
          }), p = Array.isArray(f) ? f : [f];
          s.push(...p);
        }
      }
      const u = se(i, "addPasteRules", r);
      if (Tc(i, n.options.enablePasteRules) && u) {
        const h = u();
        if (h && h.length) {
          const f = Eg({ editor: n, rules: h });
          s.push(...f);
        }
      }
      const d = se(
        i,
        "addProseMirrorPlugins",
        r
      );
      if (d) {
        const h = d();
        s.push(...h);
      }
      return s;
    });
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return Ru(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: n } = this, { nodeExtensions: e } = gr(this.extensions);
    return Object.fromEntries(
      e.filter((t) => !!se(t, "addNodeView")).map((t) => {
        const i = this.attributes.filter((l) => l.type === t.name), r = {
          name: t.name,
          options: t.options,
          storage: this.editor.extensionStorage[t.name],
          editor: n,
          type: Ze(t.name, this.schema)
        }, s = se(t, "addNodeView", r);
        if (!s)
          return [];
        const o = s();
        if (!o)
          return [];
        const a = (l, c, u, d, h) => {
          const f = vs(l, i);
          return o({
            // pass-through
            node: l,
            view: c,
            getPos: u,
            decorations: d,
            innerDecorations: h,
            // tiptap-specific
            editor: n,
            extension: t,
            HTMLAttributes: f
          });
        };
        return [t.name, a];
      })
    );
  }
  get markViews() {
    const { editor: n } = this, { markExtensions: e } = gr(this.extensions);
    return Object.fromEntries(
      e.filter((t) => !!se(t, "addMarkView")).map((t) => {
        const i = this.attributes.filter((a) => a.type === t.name), r = {
          name: t.name,
          options: t.options,
          storage: this.editor.extensionStorage[t.name],
          editor: n,
          type: Rn(t.name, this.schema)
        }, s = se(t, "addMarkView", r);
        if (!s)
          return [];
        const o = (a, l, c) => {
          const u = vs(a, i);
          return s()({
            // pass-through
            mark: a,
            view: l,
            inline: c,
            // tiptap-specific
            editor: n,
            extension: t,
            HTMLAttributes: u,
            updateAttributes: (d) => {
              ju(a, n, d);
            }
          });
        };
        return [t.name, o];
      })
    );
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    const n = this.extensions;
    this.editor.extensionStorage = Object.fromEntries(
      n.map((e) => [e.name, e.storage])
    ), n.forEach((e) => {
      var t;
      const i = {
        name: e.name,
        options: e.options,
        storage: this.editor.extensionStorage[e.name],
        editor: this.editor,
        type: go(e.name, this.schema)
      };
      e.type === "mark" && ((t = Te(se(e, "keepOnSplit", i))) == null || t) && this.splittableMarks.push(e.name);
      const r = se(e, "onBeforeCreate", i), s = se(e, "onCreate", i), o = se(e, "onUpdate", i), a = se(
        e,
        "onSelectionUpdate",
        i
      ), l = se(e, "onTransaction", i), c = se(e, "onFocus", i), u = se(e, "onBlur", i), d = se(e, "onDestroy", i);
      r && this.editor.on("beforeCreate", r), s && this.editor.on("create", s), o && this.editor.on("update", o), a && this.editor.on("selectionUpdate", a), l && this.editor.on("transaction", l), c && this.editor.on("focus", c), u && this.editor.on("blur", u), d && this.editor.on("destroy", d);
    });
  }
};
Va.resolve = Da;
Va.sort = Pa;
Va.flatten = Ia;
var Cg = {};
Su(Cg, {
  ClipboardTextSerializer: () => Ag,
  Commands: () => Mg,
  Delete: () => Og,
  Drop: () => Ng,
  Editable: () => Lg,
  FocusEvents: () => Ig,
  Keymap: () => Pg,
  Paste: () => Dg,
  Tabindex: () => $g,
  focusEventsPluginKey: () => Rg
});
var Oe = class Tg extends Ba {
  constructor() {
    super(...arguments), this.type = "extension";
  }
  /**
   * Create a new Extension instance
   * @param config - Extension configuration object or a function that returns a configuration object
   */
  static create(e = {}) {
    const t = typeof e == "function" ? e() : e;
    return new Tg(t);
  }
  configure(e) {
    return super.configure(e);
  }
  extend(e) {
    const t = typeof e == "function" ? e() : e;
    return super.extend(t);
  }
}, Ag = Oe.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new je({
        key: new Xe("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: n } = this, { state: e, schema: t } = n, { doc: i, selection: r } = e, { ranges: s } = r, o = Math.min(...s.map((u) => u.$from.pos)), a = Math.max(...s.map((u) => u.$to.pos)), l = za(t);
            return Pu(i, { from: o, to: a }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: l
            });
          }
        }
      })
    ];
  }
}), Mg = Oe.create({
  name: "commands",
  addCommands() {
    return {
      ...Eu
    };
  }
}), Og = Oe.create({
  name: "delete",
  onUpdate({ transaction: n, appendedTransactions: e }) {
    var t, i, r;
    const s = () => {
      var o, a, l, c;
      if ((c = (l = (a = (o = this.editor.options.coreExtensionOptions) == null ? void 0 : o.delete) == null ? void 0 : a.filterTransaction) == null ? void 0 : l.call(a, n)) != null ? c : n.getMeta("y-sync$"))
        return;
      const u = Ou(n.before, [n, ...e]);
      zu(u).forEach((f) => {
        u.mapping.mapResult(f.oldRange.from).deletedAfter && u.mapping.mapResult(f.oldRange.to).deletedBefore && u.before.nodesBetween(f.oldRange.from, f.oldRange.to, (p, _) => {
          const m = _ + p.nodeSize - 2, g = f.oldRange.from <= _ && m <= f.oldRange.to;
          this.editor.emit("delete", {
            type: "node",
            node: p,
            from: _,
            to: m,
            newFrom: u.mapping.map(_),
            newTo: u.mapping.map(m),
            deletedRange: f.oldRange,
            newRange: f.newRange,
            partial: !g,
            editor: this.editor,
            transaction: n,
            combinedTransform: u
          });
        });
      });
      const h = u.mapping;
      u.steps.forEach((f, p) => {
        var _, m;
        if (f instanceof _n) {
          const g = h.slice(p).map(f.from, -1), y = h.slice(p).map(f.to), x = h.invert().map(g, -1), k = h.invert().map(y), E = (_ = u.doc.nodeAt(g - 1)) == null ? void 0 : _.marks.some((w) => w.eq(f.mark)), S = (m = u.doc.nodeAt(y)) == null ? void 0 : m.marks.some((w) => w.eq(f.mark));
          this.editor.emit("delete", {
            type: "mark",
            mark: f.mark,
            from: f.from,
            to: f.to,
            deletedRange: {
              from: x,
              to: k
            },
            newRange: {
              from: g,
              to: y
            },
            partial: !!(S || E),
            editor: this.editor,
            transaction: n,
            combinedTransform: u
          });
        }
      });
    };
    (r = (i = (t = this.editor.options.coreExtensionOptions) == null ? void 0 : t.delete) == null ? void 0 : i.async) == null || r ? setTimeout(s, 0) : s();
  }
}), Ng = Oe.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new je({
        key: new Xe("tiptapDrop"),
        props: {
          handleDrop: (n, e, t, i) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: e,
              slice: t,
              moved: i
            });
          }
        }
      })
    ];
  }
}), Lg = Oe.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new je({
        key: new Xe("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), Rg = new Xe("focusEvents"), Ig = Oe.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: n } = this;
    return [
      new je({
        key: Rg,
        props: {
          handleDOMEvents: {
            focus: (e, t) => {
              n.isFocused = !0;
              const i = n.state.tr.setMeta("focus", { event: t }).setMeta("addToHistory", !1);
              return e.dispatch(i), !1;
            },
            blur: (e, t) => {
              n.isFocused = !1;
              const i = n.state.tr.setMeta("blur", { event: t }).setMeta("addToHistory", !1);
              return e.dispatch(i), !1;
            }
          }
        }
      })
    ];
  }
}), Pg = Oe.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const n = () => this.editor.commands.first(({ commands: o }) => [
      () => o.undoInputRule(),
      // maybe convert first text block node to default node
      () => o.command(({ tr: a }) => {
        const { selection: l, doc: c } = a, { empty: u, $anchor: d } = l, { pos: h, parent: f } = d, p = d.parent.isTextblock && h > 0 ? a.doc.resolve(h - 1) : d, _ = p.parent.type.spec.isolating, m = d.pos - d.parentOffset, g = _ && p.parent.childCount === 1 ? m === d.pos : fe.atStart(c).from === h;
        return !u || !f.type.isTextblock || f.textContent.length || !g || g && d.parent.type.name === "paragraph" ? !1 : o.clearNodes();
      }),
      () => o.deleteSelection(),
      () => o.joinBackward(),
      () => o.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: o }) => [
      () => o.deleteSelection(),
      () => o.deleteCurrentNode(),
      () => o.joinForward(),
      () => o.selectNodeForward()
    ]), i = {
      Enter: () => this.editor.commands.first(({ commands: o }) => [
        () => o.newlineInCode(),
        () => o.createParagraphNear(),
        () => o.liftEmptyBlock(),
        () => o.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: n,
      "Mod-Backspace": n,
      "Shift-Backspace": n,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, r = {
      ...i
    }, s = {
      ...i,
      "Ctrl-h": n,
      "Alt-Backspace": n,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return xr() || Au() ? s : r;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new je({
        key: new Xe("clearDocument"),
        appendTransaction: (n, e, t) => {
          if (n.some((_) => _.getMeta("composition")))
            return;
          const i = n.some((_) => _.docChanged) && !e.doc.eq(t.doc), r = n.some((_) => _.getMeta("preventClearDocument"));
          if (!i || r)
            return;
          const { empty: s, from: o, to: a } = e.selection, l = fe.atStart(e.doc).from, c = fe.atEnd(e.doc).to;
          if (s || !(o === l && a === c) || !Ns(t.doc))
            return;
          const h = t.tr, f = Ts({
            state: t,
            transaction: h
          }), { commands: p } = new As({
            editor: this.editor,
            state: f
          });
          if (p.clearNodes(), !!h.steps.length)
            return h;
        }
      })
    ];
  }
}), Dg = Oe.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new je({
        key: new Xe("tiptapPaste"),
        props: {
          handlePaste: (n, e, t) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: e,
              slice: t
            });
          }
        }
      })
    ];
  }
}), $g = Oe.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new je({
        key: new Xe("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
}), zg = class Xi {
  constructor(e, t, i = !1, r = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = i, this.resolvedPos = e, this.editor = t, this.currentNode = r;
  }
  get name() {
    return this.node.type.name;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var e;
    return (e = this.actualDepth) != null ? e : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(e) {
    let t = this.from, i = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      t = this.from + 1, i = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: t, to: i }, e);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const e = this.resolvedPos.start(this.resolvedPos.depth - 1), t = this.resolvedPos.doc.resolve(e);
    return new Xi(t, this.editor);
  }
  get before() {
    let e = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.from - 3)), new Xi(e, this.editor);
  }
  get after() {
    let e = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.to + 3)), new Xi(e, this.editor);
  }
  get children() {
    const e = [];
    return this.node.content.forEach((t, i) => {
      const r = t.isBlock && !t.isTextblock, s = t.isAtom && !t.isText, o = this.pos + i + (s ? 0 : 1);
      if (o < 0 || o > this.resolvedPos.doc.nodeSize - 2)
        return;
      const a = this.resolvedPos.doc.resolve(o);
      if (!r && a.depth <= this.depth)
        return;
      const l = new Xi(a, this.editor, r, r ? t : null);
      r && (l.actualDepth = this.depth + 1), e.push(new Xi(a, this.editor, r, r ? t : null));
    }), e;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const e = this.children;
    return e[e.length - 1] || null;
  }
  closest(e, t = {}) {
    let i = null, r = this.parent;
    for (; r && !i; ) {
      if (r.node.type.name === e)
        if (Object.keys(t).length > 0) {
          const s = r.node.attrs, o = Object.keys(t);
          for (let a = 0; a < o.length; a += 1) {
            const l = o[a];
            if (s[l] !== t[l])
              break;
          }
        } else
          i = r;
      r = r.parent;
    }
    return i;
  }
  querySelector(e, t = {}) {
    return this.querySelectorAll(e, t, !0)[0] || null;
  }
  querySelectorAll(e, t = {}, i = !1) {
    let r = [];
    if (!this.children || this.children.length === 0)
      return r;
    const s = Object.keys(t);
    return this.children.forEach((o) => {
      i && r.length > 0 || (o.node.type.name === e && s.every((l) => t[l] === o.node.attrs[l]) && r.push(o), !(i && r.length > 0) && (r = r.concat(o.querySelectorAll(e, t, i))));
    }), r;
  }
  setAttribute(e) {
    const { tr: t } = this.editor.state;
    t.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...e
    }), this.editor.view.dispatch(t);
  }
}, Ok = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}`;
function Hg(n, e, t) {
  const i = document.querySelector(`style[data-tiptap-style${t ? `-${t}` : ""}]`);
  if (i !== null)
    return i;
  const r = document.createElement("style");
  return e && r.setAttribute("nonce", e), r.setAttribute(`data-tiptap-style${t ? `-${t}` : ""}`, ""), r.innerHTML = n, document.getElementsByTagName("head")[0].appendChild(r), r;
}
var Bg = class extends Sk {
  constructor(e = {}) {
    super(), this.css = null, this.className = "tiptap", this.editorView = null, this.isFocused = !1, this.isInitialized = !1, this.extensionStorage = {}, this.instanceId = Math.random().toString(36).slice(2, 9), this.options = {
      element: typeof document < "u" ? document.createElement("div") : null,
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      emitContentError: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onMount: () => null,
      onUnmount: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: r }) => {
        throw r;
      },
      onPaste: () => null,
      onDrop: () => null,
      onDelete: () => null
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.setOptions(e), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("mount", this.options.onMount), this.on("unmount", this.options.onUnmount), this.on("contentError", this.options.onContentError), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: r, slice: s, moved: o }) => this.options.onDrop(r, s, o)), this.on("paste", ({ event: r, slice: s }) => this.options.onPaste(r, s)), this.on("delete", this.options.onDelete);
    const t = this.createDoc(), i = Tu(t, this.options.autofocus);
    this.editorState = Zi.create({
      doc: t,
      schema: this.schema,
      selection: i || void 0
    }), this.options.element && this.mount(this.options.element);
  }
  /**
   * Attach the editor to the DOM, creating a new editor view.
   */
  mount(e) {
    if (typeof document > "u")
      throw new Error(
        "[tiptap error]: The editor cannot be mounted because there is no 'document' defined in this environment."
      );
    this.createView(e), this.emit("mount", { editor: this }), this.css && !document.head.contains(this.css) && document.head.appendChild(this.css), window.setTimeout(() => {
      this.isDestroyed || (this.options.autofocus !== !1 && this.options.autofocus !== null && this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Remove the editor from the DOM, but still allow remounting at a different point in time
   */
  unmount() {
    if (this.editorView) {
      const e = this.editorView.dom;
      e?.editor && delete e.editor, this.editorView.destroy();
    }
    if (this.editorView = null, this.isInitialized = !1, this.css && !document.querySelectorAll(`.${this.className}`).length)
      try {
        typeof this.css.remove == "function" ? this.css.remove() : this.css.parentNode && this.css.parentNode.removeChild(this.css);
      } catch (e) {
        console.warn("Failed to remove CSS element:", e);
      }
    this.css = null, this.emit("unmount", { editor: this });
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && typeof document < "u" && (this.css = Hg(Ok, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(e = {}) {
    this.options = {
      ...this.options,
      ...e
    }, !(!this.editorView || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(e, t = !0) {
    this.setOptions({ editable: e }), t && this.emit("update", { editor: this, transaction: this.state.tr, appendedTransactions: [] });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor state.
   */
  get view() {
    return this.editorView ? this.editorView : new Proxy(
      {
        state: this.editorState,
        updateState: (e) => {
          this.editorState = e;
        },
        dispatch: (e) => {
          this.dispatchTransaction(e);
        },
        // Stub some commonly accessed properties to prevent errors
        composing: !1,
        dragging: null,
        editable: !0,
        isDestroyed: !1
      },
      {
        get: (e, t) => {
          if (this.editorView)
            return this.editorView[t];
          if (t === "state")
            return this.editorState;
          if (t in e)
            return Reflect.get(e, t);
          throw new Error(
            `[tiptap error]: The editor view is not available. Cannot access view['${t}']. The editor may not be mounted yet.`
          );
        }
      }
    );
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.editorView && (this.editorState = this.view.state), this.editorState;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(e, t) {
    const i = Lu(t) ? t(e, [...this.state.plugins]) : [...this.state.plugins, e], r = this.state.reconfigure({ plugins: i });
    return this.view.updateState(r), r;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(e) {
    if (this.isDestroyed)
      return;
    const t = this.state.plugins;
    let i = t;
    if ([].concat(e).forEach((s) => {
      const o = typeof s == "string" ? `${s}$` : s.key;
      i = i.filter((a) => !a.key.startsWith(o));
    }), t.length === i.length)
      return;
    const r = this.state.reconfigure({
      plugins: i
    });
    return this.view.updateState(r), r;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var e, t;
    const r = [...this.options.enableCoreExtensions ? [
      Lg,
      Ag.configure({
        blockSeparator: (t = (e = this.options.coreExtensionOptions) == null ? void 0 : e.clipboardTextSerializer) == null ? void 0 : t.blockSeparator
      }),
      Mg,
      Ig,
      Pg,
      $g,
      Ng,
      Dg,
      Og
    ].filter((s) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[s.name] !== !1 : !0) : [], ...this.options.extensions].filter((s) => ["extension", "node", "mark"].includes(s?.type));
    this.extensionManager = new Va(r, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new As({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates the initial document.
   */
  createDoc() {
    let e;
    try {
      e = Bo(this.options.content, this.schema, this.options.parseOptions, {
        errorOnInvalidContent: this.options.enableContentCheck
      });
    } catch (t) {
      if (!(t instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(t.message))
        throw t;
      this.emit("contentError", {
        editor: this,
        error: t,
        disableCollaboration: () => {
          "collaboration" in this.storage && typeof this.storage.collaboration == "object" && this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((i) => i.name !== "collaboration"), this.createExtensionManager();
        }
      }), e = Bo(this.options.content, this.schema, this.options.parseOptions, {
        errorOnInvalidContent: !1
      });
    }
    return e;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView(e) {
    var t;
    this.editorView = new ig(e, {
      ...this.options.editorProps,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...(t = this.options.editorProps) == null ? void 0 : t.attributes
      },
      dispatchTransaction: this.dispatchTransaction.bind(this),
      state: this.editorState,
      markViews: this.extensionManager.markViews,
      nodeViews: this.extensionManager.nodeViews
    });
    const i = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(i), this.prependClass(), this.injectCSS();
    const r = this.view.dom;
    r.editor = this;
  }
  /**
   * Creates all node and mark views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      markViews: this.extensionManager.markViews,
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `${this.className} ${this.view.dom.className}`;
  }
  captureTransaction(e) {
    this.isCapturingTransaction = !0, e(), this.isCapturingTransaction = !1;
    const t = this.capturedTransaction;
    return this.capturedTransaction = null, t;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(e) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = e;
        return;
      }
      e.steps.forEach((u) => {
        var d;
        return (d = this.capturedTransaction) == null ? void 0 : d.step(u);
      });
      return;
    }
    const { state: t, transactions: i } = this.state.applyTransaction(e), r = !this.state.selection.eq(t.selection), s = i.includes(e), o = this.state;
    if (this.emit("beforeTransaction", {
      editor: this,
      transaction: e,
      nextState: t
    }), !s)
      return;
    this.view.updateState(t), this.emit("transaction", {
      editor: this,
      transaction: e,
      appendedTransactions: i.slice(1)
    }), r && this.emit("selectionUpdate", {
      editor: this,
      transaction: e
    });
    const a = i.findLast((u) => u.getMeta("focus") || u.getMeta("blur")), l = a?.getMeta("focus"), c = a?.getMeta("blur");
    l && this.emit("focus", {
      editor: this,
      event: l.event,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transaction: a
    }), c && this.emit("blur", {
      editor: this,
      event: c.event,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transaction: a
    }), !(e.getMeta("preventUpdate") || !i.some((u) => u.docChanged) || o.doc.eq(t.doc)) && this.emit("update", {
      editor: this,
      transaction: e,
      appendedTransactions: i.slice(1)
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(e) {
    return $u(this.state, e);
  }
  isActive(e, t) {
    const i = typeof e == "string" ? e : null, r = typeof e == "string" ? t : e;
    return bg(this.state, i, r);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return Os(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(e) {
    const { blockSeparator: t = `

`, textSerializers: i = {} } = e || {};
    return Du(this.state.doc, {
      blockSeparator: t,
      textSerializers: {
        ...za(this.schema),
        ...i
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return Ns(this.state.doc);
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    this.emit("destroy"), this.unmount(), this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var e, t;
    return (t = (e = this.editorView) == null ? void 0 : e.isDestroyed) != null ? t : !0;
  }
  $node(e, t) {
    var i;
    return ((i = this.$doc) == null ? void 0 : i.querySelector(e, t)) || null;
  }
  $nodes(e, t) {
    var i;
    return ((i = this.$doc) == null ? void 0 : i.querySelectorAll(e, t)) || null;
  }
  $pos(e) {
    const t = this.state.doc.resolve(e);
    return new zg(t, this);
  }
  get $doc() {
    return this.$pos(0);
  }
};
function _r(n) {
  return new Bi({
    find: n.find,
    handler: ({ state: e, range: t, match: i }) => {
      const r = Te(n.getAttributes, void 0, i);
      if (r === !1 || r === null)
        return null;
      const { tr: s } = e, o = i[i.length - 1], a = i[0];
      if (o) {
        const l = a.search(/\S/), c = t.from + a.indexOf(o), u = c + o.length;
        if (Ha(t.from, t.to, e.doc).filter((f) => f.mark.type.excluded.find((_) => _ === n.type && _ !== f.mark.type)).filter((f) => f.to > c).length)
          return null;
        u < t.to && s.delete(u, t.to), c > t.from && s.delete(t.from + l, c);
        const h = t.from + l + o.length;
        s.addMark(t.from + l, h, n.type.create(r || {})), s.removeStoredMark(n.type);
      }
    },
    undoable: n.undoable
  });
}
function Fu(n) {
  return new Bi({
    find: n.find,
    handler: ({ state: e, range: t, match: i }) => {
      const r = Te(n.getAttributes, void 0, i) || {}, { tr: s } = e, o = t.from;
      let a = t.to;
      const l = n.type.create(r);
      if (i[1]) {
        const c = i[0].lastIndexOf(i[1]);
        let u = o + c;
        u > a ? u = a : a = u + i[1].length;
        const d = i[0][i[0].length - 1];
        s.insertText(d, o + i[0].length - 1), s.replaceWith(u, a, l);
      } else if (i[0]) {
        const c = n.type.isInline ? o : o - 1;
        s.insert(c, n.type.create(r)).delete(s.mapping.map(o), s.mapping.map(a));
      }
      s.scrollIntoView();
    },
    undoable: n.undoable
  });
}
function Fg(n) {
  return new Bi({
    find: n.find,
    handler: ({ state: e, range: t, match: i }) => {
      const r = e.doc.resolve(t.from), s = Te(n.getAttributes, void 0, i) || {};
      if (!r.node(-1).canReplaceWith(r.index(-1), r.indexAfter(-1), n.type))
        return null;
      e.tr.delete(t.from, t.to).setBlockType(t.from, t.from, n.type, s);
    },
    undoable: n.undoable
  });
}
function Nk(n) {
  return new Bi({
    find: n.find,
    handler: ({ state: e, range: t, match: i }) => {
      let r = n.replace, s = t.from;
      const o = t.to;
      if (i[1]) {
        const a = i[0].lastIndexOf(i[1]);
        r += i[0].slice(a + i[1].length), s += a;
        const l = s - o;
        l > 0 && (r = i[0].slice(a - l, a) + r, s = o);
      }
      e.tr.insertText(r, s, o);
    },
    undoable: n.undoable
  });
}
function Pi(n) {
  return new Bi({
    find: n.find,
    handler: ({ state: e, range: t, match: i, chain: r }) => {
      const s = Te(n.getAttributes, void 0, i) || {}, o = e.tr.delete(t.from, t.to), l = o.doc.resolve(t.from).blockRange(), c = l && ou(l, n.type, s);
      if (!c)
        return null;
      if (o.wrap(l, c), n.keepMarks && n.editor) {
        const { selection: d, storedMarks: h } = e, { splittableMarks: f } = n.editor.extensionManager, p = h || d.$to.parentOffset && d.$from.marks();
        if (p) {
          const _ = p.filter((m) => f.includes(m.type.name));
          o.ensureMarks(_);
        }
      }
      if (n.keepAttributes) {
        const d = n.type.name === "bulletList" || n.type.name === "orderedList" ? "listItem" : "taskList";
        r().updateAttributes(d, s).run();
      }
      const u = o.doc.resolve(t.from - 1).nodeBefore;
      u && u.type === n.type && _i(o.doc, t.from - 1) && (!n.joinPredicate || n.joinPredicate(i, u)) && o.join(t.from - 1);
    },
    undoable: n.undoable
  });
}
function Lk(n) {
  return n.children;
}
var Bh = (n, e) => {
  if (n === "slot")
    return 0;
  if (n instanceof Function)
    return n(e);
  const { children: t, ...i } = e ?? {};
  if (n === "svg")
    throw new Error("SVG elements are not supported in the JSX syntax, use the array syntax instead");
  return [n, i, t];
}, Rk = (n) => "touches" in n, Vu = class {
  /**
   * Creates a new ResizableNodeView instance.
   *
   * The constructor sets up the resize handles, applies initial sizing from
   * node attributes, and configures all resize behavior options.
   *
   * @param options - Configuration options for the resizable node view
   */
  constructor(n) {
    this.directions = ["bottom-left", "bottom-right", "top-left", "top-right"], this.minSize = {
      height: 8,
      width: 8
    }, this.preserveAspectRatio = !1, this.classNames = {
      container: "",
      wrapper: "",
      handle: "",
      resizing: ""
    }, this.initialWidth = 0, this.initialHeight = 0, this.aspectRatio = 1, this.isResizing = !1, this.activeHandle = null, this.startX = 0, this.startY = 0, this.startWidth = 0, this.startHeight = 0, this.isShiftKeyPressed = !1, this.handleMouseMove = (o) => {
      if (!this.isResizing || !this.activeHandle)
        return;
      const a = o.clientX - this.startX, l = o.clientY - this.startY;
      this.handleResize(a, l);
    }, this.handleTouchMove = (o) => {
      if (!this.isResizing || !this.activeHandle)
        return;
      const a = o.touches[0];
      if (!a)
        return;
      const l = a.clientX - this.startX, c = a.clientY - this.startY;
      this.handleResize(l, c);
    }, this.handleMouseUp = () => {
      if (!this.isResizing)
        return;
      const o = this.element.offsetWidth, a = this.element.offsetHeight;
      this.onCommit(o, a), this.isResizing = !1, this.activeHandle = null, this.container.dataset.resizeState = "false", this.classNames.resizing && this.container.classList.remove(this.classNames.resizing), document.removeEventListener("mousemove", this.handleMouseMove), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("keyup", this.handleKeyUp);
    }, this.handleKeyDown = (o) => {
      o.key === "Shift" && (this.isShiftKeyPressed = !0);
    }, this.handleKeyUp = (o) => {
      o.key === "Shift" && (this.isShiftKeyPressed = !1);
    };
    var e, t, i, r, s;
    this.node = n.node, this.element = n.element, this.contentElement = n.contentElement, this.getPos = n.getPos, this.onResize = n.onResize, this.onCommit = n.onCommit, this.onUpdate = n.onUpdate, (e = n.options) != null && e.min && (this.minSize = {
      ...this.minSize,
      ...n.options.min
    }), (t = n.options) != null && t.max && (this.maxSize = n.options.max), (i = n?.options) != null && i.directions && (this.directions = n.options.directions), (r = n.options) != null && r.preserveAspectRatio && (this.preserveAspectRatio = n.options.preserveAspectRatio), (s = n.options) != null && s.className && (this.classNames = {
      container: n.options.className.container || "",
      wrapper: n.options.className.wrapper || "",
      handle: n.options.className.handle || "",
      resizing: n.options.className.resizing || ""
    }), this.wrapper = this.createWrapper(), this.container = this.createContainer(), this.applyInitialSize(), this.attachHandles();
  }
  /**
   * Returns the top-level DOM node that should be placed in the editor.
   *
   * This is required by the ProseMirror NodeView interface. The container
   * includes the wrapper, handles, and the actual content element.
   *
   * @returns The container element to be inserted into the editor
   */
  get dom() {
    return this.container;
  }
  get contentDOM() {
    return this.contentElement;
  }
  /**
   * Called when the node's content or attributes change.
   *
   * Updates the internal node reference. If a custom `onUpdate` callback
   * was provided, it will be called to handle additional update logic.
   *
   * @param node - The new/updated node
   * @param decorations - Node decorations
   * @param innerDecorations - Inner decorations
   * @returns `false` if the node type has changed (requires full rebuild), otherwise the result of `onUpdate` or `true`
   */
  update(n, e, t) {
    return n.type !== this.node.type ? !1 : (this.node = n, this.onUpdate ? this.onUpdate(n, e, t) : !0);
  }
  /**
   * Cleanup method called when the node view is being removed.
   *
   * Removes all event listeners to prevent memory leaks. This is required
   * by the ProseMirror NodeView interface. If a resize is active when
   * destroy is called, it will be properly cancelled.
   */
  destroy() {
    this.isResizing && (this.container.dataset.resizeState = "false", this.classNames.resizing && this.container.classList.remove(this.classNames.resizing), document.removeEventListener("mousemove", this.handleMouseMove), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("keyup", this.handleKeyUp), this.isResizing = !1, this.activeHandle = null), this.container.remove();
  }
  /**
   * Creates the outer container element.
   *
   * The container is the top-level element returned by the NodeView and
   * wraps the entire resizable node. It's set up with flexbox to handle
   * alignment and includes data attributes for styling and identification.
   *
   * @returns The container element
   */
  createContainer() {
    const n = document.createElement("div");
    return n.dataset.resizeContainer = "", n.dataset.node = this.node.type.name, n.style.display = "flex", n.style.justifyContent = "flex-start", n.style.alignItems = "flex-start", this.classNames.container && (n.className = this.classNames.container), n.appendChild(this.wrapper), n;
  }
  /**
   * Creates the wrapper element that contains the content and handles.
   *
   * The wrapper uses relative positioning so that resize handles can be
   * positioned absolutely within it. This is the direct parent of the
   * content element being made resizable.
   *
   * @returns The wrapper element
   */
  createWrapper() {
    const n = document.createElement("div");
    return n.style.position = "relative", n.style.display = "block", n.dataset.resizeWrapper = "", this.classNames.wrapper && (n.className = this.classNames.wrapper), n.appendChild(this.element), n;
  }
  /**
   * Creates a resize handle element for a specific direction.
   *
   * Each handle is absolutely positioned and includes a data attribute
   * identifying its direction for styling purposes.
   *
   * @param direction - The resize direction for this handle
   * @returns The handle element
   */
  createHandle(n) {
    const e = document.createElement("div");
    return e.dataset.resizeHandle = n, e.style.position = "absolute", this.classNames.handle && (e.className = this.classNames.handle), e;
  }
  /**
   * Positions a handle element according to its direction.
   *
   * Corner handles (e.g., 'top-left') are positioned at the intersection
   * of two edges. Edge handles (e.g., 'top') span the full width or height.
   *
   * @param handle - The handle element to position
   * @param direction - The direction determining the position
   */
  positionHandle(n, e) {
    const t = e.includes("top"), i = e.includes("bottom"), r = e.includes("left"), s = e.includes("right");
    t && (n.style.top = "0"), i && (n.style.bottom = "0"), r && (n.style.left = "0"), s && (n.style.right = "0"), (e === "top" || e === "bottom") && (n.style.left = "0", n.style.right = "0"), (e === "left" || e === "right") && (n.style.top = "0", n.style.bottom = "0");
  }
  /**
   * Creates and attaches all resize handles to the wrapper.
   *
   * Iterates through the configured directions, creates a handle for each,
   * positions it, attaches the mousedown listener, and appends it to the DOM.
   */
  attachHandles() {
    this.directions.forEach((n) => {
      const e = this.createHandle(n);
      this.positionHandle(e, n), e.addEventListener("mousedown", (t) => this.handleResizeStart(t, n)), e.addEventListener("touchstart", (t) => this.handleResizeStart(t, n)), this.wrapper.appendChild(e);
    });
  }
  /**
   * Applies initial sizing from node attributes to the element.
   *
   * If width/height attributes exist on the node, they're applied to the element.
   * Otherwise, the element's natural/current dimensions are measured. The aspect
   * ratio is calculated for later use in aspect-ratio-preserving resizes.
   */
  applyInitialSize() {
    const n = this.node.attrs.width, e = this.node.attrs.height;
    n ? (this.element.style.width = `${n}px`, this.initialWidth = n) : this.initialWidth = this.element.offsetWidth, e ? (this.element.style.height = `${e}px`, this.initialHeight = e) : this.initialHeight = this.element.offsetHeight, this.initialWidth > 0 && this.initialHeight > 0 && (this.aspectRatio = this.initialWidth / this.initialHeight);
  }
  /**
   * Initiates a resize operation when a handle is clicked.
   *
   * Captures the starting mouse position and element dimensions, sets up
   * the resize state, adds the resizing class and state attribute, and
   * attaches document-level listeners for mouse movement and keyboard input.
   *
   * @param event - The mouse down event
   * @param direction - The direction of the handle being dragged
   */
  handleResizeStart(n, e) {
    n.preventDefault(), n.stopPropagation(), this.isResizing = !0, this.activeHandle = e, Rk(n) ? (this.startX = n.touches[0].clientX, this.startY = n.touches[0].clientY) : (this.startX = n.clientX, this.startY = n.clientY), this.startWidth = this.element.offsetWidth, this.startHeight = this.element.offsetHeight, this.startWidth > 0 && this.startHeight > 0 && (this.aspectRatio = this.startWidth / this.startHeight), this.getPos(), this.container.dataset.resizeState = "true", this.classNames.resizing && this.container.classList.add(this.classNames.resizing), document.addEventListener("mousemove", this.handleMouseMove), document.addEventListener("touchmove", this.handleTouchMove), document.addEventListener("mouseup", this.handleMouseUp), document.addEventListener("keydown", this.handleKeyDown), document.addEventListener("keyup", this.handleKeyUp);
  }
  handleResize(n, e) {
    if (!this.activeHandle)
      return;
    const t = this.preserveAspectRatio || this.isShiftKeyPressed, { width: i, height: r } = this.calculateNewDimensions(this.activeHandle, n, e), s = this.applyConstraints(i, r, t);
    this.element.style.width = `${s.width}px`, this.element.style.height = `${s.height}px`, this.onResize && this.onResize(s.width, s.height);
  }
  /**
   * Calculates new dimensions based on mouse delta and resize direction.
   *
   * Takes the starting dimensions and applies the mouse movement delta
   * according to the handle direction. For corner handles, both dimensions
   * are affected. For edge handles, only one dimension changes. If aspect
   * ratio should be preserved, delegates to applyAspectRatio.
   *
   * @param direction - The active resize handle direction
   * @param deltaX - Horizontal mouse movement since resize start
   * @param deltaY - Vertical mouse movement since resize start
   * @returns The calculated width and height
   */
  calculateNewDimensions(n, e, t) {
    let i = this.startWidth, r = this.startHeight;
    const s = n.includes("right"), o = n.includes("left"), a = n.includes("bottom"), l = n.includes("top");
    return s ? i = this.startWidth + e : o && (i = this.startWidth - e), a ? r = this.startHeight + t : l && (r = this.startHeight - t), (n === "right" || n === "left") && (i = this.startWidth + (s ? e : -e)), (n === "top" || n === "bottom") && (r = this.startHeight + (a ? t : -t)), this.preserveAspectRatio || this.isShiftKeyPressed ? this.applyAspectRatio(i, r, n) : { width: i, height: r };
  }
  /**
   * Applies min/max constraints to dimensions.
   *
   * When aspect ratio is NOT preserved, constraints are applied independently
   * to width and height. When aspect ratio IS preserved, constraints are
   * applied while maintaining the aspect ratio—if one dimension hits a limit,
   * the other is recalculated proportionally.
   *
   * This ensures that aspect ratio is never broken when constrained.
   *
   * @param width - The unconstrained width
   * @param height - The unconstrained height
   * @param preserveAspectRatio - Whether to maintain aspect ratio while constraining
   * @returns The constrained dimensions
   */
  applyConstraints(n, e, t) {
    var i, r, s, o;
    if (!t) {
      let c = Math.max(this.minSize.width, n), u = Math.max(this.minSize.height, e);
      return (i = this.maxSize) != null && i.width && (c = Math.min(this.maxSize.width, c)), (r = this.maxSize) != null && r.height && (u = Math.min(this.maxSize.height, u)), { width: c, height: u };
    }
    let a = n, l = e;
    return a < this.minSize.width && (a = this.minSize.width, l = a / this.aspectRatio), l < this.minSize.height && (l = this.minSize.height, a = l * this.aspectRatio), (s = this.maxSize) != null && s.width && a > this.maxSize.width && (a = this.maxSize.width, l = a / this.aspectRatio), (o = this.maxSize) != null && o.height && l > this.maxSize.height && (l = this.maxSize.height, a = l * this.aspectRatio), { width: a, height: l };
  }
  /**
   * Adjusts dimensions to maintain the original aspect ratio.
   *
   * For horizontal handles (left/right), uses width as the primary dimension
   * and calculates height from it. For vertical handles (top/bottom), uses
   * height as primary and calculates width. For corner handles, uses width
   * as the primary dimension.
   *
   * @param width - The new width
   * @param height - The new height
   * @param direction - The active resize direction
   * @returns Dimensions adjusted to preserve aspect ratio
   */
  applyAspectRatio(n, e, t) {
    const i = t === "left" || t === "right", r = t === "top" || t === "bottom";
    return i ? {
      width: n,
      height: n / this.aspectRatio
    } : r ? {
      width: e * this.aspectRatio,
      height: e
    } : {
      width: n,
      height: n / this.aspectRatio
    };
  }
}, Ik = Vu;
function Vg(n, e) {
  const { selection: t } = n, { $from: i } = t;
  if (t instanceof re) {
    const s = i.index();
    return i.parent.canReplaceWith(s, s + 1, e);
  }
  let r = i.depth;
  for (; r >= 0; ) {
    const s = i.index(r);
    if (i.node(r).contentMatchAt(s).matchType(e))
      return !0;
    r -= 1;
  }
  return !1;
}
function Pk(n) {
  return n.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function Dk(n) {
  return typeof n == "string";
}
var jg = {};
Su(jg, {
  createAtomBlockMarkdownSpec: () => Wg,
  createBlockMarkdownSpec: () => Ug,
  createInlineMarkdownSpec: () => Kg,
  parseAttributes: () => ja,
  parseIndentedBlocks: () => Vo,
  renderNestedMarkdownContent: () => Ua,
  serializeAttributes: () => Wa
});
function ja(n) {
  if (!n?.trim())
    return {};
  const e = {}, t = [], i = n.replace(/["']([^"']*)["']/g, (c) => (t.push(c), `__QUOTED_${t.length - 1}__`)), r = i.match(/(?:^|\s)\.([a-zA-Z][\w-]*)/g);
  if (r) {
    const c = r.map((u) => u.trim().slice(1));
    e.class = c.join(" ");
  }
  const s = i.match(/(?:^|\s)#([a-zA-Z][\w-]*)/);
  s && (e.id = s[1]);
  const o = /([a-zA-Z][\w-]*)\s*=\s*(__QUOTED_\d+__)/g;
  Array.from(i.matchAll(o)).forEach(([, c, u]) => {
    var d;
    const h = parseInt(((d = u.match(/__QUOTED_(\d+)__/)) == null ? void 0 : d[1]) || "0", 10), f = t[h];
    f && (e[c] = f.slice(1, -1));
  });
  const l = i.replace(/(?:^|\s)\.([a-zA-Z][\w-]*)/g, "").replace(/(?:^|\s)#([a-zA-Z][\w-]*)/g, "").replace(/([a-zA-Z][\w-]*)\s*=\s*__QUOTED_\d+__/g, "").trim();
  return l && l.split(/\s+/).filter(Boolean).forEach((u) => {
    u.match(/^[a-zA-Z][\w-]*$/) && (e[u] = !0);
  }), e;
}
function Wa(n) {
  if (!n || Object.keys(n).length === 0)
    return "";
  const e = [];
  return n.class && String(n.class).split(/\s+/).filter(Boolean).forEach((i) => e.push(`.${i}`)), n.id && e.push(`#${n.id}`), Object.entries(n).forEach(([t, i]) => {
    t === "class" || t === "id" || (i === !0 ? e.push(t) : i !== !1 && i != null && e.push(`${t}="${String(i)}"`));
  }), e.join(" ");
}
function Wg(n) {
  const {
    nodeName: e,
    name: t,
    parseAttributes: i = ja,
    serializeAttributes: r = Wa,
    defaultAttributes: s = {},
    requiredAttributes: o = [],
    allowedAttributes: a
  } = n, l = t || e, c = (u) => {
    if (!a)
      return u;
    const d = {};
    return a.forEach((h) => {
      h in u && (d[h] = u[h]);
    }), d;
  };
  return {
    parseMarkdown: (u, d) => {
      const h = { ...s, ...u.attributes };
      return d.createNode(e, h, []);
    },
    markdownTokenizer: {
      name: e,
      level: "block",
      start(u) {
        var d;
        const h = new RegExp(`^:::${l}(?:\\s|$)`, "m"), f = (d = u.match(h)) == null ? void 0 : d.index;
        return f !== void 0 ? f : -1;
      },
      tokenize(u, d, h) {
        const f = new RegExp(`^:::${l}(?:\\s+\\{([^}]*)\\})?\\s*:::(?:\\n|$)`), p = u.match(f);
        if (!p)
          return;
        const _ = p[1] || "", m = i(_);
        if (!o.find((y) => !(y in m)))
          return {
            type: e,
            raw: p[0],
            attributes: m
          };
      }
    },
    renderMarkdown: (u) => {
      const d = c(u.attrs || {}), h = r(d), f = h ? ` {${h}}` : "";
      return `:::${l}${f} :::`;
    }
  };
}
function Ug(n) {
  const {
    nodeName: e,
    name: t,
    getContent: i,
    parseAttributes: r = ja,
    serializeAttributes: s = Wa,
    defaultAttributes: o = {},
    content: a = "block",
    allowedAttributes: l
  } = n, c = t || e, u = (d) => {
    if (!l)
      return d;
    const h = {};
    return l.forEach((f) => {
      f in d && (h[f] = d[f]);
    }), h;
  };
  return {
    parseMarkdown: (d, h) => {
      let f;
      if (i) {
        const _ = i(d);
        f = typeof _ == "string" ? [{ type: "text", text: _ }] : _;
      } else a === "block" ? f = h.parseChildren(d.tokens || []) : f = h.parseInline(d.tokens || []);
      const p = { ...o, ...d.attributes };
      return h.createNode(e, p, f);
    },
    markdownTokenizer: {
      name: e,
      level: "block",
      start(d) {
        var h;
        const f = new RegExp(`^:::${c}`, "m"), p = (h = d.match(f)) == null ? void 0 : h.index;
        return p !== void 0 ? p : -1;
      },
      tokenize(d, h, f) {
        var p;
        const _ = new RegExp(`^:::${c}(?:\\s+\\{([^}]*)\\})?\\s*\\n`), m = d.match(_);
        if (!m)
          return;
        const [g, y = ""] = m, x = r(y);
        let k = 1;
        const E = g.length;
        let S = "";
        const w = /^:::([\w-]*)(\s.*)?/gm, v = d.slice(E);
        for (w.lastIndex = 0; ; ) {
          const A = w.exec(v);
          if (A === null)
            break;
          const b = A.index, C = A[1];
          if (!((p = A[2]) != null && p.endsWith(":::"))) {
            if (C)
              k += 1;
            else if (k -= 1, k === 0) {
              const M = v.slice(0, b);
              S = M.trim();
              const z = d.slice(0, E + b + A[0].length);
              let D = [];
              if (S)
                if (a === "block")
                  for (D = f.blockTokens(M), D.forEach((H) => {
                    H.text && (!H.tokens || H.tokens.length === 0) && (H.tokens = f.inlineTokens(H.text));
                  }); D.length > 0; ) {
                    const H = D[D.length - 1];
                    if (H.type === "paragraph" && (!H.text || H.text.trim() === ""))
                      D.pop();
                    else
                      break;
                  }
                else
                  D = f.inlineTokens(S);
              return {
                type: e,
                raw: z,
                attributes: x,
                content: S,
                tokens: D
              };
            }
          }
        }
      }
    },
    renderMarkdown: (d, h) => {
      const f = u(d.attrs || {}), p = s(f), _ = p ? ` {${p}}` : "", m = h.renderChildren(d.content || [], `

`);
      return `:::${c}${_}

${m}

:::`;
    }
  };
}
function $k(n) {
  if (!n.trim())
    return {};
  const e = {}, t = /(\w+)=(?:"([^"]*)"|'([^']*)')/g;
  let i = t.exec(n);
  for (; i !== null; ) {
    const [, r, s, o] = i;
    e[r] = s || o, i = t.exec(n);
  }
  return e;
}
function zk(n) {
  return Object.entries(n).filter(([, e]) => e != null).map(([e, t]) => `${e}="${t}"`).join(" ");
}
function Kg(n) {
  const {
    nodeName: e,
    name: t,
    getContent: i,
    parseAttributes: r = $k,
    serializeAttributes: s = zk,
    defaultAttributes: o = {},
    selfClosing: a = !1,
    allowedAttributes: l
  } = n, c = t || e, u = (h) => {
    if (!l)
      return h;
    const f = {};
    return l.forEach((p) => {
      p in h && (f[p] = h[p]);
    }), f;
  }, d = c.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return {
    parseMarkdown: (h, f) => {
      const p = { ...o, ...h.attributes };
      if (a)
        return f.createNode(e, p);
      const _ = i ? i(h) : h.content || "";
      return _ ? f.createNode(e, p, [f.createTextNode(_)]) : f.createNode(e, p, []);
    },
    markdownTokenizer: {
      name: e,
      level: "inline",
      start(h) {
        const f = a ? new RegExp(`\\[${d}\\s*[^\\]]*\\]`) : new RegExp(`\\[${d}\\s*[^\\]]*\\][\\s\\S]*?\\[\\/${d}\\]`), p = h.match(f), _ = p?.index;
        return _ !== void 0 ? _ : -1;
      },
      tokenize(h, f, p) {
        const _ = a ? new RegExp(`^\\[${d}\\s*([^\\]]*)\\]`) : new RegExp(`^\\[${d}\\s*([^\\]]*)\\]([\\s\\S]*?)\\[\\/${d}\\]`), m = h.match(_);
        if (!m)
          return;
        let g = "", y = "";
        if (a) {
          const [, k] = m;
          y = k;
        } else {
          const [, k, E] = m;
          y = k, g = E || "";
        }
        const x = r(y.trim());
        return {
          type: e,
          raw: m[0],
          content: g.trim(),
          attributes: x
        };
      }
    },
    renderMarkdown: (h) => {
      let f = "";
      i ? f = i(h) : h.content && h.content.length > 0 && (f = h.content.filter((g) => g.type === "text").map((g) => g.text).join(""));
      const p = u(h.attrs || {}), _ = s(p), m = _ ? ` ${_}` : "";
      return a ? `[${c}${m}]` : `[${c}${m}]${f}[/${c}]`;
    }
  };
}
function Vo(n, e, t) {
  var i, r, s, o;
  const a = n.split(`
`), l = [];
  let c = "", u = 0;
  const d = e.baseIndentSize || 2;
  for (; u < a.length; ) {
    const h = a[u], f = h.match(e.itemPattern);
    if (!f) {
      if (l.length > 0)
        break;
      if (h.trim() === "") {
        u += 1;
        continue;
      } else
        return;
    }
    const p = e.extractItemData(f), { indentLevel: _, mainContent: m } = p;
    c = `${c}${h}
`;
    const g = [m];
    for (u += 1; u < a.length; ) {
      const E = a[u];
      if (E.trim() === "") {
        const w = a.slice(u + 1).findIndex((b) => b.trim() !== "");
        if (w === -1)
          break;
        if ((((r = (i = a[u + 1 + w].match(/^(\s*)/)) == null ? void 0 : i[1]) == null ? void 0 : r.length) || 0) > _) {
          g.push(E), c = `${c}${E}
`, u += 1;
          continue;
        } else
          break;
      }
      if ((((o = (s = E.match(/^(\s*)/)) == null ? void 0 : s[1]) == null ? void 0 : o.length) || 0) > _)
        g.push(E), c = `${c}${E}
`, u += 1;
      else
        break;
    }
    let y;
    const x = g.slice(1);
    if (x.length > 0) {
      const E = x.map((S) => S.slice(_ + d)).join(`
`);
      E.trim() && (e.customNestedParser ? y = e.customNestedParser(E) : y = t.blockTokens(E));
    }
    const k = e.createToken(p, y);
    l.push(k);
  }
  if (l.length !== 0)
    return {
      items: l,
      raw: c.trim()
    };
}
function Ua(n, e, t, i) {
  if (!n || !Array.isArray(n.content))
    return "";
  const r = typeof t == "function" ? t(i) : t, [s, ...o] = n.content, a = e.renderChildren([s]), l = [`${r}${a}`];
  return o && o.length > 0 && o.forEach((c) => {
    const u = e.renderChildren([c]);
    if (u) {
      const d = u.split(`
`).map((h) => h ? e.indent(h) : "").join(`
`);
      l.push(d);
    }
  }), l.join(`
`);
}
function ju(n, e, t = {}) {
  const { state: i } = e, { doc: r, tr: s } = i, o = n;
  r.descendants((a, l) => {
    const c = s.mapping.map(l), u = s.mapping.map(l) + a.nodeSize;
    let d = null;
    if (a.marks.forEach((f) => {
      if (f !== o)
        return !1;
      d = f;
    }), !d)
      return;
    let h = !1;
    if (Object.keys(t).forEach((f) => {
      t[f] !== d.attrs[f] && (h = !0);
    }), h) {
      const f = n.type.create({
        ...n.attrs,
        ...t
      });
      s.removeMark(c, u, n.type), s.addMark(c, u, f);
    }
  }), s.docChanged && e.view.dispatch(s);
}
var Hk = class {
  constructor(n, e, t) {
    this.component = n, this.editor = e.editor, this.options = { ...t }, this.mark = e.mark, this.HTMLAttributes = e.HTMLAttributes;
  }
  get dom() {
    return this.editor.view.dom;
  }
  get contentDOM() {
    return null;
  }
  /**
   * Update the attributes of the mark in the document.
   * @param attrs The attributes to update.
   */
  updateAttributes(n, e) {
    ju(e || this.mark, this.editor, n);
  }
  ignoreMutation(n) {
    return !this.dom || !this.contentDOM ? !0 : typeof this.options.ignoreMutation == "function" ? this.options.ignoreMutation({ mutation: n }) : n.type === "selection" || this.dom.contains(n.target) && n.type === "childList" && (xr() || Ra()) && this.editor.isFocused && [...Array.from(n.addedNodes), ...Array.from(n.removedNodes)].every((t) => t.isContentEditable) ? !1 : this.contentDOM === n.target && n.type === "attributes" ? !0 : !this.contentDOM.contains(n.target);
  }
}, Ne = class qg extends Ba {
  constructor() {
    super(...arguments), this.type = "node";
  }
  /**
   * Create a new Node instance
   * @param config - Node configuration object or a function that returns a configuration object
   */
  static create(e = {}) {
    const t = typeof e == "function" ? e() : e;
    return new qg(t);
  }
  configure(e) {
    return super.configure(e);
  }
  extend(e) {
    const t = typeof e == "function" ? e() : e;
    return super.extend(t);
  }
}, Bk = class {
  constructor(n, e, t) {
    this.isDragging = !1, this.component = n, this.editor = e.editor, this.options = {
      stopEvent: null,
      ignoreMutation: null,
      ...t
    }, this.extension = e.extension, this.node = e.node, this.decorations = e.decorations, this.innerDecorations = e.innerDecorations, this.view = e.view, this.HTMLAttributes = e.HTMLAttributes, this.getPos = e.getPos, this.mount();
  }
  mount() {
  }
  get dom() {
    return this.editor.view.dom;
  }
  get contentDOM() {
    return null;
  }
  onDragStart(n) {
    var e, t, i, r, s, o, a;
    const { view: l } = this.editor, c = n.target, u = c.nodeType === 3 ? (e = c.parentElement) == null ? void 0 : e.closest("[data-drag-handle]") : c.closest("[data-drag-handle]");
    if (!this.dom || (t = this.contentDOM) != null && t.contains(c) || !u)
      return;
    let d = 0, h = 0;
    if (this.dom !== u) {
      const y = this.dom.getBoundingClientRect(), x = u.getBoundingClientRect(), k = (r = n.offsetX) != null ? r : (i = n.nativeEvent) == null ? void 0 : i.offsetX, E = (o = n.offsetY) != null ? o : (s = n.nativeEvent) == null ? void 0 : s.offsetY;
      d = x.x - y.x + k, h = x.y - y.y + E;
    }
    const f = this.dom.cloneNode(!0);
    try {
      const y = this.dom.getBoundingClientRect();
      f.style.width = `${Math.round(y.width)}px`, f.style.height = `${Math.round(y.height)}px`, f.style.boxSizing = "border-box", f.style.pointerEvents = "none";
    } catch {
    }
    let p = null;
    try {
      p = document.createElement("div"), p.style.position = "absolute", p.style.top = "-9999px", p.style.left = "-9999px", p.style.pointerEvents = "none", p.appendChild(f), document.body.appendChild(p), (a = n.dataTransfer) == null || a.setDragImage(f, d, h);
    } finally {
      p && setTimeout(() => {
        try {
          p?.remove();
        } catch {
        }
      }, 0);
    }
    const _ = this.getPos();
    if (typeof _ != "number")
      return;
    const m = re.create(l.state.doc, _), g = l.state.tr.setSelection(m);
    l.dispatch(g);
  }
  stopEvent(n) {
    var e;
    if (!this.dom)
      return !1;
    if (typeof this.options.stopEvent == "function")
      return this.options.stopEvent({ event: n });
    const t = n.target;
    if (!(this.dom.contains(t) && !((e = this.contentDOM) != null && e.contains(t))))
      return !1;
    const r = n.type.startsWith("drag"), s = n.type === "drop";
    if ((["INPUT", "BUTTON", "SELECT", "TEXTAREA"].includes(t.tagName) || t.isContentEditable) && !s && !r)
      return !0;
    const { isEditable: a } = this.editor, { isDragging: l } = this, c = !!this.node.type.spec.draggable, u = re.isSelectable(this.node), d = n.type === "copy", h = n.type === "paste", f = n.type === "cut", p = n.type === "mousedown";
    if (!c && u && r && n.target === this.dom && n.preventDefault(), c && r && !l && n.target === this.dom)
      return n.preventDefault(), !1;
    if (c && a && !l && p) {
      const _ = t.closest("[data-drag-handle]");
      _ && (this.dom === _ || this.dom.contains(_)) && (this.isDragging = !0, document.addEventListener(
        "dragend",
        () => {
          this.isDragging = !1;
        },
        { once: !0 }
      ), document.addEventListener(
        "drop",
        () => {
          this.isDragging = !1;
        },
        { once: !0 }
      ), document.addEventListener(
        "mouseup",
        () => {
          this.isDragging = !1;
        },
        { once: !0 }
      ));
    }
    return !(l || s || d || h || f || p && u);
  }
  /**
   * Called when a DOM [mutation](https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver) or a selection change happens within the view.
   * @return `false` if the editor should re-read the selection or re-parse the range around the mutation
   * @return `true` if it can safely be ignored.
   */
  ignoreMutation(n) {
    return !this.dom || !this.contentDOM ? !0 : typeof this.options.ignoreMutation == "function" ? this.options.ignoreMutation({ mutation: n }) : this.node.isLeaf || this.node.isAtom ? !0 : n.type === "selection" || this.dom.contains(n.target) && n.type === "childList" && (xr() || Ra()) && this.editor.isFocused && [...Array.from(n.addedNodes), ...Array.from(n.removedNodes)].every((t) => t.isContentEditable) ? !1 : this.contentDOM === n.target && n.type === "attributes" ? !0 : !this.contentDOM.contains(n.target);
  }
  /**
   * Update the attributes of the prosemirror node.
   */
  updateAttributes(n) {
    this.editor.commands.command(({ tr: e }) => {
      const t = this.getPos();
      return typeof t != "number" ? !1 : (e.setNodeMarkup(t, void 0, {
        ...this.node.attrs,
        ...n
      }), !0);
    });
  }
  /**
   * Delete the node.
   */
  deleteNode() {
    const n = this.getPos();
    if (typeof n != "number")
      return;
    const e = n + this.node.nodeSize;
    this.editor.commands.deleteRange({ from: n, to: e });
  }
};
function Di(n) {
  return new Fa({
    find: n.find,
    handler: ({ state: e, range: t, match: i, pasteEvent: r }) => {
      const s = Te(n.getAttributes, void 0, i, r);
      if (s === !1 || s === null)
        return null;
      const { tr: o } = e, a = i[i.length - 1], l = i[0];
      let c = t.to;
      if (a) {
        const u = l.search(/\S/), d = t.from + l.indexOf(a), h = d + a.length;
        if (Ha(t.from, t.to, e.doc).filter((p) => p.mark.type.excluded.find((m) => m === n.type && m !== p.mark.type)).filter((p) => p.to > d).length)
          return null;
        h < t.to && o.delete(h, t.to), d > t.from && o.delete(t.from + u, d), c = t.from + u + a.length, o.addMark(t.from + u, c, n.type.create(s || {})), o.removeStoredMark(n.type);
      }
    }
  });
}
function Fk(n) {
  return new Fa({
    find: n.find,
    handler({ match: e, chain: t, range: i, pasteEvent: r }) {
      const s = Te(n.getAttributes, void 0, e, r), o = Te(n.getContent, void 0, s);
      if (s === !1 || s === null)
        return null;
      const a = { type: n.type.name, attrs: s };
      o && (a.content = o), e.input && t().deleteRange(i).insertContentAt(i.from, a);
    }
  });
}
function Vk(n) {
  return new Fa({
    find: n.find,
    handler: ({ state: e, range: t, match: i }) => {
      let r = n.replace, s = t.from;
      const o = t.to;
      if (i[1]) {
        const a = i[0].lastIndexOf(i[1]);
        r += i[0].slice(a + i[1].length), s += a;
        const l = s - o;
        l > 0 && (r = i[0].slice(a - l, a) + r, s = o);
      }
      e.tr.insertText(r, s, o);
    }
  });
}
var jk = class {
  constructor(n) {
    this.transaction = n, this.currentStep = this.transaction.steps.length;
  }
  map(n) {
    let e = !1;
    return {
      position: this.transaction.steps.slice(this.currentStep).reduce((i, r) => {
        const s = r.getMap().mapResult(i);
        return s.deleted && (e = !0), s.pos;
      }, n),
      deleted: e
    };
  }
};
const Wk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CommandManager: As,
  Editor: Bg,
  Extendable: Ba,
  Extension: Oe,
  Fragment: Lk,
  InputRule: Bi,
  Mark: Jt,
  MarkView: Hk,
  Node: Ne,
  NodePos: zg,
  NodeView: Bk,
  PasteRule: Fa,
  ResizableNodeView: Vu,
  ResizableNodeview: Ik,
  Tracker: jk,
  callOrReturn: Te,
  canInsertNode: Vg,
  combineTransactionSteps: Ou,
  commands: Eu,
  createAtomBlockMarkdownSpec: Wg,
  createBlockMarkdownSpec: Ug,
  createChainableState: Ts,
  createDocument: Bo,
  createElement: Bh,
  createInlineMarkdownSpec: Kg,
  createNodeFromContent: mr,
  createStyleTag: Hg,
  defaultBlockAt: ag,
  deleteProps: Ec,
  elementFromString: Qi,
  escapeForRegEx: Pk,
  extensions: Cg,
  findChildren: Qw,
  findChildrenInRange: lg,
  findDuplicates: dg,
  findParentNode: Hi,
  findParentNodeClosestToPos: Nu,
  flattenExtensions: Ia,
  fromString: ug,
  generateHTML: ek,
  generateJSON: hg,
  generateText: tk,
  getAttributes: $u,
  getAttributesFromExtensions: Ru,
  getChangedRanges: zu,
  getDebugJSON: mg,
  getExtensionField: se,
  getHTMLFromFragment: Os,
  getMarkAttributes: Mu,
  getMarkRange: La,
  getMarkType: Rn,
  getMarksBetween: Ha,
  getNodeAtPosition: gg,
  getNodeAttributes: fg,
  getNodeType: Ze,
  getRenderedAttributes: vs,
  getSchema: $a,
  getSchemaByResolvedExtensions: Iu,
  getSchemaTypeByName: go,
  getSchemaTypeNameByName: Ms,
  getSplittedAttributes: es,
  getText: Du,
  getTextBetween: Pu,
  getTextContentFromNodes: _g,
  getTextSerializersFromSchema: za,
  h: Bh,
  injectExtensionAttributesToParseRule: Cc,
  inputRulesPlugin: wg,
  isActive: bg,
  isAndroid: Ra,
  isAtEndOfNode: vg,
  isAtStartOfNode: yg,
  isEmptyObject: cg,
  isExtensionRulesEnabled: Tc,
  isFunction: Lu,
  isList: Ac,
  isMacOS: Au,
  isMarkActive: Fo,
  isNodeActive: Gn,
  isNodeEmpty: Ns,
  isNodeSelection: Hu,
  isNumber: Sg,
  isPlainObject: Ur,
  isRegExp: Na,
  isString: Dk,
  isTextSelection: Cu,
  isiOS: xr,
  markInputRule: _r,
  markPasteRule: Di,
  markdown: jg,
  mergeAttributes: Ee,
  mergeDeep: Bu,
  minMax: Mn,
  nodeInputRule: Fu,
  nodePasteRule: Fk,
  objectIncludes: bs,
  parseAttributes: ja,
  parseIndentedBlocks: Vo,
  pasteRulesPlugin: Eg,
  posToDOMRect: ik,
  removeDuplicates: pg,
  renderNestedMarkdownContent: Ua,
  resolveExtensions: Da,
  resolveFocusPosition: Tu,
  rewriteUnknownContent: rk,
  selectionToInsertionEnd: og,
  serializeAttributes: Wa,
  sortExtensions: Pa,
  splitExtensions: gr,
  textInputRule: Nk,
  textPasteRule: Vk,
  textblockTypeInputRule: Fg,
  updateMarkViewAttributes: ju,
  wrappingInputRule: Pi
}, Symbol.toStringTag, { value: "Module" }));
var Fh = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Uk(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var kl = { exports: {} }, Lr = {}, Gs = { exports: {} }, Sl = {}, El = {}, Vh;
function Wu() {
  if (Vh) return El;
  Vh = 1;
  function n(i) {
    this.__parent = i, this.__character_count = 0, this.__indent_count = -1, this.__alignment_count = 0, this.__wrap_point_index = 0, this.__wrap_point_character_count = 0, this.__wrap_point_indent_count = -1, this.__wrap_point_alignment_count = 0, this.__items = [];
  }
  n.prototype.clone_empty = function() {
    var i = new n(this.__parent);
    return i.set_indent(this.__indent_count, this.__alignment_count), i;
  }, n.prototype.item = function(i) {
    return i < 0 ? this.__items[this.__items.length + i] : this.__items[i];
  }, n.prototype.has_match = function(i) {
    for (var r = this.__items.length - 1; r >= 0; r--)
      if (this.__items[r].match(i))
        return !0;
    return !1;
  }, n.prototype.set_indent = function(i, r) {
    this.is_empty() && (this.__indent_count = i || 0, this.__alignment_count = r || 0, this.__character_count = this.__parent.get_indent_size(this.__indent_count, this.__alignment_count));
  }, n.prototype._set_wrap_point = function() {
    this.__parent.wrap_line_length && (this.__wrap_point_index = this.__items.length, this.__wrap_point_character_count = this.__character_count, this.__wrap_point_indent_count = this.__parent.next_line.__indent_count, this.__wrap_point_alignment_count = this.__parent.next_line.__alignment_count);
  }, n.prototype._should_wrap = function() {
    return this.__wrap_point_index && this.__character_count > this.__parent.wrap_line_length && this.__wrap_point_character_count > this.__parent.next_line.__character_count;
  }, n.prototype._allow_wrap = function() {
    if (this._should_wrap()) {
      this.__parent.add_new_line();
      var i = this.__parent.current_line;
      return i.set_indent(this.__wrap_point_indent_count, this.__wrap_point_alignment_count), i.__items = this.__items.slice(this.__wrap_point_index), this.__items = this.__items.slice(0, this.__wrap_point_index), i.__character_count += this.__character_count - this.__wrap_point_character_count, this.__character_count = this.__wrap_point_character_count, i.__items[0] === " " && (i.__items.splice(0, 1), i.__character_count -= 1), !0;
    }
    return !1;
  }, n.prototype.is_empty = function() {
    return this.__items.length === 0;
  }, n.prototype.last = function() {
    return this.is_empty() ? null : this.__items[this.__items.length - 1];
  }, n.prototype.push = function(i) {
    this.__items.push(i);
    var r = i.lastIndexOf(`
`);
    r !== -1 ? this.__character_count = i.length - r : this.__character_count += i.length;
  }, n.prototype.pop = function() {
    var i = null;
    return this.is_empty() || (i = this.__items.pop(), this.__character_count -= i.length), i;
  }, n.prototype._remove_indent = function() {
    this.__indent_count > 0 && (this.__indent_count -= 1, this.__character_count -= this.__parent.indent_size);
  }, n.prototype._remove_wrap_indent = function() {
    this.__wrap_point_indent_count > 0 && (this.__wrap_point_indent_count -= 1);
  }, n.prototype.trim = function() {
    for (; this.last() === " "; )
      this.__items.pop(), this.__character_count -= 1;
  }, n.prototype.toString = function() {
    var i = "";
    return this.is_empty() ? this.__parent.indent_empty_lines && (i = this.__parent.get_indent_string(this.__indent_count)) : (i = this.__parent.get_indent_string(this.__indent_count, this.__alignment_count), i += this.__items.join("")), i;
  };
  function e(i, r) {
    this.__cache = [""], this.__indent_size = i.indent_size, this.__indent_string = i.indent_char, i.indent_with_tabs || (this.__indent_string = new Array(i.indent_size + 1).join(i.indent_char)), r = r || "", i.indent_level > 0 && (r = new Array(i.indent_level + 1).join(this.__indent_string)), this.__base_string = r, this.__base_string_length = r.length;
  }
  e.prototype.get_indent_size = function(i, r) {
    var s = this.__base_string_length;
    return r = r || 0, i < 0 && (s = 0), s += i * this.__indent_size, s += r, s;
  }, e.prototype.get_indent_string = function(i, r) {
    var s = this.__base_string;
    return r = r || 0, i < 0 && (i = 0, s = ""), r += i * this.__indent_size, this.__ensure_cache(r), s += this.__cache[r], s;
  }, e.prototype.__ensure_cache = function(i) {
    for (; i >= this.__cache.length; )
      this.__add_column();
  }, e.prototype.__add_column = function() {
    var i = this.__cache.length, r = 0, s = "";
    this.__indent_size && i >= this.__indent_size && (r = Math.floor(i / this.__indent_size), i -= r * this.__indent_size, s = new Array(r + 1).join(this.__indent_string)), i && (s += new Array(i + 1).join(" ")), this.__cache.push(s);
  };
  function t(i, r) {
    this.__indent_cache = new e(i, r), this.raw = !1, this._end_with_newline = i.end_with_newline, this.indent_size = i.indent_size, this.wrap_line_length = i.wrap_line_length, this.indent_empty_lines = i.indent_empty_lines, this.__lines = [], this.previous_line = null, this.current_line = null, this.next_line = new n(this), this.space_before_token = !1, this.non_breaking_space = !1, this.previous_token_wrapped = !1, this.__add_outputline();
  }
  return t.prototype.__add_outputline = function() {
    this.previous_line = this.current_line, this.current_line = this.next_line.clone_empty(), this.__lines.push(this.current_line);
  }, t.prototype.get_line_number = function() {
    return this.__lines.length;
  }, t.prototype.get_indent_string = function(i, r) {
    return this.__indent_cache.get_indent_string(i, r);
  }, t.prototype.get_indent_size = function(i, r) {
    return this.__indent_cache.get_indent_size(i, r);
  }, t.prototype.is_empty = function() {
    return !this.previous_line && this.current_line.is_empty();
  }, t.prototype.add_new_line = function(i) {
    return this.is_empty() || !i && this.just_added_newline() ? !1 : (this.raw || this.__add_outputline(), !0);
  }, t.prototype.get_code = function(i) {
    this.trim(!0);
    var r = this.current_line.pop();
    r && (r[r.length - 1] === `
` && (r = r.replace(/\n+$/g, "")), this.current_line.push(r)), this._end_with_newline && this.__add_outputline();
    var s = this.__lines.join(`
`);
    return i !== `
` && (s = s.replace(/[\n]/g, i)), s;
  }, t.prototype.set_wrap_point = function() {
    this.current_line._set_wrap_point();
  }, t.prototype.set_indent = function(i, r) {
    return i = i || 0, r = r || 0, this.next_line.set_indent(i, r), this.__lines.length > 1 ? (this.current_line.set_indent(i, r), !0) : (this.current_line.set_indent(), !1);
  }, t.prototype.add_raw_token = function(i) {
    for (var r = 0; r < i.newlines; r++)
      this.__add_outputline();
    this.current_line.set_indent(-1), this.current_line.push(i.whitespace_before), this.current_line.push(i.text), this.space_before_token = !1, this.non_breaking_space = !1, this.previous_token_wrapped = !1;
  }, t.prototype.add_token = function(i) {
    this.__add_space_before_token(), this.current_line.push(i), this.space_before_token = !1, this.non_breaking_space = !1, this.previous_token_wrapped = this.current_line._allow_wrap();
  }, t.prototype.__add_space_before_token = function() {
    this.space_before_token && !this.just_added_newline() && (this.non_breaking_space || this.set_wrap_point(), this.current_line.push(" "));
  }, t.prototype.remove_indent = function(i) {
    for (var r = this.__lines.length; i < r; )
      this.__lines[i]._remove_indent(), i++;
    this.current_line._remove_wrap_indent();
  }, t.prototype.trim = function(i) {
    for (i = i === void 0 ? !1 : i, this.current_line.trim(); i && this.__lines.length > 1 && this.current_line.is_empty(); )
      this.__lines.pop(), this.current_line = this.__lines[this.__lines.length - 1], this.current_line.trim();
    this.previous_line = this.__lines.length > 1 ? this.__lines[this.__lines.length - 2] : null;
  }, t.prototype.just_added_newline = function() {
    return this.current_line.is_empty();
  }, t.prototype.just_added_blankline = function() {
    return this.is_empty() || this.current_line.is_empty() && this.previous_line.is_empty();
  }, t.prototype.ensure_empty_line_above = function(i, r) {
    for (var s = this.__lines.length - 2; s >= 0; ) {
      var o = this.__lines[s];
      if (o.is_empty())
        break;
      if (o.item(0).indexOf(i) !== 0 && o.item(-1) !== r) {
        this.__lines.splice(s + 1, 0, new n(this)), this.previous_line = this.__lines[this.__lines.length - 2];
        break;
      }
      s--;
    }
  }, El.Output = t, El;
}
var Cl = {}, jh;
function Gg() {
  if (jh) return Cl;
  jh = 1;
  function n(e, t, i, r) {
    this.type = e, this.text = t, this.comments_before = null, this.newlines = i || 0, this.whitespace_before = r || "", this.parent = null, this.next = null, this.previous = null, this.opened = null, this.closed = null, this.directives = null;
  }
  return Cl.Token = n, Cl;
}
var Tl = {}, Wh;
function Jg() {
  return Wh || (Wh = 1, function(n) {
    var e = "\\x23\\x24\\x40\\x41-\\x5a\\x5f\\x61-\\x7a", t = "\\x24\\x30-\\x39\\x41-\\x5a\\x5f\\x61-\\x7a", i = "\\xaa\\xb5\\xba\\xc0-\\xd6\\xd8-\\xf6\\xf8-\\u02c1\\u02c6-\\u02d1\\u02e0-\\u02e4\\u02ec\\u02ee\\u0370-\\u0374\\u0376\\u0377\\u037a-\\u037d\\u0386\\u0388-\\u038a\\u038c\\u038e-\\u03a1\\u03a3-\\u03f5\\u03f7-\\u0481\\u048a-\\u0527\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u05d0-\\u05ea\\u05f0-\\u05f2\\u0620-\\u064a\\u066e\\u066f\\u0671-\\u06d3\\u06d5\\u06e5\\u06e6\\u06ee\\u06ef\\u06fa-\\u06fc\\u06ff\\u0710\\u0712-\\u072f\\u074d-\\u07a5\\u07b1\\u07ca-\\u07ea\\u07f4\\u07f5\\u07fa\\u0800-\\u0815\\u081a\\u0824\\u0828\\u0840-\\u0858\\u08a0\\u08a2-\\u08ac\\u0904-\\u0939\\u093d\\u0950\\u0958-\\u0961\\u0971-\\u0977\\u0979-\\u097f\\u0985-\\u098c\\u098f\\u0990\\u0993-\\u09a8\\u09aa-\\u09b0\\u09b2\\u09b6-\\u09b9\\u09bd\\u09ce\\u09dc\\u09dd\\u09df-\\u09e1\\u09f0\\u09f1\\u0a05-\\u0a0a\\u0a0f\\u0a10\\u0a13-\\u0a28\\u0a2a-\\u0a30\\u0a32\\u0a33\\u0a35\\u0a36\\u0a38\\u0a39\\u0a59-\\u0a5c\\u0a5e\\u0a72-\\u0a74\\u0a85-\\u0a8d\\u0a8f-\\u0a91\\u0a93-\\u0aa8\\u0aaa-\\u0ab0\\u0ab2\\u0ab3\\u0ab5-\\u0ab9\\u0abd\\u0ad0\\u0ae0\\u0ae1\\u0b05-\\u0b0c\\u0b0f\\u0b10\\u0b13-\\u0b28\\u0b2a-\\u0b30\\u0b32\\u0b33\\u0b35-\\u0b39\\u0b3d\\u0b5c\\u0b5d\\u0b5f-\\u0b61\\u0b71\\u0b83\\u0b85-\\u0b8a\\u0b8e-\\u0b90\\u0b92-\\u0b95\\u0b99\\u0b9a\\u0b9c\\u0b9e\\u0b9f\\u0ba3\\u0ba4\\u0ba8-\\u0baa\\u0bae-\\u0bb9\\u0bd0\\u0c05-\\u0c0c\\u0c0e-\\u0c10\\u0c12-\\u0c28\\u0c2a-\\u0c33\\u0c35-\\u0c39\\u0c3d\\u0c58\\u0c59\\u0c60\\u0c61\\u0c85-\\u0c8c\\u0c8e-\\u0c90\\u0c92-\\u0ca8\\u0caa-\\u0cb3\\u0cb5-\\u0cb9\\u0cbd\\u0cde\\u0ce0\\u0ce1\\u0cf1\\u0cf2\\u0d05-\\u0d0c\\u0d0e-\\u0d10\\u0d12-\\u0d3a\\u0d3d\\u0d4e\\u0d60\\u0d61\\u0d7a-\\u0d7f\\u0d85-\\u0d96\\u0d9a-\\u0db1\\u0db3-\\u0dbb\\u0dbd\\u0dc0-\\u0dc6\\u0e01-\\u0e30\\u0e32\\u0e33\\u0e40-\\u0e46\\u0e81\\u0e82\\u0e84\\u0e87\\u0e88\\u0e8a\\u0e8d\\u0e94-\\u0e97\\u0e99-\\u0e9f\\u0ea1-\\u0ea3\\u0ea5\\u0ea7\\u0eaa\\u0eab\\u0ead-\\u0eb0\\u0eb2\\u0eb3\\u0ebd\\u0ec0-\\u0ec4\\u0ec6\\u0edc-\\u0edf\\u0f00\\u0f40-\\u0f47\\u0f49-\\u0f6c\\u0f88-\\u0f8c\\u1000-\\u102a\\u103f\\u1050-\\u1055\\u105a-\\u105d\\u1061\\u1065\\u1066\\u106e-\\u1070\\u1075-\\u1081\\u108e\\u10a0-\\u10c5\\u10c7\\u10cd\\u10d0-\\u10fa\\u10fc-\\u1248\\u124a-\\u124d\\u1250-\\u1256\\u1258\\u125a-\\u125d\\u1260-\\u1288\\u128a-\\u128d\\u1290-\\u12b0\\u12b2-\\u12b5\\u12b8-\\u12be\\u12c0\\u12c2-\\u12c5\\u12c8-\\u12d6\\u12d8-\\u1310\\u1312-\\u1315\\u1318-\\u135a\\u1380-\\u138f\\u13a0-\\u13f4\\u1401-\\u166c\\u166f-\\u167f\\u1681-\\u169a\\u16a0-\\u16ea\\u16ee-\\u16f0\\u1700-\\u170c\\u170e-\\u1711\\u1720-\\u1731\\u1740-\\u1751\\u1760-\\u176c\\u176e-\\u1770\\u1780-\\u17b3\\u17d7\\u17dc\\u1820-\\u1877\\u1880-\\u18a8\\u18aa\\u18b0-\\u18f5\\u1900-\\u191c\\u1950-\\u196d\\u1970-\\u1974\\u1980-\\u19ab\\u19c1-\\u19c7\\u1a00-\\u1a16\\u1a20-\\u1a54\\u1aa7\\u1b05-\\u1b33\\u1b45-\\u1b4b\\u1b83-\\u1ba0\\u1bae\\u1baf\\u1bba-\\u1be5\\u1c00-\\u1c23\\u1c4d-\\u1c4f\\u1c5a-\\u1c7d\\u1ce9-\\u1cec\\u1cee-\\u1cf1\\u1cf5\\u1cf6\\u1d00-\\u1dbf\\u1e00-\\u1f15\\u1f18-\\u1f1d\\u1f20-\\u1f45\\u1f48-\\u1f4d\\u1f50-\\u1f57\\u1f59\\u1f5b\\u1f5d\\u1f5f-\\u1f7d\\u1f80-\\u1fb4\\u1fb6-\\u1fbc\\u1fbe\\u1fc2-\\u1fc4\\u1fc6-\\u1fcc\\u1fd0-\\u1fd3\\u1fd6-\\u1fdb\\u1fe0-\\u1fec\\u1ff2-\\u1ff4\\u1ff6-\\u1ffc\\u2071\\u207f\\u2090-\\u209c\\u2102\\u2107\\u210a-\\u2113\\u2115\\u2119-\\u211d\\u2124\\u2126\\u2128\\u212a-\\u212d\\u212f-\\u2139\\u213c-\\u213f\\u2145-\\u2149\\u214e\\u2160-\\u2188\\u2c00-\\u2c2e\\u2c30-\\u2c5e\\u2c60-\\u2ce4\\u2ceb-\\u2cee\\u2cf2\\u2cf3\\u2d00-\\u2d25\\u2d27\\u2d2d\\u2d30-\\u2d67\\u2d6f\\u2d80-\\u2d96\\u2da0-\\u2da6\\u2da8-\\u2dae\\u2db0-\\u2db6\\u2db8-\\u2dbe\\u2dc0-\\u2dc6\\u2dc8-\\u2dce\\u2dd0-\\u2dd6\\u2dd8-\\u2dde\\u2e2f\\u3005-\\u3007\\u3021-\\u3029\\u3031-\\u3035\\u3038-\\u303c\\u3041-\\u3096\\u309d-\\u309f\\u30a1-\\u30fa\\u30fc-\\u30ff\\u3105-\\u312d\\u3131-\\u318e\\u31a0-\\u31ba\\u31f0-\\u31ff\\u3400-\\u4db5\\u4e00-\\u9fcc\\ua000-\\ua48c\\ua4d0-\\ua4fd\\ua500-\\ua60c\\ua610-\\ua61f\\ua62a\\ua62b\\ua640-\\ua66e\\ua67f-\\ua697\\ua6a0-\\ua6ef\\ua717-\\ua71f\\ua722-\\ua788\\ua78b-\\ua78e\\ua790-\\ua793\\ua7a0-\\ua7aa\\ua7f8-\\ua801\\ua803-\\ua805\\ua807-\\ua80a\\ua80c-\\ua822\\ua840-\\ua873\\ua882-\\ua8b3\\ua8f2-\\ua8f7\\ua8fb\\ua90a-\\ua925\\ua930-\\ua946\\ua960-\\ua97c\\ua984-\\ua9b2\\ua9cf\\uaa00-\\uaa28\\uaa40-\\uaa42\\uaa44-\\uaa4b\\uaa60-\\uaa76\\uaa7a\\uaa80-\\uaaaf\\uaab1\\uaab5\\uaab6\\uaab9-\\uaabd\\uaac0\\uaac2\\uaadb-\\uaadd\\uaae0-\\uaaea\\uaaf2-\\uaaf4\\uab01-\\uab06\\uab09-\\uab0e\\uab11-\\uab16\\uab20-\\uab26\\uab28-\\uab2e\\uabc0-\\uabe2\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\uf900-\\ufa6d\\ufa70-\\ufad9\\ufb00-\\ufb06\\ufb13-\\ufb17\\ufb1d\\ufb1f-\\ufb28\\ufb2a-\\ufb36\\ufb38-\\ufb3c\\ufb3e\\ufb40\\ufb41\\ufb43\\ufb44\\ufb46-\\ufbb1\\ufbd3-\\ufd3d\\ufd50-\\ufd8f\\ufd92-\\ufdc7\\ufdf0-\\ufdfb\\ufe70-\\ufe74\\ufe76-\\ufefc\\uff21-\\uff3a\\uff41-\\uff5a\\uff66-\\uffbe\\uffc2-\\uffc7\\uffca-\\uffcf\\uffd2-\\uffd7\\uffda-\\uffdc", r = "\\u0300-\\u036f\\u0483-\\u0487\\u0591-\\u05bd\\u05bf\\u05c1\\u05c2\\u05c4\\u05c5\\u05c7\\u0610-\\u061a\\u0620-\\u0649\\u0672-\\u06d3\\u06e7-\\u06e8\\u06fb-\\u06fc\\u0730-\\u074a\\u0800-\\u0814\\u081b-\\u0823\\u0825-\\u0827\\u0829-\\u082d\\u0840-\\u0857\\u08e4-\\u08fe\\u0900-\\u0903\\u093a-\\u093c\\u093e-\\u094f\\u0951-\\u0957\\u0962-\\u0963\\u0966-\\u096f\\u0981-\\u0983\\u09bc\\u09be-\\u09c4\\u09c7\\u09c8\\u09d7\\u09df-\\u09e0\\u0a01-\\u0a03\\u0a3c\\u0a3e-\\u0a42\\u0a47\\u0a48\\u0a4b-\\u0a4d\\u0a51\\u0a66-\\u0a71\\u0a75\\u0a81-\\u0a83\\u0abc\\u0abe-\\u0ac5\\u0ac7-\\u0ac9\\u0acb-\\u0acd\\u0ae2-\\u0ae3\\u0ae6-\\u0aef\\u0b01-\\u0b03\\u0b3c\\u0b3e-\\u0b44\\u0b47\\u0b48\\u0b4b-\\u0b4d\\u0b56\\u0b57\\u0b5f-\\u0b60\\u0b66-\\u0b6f\\u0b82\\u0bbe-\\u0bc2\\u0bc6-\\u0bc8\\u0bca-\\u0bcd\\u0bd7\\u0be6-\\u0bef\\u0c01-\\u0c03\\u0c46-\\u0c48\\u0c4a-\\u0c4d\\u0c55\\u0c56\\u0c62-\\u0c63\\u0c66-\\u0c6f\\u0c82\\u0c83\\u0cbc\\u0cbe-\\u0cc4\\u0cc6-\\u0cc8\\u0cca-\\u0ccd\\u0cd5\\u0cd6\\u0ce2-\\u0ce3\\u0ce6-\\u0cef\\u0d02\\u0d03\\u0d46-\\u0d48\\u0d57\\u0d62-\\u0d63\\u0d66-\\u0d6f\\u0d82\\u0d83\\u0dca\\u0dcf-\\u0dd4\\u0dd6\\u0dd8-\\u0ddf\\u0df2\\u0df3\\u0e34-\\u0e3a\\u0e40-\\u0e45\\u0e50-\\u0e59\\u0eb4-\\u0eb9\\u0ec8-\\u0ecd\\u0ed0-\\u0ed9\\u0f18\\u0f19\\u0f20-\\u0f29\\u0f35\\u0f37\\u0f39\\u0f41-\\u0f47\\u0f71-\\u0f84\\u0f86-\\u0f87\\u0f8d-\\u0f97\\u0f99-\\u0fbc\\u0fc6\\u1000-\\u1029\\u1040-\\u1049\\u1067-\\u106d\\u1071-\\u1074\\u1082-\\u108d\\u108f-\\u109d\\u135d-\\u135f\\u170e-\\u1710\\u1720-\\u1730\\u1740-\\u1750\\u1772\\u1773\\u1780-\\u17b2\\u17dd\\u17e0-\\u17e9\\u180b-\\u180d\\u1810-\\u1819\\u1920-\\u192b\\u1930-\\u193b\\u1951-\\u196d\\u19b0-\\u19c0\\u19c8-\\u19c9\\u19d0-\\u19d9\\u1a00-\\u1a15\\u1a20-\\u1a53\\u1a60-\\u1a7c\\u1a7f-\\u1a89\\u1a90-\\u1a99\\u1b46-\\u1b4b\\u1b50-\\u1b59\\u1b6b-\\u1b73\\u1bb0-\\u1bb9\\u1be6-\\u1bf3\\u1c00-\\u1c22\\u1c40-\\u1c49\\u1c5b-\\u1c7d\\u1cd0-\\u1cd2\\u1d00-\\u1dbe\\u1e01-\\u1f15\\u200c\\u200d\\u203f\\u2040\\u2054\\u20d0-\\u20dc\\u20e1\\u20e5-\\u20f0\\u2d81-\\u2d96\\u2de0-\\u2dff\\u3021-\\u3028\\u3099\\u309a\\ua640-\\ua66d\\ua674-\\ua67d\\ua69f\\ua6f0-\\ua6f1\\ua7f8-\\ua800\\ua806\\ua80b\\ua823-\\ua827\\ua880-\\ua881\\ua8b4-\\ua8c4\\ua8d0-\\ua8d9\\ua8f3-\\ua8f7\\ua900-\\ua909\\ua926-\\ua92d\\ua930-\\ua945\\ua980-\\ua983\\ua9b3-\\ua9c0\\uaa00-\\uaa27\\uaa40-\\uaa41\\uaa4c-\\uaa4d\\uaa50-\\uaa59\\uaa7b\\uaae0-\\uaae9\\uaaf2-\\uaaf3\\uabc0-\\uabe1\\uabec\\uabed\\uabf0-\\uabf9\\ufb20-\\ufb28\\ufe00-\\ufe0f\\ufe20-\\ufe26\\ufe33\\ufe34\\ufe4d-\\ufe4f\\uff10-\\uff19\\uff3f", s = "\\\\u[0-9a-fA-F]{4}|\\\\u\\{[0-9a-fA-F]+\\}", o = "(?:" + s + "|[" + e + i + "])", a = "(?:" + s + "|[" + t + i + r + "])*";
    n.identifier = new RegExp(o + a, "g"), n.identifierStart = new RegExp(o), n.identifierMatch = new RegExp("(?:" + s + "|[" + t + i + r + "])+"), n.newline = /[\n\r\u2028\u2029]/, n.lineBreak = new RegExp(`\r
|` + n.newline.source), n.allLineBreaks = new RegExp(n.lineBreak.source, "g");
  }(Tl)), Tl;
}
var Al = {}, Rr = {}, Uh;
function Uu() {
  if (Uh) return Rr;
  Uh = 1;
  function n(i, r) {
    this.raw_options = e(i, r), this.disabled = this._get_boolean("disabled"), this.eol = this._get_characters("eol", "auto"), this.end_with_newline = this._get_boolean("end_with_newline"), this.indent_size = this._get_number("indent_size", 4), this.indent_char = this._get_characters("indent_char", " "), this.indent_level = this._get_number("indent_level"), this.preserve_newlines = this._get_boolean("preserve_newlines", !0), this.max_preserve_newlines = this._get_number("max_preserve_newlines", 32786), this.preserve_newlines || (this.max_preserve_newlines = 0), this.indent_with_tabs = this._get_boolean("indent_with_tabs", this.indent_char === "	"), this.indent_with_tabs && (this.indent_char = "	", this.indent_size === 1 && (this.indent_size = 4)), this.wrap_line_length = this._get_number("wrap_line_length", this._get_number("max_char")), this.indent_empty_lines = this._get_boolean("indent_empty_lines"), this.templating = this._get_selection_list("templating", ["auto", "none", "angular", "django", "erb", "handlebars", "php", "smarty"], ["auto"]);
  }
  n.prototype._get_array = function(i, r) {
    var s = this.raw_options[i], o = r || [];
    return typeof s == "object" ? s !== null && typeof s.concat == "function" && (o = s.concat()) : typeof s == "string" && (o = s.split(/[^a-zA-Z0-9_\/\-]+/)), o;
  }, n.prototype._get_boolean = function(i, r) {
    var s = this.raw_options[i], o = s === void 0 ? !!r : !!s;
    return o;
  }, n.prototype._get_characters = function(i, r) {
    var s = this.raw_options[i], o = r || "";
    return typeof s == "string" && (o = s.replace(/\\r/, "\r").replace(/\\n/, `
`).replace(/\\t/, "	")), o;
  }, n.prototype._get_number = function(i, r) {
    var s = this.raw_options[i];
    r = parseInt(r, 10), isNaN(r) && (r = 0);
    var o = parseInt(s, 10);
    return isNaN(o) && (o = r), o;
  }, n.prototype._get_selection = function(i, r, s) {
    var o = this._get_selection_list(i, r, s);
    if (o.length !== 1)
      throw new Error(
        "Invalid Option Value: The option '" + i + `' can only be one of the following values:
` + r + `
You passed in: '` + this.raw_options[i] + "'"
      );
    return o[0];
  }, n.prototype._get_selection_list = function(i, r, s) {
    if (!r || r.length === 0)
      throw new Error("Selection list cannot be empty.");
    if (s = s || [r[0]], !this._is_valid_selection(s, r))
      throw new Error("Invalid Default Value!");
    var o = this._get_array(i, s);
    if (!this._is_valid_selection(o, r))
      throw new Error(
        "Invalid Option Value: The option '" + i + `' can contain only the following values:
` + r + `
You passed in: '` + this.raw_options[i] + "'"
      );
    return o;
  }, n.prototype._is_valid_selection = function(i, r) {
    return i.length && r.length && !i.some(function(s) {
      return r.indexOf(s) === -1;
    });
  };
  function e(i, r) {
    var s = {};
    i = t(i);
    var o;
    for (o in i)
      o !== r && (s[o] = i[o]);
    if (r && i[r])
      for (o in i[r])
        s[o] = i[r][o];
    return s;
  }
  function t(i) {
    var r = {}, s;
    for (s in i) {
      var o = s.replace(/-/g, "_");
      r[o] = i[s];
    }
    return r;
  }
  return Rr.Options = n, Rr.normalizeOpts = t, Rr.mergeOpts = e, Rr;
}
var Kh;
function Xg() {
  if (Kh) return Al;
  Kh = 1;
  var n = Uu().Options, e = ["before-newline", "after-newline", "preserve-newline"];
  function t(i) {
    n.call(this, i, "js");
    var r = this.raw_options.brace_style || null;
    r === "expand-strict" ? this.raw_options.brace_style = "expand" : r === "collapse-preserve-inline" ? this.raw_options.brace_style = "collapse,preserve-inline" : this.raw_options.braces_on_own_line !== void 0 && (this.raw_options.brace_style = this.raw_options.braces_on_own_line ? "expand" : "collapse");
    var s = this._get_selection_list("brace_style", ["collapse", "expand", "end-expand", "none", "preserve-inline"]);
    this.brace_preserve_inline = !1, this.brace_style = "collapse";
    for (var o = 0; o < s.length; o++)
      s[o] === "preserve-inline" ? this.brace_preserve_inline = !0 : this.brace_style = s[o];
    this.unindent_chained_methods = this._get_boolean("unindent_chained_methods"), this.break_chained_methods = this._get_boolean("break_chained_methods"), this.space_in_paren = this._get_boolean("space_in_paren"), this.space_in_empty_paren = this._get_boolean("space_in_empty_paren"), this.jslint_happy = this._get_boolean("jslint_happy"), this.space_after_anon_function = this._get_boolean("space_after_anon_function"), this.space_after_named_function = this._get_boolean("space_after_named_function"), this.keep_array_indentation = this._get_boolean("keep_array_indentation"), this.space_before_conditional = this._get_boolean("space_before_conditional", !0), this.unescape_strings = this._get_boolean("unescape_strings"), this.e4x = this._get_boolean("e4x"), this.comma_first = this._get_boolean("comma_first"), this.operator_position = this._get_selection("operator_position", e), this.test_output_raw = this._get_boolean("test_output_raw"), this.jslint_happy && (this.space_after_anon_function = !0);
  }
  return t.prototype = new n(), Al.Options = t, Al;
}
var qi = {}, Ml = {}, qh;
function Ku() {
  if (qh) return Ml;
  qh = 1;
  var n = RegExp.prototype.hasOwnProperty("sticky");
  function e(t) {
    this.__input = t || "", this.__input_length = this.__input.length, this.__position = 0;
  }
  return e.prototype.restart = function() {
    this.__position = 0;
  }, e.prototype.back = function() {
    this.__position > 0 && (this.__position -= 1);
  }, e.prototype.hasNext = function() {
    return this.__position < this.__input_length;
  }, e.prototype.next = function() {
    var t = null;
    return this.hasNext() && (t = this.__input.charAt(this.__position), this.__position += 1), t;
  }, e.prototype.peek = function(t) {
    var i = null;
    return t = t || 0, t += this.__position, t >= 0 && t < this.__input_length && (i = this.__input.charAt(t)), i;
  }, e.prototype.__match = function(t, i) {
    t.lastIndex = i;
    var r = t.exec(this.__input);
    return r && !(n && t.sticky) && r.index !== i && (r = null), r;
  }, e.prototype.test = function(t, i) {
    return i = i || 0, i += this.__position, i >= 0 && i < this.__input_length ? !!this.__match(t, i) : !1;
  }, e.prototype.testChar = function(t, i) {
    var r = this.peek(i);
    return t.lastIndex = 0, r !== null && t.test(r);
  }, e.prototype.match = function(t) {
    var i = this.__match(t, this.__position);
    return i ? this.__position += i[0].length : i = null, i;
  }, e.prototype.read = function(t, i, r) {
    var s = "", o;
    return t && (o = this.match(t), o && (s += o[0])), i && (o || !t) && (s += this.readUntil(i, r)), s;
  }, e.prototype.readUntil = function(t, i) {
    var r = "", s = this.__position;
    t.lastIndex = this.__position;
    var o = t.exec(this.__input);
    return o ? (s = o.index, i && (s += o[0].length)) : s = this.__input_length, r = this.__input.substring(this.__position, s), this.__position = s, r;
  }, e.prototype.readUntilAfter = function(t) {
    return this.readUntil(t, !0);
  }, e.prototype.get_regexp = function(t, i) {
    var r = null, s = "g";
    return i && n && (s = "y"), typeof t == "string" && t !== "" ? r = new RegExp(t, s) : t && (r = new RegExp(t.source, s)), r;
  }, e.prototype.get_literal_regexp = function(t) {
    return RegExp(t.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"));
  }, e.prototype.peekUntilAfter = function(t) {
    var i = this.__position, r = this.readUntilAfter(t);
    return this.__position = i, r;
  }, e.prototype.lookBack = function(t) {
    var i = this.__position - 1;
    return i >= t.length && this.__input.substring(i - t.length, i).toLowerCase() === t;
  }, Ml.InputScanner = e, Ml;
}
var Js = {}, Ol = {}, Gh;
function Kk() {
  if (Gh) return Ol;
  Gh = 1;
  function n(e) {
    this.__tokens = [], this.__tokens_length = this.__tokens.length, this.__position = 0, this.__parent_token = e;
  }
  return n.prototype.restart = function() {
    this.__position = 0;
  }, n.prototype.isEmpty = function() {
    return this.__tokens_length === 0;
  }, n.prototype.hasNext = function() {
    return this.__position < this.__tokens_length;
  }, n.prototype.next = function() {
    var e = null;
    return this.hasNext() && (e = this.__tokens[this.__position], this.__position += 1), e;
  }, n.prototype.peek = function(e) {
    var t = null;
    return e = e || 0, e += this.__position, e >= 0 && e < this.__tokens_length && (t = this.__tokens[e]), t;
  }, n.prototype.add = function(e) {
    this.__parent_token && (e.parent = this.__parent_token), this.__tokens.push(e), this.__tokens_length += 1;
  }, Ol.TokenStream = n, Ol;
}
var Nl = {}, Ll = {}, Jh;
function Ka() {
  if (Jh) return Ll;
  Jh = 1;
  function n(e, t) {
    this._input = e, this._starting_pattern = null, this._match_pattern = null, this._until_pattern = null, this._until_after = !1, t && (this._starting_pattern = this._input.get_regexp(t._starting_pattern, !0), this._match_pattern = this._input.get_regexp(t._match_pattern, !0), this._until_pattern = this._input.get_regexp(t._until_pattern), this._until_after = t._until_after);
  }
  return n.prototype.read = function() {
    var e = this._input.read(this._starting_pattern);
    return (!this._starting_pattern || e) && (e += this._input.read(this._match_pattern, this._until_pattern, this._until_after)), e;
  }, n.prototype.read_match = function() {
    return this._input.match(this._match_pattern);
  }, n.prototype.until_after = function(e) {
    var t = this._create();
    return t._until_after = !0, t._until_pattern = this._input.get_regexp(e), t._update(), t;
  }, n.prototype.until = function(e) {
    var t = this._create();
    return t._until_after = !1, t._until_pattern = this._input.get_regexp(e), t._update(), t;
  }, n.prototype.starting_with = function(e) {
    var t = this._create();
    return t._starting_pattern = this._input.get_regexp(e, !0), t._update(), t;
  }, n.prototype.matching = function(e) {
    var t = this._create();
    return t._match_pattern = this._input.get_regexp(e, !0), t._update(), t;
  }, n.prototype._create = function() {
    return new n(this._input, this);
  }, n.prototype._update = function() {
  }, Ll.Pattern = n, Ll;
}
var Xh;
function qk() {
  if (Xh) return Nl;
  Xh = 1;
  var n = Ka().Pattern;
  function e(t, i) {
    n.call(this, t, i), i ? this._line_regexp = this._input.get_regexp(i._line_regexp) : this.__set_whitespace_patterns("", ""), this.newline_count = 0, this.whitespace_before_token = "";
  }
  return e.prototype = new n(), e.prototype.__set_whitespace_patterns = function(t, i) {
    t += "\\t ", i += "\\n\\r", this._match_pattern = this._input.get_regexp(
      "[" + t + i + "]+",
      !0
    ), this._newline_regexp = this._input.get_regexp(
      "\\r\\n|[" + i + "]"
    );
  }, e.prototype.read = function() {
    this.newline_count = 0, this.whitespace_before_token = "";
    var t = this._input.read(this._match_pattern);
    if (t === " ")
      this.whitespace_before_token = " ";
    else if (t) {
      var i = this.__split(this._newline_regexp, t);
      this.newline_count = i.length - 1, this.whitespace_before_token = i[this.newline_count];
    }
    return t;
  }, e.prototype.matching = function(t, i) {
    var r = this._create();
    return r.__set_whitespace_patterns(t, i), r._update(), r;
  }, e.prototype._create = function() {
    return new e(this._input, this);
  }, e.prototype.__split = function(t, i) {
    t.lastIndex = 0;
    for (var r = 0, s = [], o = t.exec(i); o; )
      s.push(i.substring(r, o.index)), r = o.index + o[0].length, o = t.exec(i);
    return r < i.length ? s.push(i.substring(r, i.length)) : s.push(""), s;
  }, Nl.WhitespacePattern = e, Nl;
}
var Yh;
function jo() {
  if (Yh) return Js;
  Yh = 1;
  var n = Ku().InputScanner, e = Gg().Token, t = Kk().TokenStream, i = qk().WhitespacePattern, r = {
    START: "TK_START",
    RAW: "TK_RAW",
    EOF: "TK_EOF"
  }, s = function(o, a) {
    this._input = new n(o), this._options = a || {}, this.__tokens = null, this._patterns = {}, this._patterns.whitespace = new i(this._input);
  };
  return s.prototype.tokenize = function() {
    this._input.restart(), this.__tokens = new t(), this._reset();
    for (var o, a = new e(r.START, ""), l = null, c = [], u = new t(); a.type !== r.EOF; ) {
      for (o = this._get_next_token(a, l); this._is_comment(o); )
        u.add(o), o = this._get_next_token(a, l);
      u.isEmpty() || (o.comments_before = u, u = new t()), o.parent = l, this._is_opening(o) ? (c.push(l), l = o) : l && this._is_closing(o, l) && (o.opened = l, l.closed = o, l = c.pop(), o.parent = l), o.previous = a, a.next = o, this.__tokens.add(o), a = o;
    }
    return this.__tokens;
  }, s.prototype._is_first_token = function() {
    return this.__tokens.isEmpty();
  }, s.prototype._reset = function() {
  }, s.prototype._get_next_token = function(o, a) {
    this._readWhitespace();
    var l = this._input.read(/.+/g);
    return l ? this._create_token(r.RAW, l) : this._create_token(r.EOF, "");
  }, s.prototype._is_comment = function(o) {
    return !1;
  }, s.prototype._is_opening = function(o) {
    return !1;
  }, s.prototype._is_closing = function(o, a) {
    return !1;
  }, s.prototype._create_token = function(o, a) {
    var l = new e(
      o,
      a,
      this._patterns.whitespace.newline_count,
      this._patterns.whitespace.whitespace_before_token
    );
    return l;
  }, s.prototype._readWhitespace = function() {
    return this._patterns.whitespace.read();
  }, Js.Tokenizer = s, Js.TOKEN = r, Js;
}
var Rl = {}, Zh;
function qu() {
  if (Zh) return Rl;
  Zh = 1;
  function n(e, t) {
    e = typeof e == "string" ? e : e.source, t = typeof t == "string" ? t : t.source, this.__directives_block_pattern = new RegExp(e + / beautify( \w+[:]\w+)+ /.source + t, "g"), this.__directive_pattern = / (\w+)[:](\w+)/g, this.__directives_end_ignore_pattern = new RegExp(e + /\sbeautify\signore:end\s/.source + t, "g");
  }
  return n.prototype.get_directives = function(e) {
    if (!e.match(this.__directives_block_pattern))
      return null;
    var t = {};
    this.__directive_pattern.lastIndex = 0;
    for (var i = this.__directive_pattern.exec(e); i; )
      t[i[1]] = i[2], i = this.__directive_pattern.exec(e);
    return t;
  }, n.prototype.readIgnored = function(e) {
    return e.readUntilAfter(this.__directives_end_ignore_pattern);
  }, Rl.Directives = n, Rl;
}
var Il = {}, Qh;
function Yg() {
  if (Qh) return Il;
  Qh = 1;
  var n = Ka().Pattern, e = {
    django: !1,
    erb: !1,
    handlebars: !1,
    php: !1,
    smarty: !1,
    angular: !1
  };
  function t(i, r) {
    n.call(this, i, r), this.__template_pattern = null, this._disabled = Object.assign({}, e), this._excluded = Object.assign({}, e), r && (this.__template_pattern = this._input.get_regexp(r.__template_pattern), this._excluded = Object.assign(this._excluded, r._excluded), this._disabled = Object.assign(this._disabled, r._disabled));
    var s = new n(i);
    this.__patterns = {
      handlebars_comment: s.starting_with(/{{!--/).until_after(/--}}/),
      handlebars_unescaped: s.starting_with(/{{{/).until_after(/}}}/),
      handlebars: s.starting_with(/{{/).until_after(/}}/),
      php: s.starting_with(/<\?(?:[= ]|php)/).until_after(/\?>/),
      erb: s.starting_with(/<%[^%]/).until_after(/[^%]%>/),
      // django coflicts with handlebars a bit.
      django: s.starting_with(/{%/).until_after(/%}/),
      django_value: s.starting_with(/{{/).until_after(/}}/),
      django_comment: s.starting_with(/{#/).until_after(/#}/),
      smarty: s.starting_with(/{(?=[^}{\s\n])/).until_after(/[^\s\n]}/),
      smarty_comment: s.starting_with(/{\*/).until_after(/\*}/),
      smarty_literal: s.starting_with(/{literal}/).until_after(/{\/literal}/)
    };
  }
  return t.prototype = new n(), t.prototype._create = function() {
    return new t(this._input, this);
  }, t.prototype._update = function() {
    this.__set_templated_pattern();
  }, t.prototype.disable = function(i) {
    var r = this._create();
    return r._disabled[i] = !0, r._update(), r;
  }, t.prototype.read_options = function(i) {
    var r = this._create();
    for (var s in e)
      r._disabled[s] = i.templating.indexOf(s) === -1;
    return r._update(), r;
  }, t.prototype.exclude = function(i) {
    var r = this._create();
    return r._excluded[i] = !0, r._update(), r;
  }, t.prototype.read = function() {
    var i = "";
    this._match_pattern ? i = this._input.read(this._starting_pattern) : i = this._input.read(this._starting_pattern, this.__template_pattern);
    for (var r = this._read_template(); r; )
      this._match_pattern ? r += this._input.read(this._match_pattern) : r += this._input.readUntil(this.__template_pattern), i += r, r = this._read_template();
    return this._until_after && (i += this._input.readUntilAfter(this._until_pattern)), i;
  }, t.prototype.__set_templated_pattern = function() {
    var i = [];
    this._disabled.php || i.push(this.__patterns.php._starting_pattern.source), this._disabled.handlebars || i.push(this.__patterns.handlebars._starting_pattern.source), this._disabled.angular || i.push(this.__patterns.handlebars._starting_pattern.source), this._disabled.erb || i.push(this.__patterns.erb._starting_pattern.source), this._disabled.django || (i.push(this.__patterns.django._starting_pattern.source), i.push(this.__patterns.django_value._starting_pattern.source), i.push(this.__patterns.django_comment._starting_pattern.source)), this._disabled.smarty || i.push(this.__patterns.smarty._starting_pattern.source), this._until_pattern && i.push(this._until_pattern.source), this.__template_pattern = this._input.get_regexp("(?:" + i.join("|") + ")");
  }, t.prototype._read_template = function() {
    var i = "", r = this._input.peek();
    if (r === "<") {
      var s = this._input.peek(1);
      !this._disabled.php && !this._excluded.php && s === "?" && (i = i || this.__patterns.php.read()), !this._disabled.erb && !this._excluded.erb && s === "%" && (i = i || this.__patterns.erb.read());
    } else r === "{" && (!this._disabled.handlebars && !this._excluded.handlebars && (i = i || this.__patterns.handlebars_comment.read(), i = i || this.__patterns.handlebars_unescaped.read(), i = i || this.__patterns.handlebars.read()), this._disabled.django || (!this._excluded.django && !this._excluded.handlebars && (i = i || this.__patterns.django_value.read()), this._excluded.django || (i = i || this.__patterns.django_comment.read(), i = i || this.__patterns.django.read())), this._disabled.smarty || this._disabled.django && this._disabled.handlebars && (i = i || this.__patterns.smarty_comment.read(), i = i || this.__patterns.smarty_literal.read(), i = i || this.__patterns.smarty.read()));
    return i;
  }, Il.TemplatablePattern = t, Il;
}
var ef;
function Xs() {
  if (ef) return qi;
  ef = 1;
  var n = Ku().InputScanner, e = jo().Tokenizer, t = jo().TOKEN, i = qu().Directives, r = Jg(), s = Ka().Pattern, o = Yg().TemplatablePattern;
  function a(S, w) {
    return w.indexOf(S) !== -1;
  }
  var l = {
    START_EXPR: "TK_START_EXPR",
    END_EXPR: "TK_END_EXPR",
    START_BLOCK: "TK_START_BLOCK",
    END_BLOCK: "TK_END_BLOCK",
    WORD: "TK_WORD",
    RESERVED: "TK_RESERVED",
    SEMICOLON: "TK_SEMICOLON",
    STRING: "TK_STRING",
    EQUALS: "TK_EQUALS",
    OPERATOR: "TK_OPERATOR",
    COMMA: "TK_COMMA",
    BLOCK_COMMENT: "TK_BLOCK_COMMENT",
    COMMENT: "TK_COMMENT",
    DOT: "TK_DOT",
    UNKNOWN: "TK_UNKNOWN",
    START: t.START,
    RAW: t.RAW,
    EOF: t.EOF
  }, c = new i(/\/\*/, /\*\//), u = /0[xX][0123456789abcdefABCDEF_]*n?|0[oO][01234567_]*n?|0[bB][01_]*n?|\d[\d_]*n|(?:\.\d[\d_]*|\d[\d_]*\.?[\d_]*)(?:[eE][+-]?[\d_]+)?/, d = /[0-9]/, h = /[^\d\.]/, f = ">>> === !== &&= ??= ||= << && >= ** != == <= >> || ?? |> < / - + > : & % ? ^ | *".split(" "), p = ">>>= ... >>= <<= === >>> !== **= &&= ??= ||= => ^= :: /= << <= == && -= >= >> != -- += ** || ?? ++ %= &= *= |= |> = ! ? > < : / ^ - + * & % ~ |";
  p = p.replace(/[-[\]{}()*+?.,\\^$|#]/g, "\\$&"), p = "\\?\\.(?!\\d) " + p, p = p.replace(/ /g, "|");
  var _ = new RegExp(p), m = "continue,try,throw,return,var,let,const,if,switch,case,default,for,while,break,function,import,export".split(","), g = m.concat(["do", "in", "of", "else", "get", "set", "new", "catch", "finally", "typeof", "yield", "async", "await", "from", "as", "class", "extends"]), y = new RegExp("^(?:" + g.join("|") + ")$"), x, k = function(S, w) {
    e.call(this, S, w), this._patterns.whitespace = this._patterns.whitespace.matching(
      /\u00A0\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff/.source,
      /\u2028\u2029/.source
    );
    var v = new s(this._input), A = new o(this._input).read_options(this._options);
    this.__patterns = {
      template: A,
      identifier: A.starting_with(r.identifier).matching(r.identifierMatch),
      number: v.matching(u),
      punct: v.matching(_),
      // comment ends just before nearest linefeed or end of file
      comment: v.starting_with(/\/\//).until(/[\n\r\u2028\u2029]/),
      //  /* ... */ comment ends with nearest */ or end of file
      block_comment: v.starting_with(/\/\*/).until_after(/\*\//),
      html_comment_start: v.matching(/<!--/),
      html_comment_end: v.matching(/-->/),
      include: v.starting_with(/#include/).until_after(r.lineBreak),
      shebang: v.starting_with(/#!/).until_after(r.lineBreak),
      xml: v.matching(/[\s\S]*?<(\/?)([-a-zA-Z:0-9_.]+|{[^}]+?}|!\[CDATA\[[^\]]*?\]\]|)(\s*{[^}]+?}|\s+[-a-zA-Z:0-9_.]+|\s+[-a-zA-Z:0-9_.]+\s*=\s*('[^']*'|"[^"]*"|{([^{}]|{[^}]+?})+?}))*\s*(\/?)\s*>/),
      single_quote: A.until(/['\\\n\r\u2028\u2029]/),
      double_quote: A.until(/["\\\n\r\u2028\u2029]/),
      template_text: A.until(/[`\\$]/),
      template_expression: A.until(/[`}\\]/)
    };
  };
  k.prototype = new e(), k.prototype._is_comment = function(S) {
    return S.type === l.COMMENT || S.type === l.BLOCK_COMMENT || S.type === l.UNKNOWN;
  }, k.prototype._is_opening = function(S) {
    return S.type === l.START_BLOCK || S.type === l.START_EXPR;
  }, k.prototype._is_closing = function(S, w) {
    return (S.type === l.END_BLOCK || S.type === l.END_EXPR) && w && (S.text === "]" && w.text === "[" || S.text === ")" && w.text === "(" || S.text === "}" && w.text === "{");
  }, k.prototype._reset = function() {
    x = !1;
  }, k.prototype._get_next_token = function(S, w) {
    var v = null;
    this._readWhitespace();
    var A = this._input.peek();
    return A === null ? this._create_token(l.EOF, "") : (v = v || this._read_non_javascript(A), v = v || this._read_string(A), v = v || this._read_pair(A, this._input.peek(1)), v = v || this._read_word(S), v = v || this._read_singles(A), v = v || this._read_comment(A), v = v || this._read_regexp(A, S), v = v || this._read_xml(A, S), v = v || this._read_punctuation(), v = v || this._create_token(l.UNKNOWN, this._input.next()), v);
  }, k.prototype._read_word = function(S) {
    var w;
    if (w = this.__patterns.identifier.read(), w !== "")
      return w = w.replace(r.allLineBreaks, `
`), !(S.type === l.DOT || S.type === l.RESERVED && (S.text === "set" || S.text === "get")) && y.test(w) ? (w === "in" || w === "of") && (S.type === l.WORD || S.type === l.STRING) ? this._create_token(l.OPERATOR, w) : this._create_token(l.RESERVED, w) : this._create_token(l.WORD, w);
    if (w = this.__patterns.number.read(), w !== "")
      return this._create_token(l.WORD, w);
  }, k.prototype._read_singles = function(S) {
    var w = null;
    return S === "(" || S === "[" ? w = this._create_token(l.START_EXPR, S) : S === ")" || S === "]" ? w = this._create_token(l.END_EXPR, S) : S === "{" ? w = this._create_token(l.START_BLOCK, S) : S === "}" ? w = this._create_token(l.END_BLOCK, S) : S === ";" ? w = this._create_token(l.SEMICOLON, S) : S === "." && h.test(this._input.peek(1)) ? w = this._create_token(l.DOT, S) : S === "," && (w = this._create_token(l.COMMA, S)), w && this._input.next(), w;
  }, k.prototype._read_pair = function(S, w) {
    var v = null;
    return S === "#" && w === "{" && (v = this._create_token(l.START_BLOCK, S + w)), v && (this._input.next(), this._input.next()), v;
  }, k.prototype._read_punctuation = function() {
    var S = this.__patterns.punct.read();
    if (S !== "")
      return S === "=" ? this._create_token(l.EQUALS, S) : S === "?." ? this._create_token(l.DOT, S) : this._create_token(l.OPERATOR, S);
  }, k.prototype._read_non_javascript = function(S) {
    var w = "";
    if (S === "#") {
      if (this._is_first_token() && (w = this.__patterns.shebang.read(), w))
        return this._create_token(l.UNKNOWN, w.trim() + `
`);
      if (w = this.__patterns.include.read(), w)
        return this._create_token(l.UNKNOWN, w.trim() + `
`);
      S = this._input.next();
      var v = "#";
      if (this._input.hasNext() && this._input.testChar(d)) {
        do
          S = this._input.next(), v += S;
        while (this._input.hasNext() && S !== "#" && S !== "=");
        return S === "#" || (this._input.peek() === "[" && this._input.peek(1) === "]" ? (v += "[]", this._input.next(), this._input.next()) : this._input.peek() === "{" && this._input.peek(1) === "}" && (v += "{}", this._input.next(), this._input.next())), this._create_token(l.WORD, v);
      }
      this._input.back();
    } else if (S === "<" && this._is_first_token()) {
      if (w = this.__patterns.html_comment_start.read(), w) {
        for (; this._input.hasNext() && !this._input.testChar(r.newline); )
          w += this._input.next();
        return x = !0, this._create_token(l.COMMENT, w);
      }
    } else if (x && S === "-" && (w = this.__patterns.html_comment_end.read(), w))
      return x = !1, this._create_token(l.COMMENT, w);
    return null;
  }, k.prototype._read_comment = function(S) {
    var w = null;
    if (S === "/") {
      var v = "";
      if (this._input.peek(1) === "*") {
        v = this.__patterns.block_comment.read();
        var A = c.get_directives(v);
        A && A.ignore === "start" && (v += c.readIgnored(this._input)), v = v.replace(r.allLineBreaks, `
`), w = this._create_token(l.BLOCK_COMMENT, v), w.directives = A;
      } else this._input.peek(1) === "/" && (v = this.__patterns.comment.read(), w = this._create_token(l.COMMENT, v));
    }
    return w;
  }, k.prototype._read_string = function(S) {
    if (S === "`" || S === "'" || S === '"') {
      var w = this._input.next();
      return this.has_char_escapes = !1, S === "`" ? w += this._read_string_recursive("`", !0, "${") : w += this._read_string_recursive(S), this.has_char_escapes && this._options.unescape_strings && (w = E(w)), this._input.peek() === S && (w += this._input.next()), w = w.replace(r.allLineBreaks, `
`), this._create_token(l.STRING, w);
    }
    return null;
  }, k.prototype._allow_regexp_or_xml = function(S) {
    return S.type === l.RESERVED && a(S.text, ["return", "case", "throw", "else", "do", "typeof", "yield"]) || S.type === l.END_EXPR && S.text === ")" && S.opened.previous.type === l.RESERVED && a(S.opened.previous.text, ["if", "while", "for"]) || a(S.type, [
      l.COMMENT,
      l.START_EXPR,
      l.START_BLOCK,
      l.START,
      l.END_BLOCK,
      l.OPERATOR,
      l.EQUALS,
      l.EOF,
      l.SEMICOLON,
      l.COMMA
    ]);
  }, k.prototype._read_regexp = function(S, w) {
    if (S === "/" && this._allow_regexp_or_xml(w)) {
      for (var v = this._input.next(), A = !1, b = !1; this._input.hasNext() && (A || b || this._input.peek() !== S) && !this._input.testChar(r.newline); )
        v += this._input.peek(), A ? A = !1 : (A = this._input.peek() === "\\", this._input.peek() === "[" ? b = !0 : this._input.peek() === "]" && (b = !1)), this._input.next();
      return this._input.peek() === S && (v += this._input.next(), v += this._input.read(r.identifier)), this._create_token(l.STRING, v);
    }
    return null;
  }, k.prototype._read_xml = function(S, w) {
    if (this._options.e4x && S === "<" && this._allow_regexp_or_xml(w)) {
      var v = "", A = this.__patterns.xml.read_match();
      if (A) {
        for (var b = A[2].replace(/^{\s+/, "{").replace(/\s+}$/, "}"), C = b.indexOf("{") === 0, M = 0; A; ) {
          var z = !!A[1], D = A[2], H = !!A[A.length - 1] || D.slice(0, 8) === "![CDATA[";
          if (!H && (D === b || C && D.replace(/^{\s+/, "{").replace(/\s+}$/, "}")) && (z ? --M : ++M), v += A[0], M <= 0)
            break;
          A = this.__patterns.xml.read_match();
        }
        return A || (v += this._input.match(/[\s\S]*/g)[0]), v = v.replace(r.allLineBreaks, `
`), this._create_token(l.STRING, v);
      }
    }
    return null;
  };
  function E(S) {
    for (var w = "", v = 0, A = new n(S), b = null; A.hasNext(); )
      if (b = A.match(/([\s]|[^\\]|\\\\)+/g), b && (w += b[0]), A.peek() === "\\") {
        if (A.next(), A.peek() === "x")
          b = A.match(/x([0-9A-Fa-f]{2})/g);
        else if (A.peek() === "u")
          b = A.match(/u([0-9A-Fa-f]{4})/g), b || (b = A.match(/u\{([0-9A-Fa-f]+)\}/g));
        else {
          w += "\\", A.hasNext() && (w += A.next());
          continue;
        }
        if (!b || (v = parseInt(b[1], 16), v > 126 && v <= 255 && b[0].indexOf("x") === 0))
          return S;
        v >= 0 && v < 32 || v > 1114111 ? w += "\\" + b[0] : v === 34 || v === 39 || v === 92 ? w += "\\" + String.fromCharCode(v) : w += String.fromCharCode(v);
      }
    return w;
  }
  return k.prototype._read_string_recursive = function(S, w, v) {
    var A, b;
    S === "'" ? b = this.__patterns.single_quote : S === '"' ? b = this.__patterns.double_quote : S === "`" ? b = this.__patterns.template_text : S === "}" && (b = this.__patterns.template_expression);
    for (var C = b.read(), M = ""; this._input.hasNext(); ) {
      if (M = this._input.next(), M === S || !w && r.newline.test(M)) {
        this._input.back();
        break;
      } else M === "\\" && this._input.hasNext() ? (A = this._input.peek(), A === "x" || A === "u" ? this.has_char_escapes = !0 : A === "\r" && this._input.peek(1) === `
` && this._input.next(), M += this._input.next()) : v && (v === "${" && M === "$" && this._input.peek() === "{" && (M += this._input.next()), v === M && (S === "`" ? M += this._read_string_recursive("}", w, "`") : M += this._read_string_recursive("`", w, "${"), this._input.hasNext() && (M += this._input.next())));
      M += b.read(), C += M;
    }
    return C;
  }, qi.Tokenizer = k, qi.TOKEN = l, qi.positionable_operators = f.slice(), qi.line_starters = m.slice(), qi;
}
var tf;
function Gk() {
  if (tf) return Sl;
  tf = 1;
  var n = Wu().Output, e = Gg().Token, t = Jg(), i = Xg().Options, r = Xs().Tokenizer, s = Xs().line_starters, o = Xs().positionable_operators, a = Xs().TOKEN;
  function l(b, C) {
    return C.indexOf(b) !== -1;
  }
  function c(b) {
    return b.replace(/^\s+/g, "");
  }
  function u(b) {
    for (var C = {}, M = 0; M < b.length; M++)
      C[b[M].replace(/-/g, "_")] = b[M];
    return C;
  }
  function d(b, C) {
    return b && b.type === a.RESERVED && b.text === C;
  }
  function h(b, C) {
    return b && b.type === a.RESERVED && l(b.text, C);
  }
  var f = ["case", "return", "do", "if", "throw", "else", "await", "break", "continue", "async"], p = ["before-newline", "after-newline", "preserve-newline"], _ = u(p), m = [_.before_newline, _.preserve_newline], g = {
    BlockStatement: "BlockStatement",
    // 'BLOCK'
    Statement: "Statement",
    // 'STATEMENT'
    ObjectLiteral: "ObjectLiteral",
    // 'OBJECT',
    ArrayLiteral: "ArrayLiteral",
    //'[EXPRESSION]',
    ForInitializer: "ForInitializer",
    //'(FOR-EXPRESSION)',
    Conditional: "Conditional",
    //'(COND-EXPRESSION)',
    Expression: "Expression"
    //'(EXPRESSION)'
  };
  function y(b, C) {
    C.multiline_frame || C.mode === g.ForInitializer || C.mode === g.Conditional || b.remove_indent(C.start_line_index);
  }
  function x(b) {
    b = b.replace(t.allLineBreaks, `
`);
    for (var C = [], M = b.indexOf(`
`); M !== -1; )
      C.push(b.substring(0, M)), b = b.substring(M + 1), M = b.indexOf(`
`);
    return b.length && C.push(b), C;
  }
  function k(b) {
    return b === g.ArrayLiteral;
  }
  function E(b) {
    return l(b, [g.Expression, g.ForInitializer, g.Conditional]);
  }
  function S(b, C) {
    for (var M = 0; M < b.length; M++) {
      var z = b[M].trim();
      if (z.charAt(0) !== C)
        return !1;
    }
    return !0;
  }
  function w(b, C) {
    for (var M = 0, z = b.length, D; M < z; M++)
      if (D = b[M], D && D.indexOf(C) !== 0)
        return !1;
    return !0;
  }
  function v(b, C) {
    C = C || {}, this._source_text = b || "", this._output = null, this._tokens = null, this._last_last_text = null, this._flags = null, this._previous_flags = null, this._flag_store = null, this._options = new i(C);
  }
  v.prototype.create_flags = function(b, C) {
    var M = 0;
    b && (M = b.indentation_level, !this._output.just_added_newline() && b.line_indent_level > M && (M = b.line_indent_level));
    var z = {
      mode: C,
      parent: b,
      last_token: b ? b.last_token : new e(a.START_BLOCK, ""),
      // last token text
      last_word: b ? b.last_word : "",
      // last TOKEN.WORD passed
      declaration_statement: !1,
      declaration_assignment: !1,
      multiline_frame: !1,
      inline_frame: !1,
      if_block: !1,
      else_block: !1,
      class_start_block: !1,
      // class A { INSIDE HERE } or class B extends C { INSIDE HERE }
      do_block: !1,
      do_while: !1,
      import_block: !1,
      in_case_statement: !1,
      // switch(..){ INSIDE HERE }
      in_case: !1,
      // we're on the exact line with "case 0:"
      case_body: !1,
      // the indented case-action block
      case_block: !1,
      // the indented case-action block is wrapped with {}
      indentation_level: M,
      alignment: 0,
      line_indent_level: b ? b.line_indent_level : M,
      start_line_index: this._output.get_line_number(),
      ternary_depth: 0
    };
    return z;
  }, v.prototype._reset = function(b) {
    var C = b.match(/^[\t ]*/)[0];
    this._last_last_text = "", this._output = new n(this._options, C), this._output.raw = this._options.test_output_raw, this._flag_store = [], this.set_mode(g.BlockStatement);
    var M = new r(b, this._options);
    return this._tokens = M.tokenize(), b;
  }, v.prototype.beautify = function() {
    if (this._options.disabled)
      return this._source_text;
    var b, C = this._reset(this._source_text), M = this._options.eol;
    this._options.eol === "auto" && (M = `
`, C && t.lineBreak.test(C || "") && (M = C.match(t.lineBreak)[0]));
    for (var z = this._tokens.next(); z; )
      this.handle_token(z), this._last_last_text = this._flags.last_token.text, this._flags.last_token = z, z = this._tokens.next();
    return b = this._output.get_code(M), b;
  }, v.prototype.handle_token = function(b, C) {
    b.type === a.START_EXPR ? this.handle_start_expr(b) : b.type === a.END_EXPR ? this.handle_end_expr(b) : b.type === a.START_BLOCK ? this.handle_start_block(b) : b.type === a.END_BLOCK ? this.handle_end_block(b) : b.type === a.WORD ? this.handle_word(b) : b.type === a.RESERVED ? this.handle_word(b) : b.type === a.SEMICOLON ? this.handle_semicolon(b) : b.type === a.STRING ? this.handle_string(b) : b.type === a.EQUALS ? this.handle_equals(b) : b.type === a.OPERATOR ? this.handle_operator(b) : b.type === a.COMMA ? this.handle_comma(b) : b.type === a.BLOCK_COMMENT ? this.handle_block_comment(b, C) : b.type === a.COMMENT ? this.handle_comment(b, C) : b.type === a.DOT ? this.handle_dot(b) : b.type === a.EOF ? this.handle_eof(b) : b.type === a.UNKNOWN ? this.handle_unknown(b, C) : this.handle_unknown(b, C);
  }, v.prototype.handle_whitespace_and_comments = function(b, C) {
    var M = b.newlines, z = this._options.keep_array_indentation && k(this._flags.mode);
    if (b.comments_before)
      for (var D = b.comments_before.next(); D; )
        this.handle_whitespace_and_comments(D, C), this.handle_token(D, C), D = b.comments_before.next();
    if (z)
      for (var H = 0; H < M; H += 1)
        this.print_newline(H > 0, C);
    else if (this._options.max_preserve_newlines && M > this._options.max_preserve_newlines && (M = this._options.max_preserve_newlines), this._options.preserve_newlines && M > 1) {
      this.print_newline(!1, C);
      for (var q = 1; q < M; q += 1)
        this.print_newline(!0, C);
    }
  };
  var A = ["async", "break", "continue", "return", "throw", "yield"];
  return v.prototype.allow_wrap_or_preserved_newline = function(b, C) {
    if (C = C === void 0 ? !1 : C, !this._output.just_added_newline()) {
      var M = this._options.preserve_newlines && b.newlines || C, z = l(this._flags.last_token.text, o) || l(b.text, o);
      if (z) {
        var D = l(this._flags.last_token.text, o) && l(this._options.operator_position, m) || l(b.text, o);
        M = M && D;
      }
      if (M)
        this.print_newline(!1, !0);
      else if (this._options.wrap_line_length) {
        if (h(this._flags.last_token, A))
          return;
        this._output.set_wrap_point();
      }
    }
  }, v.prototype.print_newline = function(b, C) {
    if (!C && this._flags.last_token.text !== ";" && this._flags.last_token.text !== "," && this._flags.last_token.text !== "=" && (this._flags.last_token.type !== a.OPERATOR || this._flags.last_token.text === "--" || this._flags.last_token.text === "++"))
      for (var M = this._tokens.peek(); this._flags.mode === g.Statement && !(this._flags.if_block && d(M, "else")) && !this._flags.do_block; )
        this.restore_mode();
    this._output.add_new_line(b) && (this._flags.multiline_frame = !0);
  }, v.prototype.print_token_line_indentation = function(b) {
    this._output.just_added_newline() && (this._options.keep_array_indentation && b.newlines && (b.text === "[" || k(this._flags.mode)) ? (this._output.current_line.set_indent(-1), this._output.current_line.push(b.whitespace_before), this._output.space_before_token = !1) : this._output.set_indent(this._flags.indentation_level, this._flags.alignment) && (this._flags.line_indent_level = this._flags.indentation_level));
  }, v.prototype.print_token = function(b) {
    if (this._output.raw) {
      this._output.add_raw_token(b);
      return;
    }
    if (this._options.comma_first && b.previous && b.previous.type === a.COMMA && this._output.just_added_newline() && this._output.previous_line.last() === ",") {
      var C = this._output.previous_line.pop();
      this._output.previous_line.is_empty() && (this._output.previous_line.push(C), this._output.trim(!0), this._output.current_line.pop(), this._output.trim()), this.print_token_line_indentation(b), this._output.add_token(","), this._output.space_before_token = !0;
    }
    this.print_token_line_indentation(b), this._output.non_breaking_space = !0, this._output.add_token(b.text), this._output.previous_token_wrapped && (this._flags.multiline_frame = !0);
  }, v.prototype.indent = function() {
    this._flags.indentation_level += 1, this._output.set_indent(this._flags.indentation_level, this._flags.alignment);
  }, v.prototype.deindent = function() {
    this._flags.indentation_level > 0 && (!this._flags.parent || this._flags.indentation_level > this._flags.parent.indentation_level) && (this._flags.indentation_level -= 1, this._output.set_indent(this._flags.indentation_level, this._flags.alignment));
  }, v.prototype.set_mode = function(b) {
    this._flags ? (this._flag_store.push(this._flags), this._previous_flags = this._flags) : this._previous_flags = this.create_flags(null, b), this._flags = this.create_flags(this._previous_flags, b), this._output.set_indent(this._flags.indentation_level, this._flags.alignment);
  }, v.prototype.restore_mode = function() {
    this._flag_store.length > 0 && (this._previous_flags = this._flags, this._flags = this._flag_store.pop(), this._previous_flags.mode === g.Statement && y(this._output, this._previous_flags), this._output.set_indent(this._flags.indentation_level, this._flags.alignment));
  }, v.prototype.start_of_object_property = function() {
    return this._flags.parent.mode === g.ObjectLiteral && this._flags.mode === g.Statement && (this._flags.last_token.text === ":" && this._flags.ternary_depth === 0 || h(this._flags.last_token, ["get", "set"]));
  }, v.prototype.start_of_statement = function(b) {
    var C = !1;
    return C = C || h(this._flags.last_token, ["var", "let", "const"]) && b.type === a.WORD, C = C || d(this._flags.last_token, "do"), C = C || !(this._flags.parent.mode === g.ObjectLiteral && this._flags.mode === g.Statement) && h(this._flags.last_token, A) && !b.newlines, C = C || d(this._flags.last_token, "else") && !(d(b, "if") && !b.comments_before), C = C || this._flags.last_token.type === a.END_EXPR && (this._previous_flags.mode === g.ForInitializer || this._previous_flags.mode === g.Conditional), C = C || this._flags.last_token.type === a.WORD && this._flags.mode === g.BlockStatement && !this._flags.in_case && !(b.text === "--" || b.text === "++") && this._last_last_text !== "function" && b.type !== a.WORD && b.type !== a.RESERVED, C = C || this._flags.mode === g.ObjectLiteral && (this._flags.last_token.text === ":" && this._flags.ternary_depth === 0 || h(this._flags.last_token, ["get", "set"])), C ? (this.set_mode(g.Statement), this.indent(), this.handle_whitespace_and_comments(b, !0), this.start_of_object_property() || this.allow_wrap_or_preserved_newline(
      b,
      h(b, ["do", "for", "if", "while"])
    ), !0) : !1;
  }, v.prototype.handle_start_expr = function(b) {
    this.start_of_statement(b) || this.handle_whitespace_and_comments(b);
    var C = g.Expression;
    if (b.text === "[") {
      if (this._flags.last_token.type === a.WORD || this._flags.last_token.text === ")") {
        h(this._flags.last_token, s) && (this._output.space_before_token = !0), this.print_token(b), this.set_mode(C), this.indent(), this._options.space_in_paren && (this._output.space_before_token = !0);
        return;
      }
      C = g.ArrayLiteral, k(this._flags.mode) && (this._flags.last_token.text === "[" || this._flags.last_token.text === "," && (this._last_last_text === "]" || this._last_last_text === "}")) && (this._options.keep_array_indentation || this.print_newline()), l(this._flags.last_token.type, [a.START_EXPR, a.END_EXPR, a.WORD, a.OPERATOR, a.DOT]) || (this._output.space_before_token = !0);
    } else {
      if (this._flags.last_token.type === a.RESERVED)
        this._flags.last_token.text === "for" ? (this._output.space_before_token = this._options.space_before_conditional, C = g.ForInitializer) : l(this._flags.last_token.text, ["if", "while", "switch"]) ? (this._output.space_before_token = this._options.space_before_conditional, C = g.Conditional) : l(this._flags.last_word, ["await", "async"]) ? this._output.space_before_token = !0 : this._flags.last_token.text === "import" && b.whitespace_before === "" ? this._output.space_before_token = !1 : (l(this._flags.last_token.text, s) || this._flags.last_token.text === "catch") && (this._output.space_before_token = !0);
      else if (this._flags.last_token.type === a.EQUALS || this._flags.last_token.type === a.OPERATOR)
        this.start_of_object_property() || this.allow_wrap_or_preserved_newline(b);
      else if (this._flags.last_token.type === a.WORD) {
        this._output.space_before_token = !1;
        var M = this._tokens.peek(-3);
        if (this._options.space_after_named_function && M) {
          var z = this._tokens.peek(-4);
          h(M, ["async", "function"]) || M.text === "*" && h(z, ["async", "function"]) ? this._output.space_before_token = !0 : this._flags.mode === g.ObjectLiteral ? (M.text === "{" || M.text === "," || M.text === "*" && (z.text === "{" || z.text === ",")) && (this._output.space_before_token = !0) : this._flags.parent && this._flags.parent.class_start_block && (this._output.space_before_token = !0);
        }
      } else
        this.allow_wrap_or_preserved_newline(b);
      (this._flags.last_token.type === a.RESERVED && (this._flags.last_word === "function" || this._flags.last_word === "typeof") || this._flags.last_token.text === "*" && (l(this._last_last_text, ["function", "yield"]) || this._flags.mode === g.ObjectLiteral && l(this._last_last_text, ["{", ","]))) && (this._output.space_before_token = this._options.space_after_anon_function);
    }
    this._flags.last_token.text === ";" || this._flags.last_token.type === a.START_BLOCK ? this.print_newline() : (this._flags.last_token.type === a.END_EXPR || this._flags.last_token.type === a.START_EXPR || this._flags.last_token.type === a.END_BLOCK || this._flags.last_token.text === "." || this._flags.last_token.type === a.COMMA) && this.allow_wrap_or_preserved_newline(b, b.newlines), this.print_token(b), this.set_mode(C), this._options.space_in_paren && (this._output.space_before_token = !0), this.indent();
  }, v.prototype.handle_end_expr = function(b) {
    for (; this._flags.mode === g.Statement; )
      this.restore_mode();
    this.handle_whitespace_and_comments(b), this._flags.multiline_frame && this.allow_wrap_or_preserved_newline(
      b,
      b.text === "]" && k(this._flags.mode) && !this._options.keep_array_indentation
    ), this._options.space_in_paren && (this._flags.last_token.type === a.START_EXPR && !this._options.space_in_empty_paren ? (this._output.trim(), this._output.space_before_token = !1) : this._output.space_before_token = !0), this.deindent(), this.print_token(b), this.restore_mode(), y(this._output, this._previous_flags), this._flags.do_while && this._previous_flags.mode === g.Conditional && (this._previous_flags.mode = g.Expression, this._flags.do_block = !1, this._flags.do_while = !1);
  }, v.prototype.handle_start_block = function(b) {
    this.handle_whitespace_and_comments(b);
    var C = this._tokens.peek(), M = this._tokens.peek(1);
    this._flags.last_word === "switch" && this._flags.last_token.type === a.END_EXPR ? (this.set_mode(g.BlockStatement), this._flags.in_case_statement = !0) : this._flags.case_body ? this.set_mode(g.BlockStatement) : M && (l(M.text, [":", ","]) && l(C.type, [a.STRING, a.WORD, a.RESERVED]) || l(C.text, ["get", "set", "..."]) && l(M.type, [a.WORD, a.RESERVED])) ? l(this._last_last_text, ["class", "interface"]) && !l(M.text, [":", ","]) ? this.set_mode(g.BlockStatement) : this.set_mode(g.ObjectLiteral) : this._flags.last_token.type === a.OPERATOR && this._flags.last_token.text === "=>" ? this.set_mode(g.BlockStatement) : l(this._flags.last_token.type, [a.EQUALS, a.START_EXPR, a.COMMA, a.OPERATOR]) || h(this._flags.last_token, ["return", "throw", "import", "default"]) ? this.set_mode(g.ObjectLiteral) : this.set_mode(g.BlockStatement), this._flags.last_token && h(this._flags.last_token.previous, ["class", "extends"]) && (this._flags.class_start_block = !0);
    var z = !C.comments_before && C.text === "}", D = z && this._flags.last_word === "function" && this._flags.last_token.type === a.END_EXPR;
    if (this._options.brace_preserve_inline) {
      var H = 0, q = null;
      this._flags.inline_frame = !0;
      do
        if (H += 1, q = this._tokens.peek(H - 1), q.newlines) {
          this._flags.inline_frame = !1;
          break;
        }
      while (q.type !== a.EOF && !(q.type === a.END_BLOCK && q.opened === b));
    }
    (this._options.brace_style === "expand" || this._options.brace_style === "none" && b.newlines) && !this._flags.inline_frame ? this._flags.last_token.type !== a.OPERATOR && (D || this._flags.last_token.type === a.EQUALS || h(this._flags.last_token, f) && this._flags.last_token.text !== "else") ? this._output.space_before_token = !0 : this.print_newline(!1, !0) : (k(this._previous_flags.mode) && (this._flags.last_token.type === a.START_EXPR || this._flags.last_token.type === a.COMMA) && ((this._flags.last_token.type === a.COMMA || this._options.space_in_paren) && (this._output.space_before_token = !0), (this._flags.last_token.type === a.COMMA || this._flags.last_token.type === a.START_EXPR && this._flags.inline_frame) && (this.allow_wrap_or_preserved_newline(b), this._previous_flags.multiline_frame = this._previous_flags.multiline_frame || this._flags.multiline_frame, this._flags.multiline_frame = !1)), this._flags.last_token.type !== a.OPERATOR && this._flags.last_token.type !== a.START_EXPR && (l(this._flags.last_token.type, [a.START_BLOCK, a.SEMICOLON]) && !this._flags.inline_frame ? this.print_newline() : this._output.space_before_token = !0)), this.print_token(b), this.indent(), !z && !(this._options.brace_preserve_inline && this._flags.inline_frame) && this.print_newline();
  }, v.prototype.handle_end_block = function(b) {
    for (this.handle_whitespace_and_comments(b); this._flags.mode === g.Statement; )
      this.restore_mode();
    var C = this._flags.last_token.type === a.START_BLOCK;
    this._flags.inline_frame && !C ? this._output.space_before_token = !0 : this._options.brace_style === "expand" ? C || this.print_newline() : C || (k(this._flags.mode) && this._options.keep_array_indentation ? (this._options.keep_array_indentation = !1, this.print_newline(), this._options.keep_array_indentation = !0) : this.print_newline()), this.restore_mode(), this.print_token(b);
  }, v.prototype.handle_word = function(b) {
    if (b.type === a.RESERVED) {
      if (l(b.text, ["set", "get"]) && this._flags.mode !== g.ObjectLiteral)
        b.type = a.WORD;
      else if (b.text === "import" && l(this._tokens.peek().text, ["(", "."]))
        b.type = a.WORD;
      else if (l(b.text, ["as", "from"]) && !this._flags.import_block)
        b.type = a.WORD;
      else if (this._flags.mode === g.ObjectLiteral) {
        var C = this._tokens.peek();
        C.text === ":" && (b.type = a.WORD);
      }
    }
    if (this.start_of_statement(b) ? h(this._flags.last_token, ["var", "let", "const"]) && b.type === a.WORD && (this._flags.declaration_statement = !0) : b.newlines && !E(this._flags.mode) && (this._flags.last_token.type !== a.OPERATOR || this._flags.last_token.text === "--" || this._flags.last_token.text === "++") && this._flags.last_token.type !== a.EQUALS && (this._options.preserve_newlines || !h(this._flags.last_token, ["var", "let", "const", "set", "get"])) ? (this.handle_whitespace_and_comments(b), this.print_newline()) : this.handle_whitespace_and_comments(b), this._flags.do_block && !this._flags.do_while)
      if (d(b, "while")) {
        this._output.space_before_token = !0, this.print_token(b), this._output.space_before_token = !0, this._flags.do_while = !0;
        return;
      } else
        this.print_newline(), this._flags.do_block = !1;
    if (this._flags.if_block)
      if (!this._flags.else_block && d(b, "else"))
        this._flags.else_block = !0;
      else {
        for (; this._flags.mode === g.Statement; )
          this.restore_mode();
        this._flags.if_block = !1, this._flags.else_block = !1;
      }
    if (this._flags.in_case_statement && h(b, ["case", "default"])) {
      this.print_newline(), !this._flags.case_block && (this._flags.case_body || this._options.jslint_happy) && this.deindent(), this._flags.case_body = !1, this.print_token(b), this._flags.in_case = !0;
      return;
    }
    if ((this._flags.last_token.type === a.COMMA || this._flags.last_token.type === a.START_EXPR || this._flags.last_token.type === a.EQUALS || this._flags.last_token.type === a.OPERATOR) && !this.start_of_object_property() && !// start of object property is different for numeric values with +/- prefix operators
    (l(this._flags.last_token.text, ["+", "-"]) && this._last_last_text === ":" && this._flags.parent.mode === g.ObjectLiteral) && this.allow_wrap_or_preserved_newline(b), d(b, "function")) {
      (l(this._flags.last_token.text, ["}", ";"]) || this._output.just_added_newline() && !(l(this._flags.last_token.text, ["(", "[", "{", ":", "=", ","]) || this._flags.last_token.type === a.OPERATOR)) && !this._output.just_added_blankline() && !b.comments_before && (this.print_newline(), this.print_newline(!0)), this._flags.last_token.type === a.RESERVED || this._flags.last_token.type === a.WORD ? h(this._flags.last_token, ["get", "set", "new", "export"]) || h(this._flags.last_token, A) ? this._output.space_before_token = !0 : d(this._flags.last_token, "default") && this._last_last_text === "export" ? this._output.space_before_token = !0 : this._flags.last_token.text === "declare" ? this._output.space_before_token = !0 : this.print_newline() : this._flags.last_token.type === a.OPERATOR || this._flags.last_token.text === "=" ? this._output.space_before_token = !0 : !this._flags.multiline_frame && (E(this._flags.mode) || k(this._flags.mode)) || this.print_newline(), this.print_token(b), this._flags.last_word = b.text;
      return;
    }
    var M = "NONE";
    if (this._flags.last_token.type === a.END_BLOCK ? this._previous_flags.inline_frame ? M = "SPACE" : h(b, ["else", "catch", "finally", "from"]) ? this._options.brace_style === "expand" || this._options.brace_style === "end-expand" || this._options.brace_style === "none" && b.newlines ? M = "NEWLINE" : (M = "SPACE", this._output.space_before_token = !0) : M = "NEWLINE" : this._flags.last_token.type === a.SEMICOLON && this._flags.mode === g.BlockStatement ? M = "NEWLINE" : this._flags.last_token.type === a.SEMICOLON && E(this._flags.mode) ? M = "SPACE" : this._flags.last_token.type === a.STRING ? M = "NEWLINE" : this._flags.last_token.type === a.RESERVED || this._flags.last_token.type === a.WORD || this._flags.last_token.text === "*" && (l(this._last_last_text, ["function", "yield"]) || this._flags.mode === g.ObjectLiteral && l(this._last_last_text, ["{", ","])) ? M = "SPACE" : this._flags.last_token.type === a.START_BLOCK ? this._flags.inline_frame ? M = "SPACE" : M = "NEWLINE" : this._flags.last_token.type === a.END_EXPR && (this._output.space_before_token = !0, M = "NEWLINE"), h(b, s) && this._flags.last_token.text !== ")" && (this._flags.inline_frame || this._flags.last_token.text === "else" || this._flags.last_token.text === "export" ? M = "SPACE" : M = "NEWLINE"), h(b, ["else", "catch", "finally"]))
      if ((!(this._flags.last_token.type === a.END_BLOCK && this._previous_flags.mode === g.BlockStatement) || this._options.brace_style === "expand" || this._options.brace_style === "end-expand" || this._options.brace_style === "none" && b.newlines) && !this._flags.inline_frame)
        this.print_newline();
      else {
        this._output.trim(!0);
        var z = this._output.current_line;
        z.last() !== "}" && this.print_newline(), this._output.space_before_token = !0;
      }
    else M === "NEWLINE" ? h(this._flags.last_token, f) ? this._output.space_before_token = !0 : this._flags.last_token.text === "declare" && h(b, ["var", "let", "const"]) ? this._output.space_before_token = !0 : this._flags.last_token.type !== a.END_EXPR ? (this._flags.last_token.type !== a.START_EXPR || !h(b, ["var", "let", "const"])) && this._flags.last_token.text !== ":" && (d(b, "if") && d(b.previous, "else") ? this._output.space_before_token = !0 : this.print_newline()) : h(b, s) && this._flags.last_token.text !== ")" && this.print_newline() : this._flags.multiline_frame && k(this._flags.mode) && this._flags.last_token.text === "," && this._last_last_text === "}" ? this.print_newline() : M === "SPACE" && (this._output.space_before_token = !0);
    b.previous && (b.previous.type === a.WORD || b.previous.type === a.RESERVED) && (this._output.space_before_token = !0), this.print_token(b), this._flags.last_word = b.text, b.type === a.RESERVED && (b.text === "do" ? this._flags.do_block = !0 : b.text === "if" ? this._flags.if_block = !0 : b.text === "import" ? this._flags.import_block = !0 : this._flags.import_block && d(b, "from") && (this._flags.import_block = !1));
  }, v.prototype.handle_semicolon = function(b) {
    this.start_of_statement(b) ? this._output.space_before_token = !1 : this.handle_whitespace_and_comments(b);
    for (var C = this._tokens.peek(); this._flags.mode === g.Statement && !(this._flags.if_block && d(C, "else")) && !this._flags.do_block; )
      this.restore_mode();
    this._flags.import_block && (this._flags.import_block = !1), this.print_token(b);
  }, v.prototype.handle_string = function(b) {
    b.text.startsWith("`") && b.newlines === 0 && b.whitespace_before === "" && (b.previous.text === ")" || this._flags.last_token.type === a.WORD) || (this.start_of_statement(b) ? this._output.space_before_token = !0 : (this.handle_whitespace_and_comments(b), this._flags.last_token.type === a.RESERVED || this._flags.last_token.type === a.WORD || this._flags.inline_frame ? this._output.space_before_token = !0 : this._flags.last_token.type === a.COMMA || this._flags.last_token.type === a.START_EXPR || this._flags.last_token.type === a.EQUALS || this._flags.last_token.type === a.OPERATOR ? this.start_of_object_property() || this.allow_wrap_or_preserved_newline(b) : b.text.startsWith("`") && this._flags.last_token.type === a.END_EXPR && (b.previous.text === "]" || b.previous.text === ")") && b.newlines === 0 ? this._output.space_before_token = !0 : this.print_newline())), this.print_token(b);
  }, v.prototype.handle_equals = function(b) {
    this.start_of_statement(b) || this.handle_whitespace_and_comments(b), this._flags.declaration_statement && (this._flags.declaration_assignment = !0), this._output.space_before_token = !0, this.print_token(b), this._output.space_before_token = !0;
  }, v.prototype.handle_comma = function(b) {
    this.handle_whitespace_and_comments(b, !0), this.print_token(b), this._output.space_before_token = !0, this._flags.declaration_statement ? (E(this._flags.parent.mode) && (this._flags.declaration_assignment = !1), this._flags.declaration_assignment ? (this._flags.declaration_assignment = !1, this.print_newline(!1, !0)) : this._options.comma_first && this.allow_wrap_or_preserved_newline(b)) : this._flags.mode === g.ObjectLiteral || this._flags.mode === g.Statement && this._flags.parent.mode === g.ObjectLiteral ? (this._flags.mode === g.Statement && this.restore_mode(), this._flags.inline_frame || this.print_newline()) : this._options.comma_first && this.allow_wrap_or_preserved_newline(b);
  }, v.prototype.handle_operator = function(b) {
    var C = b.text === "*" && (h(this._flags.last_token, ["function", "yield"]) || l(this._flags.last_token.type, [a.START_BLOCK, a.COMMA, a.END_BLOCK, a.SEMICOLON])), M = l(b.text, ["-", "+"]) && (l(this._flags.last_token.type, [a.START_BLOCK, a.START_EXPR, a.EQUALS, a.OPERATOR]) || l(this._flags.last_token.text, s) || this._flags.last_token.text === ",");
    if (!this.start_of_statement(b)) {
      var z = !C;
      this.handle_whitespace_and_comments(b, z);
    }
    if (b.text === "*" && this._flags.last_token.type === a.DOT) {
      this.print_token(b);
      return;
    }
    if (b.text === "::") {
      this.print_token(b);
      return;
    }
    if (l(b.text, ["-", "+"]) && this.start_of_object_property()) {
      this.print_token(b);
      return;
    }
    if (this._flags.last_token.type === a.OPERATOR && l(this._options.operator_position, m) && this.allow_wrap_or_preserved_newline(b), b.text === ":" && this._flags.in_case) {
      this.print_token(b), this._flags.in_case = !1, this._flags.case_body = !0, this._tokens.peek().type !== a.START_BLOCK ? (this.indent(), this.print_newline(), this._flags.case_block = !1) : (this._flags.case_block = !0, this._output.space_before_token = !0);
      return;
    }
    var D = !0, H = !0, q = !1;
    if (b.text === ":" ? this._flags.ternary_depth === 0 ? D = !1 : (this._flags.ternary_depth -= 1, q = !0) : b.text === "?" && (this._flags.ternary_depth += 1), !M && !C && this._options.preserve_newlines && l(b.text, o)) {
      var G = b.text === ":", ae = G && q, Y = G && !q;
      switch (this._options.operator_position) {
        case _.before_newline:
          this._output.space_before_token = !Y, this.print_token(b), (!G || ae) && this.allow_wrap_or_preserved_newline(b), this._output.space_before_token = !0;
          return;
        case _.after_newline:
          this._output.space_before_token = !0, !G || ae ? this._tokens.peek().newlines ? this.print_newline(!1, !0) : this.allow_wrap_or_preserved_newline(b) : this._output.space_before_token = !1, this.print_token(b), this._output.space_before_token = !0;
          return;
        case _.preserve_newline:
          Y || this.allow_wrap_or_preserved_newline(b), D = !(this._output.just_added_newline() || Y), this._output.space_before_token = D, this.print_token(b), this._output.space_before_token = !0;
          return;
      }
    }
    if (C) {
      this.allow_wrap_or_preserved_newline(b), D = !1;
      var le = this._tokens.peek();
      H = le && l(le.type, [a.WORD, a.RESERVED]);
    } else if (b.text === "...")
      this.allow_wrap_or_preserved_newline(b), D = this._flags.last_token.type === a.START_BLOCK, H = !1;
    else if (l(b.text, ["--", "++", "!", "~"]) || M) {
      if ((this._flags.last_token.type === a.COMMA || this._flags.last_token.type === a.START_EXPR) && this.allow_wrap_or_preserved_newline(b), D = !1, H = !1, b.newlines && (b.text === "--" || b.text === "++" || b.text === "~")) {
        var de = h(this._flags.last_token, f) && b.newlines;
        de && (this._previous_flags.if_block || this._previous_flags.else_block) && this.restore_mode(), this.print_newline(de, !0);
      }
      this._flags.last_token.text === ";" && E(this._flags.mode) && (D = !0), this._flags.last_token.type === a.RESERVED ? D = !0 : this._flags.last_token.type === a.END_EXPR ? D = !(this._flags.last_token.text === "]" && (b.text === "--" || b.text === "++")) : this._flags.last_token.type === a.OPERATOR && (D = l(b.text, ["--", "-", "++", "+"]) && l(this._flags.last_token.text, ["--", "-", "++", "+"]), l(b.text, ["+", "-"]) && l(this._flags.last_token.text, ["--", "++"]) && (H = !0)), (this._flags.mode === g.BlockStatement && !this._flags.inline_frame || this._flags.mode === g.Statement) && (this._flags.last_token.text === "{" || this._flags.last_token.text === ";") && this.print_newline();
    }
    this._output.space_before_token = this._output.space_before_token || D, this.print_token(b), this._output.space_before_token = H;
  }, v.prototype.handle_block_comment = function(b, C) {
    if (this._output.raw) {
      this._output.add_raw_token(b), b.directives && b.directives.preserve === "end" && (this._output.raw = this._options.test_output_raw);
      return;
    }
    if (b.directives) {
      this.print_newline(!1, C), this.print_token(b), b.directives.preserve === "start" && (this._output.raw = !0), this.print_newline(!1, !0);
      return;
    }
    if (!t.newline.test(b.text) && !b.newlines) {
      this._output.space_before_token = !0, this.print_token(b), this._output.space_before_token = !0;
      return;
    } else
      this.print_block_commment(b, C);
  }, v.prototype.print_block_commment = function(b, C) {
    var M = x(b.text), z, D = !1, H = !1, q = b.whitespace_before, G = q.length;
    if (this.print_newline(!1, C), this.print_token_line_indentation(b), this._output.add_token(M[0]), this.print_newline(!1, C), M.length > 1) {
      for (M = M.slice(1), D = S(M, "*"), H = w(M, q), D && (this._flags.alignment = 1), z = 0; z < M.length; z++)
        D ? (this.print_token_line_indentation(b), this._output.add_token(c(M[z]))) : H && M[z] ? (this.print_token_line_indentation(b), this._output.add_token(M[z].substring(G))) : (this._output.current_line.set_indent(-1), this._output.add_token(M[z])), this.print_newline(!1, C);
      this._flags.alignment = 0;
    }
  }, v.prototype.handle_comment = function(b, C) {
    b.newlines ? this.print_newline(!1, C) : this._output.trim(!0), this._output.space_before_token = !0, this.print_token(b), this.print_newline(!1, C);
  }, v.prototype.handle_dot = function(b) {
    this.start_of_statement(b) || this.handle_whitespace_and_comments(b, !0), this._flags.last_token.text.match("^[0-9]+$") && (this._output.space_before_token = !0), h(this._flags.last_token, f) ? this._output.space_before_token = !1 : this.allow_wrap_or_preserved_newline(
      b,
      this._flags.last_token.text === ")" && this._options.break_chained_methods
    ), this._options.unindent_chained_methods && this._output.just_added_newline() && this.deindent(), this.print_token(b);
  }, v.prototype.handle_unknown = function(b, C) {
    this.print_token(b), b.text[b.text.length - 1] === `
` && this.print_newline(!1, C);
  }, v.prototype.handle_eof = function(b) {
    for (; this._flags.mode === g.Statement; )
      this.restore_mode();
    this.handle_whitespace_and_comments(b);
  }, Sl.Beautifier = v, Sl;
}
var nf;
function Jk() {
  if (nf) return Gs.exports;
  nf = 1;
  var n = Gk().Beautifier, e = Xg().Options;
  function t(i, r) {
    var s = new n(i, r);
    return s.beautify();
  }
  return Gs.exports = t, Gs.exports.defaultOptions = function() {
    return new e();
  }, Gs.exports;
}
var Ys = { exports: {} }, Pl = {}, Dl = {}, rf;
function Zg() {
  if (rf) return Dl;
  rf = 1;
  var n = Uu().Options;
  function e(t) {
    n.call(this, t, "css"), this.selector_separator_newline = this._get_boolean("selector_separator_newline", !0), this.newline_between_rules = this._get_boolean("newline_between_rules", !0);
    var i = this._get_boolean("space_around_selector_separator");
    this.space_around_combinator = this._get_boolean("space_around_combinator") || i;
    var r = this._get_selection_list("brace_style", ["collapse", "expand", "end-expand", "none", "preserve-inline"]);
    this.brace_style = "collapse";
    for (var s = 0; s < r.length; s++)
      r[s] !== "expand" ? this.brace_style = "collapse" : this.brace_style = r[s];
  }
  return e.prototype = new n(), Dl.Options = e, Dl;
}
var sf;
function Xk() {
  if (sf) return Pl;
  sf = 1;
  var n = Zg().Options, e = Wu().Output, t = Ku().InputScanner, i = qu().Directives, r = new i(/\/\*/, /\*\//), s = /\r\n|[\r\n]/, o = /\r\n|[\r\n]/g, a = /\s/, l = /(?:\s|\n)+/g, c = /\/\*(?:[\s\S]*?)((?:\*\/)|$)/g, u = /\/\/(?:[^\n\r\u2028\u2029]*)/g;
  function d(h, f) {
    this._source_text = h || "", this._options = new n(f), this._ch = null, this._input = null, this.NESTED_AT_RULE = {
      page: !0,
      "font-face": !0,
      keyframes: !0,
      // also in CONDITIONAL_GROUP_RULE below
      media: !0,
      supports: !0,
      document: !0
    }, this.CONDITIONAL_GROUP_RULE = {
      media: !0,
      supports: !0,
      document: !0
    }, this.NON_SEMICOLON_NEWLINE_PROPERTY = [
      "grid-template-areas",
      "grid-template"
    ];
  }
  return d.prototype.eatString = function(h) {
    var f = "";
    for (this._ch = this._input.next(); this._ch; ) {
      if (f += this._ch, this._ch === "\\")
        f += this._input.next();
      else if (h.indexOf(this._ch) !== -1 || this._ch === `
`)
        break;
      this._ch = this._input.next();
    }
    return f;
  }, d.prototype.eatWhitespace = function(h) {
    for (var f = a.test(this._input.peek()), p = 0; a.test(this._input.peek()); )
      this._ch = this._input.next(), h && this._ch === `
` && (p === 0 || p < this._options.max_preserve_newlines) && (p++, this._output.add_new_line(!0));
    return f;
  }, d.prototype.foundNestedPseudoClass = function() {
    for (var h = 0, f = 1, p = this._input.peek(f); p; ) {
      if (p === "{")
        return !0;
      if (p === "(")
        h += 1;
      else if (p === ")") {
        if (h === 0)
          return !1;
        h -= 1;
      } else if (p === ";" || p === "}")
        return !1;
      f++, p = this._input.peek(f);
    }
    return !1;
  }, d.prototype.print_string = function(h) {
    this._output.set_indent(this._indentLevel), this._output.non_breaking_space = !0, this._output.add_token(h);
  }, d.prototype.preserveSingleSpace = function(h) {
    h && (this._output.space_before_token = !0);
  }, d.prototype.indent = function() {
    this._indentLevel++;
  }, d.prototype.outdent = function() {
    this._indentLevel > 0 && this._indentLevel--;
  }, d.prototype.beautify = function() {
    if (this._options.disabled)
      return this._source_text;
    var h = this._source_text, f = this._options.eol;
    f === "auto" && (f = `
`, h && s.test(h || "") && (f = h.match(s)[0])), h = h.replace(o, `
`);
    var p = h.match(/^[\t ]*/)[0];
    this._output = new e(this._options, p), this._input = new t(h), this._indentLevel = 0, this._nestedLevel = 0, this._ch = null;
    for (var _ = 0, m = !1, g = !1, y = !1, x = !1, k = !1, E = this._ch, S = !1, w, v, A; w = this._input.read(l), v = w !== "", A = E, this._ch = this._input.next(), this._ch === "\\" && this._input.hasNext() && (this._ch += this._input.next()), E = this._ch, this._ch; )
      if (this._ch === "/" && this._input.peek() === "*") {
        this._output.add_new_line(), this._input.back();
        var b = this._input.read(c), C = r.get_directives(b);
        C && C.ignore === "start" && (b += r.readIgnored(this._input)), this.print_string(b), this.eatWhitespace(!0), this._output.add_new_line();
      } else if (this._ch === "/" && this._input.peek() === "/")
        this._output.space_before_token = !0, this._input.back(), this.print_string(this._input.read(u)), this.eatWhitespace(!0);
      else if (this._ch === "$") {
        this.preserveSingleSpace(v), this.print_string(this._ch);
        var M = this._input.peekUntilAfter(/[: ,;{}()[\]\/='"]/g);
        M.match(/[ :]$/) && (M = this.eatString(": ").replace(/\s+$/, ""), this.print_string(M), this._output.space_before_token = !0), _ === 0 && M.indexOf(":") !== -1 && (g = !0, this.indent());
      } else if (this._ch === "@")
        if (this.preserveSingleSpace(v), this._input.peek() === "{")
          this.print_string(this._ch + this.eatString("}"));
        else {
          this.print_string(this._ch);
          var z = this._input.peekUntilAfter(/[: ,;{}()[\]\/='"]/g);
          z.match(/[ :]$/) && (z = this.eatString(": ").replace(/\s+$/, ""), this.print_string(z), this._output.space_before_token = !0), _ === 0 && z.indexOf(":") !== -1 ? (g = !0, this.indent()) : z in this.NESTED_AT_RULE ? (this._nestedLevel += 1, z in this.CONDITIONAL_GROUP_RULE && (y = !0)) : _ === 0 && !g && (x = !0);
        }
      else if (this._ch === "#" && this._input.peek() === "{")
        this.preserveSingleSpace(v), this.print_string(this._ch + this.eatString("}"));
      else if (this._ch === "{")
        g && (g = !1, this.outdent()), x = !1, y ? (y = !1, m = this._indentLevel >= this._nestedLevel) : m = this._indentLevel >= this._nestedLevel - 1, this._options.newline_between_rules && m && this._output.previous_line && this._output.previous_line.item(-1) !== "{" && this._output.ensure_empty_line_above("/", ","), this._output.space_before_token = !0, this._options.brace_style === "expand" ? (this._output.add_new_line(), this.print_string(this._ch), this.indent(), this._output.set_indent(this._indentLevel)) : (A === "(" ? this._output.space_before_token = !1 : A !== "," && this.indent(), this.print_string(this._ch)), this.eatWhitespace(!0), this._output.add_new_line();
      else if (this._ch === "}")
        this.outdent(), this._output.add_new_line(), A === "{" && this._output.trim(!0), g && (this.outdent(), g = !1), this.print_string(this._ch), m = !1, this._nestedLevel && this._nestedLevel--, this.eatWhitespace(!0), this._output.add_new_line(), this._options.newline_between_rules && !this._output.just_added_blankline() && this._input.peek() !== "}" && this._output.add_new_line(!0), this._input.peek() === ")" && (this._output.trim(!0), this._options.brace_style === "expand" && this._output.add_new_line(!0));
      else if (this._ch === ":") {
        for (var D = 0; D < this.NON_SEMICOLON_NEWLINE_PROPERTY.length; D++)
          if (this._input.lookBack(this.NON_SEMICOLON_NEWLINE_PROPERTY[D])) {
            S = !0;
            break;
          }
        (m || y) && !(this._input.lookBack("&") || this.foundNestedPseudoClass()) && !this._input.lookBack("(") && !x && _ === 0 ? (this.print_string(":"), g || (g = !0, this._output.space_before_token = !0, this.eatWhitespace(!0), this.indent())) : (this._input.lookBack(" ") && (this._output.space_before_token = !0), this._input.peek() === ":" ? (this._ch = this._input.next(), this.print_string("::")) : this.print_string(":"));
      } else if (this._ch === '"' || this._ch === "'") {
        var H = A === '"' || A === "'";
        this.preserveSingleSpace(H || v), this.print_string(this._ch + this.eatString(this._ch)), this.eatWhitespace(!0);
      } else if (this._ch === ";")
        S = !1, _ === 0 ? (g && (this.outdent(), g = !1), x = !1, this.print_string(this._ch), this.eatWhitespace(!0), this._input.peek() !== "/" && this._output.add_new_line()) : (this.print_string(this._ch), this.eatWhitespace(!0), this._output.space_before_token = !0);
      else if (this._ch === "(")
        if (this._input.lookBack("url"))
          this.print_string(this._ch), this.eatWhitespace(), _++, this.indent(), this._ch = this._input.next(), this._ch === ")" || this._ch === '"' || this._ch === "'" ? this._input.back() : this._ch && (this.print_string(this._ch + this.eatString(")")), _ && (_--, this.outdent()));
        else {
          var q = !1;
          this._input.lookBack("with") && (q = !0), this.preserveSingleSpace(v || q), this.print_string(this._ch), g && A === "$" && this._options.selector_separator_newline ? (this._output.add_new_line(), k = !0) : (this.eatWhitespace(), _++, this.indent());
        }
      else if (this._ch === ")")
        _ && (_--, this.outdent()), k && this._input.peek() === ";" && this._options.selector_separator_newline && (k = !1, this.outdent(), this._output.add_new_line()), this.print_string(this._ch);
      else if (this._ch === ",")
        this.print_string(this._ch), this.eatWhitespace(!0), this._options.selector_separator_newline && (!g || k) && _ === 0 && !x ? this._output.add_new_line() : this._output.space_before_token = !0;
      else if ((this._ch === ">" || this._ch === "+" || this._ch === "~") && !g && _ === 0)
        this._options.space_around_combinator ? (this._output.space_before_token = !0, this.print_string(this._ch), this._output.space_before_token = !0) : (this.print_string(this._ch), this.eatWhitespace(), this._ch && a.test(this._ch) && (this._ch = ""));
      else if (this._ch === "]")
        this.print_string(this._ch);
      else if (this._ch === "[")
        this.preserveSingleSpace(v), this.print_string(this._ch);
      else if (this._ch === "=")
        this.eatWhitespace(), this.print_string("="), a.test(this._ch) && (this._ch = "");
      else if (this._ch === "!" && !this._input.lookBack("\\"))
        this._output.space_before_token = !0, this.print_string(this._ch);
      else {
        var G = A === '"' || A === "'";
        this.preserveSingleSpace(G || v), this.print_string(this._ch), !this._output.just_added_newline() && this._input.peek() === `
` && S && this._output.add_new_line();
      }
    var ae = this._output.get_code(f);
    return ae;
  }, Pl.Beautifier = d, Pl;
}
var of;
function Yk() {
  if (of) return Ys.exports;
  of = 1;
  var n = Xk().Beautifier, e = Zg().Options;
  function t(i, r) {
    var s = new n(i, r);
    return s.beautify();
  }
  return Ys.exports = t, Ys.exports.defaultOptions = function() {
    return new e();
  }, Ys.exports;
}
var Zs = { exports: {} }, $l = {}, zl = {}, af;
function Qg() {
  if (af) return zl;
  af = 1;
  var n = Uu().Options;
  function e(t) {
    n.call(this, t, "html"), this.templating.length === 1 && this.templating[0] === "auto" && (this.templating = ["django", "erb", "handlebars", "php"]), this.indent_inner_html = this._get_boolean("indent_inner_html"), this.indent_body_inner_html = this._get_boolean("indent_body_inner_html", !0), this.indent_head_inner_html = this._get_boolean("indent_head_inner_html", !0), this.indent_handlebars = this._get_boolean("indent_handlebars", !0), this.wrap_attributes = this._get_selection(
      "wrap_attributes",
      ["auto", "force", "force-aligned", "force-expand-multiline", "aligned-multiple", "preserve", "preserve-aligned"]
    ), this.wrap_attributes_min_attrs = this._get_number("wrap_attributes_min_attrs", 2), this.wrap_attributes_indent_size = this._get_number("wrap_attributes_indent_size", this.indent_size), this.extra_liners = this._get_array("extra_liners", ["head", "body", "/html"]), this.inline = this._get_array("inline", [
      "a",
      "abbr",
      "area",
      "audio",
      "b",
      "bdi",
      "bdo",
      "br",
      "button",
      "canvas",
      "cite",
      "code",
      "data",
      "datalist",
      "del",
      "dfn",
      "em",
      "embed",
      "i",
      "iframe",
      "img",
      "input",
      "ins",
      "kbd",
      "keygen",
      "label",
      "map",
      "mark",
      "math",
      "meter",
      "noscript",
      "object",
      "output",
      "progress",
      "q",
      "ruby",
      "s",
      "samp",
      /* 'script', */
      "select",
      "small",
      "span",
      "strong",
      "sub",
      "sup",
      "svg",
      "template",
      "textarea",
      "time",
      "u",
      "var",
      "video",
      "wbr",
      "text",
      // obsolete inline tags
      "acronym",
      "big",
      "strike",
      "tt"
    ]), this.inline_custom_elements = this._get_boolean("inline_custom_elements", !0), this.void_elements = this._get_array("void_elements", [
      // HTLM void elements - aka self-closing tags - aka singletons
      // https://www.w3.org/html/wg/drafts/html/master/syntax.html#void-elements
      "area",
      "base",
      "br",
      "col",
      "embed",
      "hr",
      "img",
      "input",
      "keygen",
      "link",
      "menuitem",
      "meta",
      "param",
      "source",
      "track",
      "wbr",
      // NOTE: Optional tags are too complex for a simple list
      // they are hard coded in _do_optional_end_element
      // Doctype and xml elements
      "!doctype",
      "?xml",
      // obsolete tags
      // basefont: https://www.computerhope.com/jargon/h/html-basefont-tag.htm
      // isndex: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/isindex
      "basefont",
      "isindex"
    ]), this.unformatted = this._get_array("unformatted", []), this.content_unformatted = this._get_array("content_unformatted", [
      "pre",
      "textarea"
    ]), this.unformatted_content_delimiter = this._get_characters("unformatted_content_delimiter"), this.indent_scripts = this._get_selection("indent_scripts", ["normal", "keep", "separate"]);
  }
  return e.prototype = new n(), zl.Options = e, zl;
}
var Qs = {}, lf;
function cf() {
  if (lf) return Qs;
  lf = 1;
  var n = jo().Tokenizer, e = jo().TOKEN, t = qu().Directives, i = Yg().TemplatablePattern, r = Ka().Pattern, s = {
    TAG_OPEN: "TK_TAG_OPEN",
    TAG_CLOSE: "TK_TAG_CLOSE",
    CONTROL_FLOW_OPEN: "TK_CONTROL_FLOW_OPEN",
    CONTROL_FLOW_CLOSE: "TK_CONTROL_FLOW_CLOSE",
    ATTRIBUTE: "TK_ATTRIBUTE",
    EQUALS: "TK_EQUALS",
    VALUE: "TK_VALUE",
    COMMENT: "TK_COMMENT",
    TEXT: "TK_TEXT",
    UNKNOWN: "TK_UNKNOWN",
    START: e.START,
    RAW: e.RAW,
    EOF: e.EOF
  }, o = new t(/<\!--/, /-->/), a = function(l, c) {
    n.call(this, l, c), this._current_tag_name = "";
    var u = new i(this._input).read_options(this._options), d = new r(this._input);
    if (this.__patterns = {
      word: u.until(/[\n\r\t <]/),
      word_control_flow_close_excluded: u.until(/[\n\r\t <}]/),
      single_quote: u.until_after(/'/),
      double_quote: u.until_after(/"/),
      attribute: u.until(/[\n\r\t =>]|\/>/),
      element_name: u.until(/[\n\r\t >\/]/),
      angular_control_flow_start: d.matching(/\@[a-zA-Z]+[^({]*[({]/),
      handlebars_comment: d.starting_with(/{{!--/).until_after(/--}}/),
      handlebars: d.starting_with(/{{/).until_after(/}}/),
      handlebars_open: d.until(/[\n\r\t }]/),
      handlebars_raw_close: d.until(/}}/),
      comment: d.starting_with(/<!--/).until_after(/-->/),
      cdata: d.starting_with(/<!\[CDATA\[/).until_after(/]]>/),
      // https://en.wikipedia.org/wiki/Conditional_comment
      conditional_comment: d.starting_with(/<!\[/).until_after(/]>/),
      processing: d.starting_with(/<\?/).until_after(/\?>/)
    }, this._options.indent_handlebars && (this.__patterns.word = this.__patterns.word.exclude("handlebars"), this.__patterns.word_control_flow_close_excluded = this.__patterns.word_control_flow_close_excluded.exclude("handlebars")), this._unformatted_content_delimiter = null, this._options.unformatted_content_delimiter) {
      var h = this._input.get_literal_regexp(this._options.unformatted_content_delimiter);
      this.__patterns.unformatted_content_delimiter = d.matching(h).until_after(h);
    }
  };
  return a.prototype = new n(), a.prototype._is_comment = function(l) {
    return !1;
  }, a.prototype._is_opening = function(l) {
    return l.type === s.TAG_OPEN || l.type === s.CONTROL_FLOW_OPEN;
  }, a.prototype._is_closing = function(l, c) {
    return l.type === s.TAG_CLOSE && c && ((l.text === ">" || l.text === "/>") && c.text[0] === "<" || l.text === "}}" && c.text[0] === "{" && c.text[1] === "{") || l.type === s.CONTROL_FLOW_CLOSE && l.text === "}" && c.text.endsWith("{");
  }, a.prototype._reset = function() {
    this._current_tag_name = "";
  }, a.prototype._get_next_token = function(l, c) {
    var u = null;
    this._readWhitespace();
    var d = this._input.peek();
    return d === null ? this._create_token(s.EOF, "") : (u = u || this._read_open_handlebars(d, c), u = u || this._read_attribute(d, l, c), u = u || this._read_close(d, c), u = u || this._read_script_and_style(d, l), u = u || this._read_control_flows(d, c), u = u || this._read_raw_content(d, l, c), u = u || this._read_content_word(d, c), u = u || this._read_comment_or_cdata(d), u = u || this._read_processing(d), u = u || this._read_open(d, c), u = u || this._create_token(s.UNKNOWN, this._input.next()), u);
  }, a.prototype._read_comment_or_cdata = function(l) {
    var c = null, u = null, d = null;
    if (l === "<") {
      var h = this._input.peek(1);
      h === "!" && (u = this.__patterns.comment.read(), u ? (d = o.get_directives(u), d && d.ignore === "start" && (u += o.readIgnored(this._input))) : u = this.__patterns.cdata.read()), u && (c = this._create_token(s.COMMENT, u), c.directives = d);
    }
    return c;
  }, a.prototype._read_processing = function(l) {
    var c = null, u = null, d = null;
    if (l === "<") {
      var h = this._input.peek(1);
      (h === "!" || h === "?") && (u = this.__patterns.conditional_comment.read(), u = u || this.__patterns.processing.read()), u && (c = this._create_token(s.COMMENT, u), c.directives = d);
    }
    return c;
  }, a.prototype._read_open = function(l, c) {
    var u = null, d = null;
    return (!c || c.type === s.CONTROL_FLOW_OPEN) && l === "<" && (u = this._input.next(), this._input.peek() === "/" && (u += this._input.next()), u += this.__patterns.element_name.read(), d = this._create_token(s.TAG_OPEN, u)), d;
  }, a.prototype._read_open_handlebars = function(l, c) {
    var u = null, d = null;
    return (!c || c.type === s.CONTROL_FLOW_OPEN) && (this._options.templating.includes("angular") || this._options.indent_handlebars) && l === "{" && this._input.peek(1) === "{" && (this._options.indent_handlebars && this._input.peek(2) === "!" ? (u = this.__patterns.handlebars_comment.read(), u = u || this.__patterns.handlebars.read(), d = this._create_token(s.COMMENT, u)) : (u = this.__patterns.handlebars_open.read(), d = this._create_token(s.TAG_OPEN, u))), d;
  }, a.prototype._read_control_flows = function(l, c) {
    var u = "", d = null;
    if (!this._options.templating.includes("angular"))
      return d;
    if (l === "@") {
      if (u = this.__patterns.angular_control_flow_start.read(), u === "")
        return d;
      for (var h = u.endsWith("(") ? 1 : 0, f = 0; !(u.endsWith("{") && h === f); ) {
        var p = this._input.next();
        if (p === null)
          break;
        p === "(" ? h++ : p === ")" && f++, u += p;
      }
      d = this._create_token(s.CONTROL_FLOW_OPEN, u);
    } else l === "}" && c && c.type === s.CONTROL_FLOW_OPEN && (u = this._input.next(), d = this._create_token(s.CONTROL_FLOW_CLOSE, u));
    return d;
  }, a.prototype._read_close = function(l, c) {
    var u = null, d = null;
    return c && c.type === s.TAG_OPEN && (c.text[0] === "<" && (l === ">" || l === "/" && this._input.peek(1) === ">") ? (u = this._input.next(), l === "/" && (u += this._input.next()), d = this._create_token(s.TAG_CLOSE, u)) : c.text[0] === "{" && l === "}" && this._input.peek(1) === "}" && (this._input.next(), this._input.next(), d = this._create_token(s.TAG_CLOSE, "}}"))), d;
  }, a.prototype._read_attribute = function(l, c, u) {
    var d = null, h = "";
    if (u && u.text[0] === "<")
      if (l === "=")
        d = this._create_token(s.EQUALS, this._input.next());
      else if (l === '"' || l === "'") {
        var f = this._input.next();
        l === '"' ? f += this.__patterns.double_quote.read() : f += this.__patterns.single_quote.read(), d = this._create_token(s.VALUE, f);
      } else
        h = this.__patterns.attribute.read(), h && (c.type === s.EQUALS ? d = this._create_token(s.VALUE, h) : d = this._create_token(s.ATTRIBUTE, h));
    return d;
  }, a.prototype._is_content_unformatted = function(l) {
    return this._options.void_elements.indexOf(l) === -1 && (this._options.content_unformatted.indexOf(l) !== -1 || this._options.unformatted.indexOf(l) !== -1);
  }, a.prototype._read_raw_content = function(l, c, u) {
    var d = "";
    if (u && u.text[0] === "{")
      d = this.__patterns.handlebars_raw_close.read();
    else if (c.type === s.TAG_CLOSE && c.opened.text[0] === "<" && c.text[0] !== "/") {
      var h = c.opened.text.substr(1).toLowerCase();
      this._is_content_unformatted(h) && (d = this._input.readUntil(new RegExp("</" + h + "[\\n\\r\\t ]*?>", "ig")));
    }
    return d ? this._create_token(s.TEXT, d) : null;
  }, a.prototype._read_script_and_style = function(l, c) {
    if (c.type === s.TAG_CLOSE && c.opened.text[0] === "<" && c.text[0] !== "/") {
      var u = c.opened.text.substr(1).toLowerCase();
      if (u === "script" || u === "style") {
        var d = this._read_comment_or_cdata(l);
        if (d)
          return d.type = s.TEXT, d;
        var h = this._input.readUntil(new RegExp("</" + u + "[\\n\\r\\t ]*?>", "ig"));
        if (h)
          return this._create_token(s.TEXT, h);
      }
    }
    return null;
  }, a.prototype._read_content_word = function(l, c) {
    var u = "";
    return this._options.unformatted_content_delimiter && l === this._options.unformatted_content_delimiter[0] && (u = this.__patterns.unformatted_content_delimiter.read()), u || (u = c && c.type === s.CONTROL_FLOW_OPEN ? this.__patterns.word_control_flow_close_excluded.read() : this.__patterns.word.read()), u ? this._create_token(s.TEXT, u) : null;
  }, Qs.Tokenizer = a, Qs.TOKEN = s, Qs;
}
var uf;
function Zk() {
  if (uf) return $l;
  uf = 1;
  var n = Qg().Options, e = Wu().Output, t = cf().Tokenizer, i = cf().TOKEN, r = /\r\n|[\r\n]/, s = /\r\n|[\r\n]/g, o = function(m, g) {
    this.indent_level = 0, this.alignment_size = 0, this.max_preserve_newlines = m.max_preserve_newlines, this.preserve_newlines = m.preserve_newlines, this._output = new e(m, g);
  };
  o.prototype.current_line_has_match = function(m) {
    return this._output.current_line.has_match(m);
  }, o.prototype.set_space_before_token = function(m, g) {
    this._output.space_before_token = m, this._output.non_breaking_space = g;
  }, o.prototype.set_wrap_point = function() {
    this._output.set_indent(this.indent_level, this.alignment_size), this._output.set_wrap_point();
  }, o.prototype.add_raw_token = function(m) {
    this._output.add_raw_token(m);
  }, o.prototype.print_preserved_newlines = function(m) {
    var g = 0;
    m.type !== i.TEXT && m.previous.type !== i.TEXT && (g = m.newlines ? 1 : 0), this.preserve_newlines && (g = m.newlines < this.max_preserve_newlines + 1 ? m.newlines : this.max_preserve_newlines + 1);
    for (var y = 0; y < g; y++)
      this.print_newline(y > 0);
    return g !== 0;
  }, o.prototype.traverse_whitespace = function(m) {
    return m.whitespace_before || m.newlines ? (this.print_preserved_newlines(m) || (this._output.space_before_token = !0), !0) : !1;
  }, o.prototype.previous_token_wrapped = function() {
    return this._output.previous_token_wrapped;
  }, o.prototype.print_newline = function(m) {
    this._output.add_new_line(m);
  }, o.prototype.print_token = function(m) {
    m.text && (this._output.set_indent(this.indent_level, this.alignment_size), this._output.add_token(m.text));
  }, o.prototype.indent = function() {
    this.indent_level++;
  }, o.prototype.deindent = function() {
    this.indent_level > 0 && (this.indent_level--, this._output.set_indent(this.indent_level, this.alignment_size));
  }, o.prototype.get_full_indent = function(m) {
    return m = this.indent_level + (m || 0), m < 1 ? "" : this._output.get_indent_string(m);
  };
  var a = function(m) {
    for (var g = null, y = m.next; y.type !== i.EOF && m.closed !== y; ) {
      if (y.type === i.ATTRIBUTE && y.text === "type") {
        y.next && y.next.type === i.EQUALS && y.next.next && y.next.next.type === i.VALUE && (g = y.next.next.text);
        break;
      }
      y = y.next;
    }
    return g;
  }, l = function(m, g) {
    var y = null, x = null;
    return g.closed ? (m === "script" ? y = "text/javascript" : m === "style" && (y = "text/css"), y = a(g) || y, y.search("text/css") > -1 ? x = "css" : y.search(/module|((text|application|dojo)\/(x-)?(javascript|ecmascript|jscript|livescript|(ld\+)?json|method|aspect))/) > -1 ? x = "javascript" : y.search(/(text|application|dojo)\/(x-)?(html)/) > -1 ? x = "html" : y.search(/test\/null/) > -1 && (x = "null"), x) : null;
  };
  function c(m, g) {
    return g.indexOf(m) !== -1;
  }
  function u(m, g, y) {
    this.parent = m || null, this.tag = g ? g.tag_name : "", this.indent_level = y || 0, this.parser_token = g || null;
  }
  function d(m) {
    this._printer = m, this._current_frame = null;
  }
  d.prototype.get_parser_token = function() {
    return this._current_frame ? this._current_frame.parser_token : null;
  }, d.prototype.record_tag = function(m) {
    var g = new u(this._current_frame, m, this._printer.indent_level);
    this._current_frame = g;
  }, d.prototype._try_pop_frame = function(m) {
    var g = null;
    return m && (g = m.parser_token, this._printer.indent_level = m.indent_level, this._current_frame = m.parent), g;
  }, d.prototype._get_frame = function(m, g) {
    for (var y = this._current_frame; y && m.indexOf(y.tag) === -1; ) {
      if (g && g.indexOf(y.tag) !== -1) {
        y = null;
        break;
      }
      y = y.parent;
    }
    return y;
  }, d.prototype.try_pop = function(m, g) {
    var y = this._get_frame([m], g);
    return this._try_pop_frame(y);
  }, d.prototype.indent_to_tag = function(m) {
    var g = this._get_frame(m);
    g && (this._printer.indent_level = g.indent_level);
  };
  function h(m, g, y, x) {
    this._source_text = m || "", g = g || {}, this._js_beautify = y, this._css_beautify = x, this._tag_stack = null;
    var k = new n(g, "html");
    this._options = k, this._is_wrap_attributes_force = this._options.wrap_attributes.substr(0, 5) === "force", this._is_wrap_attributes_force_expand_multiline = this._options.wrap_attributes === "force-expand-multiline", this._is_wrap_attributes_force_aligned = this._options.wrap_attributes === "force-aligned", this._is_wrap_attributes_aligned_multiple = this._options.wrap_attributes === "aligned-multiple", this._is_wrap_attributes_preserve = this._options.wrap_attributes.substr(0, 8) === "preserve", this._is_wrap_attributes_preserve_aligned = this._options.wrap_attributes === "preserve-aligned";
  }
  h.prototype.beautify = function() {
    if (this._options.disabled)
      return this._source_text;
    var m = this._source_text, g = this._options.eol;
    this._options.eol === "auto" && (g = `
`, m && r.test(m) && (g = m.match(r)[0])), m = m.replace(s, `
`);
    var y = m.match(/^[\t ]*/)[0], x = {
      text: "",
      type: ""
    }, k = new f(this._options), E = new o(this._options, y), S = new t(m, this._options).tokenize();
    this._tag_stack = new d(E);
    for (var w = null, v = S.next(); v.type !== i.EOF; )
      v.type === i.TAG_OPEN || v.type === i.COMMENT ? (w = this._handle_tag_open(E, v, k, x, S), k = w) : v.type === i.ATTRIBUTE || v.type === i.EQUALS || v.type === i.VALUE || v.type === i.TEXT && !k.tag_complete ? w = this._handle_inside_tag(E, v, k, x) : v.type === i.TAG_CLOSE ? w = this._handle_tag_close(E, v, k) : v.type === i.TEXT ? w = this._handle_text(E, v, k) : v.type === i.CONTROL_FLOW_OPEN ? w = this._handle_control_flow_open(E, v) : v.type === i.CONTROL_FLOW_CLOSE ? w = this._handle_control_flow_close(E, v) : E.add_raw_token(v), x = w, v = S.next();
    var A = E._output.get_code(g);
    return A;
  }, h.prototype._handle_control_flow_open = function(m, g) {
    var y = {
      text: g.text,
      type: g.type
    };
    return m.set_space_before_token(g.newlines || g.whitespace_before !== "", !0), g.newlines ? m.print_preserved_newlines(g) : m.set_space_before_token(g.newlines || g.whitespace_before !== "", !0), m.print_token(g), m.indent(), y;
  }, h.prototype._handle_control_flow_close = function(m, g) {
    var y = {
      text: g.text,
      type: g.type
    };
    return m.deindent(), g.newlines ? m.print_preserved_newlines(g) : m.set_space_before_token(g.newlines || g.whitespace_before !== "", !0), m.print_token(g), y;
  }, h.prototype._handle_tag_close = function(m, g, y) {
    var x = {
      text: g.text,
      type: g.type
    };
    return m.alignment_size = 0, y.tag_complete = !0, m.set_space_before_token(g.newlines || g.whitespace_before !== "", !0), y.is_unformatted ? m.add_raw_token(g) : (y.tag_start_char === "<" && (m.set_space_before_token(g.text[0] === "/", !0), this._is_wrap_attributes_force_expand_multiline && y.has_wrapped_attrs && m.print_newline(!1)), m.print_token(g)), y.indent_content && !(y.is_unformatted || y.is_content_unformatted) && (m.indent(), y.indent_content = !1), !y.is_inline_element && !(y.is_unformatted || y.is_content_unformatted) && m.set_wrap_point(), x;
  }, h.prototype._handle_inside_tag = function(m, g, y, x) {
    var k = y.has_wrapped_attrs, E = {
      text: g.text,
      type: g.type
    };
    return m.set_space_before_token(g.newlines || g.whitespace_before !== "", !0), y.is_unformatted ? m.add_raw_token(g) : y.tag_start_char === "{" && g.type === i.TEXT ? m.print_preserved_newlines(g) ? (g.newlines = 0, m.add_raw_token(g)) : m.print_token(g) : (g.type === i.ATTRIBUTE ? m.set_space_before_token(!0) : (g.type === i.EQUALS || g.type === i.VALUE && g.previous.type === i.EQUALS) && m.set_space_before_token(!1), g.type === i.ATTRIBUTE && y.tag_start_char === "<" && ((this._is_wrap_attributes_preserve || this._is_wrap_attributes_preserve_aligned) && (m.traverse_whitespace(g), k = k || g.newlines !== 0), this._is_wrap_attributes_force && y.attr_count >= this._options.wrap_attributes_min_attrs && (x.type !== i.TAG_OPEN || // ie. second attribute and beyond
    this._is_wrap_attributes_force_expand_multiline) && (m.print_newline(!1), k = !0)), m.print_token(g), k = k || m.previous_token_wrapped(), y.has_wrapped_attrs = k), E;
  }, h.prototype._handle_text = function(m, g, y) {
    var x = {
      text: g.text,
      type: "TK_CONTENT"
    };
    return y.custom_beautifier_name ? this._print_custom_beatifier_text(m, g, y) : y.is_unformatted || y.is_content_unformatted ? m.add_raw_token(g) : (m.traverse_whitespace(g), m.print_token(g)), x;
  }, h.prototype._print_custom_beatifier_text = function(m, g, y) {
    var x = this;
    if (g.text !== "") {
      var k = g.text, E, S = 1, w = "", v = "";
      y.custom_beautifier_name === "javascript" && typeof this._js_beautify == "function" ? E = this._js_beautify : y.custom_beautifier_name === "css" && typeof this._css_beautify == "function" ? E = this._css_beautify : y.custom_beautifier_name === "html" && (E = function(D, H) {
        var q = new h(D, H, x._js_beautify, x._css_beautify);
        return q.beautify();
      }), this._options.indent_scripts === "keep" ? S = 0 : this._options.indent_scripts === "separate" && (S = -m.indent_level);
      var A = m.get_full_indent(S);
      if (k = k.replace(/\n[ \t]*$/, ""), y.custom_beautifier_name !== "html" && k[0] === "<" && k.match(/^(<!--|<!\[CDATA\[)/)) {
        var b = /^(<!--[^\n]*|<!\[CDATA\[)(\n?)([ \t\n]*)([\s\S]*)(-->|]]>)$/.exec(k);
        if (!b) {
          m.add_raw_token(g);
          return;
        }
        w = A + b[1] + `
`, k = b[4], b[5] && (v = A + b[5]), k = k.replace(/\n[ \t]*$/, ""), (b[2] || b[3].indexOf(`
`) !== -1) && (b = b[3].match(/[ \t]+$/), b && (g.whitespace_before = b[0]));
      }
      if (k)
        if (E) {
          var C = function() {
            this.eol = `
`;
          };
          C.prototype = this._options.raw_options;
          var M = new C();
          k = E(A + k, M);
        } else {
          var z = g.whitespace_before;
          z && (k = k.replace(new RegExp(`
(` + z + ")?", "g"), `
`)), k = A + k.replace(/\n/g, `
` + A);
        }
      w && (k ? k = w + k + `
` + v : k = w + v), m.print_newline(!1), k && (g.text = k, g.whitespace_before = "", g.newlines = 0, m.add_raw_token(g), m.print_newline(!0));
    }
  }, h.prototype._handle_tag_open = function(m, g, y, x, k) {
    var E = this._get_tag_open_token(g);
    if ((y.is_unformatted || y.is_content_unformatted) && !y.is_empty_element && g.type === i.TAG_OPEN && !E.is_start_tag ? (m.add_raw_token(g), E.start_tag_token = this._tag_stack.try_pop(E.tag_name)) : (m.traverse_whitespace(g), this._set_tag_position(m, g, E, y, x), E.is_inline_element || m.set_wrap_point(), m.print_token(g)), E.is_start_tag && this._is_wrap_attributes_force) {
      var S = 0, w;
      do
        w = k.peek(S), w.type === i.ATTRIBUTE && (E.attr_count += 1), S += 1;
      while (w.type !== i.EOF && w.type !== i.TAG_CLOSE);
    }
    return (this._is_wrap_attributes_force_aligned || this._is_wrap_attributes_aligned_multiple || this._is_wrap_attributes_preserve_aligned) && (E.alignment_size = g.text.length + 1), !E.tag_complete && !E.is_unformatted && (m.alignment_size = E.alignment_size), E;
  };
  var f = function(m, g, y) {
    if (this.parent = g || null, this.text = "", this.type = "TK_TAG_OPEN", this.tag_name = "", this.is_inline_element = !1, this.is_unformatted = !1, this.is_content_unformatted = !1, this.is_empty_element = !1, this.is_start_tag = !1, this.is_end_tag = !1, this.indent_content = !1, this.multiline_content = !1, this.custom_beautifier_name = null, this.start_tag_token = null, this.attr_count = 0, this.has_wrapped_attrs = !1, this.alignment_size = 0, this.tag_complete = !1, this.tag_start_char = "", this.tag_check = "", !y)
      this.tag_complete = !0;
    else {
      var x;
      this.tag_start_char = y.text[0], this.text = y.text, this.tag_start_char === "<" ? (x = y.text.match(/^<([^\s>]*)/), this.tag_check = x ? x[1] : "") : (x = y.text.match(/^{{~?(?:[\^]|#\*?)?([^\s}]+)/), this.tag_check = x ? x[1] : "", (y.text.startsWith("{{#>") || y.text.startsWith("{{~#>")) && this.tag_check[0] === ">" && (this.tag_check === ">" && y.next !== null ? this.tag_check = y.next.text.split(" ")[0] : this.tag_check = y.text.split(">")[1])), this.tag_check = this.tag_check.toLowerCase(), y.type === i.COMMENT && (this.tag_complete = !0), this.is_start_tag = this.tag_check.charAt(0) !== "/", this.tag_name = this.is_start_tag ? this.tag_check : this.tag_check.substr(1), this.is_end_tag = !this.is_start_tag || y.closed && y.closed.text === "/>";
      var k = 2;
      this.tag_start_char === "{" && this.text.length >= 3 && this.text.charAt(2) === "~" && (k = 3), this.is_end_tag = this.is_end_tag || this.tag_start_char === "{" && (!m.indent_handlebars || this.text.length < 3 || /[^#\^]/.test(this.text.charAt(k)));
    }
  };
  h.prototype._get_tag_open_token = function(m) {
    var g = new f(this._options, this._tag_stack.get_parser_token(), m);
    return g.alignment_size = this._options.wrap_attributes_indent_size, g.is_end_tag = g.is_end_tag || c(g.tag_check, this._options.void_elements), g.is_empty_element = g.tag_complete || g.is_start_tag && g.is_end_tag, g.is_unformatted = !g.tag_complete && c(g.tag_check, this._options.unformatted), g.is_content_unformatted = !g.is_empty_element && c(g.tag_check, this._options.content_unformatted), g.is_inline_element = c(g.tag_name, this._options.inline) || this._options.inline_custom_elements && g.tag_name.includes("-") || g.tag_start_char === "{", g;
  }, h.prototype._set_tag_position = function(m, g, y, x, k) {
    if (y.is_empty_element || (y.is_end_tag ? y.start_tag_token = this._tag_stack.try_pop(y.tag_name) : (this._do_optional_end_element(y) && (y.is_inline_element || m.print_newline(!1)), this._tag_stack.record_tag(y), (y.tag_name === "script" || y.tag_name === "style") && !(y.is_unformatted || y.is_content_unformatted) && (y.custom_beautifier_name = l(y.tag_check, g)))), c(y.tag_check, this._options.extra_liners) && (m.print_newline(!1), m._output.just_added_blankline() || m.print_newline(!0)), y.is_empty_element) {
      if (y.tag_start_char === "{" && y.tag_check === "else") {
        this._tag_stack.indent_to_tag(["if", "unless", "each"]), y.indent_content = !0;
        var E = m.current_line_has_match(/{{#if/);
        E || m.print_newline(!1);
      }
      y.tag_name === "!--" && k.type === i.TAG_CLOSE && x.is_end_tag && y.text.indexOf(`
`) === -1 || (y.is_inline_element || y.is_unformatted || m.print_newline(!1), this._calcluate_parent_multiline(m, y));
    } else if (y.is_end_tag) {
      var S = !1;
      S = y.start_tag_token && y.start_tag_token.multiline_content, S = S || !y.is_inline_element && !(x.is_inline_element || x.is_unformatted) && !(k.type === i.TAG_CLOSE && y.start_tag_token === x) && k.type !== "TK_CONTENT", (y.is_content_unformatted || y.is_unformatted) && (S = !1), S && m.print_newline(!1);
    } else
      y.indent_content = !y.custom_beautifier_name, y.tag_start_char === "<" && (y.tag_name === "html" ? y.indent_content = this._options.indent_inner_html : y.tag_name === "head" ? y.indent_content = this._options.indent_head_inner_html : y.tag_name === "body" && (y.indent_content = this._options.indent_body_inner_html)), !(y.is_inline_element || y.is_unformatted) && (k.type !== "TK_CONTENT" || y.is_content_unformatted) && m.print_newline(!1), this._calcluate_parent_multiline(m, y);
  }, h.prototype._calcluate_parent_multiline = function(m, g) {
    g.parent && m._output.just_added_newline() && !((g.is_inline_element || g.is_unformatted) && g.parent.is_inline_element) && (g.parent.multiline_content = !0);
  };
  var p = ["address", "article", "aside", "blockquote", "details", "div", "dl", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hr", "main", "menu", "nav", "ol", "p", "pre", "section", "table", "ul"], _ = ["a", "audio", "del", "ins", "map", "noscript", "video"];
  return h.prototype._do_optional_end_element = function(m) {
    var g = null;
    if (!(m.is_empty_element || !m.is_start_tag || !m.parent)) {
      if (m.tag_name === "body")
        g = g || this._tag_stack.try_pop("head");
      else if (m.tag_name === "li")
        g = g || this._tag_stack.try_pop("li", ["ol", "ul", "menu"]);
      else if (m.tag_name === "dd" || m.tag_name === "dt")
        g = g || this._tag_stack.try_pop("dt", ["dl"]), g = g || this._tag_stack.try_pop("dd", ["dl"]);
      else if (m.parent.tag_name === "p" && p.indexOf(m.tag_name) !== -1) {
        var y = m.parent.parent;
        (!y || _.indexOf(y.tag_name) === -1) && (g = g || this._tag_stack.try_pop("p"));
      } else m.tag_name === "rp" || m.tag_name === "rt" ? (g = g || this._tag_stack.try_pop("rt", ["ruby", "rtc"]), g = g || this._tag_stack.try_pop("rp", ["ruby", "rtc"])) : m.tag_name === "optgroup" ? g = g || this._tag_stack.try_pop("optgroup", ["select"]) : m.tag_name === "option" ? g = g || this._tag_stack.try_pop("option", ["select", "datalist", "optgroup"]) : m.tag_name === "colgroup" ? g = g || this._tag_stack.try_pop("caption", ["table"]) : m.tag_name === "thead" ? (g = g || this._tag_stack.try_pop("caption", ["table"]), g = g || this._tag_stack.try_pop("colgroup", ["table"])) : m.tag_name === "tbody" || m.tag_name === "tfoot" ? (g = g || this._tag_stack.try_pop("caption", ["table"]), g = g || this._tag_stack.try_pop("colgroup", ["table"]), g = g || this._tag_stack.try_pop("thead", ["table"]), g = g || this._tag_stack.try_pop("tbody", ["table"])) : m.tag_name === "tr" ? (g = g || this._tag_stack.try_pop("caption", ["table"]), g = g || this._tag_stack.try_pop("colgroup", ["table"]), g = g || this._tag_stack.try_pop("tr", ["table", "thead", "tbody", "tfoot"])) : (m.tag_name === "th" || m.tag_name === "td") && (g = g || this._tag_stack.try_pop("td", ["table", "thead", "tbody", "tfoot", "tr"]), g = g || this._tag_stack.try_pop("th", ["table", "thead", "tbody", "tfoot", "tr"]));
      return m.parent = this._tag_stack.get_parser_token(), g;
    }
  }, $l.Beautifier = h, $l;
}
var df;
function Qk() {
  if (df) return Zs.exports;
  df = 1;
  var n = Zk().Beautifier, e = Qg().Options;
  function t(i, r, s, o) {
    var a = new n(i, r, s, o);
    return a.beautify();
  }
  return Zs.exports = t, Zs.exports.defaultOptions = function() {
    return new e();
  }, Zs.exports;
}
var hf;
function e2() {
  if (hf) return Lr;
  hf = 1;
  var n = Jk(), e = Yk(), t = Qk();
  function i(r, s, o, a) {
    return o = o || n, a = a || e, t(r, s, o, a);
  }
  return i.defaultOptions = t.defaultOptions, Lr.js = n, Lr.css = e, Lr.html = i, Lr;
}
var ff;
function t2() {
  return ff || (ff = 1, function(n) {
    function e(t, i, r) {
      var s = function(o, a) {
        return t.js_beautify(o, a);
      };
      return s.js = t.js_beautify, s.css = i.css_beautify, s.html = r.html_beautify, s.js_beautify = t.js_beautify, s.css_beautify = i.css_beautify, s.html_beautify = r.html_beautify, s;
    }
    (function(t) {
      var i = e2();
      i.js_beautify = i.js, i.css_beautify = i.css, i.html_beautify = i.html, t.exports = e(i, i, i);
    })(n);
  }(kl)), kl.exports;
}
var e_ = t2(), n2 = Ne.create({
  name: "doc",
  topNode: !0,
  content: "block+",
  renderMarkdown: (n, e) => n.content ? e.renderChildren(n.content, `

`) : ""
}), i2 = Ne.create({
  name: "text",
  group: "inline",
  parseMarkdown: (n) => ({
    type: "text",
    text: n.text || ""
  }),
  renderMarkdown: (n) => n.text || ""
}), r2 = Jt.create({
  name: "subscript",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "sub"
      },
      {
        style: "vertical-align",
        getAttrs(n) {
          return n !== "sub" ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["sub", Ee(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setSubscript: () => ({ commands: n }) => n.setMark(this.name),
      toggleSubscript: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetSubscript: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-,": () => this.editor.commands.toggleSubscript()
    };
  }
}), s2 = Jt.create({
  name: "superscript",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "sup"
      },
      {
        style: "vertical-align",
        getAttrs(n) {
          return n !== "super" ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["sup", Ee(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setSuperscript: () => ({ commands: n }) => n.setMark(this.name),
      toggleSuperscript: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetSuperscript: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-.": () => this.editor.commands.toggleSuperscript()
    };
  }
}), o2 = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/, a2 = Ne.create({
  name: "image",
  addOptions() {
    return {
      inline: !1,
      allowBase64: !1,
      HTMLAttributes: {},
      resize: !1
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      },
      width: {
        default: null
      },
      height: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: this.options.allowBase64 ? "img[src]" : 'img[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["img", Ee(this.options.HTMLAttributes, n)];
  },
  parseMarkdown: (n, e) => e.createNode("image", {
    src: n.href,
    title: n.title,
    alt: n.text
  }),
  renderMarkdown: (n) => {
    var e, t, i, r, s, o;
    const a = (t = (e = n.attrs) == null ? void 0 : e.src) != null ? t : "", l = (r = (i = n.attrs) == null ? void 0 : i.alt) != null ? r : "", c = (o = (s = n.attrs) == null ? void 0 : s.title) != null ? o : "";
    return c ? `![${l}](${a} "${c}")` : `![${l}](${a})`;
  },
  addNodeView() {
    if (!this.options.resize || !this.options.resize.enabled || typeof document > "u" || !this.editor.isEditable)
      return null;
    const { directions: n, minWidth: e, minHeight: t, alwaysPreserveAspectRatio: i } = this.options.resize;
    return ({ node: r, getPos: s, HTMLAttributes: o }) => {
      const a = document.createElement("img");
      Object.entries(o).forEach(([u, d]) => {
        if (d != null)
          switch (u) {
            case "width":
            case "height":
              break;
            default:
              a.setAttribute(u, d);
              break;
          }
      }), a.src = o.src;
      const l = new Vu({
        element: a,
        node: r,
        getPos: s,
        onResize: (u, d) => {
          a.style.width = `${u}px`, a.style.height = `${d}px`;
        },
        onCommit: (u, d) => {
          const h = s();
          h !== void 0 && this.editor.chain().setNodeSelection(h).updateAttributes(this.name, {
            width: u,
            height: d
          }).run();
        },
        onUpdate: (u, d, h) => u.type === r.type,
        options: {
          directions: n,
          min: {
            width: e,
            height: t
          },
          preserveAspectRatio: i === !0
        }
      }), c = l.dom;
      return c.style.visibility = "hidden", c.style.pointerEvents = "none", a.onload = () => {
        c.style.visibility = "", c.style.pointerEvents = "";
      }, l;
    };
  },
  addCommands() {
    return {
      setImage: (n) => ({ commands: e }) => e.insertContent({
        type: this.name,
        attrs: n
      })
    };
  },
  addInputRules() {
    return [
      Fu({
        find: o2,
        type: this.type,
        getAttributes: (n) => {
          const [, , e, t, i] = n;
          return { src: t, alt: e, title: i };
        }
      })
    ];
  }
}), l2 = Ne.create({
  name: "hardBreak",
  markdownTokenName: "br",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [{ tag: "br" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["br", Ee(this.options.HTMLAttributes, n)];
  },
  renderText() {
    return `
`;
  },
  renderMarkdown: () => `  
`,
  parseMarkdown: () => ({
    type: "hardBreak"
  }),
  addCommands() {
    return {
      setHardBreak: () => ({ commands: n, chain: e, state: t, editor: i }) => n.first([
        () => n.exitCode(),
        () => n.command(() => {
          const { selection: r, storedMarks: s } = t;
          if (r.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: o } = this.options, { splittableMarks: a } = i.extensionManager, l = s || r.$to.parentOffset && r.$from.marks();
          return e().insertContent({ type: this.name }).command(({ tr: c, dispatch: u }) => {
            if (u && l && o) {
              const d = l.filter((h) => a.includes(h.type.name));
              c.ensureMarks(d);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), c2 = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, u2 = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, d2 = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, h2 = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, f2 = Jt.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (n) => n.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (n) => n.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["em", Ee(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: n }) => n.setMark(this.name),
      toggleItalic: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetItalic: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  markdownTokenName: "em",
  parseMarkdown: (n, e) => e.applyMark("italic", e.parseInline(n.tokens || [])),
  renderMarkdown: (n, e) => `*${e.renderChildren(n)}*`,
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      _r({
        find: c2,
        type: this.type
      }),
      _r({
        find: d2,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Di({
        find: u2,
        type: this.type
      }),
      Di({
        find: h2,
        type: this.type
      })
    ];
  }
}), p2 = Jt.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (n) => n.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["u", Ee(this.options.HTMLAttributes, n), 0];
  },
  parseMarkdown(n, e) {
    return e.applyMark(this.name || "underline", e.parseInline(n.tokens || []));
  },
  renderMarkdown(n, e) {
    return `++${e.renderChildren(n)}++`;
  },
  markdownTokenizer: {
    name: "underline",
    level: "inline",
    start(n) {
      return n.indexOf("++");
    },
    tokenize(n, e, t) {
      const r = /^(\+\+)([\s\S]+?)(\+\+)/.exec(n);
      if (!r)
        return;
      const s = r[2].trim();
      return {
        type: "underline",
        raw: r[0],
        text: s,
        tokens: t.inlineTokens(s)
      };
    }
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: n }) => n.setMark(this.name),
      toggleUnderline: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetUnderline: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
}), Wo = (n, e) => {
  if (n === "slot")
    return 0;
  if (n instanceof Function)
    return n(e);
  const { children: t, ...i } = e ?? {};
  if (n === "svg")
    throw new Error("SVG elements are not supported in the JSX syntax, use the array syntax instead");
  return [n, i, t];
}, m2 = /^\s*>\s$/, g2 = Ne.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [{ tag: "blockquote" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return /* @__PURE__ */ Wo("blockquote", { ...Ee(this.options.HTMLAttributes, n), children: /* @__PURE__ */ Wo("slot", {}) });
  },
  parseMarkdown: (n, e) => e.createNode("blockquote", void 0, e.parseChildren(n.tokens || [])),
  renderMarkdown: (n, e) => {
    if (!n.content)
      return "";
    const t = ">", i = [];
    return n.content.forEach((r) => {
      const a = e.renderChildren([r]).split(`
`).map((l) => l.trim() === "" ? t : `${t} ${l}`);
      i.push(a.join(`
`));
    }), i.join(`
${t}
`);
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: n }) => n.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: n }) => n.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: n }) => n.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      Pi({
        find: m2,
        type: this.type
      })
    ];
  }
}), _2 = Object.defineProperty, b2 = (n, e) => {
  for (var t in e)
    _2(n, t, { get: e[t], enumerable: !0 });
}, v2 = "listItem", pf = "textStyle", mf = /^\s*([-+*])\s$/, t_ = Ne.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [{ tag: "ul" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["ul", Ee(this.options.HTMLAttributes, n), 0];
  },
  markdownTokenName: "list",
  parseMarkdown: (n, e) => n.type !== "list" || n.ordered ? [] : {
    type: "bulletList",
    content: n.items ? e.parseChildren(n.items) : []
  },
  renderMarkdown: (n, e) => n.content ? e.renderChildren(n.content, `
`) : "",
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: n, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(v2, this.editor.getAttributes(pf)).run() : n.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let n = Pi({
      find: mf,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (n = Pi({
      find: mf,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(pf),
      editor: this.editor
    })), [n];
  }
}), n_ = Ne.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["li", Ee(this.options.HTMLAttributes, n), 0];
  },
  markdownTokenName: "list_item",
  parseMarkdown: (n, e) => {
    if (n.type !== "list_item")
      return [];
    let t = [];
    if (n.tokens && n.tokens.length > 0)
      if (n.tokens.some((r) => r.type === "paragraph"))
        t = e.parseChildren(n.tokens);
      else {
        const r = n.tokens[0];
        if (r && r.type === "text" && r.tokens && r.tokens.length > 0) {
          if (t = [
            {
              type: "paragraph",
              content: e.parseInline(r.tokens)
            }
          ], n.tokens.length > 1) {
            const o = n.tokens.slice(1), a = e.parseChildren(o);
            t.push(...a);
          }
        } else
          t = e.parseChildren(n.tokens);
      }
    return t.length === 0 && (t = [
      {
        type: "paragraph",
        content: []
      }
    ]), {
      type: "listItem",
      content: t
    };
  },
  renderMarkdown: (n, e, t) => Ua(
    n,
    e,
    (i) => i.parentType === "bulletList" ? "- " : i.parentType === "orderedList" ? `${i.index + 1}. ` : "- ",
    t
  ),
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), y2 = {};
b2(y2, {
  findListItemPos: () => Ls,
  getNextListDepth: () => Gu,
  handleBackspace: () => Mc,
  handleDelete: () => Oc,
  hasListBefore: () => i_,
  hasListItemAfter: () => x2,
  hasListItemBefore: () => r_,
  listItemHasSubList: () => s_,
  nextListIsDeeper: () => o_,
  nextListIsHigher: () => a_
});
var Ls = (n, e) => {
  const { $from: t } = e.selection, i = Ze(n, e.schema);
  let r = null, s = t.depth, o = t.pos, a = null;
  for (; s > 0 && a === null; )
    r = t.node(s), r.type === i ? a = s : (s -= 1, o -= 1);
  return a === null ? null : { $pos: e.doc.resolve(o), depth: a };
}, Gu = (n, e) => {
  const t = Ls(n, e);
  if (!t)
    return !1;
  const [, i] = gg(e, n, t.$pos.pos + 4);
  return i;
}, i_ = (n, e, t) => {
  const { $anchor: i } = n.selection, r = Math.max(0, i.pos - 2), s = n.doc.resolve(r).node();
  return !(!s || !t.includes(s.type.name));
}, r_ = (n, e) => {
  var t;
  const { $anchor: i } = e.selection, r = e.doc.resolve(i.pos - 2);
  return !(r.index() === 0 || ((t = r.nodeBefore) == null ? void 0 : t.type.name) !== n);
}, s_ = (n, e, t) => {
  if (!t)
    return !1;
  const i = Ze(n, e.schema);
  let r = !1;
  return t.descendants((s) => {
    s.type === i && (r = !0);
  }), r;
}, Mc = (n, e, t) => {
  if (n.commands.undoInputRule())
    return !0;
  if (n.state.selection.from !== n.state.selection.to)
    return !1;
  if (!Gn(n.state, e) && i_(n.state, e, t)) {
    const { $anchor: a } = n.state.selection, l = n.state.doc.resolve(a.before() - 1), c = [];
    l.node().descendants((h, f) => {
      h.type.name === e && c.push({ node: h, pos: f });
    });
    const u = c.at(-1);
    if (!u)
      return !1;
    const d = n.state.doc.resolve(l.start() + u.pos + 1);
    return n.chain().cut({ from: a.start() - 1, to: a.end() + 1 }, d.end()).joinForward().run();
  }
  if (!Gn(n.state, e) || !yg(n.state))
    return !1;
  const i = Ls(e, n.state);
  if (!i)
    return !1;
  const s = n.state.doc.resolve(i.$pos.pos - 2).node(i.depth), o = s_(e, n.state, s);
  return r_(e, n.state) && !o ? n.commands.joinItemBackward() : n.chain().liftListItem(e).run();
}, o_ = (n, e) => {
  const t = Gu(n, e), i = Ls(n, e);
  return !i || !t ? !1 : t > i.depth;
}, a_ = (n, e) => {
  const t = Gu(n, e), i = Ls(n, e);
  return !i || !t ? !1 : t < i.depth;
}, Oc = (n, e) => {
  if (!Gn(n.state, e) || !vg(n.state, e))
    return !1;
  const { selection: t } = n.state, { $from: i, $to: r } = t;
  return !t.empty && i.sameParent(r) ? !1 : o_(e, n.state) ? n.chain().focus(n.state.selection.from + 4).lift(e).joinBackward().run() : a_(e, n.state) ? n.chain().joinForward().joinBackward().run() : n.commands.joinItemForward();
}, x2 = (n, e) => {
  var t;
  const { $anchor: i } = e.selection, r = e.doc.resolve(i.pos - i.parentOffset - 2);
  return !(r.index() === r.parent.childCount - 1 || ((t = r.nodeAfter) == null ? void 0 : t.type.name) !== n);
}, w2 = Oe.create({
  name: "listKeymap",
  addOptions() {
    return {
      listTypes: [
        {
          itemName: "listItem",
          wrapperNames: ["bulletList", "orderedList"]
        },
        {
          itemName: "taskItem",
          wrapperNames: ["taskList"]
        }
      ]
    };
  },
  addKeyboardShortcuts() {
    return {
      Delete: ({ editor: n }) => {
        let e = !1;
        return this.options.listTypes.forEach(({ itemName: t }) => {
          n.state.schema.nodes[t] !== void 0 && Oc(n, t) && (e = !0);
        }), e;
      },
      "Mod-Delete": ({ editor: n }) => {
        let e = !1;
        return this.options.listTypes.forEach(({ itemName: t }) => {
          n.state.schema.nodes[t] !== void 0 && Oc(n, t) && (e = !0);
        }), e;
      },
      Backspace: ({ editor: n }) => {
        let e = !1;
        return this.options.listTypes.forEach(({ itemName: t, wrapperNames: i }) => {
          n.state.schema.nodes[t] !== void 0 && Mc(n, t, i) && (e = !0);
        }), e;
      },
      "Mod-Backspace": ({ editor: n }) => {
        let e = !1;
        return this.options.listTypes.forEach(({ itemName: t, wrapperNames: i }) => {
          n.state.schema.nodes[t] !== void 0 && Mc(n, t, i) && (e = !0);
        }), e;
      }
    };
  }
}), gf = /^(\s*)(\d+)\.\s+(.*)$/, k2 = /^\s/;
function S2(n) {
  const e = [];
  let t = 0, i = 0;
  for (; t < n.length; ) {
    const r = n[t], s = r.match(gf);
    if (!s)
      break;
    const [, o, a, l] = s, c = o.length;
    let u = l, d = t + 1;
    const h = [r];
    for (; d < n.length; ) {
      const f = n[d];
      if (f.match(gf))
        break;
      if (f.trim() === "")
        h.push(f), u += `
`, d += 1;
      else if (f.match(k2))
        h.push(f), u += `
${f.slice(c + 2)}`, d += 1;
      else
        break;
    }
    e.push({
      indent: c,
      number: parseInt(a, 10),
      content: u.trim(),
      raw: h.join(`
`)
    }), i = d, t = d;
  }
  return [e, i];
}
function l_(n, e, t) {
  var i;
  const r = [];
  let s = 0;
  for (; s < n.length; ) {
    const o = n[s];
    if (o.indent === e) {
      const a = o.content.split(`
`), l = ((i = a[0]) == null ? void 0 : i.trim()) || "", c = [];
      l && c.push({
        type: "paragraph",
        raw: l,
        tokens: t.inlineTokens(l)
      });
      const u = a.slice(1).join(`
`).trim();
      if (u) {
        const f = t.blockTokens(u);
        c.push(...f);
      }
      let d = s + 1;
      const h = [];
      for (; d < n.length && n[d].indent > e; )
        h.push(n[d]), d += 1;
      if (h.length > 0) {
        const f = Math.min(...h.map((_) => _.indent)), p = l_(h, f, t);
        c.push({
          type: "list",
          ordered: !0,
          start: h[0].number,
          items: p,
          raw: h.map((_) => _.raw).join(`
`)
        });
      }
      r.push({
        type: "list_item",
        raw: o.raw,
        tokens: c
      }), s = d;
    } else
      s += 1;
  }
  return r;
}
function E2(n, e) {
  return n.map((t) => {
    if (t.type !== "list_item")
      return e.parseChildren([t])[0];
    const i = [];
    return t.tokens && t.tokens.length > 0 && t.tokens.forEach((r) => {
      if (r.type === "paragraph" || r.type === "list" || r.type === "blockquote" || r.type === "code")
        i.push(...e.parseChildren([r]));
      else if (r.type === "text" && r.tokens) {
        const s = e.parseChildren([r]);
        i.push({
          type: "paragraph",
          content: s
        });
      } else {
        const s = e.parseChildren([r]);
        s.length > 0 && i.push(...s);
      }
    }), {
      type: "listItem",
      content: i
    };
  });
}
var C2 = "listItem", _f = "textStyle", bf = /^(\d+)\.\s$/, c_ = Ne.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (n) => n.hasAttribute("start") ? parseInt(n.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: null,
        parseHTML: (n) => n.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    const { start: e, ...t } = n;
    return e === 1 ? ["ol", Ee(this.options.HTMLAttributes, t), 0] : ["ol", Ee(this.options.HTMLAttributes, n), 0];
  },
  markdownTokenName: "list",
  parseMarkdown: (n, e) => {
    if (n.type !== "list" || !n.ordered)
      return [];
    const t = n.start || 1, i = n.items ? E2(n.items, e) : [];
    return t !== 1 ? {
      type: "orderedList",
      attrs: { start: t },
      content: i
    } : {
      type: "orderedList",
      content: i
    };
  },
  renderMarkdown: (n, e) => n.content ? e.renderChildren(n.content, `
`) : "",
  markdownTokenizer: {
    name: "orderedList",
    level: "block",
    start: (n) => {
      const e = n.match(/^(\s*)(\d+)\.\s+/), t = e?.index;
      return t !== void 0 ? t : -1;
    },
    tokenize: (n, e, t) => {
      var i;
      const r = n.split(`
`), [s, o] = S2(r);
      if (s.length === 0)
        return;
      const a = l_(s, 0, t);
      return a.length === 0 ? void 0 : {
        type: "list",
        ordered: !0,
        start: ((i = s[0]) == null ? void 0 : i.number) || 1,
        items: a,
        raw: r.slice(0, o).join(`
`)
      };
    }
  },
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: n, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(C2, this.editor.getAttributes(_f)).run() : n.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let n = Pi({
      find: bf,
      type: this.type,
      getAttributes: (e) => ({ start: +e[1] }),
      joinPredicate: (e, t) => t.childCount + t.attrs.start === +e[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (n = Pi({
      find: bf,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (e) => ({ start: +e[1], ...this.editor.getAttributes(_f) }),
      joinPredicate: (e, t) => t.childCount + t.attrs.start === +e[1],
      editor: this.editor
    })), [n];
  }
}), T2 = /^\s*(\[([( |x])?\])\s$/, A2 = Ne.create({
  name: "taskItem",
  addOptions() {
    return {
      nested: !1,
      HTMLAttributes: {},
      taskListTypeName: "taskList",
      a11y: void 0
    };
  },
  content() {
    return this.options.nested ? "paragraph block*" : "paragraph+";
  },
  defining: !0,
  addAttributes() {
    return {
      checked: {
        default: !1,
        keepOnSplit: !1,
        parseHTML: (n) => {
          const e = n.getAttribute("data-checked");
          return e === "" || e === "true";
        },
        renderHTML: (n) => ({
          "data-checked": n.checked
        })
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: `li[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    return [
      "li",
      Ee(this.options.HTMLAttributes, e, {
        "data-type": this.name
      }),
      [
        "label",
        [
          "input",
          {
            type: "checkbox",
            checked: n.attrs.checked ? "checked" : null
          }
        ],
        ["span"]
      ],
      ["div", 0]
    ];
  },
  parseMarkdown: (n, e) => {
    const t = [];
    if (n.tokens && n.tokens.length > 0 ? t.push(e.createNode("paragraph", {}, e.parseInline(n.tokens))) : n.text ? t.push(e.createNode("paragraph", {}, [e.createNode("text", { text: n.text })])) : t.push(e.createNode("paragraph", {}, [])), n.nestedTokens && n.nestedTokens.length > 0) {
      const i = e.parseChildren(n.nestedTokens);
      t.push(...i);
    }
    return e.createNode("taskItem", { checked: n.checked || !1 }, t);
  },
  renderMarkdown: (n, e) => {
    var t;
    const r = `- [${(t = n.attrs) != null && t.checked ? "x" : " "}] `;
    return Ua(n, e, r);
  },
  addKeyboardShortcuts() {
    const n = {
      Enter: () => this.editor.commands.splitListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
    return this.options.nested ? {
      ...n,
      Tab: () => this.editor.commands.sinkListItem(this.name)
    } : n;
  },
  addNodeView() {
    return ({ node: n, HTMLAttributes: e, getPos: t, editor: i }) => {
      const r = document.createElement("li"), s = document.createElement("label"), o = document.createElement("span"), a = document.createElement("input"), l = document.createElement("div"), c = (u) => {
        var d, h;
        a.ariaLabel = ((h = (d = this.options.a11y) == null ? void 0 : d.checkboxLabel) == null ? void 0 : h.call(d, u, a.checked)) || `Task item checkbox for ${u.textContent || "empty task item"}`;
      };
      return c(n), s.contentEditable = "false", a.type = "checkbox", a.addEventListener("mousedown", (u) => u.preventDefault()), a.addEventListener("change", (u) => {
        if (!i.isEditable && !this.options.onReadOnlyChecked) {
          a.checked = !a.checked;
          return;
        }
        const { checked: d } = u.target;
        i.isEditable && typeof t == "function" && i.chain().focus(void 0, { scrollIntoView: !1 }).command(({ tr: h }) => {
          const f = t();
          if (typeof f != "number")
            return !1;
          const p = h.doc.nodeAt(f);
          return h.setNodeMarkup(f, void 0, {
            ...p?.attrs,
            checked: d
          }), !0;
        }).run(), !i.isEditable && this.options.onReadOnlyChecked && (this.options.onReadOnlyChecked(n, d) || (a.checked = !a.checked));
      }), Object.entries(this.options.HTMLAttributes).forEach(([u, d]) => {
        r.setAttribute(u, d);
      }), r.dataset.checked = n.attrs.checked, a.checked = n.attrs.checked, s.append(a, o), r.append(s, l), Object.entries(e).forEach(([u, d]) => {
        r.setAttribute(u, d);
      }), {
        dom: r,
        contentDOM: l,
        update: (u) => u.type !== this.type ? !1 : (r.dataset.checked = u.attrs.checked, a.checked = u.attrs.checked, c(u), !0)
      };
    };
  },
  addInputRules() {
    return [
      Pi({
        find: T2,
        type: this.type,
        getAttributes: (n) => ({
          checked: n[n.length - 1] === "x"
        })
      })
    ];
  }
}), M2 = Ne.create({
  name: "taskList",
  addOptions() {
    return {
      itemTypeName: "taskItem",
      HTMLAttributes: {}
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      {
        tag: `ul[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["ul", Ee(this.options.HTMLAttributes, n, { "data-type": this.name }), 0];
  },
  parseMarkdown: (n, e) => e.createNode("taskList", {}, e.parseChildren(n.items || [])),
  renderMarkdown: (n, e) => n.content ? e.renderChildren(n.content, `
`) : "",
  markdownTokenizer: {
    name: "taskList",
    level: "block",
    start(n) {
      var e;
      const t = (e = n.match(/^\s*[-+*]\s+\[([ xX])\]\s+/)) == null ? void 0 : e.index;
      return t !== void 0 ? t : -1;
    },
    tokenize(n, e, t) {
      const i = (s) => {
        const o = Vo(
          s,
          {
            itemPattern: /^(\s*)([-+*])\s+\[([ xX])\]\s+(.*)$/,
            extractItemData: (a) => ({
              indentLevel: a[1].length,
              mainContent: a[4],
              checked: a[3].toLowerCase() === "x"
            }),
            createToken: (a, l) => ({
              type: "taskItem",
              raw: "",
              mainContent: a.mainContent,
              indentLevel: a.indentLevel,
              checked: a.checked,
              text: a.mainContent,
              tokens: t.inlineTokens(a.mainContent),
              nestedTokens: l
            }),
            // Allow recursive nesting
            customNestedParser: i
          },
          t
        );
        return o ? [
          {
            type: "taskList",
            raw: o.raw,
            items: o.items
          }
        ] : t.blockTokens(s);
      }, r = Vo(
        n,
        {
          itemPattern: /^(\s*)([-+*])\s+\[([ xX])\]\s+(.*)$/,
          extractItemData: (s) => ({
            indentLevel: s[1].length,
            mainContent: s[4],
            checked: s[3].toLowerCase() === "x"
          }),
          createToken: (s, o) => ({
            type: "taskItem",
            raw: "",
            mainContent: s.mainContent,
            indentLevel: s.indentLevel,
            checked: s.checked,
            text: s.mainContent,
            tokens: t.inlineTokens(s.mainContent),
            nestedTokens: o
          }),
          // Use the recursive parser for nested content
          customNestedParser: i
        },
        t
      );
      if (r)
        return {
          type: "taskList",
          raw: r.raw,
          items: r.items
        };
    }
  },
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleTaskList: () => ({ commands: n }) => n.toggleList(this.name, this.options.itemTypeName)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-9": () => this.editor.commands.toggleTaskList()
    };
  }
});
Oe.create({
  name: "listKit",
  addExtensions() {
    const n = [];
    return this.options.bulletList !== !1 && n.push(t_.configure(this.options.bulletList)), this.options.listItem !== !1 && n.push(n_.configure(this.options.listItem)), this.options.listKeymap !== !1 && n.push(w2.configure(this.options.listKeymap)), this.options.orderedList !== !1 && n.push(c_.configure(this.options.orderedList)), this.options.taskItem !== !1 && n.push(A2.configure(this.options.taskItem)), this.options.taskList !== !1 && n.push(M2.configure(this.options.taskList)), n;
  }
});
const u_ = (n) => {
  const { state: e } = n, { selection: t } = e.tr, { $from: i } = t;
  if (i.node(-1).type.name === "listItem" && i.node().type.name === "paragraph") {
    const r = e.schema.nodes.textBlock;
    e.tr.setNodeMarkup(i.before(), r);
  }
}, O2 = t_.extend({
  addInputRules() {
    return this.parent?.().map((n) => ({
      ...n,
      handler: (e) => {
        n.handler(e), u_(e);
      }
    }));
  }
});
var N2 = Ne.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((n) => ({
      tag: `h${n}`,
      attrs: { level: n }
    }));
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    return [`h${this.options.levels.includes(n.attrs.level) ? n.attrs.level : this.options.levels[0]}`, Ee(this.options.HTMLAttributes, e), 0];
  },
  parseMarkdown: (n, e) => e.createNode("heading", { level: n.depth || 1 }, e.parseInline(n.tokens || [])),
  renderMarkdown: (n, e) => {
    var t;
    const i = (t = n.attrs) != null && t.level ? parseInt(n.attrs.level, 10) : 1, r = "#".repeat(i);
    return n.content ? `${r} ${e.renderChildren(n.content)}` : "";
  },
  addCommands() {
    return {
      setHeading: (n) => ({ commands: e }) => this.options.levels.includes(n.level) ? e.setNode(this.name, n) : !1,
      toggleHeading: (n) => ({ commands: e }) => this.options.levels.includes(n.level) ? e.toggleNode(this.name, "paragraph", n) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce(
      (n, e) => ({
        ...n,
        [`Mod-Alt-${e}`]: () => this.editor.commands.toggleHeading({ level: e })
      }),
      {}
    );
  },
  addInputRules() {
    return this.options.levels.map((n) => Fg({
      find: new RegExp(`^(#{${Math.min(...this.options.levels)},${n}})\\s$`),
      type: this.type,
      getAttributes: {
        level: n
      }
    }));
  }
}), L2 = Ne.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {},
      nextNodeType: "paragraph"
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["hr", Ee(this.options.HTMLAttributes, n)];
  },
  markdownTokenName: "hr",
  parseMarkdown: (n, e) => e.createNode("horizontalRule"),
  renderMarkdown: () => "---",
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: n, state: e }) => {
        if (!Vg(e, e.schema.nodes[this.name]))
          return !1;
        const { selection: t } = e, { $to: i } = t, r = n();
        return Hu(t) ? r.insertContentAt(i.pos, {
          type: this.name
        }) : r.insertContent({ type: this.name }), r.command(({ state: s, tr: o, dispatch: a }) => {
          if (a) {
            const { $to: l } = o.selection, c = l.end();
            if (l.nodeAfter)
              l.nodeAfter.isTextblock ? o.setSelection(ue.create(o.doc, l.pos + 1)) : l.nodeAfter.isBlock ? o.setSelection(re.create(o.doc, l.pos)) : o.setSelection(ue.create(o.doc, l.pos));
            else {
              const u = s.schema.nodes[this.options.nextNodeType] || l.parent.type.contentMatch.defaultType, d = u?.create();
              d && (o.insert(c, d), o.setSelection(ue.create(o.doc, c + 1)));
            }
            o.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      Fu({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
});
const R2 = c_.extend({
  addInputRules() {
    return this.parent?.().map((n) => ({
      ...n,
      handler: (e) => {
        n.handler(e), u_(e);
      }
    }));
  }
});
var I2 = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, P2 = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, D2 = Jt.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (n) => n.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["s", Ee(this.options.HTMLAttributes, n), 0];
  },
  markdownTokenName: "del",
  parseMarkdown: (n, e) => e.applyMark("strike", e.parseInline(n.tokens || [])),
  renderMarkdown: (n, e) => `~~${e.renderChildren(n)}~~`,
  addCommands() {
    return {
      setStrike: () => ({ commands: n }) => n.setMark(this.name),
      toggleStrike: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetStrike: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      _r({
        find: I2,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Di({
        find: P2,
        type: this.type
      })
    ];
  }
});
function $2(n = {}) {
  return new je({
    view(e) {
      return new z2(e, n);
    }
  });
}
class z2 {
  constructor(e, t) {
    var i;
    this.editorView = e, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (i = t.width) !== null && i !== void 0 ? i : 1, this.color = t.color === !1 ? void 0 : t.color || "black", this.class = t.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((r) => {
      let s = (o) => {
        this[r](o);
      };
      return e.dom.addEventListener(r, s), { name: r, handler: s };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: e, handler: t }) => this.editorView.dom.removeEventListener(e, t));
  }
  update(e, t) {
    this.cursorPos != null && t.doc != e.state.doc && (this.cursorPos > e.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(e) {
    e != this.cursorPos && (this.cursorPos = e, e == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let e = this.editorView.state.doc.resolve(this.cursorPos), t = !e.parent.inlineContent, i;
    if (t) {
      let a = e.nodeBefore, l = e.nodeAfter;
      if (a || l) {
        let c = this.editorView.nodeDOM(this.cursorPos - (a ? a.nodeSize : 0));
        if (c) {
          let u = c.getBoundingClientRect(), d = a ? u.bottom : u.top;
          a && l && (d = (d + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2), i = { left: u.left, right: u.right, top: d - this.width / 2, bottom: d + this.width / 2 };
        }
      }
    }
    if (!i) {
      let a = this.editorView.coordsAtPos(this.cursorPos);
      i = { left: a.left - this.width / 2, right: a.left + this.width / 2, top: a.top, bottom: a.bottom };
    }
    let r = this.editorView.dom.offsetParent;
    this.element || (this.element = r.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", t), this.element.classList.toggle("prosemirror-dropcursor-inline", !t);
    let s, o;
    if (!r || r == document.body && getComputedStyle(r).position == "static")
      s = -pageXOffset, o = -pageYOffset;
    else {
      let a = r.getBoundingClientRect();
      s = a.left - r.scrollLeft, o = a.top - r.scrollTop;
    }
    this.element.style.left = i.left - s + "px", this.element.style.top = i.top - o + "px", this.element.style.width = i.right - i.left + "px", this.element.style.height = i.bottom - i.top + "px";
  }
  scheduleRemoval(e) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), e);
  }
  dragover(e) {
    if (!this.editorView.editable)
      return;
    let t = this.editorView.posAtCoords({ left: e.clientX, top: e.clientY }), i = t && t.inside >= 0 && this.editorView.state.doc.nodeAt(t.inside), r = i && i.type.spec.disableDropCursor, s = typeof r == "function" ? r(this.editorView, t, e) : r;
    if (t && !s) {
      let o = t.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let a = im(this.editorView.state.doc, o, this.editorView.dragging.slice);
        a != null && (o = a);
      }
      this.setCursor(o), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(e) {
    (e.target == this.editorView.dom || !this.editorView.dom.contains(e.relatedTarget)) && this.setCursor(null);
  }
}
class qe extends fe {
  /**
  Create a gap cursor.
  */
  constructor(e) {
    super(e, e);
  }
  map(e, t) {
    let i = e.resolve(t.map(this.head));
    return qe.valid(i) ? new qe(i) : fe.near(i);
  }
  content() {
    return J.empty;
  }
  eq(e) {
    return e instanceof qe && e.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new qe(e.resolve(t.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new Ju(this.anchor);
  }
  /**
  @internal
  */
  static valid(e) {
    let t = e.parent;
    if (t.isTextblock || !H2(e) || !B2(e))
      return !1;
    let i = t.type.spec.allowGapCursor;
    if (i != null)
      return i;
    let r = t.contentMatchAt(e.index()).defaultType;
    return r && r.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(e, t, i = !1) {
    e: for (; ; ) {
      if (!i && qe.valid(e))
        return e;
      let r = e.pos, s = null;
      for (let o = e.depth; ; o--) {
        let a = e.node(o);
        if (t > 0 ? e.indexAfter(o) < a.childCount : e.index(o) > 0) {
          s = a.child(t > 0 ? e.indexAfter(o) : e.index(o) - 1);
          break;
        } else if (o == 0)
          return null;
        r += t;
        let l = e.doc.resolve(r);
        if (qe.valid(l))
          return l;
      }
      for (; ; ) {
        let o = t > 0 ? s.firstChild : s.lastChild;
        if (!o) {
          if (s.isAtom && !s.isText && !re.isSelectable(s)) {
            e = e.doc.resolve(r + s.nodeSize * t), i = !1;
            continue e;
          }
          break;
        }
        s = o, r += t;
        let a = e.doc.resolve(r);
        if (qe.valid(a))
          return a;
      }
      return null;
    }
  }
}
qe.prototype.visible = !1;
qe.findFrom = qe.findGapCursorFrom;
fe.jsonID("gapcursor", qe);
class Ju {
  constructor(e) {
    this.pos = e;
  }
  map(e) {
    return new Ju(e.map(this.pos));
  }
  resolve(e) {
    let t = e.resolve(this.pos);
    return qe.valid(t) ? new qe(t) : fe.near(t);
  }
}
function H2(n) {
  for (let e = n.depth; e >= 0; e--) {
    let t = n.index(e), i = n.node(e);
    if (t == 0) {
      if (i.type.spec.isolating)
        return !0;
      continue;
    }
    for (let r = i.child(t - 1); ; r = r.lastChild) {
      if (r.childCount == 0 && !r.inlineContent || r.isAtom || r.type.spec.isolating)
        return !0;
      if (r.inlineContent)
        return !1;
    }
  }
  return !0;
}
function B2(n) {
  for (let e = n.depth; e >= 0; e--) {
    let t = n.indexAfter(e), i = n.node(e);
    if (t == i.childCount) {
      if (i.type.spec.isolating)
        return !0;
      continue;
    }
    for (let r = i.child(t); ; r = r.firstChild) {
      if (r.childCount == 0 && !r.inlineContent || r.isAtom || r.type.spec.isolating)
        return !0;
      if (r.inlineContent)
        return !1;
    }
  }
  return !0;
}
function F2() {
  return new je({
    props: {
      decorations: U2,
      createSelectionBetween(n, e, t) {
        return e.pos == t.pos && qe.valid(t) ? new qe(t) : null;
      },
      handleClick: j2,
      handleKeyDown: V2,
      handleDOMEvents: { beforeinput: W2 }
    }
  });
}
const V2 = ku({
  ArrowLeft: eo("horiz", -1),
  ArrowRight: eo("horiz", 1),
  ArrowUp: eo("vert", -1),
  ArrowDown: eo("vert", 1)
});
function eo(n, e) {
  const t = n == "vert" ? e > 0 ? "down" : "up" : e > 0 ? "right" : "left";
  return function(i, r, s) {
    let o = i.selection, a = e > 0 ? o.$to : o.$from, l = o.empty;
    if (o instanceof ue) {
      if (!s.endOfTextblock(t) || a.depth == 0)
        return !1;
      l = !1, a = i.doc.resolve(e > 0 ? a.after() : a.before());
    }
    let c = qe.findGapCursorFrom(a, e, l);
    return c ? (r && r(i.tr.setSelection(new qe(c))), !0) : !1;
  };
}
function j2(n, e, t) {
  if (!n || !n.editable)
    return !1;
  let i = n.state.doc.resolve(e);
  if (!qe.valid(i))
    return !1;
  let r = n.posAtCoords({ left: t.clientX, top: t.clientY });
  return r && r.inside > -1 && re.isSelectable(n.state.doc.nodeAt(r.inside)) ? !1 : (n.dispatch(n.state.tr.setSelection(new qe(i))), !0);
}
function W2(n, e) {
  if (e.inputType != "insertCompositionText" || !(n.state.selection instanceof qe))
    return !1;
  let { $from: t } = n.state.selection, i = t.parent.contentMatchAt(t.index()).findWrapping(n.state.schema.nodes.text);
  if (!i)
    return !1;
  let r = $.empty;
  for (let o = i.length - 1; o >= 0; o--)
    r = $.from(i[o].createAndFill(null, r));
  let s = n.state.tr.replace(t.pos, t.pos, new J(r, 0, 0));
  return s.setSelection(ue.near(s.doc.resolve(t.pos + 1))), n.dispatch(s), !1;
}
function U2(n) {
  if (!(n.selection instanceof qe))
    return null;
  let e = document.createElement("div");
  return e.className = "ProseMirror-gapcursor", ze.create(n.doc, [gt.widget(n.selection.head, e, { key: "gapcursor" })]);
}
var Uo = 200, bt = function() {
};
bt.prototype.append = function(e) {
  return e.length ? (e = bt.from(e), !this.length && e || e.length < Uo && this.leafAppend(e) || this.length < Uo && e.leafPrepend(this) || this.appendInner(e)) : this;
};
bt.prototype.prepend = function(e) {
  return e.length ? bt.from(e).append(this) : this;
};
bt.prototype.appendInner = function(e) {
  return new K2(this, e);
};
bt.prototype.slice = function(e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = this.length), e >= t ? bt.empty : this.sliceInner(Math.max(0, e), Math.min(this.length, t));
};
bt.prototype.get = function(e) {
  if (!(e < 0 || e >= this.length))
    return this.getInner(e);
};
bt.prototype.forEach = function(e, t, i) {
  t === void 0 && (t = 0), i === void 0 && (i = this.length), t <= i ? this.forEachInner(e, t, i, 0) : this.forEachInvertedInner(e, t, i, 0);
};
bt.prototype.map = function(e, t, i) {
  t === void 0 && (t = 0), i === void 0 && (i = this.length);
  var r = [];
  return this.forEach(function(s, o) {
    return r.push(e(s, o));
  }, t, i), r;
};
bt.from = function(e) {
  return e instanceof bt ? e : e && e.length ? new d_(e) : bt.empty;
};
var d_ = /* @__PURE__ */ function(n) {
  function e(i) {
    n.call(this), this.values = i;
  }
  n && (e.__proto__ = n), e.prototype = Object.create(n && n.prototype), e.prototype.constructor = e;
  var t = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return e.prototype.flatten = function() {
    return this.values;
  }, e.prototype.sliceInner = function(r, s) {
    return r == 0 && s == this.length ? this : new e(this.values.slice(r, s));
  }, e.prototype.getInner = function(r) {
    return this.values[r];
  }, e.prototype.forEachInner = function(r, s, o, a) {
    for (var l = s; l < o; l++)
      if (r(this.values[l], a + l) === !1)
        return !1;
  }, e.prototype.forEachInvertedInner = function(r, s, o, a) {
    for (var l = s - 1; l >= o; l--)
      if (r(this.values[l], a + l) === !1)
        return !1;
  }, e.prototype.leafAppend = function(r) {
    if (this.length + r.length <= Uo)
      return new e(this.values.concat(r.flatten()));
  }, e.prototype.leafPrepend = function(r) {
    if (this.length + r.length <= Uo)
      return new e(r.flatten().concat(this.values));
  }, t.length.get = function() {
    return this.values.length;
  }, t.depth.get = function() {
    return 0;
  }, Object.defineProperties(e.prototype, t), e;
}(bt);
bt.empty = new d_([]);
var K2 = /* @__PURE__ */ function(n) {
  function e(t, i) {
    n.call(this), this.left = t, this.right = i, this.length = t.length + i.length, this.depth = Math.max(t.depth, i.depth) + 1;
  }
  return n && (e.__proto__ = n), e.prototype = Object.create(n && n.prototype), e.prototype.constructor = e, e.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, e.prototype.getInner = function(i) {
    return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length);
  }, e.prototype.forEachInner = function(i, r, s, o) {
    var a = this.left.length;
    if (r < a && this.left.forEachInner(i, r, Math.min(s, a), o) === !1 || s > a && this.right.forEachInner(i, Math.max(r - a, 0), Math.min(this.length, s) - a, o + a) === !1)
      return !1;
  }, e.prototype.forEachInvertedInner = function(i, r, s, o) {
    var a = this.left.length;
    if (r > a && this.right.forEachInvertedInner(i, r - a, Math.max(s, a) - a, o + a) === !1 || s < a && this.left.forEachInvertedInner(i, Math.min(r, a), s, o) === !1)
      return !1;
  }, e.prototype.sliceInner = function(i, r) {
    if (i == 0 && r == this.length)
      return this;
    var s = this.left.length;
    return r <= s ? this.left.slice(i, r) : i >= s ? this.right.slice(i - s, r - s) : this.left.slice(i, s).append(this.right.slice(0, r - s));
  }, e.prototype.leafAppend = function(i) {
    var r = this.right.leafAppend(i);
    if (r)
      return new e(this.left, r);
  }, e.prototype.leafPrepend = function(i) {
    var r = this.left.leafPrepend(i);
    if (r)
      return new e(r, this.right);
  }, e.prototype.appendInner = function(i) {
    return this.left.depth >= Math.max(this.right.depth, i.depth) + 1 ? new e(this.left, new e(this.right, i)) : new e(this, i);
  }, e;
}(bt);
const q2 = 500;
class mn {
  constructor(e, t) {
    this.items = e, this.eventCount = t;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(e, t) {
    if (this.eventCount == 0)
      return null;
    let i = this.items.length;
    for (; ; i--)
      if (this.items.get(i - 1).selection) {
        --i;
        break;
      }
    let r, s;
    t && (r = this.remapping(i, this.items.length), s = r.maps.length);
    let o = e.tr, a, l, c = [], u = [];
    return this.items.forEach((d, h) => {
      if (!d.step) {
        r || (r = this.remapping(i, h + 1), s = r.maps.length), s--, u.push(d);
        return;
      }
      if (r) {
        u.push(new En(d.map));
        let f = d.step.map(r.slice(s)), p;
        f && o.maybeStep(f).doc && (p = o.mapping.maps[o.mapping.maps.length - 1], c.push(new En(p, void 0, void 0, c.length + u.length))), s--, p && r.appendMap(p, s);
      } else
        o.maybeStep(d.step);
      if (d.selection)
        return a = r ? d.selection.map(r.slice(s)) : d.selection, l = new mn(this.items.slice(0, i).append(u.reverse().concat(c)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: l, transform: o, selection: a };
  }
  // Create a new branch with the given transform added.
  addTransform(e, t, i, r) {
    let s = [], o = this.eventCount, a = this.items, l = !r && a.length ? a.get(a.length - 1) : null;
    for (let u = 0; u < e.steps.length; u++) {
      let d = e.steps[u].invert(e.docs[u]), h = new En(e.mapping.maps[u], d, t), f;
      (f = l && l.merge(h)) && (h = f, u ? s.pop() : a = a.slice(0, a.length - 1)), s.push(h), t && (o++, t = void 0), r || (l = h);
    }
    let c = o - i.depth;
    return c > J2 && (a = G2(a, c), o -= c), new mn(a.append(s), o);
  }
  remapping(e, t) {
    let i = new rr();
    return this.items.forEach((r, s) => {
      let o = r.mirrorOffset != null && s - r.mirrorOffset >= e ? i.maps.length - r.mirrorOffset : void 0;
      i.appendMap(r.map, o);
    }, e, t), i;
  }
  addMaps(e) {
    return this.eventCount == 0 ? this : new mn(this.items.append(e.map((t) => new En(t))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(e, t) {
    if (!this.eventCount)
      return this;
    let i = [], r = Math.max(0, this.items.length - t), s = e.mapping, o = e.steps.length, a = this.eventCount;
    this.items.forEach((h) => {
      h.selection && a--;
    }, r);
    let l = t;
    this.items.forEach((h) => {
      let f = s.getMirror(--l);
      if (f == null)
        return;
      o = Math.min(o, f);
      let p = s.maps[f];
      if (h.step) {
        let _ = e.steps[f].invert(e.docs[f]), m = h.selection && h.selection.map(s.slice(l + 1, f));
        m && a++, i.push(new En(p, _, m));
      } else
        i.push(new En(p));
    }, r);
    let c = [];
    for (let h = t; h < o; h++)
      c.push(new En(s.maps[h]));
    let u = this.items.slice(0, r).append(c).append(i), d = new mn(u, a);
    return d.emptyItemCount() > q2 && (d = d.compress(this.items.length - i.length)), d;
  }
  emptyItemCount() {
    let e = 0;
    return this.items.forEach((t) => {
      t.step || e++;
    }), e;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(e = this.items.length) {
    let t = this.remapping(0, e), i = t.maps.length, r = [], s = 0;
    return this.items.forEach((o, a) => {
      if (a >= e)
        r.push(o), o.selection && s++;
      else if (o.step) {
        let l = o.step.map(t.slice(i)), c = l && l.getMap();
        if (i--, c && t.appendMap(c, i), l) {
          let u = o.selection && o.selection.map(t.slice(i));
          u && s++;
          let d = new En(c.invert(), l, u), h, f = r.length - 1;
          (h = r.length && r[f].merge(d)) ? r[f] = h : r.push(d);
        }
      } else o.map && i--;
    }, this.items.length, 0), new mn(bt.from(r.reverse()), s);
  }
}
mn.empty = new mn(bt.empty, 0);
function G2(n, e) {
  let t;
  return n.forEach((i, r) => {
    if (i.selection && e-- == 0)
      return t = r, !1;
  }), n.slice(t);
}
class En {
  constructor(e, t, i, r) {
    this.map = e, this.step = t, this.selection = i, this.mirrorOffset = r;
  }
  merge(e) {
    if (this.step && e.step && !e.selection) {
      let t = e.step.merge(this.step);
      if (t)
        return new En(t.getMap().invert(), t, this.selection);
    }
  }
}
class ii {
  constructor(e, t, i, r, s) {
    this.done = e, this.undone = t, this.prevRanges = i, this.prevTime = r, this.prevComposition = s;
  }
}
const J2 = 20;
function X2(n, e, t, i) {
  let r = t.getMeta(qn), s;
  if (r)
    return r.historyState;
  t.getMeta(Q2) && (n = new ii(n.done, n.undone, null, 0, -1));
  let o = t.getMeta("appendedTransaction");
  if (t.steps.length == 0)
    return n;
  if (o && o.getMeta(qn))
    return o.getMeta(qn).redo ? new ii(n.done.addTransform(t, void 0, i, _o(e)), n.undone, vf(t.mapping.maps), n.prevTime, n.prevComposition) : new ii(n.done, n.undone.addTransform(t, void 0, i, _o(e)), null, n.prevTime, n.prevComposition);
  if (t.getMeta("addToHistory") !== !1 && !(o && o.getMeta("addToHistory") === !1)) {
    let a = t.getMeta("composition"), l = n.prevTime == 0 || !o && n.prevComposition != a && (n.prevTime < (t.time || 0) - i.newGroupDelay || !Y2(t, n.prevRanges)), c = o ? Hl(n.prevRanges, t.mapping) : vf(t.mapping.maps);
    return new ii(n.done.addTransform(t, l ? e.selection.getBookmark() : void 0, i, _o(e)), mn.empty, c, t.time, a ?? n.prevComposition);
  } else return (s = t.getMeta("rebased")) ? new ii(n.done.rebased(t, s), n.undone.rebased(t, s), Hl(n.prevRanges, t.mapping), n.prevTime, n.prevComposition) : new ii(n.done.addMaps(t.mapping.maps), n.undone.addMaps(t.mapping.maps), Hl(n.prevRanges, t.mapping), n.prevTime, n.prevComposition);
}
function Y2(n, e) {
  if (!e)
    return !1;
  if (!n.docChanged)
    return !0;
  let t = !1;
  return n.mapping.maps[0].forEach((i, r) => {
    for (let s = 0; s < e.length; s += 2)
      i <= e[s + 1] && r >= e[s] && (t = !0);
  }), t;
}
function vf(n) {
  let e = [];
  for (let t = n.length - 1; t >= 0 && e.length == 0; t--)
    n[t].forEach((i, r, s, o) => e.push(s, o));
  return e;
}
function Hl(n, e) {
  if (!n)
    return null;
  let t = [];
  for (let i = 0; i < n.length; i += 2) {
    let r = e.map(n[i], 1), s = e.map(n[i + 1], -1);
    r <= s && t.push(r, s);
  }
  return t;
}
function Z2(n, e, t) {
  let i = _o(e), r = qn.get(e).spec.config, s = (t ? n.undone : n.done).popEvent(e, i);
  if (!s)
    return null;
  let o = s.selection.resolve(s.transform.doc), a = (t ? n.done : n.undone).addTransform(s.transform, e.selection.getBookmark(), r, i), l = new ii(t ? a : s.remaining, t ? s.remaining : a, null, 0, -1);
  return s.transform.setSelection(o).setMeta(qn, { redo: t, historyState: l });
}
let Bl = !1, yf = null;
function _o(n) {
  let e = n.plugins;
  if (yf != e) {
    Bl = !1, yf = e;
    for (let t = 0; t < e.length; t++)
      if (e[t].spec.historyPreserveItems) {
        Bl = !0;
        break;
      }
  }
  return Bl;
}
const qn = new Xe("history"), Q2 = new Xe("closeHistory");
function eS(n = {}) {
  return n = {
    depth: n.depth || 100,
    newGroupDelay: n.newGroupDelay || 500
  }, new je({
    key: qn,
    state: {
      init() {
        return new ii(mn.empty, mn.empty, null, 0, -1);
      },
      apply(e, t, i) {
        return X2(t, i, e, n);
      }
    },
    config: n,
    props: {
      handleDOMEvents: {
        beforeinput(e, t) {
          let i = t.inputType, r = i == "historyUndo" ? f_ : i == "historyRedo" ? p_ : null;
          return r ? (t.preventDefault(), r(e.state, e.dispatch)) : !1;
        }
      }
    }
  });
}
function h_(n, e) {
  return (t, i) => {
    let r = qn.getState(t);
    if (!r || (n ? r.undone : r.done).eventCount == 0)
      return !1;
    if (i) {
      let s = Z2(r, t, n);
      s && i(e ? s.scrollIntoView() : s);
    }
    return !0;
  };
}
const f_ = h_(!1, !0), p_ = h_(!0, !0);
function tS(n) {
  let e = qn.getState(n);
  return e ? e.done.eventCount : 0;
}
function nS(n) {
  let e = qn.getState(n);
  return e ? e.undone.eventCount : 0;
}
Oe.create({
  name: "characterCount",
  addOptions() {
    return {
      limit: null,
      mode: "textSize",
      textCounter: (n) => n.length,
      wordCounter: (n) => n.split(" ").filter((e) => e !== "").length
    };
  },
  addStorage() {
    return {
      characters: () => 0,
      words: () => 0
    };
  },
  onBeforeCreate() {
    this.storage.characters = (n) => {
      const e = n?.node || this.editor.state.doc;
      if ((n?.mode || this.options.mode) === "textSize") {
        const i = e.textBetween(0, e.content.size, void 0, " ");
        return this.options.textCounter(i);
      }
      return e.nodeSize;
    }, this.storage.words = (n) => {
      const e = n?.node || this.editor.state.doc, t = e.textBetween(0, e.content.size, " ", " ");
      return this.options.wordCounter(t);
    };
  },
  addProseMirrorPlugins() {
    let n = !1;
    return [
      new je({
        key: new Xe("characterCount"),
        appendTransaction: (e, t, i) => {
          if (n)
            return;
          const r = this.options.limit;
          if (r == null || r === 0) {
            n = !0;
            return;
          }
          const s = this.storage.characters({ node: i.doc });
          if (s > r) {
            const o = s - r, a = 0, l = o;
            console.warn(
              `[CharacterCount] Initial content exceeded limit of ${r} characters. Content was automatically trimmed.`
            );
            const c = i.tr.deleteRange(a, l);
            return n = !0, c;
          }
          n = !0;
        },
        filterTransaction: (e, t) => {
          const i = this.options.limit;
          if (!e.docChanged || i === 0 || i === null || i === void 0)
            return !0;
          const r = this.storage.characters({ node: t.doc }), s = this.storage.characters({ node: e.doc });
          if (s <= i || r > i && s > i && s <= r)
            return !0;
          if (r > i && s > i && s > r || !e.getMeta("paste"))
            return !1;
          const a = e.selection.$head.pos, l = s - i, c = a - l, u = a;
          return e.deleteRange(c, u), !(this.storage.characters({ node: e.doc }) > i);
        }
      })
    ];
  }
});
var iS = Oe.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [$2(this.options)];
  }
});
Oe.create({
  name: "focus",
  addOptions() {
    return {
      className: "has-focus",
      mode: "all"
    };
  },
  addProseMirrorPlugins() {
    return [
      new je({
        key: new Xe("focus"),
        props: {
          decorations: ({ doc: n, selection: e }) => {
            const { isEditable: t, isFocused: i } = this.editor, { anchor: r } = e, s = [];
            if (!t || !i)
              return ze.create(n, []);
            let o = 0;
            this.options.mode === "deepest" && n.descendants((l, c) => {
              if (l.isText)
                return;
              if (!(r >= c && r <= c + l.nodeSize - 1))
                return !1;
              o += 1;
            });
            let a = 0;
            return n.descendants((l, c) => {
              if (l.isText || !(r >= c && r <= c + l.nodeSize - 1))
                return !1;
              if (a += 1, this.options.mode === "deepest" && o - a > 0 || this.options.mode === "shallowest" && a > 1)
                return this.options.mode === "deepest";
              s.push(
                gt.node(c, c + l.nodeSize, {
                  class: this.options.className
                })
              );
            }), ze.create(n, s);
          }
        }
      })
    ];
  }
});
var rS = Oe.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [F2()];
  },
  extendNodeSchema(n) {
    var e;
    const t = {
      name: n.name,
      options: n.options,
      storage: n.storage
    };
    return {
      allowGapCursor: (e = Te(se(n, "allowGapCursor", t))) != null ? e : null
    };
  }
});
Oe.create({
  name: "placeholder",
  addOptions() {
    return {
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      placeholder: "Write something …",
      showOnlyWhenEditable: !0,
      showOnlyCurrent: !0,
      includeChildren: !1
    };
  },
  addProseMirrorPlugins() {
    return [
      new je({
        key: new Xe("placeholder"),
        props: {
          decorations: ({ doc: n, selection: e }) => {
            const t = this.editor.isEditable || !this.options.showOnlyWhenEditable, { anchor: i } = e, r = [];
            if (!t)
              return null;
            const s = this.editor.isEmpty;
            return n.descendants((o, a) => {
              const l = i >= a && i <= a + o.nodeSize, c = !o.isLeaf && Ns(o);
              if ((l || !this.options.showOnlyCurrent) && c) {
                const u = [this.options.emptyNodeClass];
                s && u.push(this.options.emptyEditorClass);
                const d = gt.node(a, a + o.nodeSize, {
                  class: u.join(" "),
                  "data-placeholder": typeof this.options.placeholder == "function" ? this.options.placeholder({
                    editor: this.editor,
                    node: o,
                    pos: a,
                    hasAnchor: l
                  }) : this.options.placeholder
                });
                r.push(d);
              }
              return this.options.includeChildren;
            }), ze.create(n, r);
          }
        }
      })
    ];
  }
});
Oe.create({
  name: "selection",
  addOptions() {
    return {
      className: "selection"
    };
  },
  addProseMirrorPlugins() {
    const { editor: n, options: e } = this;
    return [
      new je({
        key: new Xe("selection"),
        props: {
          decorations(t) {
            return t.selection.empty || n.isFocused || !n.isEditable || Hu(t.selection) || n.view.dragging ? null : ze.create(t.doc, [
              gt.inline(t.selection.from, t.selection.to, {
                class: e.className
              })
            ]);
          }
        }
      })
    ];
  }
});
function xf({ types: n, node: e }) {
  return e && Array.isArray(n) && n.includes(e.type) || e?.type === n;
}
Oe.create({
  name: "trailingNode",
  addOptions() {
    return {
      node: void 0,
      notAfter: []
    };
  },
  addProseMirrorPlugins() {
    var n;
    const e = new Xe(this.name), t = ((n = this.editor.schema.topNodeType.contentMatch.defaultType) == null ? void 0 : n.name) || this.options.node || "paragraph", i = Object.entries(this.editor.schema.nodes).map(([, r]) => r).filter((r) => (this.options.notAfter || []).concat(t).includes(r.name));
    return [
      new je({
        key: e,
        appendTransaction: (r, s, o) => {
          const { doc: a, tr: l, schema: c } = o, u = e.getState(o), d = a.content.size, h = c.nodes[t];
          if (u)
            return l.insert(d, h.create());
        },
        state: {
          init: (r, s) => {
            const o = s.tr.doc.lastChild;
            return !xf({ node: o, types: i });
          },
          apply: (r, s) => {
            if (!r.docChanged || r.getMeta("__uniqueIDTransaction"))
              return s;
            const o = r.doc.lastChild;
            return !xf({ node: o, types: i });
          }
        }
      })
    ];
  }
});
var sS = Oe.create({
  name: "undoRedo",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: n, dispatch: e }) => f_(n, e),
      redo: () => ({ state: n, dispatch: e }) => p_(n, e)
    };
  },
  addProseMirrorPlugins() {
    return [eS(this.options)];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), oS = Oe.create({
  name: "textAlign",
  addOptions() {
    return {
      types: [],
      alignments: ["left", "center", "right", "justify"],
      defaultAlignment: null
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: this.options.defaultAlignment,
            parseHTML: (n) => {
              const e = n.style.textAlign;
              return this.options.alignments.includes(e) ? e : this.options.defaultAlignment;
            },
            renderHTML: (n) => n.textAlign ? { style: `text-align: ${n.textAlign}` } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setTextAlign: (n) => ({ commands: e }) => this.options.alignments.includes(n) ? this.options.types.map((t) => e.updateAttributes(t, { textAlign: n })).every((t) => t) : !1,
      unsetTextAlign: () => ({ commands: n }) => this.options.types.map((e) => n.resetAttributes(e, "textAlign")).every((e) => e),
      toggleTextAlign: (n) => ({ editor: e, commands: t }) => this.options.alignments.includes(n) ? e.isActive({ textAlign: n }) ? t.unsetTextAlign() : t.setTextAlign(n) : !1
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
      "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
      "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
      "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
    };
  }
}), aS = 20, m_ = (n, e = 0) => {
  const t = [];
  return !n.children.length || e > aS || Array.from(n.children).forEach((i) => {
    i.tagName === "SPAN" ? t.push(i) : i.children.length && t.push(...m_(i, e + 1));
  }), t;
}, lS = (n) => {
  if (!n.children.length)
    return;
  const e = m_(n);
  e && e.forEach((t) => {
    var i, r;
    const s = t.getAttribute("style"), o = (r = (i = t.parentElement) == null ? void 0 : i.closest("span")) == null ? void 0 : r.getAttribute("style");
    t.setAttribute("style", `${o};${s}`);
  });
}, cS = Jt.create({
  name: "textStyle",
  priority: 101,
  addOptions() {
    return {
      HTMLAttributes: {},
      mergeNestedSpanStyles: !0
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        consuming: !1,
        getAttrs: (n) => n.hasAttribute("style") ? (this.options.mergeNestedSpanStyles && lS(n), {}) : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["span", Ee(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      toggleTextStyle: (n) => ({ commands: e }) => e.toggleMark(this.name, n),
      removeEmptyTextStyle: () => ({ tr: n }) => {
        const { selection: e } = n;
        return n.doc.nodesBetween(e.from, e.to, (t, i) => {
          if (t.isTextblock)
            return !0;
          t.marks.filter((r) => r.type === this.type).some((r) => Object.values(r.attrs).some((s) => !!s)) || n.removeMark(i, i + t.nodeSize, this.type);
        }), !0;
      }
    };
  }
}), uS = 20, g_ = (n, e = 0) => {
  const t = [];
  return !n.children.length || e > uS || Array.from(n.children).forEach((i) => {
    i.tagName === "SPAN" ? t.push(i) : i.children.length && t.push(...g_(i, e + 1));
  }), t;
}, dS = (n) => {
  if (!n.children.length)
    return;
  const e = g_(n);
  e && e.forEach((t) => {
    var i, r;
    const s = t.getAttribute("style"), o = (r = (i = t.parentElement) == null ? void 0 : i.closest("span")) == null ? void 0 : r.getAttribute("style");
    t.setAttribute("style", `${o};${s}`);
  });
};
Jt.create({
  name: "textStyle",
  priority: 101,
  addOptions() {
    return {
      HTMLAttributes: {},
      mergeNestedSpanStyles: !0
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        consuming: !1,
        getAttrs: (n) => n.hasAttribute("style") ? (this.options.mergeNestedSpanStyles && dS(n), {}) : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["span", Ee(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      toggleTextStyle: (n) => ({ commands: e }) => e.toggleMark(this.name, n),
      removeEmptyTextStyle: () => ({ tr: n }) => {
        const { selection: e } = n;
        return n.doc.nodesBetween(e.from, e.to, (t, i) => {
          if (t.isTextblock)
            return !0;
          t.marks.filter((r) => r.type === this.type).some((r) => Object.values(r.attrs).some((s) => !!s)) || n.removeMark(i, i + t.nodeSize, this.type);
        }), !0;
      }
    };
  }
});
var hS = Oe.create({
  name: "color",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (n) => {
              var e;
              const t = n.getAttribute("style");
              if (t) {
                const i = t.split(";").map((r) => r.trim()).filter(Boolean);
                for (let r = i.length - 1; r >= 0; r -= 1) {
                  const s = i[r].split(":");
                  if (s.length >= 2) {
                    const o = s[0].trim().toLowerCase(), a = s.slice(1).join(":").trim();
                    if (o === "color")
                      return a.replace(/['"]+/g, "");
                  }
                }
              }
              return (e = n.style.color) == null ? void 0 : e.replace(/['"]+/g, "");
            },
            renderHTML: (n) => n.color ? {
              style: `color: ${n.color}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setColor: (n) => ({ chain: e }) => e().setMark("textStyle", { color: n }).run(),
      unsetColor: () => ({ chain: n }) => n().setMark("textStyle", { color: null }).removeEmptyTextStyle().run()
    };
  }
}), fS = 20, __ = (n, e = 0) => {
  const t = [];
  return !n.children.length || e > fS || Array.from(n.children).forEach((i) => {
    i.tagName === "SPAN" ? t.push(i) : i.children.length && t.push(...__(i, e + 1));
  }), t;
}, pS = (n) => {
  if (!n.children.length)
    return;
  const e = __(n);
  e && e.forEach((t) => {
    var i, r;
    const s = t.getAttribute("style"), o = (r = (i = t.parentElement) == null ? void 0 : i.closest("span")) == null ? void 0 : r.getAttribute("style");
    t.setAttribute("style", `${o};${s}`);
  });
};
Jt.create({
  name: "textStyle",
  priority: 101,
  addOptions() {
    return {
      HTMLAttributes: {},
      mergeNestedSpanStyles: !0
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        consuming: !1,
        getAttrs: (n) => n.hasAttribute("style") ? (this.options.mergeNestedSpanStyles && pS(n), {}) : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["span", Ee(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      toggleTextStyle: (n) => ({ commands: e }) => e.toggleMark(this.name, n),
      removeEmptyTextStyle: () => ({ tr: n }) => {
        const { selection: e } = n;
        return n.doc.nodesBetween(e.from, e.to, (t, i) => {
          if (t.isTextblock)
            return !0;
          t.marks.filter((r) => r.type === this.type).some((r) => Object.values(r.attrs).some((s) => !!s)) || n.removeMark(i, i + t.nodeSize, this.type);
        }), !0;
      }
    };
  }
});
var mS = Oe.create({
  name: "backgroundColor",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          backgroundColor: {
            default: null,
            parseHTML: (n) => {
              var e;
              const t = n.getAttribute("style");
              if (t) {
                const i = t.split(";").map((r) => r.trim()).filter(Boolean);
                for (let r = i.length - 1; r >= 0; r -= 1) {
                  const s = i[r].split(":");
                  if (s.length >= 2) {
                    const o = s[0].trim().toLowerCase(), a = s.slice(1).join(":").trim();
                    if (o === "background-color")
                      return a.replace(/['"]+/g, "");
                  }
                }
              }
              return (e = n.style.backgroundColor) == null ? void 0 : e.replace(/['"]+/g, "");
            },
            renderHTML: (n) => n.backgroundColor ? {
              style: `background-color: ${n.backgroundColor}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setBackgroundColor: (n) => ({ chain: e }) => e().setMark("textStyle", { backgroundColor: n }).run(),
      unsetBackgroundColor: () => ({ chain: n }) => n().setMark("textStyle", { backgroundColor: null }).removeEmptyTextStyle().run()
    };
  }
}), gS = ({ key: n, editor: e, onPaste: t, onDrop: i, allowedMimeTypes: r }) => new je({
  key: n || new Xe("fileHandler"),
  props: {
    handleDrop(s, o) {
      var a;
      if (!i || !((a = o.dataTransfer) != null && a.files.length))
        return !1;
      const l = s.posAtCoords({
        left: o.clientX,
        top: o.clientY
      });
      let c = Array.from(o.dataTransfer.files);
      return r && (c = c.filter((u) => r.includes(u.type))), c.length === 0 ? !1 : (o.preventDefault(), o.stopPropagation(), i(e, c, l?.pos || 0), !0);
    },
    handlePaste(s, o) {
      var a;
      if (!t || !((a = o.clipboardData) != null && a.files.length))
        return !1;
      let l = Array.from(o.clipboardData.files);
      const c = o.clipboardData.getData("text/html");
      return r && (l = l.filter((u) => r.includes(u.type))), !(l.length === 0 || (o.preventDefault(), o.stopPropagation(), t(e, l, c), c.length > 0));
    }
  }
}), _S = Oe.create({
  name: "fileHandler",
  addOptions() {
    return {
      onPaste: void 0,
      onDrop: void 0,
      allowedMimeTypes: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      gS({
        key: new Xe(this.name),
        editor: this.editor,
        allowedMimeTypes: this.options.allowedMimeTypes,
        onDrop: this.options.onDrop,
        onPaste: this.options.onPaste
      })
    ];
  }
});
const Fl = async (n, e) => {
  for (let t of e)
    if (t) {
      if (/^blob:/.test(t))
        try {
          t = await (await fetch(t)).text();
        } catch (i) {
          console.error(i);
          continue;
        }
      else !/^https?:/.test(t) && /\.css$/i.test(t) && (t = new URL(t, window.location.href).href);
      if (/^https?:/.test(t)) {
        const i = document.createElement("link");
        i.rel = "stylesheet", i.href = t, n.appendChild(i);
      } else {
        const i = document.createElement("style");
        i.textContent = t, n.appendChild(i);
      }
    }
}, bS = (n) => {
  if ("srcdoc" in n)
    return !0;
  const e = n.src;
  if (!e)
    return !0;
  const t = document.createElement("a");
  return t.href = e, t.hostname === window.location.hostname && t.protocol === window.location.protocol && t.port === window.location.port;
}, vS = Ne.create({
  name: "iframe",
  group: "inline",
  content: "text*",
  inline: !0,
  atom: !0,
  parseHTML() {
    return [
      {
        tag: "iframe"
      }
    ];
  },
  addNodeView() {
    return ({ node: n }) => {
      let { MTRichTextEditorHTMLAttributes: e } = n.attrs;
      if (bS(e)) {
        const i = e.sandbox ? e.sandbox.split(/\s+/).filter((r) => !/allow-same-origin/i.test(r)).join(" ") : "allow-scripts";
        e = {
          ...e,
          sandbox: i
        };
      }
      const t = document.createElement("iframe");
      for (const i in e)
        t.setAttribute(i, e[i]);
      return {
        dom: t
      };
    };
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["iframe", n];
  }
});
var Nc, Lc;
if (typeof WeakMap < "u") {
  let n = /* @__PURE__ */ new WeakMap();
  Nc = (e) => n.get(e), Lc = (e, t) => (n.set(e, t), t);
} else {
  const n = [];
  let t = 0;
  Nc = (i) => {
    for (let r = 0; r < n.length; r += 2)
      if (n[r] == i) return n[r + 1];
  }, Lc = (i, r) => (t == 10 && (t = 0), n[t++] = i, n[t++] = r);
}
var Ge = class {
  constructor(n, e, t, i) {
    this.width = n, this.height = e, this.map = t, this.problems = i;
  }
  // Find the dimensions of the cell at the given position.
  findCell(n) {
    for (let e = 0; e < this.map.length; e++) {
      const t = this.map[e];
      if (t != n) continue;
      const i = e % this.width, r = e / this.width | 0;
      let s = i + 1, o = r + 1;
      for (let a = 1; s < this.width && this.map[e + a] == t; a++)
        s++;
      for (let a = 1; o < this.height && this.map[e + this.width * a] == t; a++)
        o++;
      return { left: i, top: r, right: s, bottom: o };
    }
    throw new RangeError(`No cell with offset ${n} found`);
  }
  // Find the left side of the cell at the given position.
  colCount(n) {
    for (let e = 0; e < this.map.length; e++)
      if (this.map[e] == n)
        return e % this.width;
    throw new RangeError(`No cell with offset ${n} found`);
  }
  // Find the next cell in the given direction, starting from the cell
  // at `pos`, if any.
  nextCell(n, e, t) {
    const { left: i, right: r, top: s, bottom: o } = this.findCell(n);
    return e == "horiz" ? (t < 0 ? i == 0 : r == this.width) ? null : this.map[s * this.width + (t < 0 ? i - 1 : r)] : (t < 0 ? s == 0 : o == this.height) ? null : this.map[i + this.width * (t < 0 ? s - 1 : o)];
  }
  // Get the rectangle spanning the two given cells.
  rectBetween(n, e) {
    const {
      left: t,
      right: i,
      top: r,
      bottom: s
    } = this.findCell(n), {
      left: o,
      right: a,
      top: l,
      bottom: c
    } = this.findCell(e);
    return {
      left: Math.min(t, o),
      top: Math.min(r, l),
      right: Math.max(i, a),
      bottom: Math.max(s, c)
    };
  }
  // Return the position of all cells that have the top left corner in
  // the given rectangle.
  cellsInRect(n) {
    const e = [], t = {};
    for (let i = n.top; i < n.bottom; i++)
      for (let r = n.left; r < n.right; r++) {
        const s = i * this.width + r, o = this.map[s];
        t[o] || (t[o] = !0, !(r == n.left && r && this.map[s - 1] == o || i == n.top && i && this.map[s - this.width] == o) && e.push(o));
      }
    return e;
  }
  // Return the position at which the cell at the given row and column
  // starts, or would start, if a cell started there.
  positionAt(n, e, t) {
    for (let i = 0, r = 0; ; i++) {
      const s = r + t.child(i).nodeSize;
      if (i == n) {
        let o = e + n * this.width;
        const a = (n + 1) * this.width;
        for (; o < a && this.map[o] < r; ) o++;
        return o == a ? s - 1 : this.map[o];
      }
      r = s;
    }
  }
  // Find the table map for the given table node.
  static get(n) {
    return Nc(n) || Lc(n, yS(n));
  }
};
function yS(n) {
  if (n.type.spec.tableRole != "table")
    throw new RangeError("Not a table node: " + n.type.name);
  const e = xS(n), t = n.childCount, i = [];
  let r = 0, s = null;
  const o = [];
  for (let c = 0, u = e * t; c < u; c++) i[c] = 0;
  for (let c = 0, u = 0; c < t; c++) {
    const d = n.child(c);
    u++;
    for (let p = 0; ; p++) {
      for (; r < i.length && i[r] != 0; ) r++;
      if (p == d.childCount) break;
      const _ = d.child(p), { colspan: m, rowspan: g, colwidth: y } = _.attrs;
      for (let x = 0; x < g; x++) {
        if (x + c >= t) {
          (s || (s = [])).push({
            type: "overlong_rowspan",
            pos: u,
            n: g - x
          });
          break;
        }
        const k = r + x * e;
        for (let E = 0; E < m; E++) {
          i[k + E] == 0 ? i[k + E] = u : (s || (s = [])).push({
            type: "collision",
            row: c,
            pos: u,
            n: m - E
          });
          const S = y && y[E];
          if (S) {
            const w = (k + E) % e * 2, v = o[w];
            v == null || v != S && o[w + 1] == 1 ? (o[w] = S, o[w + 1] = 1) : v == S && o[w + 1]++;
          }
        }
      }
      r += m, u += _.nodeSize;
    }
    const h = (c + 1) * e;
    let f = 0;
    for (; r < h; ) i[r++] == 0 && f++;
    f && (s || (s = [])).push({ type: "missing", row: c, n: f }), u++;
  }
  (e === 0 || t === 0) && (s || (s = [])).push({ type: "zero_sized" });
  const a = new Ge(e, t, i, s);
  let l = !1;
  for (let c = 0; !l && c < o.length; c += 2)
    o[c] != null && o[c + 1] < t && (l = !0);
  return l && wS(a, o, n), a;
}
function xS(n) {
  let e = -1, t = !1;
  for (let i = 0; i < n.childCount; i++) {
    const r = n.child(i);
    let s = 0;
    if (t)
      for (let o = 0; o < i; o++) {
        const a = n.child(o);
        for (let l = 0; l < a.childCount; l++) {
          const c = a.child(l);
          o + c.attrs.rowspan > i && (s += c.attrs.colspan);
        }
      }
    for (let o = 0; o < r.childCount; o++) {
      const a = r.child(o);
      s += a.attrs.colspan, a.attrs.rowspan > 1 && (t = !0);
    }
    e == -1 ? e = s : e != s && (e = Math.max(e, s));
  }
  return e;
}
function wS(n, e, t) {
  n.problems || (n.problems = []);
  const i = {};
  for (let r = 0; r < n.map.length; r++) {
    const s = n.map[r];
    if (i[s]) continue;
    i[s] = !0;
    const o = t.nodeAt(s);
    if (!o)
      throw new RangeError(`No cell with offset ${s} found`);
    let a = null;
    const l = o.attrs;
    for (let c = 0; c < l.colspan; c++) {
      const u = (r + c) % n.width, d = e[u * 2];
      d != null && (!l.colwidth || l.colwidth[c] != d) && ((a || (a = kS(l)))[c] = d);
    }
    a && n.problems.unshift({
      type: "colwidth mismatch",
      pos: s,
      colwidth: a
    });
  }
}
function kS(n) {
  if (n.colwidth) return n.colwidth.slice();
  const e = [];
  for (let t = 0; t < n.colspan; t++) e.push(0);
  return e;
}
function Nt(n) {
  let e = n.cached.tableNodeTypes;
  if (!e) {
    e = n.cached.tableNodeTypes = {};
    for (const t in n.nodes) {
      const i = n.nodes[t], r = i.spec.tableRole;
      r && (e[r] = i);
    }
  }
  return e;
}
var ai = new Xe("selectingCells");
function wr(n) {
  for (let e = n.depth - 1; e > 0; e--)
    if (n.node(e).type.spec.tableRole == "row")
      return n.node(0).resolve(n.before(e + 1));
  return null;
}
function SS(n) {
  for (let e = n.depth; e > 0; e--) {
    const t = n.node(e).type.spec.tableRole;
    if (t === "cell" || t === "header_cell") return n.node(e);
  }
  return null;
}
function xn(n) {
  const e = n.selection.$head;
  for (let t = e.depth; t > 0; t--)
    if (e.node(t).type.spec.tableRole == "row") return !0;
  return !1;
}
function qa(n) {
  const e = n.selection;
  if ("$anchorCell" in e && e.$anchorCell)
    return e.$anchorCell.pos > e.$headCell.pos ? e.$anchorCell : e.$headCell;
  if ("node" in e && e.node && e.node.type.spec.tableRole == "cell")
    return e.$anchor;
  const t = wr(e.$head) || ES(e.$head);
  if (t)
    return t;
  throw new RangeError(`No cell found around position ${e.head}`);
}
function ES(n) {
  for (let e = n.nodeAfter, t = n.pos; e; e = e.firstChild, t++) {
    const i = e.type.spec.tableRole;
    if (i == "cell" || i == "header_cell") return n.doc.resolve(t);
  }
  for (let e = n.nodeBefore, t = n.pos; e; e = e.lastChild, t--) {
    const i = e.type.spec.tableRole;
    if (i == "cell" || i == "header_cell")
      return n.doc.resolve(t - e.nodeSize);
  }
}
function Rc(n) {
  return n.parent.type.spec.tableRole == "row" && !!n.nodeAfter;
}
function CS(n) {
  return n.node(0).resolve(n.pos + n.nodeAfter.nodeSize);
}
function Xu(n, e) {
  return n.depth == e.depth && n.pos >= e.start(-1) && n.pos <= e.end(-1);
}
function b_(n, e, t) {
  const i = n.node(-1), r = Ge.get(i), s = n.start(-1), o = r.nextCell(n.pos - s, e, t);
  return o == null ? null : n.node(0).resolve(s + o);
}
function $i(n, e, t = 1) {
  const i = { ...n, colspan: n.colspan - t };
  return i.colwidth && (i.colwidth = i.colwidth.slice(), i.colwidth.splice(e, t), i.colwidth.some((r) => r > 0) || (i.colwidth = null)), i;
}
function v_(n, e, t = 1) {
  const i = { ...n, colspan: n.colspan + t };
  if (i.colwidth) {
    i.colwidth = i.colwidth.slice();
    for (let r = 0; r < t; r++) i.colwidth.splice(e, 0, 0);
  }
  return i;
}
function TS(n, e, t) {
  const i = Nt(e.type.schema).header_cell;
  for (let r = 0; r < n.height; r++)
    if (e.nodeAt(n.map[t + r * n.width]).type != i)
      return !1;
  return !0;
}
var He = class zn extends fe {
  // A table selection is identified by its anchor and head cells. The
  // positions given to this constructor should point _before_ two
  // cells in the same table. They may be the same, to select a single
  // cell.
  constructor(e, t = e) {
    const i = e.node(-1), r = Ge.get(i), s = e.start(-1), o = r.rectBetween(
      e.pos - s,
      t.pos - s
    ), a = e.node(0), l = r.cellsInRect(o).filter((u) => u != t.pos - s);
    l.unshift(t.pos - s);
    const c = l.map((u) => {
      const d = i.nodeAt(u);
      if (!d)
        throw RangeError(`No cell with offset ${u} found`);
      const h = s + u + 1;
      return new lm(
        a.resolve(h),
        a.resolve(h + d.content.size)
      );
    });
    super(c[0].$from, c[0].$to, c), this.$anchorCell = e, this.$headCell = t;
  }
  map(e, t) {
    const i = e.resolve(t.map(this.$anchorCell.pos)), r = e.resolve(t.map(this.$headCell.pos));
    if (Rc(i) && Rc(r) && Xu(i, r)) {
      const s = this.$anchorCell.node(-1) != i.node(-1);
      return s && this.isRowSelection() ? zn.rowSelection(i, r) : s && this.isColSelection() ? zn.colSelection(i, r) : new zn(i, r);
    }
    return ue.between(i, r);
  }
  // Returns a rectangular slice of table rows containing the selected
  // cells.
  content() {
    const e = this.$anchorCell.node(-1), t = Ge.get(e), i = this.$anchorCell.start(-1), r = t.rectBetween(
      this.$anchorCell.pos - i,
      this.$headCell.pos - i
    ), s = {}, o = [];
    for (let l = r.top; l < r.bottom; l++) {
      const c = [];
      for (let u = l * t.width + r.left, d = r.left; d < r.right; d++, u++) {
        const h = t.map[u];
        if (s[h]) continue;
        s[h] = !0;
        const f = t.findCell(h);
        let p = e.nodeAt(h);
        if (!p)
          throw RangeError(`No cell with offset ${h} found`);
        const _ = r.left - f.left, m = f.right - r.right;
        if (_ > 0 || m > 0) {
          let g = p.attrs;
          if (_ > 0 && (g = $i(g, 0, _)), m > 0 && (g = $i(
            g,
            g.colspan - m,
            m
          )), f.left < r.left) {
            if (p = p.type.createAndFill(g), !p)
              throw RangeError(
                `Could not create cell with attrs ${JSON.stringify(g)}`
              );
          } else
            p = p.type.create(g, p.content);
        }
        if (f.top < r.top || f.bottom > r.bottom) {
          const g = {
            ...p.attrs,
            rowspan: Math.min(f.bottom, r.bottom) - Math.max(f.top, r.top)
          };
          f.top < r.top ? p = p.type.createAndFill(g) : p = p.type.create(g, p.content);
        }
        c.push(p);
      }
      o.push(e.child(l).copy($.from(c)));
    }
    const a = this.isColSelection() && this.isRowSelection() ? e : o;
    return new J($.from(a), 1, 1);
  }
  replace(e, t = J.empty) {
    const i = e.steps.length, r = this.ranges;
    for (let o = 0; o < r.length; o++) {
      const { $from: a, $to: l } = r[o], c = e.mapping.slice(i);
      e.replace(
        c.map(a.pos),
        c.map(l.pos),
        o ? J.empty : t
      );
    }
    const s = fe.findFrom(
      e.doc.resolve(e.mapping.slice(i).map(this.to)),
      -1
    );
    s && e.setSelection(s);
  }
  replaceWith(e, t) {
    this.replace(e, new J($.from(t), 0, 0));
  }
  forEachCell(e) {
    const t = this.$anchorCell.node(-1), i = Ge.get(t), r = this.$anchorCell.start(-1), s = i.cellsInRect(
      i.rectBetween(
        this.$anchorCell.pos - r,
        this.$headCell.pos - r
      )
    );
    for (let o = 0; o < s.length; o++)
      e(t.nodeAt(s[o]), r + s[o]);
  }
  // True if this selection goes all the way from the top to the
  // bottom of the table.
  isColSelection() {
    const e = this.$anchorCell.index(-1), t = this.$headCell.index(-1);
    if (Math.min(e, t) > 0) return !1;
    const i = e + this.$anchorCell.nodeAfter.attrs.rowspan, r = t + this.$headCell.nodeAfter.attrs.rowspan;
    return Math.max(i, r) == this.$headCell.node(-1).childCount;
  }
  // Returns the smallest column selection that covers the given anchor
  // and head cell.
  static colSelection(e, t = e) {
    const i = e.node(-1), r = Ge.get(i), s = e.start(-1), o = r.findCell(e.pos - s), a = r.findCell(t.pos - s), l = e.node(0);
    return o.top <= a.top ? (o.top > 0 && (e = l.resolve(s + r.map[o.left])), a.bottom < r.height && (t = l.resolve(
      s + r.map[r.width * (r.height - 1) + a.right - 1]
    ))) : (a.top > 0 && (t = l.resolve(s + r.map[a.left])), o.bottom < r.height && (e = l.resolve(
      s + r.map[r.width * (r.height - 1) + o.right - 1]
    ))), new zn(e, t);
  }
  // True if this selection goes all the way from the left to the
  // right of the table.
  isRowSelection() {
    const e = this.$anchorCell.node(-1), t = Ge.get(e), i = this.$anchorCell.start(-1), r = t.colCount(this.$anchorCell.pos - i), s = t.colCount(this.$headCell.pos - i);
    if (Math.min(r, s) > 0) return !1;
    const o = r + this.$anchorCell.nodeAfter.attrs.colspan, a = s + this.$headCell.nodeAfter.attrs.colspan;
    return Math.max(o, a) == t.width;
  }
  eq(e) {
    return e instanceof zn && e.$anchorCell.pos == this.$anchorCell.pos && e.$headCell.pos == this.$headCell.pos;
  }
  // Returns the smallest row selection that covers the given anchor
  // and head cell.
  static rowSelection(e, t = e) {
    const i = e.node(-1), r = Ge.get(i), s = e.start(-1), o = r.findCell(e.pos - s), a = r.findCell(t.pos - s), l = e.node(0);
    return o.left <= a.left ? (o.left > 0 && (e = l.resolve(
      s + r.map[o.top * r.width]
    )), a.right < r.width && (t = l.resolve(
      s + r.map[r.width * (a.top + 1) - 1]
    ))) : (a.left > 0 && (t = l.resolve(s + r.map[a.top * r.width])), o.right < r.width && (e = l.resolve(
      s + r.map[r.width * (o.top + 1) - 1]
    ))), new zn(e, t);
  }
  toJSON() {
    return {
      type: "cell",
      anchor: this.$anchorCell.pos,
      head: this.$headCell.pos
    };
  }
  static fromJSON(e, t) {
    return new zn(e.resolve(t.anchor), e.resolve(t.head));
  }
  static create(e, t, i = t) {
    return new zn(e.resolve(t), e.resolve(i));
  }
  getBookmark() {
    return new AS(this.$anchorCell.pos, this.$headCell.pos);
  }
};
He.prototype.visible = !1;
fe.jsonID("cell", He);
var AS = class y_ {
  constructor(e, t) {
    this.anchor = e, this.head = t;
  }
  map(e) {
    return new y_(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    const t = e.resolve(this.anchor), i = e.resolve(this.head);
    return t.parent.type.spec.tableRole == "row" && i.parent.type.spec.tableRole == "row" && t.index() < t.parent.childCount && i.index() < i.parent.childCount && Xu(t, i) ? new He(t, i) : fe.near(i, 1);
  }
};
function MS(n) {
  if (!(n.selection instanceof He)) return null;
  const e = [];
  return n.selection.forEachCell((t, i) => {
    e.push(
      gt.node(i, i + t.nodeSize, { class: "selectedCell" })
    );
  }), ze.create(n.doc, e);
}
function OS({ $from: n, $to: e }) {
  if (n.pos == e.pos || n.pos < e.pos - 6) return !1;
  let t = n.pos, i = e.pos, r = n.depth;
  for (; r >= 0 && !(n.after(r + 1) < n.end(r)); r--, t++)
    ;
  for (let s = e.depth; s >= 0 && !(e.before(s + 1) > e.start(s)); s--, i--)
    ;
  return t == i && /row|table/.test(n.node(r).type.spec.tableRole);
}
function NS({ $from: n, $to: e }) {
  let t, i;
  for (let r = n.depth; r > 0; r--) {
    const s = n.node(r);
    if (s.type.spec.tableRole === "cell" || s.type.spec.tableRole === "header_cell") {
      t = s;
      break;
    }
  }
  for (let r = e.depth; r > 0; r--) {
    const s = e.node(r);
    if (s.type.spec.tableRole === "cell" || s.type.spec.tableRole === "header_cell") {
      i = s;
      break;
    }
  }
  return t !== i && e.parentOffset === 0;
}
function LS(n, e, t) {
  const i = (e || n).selection, r = (e || n).doc;
  let s, o;
  if (i instanceof re && (o = i.node.type.spec.tableRole)) {
    if (o == "cell" || o == "header_cell")
      s = He.create(r, i.from);
    else if (o == "row") {
      const a = r.resolve(i.from + 1);
      s = He.rowSelection(a, a);
    } else if (!t) {
      const a = Ge.get(i.node), l = i.from + 1, c = l + a.map[a.width * a.height - 1];
      s = He.create(r, l + 1, c);
    }
  } else i instanceof ue && OS(i) ? s = ue.create(r, i.from) : i instanceof ue && NS(i) && (s = ue.create(r, i.$from.start(), i.$from.end()));
  return s && (e || (e = n.tr)).setSelection(s), e;
}
var RS = new Xe("fix-tables");
function x_(n, e, t, i) {
  const r = n.childCount, s = e.childCount;
  e: for (let o = 0, a = 0; o < s; o++) {
    const l = e.child(o);
    for (let c = a, u = Math.min(r, o + 3); c < u; c++)
      if (n.child(c) == l) {
        a = c + 1, t += l.nodeSize;
        continue e;
      }
    i(l, t), a < r && n.child(a).sameMarkup(l) ? x_(n.child(a), l, t + 1, i) : l.nodesBetween(0, l.content.size, i, t + 1), t += l.nodeSize;
  }
}
function w_(n, e) {
  let t;
  const i = (r, s) => {
    r.type.spec.tableRole == "table" && (t = IS(n, r, s, t));
  };
  return e ? e.doc != n.doc && x_(e.doc, n.doc, 0, i) : n.doc.descendants(i), t;
}
function IS(n, e, t, i) {
  const r = Ge.get(e);
  if (!r.problems) return i;
  i || (i = n.tr);
  const s = [];
  for (let l = 0; l < r.height; l++) s.push(0);
  for (let l = 0; l < r.problems.length; l++) {
    const c = r.problems[l];
    if (c.type == "collision") {
      const u = e.nodeAt(c.pos);
      if (!u) continue;
      const d = u.attrs;
      for (let h = 0; h < d.rowspan; h++) s[c.row + h] += c.n;
      i.setNodeMarkup(
        i.mapping.map(t + 1 + c.pos),
        null,
        $i(d, d.colspan - c.n, c.n)
      );
    } else if (c.type == "missing")
      s[c.row] += c.n;
    else if (c.type == "overlong_rowspan") {
      const u = e.nodeAt(c.pos);
      if (!u) continue;
      i.setNodeMarkup(i.mapping.map(t + 1 + c.pos), null, {
        ...u.attrs,
        rowspan: u.attrs.rowspan - c.n
      });
    } else if (c.type == "colwidth mismatch") {
      const u = e.nodeAt(c.pos);
      if (!u) continue;
      i.setNodeMarkup(i.mapping.map(t + 1 + c.pos), null, {
        ...u.attrs,
        colwidth: c.colwidth
      });
    } else if (c.type == "zero_sized") {
      const u = i.mapping.map(t);
      i.delete(u, u + e.nodeSize);
    }
  }
  let o, a;
  for (let l = 0; l < s.length; l++)
    s[l] && (o == null && (o = l), a = l);
  for (let l = 0, c = t + 1; l < r.height; l++) {
    const u = e.child(l), d = c + u.nodeSize, h = s[l];
    if (h > 0) {
      let f = "cell";
      u.firstChild && (f = u.firstChild.type.spec.tableRole);
      const p = [];
      for (let m = 0; m < h; m++) {
        const g = Nt(n.schema)[f].createAndFill();
        g && p.push(g);
      }
      const _ = (l == 0 || o == l - 1) && a == l ? c + 1 : d - 1;
      i.insert(i.mapping.map(_), p);
    }
    c = d;
  }
  return i.setMeta(RS, { fixTables: !0 });
}
function cn(n) {
  const e = n.selection, t = qa(n), i = t.node(-1), r = t.start(-1), s = Ge.get(i);
  return { ...e instanceof He ? s.rectBetween(
    e.$anchorCell.pos - r,
    e.$headCell.pos - r
  ) : s.findCell(t.pos - r), tableStart: r, map: s, table: i };
}
function k_(n, { map: e, tableStart: t, table: i }, r) {
  let s = r > 0 ? -1 : 0;
  TS(e, i, r + s) && (s = r == 0 || r == e.width ? null : 0);
  for (let o = 0; o < e.height; o++) {
    const a = o * e.width + r;
    if (r > 0 && r < e.width && e.map[a - 1] == e.map[a]) {
      const l = e.map[a], c = i.nodeAt(l);
      n.setNodeMarkup(
        n.mapping.map(t + l),
        null,
        v_(c.attrs, r - e.colCount(l))
      ), o += c.attrs.rowspan - 1;
    } else {
      const l = s == null ? Nt(i.type.schema).cell : i.nodeAt(e.map[a + s]).type, c = e.positionAt(o, r, i);
      n.insert(n.mapping.map(t + c), l.createAndFill());
    }
  }
  return n;
}
function PS(n, e) {
  if (!xn(n)) return !1;
  if (e) {
    const t = cn(n);
    e(k_(n.tr, t, t.left));
  }
  return !0;
}
function DS(n, e) {
  if (!xn(n)) return !1;
  if (e) {
    const t = cn(n);
    e(k_(n.tr, t, t.right));
  }
  return !0;
}
function $S(n, { map: e, table: t, tableStart: i }, r) {
  const s = n.mapping.maps.length;
  for (let o = 0; o < e.height; ) {
    const a = o * e.width + r, l = e.map[a], c = t.nodeAt(l), u = c.attrs;
    if (r > 0 && e.map[a - 1] == l || r < e.width - 1 && e.map[a + 1] == l)
      n.setNodeMarkup(
        n.mapping.slice(s).map(i + l),
        null,
        $i(u, r - e.colCount(l))
      );
    else {
      const d = n.mapping.slice(s).map(i + l);
      n.delete(d, d + c.nodeSize);
    }
    o += u.rowspan;
  }
}
function zS(n, e) {
  if (!xn(n)) return !1;
  if (e) {
    const t = cn(n), i = n.tr;
    if (t.left == 0 && t.right == t.map.width) return !1;
    for (let r = t.right - 1; $S(i, t, r), r != t.left; r--) {
      const s = t.tableStart ? i.doc.nodeAt(t.tableStart - 1) : i.doc;
      if (!s)
        throw RangeError("No table found");
      t.table = s, t.map = Ge.get(s);
    }
    e(i);
  }
  return !0;
}
function HS(n, e, t) {
  var i;
  const r = Nt(e.type.schema).header_cell;
  for (let s = 0; s < n.width; s++)
    if (((i = e.nodeAt(n.map[s + t * n.width])) == null ? void 0 : i.type) != r)
      return !1;
  return !0;
}
function S_(n, { map: e, tableStart: t, table: i }, r) {
  var s;
  let o = t;
  for (let c = 0; c < r; c++) o += i.child(c).nodeSize;
  const a = [];
  let l = r > 0 ? -1 : 0;
  HS(e, i, r + l) && (l = r == 0 || r == e.height ? null : 0);
  for (let c = 0, u = e.width * r; c < e.width; c++, u++)
    if (r > 0 && r < e.height && e.map[u] == e.map[u - e.width]) {
      const d = e.map[u], h = i.nodeAt(d).attrs;
      n.setNodeMarkup(t + d, null, {
        ...h,
        rowspan: h.rowspan + 1
      }), c += h.colspan - 1;
    } else {
      const d = l == null ? Nt(i.type.schema).cell : (s = i.nodeAt(e.map[u + l * e.width])) == null ? void 0 : s.type, h = d?.createAndFill();
      h && a.push(h);
    }
  return n.insert(o, Nt(i.type.schema).row.create(null, a)), n;
}
function BS(n, e) {
  if (!xn(n)) return !1;
  if (e) {
    const t = cn(n);
    e(S_(n.tr, t, t.top));
  }
  return !0;
}
function FS(n, e) {
  if (!xn(n)) return !1;
  if (e) {
    const t = cn(n);
    e(S_(n.tr, t, t.bottom));
  }
  return !0;
}
function VS(n, { map: e, table: t, tableStart: i }, r) {
  let s = 0;
  for (let c = 0; c < r; c++) s += t.child(c).nodeSize;
  const o = s + t.child(r).nodeSize, a = n.mapping.maps.length;
  n.delete(s + i, o + i);
  const l = /* @__PURE__ */ new Set();
  for (let c = 0, u = r * e.width; c < e.width; c++, u++) {
    const d = e.map[u];
    if (!l.has(d)) {
      if (l.add(d), r > 0 && d == e.map[u - e.width]) {
        const h = t.nodeAt(d).attrs;
        n.setNodeMarkup(n.mapping.slice(a).map(d + i), null, {
          ...h,
          rowspan: h.rowspan - 1
        }), c += h.colspan - 1;
      } else if (r < e.height && d == e.map[u + e.width]) {
        const h = t.nodeAt(d), f = h.attrs, p = h.type.create(
          { ...f, rowspan: h.attrs.rowspan - 1 },
          h.content
        ), _ = e.positionAt(r + 1, c, t);
        n.insert(n.mapping.slice(a).map(i + _), p), c += f.colspan - 1;
      }
    }
  }
}
function jS(n, e) {
  if (!xn(n)) return !1;
  if (e) {
    const t = cn(n), i = n.tr;
    if (t.top == 0 && t.bottom == t.map.height) return !1;
    for (let r = t.bottom - 1; VS(i, t, r), r != t.top; r--) {
      const s = t.tableStart ? i.doc.nodeAt(t.tableStart - 1) : i.doc;
      if (!s)
        throw RangeError("No table found");
      t.table = s, t.map = Ge.get(t.table);
    }
    e(i);
  }
  return !0;
}
function wf(n) {
  const e = n.content;
  return e.childCount == 1 && e.child(0).isTextblock && e.child(0).childCount == 0;
}
function WS({ width: n, height: e, map: t }, i) {
  let r = i.top * n + i.left, s = r, o = (i.bottom - 1) * n + i.left, a = r + (i.right - i.left - 1);
  for (let l = i.top; l < i.bottom; l++) {
    if (i.left > 0 && t[s] == t[s - 1] || i.right < n && t[a] == t[a + 1])
      return !0;
    s += n, a += n;
  }
  for (let l = i.left; l < i.right; l++) {
    if (i.top > 0 && t[r] == t[r - n] || i.bottom < e && t[o] == t[o + n])
      return !0;
    r++, o++;
  }
  return !1;
}
function kf(n, e) {
  const t = n.selection;
  if (!(t instanceof He) || t.$anchorCell.pos == t.$headCell.pos)
    return !1;
  const i = cn(n), { map: r } = i;
  if (WS(r, i)) return !1;
  if (e) {
    const s = n.tr, o = {};
    let a = $.empty, l, c;
    for (let u = i.top; u < i.bottom; u++)
      for (let d = i.left; d < i.right; d++) {
        const h = r.map[u * r.width + d], f = i.table.nodeAt(h);
        if (!(o[h] || !f))
          if (o[h] = !0, l == null)
            l = h, c = f;
          else {
            wf(f) || (a = a.append(f.content));
            const p = s.mapping.map(h + i.tableStart);
            s.delete(p, p + f.nodeSize);
          }
      }
    if (l == null || c == null)
      return !0;
    if (s.setNodeMarkup(l + i.tableStart, null, {
      ...v_(
        c.attrs,
        c.attrs.colspan,
        i.right - i.left - c.attrs.colspan
      ),
      rowspan: i.bottom - i.top
    }), a.size) {
      const u = l + 1 + c.content.size, d = wf(c) ? l + 1 : u;
      s.replaceWith(d + i.tableStart, u + i.tableStart, a);
    }
    s.setSelection(
      new He(s.doc.resolve(l + i.tableStart))
    ), e(s);
  }
  return !0;
}
function Sf(n, e) {
  const t = Nt(n.schema);
  return US(({ node: i }) => t[i.type.spec.tableRole])(n, e);
}
function US(n) {
  return (e, t) => {
    var i;
    const r = e.selection;
    let s, o;
    if (r instanceof He) {
      if (r.$anchorCell.pos != r.$headCell.pos) return !1;
      s = r.$anchorCell.nodeAfter, o = r.$anchorCell.pos;
    } else {
      if (s = SS(r.$from), !s) return !1;
      o = (i = wr(r.$from)) == null ? void 0 : i.pos;
    }
    if (s == null || o == null || s.attrs.colspan == 1 && s.attrs.rowspan == 1)
      return !1;
    if (t) {
      let a = s.attrs;
      const l = [], c = a.colwidth;
      a.rowspan > 1 && (a = { ...a, rowspan: 1 }), a.colspan > 1 && (a = { ...a, colspan: 1 });
      const u = cn(e), d = e.tr;
      for (let f = 0; f < u.right - u.left; f++)
        l.push(
          c ? {
            ...a,
            colwidth: c && c[f] ? [c[f]] : null
          } : a
        );
      let h;
      for (let f = u.top; f < u.bottom; f++) {
        let p = u.map.positionAt(f, u.left, u.table);
        f == u.top && (p += s.nodeSize);
        for (let _ = u.left, m = 0; _ < u.right; _++, m++)
          _ == u.left && f == u.top || d.insert(
            h = d.mapping.map(p + u.tableStart, 1),
            n({ node: s, row: f, col: _ }).createAndFill(l[m])
          );
      }
      d.setNodeMarkup(
        o,
        n({ node: s, row: u.top, col: u.left }),
        l[0]
      ), r instanceof He && d.setSelection(
        new He(
          d.doc.resolve(r.$anchorCell.pos),
          h ? d.doc.resolve(h) : void 0
        )
      ), t(d);
    }
    return !0;
  };
}
function KS(n, e) {
  return function(t, i) {
    if (!xn(t)) return !1;
    const r = qa(t);
    if (r.nodeAfter.attrs[n] === e) return !1;
    if (i) {
      const s = t.tr;
      t.selection instanceof He ? t.selection.forEachCell((o, a) => {
        o.attrs[n] !== e && s.setNodeMarkup(a, null, {
          ...o.attrs,
          [n]: e
        });
      }) : s.setNodeMarkup(r.pos, null, {
        ...r.nodeAfter.attrs,
        [n]: e
      }), i(s);
    }
    return !0;
  };
}
function qS(n) {
  return function(e, t) {
    if (!xn(e)) return !1;
    if (t) {
      const i = Nt(e.schema), r = cn(e), s = e.tr, o = r.map.cellsInRect(
        n == "column" ? {
          left: r.left,
          top: 0,
          right: r.right,
          bottom: r.map.height
        } : n == "row" ? {
          left: 0,
          top: r.top,
          right: r.map.width,
          bottom: r.bottom
        } : r
      ), a = o.map((l) => r.table.nodeAt(l));
      for (let l = 0; l < o.length; l++)
        a[l].type == i.header_cell && s.setNodeMarkup(
          r.tableStart + o[l],
          i.cell,
          a[l].attrs
        );
      if (s.steps.length == 0)
        for (let l = 0; l < o.length; l++)
          s.setNodeMarkup(
            r.tableStart + o[l],
            i.header_cell,
            a[l].attrs
          );
      t(s);
    }
    return !0;
  };
}
function Ef(n, e, t) {
  const i = e.map.cellsInRect({
    left: 0,
    top: 0,
    right: n == "row" ? e.map.width : 1,
    bottom: n == "column" ? e.map.height : 1
  });
  for (let r = 0; r < i.length; r++) {
    const s = e.table.nodeAt(i[r]);
    if (s && s.type !== t.header_cell)
      return !1;
  }
  return !0;
}
function ys(n, e) {
  return e = e || { useDeprecatedLogic: !1 }, e.useDeprecatedLogic ? qS(n) : function(t, i) {
    if (!xn(t)) return !1;
    if (i) {
      const r = Nt(t.schema), s = cn(t), o = t.tr, a = Ef("row", s, r), l = Ef(
        "column",
        s,
        r
      ), u = (n === "column" ? a : n === "row" ? l : !1) ? 1 : 0, d = n == "column" ? {
        left: 0,
        top: u,
        right: 1,
        bottom: s.map.height
      } : n == "row" ? {
        left: u,
        top: 0,
        right: s.map.width,
        bottom: 1
      } : s, h = n == "column" ? l ? r.cell : r.header_cell : n == "row" ? a ? r.cell : r.header_cell : r.cell;
      s.map.cellsInRect(d).forEach((f) => {
        const p = f + s.tableStart, _ = o.doc.nodeAt(p);
        _ && o.setNodeMarkup(p, h, _.attrs);
      }), i(o);
    }
    return !0;
  };
}
ys("row", {
  useDeprecatedLogic: !0
});
ys("column", {
  useDeprecatedLogic: !0
});
var GS = ys("cell", {
  useDeprecatedLogic: !0
});
function JS(n, e) {
  if (e < 0) {
    const t = n.nodeBefore;
    if (t) return n.pos - t.nodeSize;
    for (let i = n.index(-1) - 1, r = n.before(); i >= 0; i--) {
      const s = n.node(-1).child(i), o = s.lastChild;
      if (o)
        return r - 1 - o.nodeSize;
      r -= s.nodeSize;
    }
  } else {
    if (n.index() < n.parent.childCount - 1)
      return n.pos + n.nodeAfter.nodeSize;
    const t = n.node(-1);
    for (let i = n.indexAfter(-1), r = n.after(); i < t.childCount; i++) {
      const s = t.child(i);
      if (s.childCount) return r + 1;
      r += s.nodeSize;
    }
  }
  return null;
}
function Cf(n) {
  return function(e, t) {
    if (!xn(e)) return !1;
    const i = JS(qa(e), n);
    if (i == null) return !1;
    if (t) {
      const r = e.doc.resolve(i);
      t(
        e.tr.setSelection(ue.between(r, CS(r))).scrollIntoView()
      );
    }
    return !0;
  };
}
function XS(n, e) {
  const t = n.selection.$anchor;
  for (let i = t.depth; i > 0; i--)
    if (t.node(i).type.spec.tableRole == "table")
      return e && e(
        n.tr.delete(t.before(i), t.after(i)).scrollIntoView()
      ), !0;
  return !1;
}
function to(n, e) {
  const t = n.selection;
  if (!(t instanceof He)) return !1;
  if (e) {
    const i = n.tr, r = Nt(n.schema).cell.createAndFill().content;
    t.forEachCell((s, o) => {
      s.content.eq(r) || i.replace(
        i.mapping.map(o + 1),
        i.mapping.map(o + s.nodeSize - 1),
        new J(r, 0, 0)
      );
    }), i.docChanged && e(i);
  }
  return !0;
}
function YS(n) {
  if (!n.size) return null;
  let { content: e, openStart: t, openEnd: i } = n;
  for (; e.childCount == 1 && (t > 0 && i > 0 || e.child(0).type.spec.tableRole == "table"); )
    t--, i--, e = e.child(0).content;
  const r = e.child(0), s = r.type.spec.tableRole, o = r.type.schema, a = [];
  if (s == "row")
    for (let l = 0; l < e.childCount; l++) {
      let c = e.child(l).content;
      const u = l ? 0 : Math.max(0, t - 1), d = l < e.childCount - 1 ? 0 : Math.max(0, i - 1);
      (u || d) && (c = Ic(
        Nt(o).row,
        new J(c, u, d)
      ).content), a.push(c);
    }
  else if (s == "cell" || s == "header_cell")
    a.push(
      t || i ? Ic(
        Nt(o).row,
        new J(e, t, i)
      ).content : e
    );
  else
    return null;
  return ZS(o, a);
}
function ZS(n, e) {
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const s = e[r];
    for (let o = s.childCount - 1; o >= 0; o--) {
      const { rowspan: a, colspan: l } = s.child(o).attrs;
      for (let c = r; c < r + a; c++)
        t[c] = (t[c] || 0) + l;
    }
  }
  let i = 0;
  for (let r = 0; r < t.length; r++) i = Math.max(i, t[r]);
  for (let r = 0; r < t.length; r++)
    if (r >= e.length && e.push($.empty), t[r] < i) {
      const s = Nt(n).cell.createAndFill(), o = [];
      for (let a = t[r]; a < i; a++)
        o.push(s);
      e[r] = e[r].append($.from(o));
    }
  return { height: e.length, width: i, rows: e };
}
function Ic(n, e) {
  const t = n.createAndFill();
  return new au(t).replace(0, t.content.size, e).doc;
}
function QS({ width: n, height: e, rows: t }, i, r) {
  if (n != i) {
    const s = [], o = [];
    for (let a = 0; a < t.length; a++) {
      const l = t[a], c = [];
      for (let u = s[a] || 0, d = 0; u < i; d++) {
        let h = l.child(d % l.childCount);
        u + h.attrs.colspan > i && (h = h.type.createChecked(
          $i(
            h.attrs,
            h.attrs.colspan,
            u + h.attrs.colspan - i
          ),
          h.content
        )), c.push(h), u += h.attrs.colspan;
        for (let f = 1; f < h.attrs.rowspan; f++)
          s[a + f] = (s[a + f] || 0) + h.attrs.colspan;
      }
      o.push($.from(c));
    }
    t = o, n = i;
  }
  if (e != r) {
    const s = [];
    for (let o = 0, a = 0; o < r; o++, a++) {
      const l = [], c = t[a % e];
      for (let u = 0; u < c.childCount; u++) {
        let d = c.child(u);
        o + d.attrs.rowspan > r && (d = d.type.create(
          {
            ...d.attrs,
            rowspan: Math.max(1, r - d.attrs.rowspan)
          },
          d.content
        )), l.push(d);
      }
      s.push($.from(l));
    }
    t = s, e = r;
  }
  return { width: n, height: e, rows: t };
}
function eE(n, e, t, i, r, s, o) {
  const a = n.doc.type.schema, l = Nt(a);
  let c, u;
  if (r > e.width)
    for (let d = 0, h = 0; d < e.height; d++) {
      const f = t.child(d);
      h += f.nodeSize;
      const p = [];
      let _;
      f.lastChild == null || f.lastChild.type == l.cell ? _ = c || (c = l.cell.createAndFill()) : _ = u || (u = l.header_cell.createAndFill());
      for (let m = e.width; m < r; m++) p.push(_);
      n.insert(n.mapping.slice(o).map(h - 1 + i), p);
    }
  if (s > e.height) {
    const d = [];
    for (let p = 0, _ = (e.height - 1) * e.width; p < Math.max(e.width, r); p++) {
      const m = p >= e.width ? !1 : t.nodeAt(e.map[_ + p]).type == l.header_cell;
      d.push(
        m ? u || (u = l.header_cell.createAndFill()) : c || (c = l.cell.createAndFill())
      );
    }
    const h = l.row.create(null, $.from(d)), f = [];
    for (let p = e.height; p < s; p++) f.push(h);
    n.insert(n.mapping.slice(o).map(i + t.nodeSize - 2), f);
  }
  return !!(c || u);
}
function Tf(n, e, t, i, r, s, o, a) {
  if (o == 0 || o == e.height) return !1;
  let l = !1;
  for (let c = r; c < s; c++) {
    const u = o * e.width + c, d = e.map[u];
    if (e.map[u - e.width] == d) {
      l = !0;
      const h = t.nodeAt(d), { top: f, left: p } = e.findCell(d);
      n.setNodeMarkup(n.mapping.slice(a).map(d + i), null, {
        ...h.attrs,
        rowspan: o - f
      }), n.insert(
        n.mapping.slice(a).map(e.positionAt(o, p, t)),
        h.type.createAndFill({
          ...h.attrs,
          rowspan: f + h.attrs.rowspan - o
        })
      ), c += h.attrs.colspan - 1;
    }
  }
  return l;
}
function Af(n, e, t, i, r, s, o, a) {
  if (o == 0 || o == e.width) return !1;
  let l = !1;
  for (let c = r; c < s; c++) {
    const u = c * e.width + o, d = e.map[u];
    if (e.map[u - 1] == d) {
      l = !0;
      const h = t.nodeAt(d), f = e.colCount(d), p = n.mapping.slice(a).map(d + i);
      n.setNodeMarkup(
        p,
        null,
        $i(
          h.attrs,
          o - f,
          h.attrs.colspan - (o - f)
        )
      ), n.insert(
        p + h.nodeSize,
        h.type.createAndFill(
          $i(h.attrs, 0, o - f)
        )
      ), c += h.attrs.rowspan - 1;
    }
  }
  return l;
}
function Mf(n, e, t, i, r) {
  let s = t ? n.doc.nodeAt(t - 1) : n.doc;
  if (!s)
    throw new Error("No table found");
  let o = Ge.get(s);
  const { top: a, left: l } = i, c = l + r.width, u = a + r.height, d = n.tr;
  let h = 0;
  function f() {
    if (s = t ? d.doc.nodeAt(t - 1) : d.doc, !s)
      throw new Error("No table found");
    o = Ge.get(s), h = d.mapping.maps.length;
  }
  eE(d, o, s, t, c, u, h) && f(), Tf(d, o, s, t, l, c, a, h) && f(), Tf(d, o, s, t, l, c, u, h) && f(), Af(d, o, s, t, a, u, l, h) && f(), Af(d, o, s, t, a, u, c, h) && f();
  for (let p = a; p < u; p++) {
    const _ = o.positionAt(p, l, s), m = o.positionAt(p, c, s);
    d.replace(
      d.mapping.slice(h).map(_ + t),
      d.mapping.slice(h).map(m + t),
      new J(r.rows[p - a], 0, 0)
    );
  }
  f(), d.setSelection(
    new He(
      d.doc.resolve(t + o.positionAt(a, l, s)),
      d.doc.resolve(t + o.positionAt(u - 1, c - 1, s))
    )
  ), e(d);
}
var tE = ku({
  ArrowLeft: no("horiz", -1),
  ArrowRight: no("horiz", 1),
  ArrowUp: no("vert", -1),
  ArrowDown: no("vert", 1),
  "Shift-ArrowLeft": io("horiz", -1),
  "Shift-ArrowRight": io("horiz", 1),
  "Shift-ArrowUp": io("vert", -1),
  "Shift-ArrowDown": io("vert", 1),
  Backspace: to,
  "Mod-Backspace": to,
  Delete: to,
  "Mod-Delete": to
});
function bo(n, e, t) {
  return t.eq(n.selection) ? !1 : (e && e(n.tr.setSelection(t).scrollIntoView()), !0);
}
function no(n, e) {
  return (t, i, r) => {
    if (!r) return !1;
    const s = t.selection;
    if (s instanceof He)
      return bo(
        t,
        i,
        fe.near(s.$headCell, e)
      );
    if (n != "horiz" && !s.empty) return !1;
    const o = E_(r, n, e);
    if (o == null) return !1;
    if (n == "horiz")
      return bo(
        t,
        i,
        fe.near(t.doc.resolve(s.head + e), e)
      );
    {
      const a = t.doc.resolve(o), l = b_(a, n, e);
      let c;
      return l ? c = fe.near(l, 1) : e < 0 ? c = fe.near(t.doc.resolve(a.before(-1)), -1) : c = fe.near(t.doc.resolve(a.after(-1)), 1), bo(t, i, c);
    }
  };
}
function io(n, e) {
  return (t, i, r) => {
    if (!r) return !1;
    const s = t.selection;
    let o;
    if (s instanceof He)
      o = s;
    else {
      const l = E_(r, n, e);
      if (l == null) return !1;
      o = new He(t.doc.resolve(l));
    }
    const a = b_(o.$headCell, n, e);
    return a ? bo(
      t,
      i,
      new He(o.$anchorCell, a)
    ) : !1;
  };
}
function nE(n, e) {
  const t = n.state.doc, i = wr(t.resolve(e));
  return i ? (n.dispatch(n.state.tr.setSelection(new He(i))), !0) : !1;
}
function iE(n, e, t) {
  if (!xn(n.state)) return !1;
  let i = YS(t);
  const r = n.state.selection;
  if (r instanceof He) {
    i || (i = {
      width: 1,
      height: 1,
      rows: [
        $.from(
          Ic(Nt(n.state.schema).cell, t)
        )
      ]
    });
    const s = r.$anchorCell.node(-1), o = r.$anchorCell.start(-1), a = Ge.get(s).rectBetween(
      r.$anchorCell.pos - o,
      r.$headCell.pos - o
    );
    return i = QS(i, a.right - a.left, a.bottom - a.top), Mf(n.state, n.dispatch, o, a, i), !0;
  } else if (i) {
    const s = qa(n.state), o = s.start(-1);
    return Mf(
      n.state,
      n.dispatch,
      o,
      Ge.get(s.node(-1)).findCell(s.pos - o),
      i
    ), !0;
  } else
    return !1;
}
function rE(n, e) {
  var t;
  if (e.ctrlKey || e.metaKey) return;
  const i = Of(n, e.target);
  let r;
  if (e.shiftKey && n.state.selection instanceof He)
    s(n.state.selection.$anchorCell, e), e.preventDefault();
  else if (e.shiftKey && i && (r = wr(n.state.selection.$anchor)) != null && ((t = Vl(n, e)) == null ? void 0 : t.pos) != r.pos)
    s(r, e), e.preventDefault();
  else if (!i)
    return;
  function s(l, c) {
    let u = Vl(n, c);
    const d = ai.getState(n.state) == null;
    if (!u || !Xu(l, u))
      if (d) u = l;
      else return;
    const h = new He(l, u);
    if (d || !n.state.selection.eq(h)) {
      const f = n.state.tr.setSelection(h);
      d && f.setMeta(ai, l.pos), n.dispatch(f);
    }
  }
  function o() {
    n.root.removeEventListener("mouseup", o), n.root.removeEventListener("dragstart", o), n.root.removeEventListener("mousemove", a), ai.getState(n.state) != null && n.dispatch(n.state.tr.setMeta(ai, -1));
  }
  function a(l) {
    const c = l, u = ai.getState(n.state);
    let d;
    if (u != null)
      d = n.state.doc.resolve(u);
    else if (Of(n, c.target) != i && (d = Vl(n, e), !d))
      return o();
    d && s(d, c);
  }
  n.root.addEventListener("mouseup", o), n.root.addEventListener("dragstart", o), n.root.addEventListener("mousemove", a);
}
function E_(n, e, t) {
  if (!(n.state.selection instanceof ue)) return null;
  const { $head: i } = n.state.selection;
  for (let r = i.depth - 1; r >= 0; r--) {
    const s = i.node(r);
    if ((t < 0 ? i.index(r) : i.indexAfter(r)) != (t < 0 ? 0 : s.childCount)) return null;
    if (s.type.spec.tableRole == "cell" || s.type.spec.tableRole == "header_cell") {
      const a = i.before(r), l = e == "vert" ? t > 0 ? "down" : "up" : t > 0 ? "right" : "left";
      return n.endOfTextblock(l) ? a : null;
    }
  }
  return null;
}
function Of(n, e) {
  for (; e && e != n.dom; e = e.parentNode)
    if (e.nodeName == "TD" || e.nodeName == "TH")
      return e;
  return null;
}
function Vl(n, e) {
  const t = n.posAtCoords({
    left: e.clientX,
    top: e.clientY
  });
  return t && t ? wr(n.state.doc.resolve(t.pos)) : null;
}
var sE = class {
  constructor(e, t) {
    this.node = e, this.defaultCellMinWidth = t, this.dom = document.createElement("div"), this.dom.className = "tableWrapper", this.table = this.dom.appendChild(document.createElement("table")), this.table.style.setProperty(
      "--default-cell-min-width",
      `${t}px`
    ), this.colgroup = this.table.appendChild(document.createElement("colgroup")), Pc(e, this.colgroup, this.table, t), this.contentDOM = this.table.appendChild(document.createElement("tbody"));
  }
  update(e) {
    return e.type != this.node.type ? !1 : (this.node = e, Pc(
      e,
      this.colgroup,
      this.table,
      this.defaultCellMinWidth
    ), !0);
  }
  ignoreMutation(e) {
    return e.type == "attributes" && (e.target == this.table || this.colgroup.contains(e.target));
  }
};
function Pc(n, e, t, i, r, s) {
  var o;
  let a = 0, l = !0, c = e.firstChild;
  const u = n.firstChild;
  if (u) {
    for (let d = 0, h = 0; d < u.childCount; d++) {
      const { colspan: f, colwidth: p } = u.child(d).attrs;
      for (let _ = 0; _ < f; _++, h++) {
        const m = r == h ? s : p && p[_], g = m ? m + "px" : "";
        if (a += m || i, m || (l = !1), c)
          c.style.width != g && (c.style.width = g), c = c.nextSibling;
        else {
          const y = document.createElement("col");
          y.style.width = g, e.appendChild(y);
        }
      }
    }
    for (; c; ) {
      const d = c.nextSibling;
      (o = c.parentNode) == null || o.removeChild(c), c = d;
    }
    l ? (t.style.width = a + "px", t.style.minWidth = "") : (t.style.width = "", t.style.minWidth = a + "px");
  }
}
var Gt = new Xe(
  "tableColumnResizing"
);
function oE({
  handleWidth: n = 5,
  cellMinWidth: e = 25,
  defaultCellMinWidth: t = 100,
  View: i = sE,
  lastColumnResizable: r = !0
} = {}) {
  const s = new je({
    key: Gt,
    state: {
      init(o, a) {
        var l, c;
        const u = (c = (l = s.spec) == null ? void 0 : l.props) == null ? void 0 : c.nodeViews, d = Nt(a.schema).table.name;
        return i && u && (u[d] = (h, f) => new i(h, t, f)), new aE(-1, !1);
      },
      apply(o, a) {
        return a.apply(o);
      }
    },
    props: {
      attributes: (o) => {
        const a = Gt.getState(o);
        return a && a.activeHandle > -1 ? { class: "resize-cursor" } : {};
      },
      handleDOMEvents: {
        mousemove: (o, a) => {
          lE(o, a, n, r);
        },
        mouseleave: (o) => {
          cE(o);
        },
        mousedown: (o, a) => {
          uE(o, a, e, t);
        }
      },
      decorations: (o) => {
        const a = Gt.getState(o);
        if (a && a.activeHandle > -1)
          return mE(o, a.activeHandle);
      },
      nodeViews: {}
    }
  });
  return s;
}
var aE = class vo {
  constructor(e, t) {
    this.activeHandle = e, this.dragging = t;
  }
  apply(e) {
    const t = this, i = e.getMeta(Gt);
    if (i && i.setHandle != null)
      return new vo(i.setHandle, !1);
    if (i && i.setDragging !== void 0)
      return new vo(t.activeHandle, i.setDragging);
    if (t.activeHandle > -1 && e.docChanged) {
      let r = e.mapping.map(t.activeHandle, -1);
      return Rc(e.doc.resolve(r)) || (r = -1), new vo(r, t.dragging);
    }
    return t;
  }
};
function lE(n, e, t, i) {
  if (!n.editable) return;
  const r = Gt.getState(n.state);
  if (r && !r.dragging) {
    const s = hE(e.target);
    let o = -1;
    if (s) {
      const { left: a, right: l } = s.getBoundingClientRect();
      e.clientX - a <= t ? o = Nf(n, e, "left", t) : l - e.clientX <= t && (o = Nf(n, e, "right", t));
    }
    if (o != r.activeHandle) {
      if (!i && o !== -1) {
        const a = n.state.doc.resolve(o), l = a.node(-1), c = Ge.get(l), u = a.start(-1);
        if (c.colCount(a.pos - u) + a.nodeAfter.attrs.colspan - 1 == c.width - 1)
          return;
      }
      C_(n, o);
    }
  }
}
function cE(n) {
  if (!n.editable) return;
  const e = Gt.getState(n.state);
  e && e.activeHandle > -1 && !e.dragging && C_(n, -1);
}
function uE(n, e, t, i) {
  var r;
  if (!n.editable) return !1;
  const s = (r = n.dom.ownerDocument.defaultView) != null ? r : window, o = Gt.getState(n.state);
  if (!o || o.activeHandle == -1 || o.dragging)
    return !1;
  const a = n.state.doc.nodeAt(o.activeHandle), l = dE(n, o.activeHandle, a.attrs);
  n.dispatch(
    n.state.tr.setMeta(Gt, {
      setDragging: { startX: e.clientX, startWidth: l }
    })
  );
  function c(d) {
    s.removeEventListener("mouseup", c), s.removeEventListener("mousemove", u);
    const h = Gt.getState(n.state);
    h?.dragging && (fE(
      n,
      h.activeHandle,
      Lf(h.dragging, d, t)
    ), n.dispatch(
      n.state.tr.setMeta(Gt, { setDragging: null })
    ));
  }
  function u(d) {
    if (!d.which) return c(d);
    const h = Gt.getState(n.state);
    if (h && h.dragging) {
      const f = Lf(h.dragging, d, t);
      Rf(
        n,
        h.activeHandle,
        f,
        i
      );
    }
  }
  return Rf(
    n,
    o.activeHandle,
    l,
    i
  ), s.addEventListener("mouseup", c), s.addEventListener("mousemove", u), e.preventDefault(), !0;
}
function dE(n, e, { colspan: t, colwidth: i }) {
  const r = i && i[i.length - 1];
  if (r) return r;
  const s = n.domAtPos(e);
  let a = s.node.childNodes[s.offset].offsetWidth, l = t;
  if (i)
    for (let c = 0; c < t; c++)
      i[c] && (a -= i[c], l--);
  return a / l;
}
function hE(n) {
  for (; n && n.nodeName != "TD" && n.nodeName != "TH"; )
    n = n.classList && n.classList.contains("ProseMirror") ? null : n.parentNode;
  return n;
}
function Nf(n, e, t, i) {
  const r = t == "right" ? -i : i, s = n.posAtCoords({
    left: e.clientX + r,
    top: e.clientY
  });
  if (!s) return -1;
  const { pos: o } = s, a = wr(n.state.doc.resolve(o));
  if (!a) return -1;
  if (t == "right") return a.pos;
  const l = Ge.get(a.node(-1)), c = a.start(-1), u = l.map.indexOf(a.pos - c);
  return u % l.width == 0 ? -1 : c + l.map[u - 1];
}
function Lf(n, e, t) {
  const i = e.clientX - n.startX;
  return Math.max(t, n.startWidth + i);
}
function C_(n, e) {
  n.dispatch(
    n.state.tr.setMeta(Gt, { setHandle: e })
  );
}
function fE(n, e, t) {
  const i = n.state.doc.resolve(e), r = i.node(-1), s = Ge.get(r), o = i.start(-1), a = s.colCount(i.pos - o) + i.nodeAfter.attrs.colspan - 1, l = n.state.tr;
  for (let c = 0; c < s.height; c++) {
    const u = c * s.width + a;
    if (c && s.map[u] == s.map[u - s.width]) continue;
    const d = s.map[u], h = r.nodeAt(d).attrs, f = h.colspan == 1 ? 0 : a - s.colCount(d);
    if (h.colwidth && h.colwidth[f] == t) continue;
    const p = h.colwidth ? h.colwidth.slice() : pE(h.colspan);
    p[f] = t, l.setNodeMarkup(o + d, null, { ...h, colwidth: p });
  }
  l.docChanged && n.dispatch(l);
}
function Rf(n, e, t, i) {
  const r = n.state.doc.resolve(e), s = r.node(-1), o = r.start(-1), a = Ge.get(s).colCount(r.pos - o) + r.nodeAfter.attrs.colspan - 1;
  let l = n.domAtPos(r.start(-1)).node;
  for (; l && l.nodeName != "TABLE"; )
    l = l.parentNode;
  l && Pc(
    s,
    l.firstChild,
    l,
    i,
    a,
    t
  );
}
function pE(n) {
  return Array(n).fill(0);
}
function mE(n, e) {
  var t;
  const i = [], r = n.doc.resolve(e), s = r.node(-1);
  if (!s)
    return ze.empty;
  const o = Ge.get(s), a = r.start(-1), l = o.colCount(r.pos - a) + r.nodeAfter.attrs.colspan - 1;
  for (let c = 0; c < o.height; c++) {
    const u = l + c * o.width;
    if ((l == o.width - 1 || o.map[u] != o.map[u + 1]) && (c == 0 || o.map[u] != o.map[u - o.width])) {
      const d = o.map[u], h = a + d + s.nodeAt(d).nodeSize - 1, f = document.createElement("div");
      f.className = "column-resize-handle", (t = Gt.getState(n)) != null && t.dragging && i.push(
        gt.node(
          a + d,
          a + d + s.nodeAt(d).nodeSize,
          {
            class: "column-resize-dragging"
          }
        )
      ), i.push(gt.widget(h, f));
    }
  }
  return ze.create(n.doc, i);
}
function gE({
  allowTableNodeSelection: n = !1
} = {}) {
  return new je({
    key: ai,
    // This piece of state is used to remember when a mouse-drag
    // cell-selection is happening, so that it can continue even as
    // transactions (which might move its anchor cell) come in.
    state: {
      init() {
        return null;
      },
      apply(e, t) {
        const i = e.getMeta(ai);
        if (i != null) return i == -1 ? null : i;
        if (t == null || !e.docChanged) return t;
        const { deleted: r, pos: s } = e.mapping.mapResult(t);
        return r ? null : s;
      }
    },
    props: {
      decorations: MS,
      handleDOMEvents: {
        mousedown: rE
      },
      createSelectionBetween(e) {
        return ai.getState(e.state) != null ? e.state.selection : null;
      },
      handleTripleClick: nE,
      handleKeyDown: tE,
      handlePaste: iE
    },
    appendTransaction(e, t, i) {
      return LS(
        i,
        w_(i, t),
        n
      );
    }
  });
}
var T_ = Ne.create({
  name: "tableCell",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  addAttributes() {
    return {
      colspan: {
        default: 1
      },
      rowspan: {
        default: 1
      },
      colwidth: {
        default: null,
        parseHTML: (n) => {
          var e, t;
          const i = n.getAttribute("colwidth"), r = i ? i.split(",").map((s) => parseInt(s, 10)) : null;
          if (!r) {
            const s = (e = n.closest("table")) == null ? void 0 : e.querySelectorAll("colgroup > col"), o = Array.from(((t = n.parentElement) == null ? void 0 : t.children) || []).indexOf(n);
            if (o && o > -1 && s && s[o]) {
              const a = s[o].getAttribute("width");
              return a ? [parseInt(a, 10)] : null;
            }
          }
          return r;
        }
      }
    };
  },
  tableRole: "cell",
  isolating: !0,
  parseHTML() {
    return [{ tag: "td" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["td", Ee(this.options.HTMLAttributes, n), 0];
  }
}), A_ = Ne.create({
  name: "tableHeader",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  addAttributes() {
    return {
      colspan: {
        default: 1
      },
      rowspan: {
        default: 1
      },
      colwidth: {
        default: null,
        parseHTML: (n) => {
          const e = n.getAttribute("colwidth");
          return e ? e.split(",").map((i) => parseInt(i, 10)) : null;
        }
      }
    };
  },
  tableRole: "header_cell",
  isolating: !0,
  parseHTML() {
    return [{ tag: "th" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["th", Ee(this.options.HTMLAttributes, n), 0];
  }
}), M_ = Ne.create({
  name: "tableRow",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "(tableCell | tableHeader)*",
  tableRole: "row",
  parseHTML() {
    return [{ tag: "tr" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["tr", Ee(this.options.HTMLAttributes, n), 0];
  }
});
function Dc(n, e) {
  return e ? ["width", `${Math.max(e, n)}px`] : ["min-width", `${n}px`];
}
function If(n, e, t, i, r, s) {
  var o;
  let a = 0, l = !0, c = e.firstChild;
  const u = n.firstChild;
  if (u !== null)
    for (let h = 0, f = 0; h < u.childCount; h += 1) {
      const { colspan: p, colwidth: _ } = u.child(h).attrs;
      for (let m = 0; m < p; m += 1, f += 1) {
        const g = r === f ? s : _ && _[m], y = g ? `${g}px` : "";
        if (a += g || i, g || (l = !1), c) {
          if (c.style.width !== y) {
            const [x, k] = Dc(i, g);
            c.style.setProperty(x, k);
          }
          c = c.nextSibling;
        } else {
          const x = document.createElement("col"), [k, E] = Dc(i, g);
          x.style.setProperty(k, E), e.appendChild(x);
        }
      }
    }
  for (; c; ) {
    const h = c.nextSibling;
    (o = c.parentNode) == null || o.removeChild(c), c = h;
  }
  const d = n.attrs.style && typeof n.attrs.style == "string" && /\bwidth\s*:/i.test(n.attrs.style);
  l && !d ? (t.style.width = `${a}px`, t.style.minWidth = "") : (t.style.width = "", t.style.minWidth = `${a}px`);
}
var _E = class {
  constructor(n, e) {
    this.node = n, this.cellMinWidth = e, this.dom = document.createElement("div"), this.dom.className = "tableWrapper", this.table = this.dom.appendChild(document.createElement("table")), n.attrs.style && (this.table.style.cssText = n.attrs.style), this.colgroup = this.table.appendChild(document.createElement("colgroup")), If(n, this.colgroup, this.table, e), this.contentDOM = this.table.appendChild(document.createElement("tbody"));
  }
  update(n) {
    return n.type !== this.node.type ? !1 : (this.node = n, If(n, this.colgroup, this.table, this.cellMinWidth), !0);
  }
  ignoreMutation(n) {
    const e = n.target, t = this.dom.contains(e), i = this.contentDOM.contains(e);
    return !!(t && !i && (n.type === "attributes" || n.type === "childList" || n.type === "characterData"));
  }
};
function bE(n, e, t, i) {
  let r = 0, s = !0;
  const o = [], a = n.firstChild;
  if (!a)
    return {};
  for (let d = 0, h = 0; d < a.childCount; d += 1) {
    const { colspan: f, colwidth: p } = a.child(d).attrs;
    for (let _ = 0; _ < f; _ += 1, h += 1) {
      const m = t === h ? i : p && p[_];
      r += m || e, m || (s = !1);
      const [g, y] = Dc(e, m);
      o.push(["col", { style: `${g}: ${y}` }]);
    }
  }
  const l = s ? `${r}px` : "", c = s ? "" : `${r}px`;
  return { colgroup: ["colgroup", {}, ...o], tableWidth: l, tableMinWidth: c };
}
function Pf(n, e) {
  return e ? n.createChecked(null, e) : n.createAndFill();
}
function vE(n) {
  if (n.cached.tableNodeTypes)
    return n.cached.tableNodeTypes;
  const e = {};
  return Object.keys(n.nodes).forEach((t) => {
    const i = n.nodes[t];
    i.spec.tableRole && (e[i.spec.tableRole] = i);
  }), n.cached.tableNodeTypes = e, e;
}
function O_(n, e, t, i, r) {
  const s = vE(n), o = [], a = [];
  for (let c = 0; c < t; c += 1) {
    const u = Pf(s.cell, r);
    if (u && a.push(u), i) {
      const d = Pf(s.header_cell, r);
      d && o.push(d);
    }
  }
  const l = [];
  for (let c = 0; c < e; c += 1)
    l.push(s.row.createChecked(null, i && c === 0 ? o : a));
  return s.table.createChecked(null, l);
}
function yE(n) {
  return n instanceof He;
}
var ro = ({ editor: n }) => {
  const { selection: e } = n.state;
  if (!yE(e))
    return !1;
  let t = 0;
  const i = Nu(e.ranges[0].$from, (s) => s.type.name === "table");
  return i?.node.descendants((s) => {
    if (s.type.name === "table")
      return !1;
    ["tableCell", "tableHeader"].includes(s.type.name) && (t += 1);
  }), t === e.ranges.length ? (n.commands.deleteTable(), !0) : !1;
}, xE = "";
function wE(n) {
  return (n || "").replace(/\s+/g, " ").trim();
}
function kE(n, e, t = {}) {
  var i;
  const r = (i = t.cellLineSeparator) != null ? i : xE;
  if (!n || !n.content || n.content.length === 0)
    return "";
  const s = [];
  n.content.forEach((p) => {
    const _ = [];
    p.content && p.content.forEach((m) => {
      let g = "";
      m.content && Array.isArray(m.content) && m.content.length > 1 ? g = m.content.map((E) => e.renderChildren(E)).join(r) : g = m.content ? e.renderChildren(m.content) : "";
      const y = wE(g), x = m.type === "tableHeader";
      _.push({ text: y, isHeader: x });
    }), s.push(_);
  });
  const o = s.reduce((p, _) => Math.max(p, _.length), 0);
  if (o === 0)
    return "";
  const a = new Array(o).fill(0);
  s.forEach((p) => {
    var _;
    for (let m = 0; m < o; m += 1) {
      const y = (((_ = p[m]) == null ? void 0 : _.text) || "").length;
      y > a[m] && (a[m] = y), a[m] < 3 && (a[m] = 3);
    }
  });
  const l = (p, _) => p + " ".repeat(Math.max(0, _ - p.length)), c = s[0], u = c.some((p) => p.isHeader);
  let d = `
`;
  const h = new Array(o).fill(0).map((p, _) => u && c[_] && c[_].text || "");
  return d += `| ${h.map((p, _) => l(p, a[_])).join(" | ")} |
`, d += `| ${a.map((p) => "-".repeat(Math.max(3, p))).join(" | ")} |
`, (u ? s.slice(1) : s).forEach((p) => {
    d += `| ${new Array(o).fill(0).map((_, m) => l(p[m] && p[m].text || "", a[m])).join(" | ")} |
`;
  }), d;
}
var SE = kE, N_ = Ne.create({
  name: "table",
  // @ts-ignore
  addOptions() {
    return {
      HTMLAttributes: {},
      resizable: !1,
      renderWrapper: !1,
      handleWidth: 5,
      cellMinWidth: 25,
      // TODO: fix
      View: _E,
      lastColumnResizable: !0,
      allowTableNodeSelection: !1
    };
  },
  content: "tableRow+",
  tableRole: "table",
  isolating: !0,
  group: "block",
  parseHTML() {
    return [{ tag: "table" }];
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    const { colgroup: t, tableWidth: i, tableMinWidth: r } = bE(n, this.options.cellMinWidth), s = e.style;
    function o() {
      return s || (i ? `width: ${i}` : `min-width: ${r}`);
    }
    const a = [
      "table",
      Ee(this.options.HTMLAttributes, e, {
        style: o()
      }),
      t,
      ["tbody", 0]
    ];
    return this.options.renderWrapper ? ["div", { class: "tableWrapper" }, a] : a;
  },
  parseMarkdown: (n, e) => {
    const t = [];
    if (n.header) {
      const i = [];
      n.header.forEach((r) => {
        i.push(e.createNode("tableHeader", {}, [{ type: "paragraph", content: e.parseInline(r.tokens) }]));
      }), t.push(e.createNode("tableRow", {}, i));
    }
    return n.rows && n.rows.forEach((i) => {
      const r = [];
      i.forEach((s) => {
        r.push(e.createNode("tableCell", {}, [{ type: "paragraph", content: e.parseInline(s.tokens) }]));
      }), t.push(e.createNode("tableRow", {}, r));
    }), e.createNode("table", void 0, t);
  },
  renderMarkdown: (n, e) => SE(n, e),
  addCommands() {
    return {
      insertTable: ({ rows: n = 3, cols: e = 3, withHeaderRow: t = !0 } = {}) => ({ tr: i, dispatch: r, editor: s }) => {
        const o = O_(s.schema, n, e, t);
        if (r) {
          const a = i.selection.from + 1;
          i.replaceSelectionWith(o).scrollIntoView().setSelection(ue.near(i.doc.resolve(a)));
        }
        return !0;
      },
      addColumnBefore: () => ({ state: n, dispatch: e }) => PS(n, e),
      addColumnAfter: () => ({ state: n, dispatch: e }) => DS(n, e),
      deleteColumn: () => ({ state: n, dispatch: e }) => zS(n, e),
      addRowBefore: () => ({ state: n, dispatch: e }) => BS(n, e),
      addRowAfter: () => ({ state: n, dispatch: e }) => FS(n, e),
      deleteRow: () => ({ state: n, dispatch: e }) => jS(n, e),
      deleteTable: () => ({ state: n, dispatch: e }) => XS(n, e),
      mergeCells: () => ({ state: n, dispatch: e }) => kf(n, e),
      splitCell: () => ({ state: n, dispatch: e }) => Sf(n, e),
      toggleHeaderColumn: () => ({ state: n, dispatch: e }) => ys("column")(n, e),
      toggleHeaderRow: () => ({ state: n, dispatch: e }) => ys("row")(n, e),
      toggleHeaderCell: () => ({ state: n, dispatch: e }) => GS(n, e),
      mergeOrSplit: () => ({ state: n, dispatch: e }) => kf(n, e) ? !0 : Sf(n, e),
      setCellAttribute: (n, e) => ({ state: t, dispatch: i }) => KS(n, e)(t, i),
      goToNextCell: () => ({ state: n, dispatch: e }) => Cf(1)(n, e),
      goToPreviousCell: () => ({ state: n, dispatch: e }) => Cf(-1)(n, e),
      fixTables: () => ({ state: n, dispatch: e }) => (e && w_(n), !0),
      setCellSelection: (n) => ({ tr: e, dispatch: t }) => {
        if (t) {
          const i = He.create(e.doc, n.anchorCell, n.headCell);
          e.setSelection(i);
        }
        return !0;
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      Tab: () => this.editor.commands.goToNextCell() ? !0 : this.editor.can().addRowAfter() ? this.editor.chain().addRowAfter().goToNextCell().run() : !1,
      "Shift-Tab": () => this.editor.commands.goToPreviousCell(),
      Backspace: ro,
      "Mod-Backspace": ro,
      Delete: ro,
      "Mod-Delete": ro
    };
  },
  addProseMirrorPlugins() {
    return [
      ...this.options.resizable && this.editor.isEditable ? [
        oE({
          handleWidth: this.options.handleWidth,
          cellMinWidth: this.options.cellMinWidth,
          defaultCellMinWidth: this.options.cellMinWidth,
          View: this.options.View,
          lastColumnResizable: this.options.lastColumnResizable
        })
      ] : [],
      gE({
        allowTableNodeSelection: this.options.allowTableNodeSelection
      })
    ];
  },
  extendNodeSchema(n) {
    const e = {
      name: n.name,
      options: n.options,
      storage: n.storage
    };
    return {
      tableRole: Te(se(n, "tableRole", e))
    };
  }
});
Oe.create({
  name: "tableKit",
  addExtensions() {
    const n = [];
    return this.options.table !== !1 && n.push(N_.configure(this.options.table)), this.options.tableCell !== !1 && n.push(T_.configure(this.options.tableCell)), this.options.tableHeader !== !1 && n.push(A_.configure(this.options.tableHeader)), this.options.tableRow !== !1 && n.push(M_.configure(this.options.tableRow)), n;
  }
});
const EE = N_.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      style: {}
    };
  },
  addOptions() {
    const n = this.parent?.();
    return n && (n.View = class extends n.View {
      update(e) {
        return super.update(e), this.table.style.cssText = e.attrs.style, !0;
      }
    }), n;
  },
  // FIXME: renderHTML with customized attributes
  renderHTML({ HTMLAttributes: n }) {
    return ["table", n, 0];
  }
}), CE = T_.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      style: {
        default: ""
      }
    };
  },
  renderHTML({ HTMLAttributes: n }) {
    const { colspan: e, rowspan: t, style: i, ...r } = n;
    return [
      "td",
      Ee(r, {
        colspan: e === 1 ? void 0 : e,
        rowspan: t === 1 ? void 0 : t,
        style: i === "" ? void 0 : i
      }),
      0
    ];
  }
}), TE = A_.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      scope: {
        default: ""
      },
      style: {
        default: ""
      }
    };
  },
  renderHTML({ HTMLAttributes: n }) {
    const { colspan: e, rowspan: t, scope: i, style: r, ...s } = n;
    return [
      "th",
      Ee(s, {
        colspan: e === 1 ? void 0 : e,
        rowspan: t === 1 ? void 0 : t,
        scope: i === "" ? void 0 : i,
        style: r === "" ? void 0 : r
      }),
      0
    ];
  }
}), AE = Oe.create({
  name: "indent",
  addOptions() {
    return {
      types: ["paragraph"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          "data-mt-indent": {
            default: null,
            renderHTML: ({ "data-mt-indent": n }) => n && n !== "0" ? {
              style: `padding-left: ${n * 80}px`
            } : {},
            parseHTML: (n) => Number(n.getAttribute("data-mt-indent") || null)
          }
        }
      }
    ];
  },
  addCommands() {
    const n = (i, r, s) => {
      const o = i?.doc?.nodeAt(r);
      if (o) {
        let { "data-mt-indent": a, ...l } = o.attrs;
        return a = (a || 0) + s, a > 0 && (l = { ...l, "data-mt-indent": a }), i.setNodeMarkup(r, o.type, l, o.marks);
      }
      return i;
    }, e = (i, r) => {
      const { doc: s, selection: o } = i;
      if (s && o && (o instanceof ue || o instanceof Wt)) {
        const { from: a, to: l } = o;
        s.nodesBetween(a, l, (c, u) => this.options.types.includes(c.type.name) ? (i = n(i, u, r), !1) : c.type.name === "listItem" ? (r > 0 ? this.editor.commands.sinkListItem("listItem") : r < 0 && (this.editor.commands.liftListItem("listItem"), !this.editor.isActive("listItem") && this.editor.isActive("textBlock") && this.editor.commands.setParagraph()), !1) : !0);
      }
      return i;
    }, t = (i) => () => ({ tr: r, state: s, dispatch: o }) => {
      const { selection: a } = s;
      return r = r.setSelection(a), r = e(r, i), r.docChanged ? (o?.(r), !0) : !1;
    };
    return {
      indent: t(1),
      outdent: t(-1)
    };
  }
}), ME = Ne.create({
  name: "div",
  priority: 1e3,
  group: "block",
  content: "block+",
  defining: !0,
  addOptions() {
    return {
      elements: []
    };
  },
  parseHTML() {
    return [
      { tag: "div:not([data-mt-rich-text-editor-embed-object])" },
      ...this.options.elements.map((n) => ({ tag: n }))
    ];
  },
  renderHTML({ HTMLAttributes: n, node: e }) {
    return [
      e.attrs["data-tag"] || "div",
      Ee(n, {
        "data-tag": void 0
      }),
      0
    ];
  },
  addAttributes() {
    return {
      "data-tag": {
        default: "div",
        parseHTML: (n) => n.tagName.toLowerCase()
      }
    };
  }
}), OE = Oe.create({
  name: "span-like-element",
  addOptions() {
    return {
      elements: []
    };
  },
  addExtensions() {
    return this.options.elements.map(
      (n) => Jt.create({
        name: n,
        priority: 1e3,
        content: "inline*",
        parseHTML() {
          return [
            {
              tag: n
            }
          ];
        },
        renderHTML({ HTMLAttributes: e }) {
          return [n, e, 0];
        }
      })
    );
  }
});
var NE = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, LE = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, RE = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, IE = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, PE = Jt.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (n) => n.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (n) => n.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (n) => /^(bold(er)?|[5-9]\d{2,})$/.test(n) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return /* @__PURE__ */ Wo("strong", { ...Ee(this.options.HTMLAttributes, n), children: /* @__PURE__ */ Wo("slot", {}) });
  },
  markdownTokenName: "strong",
  parseMarkdown: (n, e) => e.applyMark("bold", e.parseInline(n.tokens || [])),
  renderMarkdown: (n, e) => `**${e.renderChildren(n)}**`,
  addCommands() {
    return {
      setBold: () => ({ commands: n }) => n.setMark(this.name),
      toggleBold: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetBold: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      _r({
        find: NE,
        type: this.type
      }),
      _r({
        find: RE,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Di({
        find: LE,
        type: this.type
      }),
      Di({
        find: IE,
        type: this.type
      })
    ];
  }
});
const DE = PE.extend({
  priority: 1e3,
  content: "inline*"
}), $E = Ne.create({
  name: "blockLink",
  priority: 1e3,
  group: "block",
  content: "block+",
  defining: !0,
  addAttributes() {
    return {
      HTMLAttributes: {
        default: {},
        parseHTML: (n) => {
          const e = {};
          return Array.from(n.attributes).forEach((t) => {
            e[t.name] = t.value;
          }), e;
        },
        renderHTML: (n) => n.HTMLAttributes
      },
      "data-mt-rich-text-editor-block": {
        default: null,
        renderHTML: () => null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a[data-mt-rich-text-editor-block]",
        getAttrs: (n) => n instanceof HTMLElement ? {
          href: n.getAttribute("href"),
          "data-mt-rich-text-editor-block": n.getAttribute(
            "data-mt-rich-text-editor-block"
          )
        } : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    const { href: e } = n;
    return ["a", Ee(this.options.HTMLAttributes, { href: e }), 0];
  },
  addCommands() {
    return {
      setBlockLink: (n = {}) => ({ commands: e }) => e.wrapIn(this.name, n),
      unsetBlockLink: () => ({ commands: n }) => n.lift(this.name)
    };
  }
}), zE = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3nd0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0axi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", HE = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", $c = "numeric", zc = "ascii", Hc = "alpha", ts = "asciinumeric", Kr = "alphanumeric", Bc = "domain", L_ = "emoji", BE = "scheme", FE = "slashscheme", jl = "whitespace";
function VE(n, e) {
  return n in e || (e[n] = []), e[n];
}
function Ei(n, e, t) {
  e[$c] && (e[ts] = !0, e[Kr] = !0), e[zc] && (e[ts] = !0, e[Hc] = !0), e[ts] && (e[Kr] = !0), e[Hc] && (e[Kr] = !0), e[Kr] && (e[Bc] = !0), e[L_] && (e[Bc] = !0);
  for (const i in e) {
    const r = VE(i, t);
    r.indexOf(n) < 0 && r.push(n);
  }
}
function jE(n, e) {
  const t = {};
  for (const i in e)
    e[i].indexOf(n) >= 0 && (t[i] = !0);
  return t;
}
function jt(n = null) {
  this.j = {}, this.jr = [], this.jd = null, this.t = n;
}
jt.groups = {};
jt.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(n) {
    const e = this, t = e.j[n];
    if (t)
      return t;
    for (let i = 0; i < e.jr.length; i++) {
      const r = e.jr[i][0], s = e.jr[i][1];
      if (s && r.test(n))
        return s;
    }
    return e.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(n, e = !1) {
    return e ? n in this.j : !!this.go(n);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(n, e, t, i) {
    for (let r = 0; r < n.length; r++)
      this.tt(n[r], e, t, i);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(n, e, t, i) {
    i = i || jt.groups;
    let r;
    return e && e.j ? r = e : (r = new jt(e), t && i && Ei(e, t, i)), this.jr.push([n, r]), r;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(n, e, t, i) {
    let r = this;
    const s = n.length;
    if (!s)
      return r;
    for (let o = 0; o < s - 1; o++)
      r = r.tt(n[o]);
    return r.tt(n[s - 1], e, t, i);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(n, e, t, i) {
    i = i || jt.groups;
    const r = this;
    if (e && e.j)
      return r.j[n] = e, e;
    const s = e;
    let o, a = r.go(n);
    if (a ? (o = new jt(), Object.assign(o.j, a.j), o.jr.push.apply(o.jr, a.jr), o.jd = a.jd, o.t = a.t) : o = new jt(), s) {
      if (i)
        if (o.t && typeof o.t == "string") {
          const l = Object.assign(jE(o.t, i), t);
          Ei(s, l, i);
        } else t && Ei(s, t, i);
      o.t = s;
    }
    return r.j[n] = o, o;
  }
};
const xe = (n, e, t, i, r) => n.ta(e, t, i, r), Ke = (n, e, t, i, r) => n.tr(e, t, i, r), Df = (n, e, t, i, r) => n.ts(e, t, i, r), W = (n, e, t, i, r) => n.tt(e, t, i, r), Hn = "WORD", Fc = "UWORD", R_ = "ASCIINUMERICAL", I_ = "ALPHANUMERICAL", xs = "LOCALHOST", Vc = "TLD", jc = "UTLD", yo = "SCHEME", Yi = "SLASH_SCHEME", Yu = "NUM", Wc = "WS", Zu = "NL", ns = "OPENBRACE", is = "CLOSEBRACE", Ko = "OPENBRACKET", qo = "CLOSEBRACKET", Go = "OPENPAREN", Jo = "CLOSEPAREN", Xo = "OPENANGLEBRACKET", Yo = "CLOSEANGLEBRACKET", Zo = "FULLWIDTHLEFTPAREN", Qo = "FULLWIDTHRIGHTPAREN", ea = "LEFTCORNERBRACKET", ta = "RIGHTCORNERBRACKET", na = "LEFTWHITECORNERBRACKET", ia = "RIGHTWHITECORNERBRACKET", ra = "FULLWIDTHLESSTHAN", sa = "FULLWIDTHGREATERTHAN", oa = "AMPERSAND", aa = "APOSTROPHE", la = "ASTERISK", ri = "AT", ca = "BACKSLASH", ua = "BACKTICK", da = "CARET", li = "COLON", Qu = "COMMA", ha = "DOLLAR", Cn = "DOT", fa = "EQUALS", ed = "EXCLAMATION", nn = "HYPHEN", rs = "PERCENT", pa = "PIPE", ma = "PLUS", ga = "POUND", ss = "QUERY", td = "QUOTE", P_ = "FULLWIDTHMIDDLEDOT", nd = "SEMI", Tn = "SLASH", as = "TILDE", _a = "UNDERSCORE", D_ = "EMOJI", ba = "SYM";
var $_ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ALPHANUMERICAL: I_,
  AMPERSAND: oa,
  APOSTROPHE: aa,
  ASCIINUMERICAL: R_,
  ASTERISK: la,
  AT: ri,
  BACKSLASH: ca,
  BACKTICK: ua,
  CARET: da,
  CLOSEANGLEBRACKET: Yo,
  CLOSEBRACE: is,
  CLOSEBRACKET: qo,
  CLOSEPAREN: Jo,
  COLON: li,
  COMMA: Qu,
  DOLLAR: ha,
  DOT: Cn,
  EMOJI: D_,
  EQUALS: fa,
  EXCLAMATION: ed,
  FULLWIDTHGREATERTHAN: sa,
  FULLWIDTHLEFTPAREN: Zo,
  FULLWIDTHLESSTHAN: ra,
  FULLWIDTHMIDDLEDOT: P_,
  FULLWIDTHRIGHTPAREN: Qo,
  HYPHEN: nn,
  LEFTCORNERBRACKET: ea,
  LEFTWHITECORNERBRACKET: na,
  LOCALHOST: xs,
  NL: Zu,
  NUM: Yu,
  OPENANGLEBRACKET: Xo,
  OPENBRACE: ns,
  OPENBRACKET: Ko,
  OPENPAREN: Go,
  PERCENT: rs,
  PIPE: pa,
  PLUS: ma,
  POUND: ga,
  QUERY: ss,
  QUOTE: td,
  RIGHTCORNERBRACKET: ta,
  RIGHTWHITECORNERBRACKET: ia,
  SCHEME: yo,
  SEMI: nd,
  SLASH: Tn,
  SLASH_SCHEME: Yi,
  SYM: ba,
  TILDE: as,
  TLD: Vc,
  UNDERSCORE: _a,
  UTLD: jc,
  UWORD: Fc,
  WORD: Hn,
  WS: Wc
});
const Dn = /[a-z]/, Ir = new RegExp("\\p{L}", "u"), Wl = new RegExp("\\p{Emoji}", "u"), $n = /\d/, Ul = /\s/, $f = "\r", Kl = `
`, WE = "️", UE = "‍", ql = "￼";
let so = null, oo = null;
function KE(n = []) {
  const e = {};
  jt.groups = e;
  const t = new jt();
  so == null && (so = zf(zE)), oo == null && (oo = zf(HE)), W(t, "'", aa), W(t, "{", ns), W(t, "}", is), W(t, "[", Ko), W(t, "]", qo), W(t, "(", Go), W(t, ")", Jo), W(t, "<", Xo), W(t, ">", Yo), W(t, "（", Zo), W(t, "）", Qo), W(t, "「", ea), W(t, "」", ta), W(t, "『", na), W(t, "』", ia), W(t, "＜", ra), W(t, "＞", sa), W(t, "&", oa), W(t, "*", la), W(t, "@", ri), W(t, "`", ua), W(t, "^", da), W(t, ":", li), W(t, ",", Qu), W(t, "$", ha), W(t, ".", Cn), W(t, "=", fa), W(t, "!", ed), W(t, "-", nn), W(t, "%", rs), W(t, "|", pa), W(t, "+", ma), W(t, "#", ga), W(t, "?", ss), W(t, '"', td), W(t, "/", Tn), W(t, ";", nd), W(t, "~", as), W(t, "_", _a), W(t, "\\", ca), W(t, "・", P_);
  const i = Ke(t, $n, Yu, {
    [$c]: !0
  });
  Ke(i, $n, i);
  const r = Ke(i, Dn, R_, {
    [ts]: !0
  }), s = Ke(i, Ir, I_, {
    [Kr]: !0
  }), o = Ke(t, Dn, Hn, {
    [zc]: !0
  });
  Ke(o, $n, r), Ke(o, Dn, o), Ke(r, $n, r), Ke(r, Dn, r);
  const a = Ke(t, Ir, Fc, {
    [Hc]: !0
  });
  Ke(a, Dn), Ke(a, $n, s), Ke(a, Ir, a), Ke(s, $n, s), Ke(s, Dn), Ke(s, Ir, s);
  const l = W(t, Kl, Zu, {
    [jl]: !0
  }), c = W(t, $f, Wc, {
    [jl]: !0
  }), u = Ke(t, Ul, Wc, {
    [jl]: !0
  });
  W(t, ql, u), W(c, Kl, l), W(c, ql, u), Ke(c, Ul, u), W(u, $f), W(u, Kl), Ke(u, Ul, u), W(u, ql, u);
  const d = Ke(t, Wl, D_, {
    [L_]: !0
  });
  W(d, "#"), Ke(d, Wl, d), W(d, WE, d);
  const h = W(d, UE);
  W(h, "#"), Ke(h, Wl, d);
  const f = [[Dn, o], [$n, r]], p = [[Dn, null], [Ir, a], [$n, s]];
  for (let _ = 0; _ < so.length; _++)
    Qn(t, so[_], Vc, Hn, f);
  for (let _ = 0; _ < oo.length; _++)
    Qn(t, oo[_], jc, Fc, p);
  Ei(Vc, {
    tld: !0,
    ascii: !0
  }, e), Ei(jc, {
    utld: !0,
    alpha: !0
  }, e), Qn(t, "file", yo, Hn, f), Qn(t, "mailto", yo, Hn, f), Qn(t, "http", Yi, Hn, f), Qn(t, "https", Yi, Hn, f), Qn(t, "ftp", Yi, Hn, f), Qn(t, "ftps", Yi, Hn, f), Ei(yo, {
    scheme: !0,
    ascii: !0
  }, e), Ei(Yi, {
    slashscheme: !0,
    ascii: !0
  }, e), n = n.sort((_, m) => _[0] > m[0] ? 1 : -1);
  for (let _ = 0; _ < n.length; _++) {
    const m = n[_][0], y = n[_][1] ? {
      [BE]: !0
    } : {
      [FE]: !0
    };
    m.indexOf("-") >= 0 ? y[Bc] = !0 : Dn.test(m) ? $n.test(m) ? y[ts] = !0 : y[zc] = !0 : y[$c] = !0, Df(t, m, m, y);
  }
  return Df(t, "localhost", xs, {
    ascii: !0
  }), t.jd = new jt(ba), {
    start: t,
    tokens: Object.assign({
      groups: e
    }, $_)
  };
}
function z_(n, e) {
  const t = qE(e.replace(/[A-Z]/g, (a) => a.toLowerCase())), i = t.length, r = [];
  let s = 0, o = 0;
  for (; o < i; ) {
    let a = n, l = null, c = 0, u = null, d = -1, h = -1;
    for (; o < i && (l = a.go(t[o])); )
      a = l, a.accepts() ? (d = 0, h = 0, u = a) : d >= 0 && (d += t[o].length, h++), c += t[o].length, s += t[o].length, o++;
    s -= d, o -= h, c -= d, r.push({
      t: u.t,
      // token type/name
      v: e.slice(s - c, s),
      // string value
      s: s - c,
      // start index
      e: s
      // end index (excluding)
    });
  }
  return r;
}
function qE(n) {
  const e = [], t = n.length;
  let i = 0;
  for (; i < t; ) {
    let r = n.charCodeAt(i), s, o = r < 55296 || r > 56319 || i + 1 === t || (s = n.charCodeAt(i + 1)) < 56320 || s > 57343 ? n[i] : n.slice(i, i + 2);
    e.push(o), i += o.length;
  }
  return e;
}
function Qn(n, e, t, i, r) {
  let s;
  const o = e.length;
  for (let a = 0; a < o - 1; a++) {
    const l = e[a];
    n.j[l] ? s = n.j[l] : (s = new jt(i), s.jr = r.slice(), n.j[l] = s), n = s;
  }
  return s = new jt(t), s.jr = r.slice(), n.j[e[o - 1]] = s, s;
}
function zf(n) {
  const e = [], t = [];
  let i = 0, r = "0123456789";
  for (; i < n.length; ) {
    let s = 0;
    for (; r.indexOf(n[i + s]) >= 0; )
      s++;
    if (s > 0) {
      e.push(t.join(""));
      for (let o = parseInt(n.substring(i, i + s), 10); o > 0; o--)
        t.pop();
      i += s;
    } else
      t.push(n[i]), i++;
  }
  return e;
}
const ws = {
  defaultProtocol: "http",
  events: null,
  format: Hf,
  formatHref: Hf,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function id(n, e = null) {
  let t = Object.assign({}, ws);
  n && (t = Object.assign(t, n instanceof id ? n.o : n));
  const i = t.ignoreTags, r = [];
  for (let s = 0; s < i.length; s++)
    r.push(i[s].toUpperCase());
  this.o = t, e && (this.defaultRender = e), this.ignoreTags = r;
}
id.prototype = {
  o: ws,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(n) {
    return n;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(n) {
    return this.get("validate", n.toString(), n);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(n, e, t) {
    const i = e != null;
    let r = this.o[n];
    return r && (typeof r == "object" ? (r = t.t in r ? r[t.t] : ws[n], typeof r == "function" && i && (r = r(e, t))) : typeof r == "function" && i && (r = r(e, t.t, t)), r);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(n, e, t) {
    let i = this.o[n];
    return typeof i == "function" && e != null && (i = i(e, t.t, t)), i;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(n) {
    const e = n.render(this);
    return (this.get("render", null, n) || this.defaultRender)(e, n.t, n);
  }
};
function Hf(n) {
  return n;
}
function H_(n, e) {
  this.t = "token", this.v = n, this.tk = e;
}
H_.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(n) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(n) {
    const e = this.toString(), t = n.get("truncate", e, this), i = n.get("format", e, this);
    return t && i.length > t ? i.substring(0, t) + "…" : i;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(n) {
    return n.get("formatHref", this.toHref(n.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(n = ws.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(n),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(n) {
    return {
      type: this.t,
      value: this.toFormattedString(n),
      isLink: this.isLink,
      href: this.toFormattedHref(n),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(n) {
    return n.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(n) {
    const e = this, t = this.toHref(n.get("defaultProtocol")), i = n.get("formatHref", t, this), r = n.get("tagName", t, e), s = this.toFormattedString(n), o = {}, a = n.get("className", t, e), l = n.get("target", t, e), c = n.get("rel", t, e), u = n.getObj("attributes", t, e), d = n.getObj("events", t, e);
    return o.href = i, a && (o.class = a), l && (o.target = l), c && (o.rel = c), u && Object.assign(o, u), {
      tagName: r,
      attributes: o,
      content: s,
      eventListeners: d
    };
  }
};
function Ga(n, e) {
  class t extends H_ {
    constructor(r, s) {
      super(r, s), this.t = n;
    }
  }
  for (const i in e)
    t.prototype[i] = e[i];
  return t.t = n, t;
}
const Bf = Ga("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), Ff = Ga("text"), GE = Ga("nl"), ao = Ga("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(n = ws.defaultProtocol) {
    return this.hasProtocol() ? this.v : `${n}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const n = this.tk;
    return n.length >= 2 && n[0].t !== xs && n[1].t === li;
  }
}), tn = (n) => new jt(n);
function JE({
  groups: n
}) {
  const e = n.domain.concat([oa, la, ri, ca, ua, da, ha, fa, nn, Yu, rs, pa, ma, ga, Tn, ba, as, _a]), t = [aa, li, Qu, Cn, ed, rs, ss, td, nd, Xo, Yo, ns, is, qo, Ko, Go, Jo, Zo, Qo, ea, ta, na, ia, ra, sa], i = [oa, aa, la, ca, ua, da, ha, fa, nn, ns, is, rs, pa, ma, ga, ss, Tn, ba, as, _a], r = tn(), s = W(r, as);
  xe(s, i, s), xe(s, n.domain, s);
  const o = tn(), a = tn(), l = tn();
  xe(r, n.domain, o), xe(r, n.scheme, a), xe(r, n.slashscheme, l), xe(o, i, s), xe(o, n.domain, o);
  const c = W(o, ri);
  W(s, ri, c), W(a, ri, c), W(l, ri, c);
  const u = W(s, Cn);
  xe(u, i, s), xe(u, n.domain, s);
  const d = tn();
  xe(c, n.domain, d), xe(d, n.domain, d);
  const h = W(d, Cn);
  xe(h, n.domain, d);
  const f = tn(Bf);
  xe(h, n.tld, f), xe(h, n.utld, f), W(c, xs, f);
  const p = W(d, nn);
  W(p, nn, p), xe(p, n.domain, d), xe(f, n.domain, d), W(f, Cn, h), W(f, nn, p);
  const _ = W(f, li);
  xe(_, n.numeric, Bf);
  const m = W(o, nn), g = W(o, Cn);
  W(m, nn, m), xe(m, n.domain, o), xe(g, i, s), xe(g, n.domain, o);
  const y = tn(ao);
  xe(g, n.tld, y), xe(g, n.utld, y), xe(y, n.domain, o), xe(y, i, s), W(y, Cn, g), W(y, nn, m), W(y, ri, c);
  const x = W(y, li), k = tn(ao);
  xe(x, n.numeric, k);
  const E = tn(ao), S = tn();
  xe(E, e, E), xe(E, t, S), xe(S, e, E), xe(S, t, S), W(y, Tn, E), W(k, Tn, E);
  const w = W(a, li), v = W(l, li), A = W(v, Tn), b = W(A, Tn);
  xe(a, n.domain, o), W(a, Cn, g), W(a, nn, m), xe(l, n.domain, o), W(l, Cn, g), W(l, nn, m), xe(w, n.domain, E), W(w, Tn, E), W(w, ss, E), xe(b, n.domain, E), xe(b, e, E), W(b, Tn, E);
  const C = [
    [ns, is],
    // {}
    [Ko, qo],
    // []
    [Go, Jo],
    // ()
    [Xo, Yo],
    // <>
    [Zo, Qo],
    // （）
    [ea, ta],
    // 「」
    [na, ia],
    // 『』
    [ra, sa]
    // ＜＞
  ];
  for (let M = 0; M < C.length; M++) {
    const [z, D] = C[M], H = W(E, z);
    W(S, z, H), W(H, D, E);
    const q = tn(ao);
    xe(H, e, q);
    const G = tn();
    xe(H, t), xe(q, e, q), xe(q, t, G), xe(G, e, q), xe(G, t, G), W(q, D, E), W(G, D, E);
  }
  return W(r, xs, y), W(r, Zu, GE), {
    start: r,
    tokens: $_
  };
}
function XE(n, e, t) {
  let i = t.length, r = 0, s = [], o = [];
  for (; r < i; ) {
    let a = n, l = null, c = null, u = 0, d = null, h = -1;
    for (; r < i && !(l = a.go(t[r].t)); )
      o.push(t[r++]);
    for (; r < i && (c = l || a.go(t[r].t)); )
      l = null, a = c, a.accepts() ? (h = 0, d = a) : h >= 0 && h++, r++, u++;
    if (h < 0)
      r -= u, r < i && (o.push(t[r]), r++);
    else {
      o.length > 0 && (s.push(Gl(Ff, e, o)), o = []), r -= h, u -= h;
      const f = d.t, p = t.slice(r - u, r);
      s.push(Gl(f, e, p));
    }
  }
  return o.length > 0 && s.push(Gl(Ff, e, o)), s;
}
function Gl(n, e, t) {
  const i = t[0].s, r = t[t.length - 1].e, s = e.slice(i, r);
  return new n(s, t);
}
const YE = typeof console < "u" && console && console.warn || (() => {
}), ZE = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", Fe = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function QE() {
  return jt.groups = {}, Fe.scanner = null, Fe.parser = null, Fe.tokenQueue = [], Fe.pluginQueue = [], Fe.customSchemes = [], Fe.initialized = !1, Fe;
}
function Vf(n, e = !1) {
  if (Fe.initialized && YE(`linkifyjs: already initialized - will not register custom scheme "${n}" ${ZE}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(n))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  Fe.customSchemes.push([n, e]);
}
function eC() {
  Fe.scanner = KE(Fe.customSchemes);
  for (let n = 0; n < Fe.tokenQueue.length; n++)
    Fe.tokenQueue[n][1]({
      scanner: Fe.scanner
    });
  Fe.parser = JE(Fe.scanner.tokens);
  for (let n = 0; n < Fe.pluginQueue.length; n++)
    Fe.pluginQueue[n][1]({
      scanner: Fe.scanner,
      parser: Fe.parser
    });
  return Fe.initialized = !0, Fe;
}
function rd(n) {
  return Fe.initialized || eC(), XE(Fe.parser.start, n, z_(Fe.scanner.start, n));
}
rd.scan = z_;
function B_(n, e = null, t = null) {
  if (e && typeof e == "object") {
    if (t)
      throw Error(`linkifyjs: Invalid link type ${e}; must be a string`);
    t = e, e = null;
  }
  const i = new id(t), r = rd(n), s = [];
  for (let o = 0; o < r.length; o++) {
    const a = r[o];
    a.isLink && (!e || a.t === e) && i.check(a) && s.push(a.toFormattedObject(i));
  }
  return s;
}
var sd = "[\0-   ᠎ -\u2029 　]", tC = new RegExp(sd), nC = new RegExp(`${sd}$`), iC = new RegExp(sd, "g");
function rC(n) {
  return n.length === 1 ? n[0].isLink : n.length === 3 && n[1].isLink ? ["()", "[]"].includes(n[0].value + n[2].value) : !1;
}
function sC(n) {
  return new je({
    key: new Xe("autolink"),
    appendTransaction: (e, t, i) => {
      const r = e.some((c) => c.docChanged) && !t.doc.eq(i.doc), s = e.some((c) => c.getMeta("preventAutolink"));
      if (!r || s)
        return;
      const { tr: o } = i, a = Ou(t.doc, [...e]);
      if (zu(a).forEach(({ newRange: c }) => {
        const u = lg(i.doc, c, (f) => f.isTextblock);
        let d, h;
        if (u.length > 1)
          d = u[0], h = i.doc.textBetween(
            d.pos,
            d.pos + d.node.nodeSize,
            void 0,
            " "
          );
        else if (u.length) {
          const f = i.doc.textBetween(c.from, c.to, " ", " ");
          if (!nC.test(f))
            return;
          d = u[0], h = i.doc.textBetween(d.pos, c.to, void 0, " ");
        }
        if (d && h) {
          const f = h.split(tC).filter(Boolean);
          if (f.length <= 0)
            return !1;
          const p = f[f.length - 1], _ = d.pos + h.lastIndexOf(p);
          if (!p)
            return !1;
          const m = rd(p).map((g) => g.toObject(n.defaultProtocol));
          if (!rC(m))
            return !1;
          m.filter((g) => g.isLink).map((g) => ({
            ...g,
            from: _ + g.start + 1,
            to: _ + g.end + 1
          })).filter((g) => i.schema.marks.code ? !i.doc.rangeHasMark(g.from, g.to, i.schema.marks.code) : !0).filter((g) => n.validate(g.value)).filter((g) => n.shouldAutoLink(g.value)).forEach((g) => {
            Ha(g.from, g.to, i.doc).some((y) => y.mark.type === n.type) || o.addMark(
              g.from,
              g.to,
              n.type.create({
                href: g.href
              })
            );
          });
        }
      }), !!o.steps.length)
        return o;
    }
  });
}
function oC(n) {
  return new je({
    key: new Xe("handleClickLink"),
    props: {
      handleClick: (e, t, i) => {
        var r, s;
        if (i.button !== 0 || !e.editable)
          return !1;
        let o = null;
        if (i.target instanceof HTMLAnchorElement)
          o = i.target;
        else {
          let u = i.target;
          const d = [];
          for (; u.nodeName !== "DIV"; )
            d.push(u), u = u.parentNode;
          o = d.find((h) => h.nodeName === "A");
        }
        if (!o)
          return !1;
        const a = $u(e.state, n.type.name), l = (r = o?.href) != null ? r : a.href, c = (s = o?.target) != null ? s : a.target;
        return n.enableClickSelection && n.editor.commands.extendMarkRange(n.type.name), o && l ? (window.open(l, c), !0) : !1;
      }
    }
  });
}
function aC(n) {
  return new je({
    key: new Xe("handlePasteLink"),
    props: {
      handlePaste: (e, t, i) => {
        const { shouldAutoLink: r } = n, { state: s } = e, { selection: o } = s, { empty: a } = o;
        if (a)
          return !1;
        let l = "";
        i.content.forEach((u) => {
          l += u.textContent;
        });
        const c = B_(l, { defaultProtocol: n.defaultProtocol }).find(
          (u) => u.isLink && u.value === l
        );
        return !l || !c || r !== void 0 && !r(c.href) ? !1 : n.editor.commands.setMark(n.type, {
          href: c.href
        });
      }
    }
  });
}
function xi(n, e) {
  const t = ["http", "https", "ftp", "ftps", "mailto", "tel", "callto", "sms", "cid", "xmpp"];
  return e && e.forEach((i) => {
    const r = typeof i == "string" ? i : i.scheme;
    r && t.push(r);
  }), !n || n.replace(iC, "").match(
    new RegExp(
      // eslint-disable-next-line no-useless-escape
      `^(?:(?:${t.join("|")}):|[^a-z]|[a-z0-9+.-]+(?:[^a-z+.-:]|$))`,
      "i"
    )
  );
}
var lC = Jt.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  exitable: !0,
  onCreate() {
    this.options.validate && !this.options.shouldAutoLink && (this.options.shouldAutoLink = this.options.validate, console.warn("The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.")), this.options.protocols.forEach((n) => {
      if (typeof n == "string") {
        Vf(n);
        return;
      }
      Vf(n.scheme, n.optionalSlashes);
    });
  },
  onDestroy() {
    QE();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      enableClickSelection: !1,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      defaultProtocol: "http",
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      isAllowedUri: (n, e) => !!xi(n, e.protocols),
      validate: (n) => !!n,
      shouldAutoLink: (n) => !!n
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(n) {
          return n.getAttribute("href");
        }
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a[href]",
        getAttrs: (n) => {
          const e = n.getAttribute("href");
          return !e || !this.options.isAllowedUri(e, {
            defaultValidate: (t) => !!xi(t, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol
          }) ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return this.options.isAllowedUri(n.href, {
      defaultValidate: (e) => !!xi(e, this.options.protocols),
      protocols: this.options.protocols,
      defaultProtocol: this.options.defaultProtocol
    }) ? ["a", Ee(this.options.HTMLAttributes, n), 0] : ["a", Ee(this.options.HTMLAttributes, { ...n, href: "" }), 0];
  },
  markdownTokenName: "link",
  parseMarkdown: (n, e) => e.applyMark("link", e.parseInline(n.tokens || []), {
    href: n.href,
    title: n.title || null
  }),
  renderMarkdown: (n, e) => {
    var t;
    const i = ((t = n.attrs) == null ? void 0 : t.href) || "";
    return `[${e.renderChildren(n)}](${i})`;
  },
  addCommands() {
    return {
      setLink: (n) => ({ chain: e }) => {
        const { href: t } = n;
        return this.options.isAllowedUri(t, {
          defaultValidate: (i) => !!xi(i, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? e().setMark(this.name, n).setMeta("preventAutolink", !0).run() : !1;
      },
      toggleLink: (n) => ({ chain: e }) => {
        const { href: t } = n || {};
        return t && !this.options.isAllowedUri(t, {
          defaultValidate: (i) => !!xi(i, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? !1 : e().toggleMark(this.name, n, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run();
      },
      unsetLink: () => ({ chain: n }) => n().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      Di({
        find: (n) => {
          const e = [];
          if (n) {
            const { protocols: t, defaultProtocol: i } = this.options, r = B_(n).filter(
              (s) => s.isLink && this.options.isAllowedUri(s.value, {
                defaultValidate: (o) => !!xi(o, t),
                protocols: t,
                defaultProtocol: i
              })
            );
            r.length && r.forEach((s) => {
              this.options.shouldAutoLink(s.value) && e.push({
                text: s.value,
                data: {
                  href: s.href
                },
                index: s.start
              });
            });
          }
          return e;
        },
        type: this.type,
        getAttributes: (n) => {
          var e;
          return {
            href: (e = n.data) == null ? void 0 : e.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const n = [], { protocols: e, defaultProtocol: t } = this.options;
    return this.options.autolink && n.push(
      sC({
        type: this.type,
        defaultProtocol: this.options.defaultProtocol,
        validate: (i) => this.options.isAllowedUri(i, {
          defaultValidate: (r) => !!xi(r, e),
          protocols: e,
          defaultProtocol: t
        }),
        shouldAutoLink: this.options.shouldAutoLink
      })
    ), this.options.openOnClick === !0 && n.push(
      oC({
        type: this.type,
        editor: this.editor,
        enableClickSelection: this.options.enableClickSelection
      })
    ), this.options.linkOnPaste && n.push(
      aC({
        editor: this.editor,
        defaultProtocol: this.options.defaultProtocol,
        type: this.type,
        shouldAutoLink: this.options.shouldAutoLink
      })
    ), n;
  }
});
const cC = lC.extend({
  priority: 1100,
  addOptions() {
    return {
      ...this.parent?.(),
      shortcutHandler: void 0
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(n) {
          return n.getAttribute("href");
        }
      },
      target: {
        default: null
      },
      title: {
        default: null
      },
      rel: {
        default: null
      },
      class: {
        default: null
      },
      "data-inline": {
        default: "true",
        renderHTML: () => null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a:not([data-mt-rich-text-editor-block])",
        getAttrs: (n) => {
          if (!(n instanceof HTMLElement))
            return !1;
          const e = {};
          return Array.from(n.attributes).forEach((t) => {
            e[t.name] = t.value;
          }), {
            HTMLAttributes: e,
            "data-inline": n.getAttribute("data-inline")
          };
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    const { HTMLAttributes: e = {}, ...t } = n;
    return ["a", { ...e, ...t, "data-inline": void 0 }, 0];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-k": () => (this.options.shortcutHandler?.(), !0)
    };
  },
  addCommands() {
    return {
      ...this.parent?.(),
      setInlineLinkShortcutHandler: (n) => () => {
        this.options.shortcutHandler = n;
      }
    };
  }
});
var uC = Ne.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [{ tag: "p" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["p", Ee(this.options.HTMLAttributes, n), 0];
  },
  parseMarkdown: (n, e) => {
    const t = n.tokens || [];
    return t.length === 1 && t[0].type === "image" ? e.parseChildren([t[0]]) : e.createNode(
      "paragraph",
      void 0,
      // no attributes for paragraph
      e.parseInline(t)
    );
  },
  renderMarkdown: (n, e) => !n || !Array.isArray(n.content) ? "" : e.renderChildren(n.content),
  addCommands() {
    return {
      setParagraph: () => ({ commands: n }) => n.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
});
const dC = uC.extend({
  name: "paragraph",
  priority: 1e3,
  group: "block",
  content: "inline*",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [{ tag: "p" }];
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    const { MTRichTextEditorHTMLAttributes: t, textAlign: i, ...r } = n.attrs;
    return ["p", Ee(this.options.HTMLAttributes, r, e), 0];
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: n }) => n.setNode(this.name)
    };
  }
}), hC = Ne.create({
  name: "textBlock",
  group: "block",
  content: "inline*",
  parseHTML() {
    return [
      {
        tag: "mt-text-block",
        getAttrs: (n) => n instanceof HTMLElement ? {} : !1
      }
    ];
  },
  renderHTML() {
    return ["mt-text-block", 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: ({ editor: n }) => {
        if (!n.isActive(this.name))
          return !1;
        const { state: e } = n, { selection: t } = e, { $from: i } = t, r = i.node(-1);
        if (!r)
          return !1;
        if (r.type.name === "tableCell" || r.type.name === "tableHeader")
          return n.chain().insertContent("<br />").run(), !0;
        const s = i.after(-1), o = i.parent.content.cut(i.parentOffset).toJSON();
        if (r.type.name === "listItem" && !o)
          return setTimeout(() => {
            n.state.selection.$from.node(-1).type.name !== "listItem" && n.commands.setParagraph();
          }), !1;
        if (!n.chain().insertContentAt(s, {
          type: r.type.name,
          content: [
            {
              type: this.name,
              content: o
            }
          ]
        }).deleteRange({ from: i.pos, to: i.after() }).run()) return !1;
        const u = n.state.doc.resolve(s + 1).start();
        return n.chain().setTextSelection(u).focus().run(), !0;
      },
      Backspace: ({ editor: n }) => {
        if (n.isActive(this.name) && setTimeout(() => {
          const { state: e } = n, t = e.selection.$from;
          if (t.node(-1).type.name !== "listItem")
            return;
          let r = -1;
          for (let u = t.depth; u > 0; u -= 1)
            if (t.node(u).type.name === "listItem") {
              r = u;
              break;
            }
          if (r === -1)
            return;
          const s = t.node(r);
          if (s.childCount === 1)
            return;
          const o = t.before(r);
          let a = -1;
          for (let u = s.childCount - 1; u >= 0; u -= 1) {
            const d = s.child(u);
            if (d.type.name !== this.name || d.textContent.trim() !== "")
              break;
            a = u;
          }
          if (a === -1)
            return;
          let l = o + 1;
          for (let u = 0; u < a; u += 1)
            l += s.child(u).nodeSize;
          let c = l;
          for (let u = a; u < s.childCount; u += 1) {
            const d = s.child(u);
            if (d.type.name !== this.name || d.textContent.trim() !== "")
              break;
            c += d.nodeSize;
          }
          c > l && n.view.dispatch(e.tr.delete(l, c));
        }), n.isActive("paragraph")) {
          if (n.state.selection.$from.node(-1).type.name !== "doc")
            return;
          setTimeout(() => {
            n.state.selection.$from.node(-1).type.name === "listItem" && n.commands.setNode("textBlock");
          });
        }
      }
    };
  },
  addStorage() {
    return {
      originalText: ""
    };
  }
}), fC = Ne.create({
  name: "pre",
  priority: 1e3,
  group: "block",
  content: "inline*|text*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["pre", n, 0];
  },
  addCommands() {
    return {
      setPre: () => ({ commands: n }) => n.setNode(this.name),
      unsetPre: () => ({ commands: n }) => n.setNode("paragraph")
    };
  }
}), pC = Ne.create({
  name: "code",
  priority: 1e3,
  group: "inline",
  inline: !0,
  content: "text*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "code",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["code", n, 0];
  }
}), mC = Ne.create({
  name: "descriptionList",
  priority: 1e3,
  group: "block",
  content: "(descriptionTerm|descriptionDetails)+",
  defining: !0,
  parseHTML() {
    return [{ tag: "dl" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["dl", n, 0];
  }
}), gC = Ne.create({
  name: "descriptionTerm",
  priority: 1e3,
  group: "block",
  content: "(textBlock|paragraph) block*",
  defining: !0,
  parseHTML() {
    return [{ tag: "dt" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["dt", n, 0];
  }
}), _C = Ne.create({
  name: "descriptionDetails",
  priority: 1e3,
  group: "block",
  content: "(textBlock|paragraph) block*",
  defining: !0,
  parseHTML() {
    return [{ tag: "dd" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["dd", n, 0];
  }
}), bC = Ne.create({
  name: "summary",
  priority: 1e3,
  group: "block",
  content: "inline*",
  defining: !0,
  parseHTML() {
    return [{ tag: "summary" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["summary", n, 0];
  }
}), vC = n_.extend({
  name: "listItem",
  priority: 1e3,
  content: "(textBlock|block) block*",
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["li", Ee(this.options.HTMLAttributes, n), 0];
  },
  addKeyboardShortcuts() {
    const n = this.parent();
    return {
      ...n,
      "Shift-Tab": () => (n["Shift-Tab"](), !this.editor.isActive("listItem") && this.editor.isActive("textBlock") && this.editor.commands.setParagraph(), !0)
    };
  }
}), Uc = {}, yC = (n) => {
  const e = Math.random().toString(36).substring(2, 15), t = (i) => {
    const r = i.data;
    if (r?.id !== e)
      return;
    const s = n.view.dom.querySelector(
      `iframe[data-mt-rich-text-editor-iframe="${r.id}"]`
    );
    s && (r.method === "click" ? s.click() : r.method === "resize" && (r.width && (s.style.width = `${r.width}px`), r.height && (s.style.height = `${r.height}px`)));
  };
  return Uc[e] = t, window.addEventListener("message", t, {
    capture: !0,
    passive: !0
  }), {
    id: e,
    handler: t
  };
}, xC = (n) => {
  const e = Uc[n];
  e && (window.removeEventListener("message", e, {
    capture: !0
  }), delete Uc[n]);
}, F_ = (n, e) => {
  const { id: t } = yC(n), i = {
    sourceType: "data",
    content: e,
    sandbox: "allow-scripts allow-same-origin"
  };
  n.commands.emitEditorEvent("previewIframe", i);
  const r = i.sourceType === "data-wrap", s = document.createElement("iframe");
  s.setAttribute("data-mt-rich-text-editor-iframe", t), s.setAttribute("frameborder", "0"), s.setAttribute("allowfullscreen", "true"), s.style.width = "100%", s.style.display = "block", s.sandbox = i.sandbox;
  let o = `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="${document.characterSet || "UTF-8"}">
          <style>
            html, body {
              margin: 0;
              padding: 0;
              overflow: hidden;
            }
            ::-webkit-scrollbar {
              display: none;
            }
          </style>
          <script>
            const wrap = ${r ? "true" : "false"};
            const parentWindow = wrap ? window.parent.parent : window.parent;

            const resizeObserver = new ResizeObserver((entries) => {
              const width = document.body.scrollWidth;
              const height = document.body.scrollHeight;

              parentWindow.postMessage({
                method: "resize",
                id: "${t}",
                width: width,
                height: height,
              }, "*");

              if (wrap) {
                window.frameElement.style.width = width + "px";
                window.frameElement.style.height = height + "px";
              }
            });
            
            window.addEventListener('load', () => {
              resizeObserver.observe(document.body);
            });

            const events = ['mousedown', 'mouseup', 'click', 'dblclick', 'contextmenu', 'mousemove'];
            events.forEach(eventName => {
              document.addEventListener(eventName, (e) => {
                e.stopPropagation();
                e.preventDefault();
                if (eventName === "click") {
                  parentWindow.postMessage({
                    method: eventName,
                    id: "${t}",
                  }, "*");
                }
              }, true);
            });
          <\/script>
        </head>
        <body>
          ${e}
        </body>
      </html>
    `;
  if (i.sourceType === "data" || i.sourceType === "data-wrap") {
    if (i.sourceType === "data-wrap") {
      const c = document.createElement("iframe");
      c.setAttribute("frameborder", "0"), c.setAttribute("allowfullscreen", "true"), c.srcdoc = o, o = `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="${document.characterSet || "UTF-8"}">
          <style>
            html, body {
              margin: 0;
              padding: 0;
              overflow: hidden;
            }
            iframe {
              width: 100%;
              display: block;
            }
            ::-webkit-scrollbar {
              display: none;
            }
          </style>
        </head>
        <body>
          ${c.outerHTML}
        </body>
      </html>
      `;
    }
    const a = new Blob([o], { type: "text/html" }), l = new FileReader();
    l.readAsDataURL(a), l.onload = () => {
      s.src = l.result?.toString() || "";
    };
  } else i.sourceType === "blob" ? s.src = URL.createObjectURL(
    new Blob([o], {
      type: "text/html"
    })
  ) : i.sourceType === "srcdoc" && (s.srcdoc = o);
  return s;
}, V_ = (n) => {
  xC(n.getAttribute("data-mt-rich-text-editor-iframe") || "");
}, wC = (n) => {
  if (!n)
    return;
  const e = document.createElement("a");
  return e.href = n, e.origin;
}, kC = Ne.create({
  name: "script",
  group: "inline",
  content: "text*",
  inline: !0,
  atom: !0,
  addOptions() {
    return {
      allowedOrigins: ["https://gist.github.com", "https://pastebin.com"]
    };
  },
  parseHTML() {
    return [
      {
        tag: "mt-rich-text-editor-script",
        preserveWhitespace: "full"
      }
    ];
  },
  addNodeView() {
    const n = this.options.allowedOrigins || [];
    return ({ editor: e, node: t }) => {
      const i = document.createElement("div");
      i.classList.add("mt-rich-text-editor-script");
      const r = t.attrs.MTRichTextEditorHTMLAttributes || {};
      i.dataset.mtRichTextEditorScriptTitle = "<script " + Object.entries(r).map(([a, l]) => `${a}="${l}"`).join(" ") + "/>";
      const s = r.src, o = wC(s);
      if (o && n.includes(o)) {
        i.classList.add("mt-rich-text-editor-script--preview");
        const a = document.createElement("script");
        a.src = s;
        const l = F_(e, a.outerHTML);
        return i.appendChild(l), {
          dom: i,
          destroy: () => {
            V_(l);
          }
        };
      }
      return i.innerText = t.content.content.map((a) => a.text).join("").replace(/^\n/, "").replace(/\s+$/, ""), {
        dom: i
      };
    };
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["mt-rich-text-editor-script", n, 0];
  }
}), od = ({ editor: n }) => {
  if (!n.isActive("embedObject"))
    return !1;
  const e = n.state.selection;
  if (!(e instanceof re) || e.node.type.name !== "embedObject") {
    const { $from: t } = e;
    for (let i = t.depth; i > 0; i--)
      t.node(i).type.name === "embedObject" && n.chain().setNodeSelection(t.before(i)).focus().run();
  }
}, jf = ({ editor: n }) => {
  if (!n.isActive("embedObject"))
    return !1;
  od({ editor: n });
  const e = n.state.selection, { $from: t } = e;
  if (t.nodeBefore)
    return !1;
  try {
    const i = e.from;
    return n.chain().insertContentAt(i, { type: "paragraph" }).setTextSelection(i + 1).run(), !0;
  } catch {
    return !1;
  }
}, Wf = ({ editor: n }) => {
  if (!n.isActive("embedObject"))
    return !1;
  od({ editor: n });
  const e = n.state.selection, { $to: t } = e;
  if (t.nodeAfter)
    return !1;
  try {
    const i = e.to;
    return n.chain().insertContentAt(i, { type: "paragraph" }).setTextSelection(i + 1).run(), !0;
  } catch {
    return !0;
  }
}, SC = Ne.create({
  name: "embedObject",
  priority: 1e3,
  group: "block",
  content: "block*",
  defining: !0,
  addAttributes() {
    return {
      content: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "div[data-mt-rich-text-editor-embed-object]",
        getAttrs: (n) => n instanceof HTMLElement ? {
          content: n.innerHTML
        } : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return [
      "div",
      Ee({
        "data-mt-rich-text-editor-embed-object": "",
        "data-mt-rich-text-editor-content": n.content
      }),
      0
    ];
  },
  addNodeView() {
    return ({ editor: n, node: e, getPos: t }) => {
      const i = F_(n, e.attrs.content), r = () => {
        if (!t)
          return;
        let o;
        try {
          o = t();
        } catch {
          return;
        }
        typeof o == "number" && n.chain().setNodeSelection(o).focus().run();
      }, s = (o) => {
        o.preventDefault(), r();
      };
      return i.addEventListener("click", s), {
        dom: i,
        destroy: () => {
          i.removeEventListener("click", s), V_(i);
        }
      };
    };
  },
  addCommands() {
    return {
      getEmbedObject: (n) => () => this.options.resolver(n),
      insertEmbedObject: (n) => ({ state: e, commands: t }) => {
        const i = e.selection.$anchor.pos;
        return t.insertContent({
          type: this.name,
          attrs: {
            content: n
          }
        }), t.setTextSelection(i + 2), !0;
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      Enter: ({ editor: n }) => {
        if (!n.isActive(this.name))
          return !1;
        od({ editor: n });
        const e = n.state.selection.$from.pos;
        return n.chain().insertContentAt(e - 1, { type: "paragraph" }).setTextSelection(e).run(), !0;
      },
      Backspace: ({ editor: n }) => {
        const { state: e, view: t } = n, { selection: i } = e;
        if (i.empty && i.$from.parentOffset === 0) {
          const r = i.$from.before(), s = e.doc.resolve(r).nodeBefore;
          if (s?.type.name === this.name) {
            const o = re.create(
              e.doc,
              r - s.nodeSize
            );
            let a = e.tr.setSelection(o);
            return i.$from.node().content.size === 0 ? a = a.delete(i.from - 1, i.to) : a = a.deleteSelection(), t.dispatch(a), !0;
          }
        }
        return !1;
      },
      ArrowUp: jf,
      ArrowLeft: jf,
      ArrowDown: Wf,
      ArrowRight: Wf
    };
  }
}), EC = Oe.create({
  name: "markdown",
  addCommands() {
    return {
      // FIXME: fix type error
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      isMarkdownConversionAvailable: () => () => !!this.options.toHtml,
      // FIXME: fix type error
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      markdownToHtml: (n) => () => this.options.toHtml(n)
    };
  }
}), CC = sS.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      registerShortcuts: !0
    };
  },
  addKeyboardShortcuts() {
    return this.options.registerShortcuts ? this.parent?.() ?? {} : {};
  }
}), TC = /* @__PURE__ */ new Set([
  "onabortonblur",
  "oncancel",
  "oncanplay",
  "oncanplaythrough",
  "onchange",
  "onclick",
  "onclose",
  "oncontextmenu",
  "oncuechange",
  "ondblclick",
  "ondrag",
  "ondragend",
  "ondragenter",
  "ondragleave",
  "ondragover",
  "ondragstart",
  "ondrop",
  "ondurationchange",
  "onemptied",
  "onended",
  "onerror",
  "onfocus",
  "oninput",
  "oninvalid",
  "onkeydown",
  "onkeypress",
  "onkeyup",
  "onload",
  "onloadeddata",
  "onloadedmetadata",
  "onloadstart",
  "onmousedown",
  "onmousemove",
  "onmouseout",
  "onmouseover",
  "onmouseup",
  "onmousewheel",
  "onpause",
  "onplay",
  "onplaying",
  "onprogress",
  "onratechange",
  "onreset",
  "onscroll",
  "onseeked",
  "onseeking",
  "onseeking",
  "onselect",
  "onshow",
  "onstalled",
  "onsubmit",
  "onsuspend",
  "ontimeupdate",
  "onvolumechange",
  "onwaiting",
  "formaction",
  "action"
]), AC = Oe.create({
  name: "mt-rich-text-editor-global",
  addOptions() {
    return {
      additionalGlobalAttributeTypes: []
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: [
          "div",
          "pre",
          "code",
          "blockquote",
          "bulletList",
          "document",
          "embedObject",
          "hardBreak",
          "heading",
          "horizontalRule",
          "iframe",
          "image",
          "inlineLink",
          "listItem",
          "orderedList",
          "paragraph",
          "textStyle",
          "script",
          "table",
          "tableRow",
          "tableCell",
          "tableHeader",
          "link",
          "blockLink",
          "descriptionList",
          "descriptionTerm",
          "descriptionDetails"
        ].concat(this.options.additionalGlobalAttributeTypes),
        attributes: {
          MTRichTextEditorHTMLAttributes: {
            default: {},
            parseHTML: (n) => {
              const e = {}, t = {};
              for (const i of n.attributes)
                /^data-mt-rich-text-editor-/.test(i.name) || (TC.has(i.name.toLowerCase()) ? t[i.name] = i.value : e[i.name] = i.value);
              return Object.keys(t).length > 0 && (e["data-mt-rich-text-editor-event-attributes"] = JSON.stringify(t)), e;
            },
            renderHTML: (n) => n.MTRichTextEditorHTMLAttributes
          }
        }
      }
    ];
  }
});
window.customElements.define(
  "mt-rich-text-editor-mt-function-tag",
  class extends HTMLElement {
    connectedCallback() {
      this.style.color = "#9333ea", this.style.fontFamily = "monospace";
      const n = ["data-tag-name", "contenteditable", "style", "class"], e = this.getAttribute("data-tag-name");
      if (!e)
        return;
      let t = "";
      Array.from(this.attributes).filter((i) => !n.includes(i.name)).forEach((i) => {
        t += ` ${i.name}="${i.value}"`;
      }), this.textContent = `<mt:${e}${t}>`;
    }
  }
);
const MC = Ne.create({
  name: "mt-rich-text-editor-mt-function-tag",
  group: "inline",
  inline: !0,
  atom: !0,
  addAttributes() {
    return {
      "data-tag-name": {
        default: null
      },
      HTMLAttributes: {
        default: {},
        parseHTML: (n) => {
          const e = {}, t = ["data-tag-name", "contenteditable", "style", "class"];
          return Array.from(n.attributes).filter((i) => !t.includes(i.name)).forEach((i) => {
            e[i.name] = i.value;
          }), e;
        },
        renderHTML: (n) => n.HTMLAttributes
      }
    };
  },
  addInputRules() {
    const n = this.options.tags;
    return n?.length ? [
      new Bi({
        find: new RegExp(`<\\$?mt:?(${n.join("|")})[^>]*\\$?>$`, "i"),
        handler: ({ state: e, range: t, match: i }) => {
          const s = new DOMParser().parseFromString(
            i[0].replace(/^<\$/, "<").replace(/\$>$/, ">"),
            "text/html"
          ).body.firstChild, o = {
            "data-tag-name": i[1],
            HTMLAttributes: {}
          };
          for (const l of s.attributes)
            l.name !== "data-tag-name" && (o.HTMLAttributes[l.name] = l.value);
          const a = this.type.create(o);
          e.tr.replaceWith(t.from, t.to, a);
        }
      })
    ] : [];
  },
  parseHTML() {
    return [
      {
        tag: "mt-rich-text-editor-mt-function-tag",
        getAttrs: (n) => n instanceof HTMLElement ? {
          "data-tag-name": n.getAttribute("data-tag-name"),
          ...Object.fromEntries(
            Array.from(n.attributes).filter((e) => e.name !== "data-tag-name").map((e) => [e.name, e.value])
          )
        } : {}
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["mt-rich-text-editor-mt-function-tag", Ee(n)];
  }
}), OC = Oe.create({
  name: "mt-rich-text-editor-group",
  addExtensions() {
    return [
      AC.configure({
        additionalGlobalAttributeTypes: this.options.additionalGlobalAttributeTypes || []
      }),
      MC.configure({
        tags: this.options.tags
      })
    ];
  },
  addCommands() {
    return {
      emitEditorEvent: (n, e) => () => {
        this.options.editor.emit(n, e);
      }
    };
  }
}), Uf = {
  openOnClick: !1
}, NC = Oe.create({
  name: "mt-rich-text-editor",
  addExtensions() {
    const n = [];
    return this.options.movableType !== !1 && n.push(OC.configure(this.options?.movableType)), this.options.undoRedo !== !1 && n.push(CC.configure(this.options?.undoRedo)), this.options.document !== !1 && n.push(n2.configure(this.options?.document)), this.options.text !== !1 && n.push(i2.configure(this.options?.text)), this.options.subscript !== !1 && n.push(r2.configure(this.options?.subscript)), this.options.superscript !== !1 && n.push(s2.configure(this.options?.superscript)), this.options.image !== !1 && n.push(
      a2.configure(
        this.options?.image ?? {
          inline: !0,
          allowBase64: !0
        }
      )
    ), this.options.hardBreak !== !1 && n.push(l2.configure(this.options?.hardBreak)), this.options.bold !== !1 && n.push(DE.configure(this.options?.bold)), this.options.italic !== !1 && n.push(f2.configure(this.options?.italic)), this.options.underline !== !1 && n.push(p2.configure(this.options?.underline)), this.options.strike !== !1 && n.push(D2.configure(this.options?.strike)), this.options.blockquote !== !1 && n.push(g2.configure(this.options?.blockquote)), this.options.table !== !1 && n.push(
      EE.configure(
        this.options?.table ?? {
          resizable: !0
        }
      )
    ), this.options.tableRow !== !1 && n.push(M_.configure(this.options?.tableRow)), this.options.tableHeader !== !1 && n.push(TE.configure(this.options?.tableHeader)), this.options.tableCell !== !1 && n.push(CE.configure(this.options?.tableCell)), this.options.bulletList !== !1 && n.push(O2.configure(this.options?.bulletList)), this.options.heading !== !1 && n.push(N2.configure(this.options?.heading)), this.options.horizontalRule !== !1 && n.push(L2.configure(this.options?.horizontalRule)), this.options.orderedList !== !1 && n.push(R2.configure(this.options?.orderedList)), this.options.dropcursor !== !1 && n.push(iS.configure(this.options?.dropcursor)), this.options.gapcursor !== !1 && n.push(rS.configure(this.options?.gapcursor)), this.options.textAlign !== !1 && n.push(
      oS.configure(
        this.options?.textAlign ?? {
          types: ["heading", "paragraph"],
          defaultAlignment: ""
        }
      )
    ), this.options.color !== !1 && n.push(hS.configure(this.options?.color)), this.options.backgroundColor !== !1 && n.push(mS.configure(this.options?.backgroundColor)), this.options.textStyle !== !1 && n.push(cS.configure(this.options?.textStyle)), this.options.fileHandler !== !1 && n.push(_S.configure(this.options?.fileHandler)), this.options.iframe !== !1 && n.push(vS.configure(this.options?.iframe)), this.options.indent !== !1 && n.push(AE.configure(this.options?.indent)), this.options.paragraph !== !1 && n.push(dC.configure(this.options?.paragraph)), this.options.textBlock !== !1 && n.push(hC.configure(this.options?.textBlock)), this.options.pre !== !1 && n.push(fC.configure(this.options?.pre)), this.options.code !== !1 && n.push(pC.configure(this.options?.code)), this.options.descriptionList !== !1 && n.push(mC.configure(this.options?.descriptionList)), this.options.descriptionTerm !== !1 && n.push(gC.configure(this.options?.descriptionTerm)), this.options.descriptionDetails !== !1 && n.push(_C.configure(this.options?.descriptionDetails)), this.options.summary !== !1 && n.push(bC.configure(this.options?.summary)), this.options.listItem !== !1 && n.push(vC.configure(this.options?.listItem)), this.options.div !== !1 && n.push(ME.configure(this.options?.div)), this.options.span !== !1 && n.push(OE.configure(this.options?.span)), this.options.inlineLink !== !1 && n.push(cC.configure(this.options?.inlineLink ?? Uf)), this.options.blockLink !== !1 && n.push($E.configure(this.options?.blockLink ?? Uf)), this.options.script !== !1 && n.push(kC.configure(this.options?.script)), this.options.embedObject !== !1 && n.push(SC.configure(this.options?.embedObject)), this.options.markdown !== !1 && n.push(EC.configure(this.options?.markdown)), n;
  }
});
function it(n, e, [t, i] = [0, 0]) {
  Re && t === 0 && Ni();
  var r = n, s = null, o = null, a = J0, l = t > 0 ? Xc : 0, c = !1;
  const u = (h, f = !0) => {
    c = !0, d(f, h);
  }, d = (h, f) => {
    if (a === (a = h)) return;
    let p = !1;
    if (Re && i !== -1) {
      if (t === 0) {
        const m = (
          /** @type {Comment} */
          r.data
        );
        m === X0 ? i = 0 : m === bp ? i = 1 / 0 : (i = parseInt(m.substring(1)), i !== i && (i = a ? 1 / 0 : -1));
      }
      const _ = i > t;
      !!a === _ && (r = sc(), Ci(r), Wn(!1), p = !0, i = -1);
    }
    a ? (s ? cs(s) : f && (s = lr(() => f(r))), o && wo(o, () => {
      o = null;
    })) : (o ? cs(o) : f && (o = lr(() => f(r, [t + 1, i]))), s && wo(s, () => {
      s = null;
    })), p && Wn(!0);
  };
  ya(() => {
    c = !1, e(u), c || d(null, null);
  }, l), Re && (r = pn);
}
function bn(n, e) {
  return e;
}
function LC(n, e, t, i) {
  for (var r = [], s = e.length, o = 0; o < s; o++)
    Z0(e[o].e, r, !0);
  var a = s > 0 && r.length === 0 && t !== null;
  if (a) {
    var l = (
      /** @type {Element} */
      /** @type {Element} */
      t.parentNode
    );
    Q0(l), l.append(
      /** @type {Element} */
      t
    ), i.clear(), si(n, e[0].prev, e[s - 1].next);
  }
  eb(r, () => {
    for (var c = 0; c < s; c++) {
      var u = e[c];
      a || (i.delete(u.k), si(n, u.prev, u.next)), Qc(u.e, !a);
    }
  });
}
function ut(n, e, t, i, r, s = null) {
  var o = n, a = { flags: e, items: /* @__PURE__ */ new Map(), first: null }, l = (e & wp) !== 0;
  if (l) {
    var c = (
      /** @type {Element} */
      n
    );
    o = Re ? Ci(
      /** @type {Comment | Text} */
      eu(c)
    ) : c.appendChild(vp());
  }
  Re && Ni();
  var u = null, d = !1, h = ko(() => {
    var f = t();
    return tu(f) ? f : f == null ? [] : yp(f);
  });
  ya(() => {
    var f = T(h), p = f.length;
    if (d && p === 0)
      return;
    d = p === 0;
    let _ = !1;
    if (Re) {
      var m = (
        /** @type {Comment} */
        o.data === bp
      );
      m !== (p === 0) && (o = sc(), Ci(o), Wn(!1), _ = !0);
    }
    if (Re) {
      for (var g = null, y, x = 0; x < p; x++) {
        if (pn.nodeType === 8 && /** @type {Comment} */
        pn.data === nb) {
          o = /** @type {Comment} */
          pn, _ = !0, Wn(!1);
          break;
        }
        var k = f[x], E = i(k, x);
        y = j_(
          pn,
          a,
          g,
          null,
          k,
          E,
          x,
          r,
          e,
          t
        ), a.items.set(E, y), g = y;
      }
      p > 0 && Ci(sc());
    }
    Re || RC(f, a, o, r, e, i, t), s !== null && (p === 0 ? u ? cs(u) : u = lr(() => s(o)) : u !== null && wo(u, () => {
      u = null;
    })), _ && Wn(!0), T(h);
  }), Re && (o = pn);
}
function RC(n, e, t, i, r, s, o) {
  var a = (r & Y0) !== 0, l = (r & (Yc | Zc)) !== 0, c = n.length, u = e.items, d = e.first, h = d, f, p = null, _, m = [], g = [], y, x, k, E;
  if (a)
    for (E = 0; E < c; E += 1)
      y = n[E], x = s(y, E), k = u.get(x), k !== void 0 && (k.a?.measure(), (_ ??= /* @__PURE__ */ new Set()).add(k));
  for (E = 0; E < c; E += 1) {
    if (y = n[E], x = s(y, E), k = u.get(x), k === void 0) {
      var S = h ? (
        /** @type {TemplateNode} */
        h.e.nodes_start
      ) : t;
      p = j_(
        S,
        e,
        p,
        p === null ? e.first : p.next,
        y,
        x,
        E,
        i,
        r,
        o
      ), u.set(x, p), m = [], g = [], h = p.next;
      continue;
    }
    if (l && IC(k, y, E, r), (k.e.f & rl) !== 0 && (cs(k.e), a && (k.a?.unfix(), (_ ??= /* @__PURE__ */ new Set()).delete(k))), k !== h) {
      if (f !== void 0 && f.has(k)) {
        if (m.length < g.length) {
          var w = g[0], v;
          p = w.prev;
          var A = m[0], b = m[m.length - 1];
          for (v = 0; v < m.length; v += 1)
            Kf(m[v], w, t);
          for (v = 0; v < g.length; v += 1)
            f.delete(g[v]);
          si(e, A.prev, b.next), si(e, p, A), si(e, b, w), h = w, p = b, E -= 1, m = [], g = [];
        } else
          f.delete(k), Kf(k, h, t), si(e, k.prev, k.next), si(e, k, p === null ? e.first : p.next), si(e, p, k), p = k;
        continue;
      }
      for (m = [], g = []; h !== null && h.k !== x; )
        (h.e.f & rl) === 0 && (f ??= /* @__PURE__ */ new Set()).add(h), g.push(h), h = h.next;
      if (h === null)
        continue;
      k = h;
    }
    m.push(k), p = k, h = k.next;
  }
  if (h !== null || f !== void 0) {
    for (var C = f === void 0 ? [] : yp(f); h !== null; )
      (h.e.f & rl) === 0 && C.push(h), h = h.next;
    var M = C.length;
    if (M > 0) {
      var z = (r & wp) !== 0 && c === 0 ? t : null;
      if (a) {
        for (E = 0; E < M; E += 1)
          C[E].a?.measure();
        for (E = 0; E < M; E += 1)
          C[E].a?.fix();
      }
      LC(e, C, z, u);
    }
  }
  a && xp(() => {
    if (_ !== void 0)
      for (k of _)
        k.a?.apply();
  }), us.first = e.first && e.first.e, us.last = p && p.e;
}
function IC(n, e, t, i) {
  (i & Yc) !== 0 && bd(n.v, e), (i & Zc) !== 0 ? bd(
    /** @type {Value<number>} */
    n.i,
    t
  ) : n.i = t;
}
function j_(n, e, t, i, r, s, o, a, l, c) {
  var u = (l & Yc) !== 0, d = (l & tb) === 0, h = u ? d ? nr(r) : vd(r) : r, f = (l & Zc) === 0 ? o : vd(o), p = {
    i: f,
    v: h,
    k: s,
    a: null,
    // @ts-expect-error
    e: null,
    prev: t,
    next: i
  };
  try {
    return p.e = lr(() => a(n, h, f, c), Re), p.e.prev = t && t.e, p.e.next = i && i.e, t === null ? e.first = p : (t.next = p, t.e.next = p.e), i !== null && (i.prev = p, i.e.prev = p.e), p;
  } finally {
  }
}
function Kf(n, e, t) {
  for (var i = n.next ? (
    /** @type {TemplateNode} */
    n.next.e.nodes_start
  ) : t, r = e ? (
    /** @type {TemplateNode} */
    e.e.nodes_start
  ) : t, s = (
    /** @type {TemplateNode} */
    n.e.nodes_start
  ); s !== i; ) {
    var o = (
      /** @type {TemplateNode} */
      kp(s)
    );
    r.before(s), s = o;
  }
}
function si(n, e, t) {
  e === null ? n.first = t : (e.next = t, e.e.next = t && t.e), t !== null && (t.prev = e, t.e.prev = e && e.e);
}
function Kt(n, e, t, i, r) {
  var s = n, o = "", a;
  ya(() => {
    if (o === (o = e() ?? "")) {
      Re && Ni();
      return;
    }
    a !== void 0 && (Qc(a), a = void 0), o !== "" && (a = lr(() => {
      if (Re) {
        pn.data;
        for (var l = Ni(), c = l; l !== null && (l.nodeType !== 8 || /** @type {Comment} */
        l.data !== ""); )
          c = l, l = /** @type {TemplateNode} */
          kp(l);
        if (l === null)
          throw rb(), sb;
        oc(pn, c), s = Ci(l);
        return;
      }
      var u = o + "", d = ib(u);
      oc(
        /** @type {TemplateNode} */
        eu(d),
        /** @type {TemplateNode} */
        d.lastChild
      ), s.before(d);
    }));
  });
}
function ar(n, e, t, i, r) {
  Re && Ni();
  var s = e.$$slots?.[t], o = !1;
  s === !0 && (s = e[t === "default" ? "children" : t], o = !0), s === void 0 || s(n, o ? () => i : i);
}
function PC(n) {
  const e = {};
  n.children && (e.default = !0);
  for (const t in n.$$slots)
    e[t] = !0;
  return e;
}
function kr(n, e, t, i, r, s) {
  let o = Re;
  Re && Ni();
  var a, l, c = null;
  Re && pn.nodeType === 1 && (c = /** @type {Element} */
  pn, Ni());
  var u = (
    /** @type {TemplateNode} */
    Re ? pn : n
  ), d;
  ya(() => {
    const h = e() || null;
    var f = h === "svg" ? ob : null;
    h !== a && (d && (h === null ? wo(d, () => {
      d = null, l = null;
    }) : h === l ? cs(d) : (Qc(d), yd(!1))), h && h !== l && (d = lr(() => {
      if (c = Re ? (
        /** @type {Element} */
        c
      ) : f ? document.createElementNS(f, h) : document.createElement(h), oc(c, c), i) {
        Re && ab(h) && c.append(document.createComment(""));
        var p = (
          /** @type {TemplateNode} */
          Re ? eu(c) : c.appendChild(vp())
        );
        Re && (p === null ? Wn(!1) : Ci(p)), i(c, p);
      }
      us.nodes_end = c, u.before(c);
    })), a = h, a && (l = a), yd(!0));
  }, Xc), o && (Wn(!0), Ci(u));
}
function Ye(n, e, t) {
  xa(() => {
    var i = br(() => e(n, t?.()) || {});
    if (t && i?.update) {
      var r = !1, s = (
        /** @type {any} */
        {}
      );
      nu(() => {
        var o = t();
        wa(o), r && lb(s, o) && (s = o, i.update(o));
      }), r = !0;
    }
    if (i?.destroy)
      return () => (
        /** @type {Function} */
        i.destroy()
      );
  });
}
function W_(n) {
  var e, t, i = "";
  if (typeof n == "string" || typeof n == "number") i += n;
  else if (typeof n == "object") if (Array.isArray(n)) {
    var r = n.length;
    for (e = 0; e < r; e++) n[e] && (t = W_(n[e])) && (i && (i += " "), i += t);
  } else for (t in n) n[t] && (i && (i += " "), i += t);
  return i;
}
function DC() {
  for (var n, e, t = 0, i = "", r = arguments.length; t < r; t++) (n = arguments[t]) && (e = W_(n)) && (i && (i += " "), i += e);
  return i;
}
function U_(n) {
  return typeof n == "object" ? DC(n) : n ?? "";
}
const qf = [...` 	
\r\f \v\uFEFF`];
function $C(n, e, t) {
  var i = n == null ? "" : "" + n;
  if (e && (i = i ? i + " " + e : e), t) {
    for (var r in t)
      if (t[r])
        i = i ? i + " " + r : r;
      else if (i.length)
        for (var s = r.length, o = 0; (o = i.indexOf(r, o)) >= 0; ) {
          var a = o + s;
          (o === 0 || qf.includes(i[o - 1])) && (a === i.length || qf.includes(i[a])) ? i = (o === 0 ? "" : i.substring(0, o)) + i.substring(a + 1) : o = a;
        }
  }
  return i === "" ? null : i;
}
function Gf(n, e = !1) {
  var t = e ? " !important;" : ";", i = "";
  for (var r in n) {
    var s = n[r];
    s != null && s !== "" && (i += " " + r + ": " + s + t);
  }
  return i;
}
function Jl(n) {
  return n[0] !== "-" || n[1] !== "-" ? n.toLowerCase() : n;
}
function zC(n, e) {
  if (e) {
    var t = "", i, r;
    if (Array.isArray(e) ? (i = e[0], r = e[1]) : i = e, n) {
      n = String(n).replaceAll(/\s*\/\*.*?\*\/\s*/g, "").trim();
      var s = !1, o = 0, a = !1, l = [];
      i && l.push(...Object.keys(i).map(Jl)), r && l.push(...Object.keys(r).map(Jl));
      var c = 0, u = -1;
      const _ = n.length;
      for (var d = 0; d < _; d++) {
        var h = n[d];
        if (a ? h === "/" && n[d - 1] === "*" && (a = !1) : s ? s === h && (s = !1) : h === "/" && n[d + 1] === "*" ? a = !0 : h === '"' || h === "'" ? s = h : h === "(" ? o++ : h === ")" && o--, !a && s === !1 && o === 0) {
          if (h === ":" && u === -1)
            u = d;
          else if (h === ";" || d === _ - 1) {
            if (u !== -1) {
              var f = Jl(n.substring(c, u).trim());
              if (!l.includes(f)) {
                h !== ";" && d++;
                var p = n.substring(c, d).trim();
                t += " " + p + ";";
              }
            }
            c = d + 1, u = -1;
          }
        }
      }
    }
    return i && (t += Gf(i)), r && (t += Gf(r, !0)), t = t.trim(), t === "" ? null : t;
  }
  return n == null ? null : String(n);
}
function ht(n, e, t, i, r, s) {
  var o = n.__className;
  if (Re || o !== t || o === void 0) {
    var a = $C(t, i, s);
    (!Re || a !== n.getAttribute("class")) && (a == null ? n.removeAttribute("class") : e ? n.className = a : n.setAttribute("class", a)), n.__className = t;
  } else if (s && r !== s)
    for (var l in s) {
      var c = !!s[l];
      (r == null || c !== !!r[l]) && n.classList.toggle(l, c);
    }
  return s;
}
function Xl(n, e = {}, t, i) {
  for (var r in t) {
    var s = t[r];
    e[r] !== s && (t[r] == null ? n.style.removeProperty(r) : n.style.setProperty(r, s, i));
  }
}
function ks(n, e, t, i) {
  var r = n.__style;
  if (Re || r !== e) {
    var s = zC(e, i);
    (!Re || s !== n.getAttribute("style")) && (s == null ? n.removeAttribute("style") : n.style.cssText = s), n.__style = e;
  } else i && (Array.isArray(i) ? (Xl(n, t?.[0], i[0]), Xl(n, t?.[1], i[1], "important")) : Xl(n, t, i));
  return i;
}
const Pr = Symbol("class"), Dr = Symbol("style"), K_ = Symbol("is custom element"), q_ = Symbol("is html");
function dt(n) {
  if (Re) {
    var e = !1, t = () => {
      if (!e) {
        if (e = !0, n.hasAttribute("value")) {
          var i = n.value;
          Ce(n, "value", null), n.value = i;
        }
        if (n.hasAttribute("checked")) {
          var r = n.checked;
          Ce(n, "checked", null), n.checked = r;
        }
      }
    };
    n.__on_r = t, fb(t), pb();
  }
}
function Jf(n, e) {
  var t = ad(n);
  t.checked !== (t.checked = // treat null and undefined the same for the initial value
  e ?? void 0) && (n.checked = e);
}
function HC(n, e) {
  e ? n.hasAttribute("selected") || n.setAttribute("selected", "") : n.removeAttribute("selected");
}
function Ce(n, e, t, i) {
  var r = ad(n);
  Re && (r[e] = n.getAttribute(e), e === "src" || e === "srcset" || e === "href" && n.nodeName === "LINK") || r[e] !== (r[e] = t) && (e === "loading" && (n[cb] = t), t == null ? n.removeAttribute(e) : typeof t != "string" && J_(n).includes(e) ? n[e] = t : n.setAttribute(e, t));
}
function G_(n, e, t, i, r = !1) {
  var s = ad(n), o = s[K_], a = !s[q_];
  let l = Re && o;
  l && Wn(!1);
  var c = e || {}, u = n.tagName === "OPTION";
  for (var d in e)
    d in t || (t[d] = null);
  t.class ? t.class = U_(t.class) : t[Pr] && (t.class = null), t[Dr] && (t.style ??= null);
  var h = J_(n);
  for (const x in t) {
    let k = t[x];
    if (u && x === "value" && k == null) {
      n.value = n.__value = "", c[x] = k;
      continue;
    }
    if (x === "class") {
      var f = n.namespaceURI === "http://www.w3.org/1999/xhtml";
      ht(n, f, k, i, e?.[Pr], t[Pr]), c[x] = k, c[Pr] = t[Pr];
      continue;
    }
    if (x === "style") {
      ks(n, k, e?.[Dr], t[Dr]), c[x] = k, c[Dr] = t[Dr];
      continue;
    }
    var p = c[x];
    if (k !== p) {
      c[x] = k;
      var _ = x[0] + x[1];
      if (_ !== "$$")
        if (_ === "on") {
          const E = {}, S = "$$" + x;
          let w = x.slice(2);
          var m = vb(w);
          if (mb(w) && (w = w.slice(0, -7), E.capture = !0), !m && p) {
            if (k != null) continue;
            n.removeEventListener(w, c[S], E), c[S] = null;
          }
          if (k != null)
            if (m)
              n[`__${w}`] = k, Lt([w]);
            else {
              let v = function(A) {
                c[x].call(this, A);
              };
              c[S] = gb(w, n, v, E);
            }
          else m && (n[`__${w}`] = void 0);
        } else if (x === "style")
          Ce(n, x, k);
        else if (x === "autofocus")
          _b(
            /** @type {HTMLElement} */
            n,
            !!k
          );
        else if (!o && (x === "__value" || x === "value" && k != null))
          n.value = n.__value = k;
        else if (x === "selected" && u)
          HC(
            /** @type {HTMLOptionElement} */
            n,
            k
          );
        else {
          var g = x;
          a || (g = bb(g));
          var y = g === "defaultValue" || g === "defaultChecked";
          if (k == null && !o && !y)
            if (s[x] = null, g === "value" || g === "checked") {
              let E = (
                /** @type {HTMLInputElement} */
                n
              );
              const S = e === void 0;
              if (g === "value") {
                let w = E.defaultValue;
                E.removeAttribute(g), E.defaultValue = w, E.value = E.__value = S ? w : null;
              } else {
                let w = E.defaultChecked;
                E.removeAttribute(g), E.defaultChecked = w, E.checked = S ? w : !1;
              }
            } else
              n.removeAttribute(x);
          else y || h.includes(g) && (o || typeof k != "string") ? n[g] = k : typeof k != "function" && Ce(n, g, k);
        }
    }
  }
  return l && Wn(!0), c;
}
function ad(n) {
  return (
    /** @type {Record<string | symbol, unknown>} **/
    // @ts-expect-error
    n.__attributes ??= {
      [K_]: n.nodeName.includes("-"),
      [q_]: n.namespaceURI === ub
    }
  );
}
var Xf = /* @__PURE__ */ new Map();
function J_(n) {
  var e = Xf.get(n.nodeName);
  if (e) return e;
  Xf.set(n.nodeName, e = []);
  for (var t, i = n, r = Element.prototype; r !== i; ) {
    t = hb(i);
    for (var s in t)
      t[s].set && e.push(s);
    i = db(i);
  }
  return e;
}
const BC = () => performance.now(), Vn = {
  // don't access requestAnimationFrame eagerly outside method
  // this allows basic testing of user code without JSDOM
  // bunder will eval and remove ternary when the user's app is built
  tick: (
    /** @param {any} _ */
    (n) => requestAnimationFrame(n)
  ),
  now: () => BC(),
  tasks: /* @__PURE__ */ new Set()
};
function X_() {
  const n = Vn.now();
  Vn.tasks.forEach((e) => {
    e.c(n) || (Vn.tasks.delete(e), e.f());
  }), Vn.tasks.size !== 0 && Vn.tick(X_);
}
function FC(n) {
  let e;
  return Vn.tasks.size === 0 && Vn.tick(X_), {
    promise: new Promise((t) => {
      Vn.tasks.add(e = { c: n, f: t });
    }),
    abort() {
      Vn.tasks.delete(e);
    }
  };
}
function lo(n, e) {
  Cb(() => {
    n.dispatchEvent(new CustomEvent(e));
  });
}
function VC(n) {
  if (n === "float") return "cssFloat";
  if (n === "offset") return "cssOffset";
  if (n.startsWith("--")) return n;
  const e = n.split("-");
  return e.length === 1 ? e[0] : e[0] + e.slice(1).map(
    /** @param {any} word */
    (t) => t[0].toUpperCase() + t.slice(1)
  ).join("");
}
function Yf(n) {
  const e = {}, t = n.split(";");
  for (const i of t) {
    const [r, s] = i.split(":");
    if (!r || s === void 0) break;
    const o = VC(r.trim());
    e[o] = s.trim();
  }
  return e;
}
const jC = (n) => n;
function co(n, e, t, i) {
  var r = (n & Sb) !== 0, s = (n & Eb) !== 0, o = r && s, a = (n & kb) !== 0, l = o ? "both" : r ? "in" : "out", c, u = e.inert, d = e.style.overflow, h, f;
  function p() {
    var x = Ab, k = us;
    xd(null), wd(null);
    try {
      return c ??= t()(e, i?.() ?? /** @type {P} */
      {}, {
        direction: l
      });
    } finally {
      xd(x), wd(k);
    }
  }
  var _ = {
    is_global: a,
    in() {
      if (e.inert = u, !r) {
        f?.abort(), f?.reset?.();
        return;
      }
      s || h?.abort(), lo(e, "introstart"), h = Kc(e, p(), f, 1, () => {
        lo(e, "introend"), h?.abort(), h = c = void 0, e.style.overflow = d;
      });
    },
    out(x) {
      if (!s) {
        x?.(), c = void 0;
        return;
      }
      e.inert = !0, lo(e, "outrostart"), f = Kc(e, p(), h, 0, () => {
        lo(e, "outroend"), x?.();
      });
    },
    stop: () => {
      h?.abort(), f?.abort();
    }
  }, m = (
    /** @type {Effect} */
    us
  );
  if ((m.transitions ??= []).push(_), r && yb) {
    var g = a;
    if (!g) {
      for (var y = (
        /** @type {Effect | null} */
        m.parent
      ); y && (y.f & Xc) !== 0; )
        for (; (y = y.parent) && (y.f & xb) === 0; )
          ;
      g = !y || (y.f & wb) !== 0;
    }
    g && xa(() => {
      br(() => _.in());
    });
  }
}
function Kc(n, e, t, i, r) {
  var s = i === 1;
  if (Tb(e)) {
    var o, a = !1;
    return xp(() => {
      if (!a) {
        var m = e({ direction: s ? "in" : "out" });
        o = Kc(n, m, t, i, r);
      }
    }), {
      abort: () => {
        a = !0, o?.abort();
      },
      deactivate: () => o.deactivate(),
      reset: () => o.reset(),
      t: () => o.t()
    };
  }
  if (t?.deactivate(), !e?.duration)
    return r(), {
      abort: Mr,
      deactivate: Mr,
      reset: Mr,
      t: () => i
    };
  const { delay: l = 0, css: c, tick: u, easing: d = jC } = e;
  var h = [];
  if (s && t === void 0 && (u && u(0, 1), c)) {
    var f = Yf(c(0, 1));
    h.push(f, f);
  }
  var p = () => 1 - i, _ = n.animate(h, { duration: l });
  return _.onfinish = () => {
    var m = t?.t() ?? 1 - i;
    t?.abort();
    var g = i - m, y = (
      /** @type {number} */
      e.duration * Math.abs(g)
    ), x = [];
    if (y > 0) {
      var k = !1;
      if (c)
        for (var E = Math.ceil(y / 16.666666666666668), S = 0; S <= E; S += 1) {
          var w = m + g * d(S / E), v = Yf(c(w, 1 - w));
          x.push(v), k ||= v.overflow === "hidden";
        }
      k && (n.style.overflow = "hidden"), p = () => {
        var A = (
          /** @type {number} */
          /** @type {globalThis.Animation} */
          _.currentTime
        );
        return m + g * d(A / y);
      }, u && FC(() => {
        if (_.playState !== "running") return !1;
        var A = p();
        return u(A, 1 - A), !0;
      });
    }
    _ = n.animate(x, { duration: y, fill: "forwards" }), _.onfinish = () => {
      p = () => i, u?.(i, 1 - i), r();
    };
  }, {
    abort: () => {
      _ && (_.cancel(), _.effect = null, _.onfinish = Mr);
    },
    deactivate: () => {
      r = Mr;
    },
    reset: () => {
      i === 0 && u?.(1, 0);
    },
    t: () => p()
  };
}
function St(n, e, t = e) {
  var i = Mb();
  iu(n, "input", (r) => {
    var s = r ? n.defaultValue : n.value;
    if (s = Yl(n) ? Zl(s) : s, t(s), i && s !== (s = e())) {
      var o = n.selectionStart, a = n.selectionEnd;
      n.value = s ?? "", a !== null && (n.selectionStart = o, n.selectionEnd = Math.min(a, n.value.length));
    }
  }), // If we are hydrating and the value has since changed,
  // then use the updated value from the input instead.
  (Re && n.defaultValue !== n.value || // If defaultValue is set, then value == defaultValue
  // TODO Svelte 6: remove input.value check and set to empty string?
  br(e) == null && n.value) && t(Yl(n) ? Zl(n.value) : n.value), nu(() => {
    var r = e();
    Yl(n) && r === Zl(n.value) || n.type === "date" && !r && !n.value || r !== n.value && (n.value = r ?? "");
  });
}
function Zf(n, e, t = e) {
  iu(n, "change", (i) => {
    var r = i ? n.defaultChecked : n.checked;
    t(r);
  }), // If we are hydrating and the value has since changed,
  // then use the update value from the input instead.
  (Re && n.defaultChecked !== n.checked || // If defaultChecked is set, then checked == defaultChecked
  br(e) == null) && t(n.checked), nu(() => {
    var i = e();
    n.checked = !!i;
  });
}
function Yl(n) {
  var e = n.type;
  return e === "number" || e === "range";
}
function Zl(n) {
  return n === "" ? null : +n;
}
function Y_(n, e, t) {
  if (n.multiple)
    return UC(n, e);
  for (var i of n.options) {
    var r = ls(i);
    if (Ob(r, e)) {
      i.selected = !0;
      return;
    }
  }
  (!t || e !== void 0) && (n.selectedIndex = -1);
}
function WC(n, e) {
  xa(() => {
    var t = new MutationObserver(() => {
      var i = n.__value;
      Y_(n, i);
    });
    return t.observe(n, {
      // Listen to option element changes
      childList: !0,
      subtree: !0,
      // because of <optgroup>
      // Listen to option element value attribute changes
      // (doesn't get notified of select value changes,
      // because that property is not reflected as an attribute)
      attributes: !0,
      attributeFilter: ["value"]
    }), () => {
      t.disconnect();
    };
  });
}
function er(n, e, t = e) {
  var i = !0;
  iu(n, "change", (r) => {
    var s = r ? "[selected]" : ":checked", o;
    if (n.multiple)
      o = [].map.call(n.querySelectorAll(s), ls);
    else {
      var a = n.querySelector(s) ?? // will fall back to first non-disabled option if no option is selected
      n.querySelector("option:not([disabled])");
      o = a && ls(a);
    }
    t(o);
  }), xa(() => {
    var r = e();
    if (Y_(n, r, i), i && r === void 0) {
      var s = n.querySelector(":checked");
      s !== null && (r = ls(s), t(r));
    }
    n.__value = r, i = !1;
  }), WC(n);
}
function UC(n, e) {
  for (var t of n.options)
    t.selected = ~e.indexOf(ls(t));
}
function ls(n) {
  return "__value" in n ? n.__value : n.value;
}
function uo(n) {
  return function(...e) {
    var t = (
      /** @type {Event} */
      e[0]
    );
    return t.preventDefault(), n?.apply(this, e);
  };
}
function Ja(n = !1) {
  const e = (
    /** @type {ComponentContextLegacy} */
    Gr
  ), t = e.l.u;
  if (!t) return;
  let i = () => wa(e.s);
  if (n) {
    let r = 0, s = (
      /** @type {Record<string, any>} */
      {}
    );
    const o = Rb(() => {
      let a = !1;
      const l = e.s;
      for (const c in l)
        l[c] !== s[c] && (s[c] = l[c], a = !0);
      return a && r++, r;
    });
    i = () => T(o);
  }
  t.b.length && Nb(() => {
    Qf(e, i), kd(t.b);
  }), Ae(() => {
    const r = br(() => t.m.map(Lb));
    return () => {
      for (const s of r)
        typeof s == "function" && s();
    };
  }), t.a.length && Ae(() => {
    Qf(e, i), kd(t.a);
  });
}
function Qf(n, e) {
  if (n.l.s)
    for (const t of n.l.s) T(t);
  e();
}
function va(n, e) {
  var t = (
    /** @type {Record<string, Function[] | Function>} */
    n.$$events?.[e.type]
  ), i = tu(t) ? t.slice() : t == null ? [] : [t];
  for (var r of i)
    r.call(this, e);
}
function Z_(n) {
  Gr === null && Sp(), Ib && Gr.l !== null ? GC(Gr).m.push(n) : Ae(() => {
    const e = br(n);
    if (typeof e == "function") return (
      /** @type {() => void} */
      e
    );
  });
}
function KC(n, e, { bubbles: t = !1, cancelable: i = !1 } = {}) {
  return new CustomEvent(n, { detail: e, bubbles: t, cancelable: i });
}
function qC() {
  const n = Gr;
  return n === null && Sp(), (e, t, i) => {
    const r = (
      /** @type {Record<string, Function | Function[]>} */
      n.s.$$events?.[
        /** @type {any} */
        e
      ]
    );
    if (r) {
      const s = tu(r) ? r.slice() : [r], o = KC(
        /** @type {string} */
        e,
        t,
        i
      );
      for (const a of s)
        a.call(n.x, o);
      return !o.defaultPrevented;
    }
    return !0;
  };
}
function GC(n) {
  var e = (
    /** @type {ComponentContextLegacy} */
    n.l
  );
  return e.u ??= { a: [], b: [], m: [] };
}
const Q_ = (n, e) => {
  let t;
  return (...i) => {
    clearTimeout(t), t = setTimeout(() => n(...i), e);
  };
};
var qr = { exports: {} };
var JC = qr.exports, ep;
function XC() {
  return ep || (ep = 1, function(n, e) {
    (function() {
      var t = {
        function: !0,
        object: !0
      }, i = t[typeof window] && window || this, r = e, s = n && !n.nodeType && n, o = r && s && typeof Fh == "object" && Fh;
      o && (o.global === o || o.window === o || o.self === o) && (i = o);
      var a = Math.pow(2, 53) - 1, l = /\bOpera/, c = Object.prototype, u = c.hasOwnProperty, d = c.toString;
      function h(v) {
        return v = String(v), v.charAt(0).toUpperCase() + v.slice(1);
      }
      function f(v, A, b) {
        var C = {
          "10.0": "10",
          "6.4": "10 Technical Preview",
          "6.3": "8.1",
          "6.2": "8",
          "6.1": "Server 2008 R2 / 7",
          "6.0": "Server 2008 / Vista",
          "5.2": "Server 2003 / XP 64-bit",
          "5.1": "XP",
          "5.01": "2000 SP1",
          "5.0": "2000",
          "4.0": "NT",
          "4.90": "ME"
        };
        return A && b && /^Win/i.test(v) && !/^Windows Phone /i.test(v) && (C = C[/[\d.]+$/.exec(v)]) && (v = "Windows " + C), v = String(v), A && b && (v = v.replace(RegExp(A, "i"), b)), v = _(
          v.replace(/ ce$/i, " CE").replace(/\bhpw/i, "web").replace(/\bMacintosh\b/, "Mac OS").replace(/_PowerPC\b/i, " OS").replace(/\b(OS X) [^ \d]+/i, "$1").replace(/\bMac (OS X)\b/, "$1").replace(/\/(\d)/, " $1").replace(/_/g, ".").replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, "").replace(/\bx86\.64\b/gi, "x86_64").replace(/\b(Windows Phone) OS\b/, "$1").replace(/\b(Chrome OS \w+) [\d.]+\b/, "$1").split(" on ")[0]
        ), v;
      }
      function p(v, A) {
        var b = -1, C = v ? v.length : 0;
        if (typeof C == "number" && C > -1 && C <= a)
          for (; ++b < C; )
            A(v[b], b, v);
        else
          m(v, A);
      }
      function _(v) {
        return v = E(v), /^(?:webOS|i(?:OS|P))/.test(v) ? v : h(v);
      }
      function m(v, A) {
        for (var b in v)
          u.call(v, b) && A(v[b], b, v);
      }
      function g(v) {
        return v == null ? h(v) : d.call(v).slice(8, -1);
      }
      function y(v, A) {
        var b = v != null ? typeof v[A] : "number";
        return !/^(?:boolean|number|string|undefined)$/.test(b) && (b == "object" ? !!v[A] : !0);
      }
      function x(v) {
        return String(v).replace(/([ -])(?!$)/g, "$1?");
      }
      function k(v, A) {
        var b = null;
        return p(v, function(C, M) {
          b = A(b, C, M, v);
        }), b;
      }
      function E(v) {
        return String(v).replace(/^ +| +$/g, "");
      }
      function S(v) {
        var A = i, b = v && typeof v == "object" && g(v) != "String";
        b && (A = v, v = null);
        var C = A.navigator || {}, M = C.userAgent || "";
        v || (v = M);
        var z = b ? !!C.likeChrome : /\bChrome\b/.test(v) && !/internal|\n/i.test(d.toString()), D = "Object", H = b ? D : "ScriptBridgingProxyObject", q = b ? D : "Environment", G = b && A.java ? "JavaPackage" : g(A.java), ae = b ? D : "RuntimeObject", Y = /\bJava/.test(G) && A.java, le = Y && g(A.environment) == q, de = Y ? "a" : "α", ot = Y ? "b" : "β", ye = A.document || {}, Qe = A.operamini || A.opera, we = l.test(we = b && Qe ? Qe["[[Class]]"] : g(Qe)) ? we : Qe = null, R, ft = v, me = [], vt = null, at = v == M, te = at && Qe && typeof Qe.version == "function" && Qe.version(), yt, ge = Pe([
          { label: "EdgeHTML", pattern: "Edge" },
          "Trident",
          { label: "WebKit", pattern: "AppleWebKit" },
          "iCab",
          "Presto",
          "NetFront",
          "Tasman",
          "KHTML",
          "Gecko"
        ]), P = Ue([
          "Adobe AIR",
          "Arora",
          "Avant Browser",
          "Breach",
          "Camino",
          "Electron",
          "Epiphany",
          "Fennec",
          "Flock",
          "Galeon",
          "GreenBrowser",
          "iCab",
          "Iceweasel",
          "K-Meleon",
          "Konqueror",
          "Lunascape",
          "Maxthon",
          { label: "Microsoft Edge", pattern: "(?:Edge|Edg|EdgA|EdgiOS)" },
          "Midori",
          "Nook Browser",
          "PaleMoon",
          "PhantomJS",
          "Raven",
          "Rekonq",
          "RockMelt",
          { label: "Samsung Internet", pattern: "SamsungBrowser" },
          "SeaMonkey",
          { label: "Silk", pattern: "(?:Cloud9|Silk-Accelerated)" },
          "Sleipnir",
          "SlimBrowser",
          { label: "SRWare Iron", pattern: "Iron" },
          "Sunrise",
          "Swiftfox",
          "Vivaldi",
          "Waterfox",
          "WebPositive",
          { label: "Yandex Browser", pattern: "YaBrowser" },
          { label: "UC Browser", pattern: "UCBrowser" },
          "Opera Mini",
          { label: "Opera Mini", pattern: "OPiOS" },
          "Opera",
          { label: "Opera", pattern: "OPR" },
          "Chromium",
          "Chrome",
          { label: "Chrome", pattern: "(?:HeadlessChrome)" },
          { label: "Chrome Mobile", pattern: "(?:CriOS|CrMo)" },
          { label: "Firefox", pattern: "(?:Firefox|Minefield)" },
          { label: "Firefox for iOS", pattern: "FxiOS" },
          { label: "IE", pattern: "IEMobile" },
          { label: "IE", pattern: "MSIE" },
          "Safari"
        ]), Z = Zt([
          { label: "BlackBerry", pattern: "BB10" },
          "BlackBerry",
          { label: "Galaxy S", pattern: "GT-I9000" },
          { label: "Galaxy S2", pattern: "GT-I9100" },
          { label: "Galaxy S3", pattern: "GT-I9300" },
          { label: "Galaxy S4", pattern: "GT-I9500" },
          { label: "Galaxy S5", pattern: "SM-G900" },
          { label: "Galaxy S6", pattern: "SM-G920" },
          { label: "Galaxy S6 Edge", pattern: "SM-G925" },
          { label: "Galaxy S7", pattern: "SM-G930" },
          { label: "Galaxy S7 Edge", pattern: "SM-G935" },
          "Google TV",
          "Lumia",
          "iPad",
          "iPod",
          "iPhone",
          "Kindle",
          { label: "Kindle Fire", pattern: "(?:Cloud9|Silk-Accelerated)" },
          "Nexus",
          "Nook",
          "PlayBook",
          "PlayStation Vita",
          "PlayStation",
          "TouchPad",
          "Transformer",
          { label: "Wii U", pattern: "WiiU" },
          "Wii",
          "Xbox One",
          { label: "Xbox 360", pattern: "Xbox" },
          "Xoom"
        ]), he = et({
          Apple: { iPad: 1, iPhone: 1, iPod: 1 },
          Alcatel: {},
          Archos: {},
          Amazon: { Kindle: 1, "Kindle Fire": 1 },
          Asus: { Transformer: 1 },
          "Barnes & Noble": { Nook: 1 },
          BlackBerry: { PlayBook: 1 },
          Google: { "Google TV": 1, Nexus: 1 },
          HP: { TouchPad: 1 },
          HTC: {},
          Huawei: {},
          Lenovo: {},
          LG: {},
          Microsoft: { Xbox: 1, "Xbox One": 1 },
          Motorola: { Xoom: 1 },
          Nintendo: { "Wii U": 1, Wii: 1 },
          Nokia: { Lumia: 1 },
          Oppo: {},
          Samsung: { "Galaxy S": 1, "Galaxy S2": 1, "Galaxy S3": 1, "Galaxy S4": 1 },
          Sony: { PlayStation: 1, "PlayStation Vita": 1 },
          Xiaomi: { Mi: 1, Redmi: 1 }
        }), j = Et([
          "Windows Phone",
          "KaiOS",
          "Android",
          "CentOS",
          { label: "Chrome OS", pattern: "CrOS" },
          "Debian",
          { label: "DragonFly BSD", pattern: "DragonFly" },
          "Fedora",
          "FreeBSD",
          "Gentoo",
          "Haiku",
          "Kubuntu",
          "Linux Mint",
          "OpenBSD",
          "Red Hat",
          "SuSE",
          "Ubuntu",
          "Xubuntu",
          "Cygwin",
          "Symbian OS",
          "hpwOS",
          "webOS ",
          "webOS",
          "Tablet OS",
          "Tizen",
          "Linux",
          "Mac OS X",
          "Macintosh",
          "Mac",
          "Windows 98;",
          "Windows "
        ]);
        function Pe(Be) {
          return k(Be, function(Le, ke) {
            return Le || RegExp("\\b" + (ke.pattern || x(ke)) + "\\b", "i").exec(v) && (ke.label || ke);
          });
        }
        function et(Be) {
          return k(Be, function(Le, ke, Ct) {
            return Le || (ke[Z] || ke[/^[a-z]+(?: +[a-z]+\b)*/i.exec(Z)] || RegExp("\\b" + x(Ct) + "(?:\\b|\\w*\\d)", "i").exec(v)) && Ct;
          });
        }
        function Ue(Be) {
          return k(Be, function(Le, ke) {
            return Le || RegExp("\\b" + (ke.pattern || x(ke)) + "\\b", "i").exec(v) && (ke.label || ke);
          });
        }
        function Et(Be) {
          return k(Be, function(Le, ke) {
            var Ct = ke.pattern || x(ke);
            return !Le && (Le = RegExp("\\b" + Ct + "(?:/[\\d.]+|[ \\w.]*)", "i").exec(v)) && (Le = f(Le, Ct, ke.label || ke)), Le;
          });
        }
        function Zt(Be) {
          return k(Be, function(Le, ke) {
            var Ct = ke.pattern || x(ke);
            return !Le && (Le = RegExp("\\b" + Ct + " *\\d+[.\\w_]*", "i").exec(v) || RegExp("\\b" + Ct + " *\\w+-[\\w]*", "i").exec(v) || RegExp("\\b" + Ct + "(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)", "i").exec(v)) && ((Le = String(ke.label && !RegExp(Ct, "i").test(ke.label) ? ke.label : Le).split("/"))[1] && !/[\d.]+/.test(Le[0]) && (Le[0] += " " + Le[1]), ke = ke.label || ke, Le = _(Le[0].replace(RegExp(Ct, "i"), ke).replace(RegExp("; *(?:" + ke + "[_-])?", "i"), " ").replace(RegExp("(" + ke + ")[-_.]?(\\w)", "i"), "$1 $2"))), Le;
          });
        }
        function lt(Be) {
          return k(Be, function(Le, ke) {
            return Le || (RegExp(ke + "(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)", "i").exec(v) || 0)[1] || null;
          });
        }
        function Pt() {
          return this.description || "";
        }
        if (ge && (ge = [ge]), /\bAndroid\b/.test(j) && !Z && (R = /\bAndroid[^;]*;(.*?)(?:Build|\) AppleWebKit)\b/i.exec(v)) && (Z = E(R[1]).replace(/^[a-z]{2}-[a-z]{2};\s*/i, "") || null), he && !Z ? Z = Zt([he]) : he && Z && (Z = Z.replace(RegExp("^(" + x(he) + ")[-_.\\s]", "i"), he + " ").replace(RegExp("^(" + x(he) + ")[-_.]?(\\w)", "i"), he + " $2")), (R = /\bGoogle TV\b/.exec(Z)) && (Z = R[0]), /\bSimulator\b/i.test(v) && (Z = (Z ? Z + " " : "") + "Simulator"), P == "Opera Mini" && /\bOPiOS\b/.test(v) && me.push("running in Turbo/Uncompressed mode"), P == "IE" && /\blike iPhone OS\b/.test(v) ? (R = S(v.replace(/like iPhone OS/, "")), he = R.manufacturer, Z = R.product) : /^iP/.test(Z) ? (P || (P = "Safari"), j = "iOS" + ((R = / OS ([\d_]+)/i.exec(v)) ? " " + R[1].replace(/_/g, ".") : "")) : P == "Konqueror" && /^Linux\b/i.test(j) ? j = "Kubuntu" : he && he != "Google" && (/Chrome/.test(P) && !/\bMobile Safari\b/i.test(v) || /\bVita\b/.test(Z)) || /\bAndroid\b/.test(j) && /^Chrome/.test(P) && /\bVersion\//i.test(v) ? (P = "Android Browser", j = /\bAndroid\b/.test(j) ? j : "Android") : P == "Silk" ? (/\bMobi/i.test(v) || (j = "Android", me.unshift("desktop mode")), /Accelerated *= *true/i.test(v) && me.unshift("accelerated")) : P == "UC Browser" && /\bUCWEB\b/.test(v) ? me.push("speed mode") : P == "PaleMoon" && (R = /\bFirefox\/([\d.]+)\b/.exec(v)) ? me.push("identifying as Firefox " + R[1]) : P == "Firefox" && (R = /\b(Mobile|Tablet|TV)\b/i.exec(v)) ? (j || (j = "Firefox OS"), Z || (Z = R[1])) : !P || (R = !/\bMinefield\b/i.test(v) && /\b(?:Firefox|Safari)\b/.exec(P)) ? (P && !Z && /[\/,]|^[^(]+?\)/.test(v.slice(v.indexOf(R + "/") + 8)) && (P = null), (R = Z || he || j) && (Z || he || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(j)) && (P = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(j) ? j : R) + " Browser")) : P == "Electron" && (R = (/\bChrome\/([\d.]+)\b/.exec(v) || 0)[1]) && me.push("Chromium " + R), te || (te = lt([
          "(?:Cloud9|CriOS|CrMo|Edge|Edg|EdgA|EdgiOS|FxiOS|HeadlessChrome|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$)|UCBrowser|YaBrowser)",
          "Version",
          x(P),
          "(?:Firefox|Minefield|NetFront)"
        ])), (R = ge == "iCab" && parseFloat(te) > 3 && "WebKit" || /\bOpera\b/.test(P) && (/\bOPR\b/.test(v) ? "Blink" : "Presto") || /\b(?:Midori|Nook|Safari)\b/i.test(v) && !/^(?:Trident|EdgeHTML)$/.test(ge) && "WebKit" || !ge && /\bMSIE\b/i.test(v) && (j == "Mac OS" ? "Tasman" : "Trident") || ge == "WebKit" && /\bPlayStation\b(?! Vita\b)/i.test(P) && "NetFront") && (ge = [R]), P == "IE" && (R = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(v) || 0)[1]) ? (P += " Mobile", j = "Windows Phone " + (/\+$/.test(R) ? R : R + ".x"), me.unshift("desktop mode")) : /\bWPDesktop\b/i.test(v) ? (P = "IE Mobile", j = "Windows Phone 8.x", me.unshift("desktop mode"), te || (te = (/\brv:([\d.]+)/.exec(v) || 0)[1])) : P != "IE" && ge == "Trident" && (R = /\brv:([\d.]+)/.exec(v)) && (P && me.push("identifying as " + P + (te ? " " + te : "")), P = "IE", te = R[1]), at) {
          if (y(A, "global"))
            if (Y && (R = Y.lang.System, ft = R.getProperty("os.arch"), j = j || R.getProperty("os.name") + " " + R.getProperty("os.version")), le) {
              try {
                te = A.require("ringo/engine").version.join("."), P = "RingoJS";
              } catch {
                (R = A.system) && R.global.system == A.system && (P = "Narwhal", j || (j = R[0].os || null));
              }
              P || (P = "Rhino");
            } else typeof A.process == "object" && !A.process.browser && (R = A.process) && (typeof R.versions == "object" && (typeof R.versions.electron == "string" ? (me.push("Node " + R.versions.node), P = "Electron", te = R.versions.electron) : typeof R.versions.nw == "string" && (me.push("Chromium " + te, "Node " + R.versions.node), P = "NW.js", te = R.versions.nw)), P || (P = "Node.js", ft = R.arch, j = R.platform, te = /[\d.]+/.exec(R.version), te = te ? te[0] : null));
          else g(R = A.runtime) == H ? (P = "Adobe AIR", j = R.flash.system.Capabilities.os) : g(R = A.phantom) == ae ? (P = "PhantomJS", te = (R = R.version || null) && R.major + "." + R.minor + "." + R.patch) : typeof ye.documentMode == "number" && (R = /\bTrident\/(\d+)/i.exec(v)) ? (te = [te, ye.documentMode], (R = +R[1] + 4) != te[1] && (me.push("IE " + te[1] + " mode"), ge && (ge[1] = ""), te[1] = R), te = P == "IE" ? String(te[1].toFixed(1)) : te[0]) : typeof ye.documentMode == "number" && /^(?:Chrome|Firefox)\b/.test(P) && (me.push("masking as " + P + " " + te), P = "IE", te = "11.0", ge = ["Trident"], j = "Windows");
          j = j && _(j);
        }
        if (te && (R = /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(te) || /(?:alpha|beta)(?: ?\d)?/i.exec(v + ";" + (at && C.appMinorVersion)) || /\bMinefield\b/i.test(v) && "a") && (vt = /b/i.test(R) ? "beta" : "alpha", te = te.replace(RegExp(R + "\\+?$"), "") + (vt == "beta" ? ot : de) + (/\d+\+?/.exec(R) || "")), P == "Fennec" || P == "Firefox" && /\b(?:Android|Firefox OS|KaiOS)\b/.test(j))
          P = "Firefox Mobile";
        else if (P == "Maxthon" && te)
          te = te.replace(/\.[\d.]+/, ".x");
        else if (/\bXbox\b/i.test(Z))
          Z == "Xbox 360" && (j = null), Z == "Xbox 360" && /\bIEMobile\b/.test(v) && me.unshift("mobile mode");
        else if ((/^(?:Chrome|IE|Opera)$/.test(P) || P && !Z && !/Browser|Mobi/.test(P)) && (j == "Windows CE" || /Mobi/i.test(v)))
          P += " Mobile";
        else if (P == "IE" && at)
          try {
            A.external === null && me.unshift("platform preview");
          } catch {
            me.unshift("embedded");
          }
        else (/\bBlackBerry\b/.test(Z) || /\bBB10\b/.test(v)) && (R = (RegExp(Z.replace(/ +/g, " *") + "/([.\\d]+)", "i").exec(v) || 0)[1] || te) ? (R = [R, /BB10/.test(v)], j = (R[1] ? (Z = null, he = "BlackBerry") : "Device Software") + " " + R[0], te = null) : this != m && Z != "Wii" && (at && Qe || /Opera/.test(P) && /\b(?:MSIE|Firefox)\b/i.test(v) || P == "Firefox" && /\bOS X (?:\d+\.){2,}/.test(j) || P == "IE" && (j && !/^Win/.test(j) && te > 5.5 || /\bWindows XP\b/.test(j) && te > 8 || te == 8 && !/\bTrident\b/.test(v))) && !l.test(R = S.call(m, v.replace(l, "") + ";")) && R.name && (R = "ing as " + R.name + ((R = R.version) ? " " + R : ""), l.test(P) ? (/\bIE\b/.test(R) && j == "Mac OS" && (j = null), R = "identify" + R) : (R = "mask" + R, we ? P = _(we.replace(/([a-z])([A-Z])/g, "$1 $2")) : P = "Opera", /\bIE\b/.test(R) && (j = null), at || (te = null)), ge = ["Presto"], me.push(R));
        (R = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(v) || 0)[1]) && (R = [parseFloat(R.replace(/\.(\d)$/, ".0$1")), R], P == "Safari" && R[1].slice(-1) == "+" ? (P = "WebKit Nightly", vt = "alpha", te = R[1].slice(0, -1)) : (te == R[1] || te == (R[2] = (/\bSafari\/([\d.]+\+?)/i.exec(v) || 0)[1])) && (te = null), R[1] = (/\b(?:Headless)?Chrome\/([\d.]+)/i.exec(v) || 0)[1], R[0] == 537.36 && R[2] == 537.36 && parseFloat(R[1]) >= 28 && ge == "WebKit" && (ge = ["Blink"]), !at || !z && !R[1] ? (ge && (ge[1] = "like Safari"), R = (R = R[0], R < 400 ? 1 : R < 500 ? 2 : R < 526 ? 3 : R < 533 ? 4 : R < 534 ? "4+" : R < 535 ? 5 : R < 537 ? 6 : R < 538 ? 7 : R < 601 ? 8 : R < 602 ? 9 : R < 604 ? 10 : R < 606 ? 11 : R < 608 ? 12 : "12")) : (ge && (ge[1] = "like Chrome"), R = R[1] || (R = R[0], R < 530 ? 1 : R < 532 ? 2 : R < 532.05 ? 3 : R < 533 ? 4 : R < 534.03 ? 5 : R < 534.07 ? 6 : R < 534.1 ? 7 : R < 534.13 ? 8 : R < 534.16 ? 9 : R < 534.24 ? 10 : R < 534.3 ? 11 : R < 535.01 ? 12 : R < 535.02 ? "13+" : R < 535.07 ? 15 : R < 535.11 ? 16 : R < 535.19 ? 17 : R < 536.05 ? 18 : R < 536.1 ? 19 : R < 537.01 ? 20 : R < 537.11 ? "21+" : R < 537.13 ? 23 : R < 537.18 ? 24 : R < 537.24 ? 25 : R < 537.36 ? 26 : ge != "Blink" ? "27" : "28")), ge && (ge[1] += " " + (R += typeof R == "number" ? ".x" : /[.+]/.test(R) ? "" : "+")), P == "Safari" && (!te || parseInt(te) > 45) ? te = R : P == "Chrome" && /\bHeadlessChrome/i.test(v) && me.unshift("headless")), P == "Opera" && (R = /\bzbov|zvav$/.exec(j)) ? (P += " ", me.unshift("desktop mode"), R == "zvav" ? (P += "Mini", te = null) : P += "Mobile", j = j.replace(RegExp(" *" + R + "$"), "")) : P == "Safari" && /\bChrome\b/.exec(ge && ge[1]) ? (me.unshift("desktop mode"), P = "Chrome Mobile", te = null, /\bOS X\b/.test(j) ? (he = "Apple", j = "iOS 4.3+") : j = null) : /\bSRWare Iron\b/.test(P) && !te && (te = lt("Chrome")), te && te.indexOf(R = /[\d.]+$/.exec(j)) == 0 && v.indexOf("/" + R + "-") > -1 && (j = E(j.replace(R, ""))), j && j.indexOf(P) != -1 && !RegExp(P + " OS").test(j) && (j = j.replace(RegExp(" *" + x(P) + " *"), "")), ge && !/\b(?:Avant|Nook)\b/.test(P) && (/Browser|Lunascape|Maxthon/.test(P) || P != "Safari" && /^iOS/.test(j) && /\bSafari\b/.test(ge[1]) || /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|SRWare Iron|Vivaldi|Web)/.test(P) && ge[1]) && (R = ge[ge.length - 1]) && me.push(R), me.length && (me = ["(" + me.join("; ") + ")"]), he && Z && Z.indexOf(he) < 0 && me.push("on " + he), Z && me.push((/^on /.test(me[me.length - 1]) ? "" : "on ") + Z), j && (R = / ([\d.+]+)$/.exec(j), yt = R && j.charAt(j.length - R[0].length - 1) == "/", j = {
          architecture: 32,
          family: R && !yt ? j.replace(R[0], "") : j,
          version: R ? R[1] : null,
          toString: function() {
            var Be = this.version;
            return this.family + (Be && !yt ? " " + Be : "") + (this.architecture == 64 ? " 64-bit" : "");
          }
        }), (R = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(ft)) && !/\bi686\b/i.test(ft) ? (j && (j.architecture = 64, j.family = j.family.replace(RegExp(" *" + R), "")), P && (/\bWOW64\b/i.test(v) || at && /\w(?:86|32)$/.test(C.cpuClass || C.platform) && !/\bWin64; x64\b/i.test(v)) && me.unshift("32-bit")) : j && /^OS X/.test(j.family) && P == "Chrome" && parseFloat(te) >= 39 && (j.architecture = 64), v || (v = null);
        var Ie = {};
        return Ie.description = v, Ie.layout = ge && ge[0], Ie.manufacturer = he, Ie.name = P, Ie.prerelease = vt, Ie.product = Z, Ie.ua = v, Ie.version = P && te, Ie.os = j || {
          /**
           * The CPU architecture the OS is built for.
           *
           * @memberOf platform.os
           * @type number|null
           */
          architecture: null,
          /**
           * The family of the OS.
           *
           * Common values include:
           * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
           * "Windows XP", "OS X", "Linux", "Ubuntu", "Debian", "Fedora", "Red Hat",
           * "SuSE", "Android", "iOS" and "Windows Phone"
           *
           * @memberOf platform.os
           * @type string|null
           */
          family: null,
          /**
           * The version of the OS.
           *
           * @memberOf platform.os
           * @type string|null
           */
          version: null,
          /**
           * Returns the OS string.
           *
           * @memberOf platform.os
           * @returns {string} The OS string.
           */
          toString: function() {
            return "null";
          }
        }, Ie.parse = S, Ie.toString = Pt, Ie.version && me.unshift(te), Ie.name && me.unshift(P), j && P && !(j == String(j).split(" ")[0] && (j == P.split(" ")[0] || Z)) && me.push(Z ? "(" + j + ")" : "on " + j), me.length && (Ie.description = me.join(" ")), Ie;
      }
      var w = S();
      r && s ? m(w, function(v, A) {
        r[A] = v;
      }) : i.platform = w;
    }).call(JC);
  }(qr, qr.exports)), qr.exports;
}
var YC = XC();
const ZC = /* @__PURE__ */ Uk(YC), qc = {
  mac: {
    cmd: "⌘",
    alt: "⌥",
    ctrl: "⌃",
    shift: "⇧"
  },
  other: {
    cmd: "Ctrl+",
    alt: "Alt+",
    ctrl: "Ctrl+",
    shift: "Shift+"
  }
};
let tp = !1, e0 = qc.other;
const QC = (n) => {
  tp = ["OS X", "iOS"].includes(n.os?.family || ""), e0 = tp ? qc.mac : qc.other;
};
QC(ZC);
const ld = (n) => n.replace(/(ctrl|cmd|alt|shift)\+/g, (e, t) => e0[t] || t), eT = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path fill-rule="evenodd" d="M12.767 13.084l-2.211 2.211 2.233 2.233-.789.789-3-3 3-3 .767.767zm.884 4.538l2.327-2.327-2.305-2.305.673-.673 3 3-3 3-.695-.695zm-5.561-15.622h9.916c1.101 0 1.993.898 1.993 1.991v16.018c0 1.099-.895 1.991-1.994 1.991h-12.012c-1.101 0-1.994-.897-1.994-1.999v-14.044l4.09-3.957zm.599 2l-.1 2.606h-2.59v13.394h12v-16h-9.31z"/>
</svg>
`;
Pb();
var tT = X("<div></div>");
function t0(n, e) {
  be(e, !0);
  let t = Q(e, "element", 7), i = Q(e, "event", 7), r = Q(e, "onReady", 7);
  if (typeof t() == "string") {
    const a = customElements.get(t());
    if (a)
      t(new a());
    else {
      const l = t();
      t(document.createElement("div")), t().innerHTML = l;
    }
  }
  let s = ce(void 0);
  Ae(() => {
    T(s).appendChild(t()), setTimeout(() => {
      t().dispatchEvent(i()), r()(t());
    });
  });
  var o = tT();
  return We(o, (a) => U(s, a), () => T(s)), gn("mt-component-update", o, function(a) {
    va.call(this, e, a);
  }), V(n, o), ve({
    get element() {
      return t();
    },
    set element(a) {
      t(a), ee();
    },
    get event() {
      return i();
    },
    set event(a) {
      i(a), ee();
    },
    get onReady() {
      return r();
    },
    set onReady(a) {
      r(a), ee();
    }
  });
}
_e(t0, { element: {}, event: {}, onReady: {} }, [], [], !0);
var nT = X('<div class="d-flex flex-column"><!> <!> <!></div>');
function iT(n, e) {
  be(e, !1);
  let t = Q(e, "namespace", 12), i = Q(e, "detail", 12), r = nr([]), s = 0;
  window.MT.UI.Component.getAll(t()).then((_) => {
    U(r, _);
  });
  let a = [], l = nr();
  function c(_) {
    ++s === T(r).length && [...T(l).childNodes].filter((m) => m instanceof HTMLElement).forEach((m, g) => {
      m.style.order ||= m.firstElementChild?.style.order || String((g + 1) * 100);
    });
  }
  function u(_) {
    _.dispatchEvent(new CustomEvent("mt-component-init", { detail: i() })), c();
  }
  Z_(() => {
    T(l).addEventListener("mt-component-update", (_) => {
      a.forEach((m) => {
        m.dispatchEvent(new CustomEvent("mt-component-update", { detail: _.detail }));
      });
    });
  }), Ja();
  var d = nT(), h = L(d);
  ar(h, e, "prepend", {});
  var f = F(h, 2);
  ut(f, 1, () => T(r), bn, (_, m) => {
    var g = mi(), y = Me(g);
    {
      var x = (E) => {
        var S = mi(), w = Me(S);
        kr(w, () => T(m), !1, (v, A) => {
          Ye(v, (b) => u?.(b)), gn("mt-component-update", v, function(b) {
            va.call(this, e, b);
          });
        }), V(E, S);
      }, k = (E) => {
        const S = ko(() => new CustomEvent("mt-component-init", { detail: i() }));
        t0(E, {
          get element() {
            return T(m);
          },
          get event() {
            return T(S);
          },
          onReady: c,
          $$events: {
            "mt-component-update"(w) {
              va.call(this, e, w);
            }
          }
        });
      };
      it(y, (E) => {
        typeof T(m) == "string" && customElements.get(T(m)) ? E(x) : E(k, !1);
      });
    }
    V(_, g);
  });
  var p = F(f, 2);
  return ar(p, e, "append", {}), O(d), We(d, (_) => U(l, _), () => T(l)), V(n, d), ve({
    get namespace() {
      return t();
    },
    set namespace(_) {
      t(_), ee();
    },
    get detail() {
      return i();
    },
    set detail(_) {
      i(_), ee();
    }
  });
}
_e(iT, { namespace: {}, detail: {} }, ["prepend", "append"], [], !0);
const rT = (n) => n;
function sT(n) {
  const e = n - 1;
  return e * e * e + 1;
}
function np(n) {
  const e = typeof n == "string" && n.match(/^\s*(-?[\d.]+)([^\s]*)\s*$/);
  return e ? [parseFloat(e[1]), e[2] || "px"] : [
    /** @type {number} */
    n,
    "px"
  ];
}
function ip(n, { delay: e = 0, duration: t = 400, easing: i = rT } = {}) {
  const r = +getComputedStyle(n).opacity;
  return {
    delay: e,
    duration: t,
    easing: i,
    css: (s) => `opacity: ${s * r}`
  };
}
function rp(n, { delay: e = 0, duration: t = 400, easing: i = sT, x: r = 0, y: s = 0, opacity: o = 0 } = {}) {
  const a = getComputedStyle(n), l = +a.opacity, c = a.transform === "none" ? "" : a.transform, u = l * (1 - o), [d, h] = np(r), [f, p] = np(s);
  return {
    delay: e,
    duration: t,
    easing: i,
    css: (_, m) => `
			transform: ${c} translate(${(1 - _) * d}${h}, ${(1 - _) * f}${p});
			opacity: ${l - u * m}`
  };
}
function oT(n) {
  return --n * n * n * n * n + 1;
}
const n0 = Symbol();
function aT(n) {
  Db(n0, n);
}
function lT() {
  return $b(n0);
}
var cT = X('<div class="modal show svelte-1m2bluk" tabindex="-1" role="dialog" aria-modal="true"><div role="document"><div class="modal-content"><!></div></div></div> <div class="modal-backdrop show"></div>', 1);
const uT = {
  hash: "svelte-1m2bluk",
  code: ".modal.svelte-1m2bluk {display:block;}"
};
function wn(n, e) {
  be(e, !1), Ft(n, uT);
  const t = qC();
  let i = Q(e, "open", 12, !0), r = Q(e, "id", 12, void 0), s = Q(e, "size", 12, void 0), o = Q(e, "describedby", 12, ""), a = Q(e, "labelledby", 12, "");
  function l() {
    document.body.classList.add("modal-open");
  }
  function c() {
    document.body.classList.remove("modal-open");
  }
  aT({
    closeModal() {
      i(!1);
    }
  }), Ep(() => wa(i()), () => {
    i() ? l() : c();
  }), Cp(), Ja();
  var u = mi(), d = Me(u);
  {
    var h = (f) => {
      var p = cT(), _ = Me(p), m = L(_), g = L(m), y = L(g);
      ar(y, e, "default", {}), O(g), O(m), O(_);
      var x = F(_, 2);
      ne(() => {
        Ce(_, "id", r()), Ce(_, "aria-labelledby", a()), Ce(_, "aria-describedby", o()), ht(m, 1, `modal-dialog ${s() ? `modal-${s()}` : ""}`, "svelte-1m2bluk");
      }), co(1, m, () => rp, () => ({ y: -50, duration: 300 })), co(2, m, () => rp, () => ({ y: -50, duration: 300, easing: oT })), gn("introend", _, () => {
        t("open");
      }), gn("outroend", _, () => {
        setTimeout(
          () => {
            t("close");
          },
          100
        );
      }), co(3, _, () => ip), co(3, x, () => ip, () => ({ duration: 150 })), V(f, p);
    };
    it(d, (f) => {
      i() && f(h);
    });
  }
  return V(n, u), ve({
    get open() {
      return i();
    },
    set open(f) {
      i(f), ee();
    },
    get id() {
      return r();
    },
    set id(f) {
      r(f), ee();
    },
    get size() {
      return s();
    },
    set size(f) {
      s(f), ee();
    },
    get describedby() {
      return o();
    },
    set describedby(f) {
      o(f), ee();
    },
    get labelledby() {
      return a();
    },
    set labelledby(f) {
      a(f), ee();
    }
  });
}
_e(
  wn,
  {
    open: {},
    id: {},
    size: {},
    describedby: {},
    labelledby: {}
  },
  ["default"],
  [],
  !0
);
var dT = X('<div class="modal-header"><h4 class="modal-title"><!></h4> <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>'), hT = X('<div class="modal-footer"><!></div>'), fT = X('<div><!> <div class="modal-body svelte-1grmgzm"><!></div> <!></div>');
const pT = {
  hash: "svelte-1grmgzm",
  code: ".modal-body.svelte-1grmgzm {max-height:600px;}"
};
function kn(n, e) {
  const t = PC(e);
  be(e, !1), Ft(n, pT);
  let i = lT(), r = Q(e, "close", 12, () => {
    i.closeModal();
  });
  Ja();
  var s = fT(), o = L(s);
  {
    var a = (h) => {
      var f = dT(), p = L(f), _ = L(p);
      ar(_, e, "title", {}), O(p);
      var m = F(p, 2);
      O(f), gn("click", m, function(...g) {
        r()?.apply(this, g);
      }), V(h, f);
    };
    it(o, (h) => {
      t.title && h(a);
    });
  }
  var l = F(o, 2), c = L(l);
  ar(c, e, "body", {}), O(l);
  var u = F(l, 2);
  {
    var d = (h) => {
      var f = hT(), p = L(f);
      ar(p, e, "footer", {}), O(f), V(h, f);
    };
    it(u, (h) => {
      t.footer && h(d);
    });
  }
  return O(s), V(n, s), ve({
    get close() {
      return r();
    },
    set close(h) {
      r(h), ee();
    }
  });
}
_e(kn, { close: {} }, ["title", "body", "footer"], [], !0);
var mT = X('<li class="page-item" aria-hidden="true">...</li>'), gT = X('<li class="page-item active"><a href="#" class="page-link"> <span class="visually-hidden">(current)</span></a></li>'), _T = X('<li><a href="#" class="page-link"> </a></li>'), bT = X('<div class="row"><div class="col-auto mx-auto"><nav aria-label="object list"><ul class="pagination d-none d-md-flex"><li class="page-item"><a href="#"></a></li> <!> <li class="page-item"><a href="#"></a></li></ul></nav></div></div>');
function vT(n, e) {
  be(e, !1);
  let t = Q(e, "data", 12), i = nr(), r = nr(), s = nr();
  Ep(
    () => (T(i), wa(t()), T(r), T(s)),
    () => {
      U(i, t()?.totalPages ?? 0), U(r, t()?.currentPage ?? 0), U(s, []);
      let c = !1;
      for (let u = 1; u <= T(i); u++)
        u < 3 || u > T(i) - 2 || Math.abs(u - T(r)) < 2 ? (T(s).push(u), c = !1) : c || (T(s).push(0), c = !0);
    }
  ), Cp(), Ja();
  var o = mi(), a = Me(o);
  {
    var l = (c) => {
      var u = bT(), d = L(u), h = L(d), f = L(h), p = L(f), _ = L(p);
      let m;
      _.textContent = window.trans("Previous"), O(p);
      var g = F(p, 2);
      ut(g, 1, () => T(s), bn, (E, S) => {
        var w = mi(), v = Me(w);
        {
          var A = (C) => {
            var M = mT();
            V(C, M);
          }, b = (C, M) => {
            {
              var z = (H) => {
                var q = gT(), G = L(q), ae = L(G);
                Tp(), O(G), O(q), ne(() => B(ae, `${T(S) ?? ""} `)), gn("click", G, uo(function(Y) {
                  va.call(this, e, Y);
                })), V(H, q);
              }, D = (H) => {
                var q = _T();
                let G;
                var ae = L(q), Y = L(ae, !0);
                O(ae), O(q), ne(
                  (le) => {
                    G = ht(q, 1, "page-item", null, G, le), B(Y, T(S));
                  },
                  [
                    () => ({
                      "first-last": T(S) === 1 || T(S) === T(i)
                    })
                  ],
                  ko
                ), gn("click", ae, uo(() => t().setPage(T(S)))), V(H, q);
              };
              it(
                C,
                (H) => {
                  T(S) === T(r) ? H(z) : H(D, !1);
                },
                M
              );
            }
          };
          it(v, (C) => {
            T(S) === 0 ? C(A) : C(b, !1);
          });
        }
        V(E, w);
      });
      var y = F(g, 2), x = L(y);
      let k;
      x.textContent = window.trans("Next"), O(y), O(f), O(h), O(d), O(u), ne(
        (E, S) => {
          m = ht(_, 1, "page-link", null, m, E), k = ht(x, 1, "page-link", null, k, S);
        },
        [
          () => ({ disabled: T(r) <= 1 }),
          () => ({
            disabled: T(r) === T(i)
          })
        ],
        ko
      ), gn("click", _, uo(() => T(r) > 1 && t().setPage(T(r) - 1))), gn("click", x, uo(() => T(r) !== T(i) && t().setPage(T(r) + 1))), V(c, u);
    };
    it(a, (c) => {
      t() && T(i) && T(r) && c(l);
    });
  }
  return V(n, o), ve({
    get data() {
      return t();
    },
    set data(c) {
      t(c), ee();
    }
  });
}
_e(vT, { data: {} }, [], [], !0);
var yT = X('<div class="form-group mb-3"><textarea id="source_text" class="form-control" style="height: calc(100vh - 240px)"></textarea></div>'), xT = X('<button type="button" class="action primary button btn btn-primary"> </button> <button type="button" class="cancel action button mt-close-dialog btn btn-default"> </button>', 1);
function i0(n, e) {
  be(e, !0);
  let t = Q(e, "onSubmit", 7), i = Q(e, "onClose", 7), r;
  Ae(() => {
    r?.focus();
  });
  let s = ce(""), o;
  return wn(n, {
    size: "lg",
    $$events: {
      close(...a) {
        i()?.apply(this, a);
      }
    },
    children: (a, l) => {
      kn(a, {
        get close() {
          return o;
        },
        set close(c) {
          o = c;
        },
        $$slots: {
          title: (c, u) => {
            var d = vn();
            ne((h) => B(d, h), [() => I("Source Code")]), V(c, d);
          },
          body: (c, u) => {
            var d = yT(), h = L(d);
            Ap(h), We(h, (f) => r = f, () => r), O(d), ne((f) => Ce(h, "aria-label", f), [() => I("Source Code")]), St(h, () => T(s), (f) => U(s, f)), V(c, d);
          },
          footer: (c, u) => {
            var d = xT(), h = Me(d);
            h.__click = () => {
              t()(T(s)), o();
            };
            var f = L(h, !0);
            O(h);
            var p = F(h, 2);
            p.__click = o;
            var _ = L(p, !0);
            O(p), ne(
              (m, g, y, x) => {
                Ce(h, "title", m), B(f, g), Ce(p, "title", y), B(_, x);
              },
              [
                () => I("Insert (s)"),
                () => I("Insert"),
                () => I("Cancel (x)"),
                () => I("Cancel")
              ]
            ), V(c, d);
          }
        }
      });
    },
    $$slots: { default: !0 }
  }), ve({
    get onSubmit() {
      return t();
    },
    set onSubmit(a) {
      t(a), ee();
    },
    get onClose() {
      return i();
    },
    set onClose(a) {
      i(a), ee();
    }
  });
}
Lt(["click"]);
_e(i0, { onSubmit: {}, onClose: {} }, [], [], !0);
const wT = `<svg width="72" height="72" viewBox="0 0 72 72" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_57_49)">
        <path d="M47.55 54.84L42.12 49.41L55.53 36L42.12 22.59L47.55 17.16L63.68 33.29C65.18 34.79 65.18 37.22 63.68 38.72L47.55 54.85V54.84Z" fill="black"/>
        <path d="M24.45 54.84L8.32001 38.71C6.82001 37.21 6.82001 34.78 8.32001 33.28L24.45 17.15L29.88 22.58L16.47 35.99L29.88 49.4L24.45 54.83V54.84Z" fill="black"/>
    </g>
    <defs>
        <clipPath id="clip0_57_49">
            <rect width="72" height="72" fill="white"/>
        </clipPath>
    </defs>
</svg>
`;
var kT = X('<div class="form-group mb-3"><textarea id="source_text" class="form-control" style="height: calc(100vh - 240px); max-height: 568px"></textarea></div>'), ST = X('<button type="button" class="action primary button btn btn-primary"> </button> <button type="button" class="cancel action button mt-close-dialog btn btn-default"> </button>', 1);
function r0(n, e) {
  be(e, !0);
  let t = Q(e, "text", 7), i = Q(e, "onSubmit", 7), r = Q(e, "onClose", 7);
  t(e_.html(t()));
  let s;
  Ae(() => {
    s?.focus();
  });
  let o;
  return wn(n, {
    size: "lg",
    $$events: {
      close(...a) {
        r()?.apply(this, a);
      }
    },
    children: (a, l) => {
      kn(a, {
        get close() {
          return o;
        },
        set close(c) {
          o = c;
        },
        $$slots: {
          title: (c, u) => {
            var d = vn();
            ne((h) => B(d, h), [() => I("Source Code")]), V(c, d);
          },
          body: (c, u) => {
            var d = kT(), h = L(d);
            Ap(h), We(h, (f) => s = f, () => s), O(d), ne((f) => Ce(h, "aria-label", f), [() => I("Source Code")]), St(h, t), V(c, d);
          },
          footer: (c, u) => {
            var d = ST(), h = Me(d);
            h.__click = () => {
              i()(t()), o();
            };
            var f = L(h, !0);
            O(h);
            var p = F(h, 2);
            p.__click = o;
            var _ = L(p, !0);
            O(p), ne(
              (m, g, y, x) => {
                Ce(h, "title", m), B(f, g), Ce(p, "title", y), B(_, x);
              },
              [
                () => I("Save (s)"),
                () => I("Save"),
                () => I("Cancel (x)"),
                () => I("Cancel")
              ]
            ), V(c, d);
          }
        }
      });
    },
    $$slots: { default: !0 }
  }), ve({
    get text() {
      return t();
    },
    set text(a) {
      t(a), ee();
    },
    get onSubmit() {
      return i();
    },
    set onSubmit(a) {
      i(a), ee();
    },
    get onClose() {
      return r();
    },
    set onClose(a) {
      r(a), ee();
    }
  });
}
Lt(["click"]);
_e(r0, { text: {}, onSubmit: {}, onClose: {} }, [], [], !0);
const ET = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M18.045 7.95c0-1.877-1.596-3.95-4.207-3.95h-8.262c-.427 0-.576.24-.576.647v14.79c0 .406.204.563.631.563h8.484c3.111 0 4.885-2.063 4.885-4.342 0-2.306-1.446-3.943-2.96-4.27.9-.409 2.006-1.561 2.006-3.438zm-5.326-.95c.867 0 1.497.682 1.497 1.5 0 .694-.52 1.5-1.497 1.5h-4.52v-3h4.52zm-4.52 9.5v-3h5.57c.897 0 1.472.775 1.472 1.5 0 .948-.79 1.5-1.472 1.5h-5.57z"/></svg>', CT = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M12.435 16.33l.105-.38c.005-.021.557-2.182 1.147-4.438 1.015-3.879 1.263-4.66 1.318-4.779.189-.396.495-.695.936-.916.381-.19.866-.315 1.443-.373.17-.018.33-.113.447-.267.106-.14.168-.317.168-.486 0-.381-.306-.692-.682-.692h-7.733c-.376 0-.682.311-.682.692v.024c0 .341.241.628.573.682.439.072 1.042.172 1.515.399.243.116.431.257.557.418.143.182.213.393.213.642 0 .467-.135.935-.265 1.387l-.082.291c-.167.603-.412 1.519-.696 2.579-.655 2.441-1.47 5.477-1.675 6.055-.138.389-.65 1.311-2.413 1.448-.171.013-.332.092-.447.219-.117.129-.181.294-.181.47v.002c0 .381.306.692.682.692h7.735c.376 0 .682-.311.682-.692v-.005c0-.349-.257-.644-.598-.685l-.201-.024c-.679-.079-1.523-.179-1.878-.647-.165-.217-.217-.504-.163-.872.035-.249.105-.491.178-.745"/></svg>', TT = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M6 20h12v1h-12v-1zm12-7.242c0 1.907-.532 3.324-1.596 4.251-1.064.927-2.535 1.391-4.414 1.391-1.905 0-3.379-.46-4.424-1.381-1.044-.921-1.567-2.341-1.567-4.261v-8.758h3.094v8.758c0 .381.033.756.099 1.124.066.368.204.694.414.976.21.283.502.513.877.69.374.178.877.266 1.507.266 1.103 0 1.865-.247 2.286-.74.42-.493.631-1.266.631-2.318v-8.758h3.094v8.758z"/></svg>', AT = `<svg width="72" height="72" viewBox="0 0 72 72" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_57_45)">
        <path d="M64.8 37.01H51.4V36.28C51.4 32.16 52.74 30.45 55.27 30.45C57.39 30.45 58.58 31.7 58.98 33.73H63.16C62.44 29.02 59.54 26.77 55.27 26.77C50.43 26.77 47.03 29.64 47.03 36.29V37.02H42.11C43.55 36.14 44.47 34.7 44.47 32.7C44.47 28.86 41.69 27.05 36.61 27.05H29.4V37.01H23.97L20.5 27.05H16.32L12.85 37.01H7.19V40.21H11.74L8.83 48.57H13.51L14.82 44.48H22.03L23.34 48.57H27.99L25.08 40.21H29.39V48.57H37.28C42.96 48.57 45.14 45.73 45.14 42.39C45.14 41.56 45 40.84 44.76 40.2H47.04C47.33 46.17 50.63 48.85 55.25 48.85C59.87 48.85 62.4 46.73 63.11 41.89H58.96C58.49 44.07 57.43 45.17 55.25 45.17C52.92 45.17 51.6 43.59 51.41 40.21H64.79V37.01H64.8ZM33.77 30.72H36.2C39.35 30.72 40.1 31.59 40.1 33.09C40.1 34.59 39.07 35.55 36.67 35.55H33.77V30.71V30.72ZM18.42 33.22L19.64 37.01H17.21L18.43 33.22H18.42ZM20.85 40.8H15.98L16.17 40.2H20.65L20.84 40.8H20.85ZM40.79 42.05C40.79 43.89 39.54 44.89 36.92 44.89H33.77V40.21H40.14C40.58 40.65 40.8 41.25 40.8 42.05H40.79Z" fill="black"/>
    </g>
    <defs>
        <clipPath id="clip0_57_45">
            <rect width="72" height="72" fill="white"/>
        </clipPath>
    </defs>
</svg>
`, MT = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M8 11.505c0-.279.229-.505.5-.505h10.999c.276 0 .5.214.5.505v.991c0 .279-.229.505-.5.505h-10.999c-.276 0-.5-.214-.5-.505v-.991zm0 6c0-.279.229-.505.5-.505h10.999c.276 0 .5.214.5.505v.991c0 .279-.229.505-.5.505h-10.999c-.276 0-.5-.214-.5-.505v-.991zm0-12c0-.279.229-.505.5-.505h10.999c.276 0 .5.214.5.505v.991c0 .279-.229.505-.5.505h-10.999c-.276 0-.5-.214-.5-.505v-.991zm-3 1.495c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1zm0 6c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1zm0 6c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1z"/></svg>', OT = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M6 18.5h-2v-.5h2v-1h.5v2.5h-2.5v-.5h2v-.5zm-2-6.25v-.25h2v-1h.5v1.5h-2v.5h2v.5h-2.5v-1.25zm4-.745c0-.279.229-.505.5-.505h10.999c.276 0 .5.214.5.505v.991c0 .279-.229.505-.5.505h-10.999c-.276 0-.5-.214-.5-.505v-.991zm0 6c0-.279.229-.505.5-.505h10.999c.276 0 .5.214.5.505v.991c0 .279-.229.505-.5.505h-10.999c-.276 0-.5-.214-.5-.505v-.991zm0-12c0-.279.229-.505.5-.505h10.999c.276 0 .5.214.5.505v.991c0 .279-.229.505-.5.505h-10.999c-.276 0-.5-.214-.5-.505v-.991zm-3-1.005h.5v3h-.5v-3zm-1 6.5h2v.5h-2v-.5zm0 6h2v.5h-2v-.5z"/></svg>', NT = `<svg width="72" height="72" viewBox="0 0 72 72" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M63 32H9V40H63V32Z" fill="black"/>
</svg>
`, LT = `<svg width="72" height="72" viewBox="0 0 72 72" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_57_31)">
        <path d="M30.09 44.49H13.05V31.36C13.05 26.53 14.05 22.71 16.07 19.92C18.09 17.13 21.53 14.66 26.41 12.51L30.09 19.49C27.09 20.9 25.01 22.31 23.86 23.7C22.71 25.1 22.07 26.75 21.94 28.66H30.09V44.49ZM49.95 44.49H32.91V31.36C32.91 26.53 33.91 22.71 35.93 19.92C37.95 17.13 41.39 14.66 46.27 12.51L49.95 19.49C46.95 20.9 44.87 22.31 43.72 23.7C42.57 25.09 41.93 26.75 41.8 28.66H49.95V44.49Z" fill="black"/>
    </g>
    <defs>
        <clipPath id="clip0_57_31">
            <rect width="72" height="72" fill="white"/>
        </clipPath>
    </defs>
</svg>
`, RT = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path fill-rule="evenodd" d="M16.407 6.284l1.732 1c.957.552 1.284 1.775.732 2.732l-5 8.66c-.552.957-1.775 1.284-2.732.732l-1.732-1-1.5 2.598c-.276.478-.888.642-1.366.366-.478-.276-.642-.888-.366-1.366l1.5-2.598-1.732-1c-.957-.552-1.284-1.775-.732-2.732l5-8.66c.552-.957 1.775-1.284 2.732-.732l1.732 1 1.5-2.598c.276-.478.888-.642 1.366-.366.478.276.642.888.366 1.366l-1.5 2.598zm-1 1.732l-.5.866c-.276.478-.888.642-1.366.366-.478-.276-.642-.888-.366-1.366l.5-.866-1.299-.75c-.239-.138-.545-.056-.683.183l-4.5 7.794c-.138.239-.056.545.183.683l1.299.75.5-.866c.276-.478.888-.642 1.366-.366.478.276.642.888.366 1.366l-.5.866 1.299.75c.239.138.545.056.683-.183l4.5-7.794c.138-.239.056-.545-.183-.683l-1.299-.75zm-6.696-.402l-1.961 3.397c.443-.415.872-.503 1.287-.263.415.24.564.661.445 1.263l1.961-3.397c-.448.57-.921.711-1.42.423-.499-.288-.603-.762-.312-1.423zm6.928 4l-1.961 3.397c.443-.415.872-.503 1.287-.263.415.24.564.661.445 1.263l1.961-3.397c-.448.57-.921.711-1.42.423-.499-.288-.603-.762-.312-1.423zm4.464 1.634c.138.239.056.545-.183.683l-.866.5c-.239.138-.545.056-.683-.183s-.056-.545.183-.683l.866-.5c.239-.138.545-.056.683.183zm-2.866 2.964c.276 0 .5.224.5.5v1c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-1c0-.276.224-.5.5-.5zm2.732.268c-.138.239-.444.321-.683.183l-.866-.5c-.239-.138-.321-.444-.183-.683.138-.239.444-.321.683-.183l.866.5c.239.138.321.444.183.683zm-12.64-10.607c.276 0 .5.224.5.5v1c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-1c0-.276.224-.5.5-.5zm-1.134 3.964c.138.239.056.545-.183.683l-.866.5c-.239.138-.545.056-.683-.183s-.056-.545.183-.683l.866-.5c.239-.138.545-.056.683.183zm.134-1.232c-.138.239-.444.321-.683.183l-.866-.5c-.239-.138-.321-.444-.183-.683.138-.239.444-.321.683-.183l.866.5c.239.138.321.444.183.683z"/>
</svg>
`, IT = `<svg width="72" height="72" viewBox="0 0 72 72" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_57_171)">
        <path d="M43.45 22.79H26.67L34.86 14.43L28.46 8.10001L9.65002 27.31L28.47 46.52L34.87 40.19L26.68 31.83H43.46C48.93 31.83 53.38 36.4 53.38 42.02V44.69C53.38 50.31 48.93 54.88 43.46 54.88V63.9C53.88 63.9 62.36 55.28 62.36 44.68V42.01C62.36 31.41 53.88 22.79 43.46 22.79H43.45Z" fill="black"/>
    </g>
    <defs>
        <clipPath id="clip0_57_171">
            <rect width="72" height="72" fill="white"/>
        </clipPath>
    </defs>
</svg>
`, PT = `<svg width="72" height="72" viewBox="0 0 72 72" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_57_35)">
        <path d="M43.53 8.10001L37.13 14.43L45.32 22.79H28.54C18.12 22.79 9.64001 31.41 9.64001 42.01V44.68C9.64001 55.28 18.12 63.9 28.54 63.9V54.88C23.07 54.88 18.62 50.31 18.62 44.69V42.02C18.62 36.4 23.07 31.83 28.54 31.83H45.32L37.13 40.19L43.53 46.52L62.35 27.31L43.53 8.10001Z" fill="black"/>
    </g>
    <defs>
        <clipPath id="clip0_57_35">
            <rect width="72" height="72" fill="white"/>
        </clipPath>
    </defs>
</svg>
`, DT = `<svg width="72" height="72" viewBox="0 0 72 72" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_57_39)">
        <path d="M39 56.99H9V62.99H39V56.99Z" fill="black"/>
        <path d="M57 9L55.41 17.02H40.79L33.12 52.49H23.45L31.12 17.02H16.5L18.09 9H57Z" fill="black"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M56.7601 52.5L62.1101 47.15C63.2801 45.98 63.2801 44.08 62.1101 42.91L62.0801 42.88C60.9101 41.71 59.0101 41.71 57.8401 42.88L52.4901 48.23L47.1401 42.88C45.9701 41.71 44.0701 41.71 42.9001 42.88L42.8701 42.91C41.7001 44.08 41.7001 45.98 42.8701 47.15L48.2201 52.5L42.8701 57.85C41.7001 59.02 41.7001 60.92 42.8701 62.09L42.9001 62.12C44.0701 63.29 45.9701 63.29 47.1401 62.12L52.4901 56.77L57.8401 62.12C59.0101 63.29 60.9101 63.29 62.0801 62.12L62.1101 62.09C63.2801 60.92 63.2801 59.02 62.1101 57.85L56.7601 52.5Z" fill="black"/>
    </g>
    <defs>
        <clipPath id="clip0_57_39">
            <rect width="72" height="72" fill="white"/>
        </clipPath>
    </defs>
</svg>
`, $T = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path id="a" fill-rule="evenodd" d="M8 6.49c0-.271.229-.49.5-.49h10.999c.276 0 .5.215.5.49v3.019c0 .271-.229.49-.5.49h-10.999c-.276 0-.5-.215-.5-.49v-3.019zm-4-1.994c0-.274.214-.496.505-.496h.991c.279 0 .505.226.505.496v15.007c0 .274-.214.496-.505.496h-.991c-.279 0-.505-.226-.505-.496v-15.007zm4 9.994c0-.271.231-.49.5-.49h6.999c.276 0 .5.215.5.49v3.019c0 .271-.231.49-.5.49h-6.999c-.276 0-.5-.215-.5-.49v-3.019z"/></svg>
`, zT = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M11 13v-2h-7.5c-.276 0-.5-.215-.5-.49v-3.019c0-.271.228-.49.5-.49h7.5v-2.504c0-.274.214-.496.505-.496h.991c.279 0 .505.226.505.496v2.504h7.5c.276 0 .5.215.5.49v3.019c0 .271-.228.49-.5.49h-7.5v2h2.5c.276 0 .5.215.5.49v3.019c0 .271-.231.49-.5.49h-2.5v2.504c0 .274-.214.496-.505.496h-.991c-.279 0-.505-.226-.505-.496v-2.504h-2.5c-.276 0-.5-.215-.5-.49v-3.019c0-.271.231-.49.5-.49h2.5z"/></svg>', HT = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M4 6.49c0-.271.229-.49.5-.49h10.999c.276 0 .5.215.5.49v3.019c0 .271-.229.49-.5.49h-10.999c-.276 0-.5-.215-.5-.49v-3.019zm4 8c0-.271.231-.49.5-.49h6.999c.276 0 .5.215.5.49v3.019c0 .271-.231.49-.5.49h-6.999c-.276 0-.5-.215-.5-.49v-3.019zm10-9.994c0-.274.214-.496.505-.496h.991c.279 0 .505.226.505.496v15.007c0 .274-.214.496-.505.496h-.991c-.279 0-.505-.226-.505-.496v-15.007z"/></svg>', BT = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M6.553 12.06c0 .06-.036.112-.088.135l.002.003-3.216 1.856a.147.147 0 0 1-.25-.1H3v-3.787a.148.148 0 0 1 .253-.103l3.229 1.864-.004.006a.146.146 0 0 1 .075.126zM3.5 3h17a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5zm6 5h11a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5zm0 5h11a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5zm-6 5h17a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5z"/></svg>', FT = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M3 12.06c0-.055.031-.1.075-.126l-.004-.006L6.3 10.064a.147.147 0 0 1 .253.103v3.786a.147.147 0 0 1-.25.101l-3.216-1.856.001-.003A.147.147 0 0 1 3 12.06zM3.5 3h17a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5zm6 5h11a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5zm0 5h11a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5zm-6 5h17a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5z"/></svg>', VT = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M3.923 15.095c.019-.117.102-.213.215-.249.113-.036.236-.006.319.077l1.08 1.08 2.899-2.899c.123-.123.323-.123.446 0l1.998 1.998c.123.123.123.323 0 .446l-2.9 2.899 1.08 1.08c.084.083.114.207.078.319-.036.113-.131.196-.248.215l-5.523.933c-.101.017-.203-.015-.276-.087v-.001c-.072-.072-.105-.174-.088-.274l.919-5.538zm16.154-6.19c-.019.117-.102.213-.215.249-.113.036-.236.006-.32-.077l-1.08-1.08-2.899 2.899c-.123.123-.323.123-.446 0l-1.998-1.998c-.123-.123-.123-.323 0-.446l2.9-2.9-1.08-1.08c-.084-.084-.114-.207-.078-.319.036-.113.132-.196.248-.215l5.523-.933c.101-.017.203.016.276.088v.001c.072.072.105.174.088.274l-.919 5.538z"/></svg>
`, Xt = (n, e, t, i, r, s) => (i ??= `toggle${e.slice(0, 1).toUpperCase() + e.slice(1)}`, r ??= "is-active", s ??= (o) => o.tiptap.isActive(e), class extends vr {
  #e;
  constructor() {
    super(), this.#e = document.createElement("button"), this.#e.title = typeof n == "string" ? I(n) : `${I(n[0])} (${ld(n[1])})`, this.#e.innerHTML = t, this.shadowRoot.appendChild(this.#e);
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("click", () => {
      const o = this.tiptap;
      o && (typeof i == "function" ? i(o) : o.chain().focus()[i]().run(), this.onEditorUpdate());
    });
  }
  onEditorUpdate() {
    if (r !== !1) {
      const o = s(this.editor);
      this.#e.classList.toggle(r, o), r === "is-disabled" && (this.#e.disabled = o);
    }
  }
}), cd = (n, e, t) => {
  const i = e.substring(5).toLowerCase();
  return class extends vr {
    #e;
    constructor() {
      super(), this.#e = document.createElement("button"), this.#e.title = typeof n == "string" ? I(n) : `${I(n[0])} (${ld(n[1])})`, this.#e.innerHTML = t, this.shadowRoot.appendChild(this.#e);
    }
    connectedCallback() {
      super.connectedCallback(), this.addEventListener("click", () => {
        const r = this.tiptap;
        if (!r)
          return;
        const s = r.state.selection.$head.parent.type.name;
        r.getAttributes(s).textAlign === i ? r.chain().focus().unsetTextAlign().run() : r.chain().focus().setTextAlign(i).run();
      });
    }
    onEditorUpdate() {
      const r = this.tiptap;
      if (!r)
        return;
      const s = r.state.selection.$head.parent.type.name, o = r.getAttributes(s).textAlign;
      this.#e.classList.toggle("is-active", o === i);
    }
  };
}, jT = Xt(["Bold", "cmd+B"], "bold", ET), WT = Xt(["Italic", "cmd+I"], "italic", CT), UT = Xt(
  ["Underline", "cmd+U"],
  "underline",
  TT
), KT = Xt("Strike", "strike", AT), qT = Xt(
  "Unlink",
  "unlink",
  RT,
  "unsetLink",
  "is-disabled",
  (n) => !n.tiptap.isActive("link")
), GT = Xt(
  "Bullet List",
  "bulletList",
  MT,
  (n) => {
    n.chain().focus().lift(n.state.selection.$from.before()).setNode(n.isActive("bulletList") ? "paragraph" : "textBlock").run(), n.chain().toggleBulletList().run();
  }
), JT = Xt(
  "Ordered List",
  "orderedList",
  OT,
  (n) => {
    n.chain().focus().lift(n.state.selection.$from.before()).setNode(n.isActive("orderedList") ? "paragraph" : "textBlock").run(), n.chain().toggleOrderedList().run();
  }
), XT = Xt("Blockquote", "blockquote", LT), YT = Xt(
  ["Undo", "cmd+Z"],
  "undo",
  IT,
  "undo",
  "is-disabled",
  (n) => tS(n.tiptap.state) === 0
), ZT = Xt(
  ["Redo", "cmd+Y"],
  "redo",
  PT,
  "redo",
  "is-disabled",
  (n) => nS(n.tiptap.state) === 0
), QT = Xt(
  "Remove Format",
  "removeFormat",
  DT,
  (n) => n.chain().focus().unsetAllMarks().clearNodes().run(),
  !1
), eA = cd("Align Left", "alignLeft", $T), tA = cd(
  "Align Center",
  "alignCenter",
  zT
), nA = cd(
  "Align Right",
  "alignRight",
  HT
), iA = Xt("Indent", "indent", BT, "indent", !1), rA = Xt("Outdent", "outdent", FT, "outdent", !1);
class sA extends vr {
  constructor() {
    super();
    const e = document.createElement("button");
    e.title = I("Horizontal Rule"), e.innerHTML = NT, this.shadowRoot.appendChild(e);
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("click", () => {
      const e = this.tiptap;
      e && e.chain().focus().setHorizontalRule().run();
    });
  }
}
class oA extends vr {
  constructor() {
    super();
    const e = document.createElement("button");
    e.title = I("Insert HTML"), e.innerHTML = eT, this.shadowRoot.appendChild(e);
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("click", () => {
      const e = this.editor;
      if (!e)
        return;
      const t = Rt(i0, {
        target: document.body,
        props: {
          onSubmit: (i) => {
            e.insertContent(i);
          },
          onClose: () => {
            st(t);
          }
        }
      });
    });
  }
}
class aA extends vr {
  constructor() {
    super();
    const e = document.createElement("button");
    e.title = I("Toggle to HTML editing mode"), e.innerHTML = wT, this.shadowRoot.appendChild(e);
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("click", () => {
      const e = this.editor;
      if (!e)
        return;
      const t = Rt(r0, {
        target: document.body,
        props: {
          text: e.getContent(),
          onSubmit: (i) => {
            e.setContent({
              source: "sourceEditor",
              content: i
            });
          },
          onClose: () => {
            st(t);
          }
        }
      });
    });
  }
}
class lA extends vr {
  #e;
  #t;
  constructor() {
    super(), this.#t = document.createElement("style"), this.#t.textContent = "body { overflow: hidden; }", this.#e = document.createElement("button"), this.#e.title = I("Full Screen"), this.#e.innerHTML = VT, this.shadowRoot.appendChild(this.#e);
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("click", () => {
      const e = this.editor;
      if (!e)
        return;
      const t = e[fn].classList.contains(
        "mt-rich-text-editor-editor--fullscreen"
      );
      e[fn].classList.toggle("mt-rich-text-editor-editor--fullscreen"), this.#e.classList.toggle("is-active", !t), t ? document.body.removeChild(this.#t) : document.body.appendChild(this.#t);
    });
  }
}
const s0 = (n) => class extends n {
  editor;
  options = {};
  get tiptap() {
    return this.editor?.tiptap;
  }
  get shadowRoot() {
    return super.shadowRoot;
  }
  onEditorInit(e, t) {
    this.editor = e, this.options = t;
  }
  onEditorUpdate() {
  }
}, o0 = document.createElement("style");
o0.textContent = zb;
const Yt = (n) => class extends s0(n) {
  connectedCallback() {
    super.connectedCallback(), this.shadowRoot.appendChild(o0.cloneNode(!0));
  }
}, cA = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path fill-rule="evenodd" d="M16.366 6.438l1.732 1c.957.552 1.284 1.775.732 2.732l-5 8.66c-.552.957-1.775 1.284-2.732.732l-1.732-1-1.5 2.598c-.276.478-.888.642-1.366.366-.478-.276-.642-.888-.366-1.366l1.5-2.598-1.732-1c-.957-.552-1.284-1.775-.732-2.732l5-8.66c.552-.957 1.775-1.284 2.732-.732l1.732 1 1.5-2.598c.276-.478.888-.642 1.366-.366.478.276.642.888.366 1.366l-1.5 2.598zm-1 1.732l-.5.866c-.276.478-.888.642-1.366.366-.478-.276-.642-.888-.366-1.366l.5-.866-1.299-.75c-.239-.138-.545-.056-.683.183l-4.5 7.794c-.138.239-.056.545.183.683l1.299.75.5-.866c.276-.478.888-.642 1.366-.366.478.276.642.888.366 1.366l-.5.866 1.299.75c.239.138.545.056.683-.183l4.5-7.794c.138-.239.056-.545-.183-.683l-1.299-.75z"/>
</svg>
`;
var uA = X('<div class="toolbar-group svelte-16z2bvg"></div>'), dA = X("<div></div>");
const hA = {
  hash: "svelte-16z2bvg",
  code: `.toolbar.svelte-16z2bvg {position:absolute;background-color:#fff;border:1px solid #ccc;z-index:1200;border-radius:4px;box-shadow:0 2px 4px rgba(0, 0, 0, 0.1);gap:5px;}.toolbar.svelte-16z2bvg::after,
  .toolbar.svelte-16z2bvg::before {content:"";position:absolute;left:50%;transform:translateX(-50%);width:0;height:0;}

  /* Arrow at the bottom */.toolbar--top.svelte-16z2bvg::before {bottom:-9px;border-left:8px solid transparent;border-right:8px solid transparent;border-top:8px solid #ccc;}.toolbar--top.svelte-16z2bvg::after {bottom:-7px;border-left:7px solid transparent;border-right:7px solid transparent;border-top:7px solid #fff;}

  /* Arrow at the top */.toolbar--bottom.svelte-16z2bvg::before {top:-9px;border-left:8px solid transparent;border-right:8px solid transparent;border-bottom:8px solid #ccc;}.toolbar--bottom.svelte-16z2bvg::after {top:-7px;border-left:7px solid transparent;border-right:7px solid transparent;border-bottom:7px solid #fff;}.toolbar-group.svelte-16z2bvg {display:flex;gap:5px;padding:4px;}.toolbar-item.svelte-16z2bvg {display:flex;align-items:center;justify-content:center;}`
};
function ud(n, e) {
  be(e, !0), Ft(n, hA);
  const t = Q(e, "editor", 7), i = Q(e, "condition", 7), r = Q(e, "targetNodeName", 7), s = Q(e, "targetNodeTagName", 7), o = Q(e, "items", 7), a = t().tiptap, l = a.view.dom, c = {}, u = o().map((E) => E.map((S) => ({
    name: S,
    elementName: Sr("toolbar", S),
    icon: S
  })));
  let d = ce(!1), h = ce(0), f = ce(0), p, _ = ce(!1);
  const m = () => {
    if (U(d, !t().getStructureMode() && i()(), !0), T(d)) {
      y();
      for (const E in c)
        "onEditorUpdate" in c[E] && c[E].onEditorUpdate();
    }
  };
  a.on("selectionUpdate", m), a.on("update", m);
  const g = (E) => {
    const S = E.dom.getBoundingClientRect(), { selection: w } = E.state;
    let v = null;
    if (a.isActive(r())) {
      const A = E.domAtPos(w.from);
      if (A.node && (v = A.node, v.nodeType === Node.TEXT_NODE && (v = v.parentElement)), s() === "A" && v?.tagName !== "A") {
        const b = E.domAtPos(w.from - 1);
        b.node && (v = b.node, v.nodeType === Node.TEXT_NODE && (v = v.parentElement));
      }
      if (v && s() !== v.tagName) {
        const b = v.querySelector(s());
        b && (v = b);
      }
    }
    if (!v) {
      const A = (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        w.node?.type.name === r() ? w.$anchor : Hi((b) => b.type.name === r())(w)
      );
      if (!A) {
        U(h, 0), U(f, 0);
        return;
      }
      if (v = E.nodeDOM(A.pos), !v) {
        U(h, 0), U(f, 0);
        return;
      }
    }
    (async () => {
      v instanceof HTMLImageElement && !v.complete && await new Promise((G) => {
        v.onload = G;
      });
      const A = v.getBoundingClientRect();
      if (!(A.top < S.bottom && A.bottom > S.top && A.left < S.right && A.right > S.left)) {
        U(h, 0), U(f, 0);
        return;
      }
      const C = p?.offsetWidth || 0, M = p?.offsetHeight || 0, z = v.offsetWidth, D = A.top - S.top - M - 10, H = A.bottom - S.top + 10;
      U(_, D < 0), U(h, T(_) ? H : D, !0);
      const q = A.left - S.left + z / 2 - C / 2;
      q + S.left < Fs ? U(f, Fs - S.left) : q + S.left + z > window.innerWidth - Fs ? U(f, window.innerWidth - Fs - S.left - z) : U(f, q);
    })();
  }, y = () => {
    try {
      g(a.view);
    } catch {
    }
  };
  function x(E, S) {
    return c[S] = E, "onEditorInit" in c[S] && c[S].onEditorInit(t(), {}), {
      destroy() {
        delete c[S];
      }
    };
  }
  Ae(() => {
    l.addEventListener("scroll", () => {
      T(d) && y();
    }), T(d) && y();
  });
  var k = dA();
  return ut(k, 21, () => u, bn, (E, S) => {
    var w = uA();
    ut(w, 21, () => T(S), (v) => v.name, (v, A) => {
      var b = mi(), C = Me(b);
      kr(C, () => T(A).elementName, !1, (M, z) => {
        Ye(M, (D, H) => x?.(D, H), () => T(A).name), ht(M, 0, "toolbar-item svelte-16z2bvg");
      }), V(v, b);
    }), O(w), V(E, w);
  }), O(k), We(k, (E) => p = E, () => p), ne(() => {
    ht(k, 1, `toolbar ${T(_) ? "toolbar--bottom" : "toolbar--top"}`, "svelte-16z2bvg"), ks(k, `
    display: ${T(d) && (T(h) || T(f)) ? "flex" : "none"};
    background-color: #fff;
    top: ${T(h)}px; 
    left: ${T(f)}px;
  `);
  }), V(n, k), ve({
    get editor() {
      return t();
    },
    set editor(E) {
      t(E), ee();
    },
    get condition() {
      return i();
    },
    set condition(E) {
      i(E), ee();
    },
    get targetNodeName() {
      return r();
    },
    set targetNodeName(E) {
      r(E), ee();
    },
    get targetNodeTagName() {
      return s();
    },
    set targetNodeTagName(E) {
      s(E), ee();
    },
    get items() {
      return o();
    },
    set items(E) {
      o(E), ee();
    }
  });
}
_e(
  ud,
  {
    editor: {},
    condition: {},
    targetNodeName: {},
    targetNodeTagName: {},
    items: {}
  },
  [],
  [],
  !0
);
function a0(n, e) {
  be(e, !0);
  const t = Q(e, "editor", 7);
  return ud(n, {
    get editor() {
      return t();
    },
    targetNodeName: "link",
    targetNodeTagName: "A",
    condition: () => !t().isPasting() && t().tiptap?.isActive("link") && !t().tiptap?.isActive("link", { class: "mt-asset-link" }),
    items: [["previewLink", "editLink", "unlink"]]
  }), ve({
    get editor() {
      return t();
    },
    set editor(r) {
      t(r), ee();
    }
  });
}
_e(a0, { editor: {} }, [], [], !0);
class fA {
  #e;
  constructor({ editor: e }) {
    this.#e = Rt(a0, {
      target: e.tiptap.view.dom.getRootNode(),
      props: {
        editor: e
      }
    });
  }
  destroy() {
    this.#e && st(this.#e);
  }
}
var pA = X('<div class="form-group mb-3"><label for="link-url" class="form-label"> </label> <input type="url" id="link-url" class="form-control"></div> <div class="form-group mb-3"><label for="link-text" class="form-label"> </label> <input type="text" id="link-text" class="form-control"></div> <div class="form-group mb-3"><label for="link-title" class="form-label"> </label> <input type="text" id="link-title" class="form-control"></div> <div class="form-group mb-3"><label for="link-target" class="form-label"> </label> <select id="link-target" class="form-select"><option> </option><option> </option></select></div>', 1), mA = X('<button type="button" class="action primary button btn btn-primary"> </button> <button type="button" class="cancel action button mt-close-dialog btn btn-default"> </button>', 1);
function dd(n, e) {
  be(e, !0);
  let t = Q(e, "linkData", 7), i = Q(e, "onSubmit", 7), r = Q(e, "onClose", 7), s = ce(De(t().url)), o = ce(De(t().text)), a = ce(De(t().title)), l = ce(De(t().target)), c;
  Ae(() => {
    c?.focus();
  });
  let u = t().text !== "";
  const d = () => {
    u = !0;
  };
  Ae(() => {
    u || U(o, T(s), !0);
  });
  let h, f;
  return We(
    wn(n, {
      $$events: {
        close(...p) {
          r()?.apply(this, p);
        }
      },
      children: (p, _) => {
        kn(p, {
          get close() {
            return f;
          },
          set close(m) {
            f = m;
          },
          $$slots: {
            title: (m, g) => {
              var y = vn();
              ne((x) => B(y, x), [() => I("Insert Link")]), V(m, y);
            },
            body: (m, g) => {
              var y = pA(), x = Me(y), k = L(x), E = L(k, !0);
              O(k);
              var S = F(k, 2);
              dt(S), We(S, (ye) => c = ye, () => c), O(x);
              var w = F(x, 2), v = L(w), A = L(v, !0);
              O(v);
              var b = F(v, 2);
              dt(b), b.__change = d, O(w);
              var C = F(w, 2), M = L(C), z = L(M, !0);
              O(M);
              var D = F(M, 2);
              dt(D), O(C);
              var H = F(C, 2), q = L(H), G = L(q, !0);
              O(q);
              var ae = F(q, 2), Y = L(ae);
              Y.value = (Y.__value = "_self") == null ? "" : "_self";
              var le = L(Y, !0);
              O(Y);
              var de = F(Y);
              de.value = (de.__value = "_blank") == null ? "" : "_blank";
              var ot = L(de, !0);
              O(de), O(ae), O(H), ne(
                (ye, Qe, we, R, ft, me) => {
                  B(E, ye), B(A, Qe), B(z, we), B(G, R), B(le, ft), B(ot, me);
                },
                [
                  () => I("Link URL"),
                  () => I("Link Text"),
                  () => I("Title"),
                  () => I("Link Target"),
                  () => I("LINK_TARGET_SELF"),
                  () => I("LINK_TARGET_BLANK")
                ]
              ), St(S, () => T(s), (ye) => U(s, ye)), St(b, () => T(o), (ye) => U(o, ye)), St(D, () => T(a), (ye) => U(a, ye)), er(ae, () => T(l), (ye) => U(l, ye)), V(m, y);
            },
            footer: (m, g) => {
              var y = mA(), x = Me(y);
              x.__click = () => {
                i()({
                  url: T(s),
                  text: T(o),
                  title: T(a),
                  target: T(l)
                }), f();
              };
              var k = L(x, !0);
              O(x);
              var E = F(x, 2);
              E.__click = f;
              var S = L(E, !0);
              O(E), ne(
                (w, v, A, b) => {
                  Ce(x, "title", w), B(k, v), Ce(E, "title", A), B(S, b);
                },
                [
                  () => I("Insert (s)"),
                  () => I("Insert"),
                  () => I("Cancel (x)"),
                  () => I("Cancel")
                ]
              ), V(m, y);
            }
          }
        });
      },
      $$slots: { default: !0 }
    }),
    (p) => h = p,
    () => h
  ), ve({
    get linkData() {
      return t();
    },
    set linkData(p) {
      t(p), ee();
    },
    get onSubmit() {
      return i();
    },
    set onSubmit(p) {
      i(p), ee();
    },
    get onClose() {
      return r();
    },
    set onClose(p) {
      r(p), ee();
    }
  });
}
Lt(["change", "click"]);
_e(dd, { linkData: {}, onSubmit: {}, onClose: {} }, [], [], !0);
const l0 = (n, e = {}) => () => {
  if (!n)
    return;
  let t;
  if (n.isActive("link")) {
    n.chain().extendMarkRange("link").run();
    const r = n.state.doc.textBetween(
      n.state.selection.from,
      n.state.selection.to
    ), s = n.getAttributes("link");
    t = {
      url: s.href || "",
      text: r,
      title: s.title || "",
      target: s.target || e.defaultTarget || "_self"
    };
  } else
    t = {
      url: "",
      text: n.state.selection.empty ? "" : n.state.doc.textBetween(n.state.selection.from, n.state.selection.to),
      title: "",
      target: e.defaultTarget || "_self"
    };
  const i = Rt(dd, {
    target: document.body,
    props: {
      linkData: t,
      onSubmit: (r) => {
        const s = n.chain().focus();
        n.isActive("link") && s.extendMarkRange("link"), s.deleteSelection().insertContent({
          type: "text",
          text: r.text,
          marks: [
            {
              type: "link",
              attrs: {
                href: r.url,
                target: r.target,
                title: r.title
              }
            }
          ]
        }).run();
      },
      onClose: () => {
        st(i);
      }
    }
  });
}, gA = (n) => class extends Yt(n) {
  onEditorUpdate() {
    this.classList.toggle("is-active", this.tiptap?.isActive("link"));
  }
};
var _A = X("<button><!></button>");
function c0(n, e) {
  be(e, !0);
  const t = e.$$host, { editor: i, options: r, tiptap: s } = t, o = l0(s, r);
  t.addEventListener("click", o);
  let a;
  Ae(() => (i && (a = new fA({ editor: i }), i.tiptap?.commands.setInlineLinkShortcutHandler(o)), () => {
    a?.destroy();
  }));
  var l = _A(), c = L(l);
  Kt(c, () => cA), O(l), Ye(l, (u, d) => yn?.(u, d), () => `${I("Link")} (${ld("cmd+K")})`), V(n, l), ve();
}
_e(c0, {}, [], [], !0, gA);
const bA = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-external-link">
    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
    <path d="M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6" />
    <path d="M11 13l9 -9" />
    <path d="M15 4h5v5" />
</svg>
`, vA = (n) => class extends Yt(n) {
};
var yA = X('<a target="_blank" class="svelte-23fhoy"><span class="svelte-23fhoy"> </span> <!></a>');
const xA = {
  hash: "svelte-23fhoy",
  code: "a.svelte-23fhoy {display:flex;align-items:center;gap:4px;height:100%;padding:0 4px;}a.svelte-23fhoy:hover {background-color:#dee0e2;}a.svelte-23fhoy span:where(.svelte-23fhoy) {max-width:300px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}a.svelte-23fhoy svg {width:16px;height:16px;}"
};
function u0(n, e) {
  be(e, !0), Ft(n, xA);
  const t = e.$$host, { tiptap: i } = t;
  let r = ce("");
  t.onEditorUpdate = () => {
    U(r, i?.getAttributes("link").href, !0);
  };
  var s = yA(), o = L(s), a = L(o, !0);
  O(o);
  var l = F(o, 2);
  Kt(l, () => bA), O(s), ne(() => {
    Ce(s, "href", T(r)), Ce(s, "title", T(r)), B(a, T(r));
  }), V(n, s), ve();
}
_e(u0, {}, [], [], !0, vA);
const d0 = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-pencil">
    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
    <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" />
    <path d="M13.5 6.5l4 4" />
</svg>
`, wA = (n) => class extends Yt(n) {
};
var kA = X("<button><!></button>");
function h0(n, e) {
  be(e, !0);
  const t = e.$$host, { tiptap: i } = t;
  t.addEventListener("click", l0(i));
  var r = kA(), s = L(r);
  Kt(s, () => d0), O(r), Ye(r, (o, a) => yn?.(o, a), () => I("Edit Link")), V(n, r), ve();
}
_e(h0, {}, [], [], !0, wA);
const SA = `<svg width="72" height="72" viewBox="0 0 72 72" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_57_27)">
        <path d="M56.75 24.88H51.56V15.99C51.56 13.53 49.57 11.54 47.11 11.54H24.87C22.41 11.54 20.42 13.53 20.42 15.99V24.88H15.23C12.77 24.88 10.78 26.87 10.78 29.33V56.01C10.78 58.47 12.77 60.46 15.23 60.46H56.74C59.2 60.46 61.19 58.47 61.19 56.01V29.33C61.19 26.87 59.2 24.88 56.74 24.88H56.75ZM24.88 15.99H47.12V24.88H24.88V15.99Z" fill="black"/>
    </g>
    <defs>
        <clipPath id="clip0_57_27">
            <rect width="72" height="72" fill="white"/>
        </clipPath>
    </defs>
</svg>
`;
var EA = X("<button><!></button>");
function f0(n, e) {
  be(e, !0);
  const t = e.$$host;
  t.addEventListener("click", () => {
    t.options.select?.({ editor: t.editor });
  });
  var i = EA(), r = L(i);
  Kt(r, () => SA), O(i), Ye(i, (s, o) => yn?.(s, o), () => I("Insert File")), V(n, i), ve();
}
_e(f0, {}, [], [], !0, Yt);
const CA = `<svg width="72" height="72" viewBox="0 0 72 72" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_57_21)">
        <path d="M58.5 18.9V53.1H13.5V18.9H58.5ZM58.5 11.7H13.5C9.52005 11.7 6.30005 14.92 6.30005 18.9V53.1C6.30005 57.08 9.52005 60.3 13.5 60.3H58.5C62.48 60.3 65.7 57.08 65.7 53.1V18.9C65.7 14.92 62.48 11.7 58.5 11.7Z" fill="black"/>
        <path d="M50.4 35.1C53.3823 35.1 55.8 32.6823 55.8 29.7C55.8 26.7177 53.3823 24.3 50.4 24.3C47.4177 24.3 45 26.7177 45 29.7C45 32.6823 47.4177 35.1 50.4 35.1Z" fill="#231F20"/>
        <path d="M56.7 54H50.53L50.44 53.73H50.45L37.54 29.69C37.26 29.07 36.66 28.63 35.97 28.63C35.28 28.63 34.65 29.09 34.37 29.74L25.78 45.73L23.68 41.82C23.53 41.49 23.22 41.26 22.85 41.26C22.48 41.26 22.15 41.5 22.01 41.85L13.51 54.02C13.51 56.99 15.92 59.4 18.9 59.4H56.73C59.71 59.4 62.12 56.99 62.12 54.02L56.72 54H56.7Z" fill="#231F20"/>
    </g>
    <defs>
        <clipPath id="clip0_57_21">
            <rect width="72" height="72" fill="white"/>
        </clipPath>
    </defs>
</svg>
`;
function p0(n, e) {
  be(e, !0);
  const t = Q(e, "editor", 7), i = t().tiptap, r = t().options.toolbarOptions?.image?.edit ? [["deleteImage"], ["editImage"]] : [["deleteImage"]];
  return ud(n, {
    get editor() {
      return t();
    },
    targetNodeName: "image",
    targetNodeTagName: "IMG",
    condition: () => !(i.isActive("link") && !i.isActive("link", { class: "mt-asset-link" })) && i.isActive("image"),
    items: r
  }), ve({
    get editor() {
      return t();
    },
    set editor(s) {
      t(s), ee();
    }
  });
}
_e(p0, { editor: {} }, [], [], !0);
class TA {
  #e;
  constructor({
    editor: e,
    edit: t
  }) {
    this.#e = Rt(p0, {
      target: e.tiptap.view.dom.getRootNode(),
      props: {
        editor: e,
        edit: t
      }
    });
  }
  destroy() {
    this.#e && st(this.#e);
  }
}
var AA = X("<button><!></button>");
function m0(n, e) {
  be(e, !0);
  const t = e.$$host, { editor: i, options: r } = t;
  t.addEventListener("click", () => {
    t.options.select?.({ editor: t.editor });
  });
  let s;
  Ae(() => (i && (s = new TA({ editor: i, edit: r.edit })), () => {
    s?.destroy();
  }));
  var o = AA(), a = L(o);
  Kt(a, () => CA), O(o), Ye(o, (l, c) => yn?.(l, c), () => I("Insert Image")), V(n, o), ve();
}
_e(m0, {}, [], [], !0, Yt);
const MA = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-trash">
    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
    <path d="M4 7l16 0" />
    <path d="M10 11l0 6" />
    <path d="M14 11l0 6" />
    <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
    <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
</svg>
`, OA = (n) => class extends Yt(n) {
};
var NA = X("<button><!></button>");
function g0(n, e) {
  be(e, !0);
  const t = e.$$host;
  t.addEventListener("click", () => {
    t.tiptap?.chain().focus().deleteSelection().run();
  });
  var i = NA(), r = L(i);
  Kt(r, () => MA), O(i), Ye(i, (s, o) => yn?.(s, o), () => I("Delete Image")), V(n, i), ve();
}
_e(g0, {}, [], [], !0, OA);
const LA = (n) => class extends Yt(n) {
};
var RA = X("<button><!></button>");
function _0(n, e) {
  be(e, !0);
  const t = e.$$host, { editor: i, tiptap: r } = t;
  function s() {
    if (!r)
      return null;
    const { selection: l } = r.state, c = (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      l.node?.type.name === "image" ? l.$anchor : Hi((u) => u.type.name === "image")(l)
    );
    return c ? r.view.nodeDOM(c.pos) : null;
  }
  t.addEventListener("click", () => {
    const l = s();
    l && i?.options.toolbarOptions?.image?.edit?.({ editor: i, element: l });
  });
  var o = RA(), a = L(o);
  Kt(a, () => d0), O(o), Ye(o, (l, c) => yn?.(l, c), () => I("Edit Image")), V(n, o), ve();
}
_e(_0, {}, [], [], !0, LA);
const IA = `<svg width="72" height="72" viewBox="0 0 72 72" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_57_229)">
        <path d="M64.05 22.55C63.27 21.44 62 20.78 60.65 20.78H56.32L54.81 24.93H60.65L50.08 53.98H16.8799L18.6399 49.14H14.22L12.97 52.56C12.51 53.83 12.69 55.25 13.47 56.36C14.25 57.47 15.52 58.13 16.87 58.13H50.07C51.81 58.13 53.37 57.04 53.97 55.4L64.54 26.35C65 25.08 64.82 23.66 64.04 22.55H64.05Z" fill="black"/>
        <path d="M55.1201 18.02L44.5501 47.07H11.3501L21.9201 18.02H55.1201ZM55.1201 13.87H21.9201C20.1801 13.87 18.6201 14.96 18.0201 16.6L7.45005 45.65C6.99005 46.92 7.17005 48.34 7.95005 49.45C8.73005 50.56 10.0001 51.22 11.3501 51.22H44.5501C46.2901 51.22 47.8501 50.13 48.4501 48.49L59.0201 19.44C59.4801 18.17 59.3001 16.75 58.5201 15.64C57.7401 14.53 56.4701 13.87 55.1201 13.87Z" fill="black"/>
        <path d="M43.86 23.55L39.71 35.31H21.23L25.38 23.55H43.86ZM43.86 20.79H25.38C24.21 20.79 23.16 21.53 22.77 22.63L18.62 34.39C18.32 35.24 18.45 36.18 18.97 36.91C19.49 37.64 20.33 38.08 21.23 38.08H39.71C40.88 38.08 41.93 37.34 42.32 36.24L46.47 24.48C46.77 23.63 46.64 22.69 46.12 21.96C45.6 21.23 44.76 20.79 43.86 20.79Z" fill="black"/>
    </g>
    <defs>
        <clipPath id="clip0_57_229">
            <rect width="72" height="72" fill="white"/>
        </clipPath>
    </defs>
</svg>
`, PA = (n) => class extends Yt(n) {
  onEditorUpdate() {
    this.classList.toggle("is-active", this.editor?.getStructureMode());
  }
};
var DA = X("<button><!></button>");
function b0(n, e) {
  be(e, !0);
  const t = e.$$host;
  t.addEventListener("click", () => {
    const s = t.editor;
    s && (s.setStructureMode(!s.getStructureMode()), t.onEditorUpdate());
  });
  var i = DA(), r = L(i);
  Kt(r, () => IA), O(i), Ye(i, (s, o) => yn?.(s, o), () => I("Toggle to HTML structure editing mode")), V(n, i), ve();
}
_e(b0, {}, [], [], !0, PA);
const $A = `<svg width="72" height="72" viewBox="0 0 72 72" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_57_206)">
        <path d="M58.4 8.80005H13.6C10.07 8.80005 7.20001 11.67 7.20001 15.2V56.8C7.20001 60.33 10.07 63.2001 13.6 63.2001H58.4C61.93 63.2001 64.8 60.33 64.8 56.8V15.2C64.8 11.67 61.93 8.80005 58.4 8.80005ZM58.4 24.8V37.6H39.2V24.8H58.4ZM32.8 24.8V37.6H13.6V24.8H32.8ZM13.6 56.8V44H32.8V56.8H13.6ZM39.2 56.8V44H58.4V56.8H39.2Z" fill="black"/>
    </g>
    <defs>
        <clipPath id="clip0_57_206">
            <rect width="72" height="72" fill="white"/>
        </clipPath>
    </defs>
</svg>
`;
function zA(n, e) {
  n.key === "Enter" && e(n);
}
var HA = X('<div role="button" tabindex="0"></div>'), BA = X('<div class="grid_row svelte-zhz6om"></div>'), FA = X('<div class="table_insert_panel svelte-zhz6om"><div class="grid_container svelte-zhz6om" tabindex="-1" role="grid"></div> <div class="size_indicator svelte-zhz6om"><!></div></div>');
const VA = {
  hash: "svelte-zhz6om",
  code: ".table_insert_panel.svelte-zhz6om {position:absolute;top:0;left:0;background:white;border:1px solid #ccc;border-radius:4px;padding:8px 8px 0 8px;box-shadow:0 2px 4px rgba(0, 0, 0, 0.1);}.size_indicator.svelte-zhz6om {text-align:center;margin:4px 0;height:20px;font-size:12px;}.grid_container.svelte-zhz6om {display:flex;flex-direction:column;gap:2px;}.grid_row.svelte-zhz6om {display:flex;gap:2px;}.grid_cell.svelte-zhz6om {width:12px;height:12px;border:1px solid #ddd;background:#fff;cursor:pointer;}.grid_cell.selected.svelte-zhz6om {background:#0066cc;border-color:#0066cc;}"
};
function v0(n, e) {
  be(e, !0), Ft(n, VA);
  const t = Q(e, "onInsert", 7);
  let i = ce(0), r = ce(0);
  const s = 20, o = 20, a = 10, l = 10, c = So(() => Math.min(s, Math.max(a, T(i) + 1))), u = So(() => Math.min(o, Math.max(l, T(r) + 1)));
  function d(y, x) {
    U(i, y + 1), U(r, x + 1);
  }
  function h(y) {
    y.stopPropagation(), T(i) && T(r) && t()(T(i), T(r));
  }
  var f = FA(), p = L(f);
  p.__click = h, p.__keydown = [zA, h], ut(p, 21, () => Array(T(c)), bn, (y, x, k) => {
    var E = BA();
    ut(E, 21, () => Array(T(u)), bn, (S, w, v, A) => {
      var b = HA();
      let C;
      b.__mouseover = () => d(k, v), ne((M) => C = ht(b, 1, "grid_cell svelte-zhz6om", null, C, M), [
        () => ({
          selected: k < T(i) && v < T(r)
        })
      ]), gn("focus", b, () => d(k, v)), V(S, b);
    }), O(E), V(y, E);
  }), O(p);
  var _ = F(p, 2), m = L(_);
  {
    var g = (y) => {
      var x = vn();
      ne(() => B(x, `${T(i) ?? ""} x ${T(r) ?? ""}`)), V(y, x);
    };
    it(m, (y) => {
      T(i) && T(r) && y(g);
    });
  }
  return O(_), O(f), V(n, f), ve({
    get onInsert() {
      return t();
    },
    set onInsert(y) {
      t(y), ee();
    }
  });
}
Lt(["click", "keydown", "mouseover"]);
_e(v0, { onInsert: {} }, [], [], !0);
const Ql = (n) => !n.closest("div[data-mt-rich-text-editor-embed-object]"), jA = (n, e) => {
  const r = new DOMParser().parseFromString(`<body>${n}</body>`, "text/html").body, s = e.join(",");
  return r.querySelectorAll("a").forEach((o) => {
    Ql(o) && o.querySelector(
      "blockquote, div, dl, h1, h2, h3, h4, h5, h6, hr, ol, p, pre, table, td, thead, tr, ul," + s
    ) && (o.dataset.mtRichTextEditorBlock = "true");
  }), r.querySelectorAll("script").forEach((o) => {
    if (!Ql(o))
      return;
    const a = document.createElement("mt-rich-text-editor-script");
    a.textContent = o.textContent, Array.from(o.attributes).forEach((l) => {
      a.setAttribute(l.name, l.value);
    }), o.parentNode?.replaceChild(a, o);
  }), r.querySelectorAll("div, blockquote, ul, ol, td, th," + s).forEach((o) => {
    if (!Ql(o))
      return;
    if (Array.from(o.childNodes).some(
      (l) => l instanceof HTMLImageElement || l.nodeType === Node.TEXT_NODE && l.textContent?.trim() || l.nodeType === Node.ELEMENT_NODE && l.nodeName === "BR"
    )) {
      const l = document.createElement("div");
      for (let c = 0; c < o.childNodes.length; c++) {
        const u = o.childNodes[c];
        if (u instanceof HTMLImageElement || u.nodeType === Node.TEXT_NODE || u.nodeType === Node.ELEMENT_NODE && u.nodeName === "BR") {
          const d = document.createElement("mt-text-block");
          let h = "";
          for (; c < o.childNodes.length; ) {
            const f = o.childNodes[c];
            if (f.nodeType === Node.TEXT_NODE)
              l.textContent = f.textContent, h += l.innerHTML;
            else if (f.nodeName === "BR")
              h += "<br>";
            else if (f instanceof HTMLImageElement)
              h += f.outerHTML;
            else
              break;
            f.remove();
          }
          o.insertBefore(d, o.childNodes[c]), d.innerHTML = h, c--;
        }
      }
    }
  }), r.innerHTML;
}, WA = (n) => {
  if (/^<p[^>]*><\/p>$/i.test(n))
    return "";
  const t = new DOMParser().parseFromString(n, "text/html");
  t.body.querySelectorAll("mt-text-block").forEach((r) => {
    const s = r.parentNode;
    if (s) {
      for (; r.firstChild; )
        s.insertBefore(r.firstChild, r);
      r.remove();
    }
  }), t.body.querySelectorAll('[textalign=""]').forEach((r) => {
    r.removeAttribute("textalign");
  }), t.body.querySelectorAll("[data-mt-indent]").forEach((r) => {
    r.removeAttribute("data-mt-indent");
  }), t.body.querySelectorAll("[data-mt-rich-text-editor-event-attributes]").forEach((r) => {
    const s = JSON.parse(
      r.dataset.mtRichTextEditorEventAttributes ?? "{}"
    );
    Object.entries(s).forEach(([o, a]) => {
      r.setAttribute(o, a);
    }), r.removeAttribute("data-mt-rich-text-editor-event-attributes");
  }), t.body.querySelectorAll("[data-mt-rich-text-editor-content]").forEach((r) => {
    r.innerHTML = r.getAttribute("data-mt-rich-text-editor-content") ?? "", r.removeAttribute("data-mt-rich-text-editor-content");
  }), t.body.querySelectorAll("mt-rich-text-editor-script").forEach((r) => {
    const s = document.createElement("script");
    s.textContent = r.textContent, Array.from(r.attributes).forEach((o) => {
      s.setAttribute(o.name, o.value);
    }), r.parentNode?.replaceChild(s, r);
  });
  const i = t.body.innerHTML;
  return /^<p[^>]*><\/p>$/i.test(i) ? "" : i;
}, tr = (n) => n !== "0" && /^-?(\d+|\d*\.\d+)$/.test(n) ? `${n}px` : n;
var UA = X('<div class="form-group mb-3"><label for="link-url" class="form-label"> </label> <input type="text" id="table-width" class="form-control"></div> <div class="form-group mb-3"><label for="table-height" class="form-label"> </label> <input type="text" id="table-height" class="form-control"></div> <div class="form-group mb-3"><label for="table-cell-spacing" class="form-label"> </label> <input type="text" id="table-cell-spacing" class="form-control"></div> <div class="form-group mb-3"><label for="table-border-width" class="form-label"> </label> <input type="text" id="table-border-width" class="form-control"></div>', 1), KA = X('<button type="button" class="action primary button btn btn-primary"> </button> <button type="button" class="cancel action button mt-close-dialog btn btn-default"> </button>', 1);
function y0(n, e) {
  be(e, !0);
  let t = Q(e, "tableData", 7), i = Q(e, "onSubmit", 7), r = Q(e, "onClose", 7), s = ce(De(t().width)), o = ce(De(t().height)), a = ce(De(t().cellSpacing)), l = ce(De(t().borderWidth)), c;
  Ae(() => {
    c?.focus();
  });
  let u, d;
  return We(
    wn(n, {
      $$events: {
        close(...h) {
          r()?.apply(this, h);
        }
      },
      children: (h, f) => {
        kn(h, {
          get close() {
            return d;
          },
          set close(p) {
            d = p;
          },
          $$slots: {
            title: (p, _) => {
              var m = vn();
              ne((g) => B(m, g), [() => I("Table Properties")]), V(p, m);
            },
            body: (p, _) => {
              var m = UA(), g = Me(m), y = L(g), x = L(y, !0);
              O(y);
              var k = F(y, 2);
              dt(k), We(k, (G) => c = G, () => c), O(g);
              var E = F(g, 2), S = L(E), w = L(S, !0);
              O(S);
              var v = F(S, 2);
              dt(v), O(E);
              var A = F(E, 2), b = L(A), C = L(b, !0);
              O(b);
              var M = F(b, 2);
              dt(M), O(A);
              var z = F(A, 2), D = L(z), H = L(D, !0);
              O(D);
              var q = F(D, 2);
              dt(q), O(z), ne(
                (G, ae, Y, le) => {
                  B(x, G), B(w, ae), B(C, Y), B(H, le);
                },
                [
                  () => I("Width"),
                  () => I("Height"),
                  () => I("Cell Spacing"),
                  () => I("Border Width")
                ]
              ), St(k, () => T(s), (G) => U(s, G)), St(v, () => T(o), (G) => U(o, G)), St(M, () => T(a), (G) => U(a, G)), St(q, () => T(l), (G) => U(l, G)), V(p, m);
            },
            footer: (p, _) => {
              var m = KA(), g = Me(m);
              g.__click = () => {
                i()({
                  width: T(s),
                  height: T(o),
                  cellSpacing: T(a),
                  borderWidth: T(l)
                }), d();
              };
              var y = L(g, !0);
              O(g);
              var x = F(g, 2);
              x.__click = d;
              var k = L(x, !0);
              O(x), ne(
                (E, S, w, v) => {
                  Ce(g, "title", E), B(y, S), Ce(x, "title", w), B(k, v);
                },
                [
                  () => I("Insert (s)"),
                  () => I("Insert"),
                  () => I("Cancel (x)"),
                  () => I("Cancel")
                ]
              ), V(p, m);
            }
          }
        });
      },
      $$slots: { default: !0 }
    }),
    (h) => u = h,
    () => u
  ), ve({
    get tableData() {
      return t();
    },
    set tableData(h) {
      t(h), ee();
    },
    get onSubmit() {
      return i();
    },
    set onSubmit(h) {
      i(h), ee();
    },
    get onClose() {
      return r();
    },
    set onClose(h) {
      r(h), ee();
    }
  });
}
Lt(["click"]);
_e(y0, { tableData: {}, onSubmit: {}, onClose: {} }, [], [], !0);
const qA = (n) => {
  const { state: e } = n;
  let t = e.selection.$anchor.depth, i = null;
  for (; t > 0; ) {
    const s = e.selection.$anchor.node(t);
    if (s.type.name === "table") {
      i = s;
      break;
    }
    t--;
  }
  const r = document.createElement("div");
  return r.style.cssText = i?.attrs.style || "", {
    width: r.style.width || "100%",
    height: r.style.height || "",
    cellSpacing: r.style.borderSpacing || "",
    borderWidth: r.style.borderWidth || ""
  };
}, GA = (n) => {
  const { state: e } = n;
  let t = e.selection.$anchor.depth;
  for (; t > 0; ) {
    if (e.selection.$anchor.node(t).type.name === "table")
      return e.selection.$anchor.before(t);
    t--;
  }
  return null;
};
let sp;
const JA = (n) => {
  Rt(y0, {
    target: document.body,
    props: {
      tableData: qA(n),
      onSubmit: (e) => {
        const t = GA(n);
        t !== null && n?.chain().focus().command(({ tr: i }) => {
          const r = i.doc.nodeAt(t);
          if (r) {
            const s = document.createElement("div");
            s.style.cssText = r.attrs.style || "", s.style.width = tr(e.width), s.style.height = tr(e.height), s.style.borderSpacing = e.cellSpacing, s.style.borderWidth = tr(e.borderWidth), i.setNodeMarkup(t, null, {
              ...r.attrs,
              style: s.style.cssText
            });
            const o = cn(n.state);
            o && o.map.map.forEach((a) => {
              const l = o.table.nodeAt(a);
              if (l) {
                const c = document.createElement("div");
                c.style.cssText = l.attrs.style || "", c.style.borderWidth = tr(e.borderWidth), i.setNodeMarkup(o.tableStart + a, null, {
                  ...l.attrs,
                  style: c.style.cssText
                });
              }
            });
          }
          return !0;
        }).run(), st(sp);
      },
      onClose: () => {
        st(sp);
      }
    }
  });
};
var XA = X('<div class="form-group mb-3"><label for="width" class="form-label"> </label> <input type="text" id="width" class="form-control"></div> <div class="form-group mb-3"><label for="width" class="form-label"> </label> <input type="text" id="height" class="form-control"></div> <div class="form-group mb-3"><label for="element" class="form-label"> </label> <select id="element" class="form-control"><option> </option><option> </option></select></div> <div class="form-group mb-3"><label for="scope" class="form-label"> </label> <select id="scope" class="form-control"><option> </option><option> </option><option> </option><option> </option><option> </option></select></div> <div class="form-group mb-3"><label for="horizontalAlign" class="form-label"> </label> <select id="horizontalAlign" class="form-control"><option> </option><option> </option><option> </option><option> </option><option> </option></select></div> <div class="form-group mb-3"><label for="verticalAlign" class="form-label"> </label> <select id="verticalAlign" class="form-control"><option> </option><option> </option><option> </option><option> </option></select></div>', 1), YA = X('<button type="button" class="action primary button btn btn-primary"> </button> <button type="button" class="cancel action button mt-close-dialog btn btn-default"> </button>', 1);
function x0(n, e) {
  be(e, !0);
  let t = Q(e, "cellData", 7), i = Q(e, "onSubmit", 7), r = Q(e, "onClose", 7), s = ce(De(t().width)), o = ce(De(t().height)), a = ce(De(t().element)), l = ce(De(t().scope)), c = ce(De(t().horizontalAlign)), u = ce(De(t().verticalAlign)), d;
  Ae(() => {
    d?.focus();
  });
  let h, f;
  return We(
    wn(n, {
      $$events: {
        close(...p) {
          r()?.apply(this, p);
        }
      },
      children: (p, _) => {
        kn(p, {
          get close() {
            return f;
          },
          set close(m) {
            f = m;
          },
          $$slots: {
            title: (m, g) => {
              var y = vn();
              ne((x) => B(y, x), [() => I("Cell Properties")]), V(m, y);
            },
            body: (m, g) => {
              var y = XA(), x = Me(y), k = L(x), E = L(k, !0);
              O(k);
              var S = F(k, 2);
              dt(S), We(S, (tt) => d = tt, () => d), O(x);
              var w = F(x, 2), v = L(w), A = L(v, !0);
              O(v);
              var b = F(v, 2);
              dt(b), O(w);
              var C = F(w, 2), M = L(C), z = L(M, !0);
              O(M);
              var D = F(M, 2), H = L(D);
              H.value = (H.__value = "td") == null ? "" : "td";
              var q = L(H, !0);
              O(H);
              var G = F(H);
              G.value = (G.__value = "th") == null ? "" : "th";
              var ae = L(G, !0);
              O(G), O(D), O(C);
              var Y = F(C, 2), le = L(Y), de = L(le, !0);
              O(le);
              var ot = F(le, 2), ye = L(ot);
              ye.value = ((ye.__value = "") == null, "");
              var Qe = L(ye, !0);
              O(ye);
              var we = F(ye);
              we.value = (we.__value = "row") == null ? "" : "row";
              var R = L(we, !0);
              O(we);
              var ft = F(we);
              ft.value = (ft.__value = "col") == null ? "" : "col";
              var me = L(ft, !0);
              O(ft);
              var vt = F(ft);
              vt.value = (vt.__value = "rowgroup") == null ? "" : "rowgroup";
              var at = L(vt, !0);
              O(vt);
              var te = F(vt);
              te.value = (te.__value = "colgroup") == null ? "" : "colgroup";
              var yt = L(te, !0);
              O(te), O(ot), O(Y);
              var ge = F(Y, 2), P = L(ge), Z = L(P, !0);
              O(P);
              var he = F(P, 2), j = L(he);
              j.value = ((j.__value = "") == null, "");
              var Pe = L(j, !0);
              O(j);
              var et = F(j);
              et.value = (et.__value = "left") == null ? "" : "left";
              var Ue = L(et, !0);
              O(et);
              var Et = F(et);
              Et.value = (Et.__value = "center") == null ? "" : "center";
              var Zt = L(Et, !0);
              O(Et);
              var lt = F(Et);
              lt.value = (lt.__value = "right") == null ? "" : "right";
              var Pt = L(lt, !0);
              O(lt);
              var Ie = F(lt);
              Ie.value = (Ie.__value = "justify") == null ? "" : "justify";
              var Be = L(Ie, !0);
              O(Ie), O(he), O(ge);
              var Le = F(ge, 2), ke = L(Le), Ct = L(ke, !0);
              O(ke);
              var vi = F(ke, 2), Jn = L(vi);
              Jn.value = ((Jn.__value = "") == null, "");
              var Fi = L(Jn, !0);
              O(Jn);
              var Sn = F(Jn);
              Sn.value = (Sn.__value = "top") == null ? "" : "top";
              var un = L(Sn, !0);
              O(Sn);
              var Qt = F(Sn);
              Qt.value = (Qt.__value = "middle") == null ? "" : "middle";
              var Er = L(Qt, !0);
              O(Qt);
              var Xn = F(Qt);
              Xn.value = (Xn.__value = "bottom") == null ? "" : "bottom";
              var Ya = L(Xn, !0);
              O(Xn), O(vi), O(Le), ne(
                (tt, Vi, Za, yi, Qa, el, nt, Yn, tl, Is, Cr, Ps, Ds, nl, en, Zn, $s, zs, Tr, Hs, dn, Bs) => {
                  B(E, tt), B(A, Vi), B(z, Za), B(q, yi), B(ae, Qa), B(de, el), B(Qe, nt), B(R, Yn), B(me, tl), B(at, Is), B(yt, Cr), B(Z, Ps), B(Pe, Ds), B(Ue, nl), B(Zt, en), B(Pt, Zn), B(Be, $s), B(Ct, zs), B(Fi, Tr), B(un, Hs), B(Er, dn), B(Ya, Bs);
                },
                [
                  () => I("Width"),
                  () => I("Height"),
                  () => I("Cell type"),
                  () => I("Cell"),
                  () => I("Header cell"),
                  () => I("Scope"),
                  () => I("None"),
                  () => I("Row"),
                  () => I("Column"),
                  () => I("Row group"),
                  () => I("Column group"),
                  () => I("Horizontal align"),
                  () => I("None"),
                  () => I("HORIZONTAL_ALIGN_LEFT"),
                  () => I("HORIZONTAL_ALIGN_CENTER"),
                  () => I("HORIZONTAL_ALIGN_RIGHT"),
                  () => I("HORIZONTAL_ALIGN_JUSTIFY"),
                  () => I("Vertical align"),
                  () => I("None"),
                  () => I("VERTICAL_ALIGN_TOP"),
                  () => I("VERTICAL_ALIGN_MIDDLE"),
                  () => I("VERTICAL_ALIGN_BOTTOM")
                ]
              ), St(S, () => T(s), (tt) => U(s, tt)), St(b, () => T(o), (tt) => U(o, tt)), er(D, () => T(a), (tt) => U(a, tt)), er(ot, () => T(l), (tt) => U(l, tt)), er(he, () => T(c), (tt) => U(c, tt)), er(vi, () => T(u), (tt) => U(u, tt)), V(m, y);
            },
            footer: (m, g) => {
              var y = YA(), x = Me(y);
              x.__click = () => {
                i()({
                  width: T(s),
                  height: T(o),
                  element: T(a),
                  scope: T(l),
                  horizontalAlign: T(c),
                  verticalAlign: T(u)
                }), f();
              };
              var k = L(x, !0);
              O(x);
              var E = F(x, 2);
              E.__click = f;
              var S = L(E, !0);
              O(E), ne(
                (w, v, A, b) => {
                  Ce(x, "title", w), B(k, v), Ce(E, "title", A), B(S, b);
                },
                [
                  () => I("Insert (s)"),
                  () => I("Insert"),
                  () => I("Cancel (x)"),
                  () => I("Cancel")
                ]
              ), V(m, y);
            }
          }
        });
      },
      $$slots: { default: !0 }
    }),
    (p) => h = p,
    () => h
  ), ve({
    get cellData() {
      return t();
    },
    set cellData(p) {
      t(p), ee();
    },
    get onSubmit() {
      return i();
    },
    set onSubmit(p) {
      i(p), ee();
    },
    get onClose() {
      return r();
    },
    set onClose(p) {
      r(p), ee();
    }
  });
}
Lt(["click"]);
_e(x0, { cellData: {}, onSubmit: {}, onClose: {} }, [], [], !0);
const ZA = (n) => {
  const { state: e } = n;
  let t = e.selection.$anchor.depth, i = null;
  for (; t > 0; ) {
    const s = e.selection.$anchor.node(t);
    if (s.type.name === "tableCell" || s.type.name === "tableHeader") {
      i = s;
      break;
    }
    t--;
  }
  const r = document.createElement("div");
  return r.style.cssText = i?.attrs.style || "", {
    width: r.style.width || "",
    height: r.style.height || "",
    element: i?.type.name === "tableCell" ? "td" : "th",
    scope: i?.attrs.scope || "",
    horizontalAlign: r.style.textAlign || "",
    verticalAlign: r.style.verticalAlign || ""
  };
}, QA = (n) => {
  if (!n)
    return null;
  const { state: e } = n;
  let t = e.selection.$anchor.depth;
  for (; t > 0; ) {
    const i = e.selection.$anchor.node(t);
    if (i.type.name === "tableCell" || i.type.name === "tableHeader")
      return e.selection.$anchor.before(t);
    t--;
  }
  return null;
};
let op;
const eM = (n) => {
  Rt(x0, {
    target: document.body,
    props: {
      cellData: ZA(n),
      onSubmit: (e) => {
        const t = QA(n);
        if (t !== null) {
          const i = n?.state.selection?.$anchor.node();
          (i?.type.name === "tableCell" && e.element === "th" || i?.type.name === "tableHeader" && e.element === "td") && n?.chain().focus().toggleHeaderCell().run(), n?.chain().focus().command(({ tr: r }) => {
            const s = r.doc.nodeAt(t);
            if (s) {
              const o = document.createElement("div");
              o.style.cssText = s.attrs.style || "", o.style.width = tr(e.width), o.style.height = tr(e.height), o.style.textAlign = e.horizontalAlign, o.style.verticalAlign = e.verticalAlign, r.setNodeMarkup(t, null, {
                ...s.attrs,
                scope: e.scope || void 0,
                style: o.style.cssText
              });
            }
            return !0;
          }).run();
        }
        st(op);
      },
      onClose: () => {
        st(op);
      }
    }
  });
};
var tM = X('<div class="form-group mb-3"><label for="element" class="form-label"> </label> <select id="element" class="form-control"><option> </option><option> </option></select></div>'), nM = X('<button type="button" class="action primary button btn btn-primary"> </button> <button type="button" class="cancel action button mt-close-dialog btn btn-default"> </button>', 1);
function iM(n, e) {
  be(e, !0);
  let t = Q(e, "rowData", 7), i = Q(e, "onSubmit", 7), r = Q(e, "onClose", 7), s = ce(De(t().element)), o;
  Ae(() => {
    o?.focus();
  });
  let a, l;
  return We(
    wn(n, {
      $$events: {
        close(...c) {
          r()?.apply(this, c);
        }
      },
      children: (c, u) => {
        kn(c, {
          get close() {
            return l;
          },
          set close(d) {
            l = d;
          },
          $$slots: {
            title: (d, h) => {
              var f = vn();
              ne((p) => B(f, p), [() => I("Row Properties")]), V(d, f);
            },
            body: (d, h) => {
              var f = tM(), p = L(f), _ = L(p, !0);
              O(p);
              var m = F(p, 2), g = L(m);
              g.value = (g.__value = "tbody") == null ? "" : "tbody";
              var y = L(g, !0);
              O(g);
              var x = F(g);
              x.value = (x.__value = "thead") == null ? "" : "thead";
              var k = L(x, !0);
              O(x), O(m), We(m, (E) => o = E, () => o), O(f), ne(
                (E, S, w) => {
                  B(_, E), B(y, S), B(k, w);
                },
                [
                  () => I("Row type"),
                  () => I("Row"),
                  () => I("Header row")
                ]
              ), er(m, () => T(s), (E) => U(s, E)), V(d, f);
            },
            footer: (d, h) => {
              var f = nM(), p = Me(f);
              p.__click = () => {
                i()({ element: T(s) }), l();
              };
              var _ = L(p, !0);
              O(p);
              var m = F(p, 2);
              m.__click = l;
              var g = L(m, !0);
              O(m), ne(
                (y, x, k, E) => {
                  Ce(p, "title", y), B(_, x), Ce(m, "title", k), B(g, E);
                },
                [
                  () => I("Insert (s)"),
                  () => I("Insert"),
                  () => I("Cancel (x)"),
                  () => I("Cancel")
                ]
              ), V(d, f);
            }
          }
        });
      },
      $$slots: { default: !0 }
    }),
    (c) => a = c,
    () => a
  ), ve({
    get rowData() {
      return t();
    },
    set rowData(c) {
      t(c), ee();
    },
    get onSubmit() {
      return i();
    },
    set onSubmit(c) {
      i(c), ee();
    },
    get onClose() {
      return r();
    },
    set onClose(c) {
      r(c), ee();
    }
  });
}
Lt(["click"]);
_e(iM, { rowData: {}, onSubmit: {}, onClose: {} }, [], [], !0);
var rM = X('<div class="button-menu-item-subgroup svelte-woewg3"><!></div>'), sM = (n, e) => {
  e?.chain().focus().mergeCells().run();
}, oM = (n, e) => {
  e?.chain().focus().splitCell().run();
}, aM = (n, e) => {
  eM(e);
}, lM = X('<div class="button-menu-item-subgroup svelte-woewg3"><button class="button-menu-item svelte-woewg3"> </button> <button class="button-menu-item svelte-woewg3"> </button> <button class="button-menu-item svelte-woewg3"> </button></div>'), cM = (n, e, t) => {
  e?.chain().focus().addRowBefore().command(t(e)).run();
}, uM = (n, e, t) => {
  e?.chain().focus().addRowAfter().command(t(e)).run();
}, dM = (n, e) => {
  e?.chain().focus().deleteRow().run();
}, hM = X('<div class="button-menu-item-subgroup svelte-woewg3"><button class="button-menu-item svelte-woewg3"> </button> <button class="button-menu-item svelte-woewg3"> </button> <button class="button-menu-item svelte-woewg3"> </button> <!></div>'), fM = (n, e, t) => {
  e?.chain().focus().addColumnBefore().command(t(e)).run();
}, pM = (n, e, t) => {
  e?.chain().focus().addColumnAfter().command(t(e)).run();
}, mM = (n, e) => {
  e?.chain().focus().deleteColumn().run();
}, gM = X('<div class="button-menu-item-subgroup svelte-woewg3"><button class="button-menu-item svelte-woewg3"> </button> <button class="button-menu-item svelte-woewg3"> </button> <button class="button-menu-item svelte-woewg3"> </button></div>'), _M = (n, e) => {
  JA(e);
}, bM = (n, e) => {
  e?.chain().focus().deleteTable().run();
}, vM = X('<div class="button-menu svelte-woewg3"><div class="button-menu-item-group button-menu-item-group--insert svelte-woewg3" role="menuitem" tabindex="0"><div class="button-menu-item-group-label svelte-woewg3"> </div> <!></div> <div class="button-menu-item-group svelte-woewg3" role="menuitem" tabindex="0"><div class="button-menu-item-group-label svelte-woewg3"> </div> <!></div> <div class="button-menu-item-group svelte-woewg3" role="menuitem" tabindex="0"><div class="button-menu-item-group-label svelte-woewg3"> </div> <!></div> <div class="button-menu-item-group svelte-woewg3"><div class="button-menu-item-group-label svelte-woewg3"> </div> <!></div> <div class="button-menu-item-group svelte-woewg3"><button class="button-menu-item svelte-woewg3"> </button> <button class="button-menu-item svelte-woewg3"> </button></div></div>'), yM = X('<button><!></button> <div class="button-menu-container svelte-woewg3"><!></div>', 1);
const xM = {
  hash: "svelte-woewg3",
  code: '.button-menu-container.svelte-woewg3 {position:relative;z-index:3;}.button-menu.svelte-woewg3 {position:absolute;left:0;top:0;display:flex;flex-direction:column;border-radius:4px;box-shadow:0 0 0 1px #ccc;background:white;}.button-menu-item-group.svelte-woewg3 {position:relative;background:white;&:first-child {border-top-left-radius:4px;border-top-right-radius:4px;}&:hover .button-menu-item-group-label:where(.svelte-woewg3) {background:#dee0e2;}}.button-menu-item-group--insert.svelte-woewg3 {border-bottom:1px solid #ccc;}.button-menu-item-group-label.svelte-woewg3 {font-size:0.85rem;padding:5px 10px;display:flex;align-items:center;justify-content:space-between;&:after {content:">";font-weight:bold;font-size:0.85rem;}}.button-menu-item-subgroup.svelte-woewg3 {position:absolute;left:calc(100% + 1px);top:0;border-radius:4px;.button-menu-item:where(.svelte-woewg3):first-child {border-top-left-radius:4px;border-top-right-radius:4px;}}.button-menu-item.svelte-woewg3 {font-size:0.85rem;border:none;margin:0;display:flex;align-items:center;justify-content:flex-start;padding:5px 10px;width:100%;background:white;box-shadow:0 0 0 1px #ccc;white-space:nowrap;&:last-child {border-bottom-left-radius:4px;border-bottom-right-radius:4px;}&:hover {background:#dee0e2;}}'
};
function w0(n, e) {
  be(e, !0), Ft(n, xM);
  const t = e.$$host, { tiptap: i } = t;
  t.addEventListener("click", u);
  let r = ce(!1), s = ce(De(i?.isActive("table"))), o = ce(!1), a = ce(!1);
  const l = () => {
    if (!i)
      return;
    U(s, i.isActive("table"), !0);
    const w = T(s) ? cn(i.state) : null;
    if (w) {
      const v = /* @__PURE__ */ new Set();
      let A = !1;
      const b = w.map;
      e: for (let C = w.top; C < w.bottom; C++)
        for (let M = w.left; M < w.right; M++) {
          const z = b.map[C * b.width + M], D = w.table.nodeAt(z);
          if (D && (v.add(D), A = D.attrs.colspan > 1 || D.attrs.rowspan > 1, A && v.size > 1))
            break e;
        }
      U(a, A, !0), U(o, v.size > 1);
    }
  };
  i?.on("update", l), i?.on("selectionUpdate", l);
  function c(w, v) {
    if (!i)
      return;
    const A = O_(i.schema, w, v, !1, i.schema.nodes.textBlock.create());
    A.attrs.style = "width: 100%;", i.chain().command(({ tr: b }) => {
      const C = b.selection.from + 1;
      return b.replaceSelectionWith(A).scrollIntoView().setSelection(ue.near(b.doc.resolve(C))), !0;
    }).run(), U(r, !1);
  }
  function u(w) {
    i && (w.stopPropagation(), U(r, !T(r)));
  }
  function d() {
    U(r, !1);
  }
  Ae(() => (document.addEventListener("click", d), () => {
    document.removeEventListener("click", d);
  }));
  let h = ce(De({}));
  const f = (w) => {
    U(h, { [w]: !0 }, !0);
  };
  Ae(() => {
    T(r) || U(h, {}, !0);
  });
  const p = (w) => {
    const v = /* @__PURE__ */ new Set(), A = w.state.doc.nodeAt(w.state.selection.$anchor.before(1));
    return A && A.type.name === "table" && A.forEach((b) => {
      b.forEach((C) => {
        v.add(C);
      });
    }), v;
  }, _ = (w) => {
    const v = p(w);
    return ({ tr: A }) => {
      let b = A.selection.$anchor.before(1);
      const C = A.doc.nodeAt(b);
      if (C && C.type.name === "table") {
        const M = document.createElement("div"), z = document.createElement("div");
        M.style.cssText = C.attrs.style || "", z.style.borderWidth = M.style.borderWidth;
        const D = z.style.cssText;
        C.forEach((H, q) => {
          H.forEach((G, ae) => {
            if (!v.has(G)) {
              const Y = b + q + ae + 2, le = Y + 1, de = Y + G.nodeSize - 1;
              A.setNodeMarkup(Y, void 0, { ...G.attrs, style: D }), A.replaceWith(le, de, w.schema.nodes.textBlock.create());
            }
          });
        });
      }
      return !0;
    };
  }, m = (w, v) => {
    w.addEventListener("mouseenter", () => T(h)[v] = !0), w.addEventListener("mouseleave", () => T(h)[v] = !1), w.addEventListener("focus", () => f(v)), w.addEventListener("click", (A) => {
      A.target instanceof HTMLElement && (A.target === w || A.target.parentElement === w) && A.stopPropagation();
    });
  };
  var g = yM(), y = Me(g), x = L(y);
  Kt(x, () => $A), O(y), Ye(y, (w, v) => yn?.(w, v), () => I("Table"));
  var k = F(y, 2), E = L(k);
  {
    var S = (w) => {
      var v = vM(), A = L(v), b = L(A), C = L(b, !0);
      O(b);
      var M = F(b, 2);
      {
        var z = (P) => {
          var Z = rM(), he = L(Z);
          v0(he, { onInsert: c }), O(Z), V(P, Z);
        };
        it(M, (P) => {
          T(h).insert && P(z);
        });
      }
      O(A), Ye(A, (P, Z) => m?.(P, Z), () => "insert");
      var D = F(A, 2), H = L(D), q = L(H, !0);
      O(H);
      var G = F(H, 2);
      {
        var ae = (P) => {
          var Z = lM(), he = L(Z);
          he.__click = [sM, i];
          var j = L(he, !0);
          O(he);
          var Pe = F(he, 2);
          Pe.__click = [oM, i];
          var et = L(Pe, !0);
          O(Pe);
          var Ue = F(Pe, 2);
          Ue.__click = [aM, i];
          var Et = L(Ue, !0);
          O(Ue), O(Z), ne(
            (Zt, lt, Pt) => {
              he.disabled = !(T(s) && T(o)), B(j, Zt), Pe.disabled = !(T(s) && T(a)), B(et, lt), Ue.disabled = !T(s), B(Et, Pt);
            },
            [
              () => I("Merge cells"),
              () => I("Split cell"),
              () => I("Cell properties")
            ]
          ), V(P, Z);
        };
        it(G, (P) => {
          T(h).cell && P(ae);
        });
      }
      O(D), Ye(D, (P, Z) => m?.(P, Z), () => "cell");
      var Y = F(D, 2), le = L(Y), de = L(le, !0);
      O(le);
      var ot = F(le, 2);
      {
        var ye = (P) => {
          var Z = hM(), he = L(Z);
          he.__click = [cM, i, _];
          var j = L(he, !0);
          O(he);
          var Pe = F(he, 2);
          Pe.__click = [uM, i, _];
          var et = L(Pe, !0);
          O(Pe);
          var Ue = F(Pe, 2);
          Ue.__click = [dM, i];
          var Et = L(Ue, !0);
          O(Ue);
          var Zt = F(Ue, 2);
          it(Zt, (lt) => {
          }), O(Z), ne(
            (lt, Pt, Ie) => {
              he.disabled = !T(s), B(j, lt), Pe.disabled = !T(s), B(et, Pt), Ue.disabled = !T(s), B(Et, Ie);
            },
            [
              () => I("Insert row before"),
              () => I("Insert row after"),
              () => I("Delete row")
            ]
          ), V(P, Z);
        };
        it(ot, (P) => {
          T(h).row && P(ye);
        });
      }
      O(Y), Ye(Y, (P, Z) => m?.(P, Z), () => "row");
      var Qe = F(Y, 2), we = L(Qe), R = L(we, !0);
      O(we);
      var ft = F(we, 2);
      {
        var me = (P) => {
          var Z = gM(), he = L(Z);
          he.__click = [fM, i, _];
          var j = L(he, !0);
          O(he);
          var Pe = F(he, 2);
          Pe.__click = [pM, i, _];
          var et = L(Pe, !0);
          O(Pe);
          var Ue = F(Pe, 2);
          Ue.__click = [mM, i];
          var Et = L(Ue, !0);
          O(Ue), O(Z), ne(
            (Zt, lt, Pt) => {
              he.disabled = !T(s), B(j, Zt), Pe.disabled = !T(s), B(et, lt), Ue.disabled = !T(s), B(Et, Pt);
            },
            [
              () => I("Insert column before"),
              () => I("Insert column after"),
              () => I("Delete column")
            ]
          ), V(P, Z);
        };
        it(ft, (P) => {
          T(h).col && P(me);
        });
      }
      O(Qe), Ye(Qe, (P, Z) => m?.(P, Z), () => "col");
      var vt = F(Qe, 2), at = L(vt);
      at.__click = [_M, i];
      var te = L(at, !0);
      O(at);
      var yt = F(at, 2);
      yt.__click = [bM, i];
      var ge = L(yt, !0);
      O(yt), O(vt), O(v), ne(
        (P, Z, he, j, Pe, et) => {
          B(C, P), B(q, Z), B(de, he), B(R, j), at.disabled = !T(s), B(te, Pe), yt.disabled = !T(s), B(ge, et);
        },
        [
          () => I("Insert table"),
          () => I("Cell"),
          () => I("Row"),
          () => I("Column"),
          () => I("Table properties"),
          () => I("Delete table")
        ]
      ), V(w, v);
    };
    it(E, (w) => {
      T(r) && w(S);
    });
  }
  O(k), V(n, g), ve();
}
Lt(["click"]);
_e(w0, {}, [], [], !0, Yt);
function wM(n, e, t) {
  e && (n.stopPropagation(), U(t, !T(t)));
}
var kM = (n, e, t) => e(T(t).value), SM = X("<button><div> </div></button>"), EM = X('<div class="options svelte-osezha"></div>'), CM = X('<div class="dropdown svelte-osezha"><button class="selected svelte-osezha"> <span class="arrow svelte-osezha"></span></button> <!></div>');
const TM = {
  hash: "svelte-osezha",
  code: ".dropdown.svelte-osezha {position:relative;width:150px;}.selected.svelte-osezha {width:100%;padding:4px 8px;border:1px solid #ccc;border-radius:4px;background-color:white;font-size:14px;cursor:pointer;display:flex;justify-content:space-between;align-items:center;}.arrow.svelte-osezha {width:6px;height:6px;border-right:1px solid #666;border-bottom:1px solid #666;transform:rotate(45deg);margin-left:4px;position:relative;top:-2px;}.options.svelte-osezha {position:absolute;top:100%;left:0;right:0;background:white;border:1px solid #ccc;border-radius:4px;margin-top:4px;box-shadow:0 2px 4px rgba(0, 0, 0, 0.1);z-index:1000;}.option.svelte-osezha {display:block;width:100%;text-align:left;border:none;background:white;padding:8px;cursor:pointer;}.option.svelte-osezha:hover {background-color:#f5f5f5;}.option.active.svelte-osezha {background-color:#e0e0e0;}.h1.svelte-osezha {font-size:1.8em;font-weight:bold;}.h2.svelte-osezha {font-size:1.5em;font-weight:bold;}.h3.svelte-osezha {font-size:1.3em;font-weight:bold;}.h4.svelte-osezha {font-size:1.2em;font-weight:bold;}.h5.svelte-osezha {font-size:1.1em;font-weight:bold;}.h6.svelte-osezha {font-size:1em;font-weight:bold;}.paragraph.svelte-osezha {font-size:1em;}.pre.svelte-osezha {font-family:monospace;}"
};
function k0(n, e) {
  be(e, !0), Ft(n, TM);
  const t = [
    { value: "paragraph", label: I("Paragraph") },
    { value: "h1", label: I("Heading 1") },
    { value: "h2", label: I("Heading 2") },
    { value: "h3", label: I("Heading 3") },
    { value: "h4", label: I("Heading 4") },
    { value: "h5", label: I("Heading 5") },
    { value: "h6", label: I("Heading 6") },
    { value: "pre", label: I("Preformatted") }
  ], i = e.$$host, { options: r, tiptap: s } = i;
  let o = ce(!1);
  const l = (r.blocks ?? t).map((x) => typeof x == "string" ? t.find((k) => k.value === x) : x).filter((x) => x !== void 0);
  let c = ce(De(l[0].value));
  i.onEditorUpdate = () => {
    if (!s)
      return;
    const { $head: x } = s.state.selection, k = x.parent;
    k.type.name === "heading" ? U(c, `h${k.attrs.level}`) : U(c, k.type.name, !0), l.some((E) => E.value === T(c)) || U(c, l[0].value, !0);
  };
  function u(x) {
    if (x === "paragraph" || x === "pre")
      s?.chain().focus().setNode(x).run();
    else if (x.match(/^h[1-6]$/)) {
      const k = parseInt(x.substring(1));
      s?.chain().focus().setHeading({ level: k }).run();
    }
    U(c, x, !0), U(o, !1);
  }
  function d() {
    U(o, !1);
  }
  let h, f = ce(!1);
  Ae(() => {
    if (!T(f))
      return U(f, !0), document.addEventListener("click", d), () => {
        document.removeEventListener("click", d);
      };
  });
  var p = CM(), _ = L(p);
  _.__click = [wM, s, o];
  var m = L(_);
  Tp(), O(_);
  var g = F(_, 2);
  {
    var y = (x) => {
      var k = EM();
      ut(k, 21, () => l, (E) => E.value, (E, S) => {
        var w = SM();
        let v;
        w.__click = [kM, u, S];
        var A = L(w), b = L(A, !0);
        O(A), O(w), ne(
          (C) => {
            v = ht(w, 1, "option svelte-osezha", null, v, C), ht(A, 1, U_(T(S).value), "svelte-osezha"), B(b, T(S).label);
          },
          [
            () => ({
              active: T(c) === T(S).value
            })
          ]
        ), V(E, w);
      }), O(k), V(x, k);
    };
    it(g, (x) => {
      T(o) && x(y);
    });
  }
  O(p), We(p, (x) => h = x, () => h), ne((x) => B(m, `${x ?? ""} `), [
    () => l.find((x) => x.value === T(c))?.label
  ]), V(n, p), ve();
}
Lt(["click"]);
_e(k0, {}, [], [], !0, Yt);
const AM = `<svg width="24" height="24"
    xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" d="M10.384 11.53h3.18l-1.547-4.504h-.034l-1.599 4.504zM10.642 4h2.768L18 16.275h-2.802l-.929-2.733H9.68l-.963 2.733H6L10.642 4z" />
    <rect x="4" y="18" width="16" height="3" rx=".5" fill="currentColor"/>
</svg>
`;
var MM = (n, e, t) => {
  n.stopPropagation(), e()(t);
}, OM = (n, e, t) => e(n, t), NM = X('<div class="color-item svelte-1bm8p55" role="button" tabindex="0"></div>'), LM = X('<div class="color-panel svelte-1bm8p55"></div>');
const RM = {
  hash: "svelte-1bm8p55",
  code: ".color-panel.svelte-1bm8p55 {position:absolute;top:0;left:0;display:grid;grid-template-columns:repeat(6, 1fr);gap:4px;padding:8px;background:white;border:1px solid #ddd;border-radius:4px;box-shadow:0 2px 4px rgba(0, 0, 0, 0.1);width:188px;z-index:1000;}.color-item.svelte-1bm8p55 {width:24px;height:24px;border-radius:4px;cursor:pointer;border:1px solid #ddd;}.color-item.svelte-1bm8p55:hover {transform:scale(1.1);transition:transform 0.2s;}"
};
function hd(n, e) {
  be(e, !0), Ft(n, RM);
  const t = Q(e, "colors", 7), i = Q(e, "onSelect", 7);
  function r(o, a) {
    o.key === "Enter" && (o.stopPropagation(), i()(a));
  }
  var s = LM();
  return ut(s, 20, t, (o) => o, (o, a) => {
    var l = NM();
    l.__click = [MM, i, a], l.__keydown = [OM, r, a], ne(() => {
      ks(l, `background-color: ${a ?? ""}`), Ce(l, "aria-label", a);
    }), V(o, l);
  }), O(s), V(n, s), ve({
    get colors() {
      return t();
    },
    set colors(o) {
      t(o), ee();
    },
    get onSelect() {
      return i();
    },
    set onSelect(o) {
      i(o), ee();
    }
  });
}
Lt(["click", "keydown"]);
_e(hd, { colors: {}, onSelect: {} }, [], [], !0);
const S0 = [
  "#000000",
  "#002B76",
  "#1B4F2A",
  "#783F04",
  "#700000",
  "#351C75",
  "#6B6B6B",
  "#1155CC",
  "#38761D",
  "#B45F06",
  "#AC0000",
  "#674EA7",
  "#999999",
  "#4A86E8",
  "#6AA84F",
  "#E69138",
  "#DC3D3D",
  "#8E7CC3",
  "#D9D9D9",
  "#A4C2F4",
  "#B6D7A8",
  "#F9CB9C",
  "#EA9999",
  "#B4A7D6",
  "#F3F3F3",
  "#CFE2F3",
  "#D9EAD3",
  "#FFE6C4",
  "#F4CCCC",
  "#D9D2E9",
  "#FFFFFF",
  "#EAF1FB",
  "#EBF5EB",
  "#FFF8E1",
  "#FDEBEE",
  "#F2EFF9"
];
var IM = X('<button><!></button> <div class="color-panel-container svelte-gqoyg9"><!></div>', 1);
const PM = {
  hash: "svelte-gqoyg9",
  code: ".color-panel-container.svelte-gqoyg9 {position:relative;}"
};
function E0(n, e) {
  be(e, !0), Ft(n, PM);
  const t = e.$$host;
  t.addEventListener("click", c);
  const { options: i, tiptap: r } = t;
  let s = ce(!1);
  const o = i.presetColors ?? S0;
  let a = ce("#000000");
  t.onEditorUpdate = () => {
    U(a, r?.getAttributes("textStyle").color ?? "#000000", !0);
  };
  function l(y) {
    U(a, y, !0), r?.chain().focus().setColor(y).run(), U(s, !1);
  }
  function c(y) {
    r && (y.stopPropagation(), U(s, !T(s)));
  }
  function u() {
    U(s, !1);
  }
  Ae(() => (document.addEventListener("click", u), () => {
    document.removeEventListener("click", u);
  }));
  var d = IM(), h = Me(d);
  let f;
  var p = L(h);
  Kt(p, () => AM.replace(/fill="currentColor"/g, `fill="${T(a)}"`)), O(h), Ye(h, (y, x) => yn?.(y, x), () => I("Text Color"));
  var _ = F(h, 2), m = L(_);
  {
    var g = (y) => {
      hd(y, { colors: o, onSelect: l });
    };
    it(m, (y) => {
      T(s) && y(g);
    });
  }
  O(_), ne((y) => f = ht(h, 1, "", null, f, y), [
    () => ({ "tooltip-disabled": T(s) })
  ]), V(n, d), ve();
}
_e(E0, {}, [], [], !0, Yt);
const DM = `<?xml version="1.0" encoding="UTF-8"?>
<svg id="b"
    xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 72 72">
    <!-- Generator: Adobe Illustrator 29.3.1, SVG Export Plug-In . SVG Version: 2.1.0 Build 151)  -->
    <g id="c">
        <g id="d">
            <rect x="9" y="54.8" width="54" height="10.2" rx=".5" ry=".5" fill="rgba(0,0,0,0)"/>
            <path class="st1" d="M62.3,15.6l-10.1-9.7c-.5-.5-1.1-.7-1.7-.7h0c-.6,0-1.2.2-1.7.7l-28,26.7c-.5.4-.7,1.1-.7,1.6s.2,1.2.7,1.7l.9.8-12.5,11.9h16.8l4.2-3.9.9.8c.5.5,1.1.7,1.7.7.6,0,1.3-.2,1.7-.7l28-26.7c.5-.4.7-1.1.7-1.6s-.2-1.2-.7-1.7h0ZM45.7,28.5l-7.1-6.8,11.8-11.3,7.1,6.8-11.8,11.3Z"/>
        </g>
    </g>
</svg>
`;
var $M = X('<button><!></button> <div class="color-panel-container svelte-gqoyg9"><!></div>', 1);
const zM = {
  hash: "svelte-gqoyg9",
  code: ".color-panel-container.svelte-gqoyg9 {position:relative;}"
};
function C0(n, e) {
  be(e, !0), Ft(n, zM);
  const t = e.$$host;
  t.addEventListener("click", u);
  const { options: i, tiptap: r } = t;
  let s = ce(!1);
  const o = i.presetColors ?? S0, a = "rgba(0,0,0,0)";
  let l = ce(a);
  t.onEditorUpdate = () => {
    U(l, r?.getAttributes("textStyle").backgroundColor ?? a, !0);
  };
  function c(x) {
    U(l, x, !0), r?.chain().focus().setBackgroundColor(x).run(), U(s, !1);
  }
  function u(x) {
    r && (x.stopPropagation(), U(s, !T(s)));
  }
  function d() {
    U(s, !1);
  }
  Ae(() => (document.addEventListener("click", d), () => {
    document.removeEventListener("click", d);
  }));
  var h = $M(), f = Me(h);
  let p;
  var _ = L(f);
  Kt(_, () => DM.replace(/fill="rgba\(0,0,0,0\)"/g, `fill="${T(l)}"`)), O(f), Ye(f, (x, k) => yn?.(x, k), () => I("Highlight Color"));
  var m = F(f, 2), g = L(m);
  {
    var y = (x) => {
      hd(x, { colors: o, onSelect: c });
    };
    it(g, (x) => {
      T(s) && x(y);
    });
  }
  O(m), ne((x) => p = ht(f, 1, "", null, p, x), [
    () => ({ "tooltip-disabled": T(s) })
  ]), V(n, h), ve();
}
_e(C0, {}, [], [], !0, Yt);
const HM = `<svg width="72" height="72" viewBox="0 0 72 72" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_57_211)">
        <path d="M48 32.8H24V36H48V32.8Z" fill="black"/>
        <path d="M48 40.8H24V44H48V40.8Z" fill="black"/>
        <path d="M48 48.8H24V52H48V48.8Z" fill="black"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M51.2 15.2H47.2V12.8H41.6C41.6 9.71001 39.09 7.20001 36 7.20001C32.91 7.20001 30.4 9.71001 30.4 12.8H24.8V15.2H20.8C17.27 15.2 14.4 18.07 14.4 21.6V58.4C14.4 61.93 17.27 64.8 20.8 64.8H51.2C54.73 64.8 57.6 61.93 57.6 58.4V21.6C57.6 18.07 54.73 15.2 51.2 15.2ZM52.8 58.4C52.8 59.28 52.08 60 51.2 60H20.8C19.92 60 19.2 59.28 19.2 58.4V21.6C19.2 20.72 19.92 20 20.8 20H24.8V22.4H47.2V20H51.2C52.08 20 52.8 20.72 52.8 21.6V58.4Z" fill="black"/>
    </g>
    <defs>
        <clipPath id="clip0_57_211">
            <rect width="72" height="72" fill="white"/>
        </clipPath>
    </defs>
</svg>
`;
const {
  entries: T0,
  setPrototypeOf: ap,
  isFrozen: BM,
  getPrototypeOf: FM,
  getOwnPropertyDescriptor: VM
} = Object;
let {
  freeze: Ht,
  seal: ln,
  create: A0
} = Object, {
  apply: Gc,
  construct: Jc
} = typeof Reflect < "u" && Reflect;
Ht || (Ht = function(e) {
  return e;
});
ln || (ln = function(e) {
  return e;
});
Gc || (Gc = function(e, t, i) {
  return e.apply(t, i);
});
Jc || (Jc = function(e, t) {
  return new e(...t);
});
const ho = Bt(Array.prototype.forEach), jM = Bt(Array.prototype.lastIndexOf), lp = Bt(Array.prototype.pop), $r = Bt(Array.prototype.push), WM = Bt(Array.prototype.splice), xo = Bt(String.prototype.toLowerCase), ec = Bt(String.prototype.toString), cp = Bt(String.prototype.match), zr = Bt(String.prototype.replace), UM = Bt(String.prototype.indexOf), KM = Bt(String.prototype.trim), hn = Bt(Object.prototype.hasOwnProperty), Dt = Bt(RegExp.prototype.test), Hr = qM(TypeError);
function Bt(n) {
  return function(e) {
    e instanceof RegExp && (e.lastIndex = 0);
    for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
      i[r - 1] = arguments[r];
    return Gc(n, e, i);
  };
}
function qM(n) {
  return function() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
      t[i] = arguments[i];
    return Jc(n, t);
  };
}
function Se(n, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : xo;
  ap && ap(n, null);
  let i = e.length;
  for (; i--; ) {
    let r = e[i];
    if (typeof r == "string") {
      const s = t(r);
      s !== r && (BM(e) || (e[i] = s), r = s);
    }
    n[r] = !0;
  }
  return n;
}
function GM(n) {
  for (let e = 0; e < n.length; e++)
    hn(n, e) || (n[e] = null);
  return n;
}
function Bn(n) {
  const e = A0(null);
  for (const [t, i] of T0(n))
    hn(n, t) && (Array.isArray(i) ? e[t] = GM(i) : i && typeof i == "object" && i.constructor === Object ? e[t] = Bn(i) : e[t] = i);
  return e;
}
function Br(n, e) {
  for (; n !== null; ) {
    const i = VM(n, e);
    if (i) {
      if (i.get)
        return Bt(i.get);
      if (typeof i.value == "function")
        return Bt(i.value);
    }
    n = FM(n);
  }
  function t() {
    return null;
  }
  return t;
}
const up = Ht(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), tc = Ht(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), nc = Ht(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), JM = Ht(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), ic = Ht(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), XM = Ht(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), dp = Ht(["#text"]), hp = Ht(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), rc = Ht(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), fp = Ht(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), fo = Ht(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), YM = ln(/\{\{[\w\W]*|[\w\W]*\}\}/gm), ZM = ln(/<%[\w\W]*|[\w\W]*%>/gm), QM = ln(/\$\{[\w\W]*/gm), eO = ln(/^data-[\-\w.\u00B7-\uFFFF]+$/), tO = ln(/^aria-[\-\w]+$/), M0 = ln(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), nO = ln(/^(?:\w+script|data):/i), iO = ln(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), O0 = ln(/^html$/i), rO = ln(/^[a-z][.\w]*(-[.\w]+)+$/i);
var pp = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: tO,
  ATTR_WHITESPACE: iO,
  CUSTOM_ELEMENT: rO,
  DATA_ATTR: eO,
  DOCTYPE_NAME: O0,
  ERB_EXPR: ZM,
  IS_ALLOWED_URI: M0,
  IS_SCRIPT_OR_DATA: nO,
  MUSTACHE_EXPR: YM,
  TMPLIT_EXPR: QM
});
const Fr = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, sO = function() {
  return typeof window > "u" ? null : window;
}, oO = function(e, t) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let i = null;
  const r = "data-tt-policy-suffix";
  t && t.hasAttribute(r) && (i = t.getAttribute(r));
  const s = "dompurify" + (i ? "#" + i : "");
  try {
    return e.createPolicy(s, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + s + " could not be created."), null;
  }
}, mp = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function N0() {
  let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : sO();
  const e = (oe) => N0(oe);
  if (e.version = "3.2.6", e.removed = [], !n || !n.document || n.document.nodeType !== Fr.document || !n.Element)
    return e.isSupported = !1, e;
  let {
    document: t
  } = n;
  const i = t, r = i.currentScript, {
    DocumentFragment: s,
    HTMLTemplateElement: o,
    Node: a,
    Element: l,
    NodeFilter: c,
    NamedNodeMap: u = n.NamedNodeMap || n.MozNamedAttrMap,
    HTMLFormElement: d,
    DOMParser: h,
    trustedTypes: f
  } = n, p = l.prototype, _ = Br(p, "cloneNode"), m = Br(p, "remove"), g = Br(p, "nextSibling"), y = Br(p, "childNodes"), x = Br(p, "parentNode");
  if (typeof o == "function") {
    const oe = t.createElement("template");
    oe.content && oe.content.ownerDocument && (t = oe.content.ownerDocument);
  }
  let k, E = "";
  const {
    implementation: S,
    createNodeIterator: w,
    createDocumentFragment: v,
    getElementsByTagName: A
  } = t, {
    importNode: b
  } = i;
  let C = mp();
  e.isSupported = typeof T0 == "function" && typeof x == "function" && S && S.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: M,
    ERB_EXPR: z,
    TMPLIT_EXPR: D,
    DATA_ATTR: H,
    ARIA_ATTR: q,
    IS_SCRIPT_OR_DATA: G,
    ATTR_WHITESPACE: ae,
    CUSTOM_ELEMENT: Y
  } = pp;
  let {
    IS_ALLOWED_URI: le
  } = pp, de = null;
  const ot = Se({}, [...up, ...tc, ...nc, ...ic, ...dp]);
  let ye = null;
  const Qe = Se({}, [...hp, ...rc, ...fp, ...fo]);
  let we = Object.seal(A0(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), R = null, ft = null, me = !0, vt = !0, at = !1, te = !0, yt = !1, ge = !0, P = !1, Z = !1, he = !1, j = !1, Pe = !1, et = !1, Ue = !0, Et = !1;
  const Zt = "user-content-";
  let lt = !0, Pt = !1, Ie = {}, Be = null;
  const Le = Se({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let ke = null;
  const Ct = Se({}, ["audio", "video", "img", "source", "image", "track"]);
  let vi = null;
  const Jn = Se({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Fi = "http://www.w3.org/1998/Math/MathML", Sn = "http://www.w3.org/2000/svg", un = "http://www.w3.org/1999/xhtml";
  let Qt = un, Er = !1, Xn = null;
  const Ya = Se({}, [Fi, Sn, un], ec);
  let tt = Se({}, ["mi", "mo", "mn", "ms", "mtext"]), Vi = Se({}, ["annotation-xml"]);
  const Za = Se({}, ["title", "style", "font", "a", "script"]);
  let yi = null;
  const Qa = ["application/xhtml+xml", "text/html"], el = "text/html";
  let nt = null, Yn = null;
  const tl = t.createElement("form"), Is = function(N) {
    return N instanceof RegExp || N instanceof Function;
  }, Cr = function() {
    let N = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(Yn && Yn === N)) {
      if ((!N || typeof N != "object") && (N = {}), N = Bn(N), yi = // eslint-disable-next-line unicorn/prefer-includes
      Qa.indexOf(N.PARSER_MEDIA_TYPE) === -1 ? el : N.PARSER_MEDIA_TYPE, nt = yi === "application/xhtml+xml" ? ec : xo, de = hn(N, "ALLOWED_TAGS") ? Se({}, N.ALLOWED_TAGS, nt) : ot, ye = hn(N, "ALLOWED_ATTR") ? Se({}, N.ALLOWED_ATTR, nt) : Qe, Xn = hn(N, "ALLOWED_NAMESPACES") ? Se({}, N.ALLOWED_NAMESPACES, ec) : Ya, vi = hn(N, "ADD_URI_SAFE_ATTR") ? Se(Bn(Jn), N.ADD_URI_SAFE_ATTR, nt) : Jn, ke = hn(N, "ADD_DATA_URI_TAGS") ? Se(Bn(Ct), N.ADD_DATA_URI_TAGS, nt) : Ct, Be = hn(N, "FORBID_CONTENTS") ? Se({}, N.FORBID_CONTENTS, nt) : Le, R = hn(N, "FORBID_TAGS") ? Se({}, N.FORBID_TAGS, nt) : Bn({}), ft = hn(N, "FORBID_ATTR") ? Se({}, N.FORBID_ATTR, nt) : Bn({}), Ie = hn(N, "USE_PROFILES") ? N.USE_PROFILES : !1, me = N.ALLOW_ARIA_ATTR !== !1, vt = N.ALLOW_DATA_ATTR !== !1, at = N.ALLOW_UNKNOWN_PROTOCOLS || !1, te = N.ALLOW_SELF_CLOSE_IN_ATTR !== !1, yt = N.SAFE_FOR_TEMPLATES || !1, ge = N.SAFE_FOR_XML !== !1, P = N.WHOLE_DOCUMENT || !1, j = N.RETURN_DOM || !1, Pe = N.RETURN_DOM_FRAGMENT || !1, et = N.RETURN_TRUSTED_TYPE || !1, he = N.FORCE_BODY || !1, Ue = N.SANITIZE_DOM !== !1, Et = N.SANITIZE_NAMED_PROPS || !1, lt = N.KEEP_CONTENT !== !1, Pt = N.IN_PLACE || !1, le = N.ALLOWED_URI_REGEXP || M0, Qt = N.NAMESPACE || un, tt = N.MATHML_TEXT_INTEGRATION_POINTS || tt, Vi = N.HTML_INTEGRATION_POINTS || Vi, we = N.CUSTOM_ELEMENT_HANDLING || {}, N.CUSTOM_ELEMENT_HANDLING && Is(N.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (we.tagNameCheck = N.CUSTOM_ELEMENT_HANDLING.tagNameCheck), N.CUSTOM_ELEMENT_HANDLING && Is(N.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (we.attributeNameCheck = N.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), N.CUSTOM_ELEMENT_HANDLING && typeof N.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (we.allowCustomizedBuiltInElements = N.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), yt && (vt = !1), Pe && (j = !0), Ie && (de = Se({}, dp), ye = [], Ie.html === !0 && (Se(de, up), Se(ye, hp)), Ie.svg === !0 && (Se(de, tc), Se(ye, rc), Se(ye, fo)), Ie.svgFilters === !0 && (Se(de, nc), Se(ye, rc), Se(ye, fo)), Ie.mathMl === !0 && (Se(de, ic), Se(ye, fp), Se(ye, fo))), N.ADD_TAGS && (de === ot && (de = Bn(de)), Se(de, N.ADD_TAGS, nt)), N.ADD_ATTR && (ye === Qe && (ye = Bn(ye)), Se(ye, N.ADD_ATTR, nt)), N.ADD_URI_SAFE_ATTR && Se(vi, N.ADD_URI_SAFE_ATTR, nt), N.FORBID_CONTENTS && (Be === Le && (Be = Bn(Be)), Se(Be, N.FORBID_CONTENTS, nt)), lt && (de["#text"] = !0), P && Se(de, ["html", "head", "body"]), de.table && (Se(de, ["tbody"]), delete R.tbody), N.TRUSTED_TYPES_POLICY) {
        if (typeof N.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw Hr('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof N.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw Hr('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        k = N.TRUSTED_TYPES_POLICY, E = k.createHTML("");
      } else
        k === void 0 && (k = oO(f, r)), k !== null && typeof E == "string" && (E = k.createHTML(""));
      Ht && Ht(N), Yn = N;
    }
  }, Ps = Se({}, [...tc, ...nc, ...JM]), Ds = Se({}, [...ic, ...XM]), nl = function(N) {
    let K = x(N);
    (!K || !K.tagName) && (K = {
      namespaceURI: Qt,
      tagName: "template"
    });
    const ie = xo(N.tagName), Ve = xo(K.tagName);
    return Xn[N.namespaceURI] ? N.namespaceURI === Sn ? K.namespaceURI === un ? ie === "svg" : K.namespaceURI === Fi ? ie === "svg" && (Ve === "annotation-xml" || tt[Ve]) : !!Ps[ie] : N.namespaceURI === Fi ? K.namespaceURI === un ? ie === "math" : K.namespaceURI === Sn ? ie === "math" && Vi[Ve] : !!Ds[ie] : N.namespaceURI === un ? K.namespaceURI === Sn && !Vi[Ve] || K.namespaceURI === Fi && !tt[Ve] ? !1 : !Ds[ie] && (Za[ie] || !Ps[ie]) : !!(yi === "application/xhtml+xml" && Xn[N.namespaceURI]) : !1;
  }, en = function(N) {
    $r(e.removed, {
      element: N
    });
    try {
      x(N).removeChild(N);
    } catch {
      m(N);
    }
  }, Zn = function(N, K) {
    try {
      $r(e.removed, {
        attribute: K.getAttributeNode(N),
        from: K
      });
    } catch {
      $r(e.removed, {
        attribute: null,
        from: K
      });
    }
    if (K.removeAttribute(N), N === "is")
      if (j || Pe)
        try {
          en(K);
        } catch {
        }
      else
        try {
          K.setAttribute(N, "");
        } catch {
        }
  }, $s = function(N) {
    let K = null, ie = null;
    if (he)
      N = "<remove></remove>" + N;
    else {
      const ct = cp(N, /^[\r\n\t ]+/);
      ie = ct && ct[0];
    }
    yi === "application/xhtml+xml" && Qt === un && (N = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + N + "</body></html>");
    const Ve = k ? k.createHTML(N) : N;
    if (Qt === un)
      try {
        K = new h().parseFromString(Ve, yi);
      } catch {
      }
    if (!K || !K.documentElement) {
      K = S.createDocument(Qt, "template", null);
      try {
        K.documentElement.innerHTML = Er ? E : Ve;
      } catch {
      }
    }
    const Tt = K.body || K.documentElement;
    return N && ie && Tt.insertBefore(t.createTextNode(ie), Tt.childNodes[0] || null), Qt === un ? A.call(K, P ? "html" : "body")[0] : P ? K.documentElement : Tt;
  }, zs = function(N) {
    return w.call(
      N.ownerDocument || N,
      N,
      // eslint-disable-next-line no-bitwise
      c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT | c.SHOW_PROCESSING_INSTRUCTION | c.SHOW_CDATA_SECTION,
      null
    );
  }, Tr = function(N) {
    return N instanceof d && (typeof N.nodeName != "string" || typeof N.textContent != "string" || typeof N.removeChild != "function" || !(N.attributes instanceof u) || typeof N.removeAttribute != "function" || typeof N.setAttribute != "function" || typeof N.namespaceURI != "string" || typeof N.insertBefore != "function" || typeof N.hasChildNodes != "function");
  }, Hs = function(N) {
    return typeof a == "function" && N instanceof a;
  };
  function dn(oe, N, K) {
    ho(oe, (ie) => {
      ie.call(e, N, K, Yn);
    });
  }
  const Bs = function(N) {
    let K = null;
    if (dn(C.beforeSanitizeElements, N, null), Tr(N))
      return en(N), !0;
    const ie = nt(N.nodeName);
    if (dn(C.uponSanitizeElement, N, {
      tagName: ie,
      allowedTags: de
    }), ge && N.hasChildNodes() && !Hs(N.firstElementChild) && Dt(/<[/\w!]/g, N.innerHTML) && Dt(/<[/\w!]/g, N.textContent) || N.nodeType === Fr.progressingInstruction || ge && N.nodeType === Fr.comment && Dt(/<[/\w]/g, N.data))
      return en(N), !0;
    if (!de[ie] || R[ie]) {
      if (!R[ie] && pd(ie) && (we.tagNameCheck instanceof RegExp && Dt(we.tagNameCheck, ie) || we.tagNameCheck instanceof Function && we.tagNameCheck(ie)))
        return !1;
      if (lt && !Be[ie]) {
        const Ve = x(N) || N.parentNode, Tt = y(N) || N.childNodes;
        if (Tt && Ve) {
          const ct = Tt.length;
          for (let Vt = ct - 1; Vt >= 0; --Vt) {
            const In = _(Tt[Vt], !0);
            In.__removalCount = (N.__removalCount || 0) + 1, Ve.insertBefore(In, g(N));
          }
        }
      }
      return en(N), !0;
    }
    return N instanceof l && !nl(N) || (ie === "noscript" || ie === "noembed" || ie === "noframes") && Dt(/<\/no(script|embed|frames)/i, N.innerHTML) ? (en(N), !0) : (yt && N.nodeType === Fr.text && (K = N.textContent, ho([M, z, D], (Ve) => {
      K = zr(K, Ve, " ");
    }), N.textContent !== K && ($r(e.removed, {
      element: N.cloneNode()
    }), N.textContent = K)), dn(C.afterSanitizeElements, N, null), !1);
  }, fd = function(N, K, ie) {
    if (Ue && (K === "id" || K === "name") && (ie in t || ie in tl))
      return !1;
    if (!(vt && !ft[K] && Dt(H, K))) {
      if (!(me && Dt(q, K))) {
        if (!ye[K] || ft[K]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(pd(N) && (we.tagNameCheck instanceof RegExp && Dt(we.tagNameCheck, N) || we.tagNameCheck instanceof Function && we.tagNameCheck(N)) && (we.attributeNameCheck instanceof RegExp && Dt(we.attributeNameCheck, K) || we.attributeNameCheck instanceof Function && we.attributeNameCheck(K)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            K === "is" && we.allowCustomizedBuiltInElements && (we.tagNameCheck instanceof RegExp && Dt(we.tagNameCheck, ie) || we.tagNameCheck instanceof Function && we.tagNameCheck(ie)))
          ) return !1;
        } else if (!vi[K]) {
          if (!Dt(le, zr(ie, ae, ""))) {
            if (!((K === "src" || K === "xlink:href" || K === "href") && N !== "script" && UM(ie, "data:") === 0 && ke[N])) {
              if (!(at && !Dt(G, zr(ie, ae, "")))) {
                if (ie)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, pd = function(N) {
    return N !== "annotation-xml" && cp(N, Y);
  }, md = function(N) {
    dn(C.beforeSanitizeAttributes, N, null);
    const {
      attributes: K
    } = N;
    if (!K || Tr(N))
      return;
    const ie = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: ye,
      forceKeepAttr: void 0
    };
    let Ve = K.length;
    for (; Ve--; ) {
      const Tt = K[Ve], {
        name: ct,
        namespaceURI: Vt,
        value: In
      } = Tt, Ar = nt(ct), il = In;
      let At = ct === "value" ? il : KM(il);
      if (ie.attrName = Ar, ie.attrValue = At, ie.keepAttr = !0, ie.forceKeepAttr = void 0, dn(C.uponSanitizeAttribute, N, ie), At = ie.attrValue, Et && (Ar === "id" || Ar === "name") && (Zn(ct, N), At = Zt + At), ge && Dt(/((--!?|])>)|<\/(style|title)/i, At)) {
        Zn(ct, N);
        continue;
      }
      if (ie.forceKeepAttr)
        continue;
      if (!ie.keepAttr) {
        Zn(ct, N);
        continue;
      }
      if (!te && Dt(/\/>/i, At)) {
        Zn(ct, N);
        continue;
      }
      yt && ho([M, z, D], (_d) => {
        At = zr(At, _d, " ");
      });
      const gd = nt(N.nodeName);
      if (!fd(gd, Ar, At)) {
        Zn(ct, N);
        continue;
      }
      if (k && typeof f == "object" && typeof f.getAttributeType == "function" && !Vt)
        switch (f.getAttributeType(gd, Ar)) {
          case "TrustedHTML": {
            At = k.createHTML(At);
            break;
          }
          case "TrustedScriptURL": {
            At = k.createScriptURL(At);
            break;
          }
        }
      if (At !== il)
        try {
          Vt ? N.setAttributeNS(Vt, ct, At) : N.setAttribute(ct, At), Tr(N) ? en(N) : lp(e.removed);
        } catch {
          Zn(ct, N);
        }
    }
    dn(C.afterSanitizeAttributes, N, null);
  }, G0 = function oe(N) {
    let K = null;
    const ie = zs(N);
    for (dn(C.beforeSanitizeShadowDOM, N, null); K = ie.nextNode(); )
      dn(C.uponSanitizeShadowNode, K, null), Bs(K), md(K), K.content instanceof s && oe(K.content);
    dn(C.afterSanitizeShadowDOM, N, null);
  };
  return e.sanitize = function(oe) {
    let N = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, K = null, ie = null, Ve = null, Tt = null;
    if (Er = !oe, Er && (oe = "<!-->"), typeof oe != "string" && !Hs(oe))
      if (typeof oe.toString == "function") {
        if (oe = oe.toString(), typeof oe != "string")
          throw Hr("dirty is not a string, aborting");
      } else
        throw Hr("toString is not a function");
    if (!e.isSupported)
      return oe;
    if (Z || Cr(N), e.removed = [], typeof oe == "string" && (Pt = !1), Pt) {
      if (oe.nodeName) {
        const In = nt(oe.nodeName);
        if (!de[In] || R[In])
          throw Hr("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (oe instanceof a)
      K = $s("<!---->"), ie = K.ownerDocument.importNode(oe, !0), ie.nodeType === Fr.element && ie.nodeName === "BODY" || ie.nodeName === "HTML" ? K = ie : K.appendChild(ie);
    else {
      if (!j && !yt && !P && // eslint-disable-next-line unicorn/prefer-includes
      oe.indexOf("<") === -1)
        return k && et ? k.createHTML(oe) : oe;
      if (K = $s(oe), !K)
        return j ? null : et ? E : "";
    }
    K && he && en(K.firstChild);
    const ct = zs(Pt ? oe : K);
    for (; Ve = ct.nextNode(); )
      Bs(Ve), md(Ve), Ve.content instanceof s && G0(Ve.content);
    if (Pt)
      return oe;
    if (j) {
      if (Pe)
        for (Tt = v.call(K.ownerDocument); K.firstChild; )
          Tt.appendChild(K.firstChild);
      else
        Tt = K;
      return (ye.shadowroot || ye.shadowrootmode) && (Tt = b.call(i, Tt, !0)), Tt;
    }
    let Vt = P ? K.outerHTML : K.innerHTML;
    return P && de["!doctype"] && K.ownerDocument && K.ownerDocument.doctype && K.ownerDocument.doctype.name && Dt(O0, K.ownerDocument.doctype.name) && (Vt = "<!DOCTYPE " + K.ownerDocument.doctype.name + `>
` + Vt), yt && ho([M, z, D], (In) => {
      Vt = zr(Vt, In, " ");
    }), k && et ? k.createHTML(Vt) : Vt;
  }, e.setConfig = function() {
    let oe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Cr(oe), Z = !0;
  }, e.clearConfig = function() {
    Yn = null, Z = !1;
  }, e.isValidAttribute = function(oe, N, K) {
    Yn || Cr({});
    const ie = nt(oe), Ve = nt(N);
    return fd(ie, Ve, K);
  }, e.addHook = function(oe, N) {
    typeof N == "function" && $r(C[oe], N);
  }, e.removeHook = function(oe, N) {
    if (N !== void 0) {
      const K = jM(C[oe], N);
      return K === -1 ? void 0 : WM(C[oe], K, 1)[0];
    }
    return lp(C[oe]);
  }, e.removeHooks = function(oe) {
    C[oe] = [];
  }, e.removeAllHooks = function() {
    C = mp();
  }, e;
}
var aO = N0();
function lO(n, e, t) {
  const i = n.target;
  U(e, ""), t(i.value);
}
var cO = X("<option> </option>"), uO = X('<label for="boilerplate_text"> </label> <div id="boilerplate_text" class="form-control"><!></div>', 1), dO = X('<div class="form-group mb-3"><label for="boilerplate_title"> </label> <select id="boilerplate_title" class="form-control"></select> <div class="form-text"> </div></div> <div class="form-group mb-3"><!></div>', 1), hO = X('<button type="button" class="action primary button btn btn-primary"> </button> <button type="button" class="cancel action button mt-close-dialog btn btn-default"> </button>', 1);
function L0(n, e) {
  be(e, !0);
  const t = aO(window);
  let i = Q(e, "boilerplates", 7), r = Q(e, "onSubmit", 7), s = Q(e, "onClose", 7), o = ce(""), a = ce("");
  async function l(u) {
    U(a, i().find((d) => d.url === u)?.description || "", !0), U(o, await (await fetch(u)).text(), !0);
  }
  Z_(() => {
    i().length > 0 && l(i()[0].url);
  });
  let c;
  return wn(n, {
    size: "lg",
    $$events: {
      close(...u) {
        s()?.apply(this, u);
      }
    },
    children: (u, d) => {
      kn(u, {
        get close() {
          return c;
        },
        set close(h) {
          c = h;
        },
        $$slots: {
          title: (h, f) => {
            var p = vn();
            ne((_) => B(p, _), [() => I("Insert Boilerplate")]), V(h, p);
          },
          body: (h, f) => {
            var p = dO(), _ = Me(p), m = L(_), g = L(m, !0);
            O(m);
            var y = F(m, 2);
            y.__change = [
              lO,
              o,
              l
            ], ut(y, 21, i, (v) => v.url, (v, A) => {
              var b = cO(), C = {}, M = L(b, !0);
              O(b), ne(() => {
                C !== (C = T(A).url) && (b.value = (b.__value = T(A).url) == null ? "" : T(A).url), B(M, T(A).title);
              }), V(v, b);
            }), O(y);
            var x = F(y, 2), k = L(x, !0);
            O(x), O(_);
            var E = F(_, 2), S = L(E);
            {
              var w = (v) => {
                var A = uO(), b = Me(A), C = L(b, !0);
                O(b);
                var M = F(b, 2), z = L(M);
                Kt(z, () => t.sanitize(T(o))), O(M), ne((D) => B(C, D), [() => I("Text")]), V(v, A);
              };
              it(S, (v) => {
                T(o) && v(w);
              });
            }
            O(E), ne(
              (v) => {
                B(g, v), B(k, T(a));
              },
              [() => I("Boilerplate")]
            ), V(h, p);
          },
          footer: (h, f) => {
            var p = hO(), _ = Me(p);
            _.__click = () => {
              r()(T(o)), c();
            };
            var m = L(_, !0);
            O(_);
            var g = F(_, 2);
            g.__click = c;
            var y = L(g, !0);
            O(g), ne(
              (x, k, E, S) => {
                Ce(_, "title", x), B(m, k), Ce(g, "title", E), B(y, S);
              },
              [
                () => I("Insert (s)"),
                () => I("Insert"),
                () => I("Cancel (x)"),
                () => I("Cancel")
              ]
            ), V(h, p);
          }
        }
      });
    },
    $$slots: { default: !0 }
  }), ve({
    get boilerplates() {
      return i();
    },
    set boilerplates(u) {
      i(u), ee();
    },
    get onSubmit() {
      return r();
    },
    set onSubmit(u) {
      r(u), ee();
    },
    get onClose() {
      return s();
    },
    set onClose(u) {
      s(u), ee();
    }
  });
}
Lt(["change", "click"]);
_e(L0, { boilerplates: {}, onSubmit: {}, onClose: {} }, [], [], !0);
var fO = X("<button><!></button>");
function R0(n, e) {
  be(e, !0);
  const t = e.$$host;
  t.addEventListener("click", () => {
    const s = Rt(L0, {
      target: document.body,
      props: {
        boilerplates: t.options.boilerplates,
        onSubmit: (o) => {
          t.tiptap?.chain().focus().insertContent(o).run();
        },
        onClose: () => {
          st(s);
        }
      }
    });
  });
  var i = fO(), r = L(i);
  Kt(r, () => HM), O(i), Ye(i, (s, o) => yn?.(s, o), () => I("Insert Boilerplate")), V(n, i), ve();
}
_e(R0, {}, [], [], !0, Yt);
const pO = {
  bold: jT,
  italic: WT,
  underline: UT,
  strike: KT,
  bulletList: GT,
  orderedList: JT,
  horizontalRule: sA,
  blockquote: XT,
  unlink: qT,
  insertHtml: oA,
  source: aA,
  undo: YT,
  redo: ZT,
  removeFormat: QT,
  alignLeft: eA,
  alignCenter: tA,
  alignRight: nA,
  indent: iA,
  outdent: rA,
  fullScreen: lA,
  // @ts-ignore
  link: c0.element,
  // @ts-ignore
  file: f0.element,
  // @ts-ignore
  image: m0.element,
  // @ts-ignore
  structure: b0.element,
  // @ts-ignore
  table: w0.element,
  // @ts-ignore
  block: k0.element,
  // @ts-ignore
  foregroundColor: E0.element,
  // @ts-ignore
  backgroundColor: C0.element,
  // @ts-ignore
  boilerplate: R0.element,
  // for context toolbar
  // @ts-ignore
  previewLink: u0.element,
  // @ts-ignore
  editLink: h0.element,
  // @ts-ignore
  deleteImage: g0.element,
  // @ts-ignore
  editImage: _0.element
}, mO = {
  paragraph: "p",
  heading: "h1",
  bulletList: "ul",
  orderedList: "ol",
  listItem: "li",
  blockquote: "blockquote",
  horizontalRule: "hr",
  table: "table",
  tableRow: "tr",
  tableCell: "td",
  tableHeader: "th",
  hardBreak: "br",
  text: "",
  textBlock: ""
}, gO = (n) => mO[n] ?? n;
class _O extends Hb {
  onEditorUpdate() {
    if (!this.tiptap)
      return;
    const { selection: e } = this.tiptap.state, t = e.$head, i = [];
    for (let r = 1; r <= t.depth; r++) {
      const s = t.node(r);
      let o = gO(s.type.name);
      if (!o)
        continue;
      const a = s.attrs.textAlign;
      a && (o += `[align=${a}]`), i.push(o);
    }
    this.shadowRoot.textContent = i.join(" > ");
  }
}
const bO = {
  path: _O
}, I0 = document.createElement("style");
I0.textContent = Bb;
const Rs = (n) => class extends s0(n) {
  content = void 0;
  connectedCallback() {
    super.connectedCallback(), this.shadowRoot.appendChild(I0.cloneNode(!0));
  }
  onEditorSetPasteContent(e) {
    this.content = e;
  }
  isEditorItemAvailable() {
    return !0;
  }
  insertContent(e) {
    return cr.prototype.insertContent.bind(this)(e);
  }
  onEditorPaste() {
  }
}, vO = /* @__PURE__ */ new Set(["mtIndent", "pmSlice"]);
function yO(n, e) {
  T(e).every((i) => i.checked) ? T(e).forEach((i) => i.checked = !1) : T(e).forEach((i) => i.checked = !0);
}
function xO(n, e) {
  T(e).every((i) => i.checked) ? T(e).forEach((i) => i.checked = !1) : T(e).forEach((i) => i.checked = !0);
}
var wO = X('<li><label><input type="checkbox"> </label></li>'), kO = X('<h4 class="svelte-ecdfcs"> </h4> <div class="help-text svelte-ecdfcs"> </div> <ul class="svelte-ecdfcs"></ul> <div class="mt-checkbox-all svelte-ecdfcs"><label><input type="checkbox" name="all"> </label></div>', 1), SO = X('<li><label><input type="checkbox"> </label></li>'), EO = X('<h4 class="svelte-ecdfcs"> </h4> <div class="help-text svelte-ecdfcs"> </div> <ul class="svelte-ecdfcs"></ul> <div class="mt-checkbox-all svelte-ecdfcs"><label><input type="checkbox" name="all"> </label></div>', 1), CO = X('<div class="html-modal-modal-content svelte-ecdfcs"><!> <!></div>'), TO = X('<button type="button" class="action primary button btn btn-primary"> </button> <button type="button" class="cancel action button mt-close-dialog btn btn-default"> </button>', 1);
const AO = {
  hash: "svelte-ecdfcs",
  code: ".mt-checkbox-all.svelte-ecdfcs {margin-top:0.5rem;}.help-text.svelte-ecdfcs {margin-bottom:0.5rem;font-size:0.8rem;color:#666;}h4.svelte-ecdfcs {font-weight:bold;margin-top:1.5rem;}h4.svelte-ecdfcs:first-child {margin-top:0;}ul.svelte-ecdfcs {list-style:none;padding:0;}.html-modal-modal-content.svelte-ecdfcs {overflow-y:auto;max-height:580px;}"
};
function P0(n, e) {
  be(e, !0), Ft(n, AO);
  let t = Q(e, "keepDataAttributes", 7), i = Q(e, "htmlDocument", 7), r = Q(e, "onSubmit", 7), s = Q(e, "onClose", 7), o;
  const a = ce(De([]));
  i().body.querySelectorAll("*").forEach((d) => {
    const h = d.dataset;
    for (const f in h)
      vO.has(f) || T(a).find((p) => p.name === f) || T(a).push({ name: f, checked: t() });
  });
  const l = ce(De([]));
  i().body.querySelectorAll("[style]").forEach((d) => {
    const h = d.getAttribute("style");
    if (!h) return;
    h.split(";").map((p) => p.trim()).filter((p) => p).map((p) => {
      const [_] = p.split(":");
      return _.trim();
    }).forEach((p) => {
      T(l).find((_) => _.name === p) || T(l).push({ name: p, checked: !0 });
    });
  }), Ae(() => {
    o && T(a).length === 0 && T(l).length === 0 && o.click();
  });
  let c, u;
  return We(
    wn(n, {
      $$events: {
        close(...d) {
          s()?.apply(this, d);
        }
      },
      children: (d, h) => {
        kn(d, {
          get close() {
            return u;
          },
          set close(f) {
            u = f;
          },
          $$slots: {
            title: (f, p) => {
              var _ = vn();
              ne((m) => B(_, m), [() => I("Paste as HTML")]), V(f, _);
            },
            body: (f, p) => {
              var _ = CO(), m = L(_);
              {
                var g = (k) => {
                  var E = kO(), S = Me(E), w = L(S, !0);
                  O(S);
                  var v = F(S, 2), A = L(v, !0);
                  O(v);
                  var b = F(v, 2);
                  ut(b, 21, () => T(a), (H) => H.name, (H, q, G) => {
                    var ae = wO(), Y = L(ae), le = L(Y);
                    dt(le);
                    var de = F(le);
                    O(Y), O(ae), ne(() => {
                      Ce(le, "name", T(q).name), B(de, ` data-${T(q).name ?? ""}`);
                    }), Zf(le, () => T(q).checked, (ot) => T(q).checked = ot), V(H, ae);
                  }), O(b);
                  var C = F(b, 2), M = L(C), z = L(M);
                  dt(z), z.__change = [xO, a];
                  var D = F(z);
                  O(M), O(C), ne(
                    (H, q, G, ae) => {
                      B(w, H), B(A, q), Jf(z, G), B(D, ` ${ae ?? ""}`);
                    },
                    [
                      () => I("Data attributes"),
                      () => I("Select the data attributes you want to keep in the pasted HTML. Unselected attributes will be removed."),
                      () => T(a).every((H) => H.checked),
                      () => I("Select All")
                    ]
                  ), V(k, E);
                };
                it(m, (k) => {
                  T(a).length > 0 && k(g);
                });
              }
              var y = F(m, 2);
              {
                var x = (k) => {
                  var E = EO(), S = Me(E), w = L(S, !0);
                  O(S);
                  var v = F(S, 2), A = L(v, !0);
                  O(v);
                  var b = F(v, 2);
                  ut(b, 21, () => T(l), (H) => H.name, (H, q, G) => {
                    var ae = SO(), Y = L(ae), le = L(Y);
                    dt(le);
                    var de = F(le);
                    O(Y), O(ae), ne(() => {
                      Ce(le, "name", T(q).name), B(de, ` ${T(q).name ?? ""}`);
                    }), Zf(le, () => T(q).checked, (ot) => T(q).checked = ot), V(H, ae);
                  }), O(b);
                  var C = F(b, 2), M = L(C), z = L(M);
                  dt(z), z.__change = [yO, l];
                  var D = F(z);
                  O(M), O(C), ne(
                    (H, q, G, ae) => {
                      B(w, H), B(A, q), Jf(z, G), B(D, ` ${ae ?? ""}`);
                    },
                    [
                      () => I("Properties for style attributes"),
                      () => I("Select the properties you want to keep in the pasted HTML. Unselected properties will be removed."),
                      () => T(l).every((H) => H.checked),
                      () => I("Select All")
                    ]
                  ), V(k, E);
                };
                it(y, (k) => {
                  T(l).length > 0 && k(x);
                });
              }
              O(_), V(f, _);
            },
            footer: (f, p) => {
              var _ = TO(), m = Me(_);
              m.__click = () => {
                const k = T(l).filter((w) => !w.checked).map((w) => w.name), E = i().cloneNode(!0);
                E.querySelectorAll("[style]").forEach((w) => {
                  const v = w.style;
                  for (let A = v.length - 1; A >= 0; A--) {
                    const b = v[A];
                    k.includes(b) && v.removeProperty(b);
                  }
                });
                const S = T(a).filter((w) => !w.checked).map((w) => w.name);
                E.body.querySelectorAll("*").forEach((w) => {
                  const v = w.dataset;
                  for (const A in v)
                    S.includes(A) && delete w.dataset[A];
                }), r()(E), u();
              };
              var g = L(m, !0);
              O(m), We(m, (k) => o = k, () => o);
              var y = F(m, 2);
              y.__click = u;
              var x = L(y, !0);
              O(y), ne(
                (k, E, S, w) => {
                  Ce(m, "title", k), B(g, E), Ce(y, "title", S), B(x, w);
                },
                [
                  () => I("Insert (s)"),
                  () => I("Insert"),
                  () => I("Cancel (x)"),
                  () => I("Cancel")
                ]
              ), V(f, _);
            }
          }
        });
      },
      $$slots: { default: !0 }
    }),
    (d) => c = d,
    () => c
  ), ve({
    get keepDataAttributes() {
      return t();
    },
    set keepDataAttributes(d) {
      t(d), ee();
    },
    get htmlDocument() {
      return i();
    },
    set htmlDocument(d) {
      i(d), ee();
    },
    get onSubmit() {
      return r();
    },
    set onSubmit(d) {
      r(d), ee();
    },
    get onClose() {
      return s();
    },
    set onClose(d) {
      s(d), ee();
    }
  });
}
Lt(["change", "click"]);
_e(
  P0,
  {
    keepDataAttributes: {},
    htmlDocument: {},
    onSubmit: {},
    onClose: {}
  },
  [],
  [],
  !0
);
const MO = (n) => class extends Rs(n) {
  isEditorItemAvailable() {
    const e = this.content?.htmlDocument;
    if (!e)
      return !1;
    const t = e.body.childNodes;
    return !(t.length === 0 || t.length === 1 && t[0] instanceof HTMLParagraphElement && t[0].getAttribute("data-pm-slice") && [...t[0].childNodes].every((i) => i instanceof Text));
  }
};
var OO = X("<button> </button>");
function D0(n, e) {
  be(e, !0);
  const t = e.$$host;
  t.addEventListener("click", l);
  const { options: i, tiptap: r, editor: s } = t;
  let o = null;
  const a = (h = null) => {
    if (!r || !s)
      return;
    h || (h = t.content?.htmlDocument?.cloneNode(!0), h && !i.keepDataAttributes && h.body.querySelectorAll("*").forEach((_) => {
      for (const m in _.dataset)
        delete _.dataset[m];
    })), h && i.handler?.(h);
    const f = s.preprocessHTML(h?.body.innerHTML ?? ""), p = new ClipboardEvent("paste", { clipboardData: new DataTransfer() });
    p.clipboardData?.setData("text/html", f), p.clipboardData?.setData(V0, "1"), t.content?.transaction(() => {
      r.chain().undo().focus().run(), r.view.dom.dispatchEvent(p);
    }), t.parentElement?.dispatchEvent(new Event("paste-menu-item-applied")), c();
  };
  t.onEditorPaste = a;
  function l(h) {
    r && (h.stopPropagation(), o ? c() : o = Rt(P0, {
      target: document.body,
      props: {
        keepDataAttributes: !!i.keepDataAttributes,
        htmlDocument: t.content.htmlDocument,
        onSubmit: a,
        onClose: () => {
          c();
        }
      }
    }));
  }
  function c() {
    o && (st(o), o = null);
  }
  Ae(() => c);
  var u = OO(), d = L(u, !0);
  O(u), ne((h) => B(d, h), [() => `${I("Paste as HTML")}...`]), V(n, u), ve();
}
_e(D0, {}, [], [], !0, MO);
const NO = (n) => class extends Rs(n) {
  isEditorItemAvailable() {
    return /^https?:\/\/[^\s]+(\s*)?$/.test(this.content?.plainText ?? "");
  }
};
var LO = X("<button> </button>");
function $0(n, e) {
  be(e, !0);
  const t = e.$$host, i = /* @__PURE__ */ new WeakMap(), { editor: r, tiptap: s } = t;
  let o = null;
  const a = (h = void 0) => {
    const f = t.content;
    if (!f || !s)
      return;
    h ? i.set(f, h.text) : (i.has(f) || i.set(f, s.state.doc.textBetween(s.state.selection.from, s.state.selection.to) || f.plainText), h = {
      url: f.plainText,
      text: i.get(f),
      title: "",
      target: r?.options.toolbarOptions?.link?.defaultTarget || "_self"
    });
    const p = document.createElement("a");
    p.href = h.url, h.title && (p.title = h.title), p.target = h.target, p.textContent = h.text, t.insertContent(p.outerHTML), c();
  };
  t.onEditorPaste = a;
  const l = (h) => {
    s && (h.stopPropagation(), o ? c() : o = Rt(dd, {
      target: document.body,
      props: {
        linkData: {
          url: t.content.plainText,
          text: i.get(t.content) || t.content.plainText,
          title: "",
          target: r?.options.toolbarOptions?.link?.defaultTarget || "_self"
        },
        onSubmit: a,
        onClose: () => {
          c();
        }
      }
    }));
  };
  t.addEventListener("click", l);
  const c = () => {
    o && (st(o), o = null);
  };
  Ae(() => c);
  var u = LO(), d = L(u, !0);
  O(u), ne((h) => B(d, h), [() => I("Paste as link")]), V(n, u), ve();
}
_e($0, {}, [], [], !0, NO);
const RO = {}, Xa = async ({
  embedData: n,
  tiptap: e,
  editor: t
}) => e && t ? await (RO[`${n.url}-${n.maxwidth}-${n.maxheight}`] ||= e.commands.getEmbedObject(n)).catch((i) => (t.notify({
  level: "error",
  message: I("Failed to get embed object: ", i.toString())
}), {
  html: "",
  inline: void 0
})) : {
  html: "",
  inline: void 0
};
var IO = X('<div class="form-group mb-3"><label for="embed-url" class="form-label"> </label> <input type="url" id="embed-url" class="form-control"></div> <div class="form-group mb-3"><label for="embed-maxwidth" class="form-label"> </label> <input type="number" id="embed-maxwidth" class="form-control"></div> <div class="form-group mb-3"><label for="embed-maxheight" class="form-label"> </label> <input type="number" id="embed-maxheight" class="form-control"></div>', 1), PO = X('<button type="button" class="action primary button btn btn-primary"> </button> <button type="button" class="cancel action button mt-close-dialog btn btn-default"> </button>', 1);
function z0(n, e) {
  be(e, !0);
  let t = Q(e, "embedData", 7), i = Q(e, "onSubmit", 7), r = Q(e, "onClose", 7), s = ce(De(t().url)), o = ce(De(t().maxwidth)), a = ce(De(t().maxheight)), l;
  Ae(() => {
    l?.focus();
  });
  let c, u;
  return We(
    wn(n, {
      $$events: {
        close(...d) {
          r()?.apply(this, d);
        }
      },
      children: (d, h) => {
        kn(d, {
          get close() {
            return u;
          },
          set close(f) {
            u = f;
          },
          $$slots: {
            title: (f, p) => {
              var _ = vn();
              ne((m) => B(_, m), [() => I("oEmbed")]), V(f, _);
            },
            body: (f, p) => {
              var _ = IO(), m = Me(_), g = L(m), y = L(g, !0);
              O(g);
              var x = F(g, 2);
              dt(x), We(x, (M) => l = M, () => l), O(m);
              var k = F(m, 2), E = L(k), S = L(E, !0);
              O(E);
              var w = F(E, 2);
              dt(w), O(k);
              var v = F(k, 2), A = L(v), b = L(A, !0);
              O(A);
              var C = F(A, 2);
              dt(C), O(v), ne(
                (M, z, D) => {
                  B(y, M), B(S, z), B(b, D);
                },
                [
                  () => I("URL"),
                  () => I("Width"),
                  () => I("Height")
                ]
              ), St(x, () => T(s), (M) => U(s, M)), St(w, () => T(o), (M) => U(o, M)), St(C, () => T(a), (M) => U(a, M)), V(f, _);
            },
            footer: (f, p) => {
              var _ = PO(), m = Me(_);
              m.__click = () => {
                i()({
                  url: T(s),
                  maxwidth: T(o),
                  maxheight: T(a)
                }), u();
              };
              var g = L(m, !0);
              O(m);
              var y = F(m, 2);
              y.__click = u;
              var x = L(y, !0);
              O(y), ne(
                (k, E, S, w) => {
                  Ce(m, "title", k), B(g, E), Ce(y, "title", S), B(x, w);
                },
                [
                  () => I("Insert (s)"),
                  () => I("Insert"),
                  () => I("Cancel (x)"),
                  () => I("Cancel")
                ]
              ), V(f, _);
            }
          }
        });
      },
      $$slots: { default: !0 }
    }),
    (d) => c = d,
    () => c
  ), ve({
    get embedData() {
      return t();
    },
    set embedData(d) {
      t(d), ee();
    },
    get onSubmit() {
      return i();
    },
    set onSubmit(d) {
      i(d), ee();
    },
    get onClose() {
      return r();
    },
    set onClose(d) {
      r(d), ee();
    }
  });
}
Lt(["click"]);
_e(z0, { embedData: {}, onSubmit: {}, onClose: {} }, [], [], !0);
const DO = (n) => class extends Rs(n) {
  async isEditorItemAvailable() {
    const e = this.content?.plainText || "";
    if (!/^https?:\/\/[^\s]+(\s*)?$/.test(e) || !(await Xa({
      embedData: { url: e, maxwidth: 0, maxheight: 0 },
      tiptap: this.tiptap,
      editor: this.editor
    }))?.html)
      return !1;
    const i = this.content?.targetDomNode;
    return i instanceof HTMLElement && i?.tagName === "P" && i.childNodes.length === 0 ? cr.Priority.High : cr.Priority.Default;
  }
};
var $O = X("<button> </button>");
function H0(n, e) {
  be(e, !0);
  const t = e.$$host;
  t.addEventListener("click", a);
  const { editor: i, tiptap: r } = t;
  let s = null;
  const o = async (d = void 0) => {
    const h = t.content;
    if (!h || !r)
      return;
    d ??= {
      url: h.plainText,
      maxwidth: 0,
      maxheight: 0
    };
    const f = await Xa({ embedData: d, tiptap: t.tiptap, editor: i });
    f.html && (t.content?.transaction(() => {
      r.chain().undo().focus().run(), r.commands.insertEmbedObject(f.html);
    }), t.parentElement?.dispatchEvent(new Event("paste-menu-item-applied")), l());
  };
  t.onEditorPaste = o;
  function a(d) {
    r && (d.stopPropagation(), s ? l() : s = Rt(z0, {
      target: document.body,
      props: {
        embedData: { url: t.content.plainText },
        onSubmit: o,
        onClose: () => {
          l();
        }
      }
    }));
  }
  function l() {
    s && (st(s), s = null);
  }
  Ae(() => l);
  var c = $O(), u = L(c, !0);
  O(c), ne((d) => B(u, d), [() => I("Embed object")]), V(n, c), ve();
}
_e(H0, {}, [], [], !0, DO);
const zO = (n) => class extends Rs(n) {
  async isEditorItemAvailable() {
    const e = this.content?.plainText || "";
    return /^https?:\/\/[^\s]+(\s*)?$/.test(e) ? !!(await Xa({
      embedData: { url: e, maxwidth: 0, maxheight: 0 },
      tiptap: this.tiptap,
      editor: this.editor
    })).inline : !1;
  }
};
var HO = X("<button> </button>");
function B0(n, e) {
  be(e, !0);
  const t = e.$$host, i = () => {
    const o = t.content;
    o && Xa({
      embedData: {
        url: o.plainText,
        maxwidth: 0,
        maxheight: 0
      },
      tiptap: t.tiptap,
      editor: t.editor
    }).then((a) => {
      const l = a.inline;
      l && t.insertContent(l);
    });
  };
  t.onEditorPaste = i, t.addEventListener("click", i);
  var r = HO(), s = L(r, !0);
  O(r), ne((o) => B(s, o), [() => I("Embed inline")]), V(n, r), ve();
}
_e(B0, {}, [], [], !0, zO);
const BO = (n) => class extends Rs(n) {
  isEditorItemAvailable() {
    return this.tiptap?.commands.isMarkdownConversionAvailable() && /^(#|```|- |\* |\d+\. |> |=+$|-+$)/m.test(this.content?.plainText ?? "") ? this.content?.htmlDocument ? cr.Priority.Default : cr.Priority.High : !1;
  }
};
var FO = X("<button> </button>");
function F0(n, e) {
  be(e, !0);
  const t = e.$$host, i = async () => {
    t.insertContent((await t.tiptap?.commands.markdownToHtml({ content: t.content?.plainText ?? "" }))?.content ?? "");
  };
  t.onEditorPaste = i, t.addEventListener("click", i);
  var r = FO(), s = L(r, !0);
  O(r), ne((o) => B(s, o), [() => I("Convert from Markdown")]), V(n, r), ve();
}
_e(F0, {}, [], [], !0, BO);
const V0 = "x-mt-rich-text-editor";
class VO extends cr {
  constructor() {
    super();
    const e = document.createElement("button");
    e.textContent = I("Paste as text"), this.shadowRoot.appendChild(e);
  }
  onEditorPaste() {
    const e = this.content?.plainText;
    e && this.insertContent({
      type: "text",
      text: e
    });
  }
  connectedCallback() {
    this.addEventListener("click", () => {
      this.onEditorPaste();
    });
  }
}
const jO = {
  text: VO,
  // @ts-ignore
  html: D0.element,
  // @ts-ignore
  link: $0.element,
  // @ts-ignore
  embed: H0.element,
  // @ts-ignore
  embedInline: B0.element,
  // @ts-ignore
  markdown: F0.element
}, WO = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-h-1">
    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
    <path d="M19 18v-8l-2 2" />
    <path d="M4 6v12" />
    <path d="M12 6v12" />
    <path d="M11 18h2" />
    <path d="M3 18h2" />
    <path d="M4 12h8" />
    <path d="M3 6h2" />
    <path d="M11 6h2" />
</svg>
`, UO = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-h-2">
    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
    <path d="M17 12a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0" />
    <path d="M4 6v12" />
    <path d="M12 6v12" />
    <path d="M11 18h2" />
    <path d="M3 18h2" />
    <path d="M4 12h8" />
    <path d="M3 6h2" />
    <path d="M11 6h2" />
</svg>
`, KO = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-h-3">
    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
    <path d="M19 14a2 2 0 1 0 -2 -2" />
    <path d="M17 16a2 2 0 1 0 2 -2" />
    <path d="M4 6v12" />
    <path d="M12 6v12" />
    <path d="M11 18h2" />
    <path d="M3 18h2" />
    <path d="M4 12h8" />
    <path d="M3 6h2" />
    <path d="M11 6h2" />
</svg>
`, qO = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-h-4">
    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
    <path d="M20 18v-8l-4 6h5" />
    <path d="M4 6v12" />
    <path d="M12 6v12" />
    <path d="M11 18h2" />
    <path d="M3 18h2" />
    <path d="M4 12h8" />
    <path d="M3 6h2" />
    <path d="M11 6h2" />
</svg>
`, GO = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-h-5">
    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
    <path d="M17 18h2a2 2 0 1 0 0 -4h-2v-4h4" />
    <path d="M4 6v12" />
    <path d="M12 6v12" />
    <path d="M11 18h2" />
    <path d="M3 18h2" />
    <path d="M4 12h8" />
    <path d="M3 6h2" />
    <path d="M11 6h2" />
</svg>
`, JO = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-h-6">
    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
    <path d="M19 14a2 2 0 1 0 0 4a2 2 0 0 0 0 -4z" />
    <path d="M21 12a2 2 0 1 0 -4 0v4" />
    <path d="M4 6v12" />
    <path d="M12 6v12" />
    <path d="M11 18h2" />
    <path d="M3 18h2" />
    <path d="M4 12h8" />
    <path d="M3 6h2" />
    <path d="M11 6h2" />
</svg>
`, XO = {
  1: WO,
  2: UO,
  3: KO,
  4: qO,
  5: GO,
  6: JO
};
class YO extends Fb {
  connectedCallback() {
    const e = this.dataset.mtRichTextEditorPanelItemVariant;
    if (!e)
      return;
    this.aliases = [`h${e}`, `heading${e}`];
    const t = document.createElement("button"), i = document.createElement("span");
    i.classList.add("icon"), i.innerHTML = XO[e];
    const r = document.createElement("span");
    r.textContent = I(`Heading ${e}`), t.appendChild(i), t.appendChild(r), this.shadowRoot.appendChild(t), this.addEventListener("click", () => {
      this.insertContent(`<h${e}></h${e}>`);
    });
  }
}
const ZO = {
  heading: YO
}, QO = {
  toolbar: pO,
  statusbar: bO,
  "paste-menu": jO,
  "quick-action": ZO
}, Sr = (n, e) => {
  const t = e.toLowerCase();
  if (t.includes("-") && window.customElements.get(t))
    return t;
  const i = `mt-rich-text-editor-${n}-item-${t}`;
  let r = window.customElements.get(i);
  if (!r) {
    if (r = QO[n][e], !r) {
      console.error(`Item for ${e} is not found`);
      return;
    }
    window.customElements.define(i, r);
  }
  return i;
};
var eN = X("<div></div>"), tN = X('<div class="toolbar-side svelte-1rk98em"></div>'), nN = X('<div class="toolbar-row svelte-1rk98em"></div>'), iN = X("<div></div>");
const rN = {
  hash: "svelte-1rk98em",
  code: `.toolbar.svelte-1rk98em {display:flex;flex-wrap:wrap;flex-direction:column;}.toolbar-row.svelte-1rk98em {display:flex;justify-content:space-between;border-bottom:1px solid #ccc;position:relative;}.toolbar-row.svelte-1rk98em::before {content:"";position:absolute;left:0;top:0;width:100%;height:90%;background-image:url("data:image/svg+xml;utf8,<svg width='100%' height='39' xmlns='http://www.w3.org/2000/svg'><line x1='0' y1='39' x2='10000' y2='39' stroke='%23ccc' stroke-width='2'/></svg>");background-repeat:repeat-y;background-size:100% 39px;}.toolbar-row.svelte-1rk98em:last-child {border-bottom:none;}.toolbar-side.svelte-1rk98em {display:flex;flex-wrap:wrap;}.toolbar-group.svelte-1rk98em {padding:0 4px;display:flex;}.toolbar-group.svelte-1rk98em:not(:last-child) {border-right:1px solid #ccc;white-space:nowrap;}.toolbar-item.svelte-1rk98em {display:inline-flex;align-items:center;justify-content:center;margin:2px 0 3px;height:34px;}.toolbar-item.is-active.svelte-1rk98em {background:#dee0e2;}

  /**
   * Inline
   */.toolbar--inline.svelte-1rk98em {position:absolute;display:none;z-index:1;border:1px solid #ccc;border-radius:4px;background:#fff;}.toolbar--inline.svelte-1rk98em::before {content:"";position:absolute;z-index:-1;top:50%;left:-8px;width:14px;height:14px;background:#fff;transform:translateY(-50%) rotate(45deg);border-left:1px solid #ccc;border-bottom:1px solid #ccc;box-shadow:-1px 1px 2px rgba(0, 0, 0, 0.03);}.toolbar--inline.svelte-1rk98em:not([data-is-new-line])::before {content:"";position:absolute;z-index:-1;top:-8px;left:20px;width:14px;height:14px;background:#fff;transform:translateX(-50%) rotate(45deg);border-left:1px solid #ccc;border-top:1px solid #ccc;border-bottom:none;box-shadow:-1px -1px 2px rgba(0, 0, 0, 0.03);}`
};
function j0(n, e) {
  be(e, !0), Ft(n, rN);
  const t = Q(e, "editor", 7), i = Q(e, "toolbar", 7), r = Q(e, "options", 7), s = Q(e, "inline", 7);
  let o = null;
  const a = {}, l = i().map((h) => h.map((f) => (f || []).map((p) => (p || []).map((_) => ({
    name: _,
    elementName: Sr("toolbar", _),
    options: r()[_] ?? {}
  })).filter((_) => _.elementName && _.options !== !1)).filter((p) => p.length > 0))).filter((h) => h.length > 0);
  function c() {
    for (const h in a)
      "onEditorUpdate" in a[h] && a[h].onEditorUpdate();
  }
  if (t().tiptap.on("selectionUpdate", c), t().tiptap.on("update", c), Ae(() => {
    c();
  }), s()) {
    let h = !1;
    const f = Q_(
      () => {
        if (!o || h)
          return;
        let p = !1, _ = !1;
        if (!t().tiptap.isFocused)
          p = !1;
        else if (t().tiptap.state.selection.empty) {
          const x = t().tiptap.state.selection.$head.parent;
          p = x.type.name === "paragraph" && x.content.size === 0, _ = !0;
        } else
          p = !0;
        if (!p) {
          o.style.display = "", o.style.transition = "";
          return;
        }
        o.style.display === "" && (o.style.display = "block", setTimeout(
          () => {
            o && (o.style.transition = "left 0.2s ease-in-out");
          },
          100
        ));
        const m = t().tiptap.view.dom.getBoundingClientRect(), { selection: g } = t().tiptap.view.state, y = t().tiptap.view.coordsAtPos(g.$to.pos);
        if (_)
          o.style.top = `${y.bottom - m.top - 30}px`, o.style.left = `${y.left - m.left + 20}px`, o.setAttribute("data-is-new-line", "true");
        else {
          const x = t().tiptap.view.coordsAtPos(g.$from.pos), k = x.left < y.left ? x : y;
          o.style.top = `${k.bottom - m.top + 15}px`, o.style.left = `${k.left - m.left}px`, o.removeAttribute("data-is-new-line");
        }
      },
      50
    );
    t().tiptap.on("selectionUpdate", f), t().tiptap.on("focus", f), t().tiptap.on("blur", f), f(), Ae(() => {
      const p = () => h = !0, _ = () => h = !1;
      return o?.addEventListener("mousedown", p, { capture: !0, passive: !0 }), document.addEventListener("mouseup", _, { capture: !0, passive: !0 }), () => {
        o?.removeEventListener("mousedown", p, { capture: !0 }), document.removeEventListener("mouseup", _, { capture: !0 });
      };
    });
  }
  function u(h, f) {
    return a[f] = h, "onEditorInit" in h && h.onEditorInit(t(), (r()[f] || void 0) ?? {}), {
      destroy() {
        delete a[f];
      }
    };
  }
  var d = iN();
  return ut(d, 21, () => l, bn, (h, f) => {
    var p = nN();
    ut(p, 21, () => T(f), bn, (_, m) => {
      var g = tN();
      ut(g, 21, () => T(m), bn, (y, x) => {
        var k = eN();
        ut(k, 21, () => T(x), bn, (E, S) => {
          var w = mi(), v = Me(w);
          kr(v, () => T(S).elementName, !1, (A, b) => {
            Ye(A, (C, M) => u?.(C, M), () => T(S).name), ht(A, 0, "toolbar-item svelte-1rk98em");
          }), V(E, w);
        }), O(k), ne(() => ht(k, 1, `toolbar-group ${T(x).length === 1 ? `toolbar-group--${T(x)[0].name}` : ""}`, "svelte-1rk98em")), V(y, k);
      }), O(g), V(_, g);
    }), O(p), V(h, p);
  }), O(d), We(d, (h) => o = h, () => o), ne(() => ht(d, 1, `toolbar ${(s() ? "toolbar--inline" : "") ?? ""}`, "svelte-1rk98em")), V(n, d), ve({
    get editor() {
      return t();
    },
    set editor(h) {
      t(h), ee();
    },
    get toolbar() {
      return i();
    },
    set toolbar(h) {
      i(h), ee();
    },
    get options() {
      return r();
    },
    set options(h) {
      r(h), ee();
    },
    get inline() {
      return s();
    },
    set inline(h) {
      s(h), ee();
    }
  });
}
_e(
  j0,
  {
    editor: {},
    toolbar: {},
    options: {},
    inline: {}
  },
  [],
  [],
  !0
);
class sN {
  #e;
  constructor({ target: e, editor: t, toolbar: i, options: r, inline: s }) {
    !i || i.length === 0 || (this.#e = Rt(j0, {
      target: e,
      props: {
        editor: t,
        toolbar: i,
        inline: s,
        options: r
      }
    }));
  }
  destroy() {
    this.#e && st(this.#e);
  }
}
var oN = X('<div class="statusbar-side svelte-1axc334"></div>'), aN = X('<div class="statusbar svelte-1axc334"></div>');
const lN = {
  hash: "svelte-1axc334",
  code: ".statusbar.svelte-1axc334 {display:flex;flex-wrap:wrap;justify-content:space-between;}.statusbar-side.svelte-1axc334 {display:flex;flex-wrap:wrap;}.statusbar-item.svelte-1axc334 {display:inline-flex;align-items:center;margin:2px 0 3px;border:none;background:none;border-radius:4px;padding:1px 5px;}"
};
function W0(n, e) {
  be(e, !0), Ft(n, lN);
  const t = Q(e, "editor", 7), i = Q(e, "statusbar", 7), r = Q(e, "options", 7), s = {}, o = i().map((u) => (u || []).map((d) => ({
    name: d,
    elementName: Sr("statusbar", d),
    options: r()[d] ?? {}
  })).filter((d) => d.elementName && d.options !== !1));
  function a() {
    for (const u in s)
      "onEditorUpdate" in s[u] && s[u].onEditorUpdate();
  }
  t().tiptap.on("selectionUpdate", a), t().tiptap.on("update", a), Ae(() => {
    a();
  });
  function l(u, d) {
    return s[d] = u, "onEditorInit" in u && u.onEditorInit(t(), r()[d] ?? {}), {
      destroy() {
        delete s[d];
      }
    };
  }
  var c = aN();
  return ut(c, 21, () => o, bn, (u, d) => {
    var h = oN();
    ut(h, 21, () => T(d), bn, (f, p) => {
      var _ = mi(), m = Me(_);
      kr(m, () => T(p).elementName, !1, (g, y) => {
        Ye(g, (x, k) => l?.(x, k), () => T(p).name), ht(g, 0, "statusbar-item svelte-1axc334");
      }), V(f, _);
    }), O(h), V(u, h);
  }), O(c), V(n, c), ve({
    get editor() {
      return t();
    },
    set editor(u) {
      t(u), ee();
    },
    get statusbar() {
      return i();
    },
    set statusbar(u) {
      i(u), ee();
    },
    get options() {
      return r();
    },
    set options(u) {
      r(u), ee();
    }
  });
}
_e(W0, { editor: {}, statusbar: {}, options: {} }, [], [], !0);
class cN {
  #e;
  constructor({ target: e, editor: t, statusbar: i, options: r, inline: s }) {
    s || i.length === 0 || (this.#e = Rt(W0, {
      target: e,
      props: {
        editor: t,
        statusbar: i,
        inline: s,
        options: r
      }
    }));
  }
  destroy() {
    this.#e && st(this.#e);
  }
}
const uN = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-clipboard">
    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
    <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" />
    <path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
</svg>
`, dN = /font-weight:\s*normal/, hN = ["P", "OL", "UL"], gp = (n) => n && hN.includes(n.tagName), fN = (n) => {
  Array.from(n.querySelectorAll("br")).filter((e) => gp(e.previousElementSibling) && gp(e.nextElementSibling)).forEach((e) => {
    e.parentNode?.removeChild(e);
  });
}, pN = (n) => {
  Array.from(n.querySelectorAll('b[style*="font-weight"]')).filter((e) => e.getAttribute("style")?.match(dN)).forEach((e) => {
    const t = n.createDocumentFragment();
    t.append(...e.childNodes), e.parentNode?.replaceChild(t, e);
  });
};
function mN(n) {
  n.querySelector('[id^="docs-internal-guid-"]') && (pN(n), fN(n));
}
const gN = /\bmso-list:[^;]*ignore/i, _N = /\bmso-list:[^;]*\bl(\d+)/i, bN = /\bmso-list:[^;]*\blevel(\d+)/i, vN = (n, e) => {
  const t = n.getAttribute("style"), i = t?.match(_N);
  if (!i)
    return null;
  const r = Number(i[1]), s = t?.match(bN), o = s ? Number(s[1]) : 1, a = new RegExp(`@list l${r}:level${o}\\s*\\{[^\\}]*mso-level-number-format:\\s*([\\w-]+)`, "i"), l = e.match(a), c = l && l[1] === "bullet" ? "bullet" : "ordered";
  return {
    id: r,
    indent: o,
    type: c,
    element: n
  };
}, yN = (n) => {
  const e = Array.from(n.querySelectorAll("[style*=mso-list]")), t = [], i = [];
  e.forEach((o) => {
    (o.getAttribute("style") || "").match(gN) ? t.push(o) : i.push(o);
  }), t.forEach((o) => o.parentNode?.removeChild(o));
  const r = n.documentElement.innerHTML, s = i.map((o) => vN(o, r)).filter((o) => o);
  for (; s.length; ) {
    const o = [];
    let a = s.shift();
    for (; a; )
      o.push(a), a = s.length && s[0]?.element === a.element.nextElementSibling && // Different id means the next item doesn't belong to this group.
      s[0].id === a.id ? s.shift() : null;
    const l = document.createElement("ul");
    o.forEach((d) => {
      const h = document.createElement("li");
      h.setAttribute("data-list", d.type), d.indent > 1 && h.setAttribute("class", `ql-indent-${d.indent - 1}`), h.innerHTML = d.element.innerHTML, l.appendChild(h);
    });
    const c = o[0]?.element, {
      parentNode: u
    } = c ?? {};
    c && u?.replaceChild(l, c), o.slice(1).forEach((d) => {
      let {
        element: h
      } = d;
      u?.removeChild(h);
    });
  }
};
function xN(n) {
  n.documentElement.getAttribute("xmlns:w") === "urn:schemas-microsoft-com:office:word" && yN(n);
}
const wN = [xN, mN], kN = (n) => {
  n.documentElement && wN.forEach((e) => {
    e(n);
  });
};
var SN = (n, e) => U(e, !T(e)), EN = X("<div><!></div>"), CN = X('<div class="paste-menu svelte-19f323f"><button type="button"><!></button> <div class="paste-menu-list svelte-19f323f"></div></div>');
const TN = {
  hash: "svelte-19f323f",
  code: '.paste-menu.svelte-19f323f {position:absolute;z-index:1;}.paste-menu-icon.svelte-19f323f {background:none;border:1px solid #ccc;border-radius:4px;padding:2px;margin:0;cursor:pointer;display:flex;align-items:center;justify-content:center;background:#fff;}.paste-menu-icon.svelte-19f323f:after {content:"";display:block;margin:0 2px;width:6px;height:6px;border-right:1px solid #000;border-bottom:1px solid #000;transform:rotate(45deg);margin-top:-3px;}.paste-menu-icon.svelte-19f323f:hover {background:#f0f0f0;}.paste-menu-icon.is-active.svelte-19f323f {border-bottom:0;border-bottom-left-radius:0;border-bottom-right-radius:0;position:relative;z-index:1;background:#fff;}.paste-menu.svelte-19f323f {display:flex;flex-wrap:wrap;flex-direction:column;}.paste-menu-list.svelte-19f323f {display:flex;flex-wrap:wrap;border:1px solid #ccc;border-radius:4px;border-top-left-radius:0;margin-top:-1px;background:#fff;}.paste-menu-item-container.svelte-19f323f {position:relative;}.paste-menu-item-container.is-applied.svelte-19f323f::before {content:"✔";position:absolute;left:10px;top:50%;transform:translateY(-50%);}'
};
function U0(n, e) {
  be(e, !0), Ft(n, TN);
  function t(b) {
    const C = b.getData("text/plain") || b.getData("Text");
    if (C)
      return C;
    const M = b.getData("text/uri-list");
    return M ? M.replace(/\r?\n/g, " ") : void 0;
  }
  const i = Q(e, "editor", 7), r = Q(e, "onPaste", 7), s = Q(e, "pasteMenu", 7), o = Q(e, "options", 7), a = Q(e, "setIsPasting", 7), l = {}, c = s().map((b) => ({
    name: b,
    elementName: Sr("paste-menu", b),
    options: o()[b] ?? {}
  })).filter((b) => b.elementName && b.options !== !1);
  let u = ce(!1), d = ce(!1), h = !1, f = ce(0), p = ce(0), _ = null;
  const m = ce(De({}));
  Ae(() => {
    a()(T(u));
  }), i().tiptap.on("update", () => {
    h || U(u, !1);
  });
  const g = (b, C = !1) => {
    const M = b.dom.getBoundingClientRect(), { selection: z } = b.state, D = z.$to.pos, H = b.nodeDOM(z.$from.pos - 2);
    if (!H) {
      const G = b.coordsAtPos(D), ae = G.bottom - M.top;
      (T(f) < ae || T(f) - ae > 100) && U(f, ae);
      const Y = G.left - M.left;
      T(p) !== 0 && T(p) > Y && U(p, Y);
      return;
    }
    const q = (G = void 0) => {
      if (!H.parentElement) {
        G?.disconnect();
        return;
      }
      const ae = H.getBoundingClientRect(), Y = ae.bottom - M.top, le = Y > M.height - 20 ? M.height - 20 : Y;
      (C || T(f) < le || T(f) - le > 100) && U(f, le, !0);
      const de = ae.left - M.left;
      (C || T(p) > de) && U(p, de);
    };
    if (q(), !C) {
      const G = new ResizeObserver(() => {
        q(G);
      });
      G.observe(H), setTimeout(
        () => {
          G.disconnect();
        },
        1e4
      );
    }
  }, y = (b, C = !1) => {
    try {
      g(b, C);
    } catch {
    }
  };
  i().tiptap.view.dom.addEventListener("scroll", () => {
    T(u) && y(i().tiptap.view, !0);
  });
  let x = ce("");
  r()((b, C) => {
    if (C.clipboardData?.getData(V0))
      return !1;
    i().tiptap.commands.undo(), i().tiptap.commands.redo();
    const M = b.domAtPos(i().tiptap.state.selection.from)?.node?.cloneNode(!0);
    if (M instanceof HTMLElement && M.querySelectorAll("br.ProseMirror-trailingBreak").forEach((G) => {
      G.remove();
    }), !C.clipboardData)
      return !1;
    const z = C.clipboardData, D = t(z), H = z.getData("text/html");
    let q = null;
    return H && (q = new DOMParser().parseFromString(H, "text/html"), q.body.querySelector("[data-pm-slice]") || kN(q)), (async () => {
      U(f, 0), U(p, D?.includes(`
`) ? 0 : 9999, !0);
      const G = {};
      c.forEach(({ name: Y }) => {
        const le = l[Y];
        "onEditorSetPasteContent" in le && le.onEditorSetPasteContent?.({
          plainText: D ?? q?.body.innerText ?? "",
          htmlDocument: q,
          targetDomNode: M,
          clipboardData: z,
          transaction: async (de) => {
            h = !0;
            try {
              await de();
            } finally {
              h = !1, y(b);
            }
          }
        }), "isEditorItemAvailable" in le && (G[Y] = le.isEditorItemAvailable());
      }), await Promise.all(Object.values(G));
      let ae = 0;
      U(x, "");
      for (const { name: Y } of c) {
        const le = await G[Y];
        T(m)[Y] = le === !0 ? 1 : le === !1 ? 0 : le, T(m)[Y] > ae && (ae = T(m)[Y], U(x, Y, !0));
      }
      if (T(x)) {
        a()(!0);
        const Y = l[T(x)];
        "onEditorPaste" in Y && Y.onEditorPaste();
      }
      setTimeout(() => {
        Object.values(T(m)).filter(Boolean).length <= 1 || (U(u, !0), y(b));
      });
    })(), !1;
  });
  const k = (b, C) => (l[C] = b, "onEditorInit" in b && b.onEditorInit(i(), o()[C] ?? {}), {
    destroy() {
      delete l[C];
    }
  }), E = (b) => {
    document.body.classList.contains("modal-open") || _ && b.composedPath().includes(_) || U(d, !1);
  };
  Ae(() => (T(d) && document.addEventListener("click", E), () => {
    document.removeEventListener("click", E);
  }));
  var S = CN(), w = L(S);
  w.__click = [SN, d];
  var v = L(w);
  Kt(v, () => uN), O(w);
  var A = F(w, 2);
  return ut(A, 21, () => c, (b) => b.name, (b, C) => {
    var M = EN();
    let z;
    var D = L(M);
    kr(D, () => T(C).elementName, !1, (H, q) => {
      Ye(H, (ae, Y) => k?.(ae, Y), () => T(C).name);
      let G;
      ne(() => G = G_(H, G, {
        class: "paste-menu-item",
        style: `display: ${T(m)[T(C).name] ? "block" : "none"};`
      }));
    }), O(M), ne((H) => z = ht(M, 1, "paste-menu-item-container svelte-19f323f", null, z, H), [
      () => ({
        "is-applied": T(x) === T(C).name
      })
    ]), gn("paste-menu-item-applied", M, () => {
      U(x, T(C).name, !0);
    }), V(b, M);
  }), O(A), O(S), We(S, (b) => _ = b, () => _), ne(() => {
    ks(S, `
    display: ${T(u) ? "block" : "none"};
    z-index: 1000;
    top: ${T(f)}px;
    left: ${T(p)}px;
    width: max-content;
  `), ht(w, 1, `paste-menu-icon ${T(d) ? "is-active" : ""}`, "svelte-19f323f"), ks(A, `display: ${T(d) ? "block" : "none"};`);
  }), V(n, S), ve({
    get editor() {
      return i();
    },
    set editor(b) {
      i(b), ee();
    },
    get onPaste() {
      return r();
    },
    set onPaste(b) {
      r(b), ee();
    },
    get pasteMenu() {
      return s();
    },
    set pasteMenu(b) {
      s(b), ee();
    },
    get options() {
      return o();
    },
    set options(b) {
      o(b), ee();
    },
    get setIsPasting() {
      return a();
    },
    set setIsPasting(b) {
      a(b), ee();
    }
  });
}
Lt(["click"]);
_e(
  U0,
  {
    editor: {},
    onPaste: {},
    pasteMenu: {},
    options: {},
    setIsPasting: {}
  },
  [],
  [],
  !0
);
class AN {
  #e;
  #t = !1;
  constructor({ target: e, editor: t, onPaste: i, pasteMenu: r, options: s }) {
    r.length !== 0 && (this.#e = Rt(U0, {
      target: e,
      props: {
        editor: t,
        onPaste: i,
        pasteMenu: r,
        options: s,
        setIsPasting: (o) => {
          this.#t = o;
        }
      }
    }));
  }
  isPasting() {
    return this.#t;
  }
  destroy() {
    this.#e && st(this.#e);
  }
}
var MN = X("<div><!></div>"), ON = X('<div class="mt-rich-text-editor-quick-action svelte-182x144"></div>');
const NN = {
  hash: "svelte-182x144",
  code: `.mt-rich-text-editor-quick-action.svelte-182x144 {position:absolute;z-index:1;border:1px solid #ccc;border-radius:4px;background:#fff;display:none;}.mt-rich-text-editor-quick-action-button.svelte-182x144 {padding:10px;display:block;&.selected,
    &:hover {background:#f0f0f0;}}`
};
function K0(n, e) {
  be(e, !0), Ft(n, NN);
  const t = Q(e, "editor", 7), i = Q(e, "quickAction", 7), r = Q(e, "options", 7), s = {}, o = i().map((m) => {
    const [g, y] = m.split(":");
    return {
      name: m,
      variant: y,
      elementName: Sr("quick-action", g),
      aliases: [y],
      options: r()[m] ?? {}
    };
  }).filter((m) => m.elementName && m.options !== !1);
  let a = ce("");
  const l = So(() => T(a) ? o.filter((m) => m.aliases.some((g) => g.startsWith(T(a)))) : o), c = So(() => T(l).length);
  let u = ce(0);
  Ae(() => {
    T(c) > 0 && U(u, 0);
  });
  let d = !1, h = null;
  const f = Q_(
    () => {
      if (!h)
        return;
      if (d = !1, t().tiptap.state.selection.empty) {
        const x = t().tiptap.state.selection.$head.parent;
        d = x.type.name === "paragraph" && x.textContent?.startsWith("/"), d && U(a, x.textContent?.slice(1), !0);
      }
      if (!d) {
        h.style.display = "", h.style.transition = "";
        return;
      }
      h.style.display === "" && (h.style.display = "block", setTimeout(
        () => {
          h && (h.style.transition = "left 0.2s ease-in-out");
        },
        100
      ));
      const m = t().tiptap.view.dom.getBoundingClientRect(), { selection: g } = t().tiptap.view.state, y = t().tiptap.view.coordsAtPos(g.$to.pos);
      h.style.top = `${y.bottom - m.top + 10}px`, h.style.left = "0px";
    },
    50
  );
  Ae(() => {
    t().tiptap.on("selectionUpdate", f), f(), t().tiptap.view.dom.addEventListener(
      "keydown",
      (m) => {
        d && (m.key === "Enter" ? (m.preventDefault(), m.stopPropagation(), m.stopImmediatePropagation(), s[T(l)[T(u)].name].click()) : m.key === "ArrowDown" ? (m.preventDefault(), m.stopPropagation(), m.stopImmediatePropagation(), U(u, (T(u) + 1) % T(l).length)) : m.key === "ArrowUp" && (m.preventDefault(), m.stopPropagation(), m.stopImmediatePropagation(), U(u, (T(u) - 1 + T(l).length) % T(l).length)));
      },
      { capture: !0 }
    );
  });
  function p(m, g) {
    if (s[g] = m, "onEditorInit" in m && m.onEditorInit(t(), r()[g] ?? {}), "aliases" in m) {
      const y = o.find((x) => x.name === g);
      y && (y.aliases = m.aliases);
    }
    return {
      destroy() {
        delete s[g];
      }
    };
  }
  var _ = ON();
  return ut(_, 23, () => T(l), (m) => m.name, (m, g, y) => {
    var x = MN(), k = L(x);
    kr(k, () => T(g).elementName, !1, (E, S) => {
      Ye(E, (v, A) => p?.(v, A), () => T(g).name);
      let w;
      ne(() => w = G_(E, w, {
        "data-mt-rich-text-editor-panel-item-variant": T(g).variant
      }));
    }), O(x), ne(() => ht(x, 1, `mt-rich-text-editor-quick-action-button ${(T(y) === T(u) ? "selected" : "") ?? ""}`, "svelte-182x144")), V(m, x);
  }), O(_), We(_, (m) => h = m, () => h), V(n, _), ve({
    get editor() {
      return t();
    },
    set editor(m) {
      t(m), ee();
    },
    get quickAction() {
      return i();
    },
    set quickAction(m) {
      i(m), ee();
    },
    get options() {
      return r();
    },
    set options(m) {
      r(m), ee();
    }
  });
}
_e(K0, { editor: {}, quickAction: {}, options: {} }, [], [], !0);
class LN {
  #e;
  constructor({ target: e, editor: t, quickAction: i, options: r }) {
    i.length !== 0 && (this.#e = Rt(K0, {
      target: e,
      props: {
        editor: t,
        quickAction: i,
        options: r
      }
    }));
  }
  destroy() {
    this.#e && st(this.#e);
  }
}
var RN = X('<div class="form-group mb-3"><label for="structure-id" class="form-label">id</label> <input type="text" id="structure-id" class="form-control"></div> <div class="form-group mb-3"><label for="structure-class-name" class="form-label">class</label> <input type="text" id="structure-class-name" class="form-control"></div> <div class="form-group mb-3"><label for="structure-style" class="form-label">style</label> <input type="text" id="structure-style" class="form-control"></div>', 1), IN = X('<button type="button" class="action primary button btn btn-primary"> </button> <button type="button" class="cancel action button mt-close-dialog btn btn-default"> </button>', 1);
function q0(n, e) {
  be(e, !0);
  let t = Q(e, "structureData", 7), i = Q(e, "onSubmit", 7), r = Q(e, "onClose", 7), s = ce(De(t().id)), o = ce(De(t().className)), a = ce(De(t().style)), l;
  Ae(() => {
    l?.focus();
  });
  let c, u;
  return We(
    wn(n, {
      $$events: {
        close(...d) {
          r()?.apply(this, d);
        }
      },
      children: (d, h) => {
        kn(d, {
          get close() {
            return u;
          },
          set close(f) {
            u = f;
          },
          $$slots: {
            title: (f, p) => {
              var _ = vn();
              ne((m) => B(_, m), [() => I("Edit attributes")]), V(f, _);
            },
            body: (f, p) => {
              var _ = RN(), m = Me(_), g = F(L(m), 2);
              dt(g), We(g, (S) => l = S, () => l), O(m);
              var y = F(m, 2), x = F(L(y), 2);
              dt(x), O(y);
              var k = F(y, 2), E = F(L(k), 2);
              dt(E), O(k), St(g, () => T(s), (S) => U(s, S)), St(x, () => T(o), (S) => U(o, S)), St(E, () => T(a), (S) => U(a, S)), V(f, _);
            },
            footer: (f, p) => {
              var _ = IN(), m = Me(_);
              m.__click = () => {
                i()({
                  id: T(s),
                  className: T(o),
                  style: T(a)
                }), u();
              };
              var g = L(m, !0);
              O(m);
              var y = F(m, 2);
              y.__click = u;
              var x = L(y, !0);
              O(y), ne(
                (k, E, S, w) => {
                  Ce(m, "title", k), B(g, E), Ce(y, "title", S), B(x, w);
                },
                [
                  () => I("Insert (s)"),
                  () => I("Insert"),
                  () => I("Cancel (x)"),
                  () => I("Cancel")
                ]
              ), V(f, _);
            }
          }
        });
      },
      $$slots: { default: !0 }
    }),
    (d) => c = d,
    () => c
  ), ve({
    get structureData() {
      return t();
    },
    set structureData(d) {
      t(d), ee();
    },
    get onSubmit() {
      return i();
    },
    set onSubmit(d) {
      i(d), ee();
    },
    get onClose() {
      return r();
    },
    set onClose(d) {
      r(d), ee();
    }
  });
}
Lt(["click"]);
_e(q0, { structureData: {}, onSubmit: {}, onClose: {} }, [], [], !0);
class PN {
  #e;
  #t;
  #i;
  #r;
  #n = null;
  #s = "section, div, p, ul, ol, li, h1, h2, h3, h4, h5, h6";
  constructor(e) {
    this.#e = e, this.#t = this.onUpdate.bind(this), this.#r = (t) => {
      const i = t.currentTarget;
      if (t.target !== i)
        return;
      const r = i.getBoundingClientRect();
      t.clientY - r.top > 13 || (this.#n = Rt(q0, {
        target: document.body,
        props: {
          structureData: {
            id: i.id,
            className: i.className,
            style: i.style.cssText
          },
          onSubmit: (s) => {
            const o = this.#e.tiptap.view.posAtDOM(i, 0), a = this.#e.tiptap.state.doc.nodeAt(o - 1);
            if (!a)
              return;
            const l = { ...a.attrs.MTRichTextEditorHTMLAttributes }, c = {
              className: "class"
            };
            ["id", "className", "style"].forEach((d) => {
              l[c[d] ?? d] = s[d] || void 0;
            });
            const u = this.#e.tiptap.state.tr.setNodeAttribute(
              o - 1,
              "MTRichTextEditorHTMLAttributes",
              l
            );
            this.#e.tiptap.view.dispatch(u), this.#n && (st(this.#n), this.#n = null);
          },
          onClose: () => {
            this.#n && (st(this.#n), this.#n = null);
          }
        }
      }));
    }, this.#i = document.createElement("style"), this.#e.tiptap.view.dom.getRootNode().appendChild(this.#i), this.#e.tiptap.on("update", this.#t), this.onUpdate();
  }
  onUpdate() {
    let e = "";
    const t = this.#e.tiptap.view.dom.querySelectorAll(this.#s);
    for (const i of t) {
      i.removeEventListener("click", this.#r), i.addEventListener("click", this.#r);
      const r = `${i.tagName.toLowerCase()}${i.getAttributeNames().map((s) => s === "data-mt-rich-text-editor-id" || !["id", "class", "style"].includes(s) ? "" : `[${s}="${i.getAttribute(s)}"]`).join("")}`;
      e += `${r} {
    outline: 1px solid rgba(0, 0, 0, 0.2);
    padding: 0.5rem;
    margin: 1rem 0;
    border-radius: 0.5rem;
    position: relative;
    &:before {
      content: "${r.replace(/"/g, '\\"')}";
      position: absolute;
      top: -0.8rem;
      left: 0.5rem;
      display: block;
      background-color: #fff;
      padding: 0 0.5rem;
      font-weight: normal;
      font-size: 1rem;
      cursor: pointer;
    }
  }
      `;
    }
    this.#i.textContent = e;
  }
  destroy() {
    const e = this.#e.tiptap.view.dom.querySelectorAll(this.#s);
    for (const t of e)
      t.removeEventListener("click", this.#r);
    this.#i.remove(), this.#n && (st(this.#n), this.#n = null), this.#e.tiptap.off("update", this.#t);
  }
}
const DN = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror pre {
  white-space: pre-wrap;
}

.ProseMirror li {
  position: relative;
}

.ProseMirror-hideselection *::selection { background: transparent; }
.ProseMirror-hideselection *::-moz-selection { background: transparent; }
.ProseMirror-hideselection { caret-color: transparent; }

/* See https://github.com/ProseMirror/prosemirror/issues/1421#issuecomment-1759320191 */
.ProseMirror [draggable][contenteditable=false] { user-select: text }

.ProseMirror-selectednode {
  outline: 2px solid #8cf;
}

/* Make sure li selections wrap around markers */

li.ProseMirror-selectednode {
  outline: none;
}

li.ProseMirror-selectednode:after {
  content: "";
  position: absolute;
  left: -32px;
  right: -2px; top: -2px; bottom: -2px;
  border: 2px solid #8cf;
  pointer-events: none;
}

/* Protect against generic img rules */

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
}
`, _p = `.tiptap{overflow:auto}.mt-rich-text-editor-editor{border:1px solid #ccc;border-radius:4px;display:flex;flex-direction:column;height:100%;position:relative;background:#fff}.mt-rich-text-editor-editor--fullscreen{position:fixed;top:-1px;left:0;width:100%;z-index:var( --modal-z-index, 1040)}.mt-rich-text-editor-content{position:relative}.mt-rich-text-editor-content-root,.mt-rich-text-editor-content-root>.tiptap{height:calc(100% - 10px)}.mt-rich-text-editor-content-root>.tiptap{padding:10px;outline:none}.mt-rich-text-editor-content-root>.tiptap:after{content:"";display:block;height:1px}.mt-rich-text-editor-editor:focus-within{outline:none}.mt-rich-text-editor-content{flex-grow:1;min-height:0}.mt-rich-text-editor-toolbar{border-bottom:1px solid #ccc}.mt-rich-text-editor-statusbar{border-top:1px solid #ccc}.mt-rich-text-editor-resize-handle{position:absolute;right:0;bottom:0;width:15px;height:15px;cursor:ns-resize;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 15 15'%3E%3Cpath d='M11 15 L15 11 M7 15 L15 7' stroke='%23666666' stroke-width='1' fill='none'/%3E%3C/svg%3E")}.mt-rich-text-editor-editor--fullscreen .mt-rich-text-editor-resize-handle{display:none}.mt-rich-text-editor-editor--inline,.mt-rich-text-editor-editor--inline .mt-rich-text-editor-content,.mt-rich-text-editor-content-root{display:flex;flex-direction:column;flex-grow:1}.tiptap{flex-grow:1}.mt-rich-text-editor-toolbar--inline,.mt-rich-text-editor-statusbar--inline{border:none}.mt-rich-text-editor-editor--inline .mt-rich-text-editor-resize-handle{display:none}`, $N = ':host{--table-border-color: #ccc;--table-header-background-color: #f0f0f0;--table-header-text-color: #333;--table-header-font-weight: bold;--table-header-text-align: left;--table-selected-cell-background-color: #f0f0f0;--table-resize-handle-background-color: #ccc}table{border-collapse:collapse;margin:0;overflow:hidden;table-layout:fixed;width:100%}table td,table th{border:1px solid var(--table-border-color);box-sizing:border-box;min-width:1em;padding:6px 8px;position:relative;vertical-align:top}:is(table td,table th)>*{margin-bottom:0}table th{background-color:var(--table-header-background-color);color:var(--table-header-text-color);font-weight:var(--table-header-font-weight);text-align:var(--table-header-text-align)}table .selectedCell:after{background:var(--table-selected-cell-background-color);content:"";inset:0;pointer-events:none;position:absolute;z-index:2}table .column-resize-handle{background-color:var(--table-resize-handle-background-color);bottom:-2px;pointer-events:none;position:absolute;right:-2px;top:0;width:4px}.tableWrapper{margin:1.5rem 0;overflow-x:auto}.resize-cursor{cursor:col-resize}.mt-rich-text-editor-script:before{content:attr(data-mt-rich-text-editor-script-title);display:block;position:absolute;top:-13px;left:10px;background-color:#fff;padding:0 5px}.mt-rich-text-editor-script{position:relative;border:1px solid #ccc;border-radius:4px;margin-top:10px;padding:10px}.mt-rich-text-editor-script.mt-rich-text-editor-script--preview{padding:10px 0 0}', zN = (n) => {
  const t = new DOMParser().parseFromString(n.content, "text/html");
  t.body.children.length > 0 && [...t.body.children].every(
    (i) => i instanceof HTMLIFrameElement && /^https:\/\/www.youtube.com\//.test(i.src)
  ) ? n.sourceType = "srcdoc" : /^https:\/\/www.tiktok.com\//.test(t.body.querySelector("script")?.src || "") && (n.sourceType = "data-wrap");
}, HN = 350, BN = 300, fn = Symbol("EditorEl");
class FN {
  id;
  tiptap;
  [fn];
  options;
  #e;
  #t;
  #i;
  #r;
  #n;
  #s;
  #l;
  #f;
  #o;
  #c;
  #u;
  #d;
  #h;
  #a = {};
  constructor(e, t) {
    this.#p(), this.id = e.id, this.#i = e, this.options = t, this.#d = Vb.concat(t.additionalBlockElements ?? []), this.#h = jb.concat(t.additionalInlineElements ?? []), this.#c = t.htmlOutputOptions?.format === !1 ? void 0 : {
      indent_size: t.htmlOutputOptions?.indentSize ?? 0,
      wrap_line_length: 0,
      content_unformatted: t.htmlOutputOptions?.contentUnformatted ?? [
        "pre",
        "style",
        "script"
      ]
    };
    const i = t.inline ?? !1, r = typeof t.height == "number" ? `${t.height}px` : t.height ?? `${localStorage.getItem("mt-rich-text-editor-height") ?? HN}px`;
    this.#t = document.createElement("div"), this.#t.className = "mt-rich-text-editor", i ? this.#t.style.minHeight = r : this.#t.style.height = r, this.#t.dataset.mtRichTextEditorId = e.id, this.#i.parentNode?.insertBefore(this.#t, this.#i), this.#i.style.display = "none";
    const s = this.#t.attachShadow({ mode: "open" });
    Fl(s, [_p, ...t.editorStylesheets ?? []]), this[fn] = document.createElement("div"), this[fn].classList.add("mt-rich-text-editor-editor"), i && (this[fn].classList.add("mt-rich-text-editor-editor--inline"), this[fn].style.minHeight = r), s.appendChild(this[fn]);
    const o = (g, y) => {
      const k = (g ?? (() => {
        const S = document.createElement("div");
        return S.className = y, i && S.classList.add(`${y}--inline`), this[fn].appendChild(S), S;
      })()).attachShadow({ mode: "open" });
      Fl(k, t.editorStylesheets ?? []);
      const E = document.createElement("div");
      return k.appendChild(E), E;
    }, a = o(
      t.toolbarContainer,
      t.toolbar?.length ? "mt-rich-text-editor-toolbar" : "mt-rich-text-editor-toolbar--empty"
    );
    this.#r = document.createElement("div"), this.#r.className = "mt-rich-text-editor-content";
    const l = this.#r.attachShadow({ mode: "open" });
    Fl(l, [
      DN + _p + $N,
      ...t.editorStylesheets ?? [],
      ...t.stylesheets ?? []
    ]);
    const c = document.createElement("div");
    c.className = "mt-rich-text-editor-content-root", l.appendChild(c), this[fn].appendChild(this.#r);
    const u = (g) => {
      this.#e = g;
    }, d = (...g) => this.#e?.(...g) ?? !1, h = document.createElement("div");
    h.className = "mt-rich-text-editor-paste-menu", l.appendChild(h);
    const f = t.extensionOptions ?? {};
    f.div ??= {}, f.div.elements ??= this.#d, f.span ??= {}, f.span.elements ??= this.#h, f.movableType ??= {}, f.movableType.additionalGlobalAttributeTypes ??= this.#h, f.movableType.editor = this, this.#u = [NC.configure(f), ...t.extensions ?? []], this.tiptap = new Bg({
      element: c,
      extensions: this.#u,
      content: this.preprocessHTML(this.#i.value),
      editorProps: {
        handlePaste: d,
        attributes: {
          class: t.classNames?.join(" ") || ""
        }
      }
    }), t.autoFocus && this.focus(), this.#n = new sN({
      target: a,
      editor: this,
      toolbar: t.toolbar,
      options: t.toolbarOptions ?? {},
      inline: i && !t.toolbarContainer
    });
    const p = o(
      t.statusbarContainer,
      t.statusbar?.length ? "mt-rich-text-editor-statusbar" : "mt-rich-text-editor-statusbar--empty"
    );
    this.#s = new cN({
      target: p,
      editor: this,
      statusbar: t.statusbar ?? [],
      options: t.statusbarOptions ?? {},
      inline: i && !t.statusbarContainer
    });
    const _ = o(h, "mt-rich-text-editor-paste-menu");
    this.#l = new AN({
      target: _,
      editor: this,
      onPaste: u,
      pasteMenu: t.pasteMenu ?? [],
      options: t.pasteMenuOptions ?? {},
      inline: i
    });
    const m = document.createElement("div");
    l.appendChild(m), this.#f = new LN({
      target: m,
      editor: this,
      quickAction: t.quickAction ?? [],
      options: t.quickActionOptions ?? {}
    }), this.#m(this[fn]), t.structure && this.setStructureMode(!0);
  }
  #p() {
    this.on("previewIframe", zN);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  emit(e, t = {}) {
    t.editor = this, this.#a[e]?.forEach((i) => i(t));
  }
  on(e, t) {
    this.#a[e] || (this.#a[e] = []), this.#a[e].push(t);
  }
  save() {
    this.#i.value = this.getContent();
  }
  getContent() {
    this.emit("beforeGetContent", {});
    let e = WA(this.tiptap.getHTML());
    this.#c && (e = e_.html(e, this.#c));
    const t = { content: e };
    return this.emit("getContent", t), t.content;
  }
  preprocessHTML(e) {
    return jA(e, this.#d);
  }
  setContent(e) {
    const t = typeof e == "string" ? { source: "external", content: e } : e;
    this.emit("setContent", t), this.tiptap.commands.setContent(this.preprocessHTML(t.content)), this.#i.value = t.content;
  }
  getHeight() {
    return this.#t.clientHeight;
  }
  setHeight(e) {
    e !== 0 && (this.#t.style.height = `${e}px`, localStorage.setItem("mt-rich-text-editor-height", e.toString()));
  }
  getStructureMode() {
    return this.#o !== void 0;
  }
  setStructureMode(e) {
    e ? this.#o = new PN(this) : (this.#o?.destroy(), this.#o = void 0);
  }
  focus() {
    this.tiptap.commands.focus();
  }
  destroy() {
    this.#e = void 0, this.#n.destroy(), this.#s.destroy(), this.#l.destroy(), this.#o?.destroy(), this.#f.destroy(), this.tiptap.destroy(), this.#t.remove();
  }
  insertContent(e) {
    const t = hg(this.preprocessHTML(e), this.#u);
    this.tiptap.commands.insertContent(t);
  }
  notify({ message: e }) {
    alert(e);
  }
  isPasting() {
    return this.#l.isPasting();
  }
  #m(e) {
    const t = document.createElement("div");
    t.className = "mt-rich-text-editor-resize-handle", e.appendChild(t);
    let i = 0, r = 0;
    const s = (l) => {
      l.preventDefault(), i = l.clientY, r = this.getHeight(), document.addEventListener("mousemove", o), document.addEventListener("mouseup", a);
    }, o = (l) => {
      const c = l.clientY - i, u = Math.max(BN, r + c);
      this.setHeight(u);
    }, a = () => {
      document.removeEventListener("mousemove", o), document.removeEventListener("mouseup", a);
    };
    t.addEventListener("mousedown", s);
  }
}
class ti {
  static version = Ub;
  static Editors = {};
  static Component = {
    ...Wb,
    getPanelItem: Sr
  };
  static #e = {};
  static on(e, t) {
    this.#e[e] || (this.#e[e] = []), this.#e[e].push(t);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static #t(e, ...t) {
    (this.#e[e] || []).forEach((r) => r(...t));
  }
  static async create(e) {
    const { id: t, language: i } = e;
    if (i && Je.language !== i && Je.changeLanguage(i), ti.Editors[t])
      throw new Error("Editor already exists");
    const r = document.querySelector(`#${t}`);
    if (!r)
      throw new Error("Textarea not found");
    const s = {
      toolbar: [],
      toolbarOptions: {},
      statusbar: [["path"]],
      statusbarOptions: {},
      pasteMenu: ["embedInline", "embed", "html", "link", "text", "markdown"],
      pasteMenuOptions: {},
      quickAction: ["heading:1", "heading:2", "heading:3", "heading:4", "heading:5", "heading:6"],
      quickActionOptions: {},
      extensions: [],
      inline: !1,
      ...e
    };
    this.#t("create", s);
    const { id: o, language: a, ...l } = s, c = new FN(r, l);
    return this.#t("init", c), ti.Editors[t] = c, c;
  }
  static unload({ id: e }) {
    ti.Editors[e] && (ti.Editors[e].destroy(), delete ti.Editors[e]);
  }
  static get({ id: e }) {
    return ti.Editors[e];
  }
  static async save() {
    await Promise.all(Object.values(ti.Editors).map((e) => e.save()));
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static async import(e) {
    if (e === "@tiptap/core")
      return Wk;
    throw new Error(`Unknown module: ${e}`);
  }
  static setLanguage(e) {
    Je.language !== e && Je.changeLanguage(e);
  }
}
export {
  FN as Editor,
  ti as default
};
//# sourceMappingURL=index.js.map
